


// /* ============================================================
//    B2B MARCA TABLA — JS REFACTORIZADO
//    - type, coefficient y msrp vienen de la variante (extras)
//      con fallback al metafield del producto (notes)
//    ============================================================ */

// 'use strict';


// /* ============================================================
//    CONSTANTES Y UTILIDADES
//    ============================================================ */

// const formatNum = n => {
//   const num = parseFloat(n);
//   if (isNaN(num)) return n;
//   return num.toLocaleString('en-US');
// };

// function getOrdersCount() { return window._b2bOrdersCount || 0; }
// function isFirstOrder()   { return getOrdersCount() === 0; }

// const normalize   = s => (s || '').toString().trim().toLowerCase();
// const toCents     = v => { const n = parseInt(v, 10); return isNaN(n) ? 0 : n; };
// const getEl       = id => document.getElementById(id);
// const qsa         = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
// const variantRows = () => qsa('.b2b-variant-row');

// function getColHandle() {
//   return (new URLSearchParams(window.location.search).get('vendor') || '')
//     .toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
// }

// function formatMoney(val) {
//   return parseFloat(val).toLocaleString('en-US', {
//     style: 'currency', currency: 'USD', minimumFractionDigits: 2
//   });
// }

// // function loadImgAsBase64ForExport(url) {
// //   return new Promise((resolve, reject) => {
// //     if (!url) { reject(new Error('no url')); return; }
// //     const img = new Image();
// //     img.crossOrigin = 'Anonymous';
// //     img.onload = () => {
// //       try {
// //         const canvas = document.createElement('canvas');
// //         canvas.width = img.width;
// //         canvas.height = img.height;
// //         canvas.getContext('2d').drawImage(img, 0, 0);
// //         resolve(canvas.toDataURL('image/png'));
// //       } catch (e) { reject(e); }
// //     };
// //     img.onerror = reject;
// //     img.src = url;
// //   });
// // }
// function loadImgAsBase64ForExport(url, maxSize = 120) {
//   return new Promise((resolve, reject) => {
//     if (!url) { reject(new Error('no url')); return; }
//     const smallUrl = url.replace(/(\.[^.]+)(\?.*)?$/, `_${maxSize}x${maxSize}$1$2`);
 
//     fetch(smallUrl)
//       .then(res => {
//         if (!res.ok) throw new Error('image fetch failed: ' + res.status);
//         return res.blob();
//       })
//       .then(blob => {
//         const blobUrl = URL.createObjectURL(blob);
//         const img = new Image();
//         img.onload = () => {
//           try {
//             const canvas = document.createElement('canvas');
//             canvas.width = maxSize;
//             canvas.height = maxSize;
//             const ctx = canvas.getContext('2d');
//             const scale = Math.max(maxSize / img.width, maxSize / img.height);
//             const w = img.width * scale, h = img.height * scale;
//             const dx = (maxSize - w) / 2, dy = (maxSize - h) / 2;
//             ctx.drawImage(img, dx, dy, w, h);
//             URL.revokeObjectURL(blobUrl);
//             resolve(canvas.toDataURL('image/jpeg', 0.7));
//           } catch (e) {
//             URL.revokeObjectURL(blobUrl);
//             reject(e);
//           }
//         };
//         img.onerror = (e) => { URL.revokeObjectURL(blobUrl); reject(e); };
//         img.src = blobUrl;
//       })
//       .catch(err => {
//         console.warn('[export] No se pudo cargar imagen:', smallUrl, err);
//         reject(err);
//       });
//   });
// }
// /* ============================================================
//    HELPERS: resolver type / coefficient / msrp desde variante
//    con fallback al producto
//    ============================================================ */

// /**
//  * Devuelve el valor del campo desde extras (variante) si existe y no es vacío/nulo,
//  * o cae al valor del producto (notes) como fallback.
//  */
// function resolveVariantField(extras, notes, field, fallbackField, defaultVal) {
//   const variantVal = extras[field];
//   if (variantVal != null && variantVal !== '' && variantVal !== 0) return variantVal;
//   const productVal = notes[fallbackField || field];
//   if (productVal != null && productVal !== '') return productVal;
//   return defaultVal !== undefined ? defaultVal : 'N/A';
// }

// function getTypeVal(extras, notes) {
//   return resolveVariantField(extras, notes, 'type', 'type', 'N/A');
// }

// function getCoefficientVal(extras, notes) {
//   return resolveVariantField(extras, notes, 'coefficient', 'coefficient', 'N/A');
// }

// function getMsrpVal(extras, notes) {
//   // msrp: si extras.msrp es 0 también se considera "sin valor" → cae a notes
//   const v = extras.msrp;
//   if (v != null && v !== '' && v !== 0) return v;
//   const n = notes.msrp;
//   if (n != null && n !== '') return n;
//   return '0';
// }

// /* ============================================================
//    HELPERS DE INCENTIVOS
//    ============================================================ */

// function isAutoApply(rule) {
//   return rule.apply !== false && rule.apply !== 'false';
// }

// function normalizeQtyArray(arr) {
//   if (!Array.isArray(arr)) return [];
//   return arr.map(item => {
//     if (item == null) return 1;
//     if (typeof item === 'number') return item > 0 ? item : 1;
//     if (typeof item === 'string') return parseInt(item, 10) || 1;
//     if (typeof item === 'object') return parseInt(item.value || item, 10) || 1;
//     return 1;
//   });
// }

// function getTesterQty(rule, idx) {
//   const arr = normalizeQtyArray(rule.testers_qty);
//   if (!arr.length) return 1;
//   return arr[idx] !== undefined ? arr[idx] : arr[0];
// }

// function calcActiveIncentive(rules, totalUnits, totalValue) {
//   let active = null;
//   for (const rule of rules) {
//     const minQ = Number(rule.min_qty || 0);
//     const minV = Number(rule.min_order_value || 0);
//     if ((minQ <= 0 || totalUnits >= minQ) && (minV <= 0 || totalValue >= minV)) {
//       active = rule;
//     }
//   }
//   return active;
// }

// function calcNextIncentive(rules, totalUnits, totalValue) {
//   for (const rule of rules) {
//     const minQ = Number(rule.min_qty || 0);
//     const minV = Number(rule.min_order_value || 0);
//     if (!(minQ <= 0 || totalUnits >= minQ) || !(minV <= 0 || totalValue >= minV)) {
//       return rule;
//     }
//   }
//   return null;
// }

// function getVariantThresholds(extras) {
//   if (isFirstOrder()) {
//     const firstMin = Number(extras.incentive_product || 0);
//     return {
//       minU: firstMin > 0 ? firstMin : Number(extras.next_incentive_product || 0),
//       minV: Number(extras.incentive_value || 0) || Number(extras.next_incentive_value || 0)
//     };
//   }
//   return {
//     minU: Number(extras.next_incentive_product || 0),
//     minV: Number(extras.next_incentive_value   || 0)
//   };
// }


// function computeCartGiftQty(variantId, baseQty) {
//   const vid = String(variantId || '');
//   if (!vid) return baseQty;
//   const extras  = window.b2bVariantExtrasMap?.[vid] || {};
//   const varData = window.b2bAllVariantsMap?.[vid] || {};
//   const row     = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
//   const pres = (extras.presentation || varData.pres || (row ? row.cells[8]?.textContent?.trim() : '') || '').toLowerCase();
//   const isVials = pres.includes('vial') || pres.includes('vail');
//   if (!isVials) return baseQty;
//   const pack = parseInt(extras.quantity) || 1;
//   return baseQty * (pack > 1 ? pack : 1);
// }


// function calcVariantMultiplier(extras, qty, lineValue) {
//   const { minU, minV } = getVariantThresholds(extras);
//   let m = 1;
//   if      (minU > 0 && minV <= 0) m = Math.floor(qty / minU);
//   else if (minV > 0 && minU <= 0) m = Math.floor(lineValue / minV);
//   else if (minU > 0 && minV > 0)  m = Math.min(Math.floor(qty / minU), Math.floor(lineValue / minV));
//   return Math.max(1, m);
// }

// function getVariantFreeProducts(extras) {
//   if (!extras) return [];
//   if (isFirstOrder()) {
//     const first = extras.free_product_first_order || extras.free_products || [];
//     return first.length > 0 ? first : (extras.free_product_next_order || []);
//   }
//   return extras.free_product_next_order || extras.free_products || [];
// }

// function getVariantFreeQtys(extras) {
//   if (!extras) return [];
//   if (isFirstOrder()) {
//     const firstQtys = extras.free_product_first_qty || extras.free_product_quantities || [];
//     return normalizeQtyArray(firstQtys.length > 0 ? firstQtys : (extras.free_product_next_qty || []));
//   }
//   return normalizeQtyArray(extras.free_product_next_qty || extras.free_product_quantities || []);
// }

// function dedupeFreeGifts(rawProducts, rawQtys) {
//   const seen = new Set();
//   const products = [], qtys = [];
//   (rawProducts || []).forEach((fp, i) => {
//     const key = String(fp?.variant_id || fp?.handle || fp?.title || i);
//     if (seen.has(key)) return; // descarta duplicado
//     seen.add(key);
//     products.push(fp);
//     qtys.push((rawQtys || [])[i] || 1);
//   });
//   return { products, qtys };
// }


// // function variantHasIncentive(extras) {
// //   if (!extras) return false;
// //   const { minU, minV } = getVariantThresholds(extras);
// //   const fps = getVariantFreeProducts(extras);
// //   return (minU > 0 || minV > 0) && fps.length > 0;
// // }

// function variantHasIncentive(extras) {
//   if (!extras) return false;
//   const { minU, minV } = getVariantThresholds(extras);
//   const fps = getVariantFreeProducts(extras);
//   if (!(minU > 0 || minV > 0) || !fps.length) return false;
//   return hasAnyGiftStock(fps); 
// }

// function checkVariantIncentiveMet(extras, qty, lineValue) {
//   if (!extras) return false;
//   const { minU, minV } = getVariantThresholds(extras);
//   if (!minU && !minV) return false;
//   const fps = getVariantFreeProducts(extras);
//   if (!fps.length) return false;
//   if (minU > 0 && minV <= 0) return qty >= minU;
//   if (minV > 0 && minU <= 0) return lineValue >= minV;
//   return qty >= minU && lineValue >= minV;
// }

// function formatIncentiveRule(rule, prefix = '') {
//   const parts = [];
//   const d    = Number(rule.discount || 0);
//   const auto = isAutoApply(rule);
//   const sep  = auto ? ' + ' : ' <em style="color:#92400e;">or</em> ';

//   if (Array.isArray(rule.free_testers) && rule.free_testers.length) {
//     rule.free_testers.forEach((tp, i) => {
//       if (tp?.title) parts.push(`<strong>${getTesterQty(rule, i)}x</strong> tester: ${tp.title}`);
//     });
//   } else {
//     const tot = normalizeQtyArray(rule.testers_qty).reduce((s, q) => s + q, 0);
//     if (tot > 0) parts.push(`<strong>${tot}</strong> tester${tot > 1 ? 's' : ''}`);
//   }

//   if (Array.isArray(rule.free_products)) {
//     rule.free_products.forEach((fp, i) => {
//       if (fp?.title) {
//         const qty = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
//         parts.push(`<strong>${qty}x</strong> free: ${fp.title}`);
//       }
//     });
//   }

//   if (d > 0) parts.push(`<strong>${d}%</strong> discount`);
//   if (!parts.length) return '';
//   return prefix + (auto ? 'you receive: ' : 'choose one: ') + parts.join(sep);
// }

// /* ============================================================
//    ESTADO GLOBAL DE INCENTIVOS
//    ============================================================ */

// Object.defineProperty(window, 'b2bRC', {
//   get() { return window.b2bRewardChoice || {}; }
// });

// const rewardChoice = new Proxy({}, {
//   get(_, k)    { return (window.b2bRewardChoice || {})[k]; },
//   set(_, k, v) { if (window.b2bRewardChoice) { window.b2bRewardChoice[k] = v; } return true; }
// });

// /* ============================================================
//    STOCK
//    ============================================================ */

// let _freeStockDeductions = {};

// // function setStockBadge(row, stock) {
// //   const cell = row.querySelector('.b2b-stock-cell');
// //   if (!cell) return;
// //   if      (stock > 5) cell.innerHTML = `<span class="b2b-stock-ok">${stock}</span>`;
// //   else if (stock > 0) cell.innerHTML = `<span class="b2b-stock-low">${stock}</span>`;
// //   else                cell.innerHTML = `<span class="b2b-stock-out">0</span>`;
// // }

// // // function refreshStepperState(row) {
// // //   const stock = parseInt(row.dataset.stock || 0);
// // //   const cur   = parseInt(row.querySelector('.hidden-qty')?.value || 0);
// // //   const plus  = row.querySelector('.step-plus');
// // //   const minus = row.querySelector('.step-minus');
// // //   if (plus)  plus.disabled  = stock <= 0;
// // //   if (minus) minus.disabled = stock <= 0 && cur === 0;
// // // }

// // function refreshStepperState(row) {
// //   const stock = parseInt(row.dataset.stock || 0);
// //   const cur   = parseInt(row.querySelector('.hidden-qty')?.value || 0);
// //   const plus  = row.querySelector('.step-plus');
// //   const minus = row.querySelector('.step-minus');
// //   if (plus)  plus.disabled  = stock <= 0 || cur >= stock;
// //   if (minus) minus.disabled = cur <= 0;
// // }

// // // function applyFreeProductStockDeductions() {
// // //   Object.keys(_freeStockDeductions).forEach(variantId => {
// // //     const row = document.querySelector(`.b2b-variant-row[data-variant-id="${variantId}"]`);
// // //     if (!row) return;
// // //     row.dataset.stock = parseInt(row.dataset.realStock || 0);
// // //     setStockBadge(row, parseInt(row.dataset.stock));
// // //     refreshStepperState(row);
// // //   });
// // //   _freeStockDeductions = {};
// // // }

// // function applyFreeProductStockDeductions() {
// //   const reservations = computeGiftReservations();

// //   variantRows().forEach(row => {
// //     const vid       = row.dataset.variantId;
// //     const realStock = parseInt(row.dataset.realStock || 0);
// //     const reserved  = reservations[vid] || 0;
// //     const newStock  = Math.max(0, realStock - reserved);

// //     row.dataset.stock = newStock;
// //     setStockBadge(row, newStock);

// //     // Si la cantidad ya comprada supera el nuevo stock disponible, la recortamos
// //     const hidden = row.querySelector('.hidden-qty');
// //     const valueEl = row.querySelector('.step-value');
// //     const totalCell = row.querySelector('.b2b-row-total');
// //     const curQty = parseInt(hidden?.value) || 0;
// //     if (curQty > newStock) {
// //       const clamped = Math.max(0, newStock);
// //       if (hidden)   hidden.value = clamped;
// //       if (valueEl)  valueEl.textContent = clamped;
// //       if (totalCell) totalCell.textContent =
// //         (clamped * parseFloat(row.dataset.unitPrice || 0))
// //           .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// //     }

// //     refreshStepperState(row);
// //   });
// // }


// function setStockBadge(row, stock) {
//   const cell = row.querySelector('.b2b-stock-cell');
//   if (!cell) return;
//   if      (stock > 5) cell.innerHTML = `<span class="b2b-stock-ok">${stock}</span>`;
//   else if (stock > 0) cell.innerHTML = `<span class="b2b-stock-low">${stock}</span>`;
//   else                cell.innerHTML = `<span class="b2b-stock-out">0</span>`;
// }

// // function refreshStepperState(row) {
// //   const stock = parseInt(row.dataset.stock || 0);
// //   const cur   = parseInt(row.querySelector('.hidden-qty')?.value || 0);
// //   const plus  = row.querySelector('.step-plus');
// //   const minus = row.querySelector('.step-minus');
// //   if (plus)  plus.disabled  = stock <= 0 || cur >= stock;
// //   if (minus) minus.disabled = cur <= 0;
// // }

// function refreshStepperState(row) {
//   const stock     = parseInt(row.dataset.stock || 0);
//   const sellLimit = parseInt(row.dataset.sellLimit || 0);
//   const cur       = parseInt(row.querySelector('.hidden-qty')?.value || 0);
//   const plus      = row.querySelector('.step-plus');
//   const minus     = row.querySelector('.step-minus');

//   if (plus) {
//     // Solo deshabilitar de verdad cuando no hay stock disponible (0).
//     // Si el límite es por sell_limit, lo dejamos "clickeable" para poder mostrar el aviso.
//     plus.disabled = stock <= 0;
//     const atSellLimit = sellLimit > 0 && cur >= stock && stock > 0;
//     plus.style.opacity = atSellLimit ? '0.5' : '';
//     plus.style.cursor  = atSellLimit ? 'not-allowed' : '';
//   }
//   if (minus) minus.disabled = cur <= 0;
// }

// /* ── Calcula cuánto de cada variante está comprometido como regalo (P1 + P2 + P3 + reglas de colección) ── */
// function computeGiftReservations() {

//   if (window.b2bIsMasterUser) {
//     const reservations = {};
//     Object.entries(window.b2bMasterFreeItems || {}).forEach(([vid, qty]) => {
//       vid = String(vid);
//       if (!vid || !qty) return;
//       reservations[vid] = (reservations[vid] || 0) + qty;
//     });
//     return reservations;
//   }

//   const reservations = {};
//   const add = (vid, qty) => {
//     vid = String(vid || '');
//     if (!vid || vid === '0' || !qty) return;
//     reservations[vid] = (reservations[vid] || 0) + qty;
//   };

//   // ── P1: incentivos por variante (single choice o multi choice confirmado) ──
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

//     const fps  = getVariantFreeProducts(extras);
//     const fqs  = getVariantFreeQtys(extras);
//     const mult = calcVariantMultiplier(extras, qty, lineV);
//     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

//     if (fps.length > 1) {
//       if (choice?.confirmed) add(choice.chosenVariantId, choice.chosenQty);
//     } else {
//       fps.forEach((fp, i) => add(fp.variant_id, (fqs[i] || 1) * mult));
//     }
//   });

//   // ── P2 ──
//   const p2 = window.b2bPriority2Choice || {};
//   if (p2.confirmed && Array.isArray(p2.selections)) {
//     p2.selections.forEach(s => add(s.variant_id, s.selectedQty || 0));
//   }

//   // ── P3 ──
//   const p3 = window.b2bPriority3Choice || {};
//   if (p3.confirmed && Array.isArray(p3.selections)) {
//     p3.selections.forEach(sel => {
//       (sel.choices || []).forEach(c => add(c.chosenVariantId, c.chosenQty || 0));
//     });
//   }

//   // ── Reglas de colección (auto-apply o elegidas por el cliente) ──
//   const rules = window.b2bCollectionIncentivesMap?.[getColHandle()] || [];
//   if (rules.length) {
//     let unitsCol = 0, valueCol = 0;
//     variantRows().forEach(row => {
//       const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) return;
//       unitsCol += qty; valueCol += lineV;
//     });
//     const active = calcActiveIncentive(rules, unitsCol, valueCol);
//     if (active) {
//       if (isAutoApply(active)) {
//         (active.free_products || []).forEach((fp, i) => {
//           add(fp.variant_id, normalizeQtyArray(active.free_product_quantities)[i] || 1);
//         });
//         (active.free_testers || []).forEach((tp, i) => {
//           add(tp.variant_id, getTesterQty(active, i));
//         });
//       } else if (rewardChoice.confirmed) {
//         add(rewardChoice.chosenVariantId, rewardChoice.chosenQty || 1);
//       }
//     }
//   }

//   return reservations;
// }

// // function applyFreeProductStockDeductions() {
// //   const reservations = computeGiftReservations();

// //   variantRows().forEach(row => {
// //     const vid       = row.dataset.variantId;
// //     const realStock = parseInt(row.dataset.realStock || 0);
// //     const reserved  = reservations[vid] || 0;
// //     const sellLimit = parseInt(row.dataset.sellLimit || 0);

// //     let newStock = Math.max(0, realStock - reserved);
// //     if (sellLimit > 0) {
// //       newStock = Math.min(newStock, sellLimit);
// //     }

// //     row.dataset.stock = newStock;
// //     setStockBadge(row, newStock);

// //     // Si la cantidad ya comprada supera el nuevo stock disponible, la recortamos
// //     const hidden    = row.querySelector('.hidden-qty');
// //     const valueEl   = row.querySelector('.step-value');
// //     const totalCell = row.querySelector('.b2b-row-total');
// //     const curQty    = parseInt(hidden?.value) || 0;

// //     if (curQty > newStock) {
// //       const clamped = Math.max(0, newStock);
// //       if (hidden)   hidden.value = clamped;
// //       if (valueEl)  valueEl.textContent = clamped;
// //       if (totalCell) totalCell.textContent =
// //         (clamped * parseFloat(row.dataset.unitPrice || 0))
// //           .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// //       const badge = row.querySelector('.qty-badge');
// //       if (badge) {
// //         badge.textContent = clamped;
// //         badge.style.display = clamped > 0 ? 'flex' : 'none';
// //       }
// //     }

// //     refreshStepperState(row);
// //   });

// //   _freeStockDeductions = {};
// // }

// function applyFreeProductStockDeductions() {
//   const reservations = computeGiftReservations();

//   variantRows().forEach(row => {
//     const vid       = row.dataset.variantId;
//     const realStock = parseInt(row.dataset.realStock || 0);
//     const reserved  = reservations[vid] || 0;
//     const sellLimit = parseInt(row.dataset.sellLimit || 0);

//     // ── Stock real disponible (descuenta lo reservado como FOC, pero NO aplica el tope de venta) ──
//     const availableRealStock = Math.max(0, realStock - reserved);

//     // ── Stock máximo que se puede COMPRAR (sí aplica el tope de venta) ──
//     let purchasableStock = availableRealStock;
//     if (sellLimit > 0) {
//       purchasableStock = Math.min(purchasableStock, sellLimit);
//     }


//      const unlockCap = getUnlockCap(row);
//     purchasableStock = Math.min(purchasableStock, unlockCap);


//     row.dataset.stock = purchasableStock;       // usado por steppers para limitar compra
//     setStockBadge(row, availableRealStock);     // ← muestra el stock REAL, no el tope de venta

//     // Si la cantidad ya comprada supera lo que ahora se puede comprar, la recortamos
//     const hidden    = row.querySelector('.hidden-qty');
//     const valueEl   = row.querySelector('.step-value');
//     const totalCell = row.querySelector('.b2b-row-total');
//     const curQty    = parseInt(hidden?.value) || 0;

//     if (curQty > purchasableStock) {
//       const clamped = Math.max(0, purchasableStock);
//       if (hidden)   hidden.value = clamped;
//       if (valueEl)  valueEl.textContent = clamped;
//       if (totalCell) totalCell.textContent =
//         (clamped * parseFloat(row.dataset.unitPrice || 0))
//           .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//       const badge = row.querySelector('.qty-badge');
//       if (badge) {
//         badge.textContent = clamped;
//         badge.style.display = clamped > 0 ? 'flex' : 'none';
//       }
//     }

//     refreshStepperState(row);
//   });

//   _freeStockDeductions = {};
// }

// /* ============================================================
//    FETCH HELPER — variante regalo
//    ============================================================ */

// async function fetchFreeGiftVariant(handle, type = 'product') {
//   try {
//     const res = await fetch(`/products/${handle}.js`);
//     if (!res.ok) return null;
//     const variants = (await res.json()).variants || [];
//     if (type === 'tester') return variants.find(v => v.available) || variants[0] || null;
//     const FREE_KW = ['free', 'gift', 'sample'];
//     const isFree = v =>
//       parseFloat(v.price) === 0 ||
//       FREE_KW.some(k =>
//         (v.sku || '').toLowerCase().includes(k) ||
//         ['option1', 'option2', 'option3'].some(f => (v[f] || '').toLowerCase().includes(k))
//       );
//     return variants.find(v => isFree(v) && v.available)
//         || variants.find(v => parseFloat(v.price) === 0)
//         || variants.find(v => isFree(v))
//         || variants[0] || null;
//   } catch {
//     return null;
//   }
// }

// /* ============================================================
//    STEPPERS
//    ============================================================ */

// function initSteppers() {
//   document.querySelectorAll('.quantity-stepper').forEach(stepper => {
//     const minus     = stepper.querySelector('.step-minus');
//     const plus      = stepper.querySelector('.step-plus');
//     const valueEl   = stepper.querySelector('.step-value');
//     const hidden    = stepper.querySelector('.hidden-qty');
//     const row       = stepper.closest('tr');
//     const totalCell = row.querySelector('.b2b-row-total');
//     const minQty    = parseInt(row.dataset.minQty || 0);

//     // function setQty(newQty) {
//     //   const stock = parseInt(row.dataset.stock || 0);
//     //   // ── Leer qty SIEMPRE desde el hidden input, no del closure ──
//     //   const qty = Math.max(0, newQty);
//     //   valueEl.textContent = qty;
//     //   hidden.value = qty;
//     //   const rowTotal = qty * parseFloat(row.dataset.unitPrice || 0);
//     //   totalCell.textContent = rowTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     //   plus.disabled  = qty >= stock;
//     //   minus.disabled = qty <= 0;

//     //   const badge = row.querySelector('.qty-badge');
//     //   if (badge) {
//     //     badge.textContent = qty;
//     //     badge.style.display = qty > 0 ? 'flex' : 'none';
//     //   }
//     //   updateTotals();
//     // }

//     function setQty(newQty) {
//       const stock = parseInt(row.dataset.stock || 0);
//       const qty = Math.max(0, newQty);
//       valueEl.textContent = qty;
//       hidden.value = qty;
//       const rowTotal = qty * parseFloat(row.dataset.unitPrice || 0);
//       totalCell.textContent = rowTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//       refreshStepperState(row); // ← usa la misma lógica centralizada
//       minus.disabled = qty <= 0;

//       const badge = row.querySelector('.qty-badge');
//       if (badge) {
//         badge.textContent = qty;
//         badge.style.display = qty > 0 ? 'flex' : 'none';
//       }
//       updateTotals();
//     }

//       minus.addEventListener('click', () => {
//         if (window.b2bIsMasterUser && window.b2bMasterOrderLocked) {
//           showMasterLockRequiredModal();
//           return;
//         }
//         // ── Leer siempre del hidden input, no del closure ──
//         const currentQty = parseInt(hidden.value) || 0;
//         if (currentQty === 0) return;
//         setQty(currentQty <= minQty ? 0 : currentQty - 1);
//       });

//       plus.addEventListener('click', () => {
//         if (window.b2bIsMasterUser && window.b2bMasterOrderLocked) {
//           showMasterLockRequiredModal();
//           return;
//         }
//         const stock      = parseInt(row.dataset.stock || 0);
//         const sellLimit  = parseInt(row.dataset.sellLimit || 0);
//         const currentQty = parseInt(hidden.value) || 0;
//         const newQty     = currentQty === 0 && minQty > 1 ? minQty : currentQty + 1;

//         if (newQty > stock) {
//         const unlockPres = (row.dataset.unlockPres || '').trim();
//         const unlockQty  = parseInt(row.dataset.unlockQty || 0);
//         const unlockCap  = getUnlockCap(row);

//         // ── Prioridad: si el bloqueo es por falta de desbloqueo, avisar eso ──
//         if (unlockPres && unlockQty > 0 && newQty > unlockCap) {
//           const productName    = row.cells[5]?.textContent?.trim() || '';
//           const currentBase    = getProductPresentationPurchasedQty(row.dataset.handle, unlockPres);
//           showUnlockRequiredModal(unlockQty, unlockPres.charAt(0).toUpperCase() + unlockPres.slice(1), productName, currentBase);
//           return;
//         }

//         // ── Si no, y el límite es por sell_limit ──
//         if (sellLimit > 0 && stock <= sellLimit) {
//           const productName = row.cells[5]?.textContent?.trim() || '';
//           showSellLimitModal(sellLimit, productName);
//         }
//         return;
//       }
//       setQty(newQty);
//     });
//   });
// }

// /* ============================================================
//    COPY SKU
//    ============================================================ */

// function initCopySku() {
//   document.querySelectorAll('.copy-sku-icon').forEach(btn => {
//     btn.addEventListener('click', () => {
//       const sku = btn.dataset.sku.trim();
//       if (!sku || sku === '-') {
//           const overlay = getEl('b2b-processing-overlay') || (() => {
//             const el = document.createElement('div');
//             el.id = 'b2b-processing-overlay';
//             el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
//             document.body.appendChild(el);
//             return el;
//           })();

//           const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');

//           overlay.innerHTML = `
//             <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
//                         box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
//                         max-width:400px;width:90%;">
//               <img src="${logoUrl}" alt="Logo"
//                 style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
//                 onerror="this.style.display='none'">
//               <div style="width:56px;height:56px;border-radius:50%;background:#fee2e2;
//                           display:flex;align-items:center;justify-content:center;
//                           margin:0 auto 16px;font-size:28px;">⚠️</div>
//               <div style="font-size:1.3rem;font-weight:700;color:#b91c1c;margin-bottom:8px;">
//                 No SKU available
//               </div>
//               <p style="font-size:15px;color:#555;margin:0 0 20px;line-height:1.6;">
//                 This product does not have a SKU assigned.
//               </p>
//               <button type="button" onclick="unlockUI()"
//                 style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
//                       border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
//                       font-family:'Crimson Pro',serif;width:100%;">
//                 OK
//               </button>
//             </div>`;

//           overlay.style.display = 'flex';
//           return;
//         }
//       navigator.clipboard.writeText(sku).then(() => {
//         const orig = btn.textContent;
//         btn.textContent = '✓ Copied';
//         btn.style.color = '#b8a77d';
//         setTimeout(() => { btn.textContent = orig; btn.style.color = ''; }, 2000);
//       });
//     });
//   });
// }

// /* ============================================================
//    SKU HOVER POPUP
//    ============================================================ */

// let skuPopup = null;

// function ensureSkuPopup() {
//   if (skuPopup) return;
//   skuPopup = document.createElement('div');
//   skuPopup.className = 'sku-popup';
//   skuPopup.innerHTML = `
//     <img class="sku-popup-img" src="" alt="">
//     <div class="sku-popup-body">
//       <div class="popup-description"></div>
//       <div class="popup-notes">
//         <span><strong>Top Notes:</strong> <span class="top-notes-val"></span></span>
//         <span><strong>Middle Notes:</strong> <span class="middle-notes-val"></span></span>
//         <span><strong>Base Notes:</strong> <span class="base-notes-val"></span></span>
//       </div>
//     </div>`;
//   document.body.appendChild(skuPopup);
// }

// function parseNotes(val) {
//   if (!val) return '-';
//   try { const a = JSON.parse(val); if (Array.isArray(a)) return a.join(', '); } catch {}
//   return val;
// }

// function positionPopup(e) {
//   const margin = 16, popupW = 480, popupH = skuPopup.offsetHeight || 220;
//   let x = e.clientX + margin, y = e.clientY + margin;
//   if (x + popupW > window.innerWidth)  x = e.clientX - popupW - margin;
//   if (y + popupH > window.innerHeight) y = e.clientY - popupH - margin;
//   skuPopup.style.left = x + 'px';
//   skuPopup.style.top  = y + 'px';
// }

// function initSkuHover() {
//   ensureSkuPopup();
//   variantRows().forEach(row => {
//     const skuCell = row.querySelector('.sku-cell');
//     if (!skuCell) return;
//     skuCell.style.cursor = 'pointer';
//     skuCell.addEventListener('mouseenter', e => {
//       skuPopup.querySelector('.sku-popup-img').src = row.dataset.imgUrl || '';
//       skuPopup.querySelector('.popup-description').textContent = row.dataset.description || 'No description.';
//       skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(row.dataset.topNotes);
//       skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(row.dataset.middleNotes);
//       skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(row.dataset.baseNotes);
//       positionPopup(e);
//       skuPopup.classList.add('visible');
//     });
//     skuCell.addEventListener('mousemove', positionPopup);
//     skuCell.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
//   });
// }

// /* ============================================================
//    SKU DETAIL MODAL
//    ============================================================ */
//   function initSkuModal() {
//     const skuModal = getEl('sku-detail-modal');

//     getEl('sku-modal-close-btn')?.addEventListener('click', () => {
//       skuModal.style.display = 'none';
//       document.body.style.overflow = '';
//     });
//     skuModal?.addEventListener('click', e => {
//       if (e.target === skuModal) { skuModal.style.display = 'none'; document.body.style.overflow = ''; }
//     });

//     variantRows().forEach(row => {
//       const skuCell = row.querySelector('.sku-cell');
//       if (!skuCell) return;

//       skuCell.addEventListener('click', e => {
//         if (e.target.closest('.copy-sku-icon')) return;
//         const handle    = row.dataset.handle || '';
//         const notes     = window.b2bNotesMap?.[handle] || {};
//         const extras    = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//         const freeProds = getVariantFreeProducts(extras);
//         const freeQtys  = getVariantFreeQtys(extras);
//         const curQty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//         const threshold  = isFirstOrder() ? Number(extras?.incentive_product || 0) : Number(extras?.next_incentive_product || extras?.incentive_product || 0);
//         const multiplier = threshold > 0 && curQty > 0 ? Math.floor(curQty / threshold) : 0;
//         const incValue   = isFirstOrder() ? (extras?.incentive_value || 0) : (extras?.next_incentive_value || extras?.incentive_value || 0);

//         getEl('sku-modal-main-img').src           = row.dataset.imgUrl || '';
//         getEl('sku-modal-title').textContent       = row.cells[5]?.textContent.trim() || '';
//         getEl('sku-modal-sku').textContent         = (row.dataset.sku || '').toUpperCase();
//         getEl('sku-modal-collection').textContent  = row.cells[4]?.textContent.trim() || '';
//         getEl('sku-modal-ml').textContent          = row.cells[7]?.textContent.trim() || '';
//         getEl('sku-modal-price-single').textContent = formatMoney(row.dataset.wholesale || 0);
//         getEl('sku-modal-description').textContent  = row.dataset.description || 'No description available.';
//         getEl('sku-modal-top').textContent    = parseNotes(notes.top)    || '-';
//         getEl('sku-modal-middle').textContent = parseNotes(notes.middle) || '-';
//         getEl('sku-modal-base').textContent   = parseNotes(notes.base)   || '-';
//         // ── Videos del producto ──
//         const productVideos = window.b2bProductVideosMap?.[String(row.dataset.productId)] || [];
//         renderSkuVideoCarousel(productVideos);
//        // ── Audio description (mini player flotante) ──
//           const audioBtnEl   = getEl('sku-modal-audio-btn');
//           const audioUrl     = notes.audio || '';

//           if (audioUrl) {
//             audioBtnEl.style.display = 'inline-flex';
//             audioBtnEl.dataset.src   = audioUrl;
//           } else {
//             audioBtnEl.style.display = 'none';
//             audioBtnEl.dataset.src   = '';
//           }

//           // título/imagen del mini player
//           getEl('sku-modal-audio-title').textContent = row?.cells[5]?.textContent?.trim() || productName || '';
//           getEl('sku-modal-audio-thumb').src = row?.dataset?.imgUrl || '';

//           // cerrar el mini player si estaba abierto de un producto anterior
//           closeSkuAudioPlayer();

//         const firstMinQtyEl = getEl('firstMinQty');
//         const nextOrdersEl  = getEl('NextOrders');
//         if (firstMinQtyEl) firstMinQtyEl.textContent = (row.dataset.firstMinQty || '1') + ' Units';
//         if (nextOrdersEl)  nextOrdersEl.textContent  = row.dataset.nextMinQty === '—' ? '—' : (row.dataset.nextMinQty || '—') + ' Units';

//         const incEl   = getEl('sku-modal-incentives');
//         const incBody = getEl('sku-modal-incentive-body');
//         const incFP   = getEl('sku-modal-free-products');
//         const priority = Number(window.b2bCollectionPriority || 1);

//         if (priority === 2) {
//           // ── Prioridad 2: descuento por porcentaje ──
//           const discPct2      = parseFloat(window.b2bCollectionDiscount || 0);
//           const minAmount2    = parseFloat(window.b2bDiscountMinAmount  || 0);
//           const discProducts2 = window.b2bDiscountProducts || [];

//           if (discPct2 > 0 && discProducts2.length > 0) {
//             incEl.style.display = 'block';
//           //  <br><span style="font-size:12px;color:#000;">
//           //                     Discount budget = Order Total × ${discPct2}%
//           //                   </span>
//             incBody.innerHTML = `
//               <div style="background:#fff;border-radius:10px;margin-bottom:12px; font-family: Crimson Pro">
//                 <div style="font-size:16px;font-weight:700;color:#000;margin-bottom:6px; font-family:Crimson Pro">
                  
//                 </div>
//                 <div style="font-size:17px;color:#585858;line-height:1.6;font-family: Crimson Pro;">
//                   For purchases of 
//                   <strong>$${minAmount2.toLocaleString('en-US', {minimumFractionDigits:2})}</strong>,
//                    or more, you will receive a <strong>${discPct2}%</strong>  credit that can be used on selected products.
  
//                 </div>
//               </div>`;

//             incFP.innerHTML = discProducts2.map(p => {
//               if (!p?.title) return '';
//               const imgSrc   = (p.image || '').replace(/^\/\//, 'https://');
//               const varTitle = p.variant_title && p.variant_title.toLowerCase() !== 'default title'
//                 ? p.variant_title : '';
//               const vid2      = String(p.variant_id || '');
//               const extras2   = window.b2bVariantExtrasMap?.[vid2] || {};
//               const tableRow2 = document.querySelector(`.b2b-variant-row[data-variant-id="${vid2}"]`);

//               // ── Precio desde incentive_product_price ──
//               const metaPrice = parseFloat(p.incentive_product_price || extras2.incentive_product_price || 0);
//               const realPrice = metaPrice > 0
//                 ? metaPrice
//                 : tableRow2
//                   ? parseFloat(tableRow2.dataset.unitPrice || p.price || 0)
//                   : parseFloat(p.price || 0);

//               return `<div style="display:flex;flex-direction:column;align-items:center;gap:6px;text-align:center;max-width:90px;">
//                 ${imgSrc
//                   ? `<img src="${imgSrc}" style="width:72px;height:72px;object-fit:cover;border-radius:10px;border:1px solid #000;" onerror="this.style.display='none'">`
//                   : '<div style="width:72px;height:72px;border-radius:10px;background:#dbeafe;display:flex;align-items:center;justify-content:center;font-size:28px;">🏷️</div>'}
//                 <span style="font-size:12px;color:#111;font-weight:600;line-height:1.3;">
//                   ${p.title}${varTitle ? `<br><span style="font-size:15px;color:#6b7280;">${varTitle}</span>` : ''}
//                 </span>
//                 <span style="font-size:17px;color:#000;font-weight:700; font-family: 'Crimson Pro';">$${realPrice.toFixed(2)}</span>
//               </div>`;
//             }).join('');

//           } else {
//             incEl.style.display = 'none';
//             incBody.innerHTML   = '';
//             incFP.innerHTML     = '';
//           }

//         } else {
//           // ── Prioridad 1: lógica original de free gifts por variante ──
//           if (extras && (incValue > 0 || threshold > 0 || freeProds.length)) {
//             incEl.style.display = 'block';
//             const parts = [];
//             if (threshold > 0) parts.push(`minimum <strong>${threshold} units</strong>`);
//             if (incValue > 0)  parts.push(`order value of <strong>$${Number(incValue).toLocaleString()}</strong>`);
//             const getText = freeProds.map((fp, i) => {
//               const tq   = (freeQtys[i] || 1) * (multiplier || 1);
//               const name = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
//                 ? `${fp.title} — ${fp.variant_title}` : fp.title;
//               return `<strong>${tq}x</strong> ${name}`;
//             }).join(' or ');
//             incBody.innerHTML = (parts.length
//               ? 'When placing an order: ' + parts.join(' and ') + '.'
//               : '')
//               + (getText ? ' You get: ' + getText : '');

//             incFP.innerHTML = freeProds.map((fp, i) => {
//               const tq  = (freeQtys[i] || 1) * (multiplier || 1);
//               const img = fp.image
//                 ? `<img src="${fp.image}" style="width:56px;height:56px;object-fit:cover;border-radius:8px;" onerror="this.style.display='none'">`
//                 : '';
//               const name = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
//                 ? `${fp.title}<br><span style="font-size:15px;color:#6b7280; font-family:Crimson Pro">${fp.variant_title}</span>`
//                 : fp.title;
//               return `<div style="display:flex;flex-direction:column;align-items:center;gap:4px;text-align:center;">
//                 ${img}
//                 <span style="font-size:12px;font-weight:700;color:#166534;background:#dcfce7;border-radius:6px;padding:2px 7px;">${tq}x</span>
//                 <span style="font-size:11px;font-weight:600;color:#000;max-width:70px;line-height:1.3;">${name}</span>
//               </div>`;
//             }).join('');

//           } else {
//             incEl.style.display = 'none';
//             incBody.innerHTML   = '';
//             incFP.innerHTML     = '';
//           }
//         }


//        getEl('sku-modal-close-btn')?.addEventListener('click', () => {
//           skuModal.style.display = 'none';
//           document.body.style.overflow = '';
//           closeSkuAudioPlayer();
//         });
//         skuModal?.addEventListener('click', e => {
//           if (e.target === skuModal) {
//             skuModal.style.display = 'none';
//             document.body.style.overflow = '';
//             closeSkuAudioPlayer();
//           }
//         });

//         const thumbsEl = getEl('sku-modal-thumbs');
//         thumbsEl.innerHTML = '';
//         if (handle) {
//           fetch(`/products/${handle}.js`).then(r => r.json()).then(product => {
//             if (!product?.images?.length) return;
//             const mainImg = getEl('sku-modal-main-img');
//             product.images.forEach((img, i) => {
//               const src = (typeof img === 'string' ? img : img.src || '').replace(/^\/\//, 'https://');
//               const thumb = document.createElement('img');
//               thumb.className = 'sku-modal-thumb' + (i === 0 ? ' active' : '');
//               thumb.src = src; thumb.width = 56; thumb.height = 56;
//               thumb.addEventListener('click', () => {
//                 mainImg.src = src;
//                 document.querySelectorAll('.sku-modal-thumb').forEach(t => t.classList.remove('active'));
//                 thumb.classList.add('active');
//               });
//               thumbsEl.appendChild(thumb);
//               if (i === 0) mainImg.src = src;
//             });
//           }).catch(() => {});
//         }

//         skuModal.style.display = 'flex';
//         document.body.style.overflow = 'hidden';
//         skuPopup.classList.remove('visible');
//       });
//     });
//   }





//   function closeSkuAudioPlayer() {
//   const container = getEl('sku-modal-audio-container');
//   const audioEl    = getEl('sku-modal-audio');
//   if (!container || !audioEl) return;
//   container.classList.remove('active');
//   container.style.opacity    = '0';
//   container.style.visibility = 'hidden';
//   container.style.transform  = 'translateX(-50%) translateY(150%)';
//   audioEl.pause();
//   getEl('sku-modal-audio-play-icon').style.display  = '';
//   getEl('sku-modal-audio-pause-icon').style.display = 'none';
// }

// function initSkuAudioPlayer() {
//   const audioEl     = getEl('sku-modal-audio');
//   const container   = getEl('sku-modal-audio-container');
//   const triggerBtn  = getEl('sku-modal-audio-btn');
//   const closeBtn     = getEl('sku-modal-audio-close');
//   const playPauseBtn = getEl('sku-modal-audio-playpause');
//   const playIcon     = getEl('sku-modal-audio-play-icon');
//   const pauseIcon    = getEl('sku-modal-audio-pause-icon');
//   const progressWrap = getEl('sku-modal-audio-progress');
//   const progressBar  = getEl('sku-modal-audio-progress-bar');
//   const currentEl    = getEl('sku-modal-audio-current');
//   const durationEl   = getEl('sku-modal-audio-duration');
//   const volumeWrap   = getEl('sku-modal-audio-volume');
//   const volumeBar    = getEl('sku-modal-audio-volume-bar');
//   if (!audioEl || triggerBtn.dataset.listenerAttached) return;

//   function formatTime(sec) {
//     if (isNaN(sec)) return '0:00';
//     const m = Math.floor(sec / 60), s = Math.floor(sec % 60);
//     return m + ':' + (s < 10 ? '0' : '') + s;
//   }

//   function openPlayer() {
//     const src = triggerBtn.dataset.src;
//     if (!src) return;
//     if (audioEl.src !== src) audioEl.src = src;
//     container.classList.add('active');
//     container.style.opacity    = '1';
//     container.style.visibility = 'visible';
//     container.style.transform  = 'translateX(-50%) translateY(0)';
//     audioEl.play().then(() => {
//       playIcon.style.display  = 'none';
//       pauseIcon.style.display = '';
//     }).catch(() => {});
//   }

//   triggerBtn.addEventListener('click', () => {
//     const isOpen = container.classList.contains('active');
//     if (isOpen) closeSkuAudioPlayer(); else openPlayer();
//   });

//   closeBtn.addEventListener('click', closeSkuAudioPlayer);

//   playPauseBtn.addEventListener('click', () => {
//     if (audioEl.paused) {
//       audioEl.play();
//       playIcon.style.display  = 'none';
//       pauseIcon.style.display = '';
//     } else {
//       audioEl.pause();
//       playIcon.style.display  = '';
//       pauseIcon.style.display = 'none';
//     }
//   });

//   audioEl.addEventListener('loadedmetadata', () => {
//     durationEl.textContent = formatTime(audioEl.duration);
//   });
//   audioEl.addEventListener('timeupdate', () => {
//     const pct = (audioEl.currentTime / audioEl.duration) * 100 || 0;
//     progressBar.style.width = pct + '%';
//     currentEl.textContent   = formatTime(audioEl.currentTime);
//   });
//   audioEl.addEventListener('ended', () => {
//     playIcon.style.display  = '';
//     pauseIcon.style.display = 'none';
//   });

//   progressWrap.addEventListener('click', e => {
//     const rect = progressWrap.getBoundingClientRect();
//     const pct  = (e.clientX - rect.left) / rect.width;
//     audioEl.currentTime = pct * audioEl.duration;
//   });

//   volumeWrap.addEventListener('click', e => {
//     const rect = volumeWrap.getBoundingClientRect();
//     const pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
//     audioEl.volume = pct;
//     volumeBar.style.width = (pct * 100) + '%';
//   });

//   triggerBtn.dataset.listenerAttached = 'true';
// }







//   function showUnlockRequiredModal(unlockQty, unlockPres, productName, currentBase) {
//   const modal = getEl('sell-limit-modal'); // reutilizamos el mismo modal visual
//   const text  = getEl('sell-limit-modal-text');
//   if (!modal || !text) return;
//   const needed = Math.max(0, unlockQty - (currentBase % unlockQty === 0 ? unlockQty : currentBase % unlockQty));
//   text.innerHTML = `To purchase <strong>${productName}</strong>, you need to buy <strong>${unlockQty}</strong> unit${unlockQty > 1 ? 's' : ''} of <strong>${unlockPres}</strong> first.` +
//     `<br><br>You currently have <strong>${currentBase}</strong> unit${currentBase !== 1 ? 's' : ''} of ${unlockPres} in your order.`;
//   modal.style.display = 'flex';
// }

// /* ============================================================
//    UPDATE TOTALS
//    ============================================================ */

// function updateTotals() {
//    if (window.b2bIsMasterUser) updateMasterOrderLock();
//   let items = 0, total = 0;

//   // ── Sin check de display — contar TODAS las filas con qty ──
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;
//     items += qty;
//     total += qty * parseFloat(row.dataset.unitPrice || 0);
//   });

//   getEl('b2b-items').textContent = items;
//   getEl('b2b-total').textContent = '$ ' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//   const hasItems = items > 0;
//   getEl('b2b-buy-btn').disabled          = !hasItems;
//   getEl('b2b-view-details-btn').disabled = !hasItems;
//   getEl('b2b-buy-now-bottom').disabled   = !hasItems;

//   // ── Contar incentivos ──
//   let liveIncentives = 0;

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     const fps    = getVariantFreeProducts(extras);
//     const fqs    = getVariantFreeQtys(extras);
//     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//     if (fps.length > 1) {
//       if (choice?.confirmed) liveIncentives += choice.chosenQty || 0;
//     } else {
//       fps.forEach((fp, i) => { liveIncentives += fqs[i] || 1; });
//     }
//   });

//   // P2
//   const p2live = window.b2bPriority2Choice || {};
//   if (p2live.confirmed && Array.isArray(p2live.selections)) {
//     p2live.selections.forEach(s => { liveIncentives += s.selectedQty || 0; });
//   }

//   // P3
//   const p3live = window.b2bPriority3Choice || {};
//   if (p3live.confirmed && Array.isArray(p3live.selections)) {
//     p3live.selections.forEach(sel => {
//       (sel.choices || []).forEach(c => { liveIncentives += c.chosenQty || 0; });
//     });
//   }

//     // Master FOC manual
//   Object.values(window.b2bMasterFreeItems || {}).forEach(q => {
//     liveIncentives += parseInt(q) || 0;
//   });


//   const incEl = getEl('dash-total-incentives');
//   if (incEl) incEl.textContent = liveIncentives;

//   if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
//   updateIncentiveBanners();
// }

// /* ============================================================
//    INCENTIVE BANNERS
//    ============================================================ */

// function updateIncentiveBanners() {

//   if (window.b2bIsMasterUser) {
//     getEl('b2b-incentive-banner').style.display = 'none';
//     getEl('b2b-incentive-next').style.display   = 'none';
//     const varBanner = getEl('b2b-variant-incentive-banner');
//     if (varBanner) varBanner.style.display = 'none';
//     const rewardBtn = getEl('b2b-choose-reward-btn');
//     if (rewardBtn) rewardBtn.style.display = 'none';
//     applyFreeProductStockDeductions();
//     return;
//   }


//   const colHandle  = getColHandle();
//   const rules      = window.b2bCollectionIncentivesMap?.[colHandle] || [];
//   const priority   = Number(window.b2bCollectionPriority || 1);

//   // ── Calcular total general de la orden ──
//   let grandOrderTotal = 0;
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     grandOrderTotal += qty * parseFloat(row.dataset.unitPrice || 0);
//   });

//   // ── Configuración prioridad 2 ──
//   const discountPct      = parseFloat(window.b2bCollectionDiscount || 0);
//   const discountMinAmt   = parseFloat(window.b2bDiscountMinAmount || 0);
//   const discountProducts = window.b2bDiscountProducts || [];
//   const isPriority2      = priority === 2;
//   const p2HasConfig      = isPriority2 && discountMinAmt > 0 && discountPct > 0 && discountProducts.length > 0;
//   const p2Unlocked       = p2HasConfig && grandOrderTotal >= discountMinAmt;

//   let totalUnitsForCollection = 0, totalValueForCollection = 0;
//   let anyVariantIncentiveActive = false;
//   let pendingChoices = 0, confirmedChoices = 0, totalChoices = 0;
//   let variantIncentiveHTML = '';

//   // ── Solo evaluar incentivos de variante si prioridad = 1 ──
//   if (!isPriority2) {
//     variantRows().forEach(row => {
//       const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
//       const met    = variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV);

//       if (met) {
//         anyVariantIncentiveActive = true;
//         const freeProducts = getVariantFreeProducts(extras);
//         const freeQtys     = getVariantFreeQtys(extras);
//         const multiplier   = calcVariantMultiplier(extras, qty, lineV);
//         const choice       = window.b2bVariantRewardChoices[row.dataset.variantId];
//         const pName        = row.cells[5]?.textContent?.trim() || 'Product';

//         if (freeProducts.length > 1) {
//           totalChoices++;
//           if (!choice?.confirmed) pendingChoices++;
//           else confirmedChoices++;
//           variantIncentiveHTML += `<div style="margin-top:4px;"></div>`;
//         } else {
//           const giftParts = freeProducts.map((fp, i) =>
//             `<strong>${(freeQtys[i] || 1) * multiplier}x</strong> ${fp.title}`
//           );
//           if (giftParts.length) {
//             variantIncentiveHTML += `<div style="margin-top:4px;"><strong>${pName}:</strong> you receive: ${giftParts.join(' + ')}</div>`;
//           }
//         }
//       } else {
//         totalUnitsForCollection += qty;
//         totalValueForCollection += lineV;
//       }
//     });
//   }

//   const active = (!isPriority2 && rules.length) ? calcActiveIncentive(rules, totalUnitsForCollection, totalValueForCollection) : null;
//   const next   = (!isPriority2 && rules.length) ? calcNextIncentive(rules, totalUnitsForCollection, totalValueForCollection)   : null;

//   applyFreeProductStockDeductions();

//   const rewardBtn = getEl('b2b-choose-reward-btn');
//   if (rewardBtn) rewardBtn.style.display = 'none';

//   function resetRewardChoice(extra) {
//     const rc = window.b2bRewardChoice;
//     if (!rc) return;
//     rc.active = extra?.active !== undefined ? extra.active : null;
//     rc.confirmed = false; rc.chosenType = null; rc.chosenVariantId = null;
//     rc.chosenProductHandle = null; rc.chosenProductTitle = null;
//     rc.chosenProductImage = null; rc.chosenQty = 1;
//     rc.discountPct = extra?.discountPct || 0;
//   }

//   // ════════════════════════════════════
//   //  PRIORIDAD 2 — descuento por monto
//   // ════════════════════════════════════

//   if (isPriority2) {
//     getEl('b2b-incentive-banner').style.display = 'none';
//     const varBanner = getEl('b2b-variant-incentive-banner');
//     if (varBanner) varBanner.style.display = 'none';

//     if (p2HasConfig) {
//       const p2choice = window.b2bPriority2Choice || {};

//       if (p2Unlocked) {
//         // ── DESBLOQUEADO: mostrar botón activo ──
//         if (rewardBtn) {
//           rewardBtn.style.display    = 'inline-flex';
//           rewardBtn.style.opacity    = '1';
//           rewardBtn.style.cursor     = 'pointer';
//           rewardBtn.disabled         = false;
//           const selCount = (p2choice.selections || []).filter(s => (s.selectedQty || 0) > 0).length;
//           rewardBtn.textContent = p2choice.confirmed
//             ? `Incentive Selected`
//             : `Choose your FOC`;
//           rewardBtn.onclick = () => openPriority2Modal();
//         }
//         // Ocultar banner "X para desbloquear"
//         const nextEl = getEl('b2b-incentive-next');
//         if (nextEl) nextEl.style.display = 'none';

//       } else {
//         // ── NO DESBLOQUEADO ──
//         if (rewardBtn) rewardBtn.style.display = 'none';

//         // Mostrar banner solo si hay algo en el carrito
//         const nextEl     = getEl('b2b-incentive-next');
//         const nextDetail = getEl('b2b-incentive-next-detail');
//         if (nextEl && nextDetail) {
//           if (grandOrderTotal > 0) {
//             const needed = discountMinAmt - grandOrderTotal;
//             nextDetail.innerHTML = `Add <strong>$${needed.toFixed(2)}</strong>or more to unlock: <strong>${discountPct}%</strong> reward credit on selected products.`;
//             nextEl.style.display = 'block';
//           } else {
//             nextEl.style.display = 'none';
//           }
//         }
//       }
//     } else {
//       // Sin configuración P2 válida
//       if (rewardBtn) rewardBtn.style.display = 'none';
//     }
//     return; // no procesar prioridad 1
//   }


//   // ════════════════════════════════════
//   //  PRIORIDAD 3 — distribución libre
//   // ════════════════════════════════════
//   const isPriority3 = priority === 3;
//   if (isPriority3) {
//     getEl('b2b-incentive-banner').style.display = 'none';
//     const varBanner = getEl('b2b-variant-incentive-banner');
//     if (varBanner) varBanner.style.display = 'none';

//     let anyP3Met = false;
//     variantRows().forEach(row => {
//       const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) anyP3Met = true;
//     });

//     if (anyP3Met) {
//       if (rewardBtn) {
//         rewardBtn.style.display = 'inline-flex';
//         rewardBtn.disabled      = false;
//         rewardBtn.style.opacity = '1';
//         rewardBtn.style.cursor  = 'pointer';
//         const p3choice = window.b2bPriority3Choice || {};
//         rewardBtn.textContent = p3choice.confirmed ? 'Incentive Selected ✓' : 'Choose Your FOC';
//         rewardBtn.onclick = () => openPriority3Modal();
//       }
//       const nextEl = getEl('b2b-incentive-next');
//       if (nextEl) nextEl.style.display = 'none';
//     } else {
//       if (rewardBtn) rewardBtn.style.display = 'none';

//       // Banner "X más para desbloquear"
//       let totalUnits = 0, totalValue = 0;
//       variantRows().forEach(row => {
//         const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//         totalUnits += qty;
//         totalValue += qty * parseFloat(row.dataset.unitPrice || 0);
//       });

//       const nextEl     = getEl('b2b-incentive-next');
//       const nextDetail = getEl('b2b-incentive-next-detail');
//       if (nextEl && nextDetail && totalUnits > 0) {
//         // Buscar el primer incentivo no cumplido
//         let nextRule = null;
//         variantRows().forEach(row => {
//           const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//           if (!extras || nextRule) return;
//           const { minU, minV } = getVariantThresholds(extras);
//           const fps = getVariantFreeProducts(extras);
//           if (fps.length > 0 && (minU > 0 || minV > 0)) nextRule = { minU, minV };
//         });
//         if (nextRule) {
//           const needed = Math.max(0, (nextRule.minU || 0) - totalUnits);
//           if (needed > 0) {
//             // nextDetail.innerHTML = `Add <strong>${needed}</strong> more unit${needed > 1 ? 's' : ''} to unlock your free gift choices.`;
//              nextDetail.innerHTML = ``;
//             nextEl.style.display = 'block';
//           } else {
//             nextEl.style.display = 'none';
//           }
//         }
//       } else if (nextEl) {
//         nextEl.style.display = 'none';
//       }
//     }
//     return;
//   }
  

//   // ════════════════════════════════════
//   //  PRIORIDAD 1 — lógica original
//   // ════════════════════════════════════
//   //  ? `Choose your Incentive (${confirmedChoices}/${totalChoices} selected)`
//   if (anyVariantIncentiveActive) {
//     resetRewardChoice();
//     getEl('b2b-incentive-banner').style.display = 'none';
//     getEl('b2b-incentive-next').style.display   = 'none';

//     if (rewardBtn && totalChoices > 0) {
//       rewardBtn.style.display = 'inline-flex';
//       rewardBtn.textContent = pendingChoices > 0
//         ? `Choose your FOC`
//         : `Gifts Selected ✓`;
//       rewardBtn.onclick = () => openAllVariantRewardsModal();
//     }

//   } else if (active) {
//     const needsChoice = !isAutoApply(active);
//     if (rewardChoice.active !== active) {
//       resetRewardChoice({ active, discountPct: Number(active.discount || 0) });
//       if (window.b2bRewardChoice) window.b2bRewardChoice.active = active;
//     }
//     if (rewardBtn && needsChoice) {
//       rewardBtn.style.display = 'inline-flex';
//       rewardBtn.textContent = rewardChoice.confirmed ? 'Reward Selected ✓' : 'Choose Your Reward';
//       rewardBtn.onclick = () => openRewardChoiceModal();
//     }
//     renderCollectionBanner(active, totalUnitsForCollection, totalValueForCollection, next);

//   } else {
//     resetRewardChoice();
//     getEl('b2b-incentive-banner').style.display = 'none';
//     renderNextBanner(next, totalUnitsForCollection, totalValueForCollection);
//   }
// // (${confirmedChoices}/${totalChoices} selected)
//   const variantBannerEl = getEl('b2b-variant-incentive-banner');
//   if (variantBannerEl) {
//     if (variantIncentiveHTML) {
//       const btnLabel = pendingChoices > 0
//         ? `Choose your FOC`
//         : `Gifts Selected ✓`;
//       variantBannerEl.innerHTML = `
//         ${variantIncentiveHTML}
//         ${totalChoices > 0 ? `
//           <div style="margin-top:10px;">
//             <button type="button" onclick="openAllVariantRewardsModal()"
//               style="width:100%;padding:12px 14px;background:#276e31;color:#fff;border:none;border-radius:8px;font-size:17px;font-weight:700;cursor:pointer;font-family:'Crimson Pro';">
//               ${btnLabel}
//             </button>
//           </div>` : ''}`;
//       variantBannerEl.style.display = 'block';
//       if (rewardBtn) rewardBtn.style.display = 'none';
//     } else {
//       variantBannerEl.style.display = 'none';
//     }
//   }
// }

// function renderCollectionBanner(active, totalUnits, totalValue, next) {
//   const bannerEl = getEl('b2b-incentive-banner');
//   const detailEl = getEl('b2b-incentive-detail');
//   const html = formatIncentiveRule(active, 'You earned: ');

//   if (html) {
//     detailEl.innerHTML = html + (rewardChoice.confirmed
//       ? ' <span style="color:#000;font-weight:700;">✓ Reward confirmed — <span style="text-decoration:underline;cursor:pointer;" onclick="openRewardChoiceModal()">Change</span></span>'
//       : ' <span style="color:#000;font-weight:700;"> ← Click to select your reward</span>');
//     bannerEl.style.display = 'block';
//   } else {
//     bannerEl.style.display = 'none';
//   }

//   renderNextBanner(next, totalUnits, totalValue);
// }

// function renderNextBanner(next, totalUnits, totalValue) {
//   const nextEl     = getEl('b2b-incentive-next');
//   const nextDetail = getEl('b2b-incentive-next-detail');
//   if (!next || totalUnits === 0) { nextEl.style.display = 'none'; return; }

//   const qtyNeeded   = Math.max(0, (next.min_qty || 0) - totalUnits);
//   const valueNeeded = Math.max(0, (next.min_order_value || 0) - totalValue);
//   let msg = '';
//   if (qtyNeeded > 0 && valueNeeded > 0)
//     msg = `Add <strong>${qtyNeeded}</strong> unit${qtyNeeded > 1 ? 's' : ''} and <strong>$${valueNeeded.toFixed(2)}</strong> more to unlock: `;
//   else if (qtyNeeded > 0)
//     msg = `Add <strong>${qtyNeeded}</strong> unit${qtyNeeded > 1 ? 's' : ''} more to unlock: `;
//   else if (valueNeeded > 0)
//     msg = `Add <strong>$${valueNeeded.toFixed(2)}</strong> more to unlock: `;

//   nextDetail.innerHTML = msg + formatIncentiveRule(next);
//   nextEl.style.display = 'block';
// }

// /* ============================================================
//    MODAL — VARIANT REWARD
//    ============================================================ */

// let _variantRewardCurrentId = null;

// async function openAllVariantRewardsModal() {
//   const modal      = getEl('variant-reward-modal');
//   const list       = getEl('variant-reward-products-list');
//   const titleEl    = getEl('variant-reward-modal-title');
//   const subtitleEl = getEl('variant-reward-modal-subtitle');

//   titleEl.textContent  = 'Choose Your FOC';
//   subtitleEl.innerHTML = 'Select your preferred free product for each eligible item.';

//   const activeChoices  = [];
//   const seenVariantIds = new Set();

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     const fps = getVariantFreeProducts(extras);
//     if (fps.length <= 1) return;
//     if (seenVariantIds.has(row.dataset.variantId)) return;
//     seenVariantIds.add(row.dataset.variantId);
//     activeChoices.push({
//       variantId: row.dataset.variantId,
//       pName: row.cells[5]?.textContent?.trim() || 'Product',
//       qty, extras, lineV, freeProducts: fps, freeQtys: getVariantFreeQtys(extras)
//     });
//   });

//   if (!activeChoices.length) return;

//   list.innerHTML = '';

//   activeChoices.forEach(({ variantId, pName, qty, extras, lineV, freeProducts, freeQtys }) => {
//     const multiplier = calcVariantMultiplier(extras, qty, lineV);
//     const current    = window.b2bVariantRewardChoices[variantId] || {};

//     // ── Header del grupo ──
//     const header = document.createElement('div');
//     header.style.cssText = 'margin:16px 0 8px;padding-bottom:6px;border-bottom:2px solid #e5e7eb;';
//     header.innerHTML = `
//       <strong style="font-size:18px;color:#686a6c;">${pName}</strong>
//       <span style="font-size:18px;color:#6b7280;margin-left:8px;">(${qty} units ordered)</span>`;
//     list.appendChild(header);

//     // ── Tabla de opciones ──
//     const tableWrap = document.createElement('div');
//     tableWrap.style.cssText = 'overflow-x:auto;-webkit-overflow-scrolling:touch;margin-bottom:16px;';
//     tableWrap.innerHTML = `
//       <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;table-layout:fixed;">
//         <colgroup>
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//         </colgroup>
//         <thead>
//           <tr style="background:#686a6c;color:#fff;">
//           <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Photo</th>
//           <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Name</th>
//           <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">ML</th>
//           <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Presentation</th>
//           <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Quantity</th>
//           <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Select</th>
            
//           </tr>
//         </thead>
//         <tbody id="p1-tbody-${variantId}"></tbody>
//       </table>`;
//     list.appendChild(tableWrap);

//     const tbody = tableWrap.querySelector(`#p1-tbody-${variantId}`);

//     // freeProducts.forEach((fp, i) => {
//     //   if (!fp?.title) return;
//     //   const totalQty    = (freeQtys[i] || 1) * multiplier;
//     //   const imgSrc      = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//     //   const isSelected  = current.chosenIndex === i;
//     //   const resolvedVid = fp.variant_id && fp.variant_id !== '0' ? String(fp.variant_id) : '';
//     freeProducts.forEach((fp, i) => {
//       if (!fp?.title) return;
//       const totalQty    = (freeQtys[i] || 1) * multiplier;
//       const imgSrc      = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//       const isSelected  = current.chosenIndex === i;
//       const resolvedVid = fp.variant_id && fp.variant_id !== '0' ? String(fp.variant_id) : '';

//       // ── Validar stock disponible para regalar (mismo producto vendido y regalado) ──
//       const remainingStockForGift = getRemainingStockForGift(resolvedVid);
//       const isOutOfStock = resolvedVid && remainingStockForGift < totalQty;
//       if (isOutOfStock) return; // no mostrar opciones que no se pueden cumplir con el stock actual

//       const vid2    = String(fp.variant_id || '');
//       const varData = window.b2bAllVariantsMap?.[vid2] || {};
//       const ml      = varData.ml   || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
//       const pres    = varData.pres || '—';
//       const bgColor = isSelected ? '' : (i % 2 === 0 ? '#fff' : '#f9fafb');
//       const tdC     = 'padding:9px 7px;vertical-align:middle;font-size:18px;color:#374151;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

//       const tr = document.createElement('tr');
//       tr.style.cssText = `background:${bgColor};border-bottom:1px solid #e5e7eb;cursor:pointer;transition:background 0.15s;`;
//       tr.dataset.variantId    = variantId;
//       tr.dataset.chosenIdx    = i;
//       tr.dataset.chosenVid    = resolvedVid;
//       tr.dataset.chosenTitle  = fp.title;
//       tr.dataset.chosenImage  = imgSrc;
//       tr.dataset.chosenQty    = totalQty;
//       tr.dataset.chosenHandle = fp.handle || '';
//       tr.dataset.idx          = i;

//       tr.innerHTML = `
     
//         <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
//           ${imgSrc
//             ? `<img src="${imgSrc}" style="width:48px;height:48px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;">`
//             : `<div style="width:48px;height:48px;border-radius:8px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:18px;">🎁</div>`}
//         </td>
//         <td style="padding:9px 7px;vertical-align:middle;">
//           <div style="font-weight:700;color:#111;font-size:18px;white-space:normal;word-break:break-word;text-align: center;">${fp.title}</div>
//         </td>
//         <td style="${tdC}">${ml}</td>
//         <td style="${tdC}">${pres}</td>
//          <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
//           <span class="p1-qty-badge" style="background:${isSelected ? '#dcfce7' : '#f3f4f6'};color:${isSelected ? '#166534' : '#6b7280'};font-size:18px;font-weight:700;padding:3px 10px;border-radius:12px;white-space:nowrap;">${totalQty}</span>
//         </td>
//            <td style="padding:9px 7px;text-align:center;vertical-align:middle;width:40px;">
//           <div class="allreward-radio" style="width:18px;height:18px;border-radius:50%;border:2px solid ${isSelected ? '#b8a77d' : '#9ca3af'};background:${isSelected ? '#b8a77d' : '#fff'};display:flex;align-items:center;justify-content:center;margin:0 auto;">
//             ${isSelected ? '<svg width="9" height="9" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>' : ''}
//           </div>
//         </td>
//         `;

//       tr.addEventListener('click', () => {
//         // ── Deseleccionar todas las filas del grupo ──
//         tbody.querySelectorAll('tr').forEach(r => {
//           r.style.background = parseInt(r.dataset.idx) % 2 === 0 ? '#fff' : '#f9fafb';
//           const radio = r.querySelector('.allreward-radio');
//           if (radio) { radio.style.border = '2px solid #9ca3af'; radio.style.background = '#fff'; radio.innerHTML = ''; }
//           const badge = r.querySelector('.p1-qty-badge');
//           if (badge) { badge.style.background = '#f3f4f6'; badge.style.color = '#6b7280'; }
//         });

//         // ── Seleccionar esta fila ──
//         tr.style.background = '';
//         const radio = tr.querySelector('.allreward-radio');
//         if (radio) {
//           radio.style.border = '2px solid #b8a77d';
//           radio.style.background = '#b8a77d';
//           radio.innerHTML = '<svg width="9" height="9" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
//         }
//         const badge = tr.querySelector('.p1-qty-badge');
//         if (badge) { badge.style.background = '#dcfce7'; badge.style.color = '#166534'; }

//         if (!window.b2bVariantRewardChoices[variantId]) window.b2bVariantRewardChoices[variantId] = {};
//         window.b2bVariantRewardChoices[variantId]._pending = {
//           chosenIndex:     parseInt(tr.dataset.chosenIdx),
//           chosenTitle:     tr.dataset.chosenTitle,
//           chosenImage:     tr.dataset.chosenImage,
//           chosenHandle:    tr.dataset.chosenHandle,
//           chosenQty:       parseInt(tr.dataset.chosenQty),
//           chosenVariantId: tr.dataset.chosenVid
//         };
//       });

//       tbody.appendChild(tr);
//     });
//   });

//   const confirmBtn = getEl('variant-reward-confirm');
//   confirmBtn.onclick = () => {
//     const missing = activeChoices.filter(({ variantId }) =>
//       !window.b2bVariantRewardChoices[variantId]?._pending &&
//       !window.b2bVariantRewardChoices[variantId]?.confirmed
//     );
//      if (missing.length > 0) {
//         const overlay = getEl('b2b-processing-overlay') || (() => {
//           const el = document.createElement('div');
//           el.id = 'b2b-processing-overlay';
//           el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
//           document.body.appendChild(el);
//           return el;
//         })();

//         const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
//         const names   = missing.map(m => `<li style="margin:4px 0;">${m.pName}</li>`).join('');

//         overlay.innerHTML = `
//           <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
//                       box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
//                       max-width:440px;width:90%;">
//             <img src="${logoUrl}" alt="Logo"
//               style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
//               onerror="this.style.display='none'">
//             <div style="width:56px;height:56px;border-radius:50%;background:#fff;
//                         display:flex;align-items:center;justify-content:center;
//                         margin:0 auto 16px;font-size:28px;">⚠️</div>
//             <div style="font-size:17px;font-weight:700;color:#000 ;margin-bottom:8px;">
//               Free product not selected
//             </div>
//             <p style="font-size:15px;color:#555;margin:0 0 14px;line-height:1.6;">
//               Please select a free product for:
//             </p>
//             <ul style="text-align:left;list-style:none;padding:0 0 0 8px;margin:0 0 20px;font-size:15px;color:#1f2937;">
//               ${names}
//             </ul>
//             <button type="button" onclick="unlockUI()"
//               style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
//                     border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
//                     font-family:'Crimson Pro',serif;width:100%;">
//               OK, I'll fix it
//             </button>
//           </div>`;

//         overlay.style.display = 'flex';
//         return;
//       }
//     activeChoices.forEach(({ variantId }) => {
//       const p = window.b2bVariantRewardChoices[variantId]?._pending;
//       if (p) window.b2bVariantRewardChoices[variantId] = { confirmed: true, ...p };
//     });
//     closeVariantRewardModal();
//     updateIncentiveBanners();
//     if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
//   };

//   modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// }

// function openPriority2Modal() {
//   const modal    = getEl('variant-reward-modal');
//   const list     = getEl('variant-reward-products-list');
//   const titleEl  = getEl('variant-reward-modal-title');
//   const subEl    = getEl('variant-reward-modal-subtitle');

//   const pct      = parseFloat(window.b2bCollectionDiscount || 0);
//   const products = window.b2bDiscountProducts || [];

//   function getProductPrice(p) {
//     const liquidPrice = parseFloat(p.incentive_product_price || 0);
//     if (liquidPrice > 0) return liquidPrice;
//     const vid2      = String(p.variant_id || '');
//     const extras2   = window.b2bVariantExtrasMap?.[vid2] || {};
//     const metaPrice = parseFloat(extras2.incentive_product_price || 0);
//     if (metaPrice > 0) return metaPrice;
//     return parseFloat(p.price || 0);
//   }

//   let orderTotal = 0;
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     orderTotal += qty * parseFloat(row.dataset.unitPrice || 0);
//   });

//   const budget = orderTotal * (pct / 100);

//   titleEl.textContent = 'Choose Products to Redeem Your Credit';
//   subEl.innerHTML     = `Use your <strong>$${budget.toFixed(2)}</strong> credit on selected products.`;

//   // Solo usar prevSelections si está confirmado Y no fue reseteado
//     const prevSelections = (window.b2bPriority2Choice?.confirmed && window.b2bPriority2Choice?.selections?.length)
//       ? window.b2bPriority2Choice.selections
//       : [];
//     const selectedQtys = {};
//     products.forEach((_, i) => {
//       selectedQtys[i] = prevSelections[i]?.selectedQty || 0;
//     });

//   function calcSummary() {
//     let selectedSpent = 0;
//     products.forEach((p, i) => {
//       selectedSpent += (selectedQtys[i] || 0) * getProductPrice(p);
//     });
//     const available   = Math.max(0, budget - selectedSpent);
//     const progressPct = budget > 0 ? Math.min(100, (selectedSpent / budget) * 100) : 0;
//     return { selectedSpent, available, progressPct };
//   }

//   function renderSummary() {
//     const { selectedSpent, available, progressPct } = calcSummary();
//     const selEl   = getEl('p2-selected');
//     const avaEl   = getEl('p2-available');
//     const barEl   = getEl('p2-progress');
//     const countEl = getEl('p2-count');

//     if (selEl) selEl.textContent = `$${selectedSpent.toFixed(2)}`;
//     if (avaEl) {
//       avaEl.textContent = `$${available.toFixed(2)}`;
//       avaEl.style.color = available < 0.01 ? '#dc2626' : '#16a34a';
//     }
//     if (barEl) barEl.style.width = `${progressPct}%`;
//     if (countEl) {
//       const totalUnitsSelected = products.reduce((sum, _, i) => sum + (selectedQtys[i] || 0), 0);
//       countEl.textContent = totalUnitsSelected;
//     }
//   }

//  function renderP2TableRows() {
//     const tbody = getEl('p2-table-body');
//     if (!tbody) return;
//     const { available } = calcSummary();
//     tbody.innerHTML = products.map((p, idx) => {
//       if (!p?.title) return '';
//       const imgSrc     = (p.image || '').replace(/^\/\//, 'https://');
//       const price      = getProductPrice(p);
//       const currentQty = selectedQtys[idx] || 0;
//       const vid        = String(p.variant_id || '');
//       const varData    = window.b2bAllVariantsMap?.[vid] || {};
//       const extras2    = window.b2bVariantExtrasMap?.[vid] || {};
//       const notes      = window.b2bNotesMap?.[p.handle] || {};
//       const ml         = varData.ml || (p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '') || '—';
//       const pres       = varData.pres       || '—';
//       const collection = varData.collection || notes.collection || '—';
//       const minQty     = extras2.quantity > 0 ? extras2.quantity : '—';
      
//       const bgColor    = idx % 2 === 0 ? '#fff' : '#f9fafb';
//       const plusDisabled = price > available + 0.001;
//       const tdC = 'padding:9px 7px;vertical-align:middle;font-size:13px;color:#374151;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

//       return `<tr style="background:${bgColor};border-bottom:1px solid #e5e7eb;">
//         <!-- View -->
//         <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
//           <button type="button" class="b2b-p2-view-btn"
//             data-handle="${p.handle || ''}"
//             data-variant-id="${p.variant_id || ''}"
//             style="background:transparent;border:none;cursor:pointer;">
//             <svg viewBox="0 0 32 32" stroke-linecap="round" style="width:26px;height:26px;stroke:#356ce1;fill:none;">
//               <path d="M4,16 C9,28 23,28 28,16" stroke-width="3"/>
//               <path d="M4,16 C9,4 23,4 28,16" stroke-width="3"/>
//               <circle cx="16" cy="16" r="4.5" stroke-width="5"/>
//             </svg>
//           </button>
//         </td>
//         <!-- Photo -->
//         <td style="padding:9px 7px;text-align:center;vertical-align:middle;width:68px;">
//           ${imgSrc
//             ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;" onerror="this.style.display='none'">`
//             : `<div style="width:52px;height:52px;border-radius:8px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:18px;margin:0 auto;">🏷️</div>`}
//         </td>
//         <!-- Collection -->
//         <td style="${tdC};max-width:130px;" title="${collection}">${collection}</td>
//         <!-- Product -->
//         <td style="padding:9px 7px;vertical-align:middle;min-width:120px;text-align: center;">
//           <div style="font-weight:700;color:#111;font-size:14px;white-space:normal;word-break:break-word;">${p.title}</div>
//         </td>
//         <!-- Presentation -->
//         <td style="${tdC}">${pres}</td>
//         <!-- Quantity (Min Qty) -->
//         <td style="${tdC};font-weight:700;color:#000;">${minQty}</td>
//         <!-- ML -->
//         <td style="${tdC};max-width:65px;">${ml}</td>
//         <!-- Price -->
//         <td style="padding:9px 7px;text-align:center;vertical-align:middle;font-size:14px;font-weight:700;color:#111;white-space:nowrap;">$${price.toFixed(2)}</td>
//         <!-- Qty stepper -->
//         <td style="padding:9px 7px;text-align:center;vertical-align:middle;white-space:nowrap;">
//           <div style="display:inline-flex;align-items:center;gap:4px;">
//             <button type="button" id="p2-minus-${idx}" data-idx="${idx}"
//               style="width:28px;height:28px;border:1px solid #e5e7eb;border-radius:6px;background:#f9fafb;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;">−</button>
//             <span id="p2-qty-${idx}" style="min-width:22px;text-align:center;font-weight:700;font-size:14px;">${currentQty}</span>
//             <button type="button" id="p2-plus-${idx}" data-idx="${idx}"
//               style="width:28px;height:28px;border:1px solid ${plusDisabled ? '#e5e7eb' : '#b8a77d'};border-radius:6px;background:${plusDisabled ? '#f3f4f6' : '#b8a77d'};color:${plusDisabled ? '#9ca3af' : '#fff'};font-size:16px;cursor:${plusDisabled ? 'not-allowed' : 'pointer'};display:flex;align-items:center;justify-content:center;flex-shrink:0;opacity:${plusDisabled ? '0.4' : '1'};">+</button>
//           </div>
//         </td>
//       </tr>`;
//     }).join('');
//   }

//   list.innerHTML = `
//    <div style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:14px 16px;margin-bottom:16px;">
//       <div style="display:flex;gap:24px;flex-wrap:nowrap;justify-content:space-around;align-items:center;">
  
//   <!-- Grupo cálculo pegado -->
//   <div style="display:flex;align-items:center;gap:14px;">
//     <div style="text-align:center;">
//       <span style="color:#6b7280;font-size:16px;display:block;">Order Total</span>
//       <strong style="font-size:16px;color:#111;">$${orderTotal.toFixed(2)}</strong>
//     </div>
//     <span style="color:#6b7280;font-size:16px;padding-top:27px;">×</span>
//     <div style="text-align:center;">
//       <span style="color:#6b7280;font-size:16px;display:block;">%</span>
//       <strong style="font-size:16px;color:#b8a77d;">${pct}%</strong>
//     </div>
//     <span style="color:#6b7280;font-size:16px;padding-top:27px;">=</span>
//     <div style="text-align:center;">
//       <span style="color:#6b7280;font-size:16px;display:block;">Credit Total</span>
//       <strong style="font-size:16px;color:#16a34a;">$${budget.toFixed(2)}</strong>
//     </div>
//   </div>

//   <div style="width:2px;height:50px;background:#d1d5db;flex-shrink:0;"></div>

//   <div style="text-align:center;">
//     <span style="color:#6b7280;font-size:16px;display:block;">Selected</span>
//     <strong id="p2-selected" style="font-size:16px;color:#b8a77d;">$0.00</strong>
//   </div>
//   <div style="text-align:center;">
//     <span style="color:#6b7280;font-size:16px;display:block;">Available</span>
//     <strong id="p2-available" style="font-size:16px;color:#16a34a;">$${budget.toFixed(2)}</strong>
//   </div>
//   <div style="text-align:center;">
//     <span style="color:#6b7280;font-size:16px;display:block;">Incentive</span>
//     <strong id="p2-count" style="font-size:16px;color:#000;">0</strong>
//   </div>
// </div>
//   <div style="margin-top:10px;background:#e5e7eb;border-radius:99px;height:6px;">
//     <div id="p2-progress" style="height:6px;border-radius:99px;background:#b8a77d;width:0%;transition:width 0.3s;"></div>
//   </div>
// </div>
//     <div style="overflow-x:auto;-webkit-overflow-scrolling:touch;">
//       <table style="width:100%;min-width:500px;border-collapse:collapse;font-family:'Crimson Pro',serif;table-layout:fixed;">
//         <colgroup>
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//           <col style="width:30%;">
//         </colgroup>
//         <thead>
//           <tr style="background:#686a6c;color:#fff;">
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">View</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Photo</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Collection</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Product</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Presentation</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Units/Pack</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">ML</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Price</th>
//             <th style="padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Qty</th>
//           </tr>
//         </thead>
//         <tbody id="p2-table-body"></tbody>
//       </table>
//     </div>`;

//   renderP2TableRows();

//   const tbody = getEl('p2-table-body');
//   tbody.addEventListener('click', e => {
//     const btn = e.target.closest('button[data-idx]');
//     if (!btn) return;
//     const idx     = parseInt(btn.dataset.idx);
//     const isMinus = btn.id.startsWith('p2-minus');
//     const price   = getProductPrice(products[idx]);

//     if (isMinus) {
//       selectedQtys[idx] = Math.max(0, (selectedQtys[idx] || 0) - 1);
//     } else {
//       const { available } = calcSummary();
//       if (price > available + 0.001) return;
//       selectedQtys[idx] = (selectedQtys[idx] || 0) + 1;
//     }

//     const qtyEl = getEl(`p2-qty-${idx}`);
//     if (qtyEl) qtyEl.textContent = selectedQtys[idx];
//     renderSummary();
//     renderP2TableRows();
//   });

//   list.addEventListener('click', e => {
//       const viewBtn = e.target.closest('.b2b-p2-view-btn');
//       if (!viewBtn) return;
//       const vid    = viewBtn.dataset.variantId;
//       const handle = viewBtn.dataset.handle;
//       if (!handle) return;

//       const skuModal = getEl('sku-detail-modal');
//       const extras   = window.b2bVariantExtrasMap?.[vid] || {};
//       const notes    = window.b2bNotesMap?.[handle] || {};

//       // ── Buscar imagen del producto de incentivo ──
//       const p = (window.b2bDiscountProducts || []).find(p => String(p.variant_id) === String(vid));
//       const imgSrc = (p?.image || '').replace(/^\/\//, 'https://');

//       // ── ML y precio desde metafields de la variante ──
//       const ml    = extras.size || '—';
//       const pres  = extras.presentation || '—';
//       const metaPrice = parseFloat(p?.incentive_product_price || extras.incentive_product_price || 0);
//       const price = metaPrice > 0 ? metaPrice : parseFloat(p?.price || 0);

//       getEl('sku-modal-main-img').src             = imgSrc;
//       getEl('sku-modal-title').textContent        = p?.title || handle;
      
//       const varData = window.b2bAllVariantsMap?.[String(vid)] || {};
//       const sku     = varData.sku || extras.sku || '—';
//       getEl('sku-modal-sku').textContent = sku.toUpperCase();
//       getEl('sku-modal-collection').textContent   = notes.collection || '—';
//       getEl('sku-modal-ml').textContent           = ml;
//       getEl('sku-modal-price-single').textContent = formatMoney(price);
//       getEl('sku-modal-description').textContent  = '';
//       getEl('sku-modal-top').textContent          = parseNotes(notes.top)    || '-';
//       getEl('sku-modal-middle').textContent       = parseNotes(notes.middle) || '-';
//       getEl('sku-modal-base').textContent         = parseNotes(notes.base)   || '-';
//       getEl('sku-modal-incentives').style.display = 'none';

//       // ── Galería ──
//       const thumbsEl = getEl('sku-modal-thumbs');
//       thumbsEl.innerHTML = '';
//       fetch(`/products/${handle}.js`).then(r => r.json()).then(product => {
//         if (!product?.variants?.length) return;
//         // Buscar la variante por id
//         const variant = product.variants.find(v => String(v.id) === String(vid)) || product.variants[0];
//         if (variant?.sku) {
//           const skuEl = getEl('sku-modal-sku');
//           if (skuEl) skuEl.textContent = variant.sku.toUpperCase();
//         }
//         // ── Galería ──
//         if (!product?.images?.length) return;
//         const mainImg = getEl('sku-modal-main-img');
//         product.images.forEach((img, i) => {
//           const src   = (typeof img === 'string' ? img : img.src || '').replace(/^\/\//, 'https://');
//           const thumb = document.createElement('img');
//           thumb.className = 'sku-modal-thumb' + (i === 0 ? ' active' : '');
//           thumb.src = src; thumb.width = 56; thumb.height = 56;
//           thumb.addEventListener('click', () => {
//             mainImg.src = src;
//             document.querySelectorAll('.sku-modal-thumb').forEach(t => t.classList.remove('active'));
//             thumb.classList.add('active');
//           });
//           thumbsEl.appendChild(thumb);
//           if (i === 0) mainImg.src = src;
//         });
//       }).catch(() => {});

//       getEl('variant-reward-modal').style.zIndex = '99990';
//       skuModal.style.zIndex = '999999';
//       skuModal.style.display = 'flex';
//       document.body.style.overflow = 'hidden';
//    });

//   const confirmBtn = getEl('variant-reward-confirm');
//   confirmBtn.textContent = '✓ Confirm My Choice';
//   confirmBtn.onclick = () => {
//     const hasSelection = products.some((_, i) => (selectedQtys[i] || 0) > 0);
//     if (!hasSelection) {
//       alert('Please select at least one product.');
//       return;
//     }

//     const selections = products.map((p, i) => {
//       const qty = parseInt(selectedQtys[i] || 0);
//       return { ...p, selectedQty: qty };
//     });

//     const { selectedSpent } = calcSummary();
//     window.b2bPriority2Choice = {
//       confirmed:   true,
//       selections,
//       totalSpent:  selectedSpent,
//       discountPct: pct
//     };

//     closeVariantRewardModal();
//     updateIncentiveBanners();
//     if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
//   };

//   renderSummary();
//   modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// }

// window.openPriority2Modal = openPriority2Modal;



// function openPriority3Modal() {
//   const modal   = getEl('variant-reward-modal');
//   const list    = getEl('variant-reward-products-list');
//   const titleEl = getEl('variant-reward-modal-title');
//   const subEl   = getEl('variant-reward-modal-subtitle');

//   titleEl.textContent = 'Choose Your Incentive';
//   list.innerHTML = '';

//   const groups  = [];
//   const seenIds = new Set();

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;
//     const vid = row.dataset.variantId;
//     if (seenIds.has(vid)) return;
//     const extras = window.b2bVariantExtrasMap?.[vid];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     seenIds.add(vid);
//     const fps        = getVariantFreeProducts(extras);
//     const fqs        = getVariantFreeQtys(extras);
//     const multiplier = calcVariantMultiplier(extras, qty, lineV);
//     const totalFree  = (fqs[0] || 1) * multiplier;
//     // groups.push({ vid, pName: row.cells[5]?.textContent?.trim() || 'Product',
//     //   qty, extras, fps, fqs, multiplier, totalFree });
//     const maxAchievable = computeMaxAchievableFoc(fps, totalFree);
//     groups.push({ vid, pName: row.cells[5]?.textContent?.trim() || 'Product',
//       qty, extras, fps, fqs, multiplier, totalFree, maxAchievable });
//   });

//   if (!groups.length) return;

//   const prevSelections = (window.b2bPriority3Choice?.confirmed && window.b2bPriority3Choice?.selections?.length)
//     ? window.b2bPriority3Choice.selections
//     : [];
//   const selectedQtys = groups.map((g, gi) => {
//     const prev = prevSelections[gi];
//     return g.fps.map((_, fi) => prev?.qtys?.[fi] || 0);
//   });

//   // function getTotalFreeAll() { return groups.reduce((s, g) => s + g.totalFree, 0); }
//   function getTotalFreeAll() { return groups.reduce((s, g) => s + g.maxAchievable, 0); }
//   function getTotalUsedAll() { return groups.reduce((s, _, gi) => s + calcGroupTotal(gi), 0); }
//   function calcGroupTotal(gi) { return selectedQtys[gi].reduce((s, q) => s + q, 0); }

//   function updateGlobalCounter() {
//     const total     = getTotalFreeAll();
//     const used      = getTotalUsedAll();
//     const remaining = total - used;
//     const allDone   = remaining === 0;
//     const pct       = total > 0 ? Math.min(100, (used / total) * 100) : 0;

//     const counterEl = getEl('p3-global-counter');
//     if (!counterEl) return;

//     const listId  = 'p3-instructions-list';
//     const btnId   = 'p3-instructions-toggle';
//     const PAGE_SIZE = 4;

//     const allGuideCards = [];
//     groups.forEach(g => {
//       const mainImgSrc = (() => {
//         const row = document.querySelector(`.b2b-variant-row[data-variant-id="${g.vid}"]`);
//         return row ? (row.dataset.imgUrl || '') : '';
//       })();
//       const minU = g.extras?.incentive_product || g.extras?.next_incentive_product || '?';
//       g.fps.forEach((fp, fi) => {
//         const fpImg = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//         const vid2  = String(fp.variant_id || '');
//         const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
//         const ml2   = vd2.ml || '—';
//         const pres2 = vd2.pres || '—';
//         const pack2 = ex2.quantity > 0 ? ex2.quantity : '—';
//         const qty2  = g.fqs[fi] || 1;
//         allGuideCards.push(`
//           <div style="display:flex;align-items:center;gap:0;border-radius:14px;overflow:hidden;border:1px solid #e5e7eb;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,0.06);flex:1;min-width:220px;max-width:300px;">
//             <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:14px 10px;text-align:center;flex:1;background:#f9fafb;">
//               ${mainImgSrc
//                 ? `<img src="${mainImgSrc}" style="width:70px;height:90px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;">`
//                 : `<div style="width:50px;height:50px;border-radius:8px;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-size:22px;">🛍️</div>`}
//               <div style="font-size:14px;font-weight:700;color:#111;">Buy ${minU} units</div>
//               <div style="font-size:13px;font-weight:600;color:#374151;">${g.pName}</div>
//             </div>
//             <div style="display:flex;align-items:center;justify-content:center;width:28px;flex-shrink:0;font-size:18px;font-weight:700;color:#000;background:#fff;">=</div>
//             <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:14px 10px;text-align:center;flex:1;border-left:1px solid #e5e7eb;">
//               ${fpImg
//                 ? `<img src="${fpImg}" style="width:70px;height:90px;object-fit:cover;border-radius:8px;">`
//                 : `<div style="width:50px;height:50px;border-radius:8px;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:22px;">🎁</div>`}
//               <div style="font-size:14px;font-weight:700;color:#000;line-height:1.3;">${pack2}x ${fp.title}</div>
//               <div style="font-size:13px;color:#6b7280;">${pres2} | ${ml2} | Pack: ${qty2}</div>
//             </div>
//           </div>`);
//       });
//     });

//     const arrowColors = ['#22c55e','#ec4899','#f59e0b','#3b82f6'];
//     const allTableRows = [];
//     groups.forEach(g => {
//       const mainImgSrc = (() => {
//         const row = document.querySelector(`.b2b-variant-row[data-variant-id="${g.vid}"]`);
//         return row ? (row.dataset.imgUrl || '') : '';
//       })();
//       const minU = g.extras?.incentive_product || g.extras?.next_incentive_product || '?';
//       g.fps.forEach((fp, fi) => {
//         const fpImg  = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//         const vid2   = String(fp.variant_id || '');
//         const vd2    = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
//         const ml2    = vd2.ml || '—';
//         const pres2  = vd2.pres || '—';
//         const pack2  = ex2.quantity > 0 ? ex2.quantity : '—';
//         const qty2   = g.fqs[fi] || 1;
//         const color  = arrowColors[fi % arrowColors.length];
//         const bgC    = fi % 2 === 0 ? '#fff' : '#f9fafb';
//         allTableRows.push(`
//           <tr style="background:${bgC};border-bottom:1px solid #e5e7eb;">
//             <td style="padding:12px 14px;vertical-align:middle;">
//               <div style="display:flex;align-items:center;gap:10px;">
//                 ${mainImgSrc
//                   ? `<img src="${mainImgSrc}" style="width:70px;height:90px;object-fit:cover;border-radius:6px;flex-shrink:0;">`
//                   : `<div style="width:38px;height:38px;border-radius:6px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;">🛍️</div>`}
//                 <div>
//                   <div style="font-size:16px;color:#111;">${minU} units of</div>
//                   <div style="font-size:16px;font-weight:700;color:#111;">${g.pName}</div>
//                 </div>
//               </div>
//             </td>
//             <td style="padding:12px 14px;text-align:center;vertical-align:middle;">
//               <div style="display:flex;align-items:center;justify-content:center;gap:10px;">
                
//                 <div style="display:flex;flex-direction:column;align-items:center;gap:3px;">
//                   ${fpImg
//                     ? `<img src="${fpImg}" style="width:70px;height:90px;object-fit:cover;border-radius:6px;">`
//                     : `<div style="width:50px;height:50px;background:#f0fdf4;display:flex;align-items:center;justify-content:center;font-size:18px;border:2px solid #bbf7d0;">🎁</div>`}
//                   <div style="font-size:16px;font-weight:700;color:#111;">${pack2}x ${fp.title}</div>
//                   <div style="font-size:16px;color:#111;">${pres2} | ${ml2} | Pack: ${qty2}</div>
//                 </div>
//               </div>
//             </td>
//             <td style="padding:12px 14px;text-align:center;vertical-align:middle;">
//               <div style="display:flex;align-items:center;justify-content:center;gap:8px;">
               
//                 <div style="font-size:16px;color:#374151;text-align:left;">
//                   <div style="font-weight:700;">${pack2} ${pres2} ${ml2} ${fp.title} = ${minU} units ${g.pName} </div>
                  
//                 </div>
//               </div>
//             </td>
//           </tr>`);
//       });
//     });

//     function buildPaginationHTML(total, prevId, nextId, infoId) {
//       if (total <= PAGE_SIZE) return '';
//       return `
//         <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding-top:10px;border-top:1px solid #e5e7eb;">
//           <button type="button" id="${prevId}" style="padding:5px 16px;border:1px solid #e5e7eb;border-radius:6px;font-size:13px;cursor:pointer;font-family:'Crimson Pro',serif;font-weight:600;">← Prev</button>
//           <span id="${infoId}" style="font-size:13px;color:#6b7280;"></span>
//           <button type="button" id="${nextId}" style="padding:5px 16px;border:1px solid #e5e7eb;border-radius:6px;font-size:13px;cursor:pointer;font-family:'Crimson Pro',serif;font-weight:600;">Next →</button>
//         </div>`;
//     }
//     const totalSelectedUnits = groups.reduce((s, g) => s + g.qty, 0);
//     counterEl.innerHTML = `
//       <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px;flex-wrap:wrap;">
//         <div style="display:flex;flex-direction:column;gap:8px;">
//           <span style="font-size:15px;color:#6b7280;">
//             Distribute your free units below. Each group must use exactly its total.
//           </span>
//           <div style="position:relative;display:inline-block;">
//             <button type="button" id="${btnId}" onclick="
//               var el = document.getElementById('${listId}');
//               var open = el.style.display !== 'none';
//               el.style.display = open ? 'none' : 'block';
//               this.querySelector('.p3-arrow').textContent = open ? '▼' : '▲';
//             " style="display:inline-flex;align-items:center;gap:6px;background:none;border:1px solid #e5e7eb;border-radius:6px;cursor:pointer;font-size:14px;color:#374151;font-family:'Crimson Pro',serif;padding:5px 10px;">
//               <span style="font-weight:600;font-size:15px;">📋 Conversion Equivalencies Table</span>
//               <span class="p3-arrow" style="font-size:12px;color:#9ca3af;">▼</span>
//             </button>
//             <div id="${listId}" style="display:none;position:absolute;top:calc(100% + 6px);left:0;z-index:9999;min-width:1049px;max-width:860px;background:#fff;border:1px solid #e5e7eb;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,0.12);">
//               <div style="padding:16px 18px;">
//                 <div style="margin-bottom:24px;">
//                   <div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
//                     <span style="font-size:16px;">⭐</span>
//                     <span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Examples</span>
//                   </div>
//                   <div id="p3-guide-cards" style="display:flex;flex-wrap:wrap;gap:12px;min-height:60px;"></div>
//                   ${buildPaginationHTML(allGuideCards.length, 'p3-guide-prev', 'p3-guide-next', 'p3-guide-info')}
//                 </div>
//                 <div>
//                   <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
//                     <span style="font-size:16px;">⇄</span>
//                     <span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Conversion Equivalencies</span>
//                   </div>
//                   <div style="overflow-x:auto;">
//                     <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
//                       <thead>
//                         <tr style="background:#686a6c;color:#fff;">
//                           <th style="padding:10px 14px;text-align:left;font-size:13px;font-weight:600;border-radius:8px 0 0 0;">If You Purchase</th>
//                           <th style="padding:10px 14px;text-align:center;font-size:13px;font-weight:600;">You Can Receive (FOC)</th>
//                           <th style="padding:10px 14px;text-align:center;font-size:13px;font-weight:600;border-radius:0 8px 0 0;">Equivalency (Either Way)</th>
//                         </tr>
//                       </thead>
//                       <tbody id="p3-table-rows" style="min-height:60px;"></tbody>
//                     </table>
//                   </div>
//                   ${buildPaginationHTML(allTableRows.length, 'p3-table-prev', 'p3-table-next', 'p3-table-info')}
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//         <div style="display:flex;align-items:center;gap:10px;flex-shrink:0;">
//           <div style="display:flex;gap:16px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:8px 16px;">
//           <div style="text-align:center;">
//               <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">Selected unit</div>
//               <div style="font-size:20px;font-weight:700;color:#111;">${totalSelectedUnits}</div>
//             </div>
//             <div style="text-align:center;">
//               <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">FOC</div>
//               <div style="font-size:20px;font-weight:700;color:#111;">${total}</div>
//             </div>
//             <div style="width:1px;background:#e5e7eb;"></div>
//             <div style="text-align:center;">
//               <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">Selected</div>
//               <div style="font-size:20px;font-weight:700;color:#b8a77d;">${used}</div>
//             </div>
//             <div style="width:1px;background:#e5e7eb;"></div>
//             <div style="text-align:center;">
//               <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">Remaining</div>
//               <div style="font-size:20px;font-weight:700;color:${allDone ? '#16a34a' : '#b45309'};">${remaining}</div>
//             </div>
//           </div>
//           ${allDone
//             ? `<span style="background:#dcfce7;color:#166534;font-size:13px;font-weight:700;padding:6px 14px;border-radius:10px;">✓ All assigned!</span>`
//             : `<span></span>`}
//         </div>
//       </div>
//       <div style="border-radius:99px;height:7px;">
//         <div style="height:7px;border-radius:99px;background:${allDone ? '#16a34a' : '#b8a77d'};width:${pct}%;transition:width 0.3s;"></div>
//       </div>`;

//     let guideP = 0;
//     function renderGuideCards() {
//       const container = document.getElementById('p3-guide-cards');
//       const infoEl    = document.getElementById('p3-guide-info');
//       if (!container) return;
//       const start = guideP * PAGE_SIZE;
//       const end   = Math.min(start + PAGE_SIZE, allGuideCards.length);
//       container.innerHTML = allGuideCards.slice(start, end).join('');
//       if (infoEl) infoEl.textContent = allGuideCards.length > PAGE_SIZE ? `${start + 1}–${end} of ${allGuideCards.length}` : '';
//       const prevBtn = document.getElementById('p3-guide-prev');
//       const nextBtn = document.getElementById('p3-guide-next');
//       if (prevBtn) {
//         prevBtn.style.background = guideP === 0 ? '#f3f4f6' : '#b8a77d';
//         prevBtn.style.color      = guideP === 0 ? '#9ca3af' : '#fff';
//         prevBtn.style.border     = `1px solid ${guideP === 0 ? '#e5e7eb' : '#b8a77d'}`;
//         prevBtn.style.cursor     = guideP === 0 ? 'not-allowed' : 'pointer';
//         prevBtn.onclick = () => { if (guideP > 0) { guideP--; renderGuideCards(); } };
//       }
//       if (nextBtn) {
//         const isLast = end >= allGuideCards.length;
//         nextBtn.style.background = isLast ? '#f3f4f6' : '#b8a77d';
//         nextBtn.style.color      = isLast ? '#9ca3af' : '#fff';
//         nextBtn.style.border     = `1px solid ${isLast ? '#e5e7eb' : '#b8a77d'}`;
//         nextBtn.style.cursor     = isLast ? 'not-allowed' : 'pointer';
//         nextBtn.onclick = () => { if (!isLast) { guideP++; renderGuideCards(); } };
//       }
//     }

//     let tableP = 0;
//     function renderTableRows() {
//       const tbody  = document.getElementById('p3-table-rows');
//       const infoEl = document.getElementById('p3-table-info');
//       if (!tbody) return;
//       const start = tableP * PAGE_SIZE;
//       const end   = Math.min(start + PAGE_SIZE, allTableRows.length);
//       tbody.innerHTML = allTableRows.slice(start, end).join('');
//       if (infoEl) infoEl.textContent = allTableRows.length > PAGE_SIZE ? `${start + 1}–${end} of ${allTableRows.length}` : '';
//       const prevBtn = document.getElementById('p3-table-prev');
//       const nextBtn = document.getElementById('p3-table-next');
//       if (prevBtn) {
//         prevBtn.style.background = tableP === 0 ? '#f3f4f6' : '#b8a77d';
//         prevBtn.style.color      = tableP === 0 ? '#9ca3af' : '#fff';
//         prevBtn.style.border     = `1px solid ${tableP === 0 ? '#e5e7eb' : '#b8a77d'}`;
//         prevBtn.style.cursor     = tableP === 0 ? 'not-allowed' : 'pointer';
//         prevBtn.onclick = () => { if (tableP > 0) { tableP--; renderTableRows(); } };
//       }
//       if (nextBtn) {
//         const isLast = end >= allTableRows.length;
//         nextBtn.style.background = isLast ? '#f3f4f6' : '#b8a77d';
//         nextBtn.style.color      = isLast ? '#9ca3af' : '#fff';
//         nextBtn.style.border     = `1px solid ${isLast ? '#e5e7eb' : '#b8a77d'}`;
//         nextBtn.style.cursor     = isLast ? 'not-allowed' : 'pointer';
//         nextBtn.onclick = () => { if (!isLast) { tableP++; renderTableRows(); } };
//       }
//     }

//     setTimeout(() => {
//       renderGuideCards();
//       renderTableRows();
//     }, 50);
//   }

//   subEl.innerHTML = `<div id="p3-global-counter"></div>`;

//   function renderGroups() {
//     list.innerHTML = '';

//     // groups.forEach((g, gi) => {
//     //   const used       = calcGroupTotal(gi);
//     //   const remaining  = g.totalFree - used;
//     //   const isComplete = remaining === 0;
//     groups.forEach((g, gi) => {
//       const used       = calcGroupTotal(gi);
//       const target     = g.maxAchievable; // límite real (puede ser menor a totalFree si falta stock)
//       const remaining  = target - used;
//       const isComplete = remaining === 0;

//       const groupCard = document.createElement('div');
//       groupCard.style.cssText = `border:2px solid #e5e7eb;border-radius:12px;padding:16px;margin-bottom:20px;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,0.06);transition:border-color 0.2s,background 0.2s;`;


//       groupCard.innerHTML = `
//         <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid #e5e7eb;">
//           <div>
//             <span style="font-size:19px;font-weight:700;color:#686a6c;">${g.pName}</span>
//             <div style="font-size:18px;color:#6b7280;margin-top:4px;line-height:1.5;">
//               You ordered <strong style="color:#111;">${g.qty} units ${g.pName} </strong>
//               you can choose up to <strong style="color:#111;">${g.totalFree} FOC</strong>
//               ${g.totalFree > 1 ? `<span style="color:#9ca3af;font-size:16px;">(select ${g.totalFree} product${g.totalFree > 1 ? 's' : ''} below)</span>` : ''}
//             </div>
//           </div>
//           <div style="display:flex;align-items:center;gap:8px;">
//             <span style="font-size:18px;color:#6b7280;">
//               FOC assign: <strong style="color:${isComplete ? '#16a34a' : '#b45309'};">${remaining}</strong> / ${target}
//             </span>
//             ${isComplete ? `<span style="background:#dcfce7;color:#166534;font-size:11px;font-weight:700;padding:3px 10px;border-radius:12px;">✓ Complete</span>` : ''}
//           </div>
//         </div>
//         <div style="background:#e5e7eb;border-radius:99px;height:5px;margin-bottom:14px;">
//           <div style="height:5px;border-radius:99px;background:${isComplete ? '#16a34a' : '#b8a77d'};width:${Math.min(100,(used/g.totalFree)*100)}%;transition:width 0.3s;"></div>
//         </div>`;

//       const tableWrap = document.createElement('div');
//       tableWrap.style.cssText = 'overflow-x:auto;-webkit-overflow-scrolling:touch;';
//       tableWrap.innerHTML = `
//         <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;table-layout:fixed;">
//           <colgroup>
//             <col style="width:10%;"><col style="width:17%;"><col style="width:22%;">
//             <col style="width:14%;"><col style="width:12%;"><col style="width:11%;"><col style="width:14%;">
//           </colgroup>
//           <thead>
//             <tr style="background:#686a6c;color:#fff;">
//               <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Photo</th>
//               <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Collection</th>
//               <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Product</th>
//               <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Presentation</th>
//               <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Units/Pack</th>
//               <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">ML</th>
//               <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Qty</th>
//             </tr>
//           </thead>
//           <tbody id="p3-tbody-${gi}"></tbody>
//         </table>`;

//       groupCard.appendChild(tableWrap);
//       list.appendChild(groupCard);

//       const tbody = tableWrap.querySelector(`#p3-tbody-${gi}`);

//       // g.fps.forEach((fp, fi) => {
//       //   if (!fp?.title) return;
//       //   const imgSrc       = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//       //   const curQty       = selectedQtys[gi][fi] || 0;
//       //   const canAdd       = remaining > 0;
//       //   const canSub       = curQty > 0;
//       g.fps.forEach((fp, fi) => {
//         if (!fp?.title) return;
//         const imgSrc       = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//         const curQty       = selectedQtys[gi][fi] || 0;
//         const vidFp        = String(fp.variant_id || '');

//         // ── Límite adicional: no exceder stock real disponible para esta variante ──
//         const remainingStockForGift = getRemainingStockForGift(vidFp);
//         const stockCapReached = vidFp && curQty >= remainingStockForGift;

//         const canAdd       = remaining > 0 && !stockCapReached;
//         const canSub       = curQty > 0;
//         const vid2         = String(fp.variant_id || '');
//         const varData      = window.b2bAllVariantsMap?.[vid2] || {};
//         const extras2      = window.b2bVariantExtrasMap?.[vid2] || {};
//         const ml           = varData.ml || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
//         const pres         = varData.pres || '—';
//         const collection   = varData.collection || '—';
//         const unitsPerPack = extras2.quantity > 0 ? extras2.quantity : '—';
//         const bgColor      = fi % 2 === 0 ? '#fff' : '#f9fafb';
//         const tdC          = 'padding:9px 7px;vertical-align:middle;font-size:17px;color:#374151;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

//         const tr = document.createElement('tr');
//         tr.style.cssText = `background:${curQty > 0 ? '' : bgColor};border-bottom:1px solid #e5e7eb;transition:background 0.2s;`;
//         tr.innerHTML = `
//           <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
//             ${imgSrc
//               ? `<img src="${imgSrc}" style="width:48px;height:48px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;">`
//               : `<div style="width:48px;height:48px;border-radius:8px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:18px;">🎁</div>`}
//           </td>
//           <td style="${tdC}">${collection}</td>
//           <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
//             <div style="font-weight:700;color:#111;font-size:17px;white-space:normal;word-break:break-word;">${fp.title}</div>
//           </td>
//           <td style="${tdC}">${pres}</td>
//           <td style="${tdC};font-weight:700;color:#000;">${unitsPerPack}</td>
//           <td style="${tdC}">${ml}</td>
//           <td style="padding:9px 7px;text-align:center;vertical-align:middle;white-space:nowrap;">
//             <div style="display:inline-flex;align-items:center;gap:5px;">
//               <button type="button" data-gi="${gi}" data-fi="${fi}" data-action="minus"
//                 style="width:28px;height:28px;border:1px solid #e5e7eb;border-radius:6px;background:${canSub ? '#f9fafb' : '#f3f4f6'};font-size:16px;cursor:${canSub ? 'pointer' : 'not-allowed'};display:flex;align-items:center;justify-content:center;opacity:${canSub ? '1' : '0.4'};">−</button>
//               <span style="min-width:22px;text-align:center;font-weight:700;font-size:19px;color:#374151;">${curQty}</span>
//               <button type="button" data-gi="${gi}" data-fi="${fi}" data-action="plus"
//                 style="width:28px;height:28px;border:1px solid ${canAdd ? '#b8a77d' : '#e5e7eb'};border-radius:6px;background:${canAdd ? '#b8a77d' : '#f3f4f6'};color:${canAdd ? '#fff' : '#9ca3af'};font-size:16px;cursor:${canAdd ? 'pointer' : 'not-allowed'};display:flex;align-items:center;justify-content:center;opacity:${canAdd ? '1' : '0.4'};">+</button>
//             </div>
//           </td>`;
//         tbody.appendChild(tr);
//       });
//     });

//     updateGlobalCounter();
//   }

//   renderGroups();

//   list.addEventListener('click', e => {
//     const btn = e.target.closest('button[data-action]');
//     if (!btn) return;
//     const gi        = parseInt(btn.dataset.gi);
//     const fi        = parseInt(btn.dataset.fi);
//     const action    = btn.dataset.action;
//     const remaining = groups[gi].totalFree - calcGroupTotal(gi);

//     // if (action === 'plus') {
//     //   if (remaining <= 0) return;
//     //   selectedQtys[gi][fi] = (selectedQtys[gi][fi] || 0) + 1;
//     if (action === 'plus') {
//       if (remaining <= 0) return;
//       const fpCheck = groups[gi].fps[fi];
//       const vidCheck = String(fpCheck?.variant_id || '');
//       const remStock = getRemainingStockForGift(vidCheck);
//       if (vidCheck && (selectedQtys[gi][fi] || 0) >= remStock) return; // no superar stock disponible
//       selectedQtys[gi][fi] = (selectedQtys[gi][fi] || 0) + 1;
//     } else {
//       if ((selectedQtys[gi][fi] || 0) <= 0) return;
//       selectedQtys[gi][fi]--;
//     }
//     renderGroups();
//   });

//   const confirmBtn = getEl('variant-reward-confirm');
//   confirmBtn.textContent = '✓ Confirm My Choice';
//   // confirmBtn.onclick = () => {
//   //   const incomplete = groups.filter((g, gi) => calcGroupTotal(gi) !== g.totalFree);
//   confirmBtn.onclick = () => {
//     const incomplete = groups.filter((g, gi) => calcGroupTotal(gi) !== g.maxAchievable);
//    if (incomplete.length > 0) {
//       const overlay = getEl('b2b-processing-overlay') || (() => {
//         const el = document.createElement('div');
//         el.id = 'b2b-processing-overlay';
//         el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
//         document.body.appendChild(el);
//         return el;
//       })();

//       const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
//       const names   = incomplete.map(g => `<li style="margin:4px 0;">${g.pName}</li>`).join('');

//       overlay.innerHTML = `
//         <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
//                     box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
//                     max-width:440px;width:90%;">
//           <img src="${logoUrl}" alt="Logo"
//             style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
//             onerror="this.style.display='none'">
//           <div style="width:56px;height:56px;border-radius:50%;background:#fff;
//                       display:flex;align-items:center;justify-content:center;
//                       margin:0 auto 16px;font-size:28px;">⚠️</div>
//           <div style="font-size:17px;font-weight:700;color:#555;margin-bottom:8px;">
//             Pending free units
//           </div>
//           <p style="font-size:15px;color:#555;margin:0 0 14px;line-height:1.6;">
//             Please assign all free units for:
//           </p>
//           <ul style="text-align:center;list-style:none;padding:0 0 0 8px;margin:0 0 20px;font-size:15px;color:#1f2937;">
//             ${names}
//           </ul>
//           <button type="button" onclick="unlockUI()"
//             style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
//                   border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
//                   font-family:'Crimson Pro',serif;width:100%;">
//             OK, I'll fix it
//           </button>
//         </div>`;

//       overlay.style.display = 'flex';
//       return;
//     }
//     const selections = groups.map((g, gi) => ({
//       variantId: g.vid,
//       pName:     g.pName,
//       totalFree: g.totalFree,
//       qtys:      [...selectedQtys[gi]],
//       choices:   g.fps.map((fp, fi) => ({
//         ...fp,
//         chosenQty:       selectedQtys[gi][fi],
//         chosenVariantId: fp.variant_id && fp.variant_id !== '0' ? String(fp.variant_id) : null
//       })).filter(c => c.chosenQty > 0)
//     }));
//     window.b2bPriority3Choice = { confirmed: true, selections };
//     closeVariantRewardModal();
//     updateIncentiveBanners();
//     if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
//   };

//   modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// }

//  window.openPriority3Modal = openPriority3Modal;




// function closeVariantRewardModal() {
//   getEl('variant-reward-modal').style.display = 'none';
//   document.body.style.overflow = '';
//   _variantRewardCurrentId = null;
// }

// /* ============================================================
//    MODAL — COLLECTION REWARD CHOICE
//    ============================================================ */

// async function openRewardChoiceModal() {
//   const rule = rewardChoice.active;
//   if (!rule) return;

//   const modal     = getEl('reward-choice-modal');
//   const prodsEl   = getEl('reward-products-section');
//   const prodsList = getEl('reward-products-list');
//   prodsEl.style.display = 'none';

//   const disc    = Number(rule.discount || 0);
//   const options = [];

//   if (Array.isArray(rule.free_testers) && rule.free_testers.length) {
//     rule.free_testers.forEach((tp, i) => {
//       if (!tp?.title) return;
//       options.push({ type: 'tester', label: `${getTesterQty(rule, i)}x tester: ${tp.title}`,
//         handle: tp.handle || null, variant_id: tp.variant_id || null,
//         variant_title: tp.variant_title || '', id: tp.id || null,
//         image: tp.image || null, title: tp.title, qty: getTesterQty(rule, i) });
//     });
//   } else {
//     const total = normalizeQtyArray(rule.testers_qty).reduce((s, q) => s + q, 0);
//     if (total > 0) options.push({ type: 'tester', label: `${total} tester${total > 1 ? 's' : ''}`, handle: null, image: null, qty: total });
//   }

//   (rule.free_products || []).forEach((fp, i) => {
//     const qty = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
//     if (fp?.title) options.push({
//       type: 'product', label: `${qty}x free: ${fp.title}`, handle: fp.handle,
//       image: fp.image, title: fp.title, variant_id: fp.variant_id || null,
//       variant_title: fp.variant_title || '', qty
//     });
//   });

//   if (disc > 0) options.push({ type: 'discount', label: `🏷️ ${disc}% discount on your order`, handle: null, image: null, qty: 0 });
//   if (!options.length) return;

//   const variantMap = {};
//   await Promise.all(options.filter(o => (o.type === 'product' || o.type === 'tester') && o.handle).map(async o => {
//     try {
//       const res = await fetch(`/products/${o.handle}.js`);
//       if (!res.ok) return;
//       const all = (await res.json()).variants || [];
//       if (o.type === 'tester') { variantMap[o.handle] = all; return; }
//       const FREE_KW = ['free', 'gift', 'sample'];
//       const free = all.filter(v =>
//         parseFloat(v.price) === 0 ||
//         FREE_KW.some(k => (v.sku || '').toLowerCase().includes(k) || ['option1','option2','option3'].some(f => (v[f]||'').toLowerCase().includes(k)))
//       );
//       variantMap[o.handle] = free.length ? free : all;
//     } catch {}
//   }));

//   prodsEl.style.display = 'block';
//   prodsList.innerHTML   = '<p style="color:#6b7280;font-size:13px;margin:0 0 14px;">Select ONE reward:</p>';

//   options.forEach(opt => {
//     const isSelected = rewardChoice.chosenType === opt.type && (
//       opt.type === 'discount'
//         ? true
//         : rewardChoice.chosenProductHandle === opt.handle &&
//           rewardChoice.chosenVariantId === (opt._autoVariantId || (opt.variant_id && opt.variant_id !== '0' ? String(opt.variant_id) : null))
//     );
//     const imgSrc     = opt.image ? opt.image.replace(/^\/\//, 'https://') : '';
//     let variantHTML  = '';

//     if ((opt.type === 'product' || opt.type === 'tester') && opt.variant_id && opt.variant_id !== '0') {
//       opt._autoVariantId = String(opt.variant_id);
//       const vLabel = opt.variant_title && opt.variant_title.toLowerCase() !== 'default title' ? opt.variant_title : '';
//       if (vLabel) variantHTML = `<div style="margin-top:5px;font-size:12px;color:#6b7280;">Variant: <strong>${vLabel}</strong></div>`;
//     } else if (variantMap[opt.handle]?.length) {
//       const vms = variantMap[opt.handle];
//       if (vms.length === 1) {
//         opt._autoVariantId = String(vms[0].id);
//         const lbl = vms[0].option1 + (vms[0].option2 && vms[0].option2.toLowerCase() !== 'default title' ? ' / ' + vms[0].option2 : '');
//         if (lbl && lbl.toLowerCase() !== 'default title') variantHTML = `<div style="margin-top:5px;font-size:12px;color:#6b7280;">Variant: <strong>${lbl}</strong></div>`;
//       } else if (opt.type === 'product') {
//         const curVid = rewardChoice.chosenProductHandle === opt.handle ? rewardChoice.chosenVariantId : '';
//         const opts = vms.map(v => {
//           const lbl = v.option1 + (v.option2 && v.option2.toLowerCase() !== 'default title' ? ' / ' + v.option2 : '');
//           return `<option value="${v.id}" ${String(v.id) === String(curVid) ? 'selected' : ''}>${lbl}</option>`;
//         }).join('');
//         variantHTML = `<div class="reward-variant-wrap" style="margin-top:10px;display:${isSelected?'block':'none'};">
//           <label style="font-size:12px;color:#555;display:block;margin-bottom:4px;">Select variant:</label>
//           <select class="reward-variant-sel" data-handle="${opt.handle}" style="width:100%;padding:8px 10px;border:1px solid #d1d5db;border-radius:6px;font-size:13px;background:#fff;">
//             <option value="">— Select variant —</option>${opts}
//           </select></div>`;
//       } else {
//         const autoV = vms.find(v => v.available) || vms[0];
//         opt._autoVariantId = String(autoV.id);
//       }
//     }

//     const card = document.createElement('div');
//     card.className = 'b2b-reward-card';
//     card.style.cssText = `display:flex;align-items:flex-start;gap:12px;padding:14px;border:2px solid ${isSelected?'#16a34a':'#e5e7eb'};border-radius:10px;margin-bottom:10px;cursor:pointer;background:${isSelected?'#f0fdf4':'#fff'};transition:all .15s;`;
//     card.innerHTML = `
//       <div class="b2b-reward-radio" style="width:22px;height:22px;border-radius:50%;border:2px solid ${isSelected?'#16a34a':'#9ca3af'};background:${isSelected?'#16a34a':'#fff'};display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px;">
//         ${isSelected ? '<svg width="12" height="12" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>' : ''}
//       </div>
//       ${imgSrc ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:8px;flex-shrink:0;">` : ''}
//       <div style="flex:1;"><div style="font-weight:700;color:#111;font-size:14px;">${opt.label}</div>${variantHTML}</div>`;

//     if (isSelected && opt._autoVariantId && !rewardChoice.chosenVariantId) rewardChoice.chosenVariantId = opt._autoVariantId;

//     card.addEventListener('click', e => {
//       if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
//       prodsList.querySelectorAll('.b2b-reward-card').forEach(c => {
//         c.style.border = '2px solid #e5e7eb'; c.style.background = '#fff';
//         const r = c.querySelector('.b2b-reward-radio'); if (r) { r.style.border = '2px solid #9ca3af'; r.style.background = '#fff'; r.innerHTML = ''; }
//         const vw = c.querySelector('.reward-variant-wrap'); if (vw) vw.style.display = 'none';
//       });
//       card.style.border = '2px solid #16a34a'; card.style.background = '#f0fdf4';
//       const radio = card.querySelector('.b2b-reward-radio');
//       if (radio) { radio.style.border = '2px solid #16a34a'; radio.style.background = '#16a34a'; radio.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>'; }
//       const vw = card.querySelector('.reward-variant-wrap'); if (vw) vw.style.display = 'block';
//       rewardChoice.chosenType          = opt.type;
//       rewardChoice.chosenProductHandle = opt.type !== 'discount' ? opt.handle : null;
//       rewardChoice.chosenProductTitle  = opt.type !== 'discount' ? opt.title  : null;
//       rewardChoice.chosenProductImage  = opt.type !== 'discount' ? opt.image  : null;
//       rewardChoice.chosenQty           = opt.qty || 1;
//       rewardChoice.chosenVariantId     = opt._autoVariantId || (opt.variant_id && opt.variant_id !== '0' ? String(opt.variant_id) : null);
//       rewardChoice.discountPct         = opt.type === 'discount' ? disc : 0;
//     });

//     const sel = card.querySelector('.reward-variant-sel');
//     if (sel) {
//       sel.addEventListener('change', () => { rewardChoice.chosenVariantId = sel.value; });
//       if (isSelected && rewardChoice.chosenVariantId) sel.value = rewardChoice.chosenVariantId;
//     }

//     prodsList.appendChild(card);
//   });

//   modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// }

// function closeRewardChoiceModal() {
//   getEl('reward-choice-modal').style.display = 'none';
//   document.body.style.overflow = '';
// }

// /* ============================================================
//    RENDER PURCHASE DETAILS
//    ============================================================ */
//   // function renderPurchaseDetails() {
//   //   ensureSkuPopup();
//   //   const content = getEl('b2b-details-content');
//   //   const noMsg   = getEl('b2b-no-items-msg');
//   //   if (!content) return;
//   //   content.innerHTML = '';
//   //   if (noMsg) noMsg.style.display = 'none';

//   //   const uniqueProducts = new Set(), uniqueCollections = new Set();
//   //   let totalItems = 0, grandTotal = 0;

//   //   function getSelectionPrice(sel) {
//   //     const metaP = parseFloat(sel.incentive_product_price || 0);
//   //     if (metaP > 0) return metaP;
//   //     const vid2    = String(sel.variant_id || '');
//   //     const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
//   //     const metaP2  = parseFloat(extras2.incentive_product_price || 0);
//   //     if (metaP2 > 0) return metaP2;
//   //     return parseFloat(sel.price || 0);
//   //   }

//   //   // ── Filas principales ──
//   //   const mainRows = [];
//   //   variantRows().forEach(row => {
//   //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//   //     if (!qty) return;
//   //     const sku        = (row.dataset.sku || '-').toUpperCase();
//   //     const vendor     = new URLSearchParams(window.location.search).get('vendor') || '';
//   //     const product    = row.cells[5]?.textContent?.trim() || 'Product';
//   //     const ml         = row.cells[7]?.textContent?.trim() || 'N/A';
//   //     const pres       = row.cells[8]?.textContent?.trim() || 'N/A';
//   //     const collection = row.cells[4]?.textContent?.trim() || 'N/A';
//   //     const unitPrice  = parseFloat(row.dataset.unitPrice || 0);
//   //     const subtotal   = qty * unitPrice;
//   //     const imgUrl     = row.dataset.imgUrl || '';
//   //     const coeff      = row.cells[10]?.textContent?.trim() || 'N/A';

//   //       mainRows.push(`
//   //       <tr style="border-bottom:1px solid #e5e7eb;">
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
//   //           ${imgUrl
//   //             ? `<img src="${imgUrl}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;cursor:pointer;"
//   //                 class="detail-img-hover"
//   //                 data-description="${row.dataset.description||''}"
//   //                 data-top-notes="${row.dataset.topNotes||''}"
//   //                 data-middle-notes="${row.dataset.middleNotes||''}"
//   //                 data-base-notes="${row.dataset.baseNotes||''}"
//   //                 onerror="this.style.display='none'">`
//   //             : '<div style="width:52px;height:52px;border-radius:6px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">📦</div>'}
//   //         </td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">${product}</td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${sku}</td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${ml}</td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${pres}</td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${collection}</td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${coeff}</td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
//   //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">$${subtotal.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
//   //       </tr>`);

//   //     totalItems += qty; grandTotal += subtotal;
//   //     uniqueProducts.add(product); uniqueCollections.add(collection);
//   //   });

//   //   // ── Filas de incentivos ──
//   //   const freeRows = [];
//   //   const freeRowsData = [];
//   //   const withOwnRule = new Set();
//   //   const colH     = getColHandle();
//   //   const rulesRPD = window.b2bCollectionIncentivesMap?.[colH] || [];

//   //   function getFreeVariantInfo(variantId) {
//   //     if (!variantId) return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack:'—' };
//   //     const vid = String(variantId);
//   //     const freeRow = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
//   //     const extras2 = window.b2bVariantExtrasMap?.[vid] || {};
//   //     const unitsPerPack = extras2.quantity > 0 ? extras2.quantity : '—';
//   //     if (freeRow) {
//   //       return {
//   //         sku:         (freeRow.dataset.sku || '').toUpperCase() || '—',
//   //         ml:          freeRow.cells[7]?.textContent?.trim()  || '—',
//   //         pres:        freeRow.cells[8]?.textContent?.trim()  || '—',
//   //         collection:  freeRow.cells[4]?.textContent?.trim()  || '—',
//   //         coefficient: freeRow.cells[10]?.textContent?.trim() || '—',
//   //         unitsPerPack
//   //       };
//   //     }
//   //     const v = window.b2bAllVariantsMap?.[vid];
//   //     if (v) return {
//   //       sku:         v.sku         || '—',
//   //       ml:          v.ml          || '—',
//   //       pres:        v.pres        || '—',
//   //       collection:  v.collection  || '—',
//   //       coefficient: v.coefficient || '—',
//   //       unitsPerPack
//   //     };
//   //     return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack:'—' };
//   //   }

//   //     function addFreeRow(imgSrc, title, badge, badgeBg, subtitle, variantId, qty, extraCol = '—') {
//   //         const info = getFreeVariantInfo(variantId);
//   //          const pack = parseInt(info.unitsPerPack) || 1;
//   //         // Solo multiplicar por Units/Pack si la presentación es Vails
//   //         const isVails = (info.pres || '').toLowerCase().includes('vail');
//   //         const totalUnits = isVails ? (parseInt(qty) || 0) * pack : (parseInt(qty) || 0);
//   //         freeRowsData.push({ pres: info.pres, qty: totalUnits });
//   //         // freeRowsData.push({ pres: info.pres, qty: parseInt(qty) || 0 });
//   //         freeRows.push(`
//   //           <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
//   //               ${imgSrc
//   //                 ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
//   //                 : '<div style="width:52px;height:52px;border-radius:6px;background:#dcfce7;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>'}
//   //             </td>
//   //             <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;text-align: center;">
//   //               ${title}
                
//   //             </td>
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
             
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${extraCol}</td>
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
//   //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">$0.00</td>
//   //           </tr>`);
//   //      }

//   //   // P1 variant incentives
//   //   variantRows().forEach(row => {
//   //     const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//   //     if (qty <= 0) return;
//   //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//   //     if (!variantHasIncentive(extras)) return;
//   //     const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
//   //     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

//   //     withOwnRule.add(row.dataset.variantId);
//   //     const pName      = row.cells[5]?.textContent?.trim() || 'Product';
//   //     const multiplier = calcVariantMultiplier(extras, qty, lineV);
//   //     const fps        = getVariantFreeProducts(extras);
//   //     const fqs        = getVariantFreeQtys(extras);
//   //     const choice     = window.b2bVariantRewardChoices[row.dataset.variantId];

//   //     if (fps.length > 1 && choice?.confirmed) {
//   //       const img  = (choice.chosenImage || '').replace(/^\/\//, 'https://');
//   //       const vid2 = choice.chosenVariantId;
//   //       const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//   //       const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//   //       addFreeRow(img, choice.chosenTitle, 'FREE', '#16a34a', `${pName} Incentive — Your Choice`, vid2, choice.chosenQty, up);
//   //     } else if (fps.length > 1 && !choice?.confirmed) {
//   //       if (Number(window.b2bCollectionPriority || 1) !== 2 && Number(window.b2bCollectionPriority || 1) !== 3) {
//   //         freeRows.push(`
//   //           <tr style="border-bottom:1px solid #fde68a;background:#fffbeb;">
//   //             <td colspan="7" style="padding:12px 16px;">
//   //               <div style="display:flex;align-items:center;gap:10px;">
//   //                 <span style="font-size:20px;">⚠️</span>
//   //                 <div>
//   //                   <strong style="color:#92400e;">Free Gift Pending Selection</strong>
//   //                   <span style="font-size:12px;color:#92400e;margin-left:8px;">${pName} — click Choose Gift to select</span>
//   //                 </div>
//   //               </div>
//   //             </td>
//   //           </tr>`);
//   //       }
//   //     } else {
//   //       fps.forEach((fp, i) => {
//   //         if (!fp?.title) return;
//   //         const giftQty = (fqs[i] || 1) * multiplier;
//   //         const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//   //         const vid2    = String(fp.variant_id || '');
//   //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//   //         const up      = ex2.quantity > 0 ? ex2.quantity : '—';
//   //         addFreeRow(img, fp.title, 'FREE', '#16a34a', `${pName} Incentive`, vid2, giftQty, up);
//   //       });
//   //     }
//   //   });

//   //   // P2
//   //   const p2choice = window.b2bPriority2Choice || {};
//   //   if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
//   //     p2choice.selections.filter(sel => (sel.selectedQty || 0) > 0).forEach(sel => {
//   //       const imgSrc   = (sel.image || '').replace(/^\/\//, 'https://');
//   //       const vid      = String(sel.variant_id || '');
//   //       const ex2      = window.b2bVariantExtrasMap?.[vid] || {};
//   //       const up       = ex2.quantity > 0 ? ex2.quantity : '—';
//   //       const price    = getSelectionPrice(sel);
//   //       const discPct2 = parseFloat(p2choice.discountPct || 0);
//   //       const final    = price * (1 - discPct2 / 100);
//   //       const subtotal = final * sel.selectedQty;
//   //       const info     = getFreeVariantInfo(vid);
//   //       freeRowsData.push({ pres: info.pres, qty: sel.selectedQty });
//   //      freeRows.push(`
//   //         <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;">
//   //             ${imgSrc
//   //               ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
//   //               : '<div style="width:52px;height:52px;border-radius:6px;background:#dbeafe;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🏷️</div>'}
//   //           </td>
//   //           <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">
//   //             ${sel.title}
              
//   //           </td>
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
            
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${up}</td>
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${sel.selectedQty}</td>
//   //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">$${subtotal.toFixed(2)}</td>
//   //         </tr>`);
//   //     });
//   //   }

//   //   // P3
//   //   const p3choice = window.b2bPriority3Choice || {};
//   //   if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
//   //     p3choice.selections.forEach(sel => {
//   //       (sel.choices || []).forEach(choice => {
//   //         if (!choice.chosenQty || choice.chosenQty <= 0) return;
//   //         const imgSrc = (choice.image || '').replace(/^\/\//, 'https://');
//   //         const vid2   = String(choice.chosenVariantId || '');
//   //         const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
//   //         const up     = ex2.quantity > 0 ? ex2.quantity : '—';
//   //         addFreeRow(imgSrc, choice.title, 'FREE', '#16a34a', `${sel.pName} — Your choice (P3)`, vid2, choice.chosenQty, up);
//   //       });
//   //     });
//   //   }

//   //   // Collection rules
//   //   let unitsCol = 0, valueCol = 0;
//   //   variantRows().forEach(row => {
//   //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//   //     if (qty <= 0 || withOwnRule.has(row.dataset.variantId)) return;
//   //     unitsCol += qty;
//   //     valueCol += qty * parseFloat(row.dataset.unitPrice || 0);
//   //   });

//   //   const activeRPD = rulesRPD.length ? calcActiveIncentive(rulesRPD, unitsCol, valueCol) : null;
//   //   if (activeRPD) {
//   //     if (isAutoApply(activeRPD)) {
//   //       (activeRPD.free_products || []).forEach((fp, i) => {
//   //         if (!fp?.title) return;
//   //         const giftQty = normalizeQtyArray(activeRPD.free_product_quantities)[i] || 1;
//   //         const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//   //         const vid2    = String(fp.variant_id || '');
//   //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//   //         const up      = ex2.quantity > 0 ? ex2.quantity : '—';
//   //         addFreeRow(img, fp.title, 'FREE', '#16a34a', 'Collection Incentive', vid2, giftQty, up);
//   //       });
//   //       (activeRPD.free_testers || []).forEach((tp, i) => {
//   //         if (!tp?.title) return;
//   //         const q   = getTesterQty(activeRPD, i);
//   //         const img = tp.image ? tp.image.replace(/^\/\//, 'https://') : '';
//   //         const vid2 = String(tp.variant_id || '');
//   //         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//   //         const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//   //         addFreeRow(img, tp.title, 'TESTER', '#2563eb', 'Collection Incentive', vid2, q, up);
//   //       });
//   //     } else if (rewardChoice.confirmed) {
//   //       const ct  = rewardChoice.chosenType;
//   //       const img = (rewardChoice.chosenProductImage || '').replace(/^\/\//, 'https://');
//   //       if (ct === 'tester' || ct === 'product') {
//   //         const vid2 = rewardChoice.chosenVariantId;
//   //         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//   //         const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//   //         addFreeRow(img, rewardChoice.chosenProductTitle || ct, ct === 'tester' ? 'TESTER' : 'FREE', '#16a34a', 'Your chosen reward', vid2, rewardChoice.chosenQty || 1, up);
//   //       }
//   //     }
//   //   }

//   //   // ── Contar incentivos ──
//   //   let totalIncentives = 0;
//   //   variantRows().forEach(row => {
//   //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//   //     if (qty <= 0) return;
//   //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//   //     if (!variantHasIncentive(extras)) return;
//   //     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//   //     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//   //     const fps    = getVariantFreeProducts(extras);
//   //     const fqs    = getVariantFreeQtys(extras);
//   //     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//   //     if (fps.length > 1 && choice?.confirmed) {
//   //       totalIncentives += choice.chosenQty || 0;
//   //     } else if (fps.length <= 1) {
//   //       fps.forEach((fp, i) => { totalIncentives += fqs[i] || 1; });
//   //     }
//   //   });
//   //   const p2i = window.b2bPriority2Choice || {};
//   //   if (p2i.confirmed && Array.isArray(p2i.selections)) {
//   //     p2i.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => { totalIncentives += s.selectedQty; });
//   //   }
//   //   const p3i = window.b2bPriority3Choice || {};
//   //   if (p3i.confirmed && Array.isArray(p3i.selections)) {
//   //     p3i.selections.forEach(sel => {
//   //       (sel.choices || []).forEach(c => { totalIncentives += c.chosenQty || 0; });
//   //     });
//   //   }

//   //   // ── Totales ──
//   //   const p2 = window.b2bPriority2Choice || {};
//   //   let p2Subtotal = 0;
//   //   if (p2.confirmed && Array.isArray(p2.selections)) {
//   //     p2.selections.filter(s => s.selectedQty > 0).forEach(s => {
//   //       const price    = getSelectionPrice(s);
//   //       const discPct2 = parseFloat(p2.discountPct || 0);
//   //       p2Subtotal += price * (1 - discPct2 / 100) * s.selectedQty;
//   //     });
//   //   }
//   //   const discPct    = rewardChoice?.discountPct || 0;
//   //   const discAmount = discPct > 0 ? grandTotal * discPct / 100 : 0;
//   //   const finalTotal = grandTotal - discAmount;
//   //   const fmt = n => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//   //   // ── Construir HTML final ──
//   //   const tableStyle = 'width:100%;border-collapse:collapse;font-family:"Crimson Pro",serif;';
//   //   const thStyle    = 'padding:9px 8px;text-align:center;font-size:17px;font-weight:600;color:#fff;';

//   //   let html = '';

//   //   if (mainRows.length) {
//   //  html += `
//   //     <div style="overflow-x:auto;margin-bottom:0;">
//   //       <table style="${tableStyle}">
//   //         <thead>
//   //           <tr style="background:#686a6c;">
//   //             <th style="${thStyle}">Photo</th>
//   //             <th style="${thStyle}">Product</th>
//   //             <th style="${thStyle}">SKU</th>
//   //             <th style="${thStyle}">ML</th>
//   //             <th style="${thStyle}">Presentation</th>
//   //             <th style="${thStyle}">Collection</th>
//   //             <th style="${thStyle}">Coefficient</th>
//   //             <th style="${thStyle}">Qty</th>
//   //             <th style="${thStyle}">Total</th>
//   //           </tr>
//   //         </thead>
//   //         <tbody>
//   //           ${mainRows.join('')}
//   //         </tbody>
//   //       </table>
//   //     </div>`;
//   //   }

//   //   if (freeRows.length) {
//   //     html += `
//   //       <div style="margin-top:16px;overflow-x:auto;">
//   //         <div class="b2b-free-gifts-header">Incentives Included</div>
//   //         <table style="${tableStyle}">
//   //           <thead>
//   //             <tr style="background:#686a6c;">
//   //               <th style="${thStyle}">Photo</th>
//   //               <th style="${thStyle}">Product</th>
//   //               <th style="${thStyle}">SKU</th>
//   //               <th style="${thStyle}">ML</th>
//   //               <th style="${thStyle}">Presentation</th>
//   //               <th style="${thStyle}">Collection</th>
                
//   //               <th style="${thStyle}">Units/Pack</th>
//   //               <th style="${thStyle}">Qty</th>
//   //               <th style="${thStyle}">Total</th>
//   //             </tr>
//   //           </thead>
//   //           <tbody>
//   //             ${freeRows.join('')}
//   //           </tbody>
//   //         </table>
//   //       </div>`;
//   //   }


//   //   const incentiveByPres = {};
//   //     freeRowsData.forEach(item => {
//   //       const key = item.pres && item.pres !== '—' ? item.pres : 'Other';
//   //       incentiveByPres[key] = (incentiveByPres[key] || 0) + item.qty;
//   //     });
//   //     const totalIncentiveQty = totalIncentives;

//   //     const presBreakdownHTML = Object.entries(incentiveByPres).map(([pres, qty]) => `
//   //       <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
//   //         <span style="font-weight:400;text-align:right;padding-right:16px;color:#000;font-size:16px;">GWP ${pres}</span>
//   //         <span style="text-align:right;font-size:16px; color:#000;">${qty}</span>
//   //       </div>`).join('');

//   //   // Totales
//   //   html += `
//   //       <div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px;font-size:15px;margin-top:16px;padding-top:12px;padding-bottom:40px;border-top:1px solid #e5e7eb;">

//   //         ${totalIncentiveQty > 0 ? `
//   //         <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
//   //           <span style="font-weight:700;text-align:right;padding-right:16px; color:#000">GWP Qty</span>
//   //           <span style="font-weight:700;text-align:right;color:#000">${totalIncentiveQty}</span>
//   //         </div>
//   //         ${presBreakdownHTML}
//   //         <div style="width:300px;border-top:1px dashed #d1d5db;margin:4px 0;"></div>
//   //         ` : ''}

//   //         <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
//   //           <span style="font-weight:600;text-align:right;padding-right:16px;">Total Qty</span>
//   //           <span style="font-weight:700;text-align:right;">${totalItems.toLocaleString('en-US')}</span>
//   //         </div>
//   //         <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
//   //           <span style="font-weight:600;text-align:right;padding-right:16px;">Subtotal</span>
//   //           <span style="text-align:right;">$${fmt(grandTotal)}</span>
//   //         </div>
//   //         ${p2Subtotal > 0
//   //           ? `<div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;color:#2563eb;">
//   //               <span style="font-weight:600;text-align:right;padding-right:16px;">Reward Credit (${p2.discountPct}%)</span>
//   //               <span style="font-weight:700;text-align:right;">$${fmt(p2Subtotal)}</span>
//   //             </div>` : ''}
//   //         ${discPct > 0
//   //           ? `<div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;color:#b45309;">
//   //               <span style="font-weight:600;text-align:right;padding-right:16px;">Discount (${discPct}%)</span>
//   //               <span style="font-weight:700;text-align:right;">-$${fmt(discAmount)}</span>
//   //             </div>
//   //             <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;font-size:17px;color:#166534;">
//   //               <span style="font-weight:700;text-align:right;padding-right:16px;">Estimated Total</span>
//   //               <span style="font-weight:800;text-align:right;">$${fmt(finalTotal)}</span>
//   //             </div>`
//   //           : `<div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;font-size:17px;">
//   //               <span style="font-weight:700;text-align:right;padding-right:16px;">Estimated Total</span>
//   //               <span style="font-weight:800;text-align:right;">$${fmt(finalTotal)}</span>
//   //             </div>`}
//   //       </div>`;

//   //   if (!mainRows.length) {
//   //     if (noMsg) noMsg.style.display = 'block';
//   //   } else {
//   //     content.innerHTML = html;
//   //     content.querySelectorAll('.detail-img-hover').forEach(img => {
//   //       img.addEventListener('mouseenter', e => {
//   //         skuPopup.querySelector('.sku-popup-img').src = img.src || '';
//   //         skuPopup.querySelector('.popup-description').textContent  = img.dataset.description || '';
//   //         skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(img.dataset.topNotes);
//   //         skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(img.dataset.middleNotes);
//   //         skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(img.dataset.baseNotes);
//   //         positionPopup(e); skuPopup.classList.add('visible');
//   //       });
//   //       img.addEventListener('mousemove', positionPopup);
//   //       img.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
//   //     });
//   //   }

//   //   getEl('dash-count-product').textContent    = uniqueProducts.size;
//   //   getEl('dash-unique-types').textContent     = uniqueCollections.size;
//   //   getEl('dash-total-items').textContent      = totalItems;
//   //   getEl('dash-total-incentives').textContent = totalIncentives;
//   //   getEl('dash-total-purchase').textContent   = '$' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//   //   getEl('b2b-incentive-summary-panel').style.display = 'none';
//   // }

// //  function renderPurchaseDetails() {
// //     ensureSkuPopup();
// //     const content = getEl('b2b-details-content');
// //     const noMsg   = getEl('b2b-no-items-msg');
// //     if (!content) return;
// //     content.innerHTML = '';
// //     if (noMsg) noMsg.style.display = 'none';

// //     const uniqueProducts = new Set(), uniqueCollections = new Set();
// //     let totalItems = 0, grandTotal = 0;

// //     const tableStyle = 'width:100%;border-collapse:collapse;font-family:"Crimson Pro",serif;';
// //     const thStyle    = 'padding:9px 8px;text-align:center;font-size:17px;font-weight:600;color:#fff;';

// //     function getSelectionPrice(sel) {
// //       const metaP = parseFloat(sel.incentive_product_price || 0);
// //       if (metaP > 0) return metaP;
// //       const vid2    = String(sel.variant_id || '');
// //       const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
// //       const metaP2  = parseFloat(extras2.incentive_product_price || 0);
// //       if (metaP2 > 0) return metaP2;
// //       return parseFloat(sel.price || 0);
// //     }

// //     // ── Agrupar filas principales por presentación ──
// //     const groupedRows = {};
// //     const groupOrder  = [];

// //     variantRows().forEach(row => {
// //       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       if (!qty) return;

// //       const sku        = (row.dataset.sku || '-').toUpperCase();
// //       const product    = row.cells[5]?.textContent?.trim() || 'Product';
// //       const ml         = row.cells[7]?.textContent?.trim() || 'N/A';
// //       const presDisp   = row.cells[8]?.textContent?.trim() || 'N/A';
// //       const presLower  = presDisp.toLowerCase();
// //       const collection = row.cells[4]?.textContent?.trim() || 'N/A';
// //       const unitPrice  = parseFloat(row.dataset.unitPrice || 0);
// //       const subtotal   = qty * unitPrice;
// //       const imgUrl     = row.dataset.imgUrl || '';
// //       const coeff      = row.cells[10]?.textContent?.trim() || 'N/A';

// //       let groupKey = 'Others';
// //       if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
// //       // else if (presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
// //       else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester') || presLower.includes('sample')) groupKey = 'Vials & Testers';
// //       else if (presLower.includes('retail'))                               groupKey = 'Retail';
// //       else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;

// //       if (!groupedRows[groupKey]) {
// //         groupedRows[groupKey] = { rows: [], subtotal: 0, qty: 0 };
// //         groupOrder.push(groupKey);
// //       }

// //       groupedRows[groupKey].subtotal += subtotal;
// //       groupedRows[groupKey].qty      += qty;
// //       groupedRows[groupKey].rows.push(`
// //         <tr style="border-bottom:1px solid #e5e7eb;">
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
// //             ${imgUrl
// //               ? `<img src="${imgUrl}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;cursor:pointer;"
// //                   class="detail-img-hover"
// //                   data-description="${row.dataset.description||''}"
// //                   data-top-notes="${row.dataset.topNotes||''}"
// //                   data-middle-notes="${row.dataset.middleNotes||''}"
// //                   data-base-notes="${row.dataset.baseNotes||''}"
// //                   onerror="this.style.display='none'">`
// //               : '<div style="width:52px;height:52px;border-radius:6px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">📦</div>'}
// //           </td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">${product}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${sku}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${ml}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${presDisp}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${collection}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${coeff}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">$${subtotal.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
// //         </tr>`);

// //       totalItems += qty;
// //       grandTotal += subtotal;
// //       uniqueProducts.add(product);
// //       uniqueCollections.add(collection);
// //     });

// //     // ── Filas de incentivos ──
// //     const freeRows     = [];
// //     const freeRowsData = [];
// //     const withOwnRule  = new Set();
// //     const colH         = getColHandle();
// //     const rulesRPD     = window.b2bCollectionIncentivesMap?.[colH] || [];

// //     function getFreeVariantInfo(variantId) {
// //       if (!variantId) return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
// //       const vid      = String(variantId);
// //       const freeRow  = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
// //       const extras2  = window.b2bVariantExtrasMap?.[vid] || {};
// //       const unitsPerPack = parseInt(extras2.quantity) || 0;
// //       if (freeRow) {
// //         return {
// //           sku:         (freeRow.dataset.sku || '').toUpperCase() || '—',
// //           ml:          freeRow.cells[7]?.textContent?.trim()  || '—',
// //           pres:        freeRow.cells[8]?.textContent?.trim()  || '—',
// //           collection:  freeRow.cells[4]?.textContent?.trim()  || '—',
// //           coefficient: freeRow.cells[10]?.textContent?.trim() || '—',
// //           unitsPerPack
// //         };
// //       }
// //       const v = window.b2bAllVariantsMap?.[vid];
// //       if (v) return {
// //         sku:         v.sku         || '—',
// //         ml:          v.ml          || '—',
// //         pres:        v.pres        || '—',
// //         collection:  v.collection  || '—',
// //         coefficient: v.coefficient || '—',
// //         unitsPerPack
// //       };
// //       return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
// //     }

// //     function addFreeRow(imgSrc, title, badge, badgeBg, subtitle, variantId, qty, extraCol = '—', overridePrice = null) {
// //       const info = getFreeVariantInfo(variantId);

// //       // ── Resolver pack desde múltiples fuentes ──
// //       const extras3     = window.b2bVariantExtrasMap?.[String(variantId)] || {};
// //       const packFromExt = parseInt(extras3.quantity) || 0;
// //       const packFromCol = extraCol !== '—' ? parseInt(extraCol) || 0 : 0;
// //       const packFromInf = parseInt(info.unitsPerPack) || 0;
// //       const pack        = packFromExt > 0 ? packFromExt
// //                         : packFromCol > 0 ? packFromCol
// //                         : packFromInf > 0 ? packFromInf : 1;

// //       // const isVails = (info.pres || '').toLowerCase().includes('vail');
// //       const isVails = (info.pres || '').toLowerCase().includes('vial') || 
// //                 (info.pres || '').toLowerCase().includes('vail');
// //       // const realQty = isVails ? (parseInt(qty) || 0) * pack : (parseInt(qty) || 0);
// //       const packVal = pack > 1 ? pack : 1;
// //             const realQty = isVails ? (parseInt(qty) || 0) * packVal : (parseInt(qty) || 0);

// //       // freeRowsData.push({ pres: info.pres, qty: realQty, pack, rawQty: parseInt(qty) || 0 });
// //       freeRowsData.push({ pres: info.pres, qty: realQty, pack: packVal, rawQty: parseInt(qty) || 0 });

// //       const packDisplay  = pack > 1 ? pack : (extraCol !== '—' ? extraCol : '—');
// //       const priceDisplay = overridePrice !== null ? `$${overridePrice}` : '$0.00';

// //       freeRows.push(`
// //         <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
// //             ${imgSrc
// //               ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
// //               : '<div style="width:52px;height:52px;border-radius:6px;background:#dcfce7;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>'}
// //           </td>
// //           <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;text-align:center;">${title}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${packDisplay}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
// //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">${priceDisplay}</td>
// //         </tr>`);
// //     }

// //     // ── P1 variant incentives ──
// //     variantRows().forEach(row => {
// //       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       if (qty <= 0) return;
// //       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
// //       if (!variantHasIncentive(extras)) return;
// //       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
// //       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

// //       withOwnRule.add(row.dataset.variantId);
// //       const pName      = row.cells[5]?.textContent?.trim() || 'Product';
// //       const multiplier = calcVariantMultiplier(extras, qty, lineV);
// //       const fps        = getVariantFreeProducts(extras);
// //       const fqs        = getVariantFreeQtys(extras);
// //       const choice     = window.b2bVariantRewardChoices[row.dataset.variantId];

// //       if (fps.length > 1 && choice?.confirmed) {
// //         const img  = (choice.chosenImage || '').replace(/^\/\//, 'https://');
// //         const vid2 = choice.chosenVariantId;
// //         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
// //         const up   = ex2.quantity > 0 ? ex2.quantity : '—';
// //         addFreeRow(img, choice.chosenTitle, 'FREE', '#16a34a', `${pName} Incentive — Your Choice`, vid2, choice.chosenQty, up);
// //       } else if (fps.length > 1 && !choice?.confirmed) {
// //         if (Number(window.b2bCollectionPriority || 1) !== 2 && Number(window.b2bCollectionPriority || 1) !== 3) {
// //           freeRows.push(`
// //             <tr style="border-bottom:1px solid #fde68a;background:#fffbeb;">
// //               <td colspan="9" style="padding:12px 16px;">
// //                 <div style="display:flex;align-items:center;gap:10px;">
// //                   <span style="font-size:20px;">⚠️</span>
// //                   <div>
// //                     <strong style="color:#92400e;">Free Gift Pending Selection</strong>
// //                     <span style="font-size:12px;color:#92400e;margin-left:8px;">${pName} — click Choose Gift to select</span>
// //                   </div>
// //                 </div>
// //               </td>
// //             </tr>`);
// //         }
// //       } else {
// //         fps.forEach((fp, i) => {
// //           if (!fp?.title) return;
// //           const giftQty = (fqs[i] || 1) * multiplier;
// //           const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
// //           const vid2    = String(fp.variant_id || '');
// //           const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //           const up      = ex2.quantity > 0 ? ex2.quantity : '—';
// //           addFreeRow(img, fp.title, 'FREE', '#16a34a', `${pName} Incentive`, vid2, giftQty, up);
// //         });
// //       }
// //     });

// //     // ── P2 ──
// //     const p2choice = window.b2bPriority2Choice || {};
// //     if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
// //       p2choice.selections.filter(sel => (sel.selectedQty || 0) > 0).forEach(sel => {
// //         const imgSrc   = (sel.image || '').replace(/^\/\//, 'https://');
// //         const vid      = String(sel.variant_id || '');
// //         const ex2      = window.b2bVariantExtrasMap?.[vid] || {};
// //         const up       = ex2.quantity > 0 ? ex2.quantity : '—';
// //         const price    = getSelectionPrice(sel);
// //         const discPct2 = parseFloat(p2choice.discountPct || 0);
// //         const final    = price * (1 - discPct2 / 100);
// //         const subtotal = parseFloat((final * sel.selectedQty).toFixed(2));
// //         addFreeRow(imgSrc, sel.title, `${discPct2}%`, '#2563eb', 'Reward Credit', vid, sel.selectedQty, up, subtotal);
// //       });
// //     }

// //     // ── P3 ──
// //     const p3choice = window.b2bPriority3Choice || {};
// //     if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
// //       p3choice.selections.forEach(sel => {
// //         (sel.choices || []).forEach(choice => {
// //           if (!choice.chosenQty || choice.chosenQty <= 0) return;
// //           const imgSrc = (choice.image || '').replace(/^\/\//, 'https://');
// //           const vid2   = String(choice.chosenVariantId || '');
// //           const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
// //           const up     = ex2.quantity > 0 ? ex2.quantity : '—';
// //           addFreeRow(imgSrc, choice.title, 'FREE', '#16a34a', `${sel.pName} — Your choice (P3)`, vid2, choice.chosenQty, up);
// //         });
// //       });
// //     }

// //     // ── Collection rules ──
// //     let unitsCol = 0, valueCol = 0;
// //     variantRows().forEach(row => {
// //       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       if (qty <= 0 || withOwnRule.has(row.dataset.variantId)) return;
// //       unitsCol += qty;
// //       valueCol += qty * parseFloat(row.dataset.unitPrice || 0);
// //     });

// //     const activeRPD = rulesRPD.length ? calcActiveIncentive(rulesRPD, unitsCol, valueCol) : null;
// //     if (activeRPD) {
// //       if (isAutoApply(activeRPD)) {
// //         (activeRPD.free_products || []).forEach((fp, i) => {
// //           if (!fp?.title) return;
// //           const giftQty = normalizeQtyArray(activeRPD.free_product_quantities)[i] || 1;
// //           const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
// //           const vid2    = String(fp.variant_id || '');
// //           const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //           const up      = ex2.quantity > 0 ? ex2.quantity : '—';
// //           addFreeRow(img, fp.title, 'FREE', '#16a34a', 'Collection Incentive', vid2, giftQty, up);
// //         });
// //         (activeRPD.free_testers || []).forEach((tp, i) => {
// //           if (!tp?.title) return;
// //           const q    = getTesterQty(activeRPD, i);
// //           const img  = tp.image ? tp.image.replace(/^\/\//, 'https://') : '';
// //           const vid2 = String(tp.variant_id || '');
// //           const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
// //           const up   = ex2.quantity > 0 ? ex2.quantity : '—';
// //           addFreeRow(img, tp.title, 'TESTER', '#2563eb', 'Collection Incentive', vid2, q, up);
// //         });
// //       } else if (rewardChoice.confirmed) {
// //         const ct  = rewardChoice.chosenType;
// //         const img = (rewardChoice.chosenProductImage || '').replace(/^\/\//, 'https://');
// //         if (ct === 'tester' || ct === 'product') {
// //           const vid2 = rewardChoice.chosenVariantId;
// //           const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
// //           const up   = ex2.quantity > 0 ? ex2.quantity : '—';
// //           addFreeRow(img, rewardChoice.chosenProductTitle || ct, ct === 'tester' ? 'TESTER' : 'FREE', '#16a34a', 'Your chosen reward', vid2, rewardChoice.chosenQty || 1, up);
// //         }
// //       }
// //     }

// //     // ── Contar incentivos ──
// //     let totalIncentives = 0;
// //     variantRows().forEach(row => {
// //       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       if (qty <= 0) return;
// //       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
// //       if (!variantHasIncentive(extras)) return;
// //       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
// //       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
// //       const fps    = getVariantFreeProducts(extras);
// //       const fqs    = getVariantFreeQtys(extras);
// //       const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
// //       if (fps.length > 1 && choice?.confirmed) {
// //         totalIncentives += choice.chosenQty || 0;
// //       } else if (fps.length <= 1) {
// //         fps.forEach((fp, i) => { totalIncentives += fqs[i] || 1; });
// //       }
// //     });
// //     const p2i = window.b2bPriority2Choice || {};
// //     if (p2i.confirmed && Array.isArray(p2i.selections)) {
// //       p2i.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => { totalIncentives += s.selectedQty; });
// //     }
// //     const p3i = window.b2bPriority3Choice || {};
// //     if (p3i.confirmed && Array.isArray(p3i.selections)) {
// //       p3i.selections.forEach(sel => {
// //         (sel.choices || []).forEach(c => { totalIncentives += c.chosenQty || 0; });
// //       });
// //     }

// //     // ── Totales ──
// //     const p2       = window.b2bPriority2Choice || {};
// //     let p2Subtotal = 0;
// //     if (p2.confirmed && Array.isArray(p2.selections)) {
// //       p2.selections.filter(s => s.selectedQty > 0).forEach(s => {
// //         const price    = getSelectionPrice(s);
// //         const discPct2 = parseFloat(p2.discountPct || 0);
// //         p2Subtotal += price * (1 - discPct2 / 100) * s.selectedQty;
// //       });
// //     }
// //     const discPct    = rewardChoice?.discountPct || 0;
// //     const discAmount = discPct > 0 ? grandTotal * discPct / 100 : 0;
// //     const finalTotal = grandTotal - discAmount;
// //     const fmt = n => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// //     // ── Construir HTML final ──
// //     let html = '';

// //     const tableHeader = `
// //       <thead>
// //         <tr style="background:#686a6c;">
// //           <th style="${thStyle}">Photo</th>
// //           <th style="${thStyle}">Product</th>
// //           <th style="${thStyle}">SKU</th>
// //           <th style="${thStyle}">ML</th>
// //           <th style="${thStyle}">Presentation</th>
// //           <th style="${thStyle}">Collection</th>
// //           <th style="${thStyle}">Coefficient</th>
// //           <th style="${thStyle}">Qty</th>
// //           <th style="${thStyle}">Total</th>
// //         </tr>
// //       </thead>`;

// //     const preferredOrder = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
// //     const sortedGroups   = [
// //       ...preferredOrder.filter(g => groupedRows[g]),
// //       ...groupOrder.filter(g => !preferredOrder.includes(g))
// //     ];

// //     const groupIcons = {
// //       'Perfumes':        '',
// //       'Vials & Testers': '',
// //       'Retail':          '',
// //       'Others':          ''
// //     };

// //     sortedGroups.forEach(groupKey => {
// //       const group = groupedRows[groupKey];
// //       if (!group?.rows?.length) return;
// //       const icon = groupIcons[groupKey] || '';

// //       html += `
// //         <div style="margin-bottom:28px;">
// //           <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">
// //             <div style="width:4px;height:28px;background:#b8a77d;border-radius:2px;"></div>
// //             <span style="font-size:20px;">${icon}</span>
// //             <h3 style="margin:0;font-size:19px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;">${groupKey}</h3>
// //             <span style="background:#f3f4f6;color:#6b7280;font-size:13px;font-weight:600;padding:2px 10px;border-radius:99px;">
// //               ${group.rows.length} item${group.rows.length > 1 ? 's' : ''}
// //             </span>
// //           </div>
// //           <div style="overflow-x:auto;border-radius:8px;border:1px solid #e5e7eb;overflow:hidden;">
// //             <table style="${tableStyle}">
// //               ${tableHeader}
// //               <tbody>${group.rows.join('')}</tbody>
// //               <tfoot>
// //                 <tr style="border-top:2px solid #b8a77d;">
// //                   <td colspan="7" style="padding:10px 8px;"></td>
// //                   <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">${group.qty}</td>
// //                   <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">$${fmt(group.subtotal)}</td>
// //                 </tr>
// //               </tfoot>
// //             </table>
// //           </div>
// //         </div>`;
// //     });

// //     // ── Sección Incentives Included ──
// //     if (freeRows.length) {
// //       html += `
// //         <div style="margin-top:16px;overflow-x:auto;">
// //           <div class="b2b-free-gifts-header">Incentives Included</div>
// //           <table style="${tableStyle}">
// //             <thead>
// //               <tr style="background:#686a6c;">
// //                 <th style="${thStyle}">Photo</th>
// //                 <th style="${thStyle}">Product</th>
// //                 <th style="${thStyle}">SKU</th>
// //                 <th style="${thStyle}">ML</th>
// //                 <th style="${thStyle}">Presentation</th>
// //                 <th style="${thStyle}">Collection</th>
// //                 <th style="${thStyle}">Units/Pack</th>
// //                 <th style="${thStyle}">Qty</th>
// //                 <th style="${thStyle}">Total</th>
// //               </tr>
// //             </thead>
// //             <tbody>${freeRows.join('')}</tbody>
// //           </table>
// //         </div>`;
// //     }

// //     // ── Breakdown GWP por presentación ──
// //     const incentiveByPres = {};
// //     const packByPres      = {};
// //     freeRowsData.forEach(item => {
// //       const key  = item.pres && item.pres !== '—' ? item.pres : 'Other';
// //       const pack = parseInt(item.pack) || 1;
// //       incentiveByPres[key] = (incentiveByPres[key] || 0) + item.qty;
// //       if (!packByPres[key]) packByPres[key] = pack;
// //     });

// //     const totalIncentiveQty = totalIncentives;

// //     // ── Order Summary ──
// //     const summaryRows = [];

// //     // GWP por presentación
// //     if (totalIncentiveQty > 0) {
// //       Object.entries(incentiveByPres).forEach(([pres, qty]) => {
// //         const packVal = (packByPres[pres] && packByPres[pres] > 1) ? packByPres[pres] : '—';
// //         summaryRows.push(`
// //           <tr style="border-bottom:1px solid #f3f4f6;">
// //             <td style="padding:10px 16px;font-size:15px;color:#374151;">FOC ${pres}</td>
// //             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${packVal}</td>
// //             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${qty}</td>
// //             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
// //           </tr>`);
// //       });
// //       summaryRows.push(`
// //         <tr style="border-bottom:2px solid #e5e7eb;background:#f9fafb;">
// //           <td style="padding:10px 16px;font-size:15px;font-weight:700;color:#111;">Total FOC</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">—</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">${totalIncentiveQty}</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">$0.00</td>
// //         </tr>`);
// //     }

// //     // Grupos por presentación
// //     const preferredSummary = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
// //     const allSummaryGroups = [
// //       ...preferredSummary.filter(g => groupedRows[g]),
// //       ...groupOrder.filter(g => !preferredSummary.includes(g) && groupedRows[g])
// //     ];

// //     allSummaryGroups.forEach(groupKey => {
// //       const group = groupedRows[groupKey];
// //       if (!group?.qty) return;
// //       const icon = groupIcons[groupKey] || '';
// //       summaryRows.push(`
// //         <tr style="border-bottom:1px solid #f3f4f6;">
// //           <td style="padding:10px 16px;font-size:15px;color:#374151;">${icon} ${groupKey}</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${group.qty}</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">$${fmt(group.subtotal)}</td>
// //         </tr>`);
// //     });

// //     // Reward Credit P2
// //     // if (p2Subtotal > 0) {
// //     //   summaryRows.push(`
// //     //     <tr style="border-bottom:1px solid #e5e7eb;">
// //     //       <td style="padding:10px 16px;font-size:15px;color:#2563eb;">Reward Credit (${p2.discountPct}%)</td>
// //     //       <td style="padding:10px 16px;text-align:right;font-size:15px;color:#2563eb;">—</td>
// //     //       <td style="padding:10px 16px;text-align:right;font-size:15px;color:#2563eb;">—</td>
// //     //       <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#2563eb;">$${fmt(p2Subtotal)}</td>
// //     //     </tr>`);
// //     // }

// //     // Total Qty
// //     // summaryRows.push(`
// //     //   <tr style="border-bottom:1px solid #e5e7eb;background:#f9fafb;">
// //     //     <td style="padding:10px 16px;font-size:15px;font-weight:700;color:#111;">Total Qty</td>
// //     //     <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">—</td>
// //     //     <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">${totalItems.toLocaleString('en-US')}</td>
// //     //     <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">$${fmt(grandTotal)}</td>
// //     //   </tr>`);

// //     // Descuento
// //     if (discPct > 0) {
// //       summaryRows.push(`
// //         <tr style="border-bottom:1px solid #e5e7eb;">
// //           <td style="padding:10px 16px;font-size:15px;color:#b45309;">Discount (${discPct}%)</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
// //           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#b45309;">-$${fmt(discAmount)}</td>
// //         </tr>`);
// //     }

// //     // Estimated Total
// //     summaryRows.push(`
// //       <tr style="background:#686a6c;">
// //         <td style="padding:0px 7px;font-size:17px;font-weight:700;color:#fff;">Estimated Total</td>
// //         <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
// //         <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
// //         <td style="padding:14px 16px;text-align:right;font-size:18px;font-weight:800;color:#fff;">$${fmt(finalTotal)}</td>
// //       </tr>`);

// //     html += `
// //       <div style="margin-top:24px;padding-top:16px;border-top:2px solid #e5e7eb;padding-bottom:40px;">
// //         <div style="display:flex;align-items:center;gap:10px;margin-bottom:12px;">
// //           <div style="width:4px;height:24px;background:#b8a77d;border-radius:2px;"></div>
// //           <h3 style="margin:0;font-size:18px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;"></h3>
// //         </div>
// //         <div style="overflow-x:auto;border-radius:10px;border:1px solid #e5e7eb;overflow:hidden;max-width:550px;margin-left:auto;">
// //           <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
// //             <thead>
// //               <tr style="background:#686a6c;">
// //                 <th style="padding:10px 16px;text-align:left;font-size:16px;font-weight:600;color:#fff;">Category</th>
// //                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Units/Pack</th>
// //                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Qty</th>
// //                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Amount</th>
// //               </tr>
// //             </thead>
// //             <tbody>${summaryRows.join('')}</tbody>
// //           </table>
// //         </div>
// //       </div>`;

// //     if (!Object.keys(groupedRows).length) {
// //       if (noMsg) noMsg.style.display = 'block';
// //     } else {
// //       content.innerHTML = html;
// //       content.querySelectorAll('.detail-img-hover').forEach(img => {
// //         img.addEventListener('mouseenter', e => {
// //           skuPopup.querySelector('.sku-popup-img').src = img.src || '';
// //           skuPopup.querySelector('.popup-description').textContent  = img.dataset.description || '';
// //           skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(img.dataset.topNotes);
// //           skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(img.dataset.middleNotes);
// //           skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(img.dataset.baseNotes);
// //           positionPopup(e); skuPopup.classList.add('visible');
// //         });
// //         img.addEventListener('mousemove', positionPopup);
// //         img.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
// //       });
// //     }

// //     getEl('dash-count-product').textContent    = uniqueProducts.size;
// //     getEl('dash-unique-types').textContent     = uniqueCollections.size;
// //     getEl('dash-total-items').textContent      = totalItems;
// //     getEl('dash-total-incentives').textContent = totalIncentives;
// //     getEl('dash-total-purchase').textContent   = '$' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
// //     getEl('b2b-incentive-summary-panel').style.display = 'none';
// //   }




// function renderPurchaseDetails() {
//     ensureSkuPopup();
//     const content = getEl('b2b-details-content');
//     const noMsg   = getEl('b2b-no-items-msg');
//     if (!content) return;
//     content.innerHTML = '';
//     if (noMsg) noMsg.style.display = 'none';

//     const uniqueProducts = new Set(), uniqueCollections = new Set();
//     let totalItems = 0, grandTotal = 0;

//     const tableStyle = 'width:100%;border-collapse:collapse;font-family:"Crimson Pro",serif;';
//     const thStyle    = 'padding:9px 8px;text-align:center;font-size:17px;font-weight:600;color:#fff;';

//     function getSelectionPrice(sel) {
//       const metaP = parseFloat(sel.incentive_product_price || 0);
//       if (metaP > 0) return metaP;
//       const vid2    = String(sel.variant_id || '');
//       const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
//       const metaP2  = parseFloat(extras2.incentive_product_price || 0);
//       if (metaP2 > 0) return metaP2;
//       return parseFloat(sel.price || 0);
//     }

//     // ── Agrupar filas principales por presentación ──
//     const groupedRows = {};
//     const groupOrder  = [];

//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (!qty) return;

//       const sku        = (row.dataset.sku || '-').toUpperCase();
//       const product    = row.cells[5]?.textContent?.trim() || 'Product';
//       const ml         = row.cells[7]?.textContent?.trim() || 'N/A';
//       const presDisp   = row.cells[8]?.textContent?.trim() || 'N/A';
//       const presLower  = presDisp.toLowerCase();
//       const collection = row.cells[4]?.textContent?.trim() || 'N/A';
//       const unitPrice  = parseFloat(row.dataset.unitPrice || 0);
//       const subtotal   = qty * unitPrice;
//       const imgUrl     = row.dataset.imgUrl || '';
//       const coeff      = row.cells[10]?.textContent?.trim() || 'N/A';

//       let groupKey = 'Others';
//       if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
//       else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester') || presLower.includes('sample')) groupKey = 'Vials & Testers';
//       else if (presLower.includes('retail'))                               groupKey = 'Retail';
//       else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;

//       if (!groupedRows[groupKey]) {
//         groupedRows[groupKey] = { rows: [], subtotal: 0, qty: 0 };
//         groupOrder.push(groupKey);
//       }

//       groupedRows[groupKey].subtotal += subtotal;
//       groupedRows[groupKey].qty      += qty;
//       groupedRows[groupKey].rows.push(`
//         <tr style="border-bottom:1px solid #e5e7eb;">
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
//             ${imgUrl
//               ? `<img src="${imgUrl}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;cursor:pointer;"
//                   class="detail-img-hover"
//                   data-description="${row.dataset.description||''}"
//                   data-top-notes="${row.dataset.topNotes||''}"
//                   data-middle-notes="${row.dataset.middleNotes||''}"
//                   data-base-notes="${row.dataset.baseNotes||''}"
//                   onerror="this.style.display='none'">`
//               : '<div style="width:52px;height:52px;border-radius:6px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">📦</div>'}
//           </td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">${product}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${sku}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${ml}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${presDisp}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${collection}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${coeff}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">$${subtotal.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
//         </tr>`);

//       totalItems += qty;
//       grandTotal += subtotal;
//       uniqueProducts.add(product);
//       uniqueCollections.add(collection);
//     });

//     // ── Filas de incentivos ──
//     const freeRows     = [];
//     const freeRowsData = [];
//     const withOwnRule  = new Set();
//     const colH         = getColHandle();
//     const rulesRPD     = window.b2bCollectionIncentivesMap?.[colH] || [];

//     function getFreeVariantInfo(variantId) {
//       if (!variantId) return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
//       const vid      = String(variantId);
//       const freeRow  = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
//       const extras2  = window.b2bVariantExtrasMap?.[vid] || {};
//       const unitsPerPack = parseInt(extras2.quantity) || 0;
//       if (freeRow) {
//         return {
//           sku:         (freeRow.dataset.sku || '').toUpperCase() || '—',
//           ml:          freeRow.cells[7]?.textContent?.trim()  || '—',
//           pres:        freeRow.cells[8]?.textContent?.trim()  || '—',
//           collection:  freeRow.cells[4]?.textContent?.trim()  || '—',
//           coefficient: freeRow.cells[10]?.textContent?.trim() || '—',
//           unitsPerPack
//         };
//       }
//       const v = window.b2bAllVariantsMap?.[vid];
//       if (v) return {
//         sku:         v.sku         || '—',
//         ml:          v.ml          || '—',
//         pres:        v.pres        || '—',
//         collection:  v.collection  || '—',
//         coefficient: v.coefficient || '—',
//         unitsPerPack
//       };
//       return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
//     }

//     function addFreeRow(imgSrc, title, badge, badgeBg, subtitle, variantId, qty, extraCol = '—', overridePrice = null) {
//       const info = getFreeVariantInfo(variantId);

//       // ── Resolver pack desde múltiples fuentes ──
//       const extras3     = window.b2bVariantExtrasMap?.[String(variantId)] || {};
//       const packFromExt = parseInt(extras3.quantity) || 0;
//       const packFromCol = extraCol !== '—' ? parseInt(extraCol) || 0 : 0;
//       const packFromInf = parseInt(info.unitsPerPack) || 0;
//       const pack        = packFromExt > 0 ? packFromExt
//                         : packFromCol > 0 ? packFromCol
//                         : packFromInf > 0 ? packFromInf : 1;

//       const isVails = (info.pres || '').toLowerCase().includes('vial') || 
//                 (info.pres || '').toLowerCase().includes('vail');
//       const packVal = pack > 1 ? pack : 1;
//       const realQty = isVails ? (parseInt(qty) || 0) * packVal : (parseInt(qty) || 0);

//       freeRowsData.push({ pres: info.pres, qty: realQty, pack: packVal, rawQty: parseInt(qty) || 0 });

//       const packDisplay  = pack > 1 ? pack : (extraCol !== '—' ? extraCol : '—');
//       const priceDisplay = overridePrice !== null ? `$${overridePrice}` : '$0.00';

//       // ── Determinar grupo FOC: Vials, Testers u Others ──
//       const presLowerFoc = (info.pres || '').toLowerCase();
//       let focGroupKey = 'Others';
//       if (presLowerFoc.includes('tester')) focGroupKey = 'Testers';
//       else if (presLowerFoc.includes('vial') || presLowerFoc.includes('vail')) focGroupKey = 'Vials';

//       freeRows.push({ groupKey: focGroupKey, qty: parseInt(qty) || 0, html: `
//         <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
//             ${imgSrc
//               ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
//               : '<div style="width:52px;height:52px;border-radius:6px;background:#dcfce7;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>'}
//           </td>
//           <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;text-align:center;">${title}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${packDisplay}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">${priceDisplay}</td>
//         </tr>`});
//     }

//     // ── P1 variant incentives ──
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       if (!variantHasIncentive(extras)) return;
//       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

//       withOwnRule.add(row.dataset.variantId);
//       const pName      = row.cells[5]?.textContent?.trim() || 'Product';
//       const multiplier = calcVariantMultiplier(extras, qty, lineV);
//       const fps        = getVariantFreeProducts(extras);
//       const fqs        = getVariantFreeQtys(extras);
//       const choice     = window.b2bVariantRewardChoices[row.dataset.variantId];
//       const priorityNow = Number(window.b2bCollectionPriority || 1);

//       if (fps.length > 1 && choice?.confirmed) {
//         const img  = (choice.chosenImage || '').replace(/^\/\//, 'https://');
//         const vid2 = choice.chosenVariantId;
//         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//         const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//         addFreeRow(img, choice.chosenTitle, 'FREE', '#16a34a', `${pName} Incentive — Your Choice`, vid2, choice.chosenQty, up);
//    } else if (fps.length > 1 && !choice?.confirmed) {
//         if (priorityNow !== 2 && priorityNow !== 3) {
//           freeRows.push({ groupKey: 'Pending', qty: 0, html: `
//             <tr style="border-bottom:1px solid #fde68a;background:#fffbeb;">
//               <td colspan="9" style="padding:12px 16px;">
//                 <div style="display:flex;align-items:center;gap:10px;">
//                   <span style="font-size:20px;">⚠️</span>
//                   <div>
//                     <strong style="color:#92400e;">Free Gift Pending Selection</strong>
//                     <span style="font-size:12px;color:#92400e;margin-left:8px;">${pName} — click Choose Gift to select</span>
//                   </div>
//                 </div>
//               </td>
//             </tr>` });
//         }
//       } else {
//         // ⚠️ FIX: en priority 2 y 3, este regalo ya se muestra vía p2choice/p3choice más abajo.
//         // Si no bloqueamos acá, se duplica cuando fps.length === 1.
//         if (priorityNow !== 2 && priorityNow !== 3) {
//           fps.forEach((fp, i) => {
//             if (!fp?.title) return;
//             const giftQty = (fqs[i] || 1) * multiplier;
//             const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//             const vid2    = String(fp.variant_id || '');
//             const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//             const up      = ex2.quantity > 0 ? ex2.quantity : '—';
//             addFreeRow(img, fp.title, 'FREE', '#16a34a', `${pName} Incentive`, vid2, giftQty, up);
//           });
//         }
//       }
//     });

//     // ── P2 ──
//     const p2choice = window.b2bPriority2Choice || {};
//     if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
//       p2choice.selections.filter(sel => (sel.selectedQty || 0) > 0).forEach(sel => {
//         const imgSrc   = (sel.image || '').replace(/^\/\//, 'https://');
//         const vid      = String(sel.variant_id || '');
//         const ex2      = window.b2bVariantExtrasMap?.[vid] || {};
//         const up       = ex2.quantity > 0 ? ex2.quantity : '—';
//         const price    = getSelectionPrice(sel);
//         const discPct2 = parseFloat(p2choice.discountPct || 0);
//         const final    = price * (1 - discPct2 / 100);
//         const subtotal = parseFloat((final * sel.selectedQty).toFixed(2));
//         addFreeRow(imgSrc, sel.title, `${discPct2}%`, '#2563eb', 'Reward Credit', vid, sel.selectedQty, up, subtotal);
//       });
//     }

//     // ── P3 ──
//     const p3choice = window.b2bPriority3Choice || {};
//     if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
//       p3choice.selections.forEach(sel => {
//         (sel.choices || []).forEach(choice => {
//           if (!choice.chosenQty || choice.chosenQty <= 0) return;
//           const imgSrc = (choice.image || '').replace(/^\/\//, 'https://');
//           const vid2   = String(choice.chosenVariantId || '');
//           const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up     = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(imgSrc, choice.title, 'FREE', '#16a34a', `${sel.pName} — Your choice (P3)`, vid2, choice.chosenQty, up);
//         });
//       });
//     }


//         // ── Master FOC (manual, sin restricciones) ──
//     if (window.b2bIsMasterUser) {
//       Object.entries(window.b2bMasterFreeItems || {}).forEach(([vid2, qty]) => {
//         qty = parseInt(qty) || 0;
//         if (qty <= 0) return;
//         const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
//         const row2  = document.querySelector(`.b2b-variant-row[data-variant-id="${vid2}"]`);
//         const img2  = row2 ? (row2.dataset.imgUrl || '') : '';
//         const title2 = vd2.title || (row2 ? row2.cells[5]?.textContent?.trim() : '') || 'Product';
//         const up2   = ex2.quantity > 0 ? ex2.quantity : '—';
//         addFreeRow(img2, title2, 'FREE', '#7c3aed', 'Master FOC', vid2, qty, up2);
//       });
//     }

//     // ── Collection rules ──
//     let unitsCol = 0, valueCol = 0;
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0 || withOwnRule.has(row.dataset.variantId)) return;
//       unitsCol += qty;
//       valueCol += qty * parseFloat(row.dataset.unitPrice || 0);
//     });

//     const activeRPD = rulesRPD.length ? calcActiveIncentive(rulesRPD, unitsCol, valueCol) : null;
//     if (activeRPD) {
//       if (isAutoApply(activeRPD)) {
//         (activeRPD.free_products || []).forEach((fp, i) => {
//           if (!fp?.title) return;
//           const giftQty = normalizeQtyArray(activeRPD.free_product_quantities)[i] || 1;
//           const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//           const vid2    = String(fp.variant_id || '');
//           const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up      = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(img, fp.title, 'FREE', '#16a34a', 'Collection Incentive', vid2, giftQty, up);
//         });
//         (activeRPD.free_testers || []).forEach((tp, i) => {
//           if (!tp?.title) return;
//           const q    = getTesterQty(activeRPD, i);
//           const img  = tp.image ? tp.image.replace(/^\/\//, 'https://') : '';
//           const vid2 = String(tp.variant_id || '');
//           const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(img, tp.title, 'TESTER', '#2563eb', 'Collection Incentive', vid2, q, up);
//         });
//       } else if (rewardChoice.confirmed) {
//         const ct  = rewardChoice.chosenType;
//         const img = (rewardChoice.chosenProductImage || '').replace(/^\/\//, 'https://');
//         if (ct === 'tester' || ct === 'product') {
//           const vid2 = rewardChoice.chosenVariantId;
//           const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(img, rewardChoice.chosenProductTitle || ct, ct === 'tester' ? 'TESTER' : 'FREE', '#16a34a', 'Your chosen reward', vid2, rewardChoice.chosenQty || 1, up);
//         }
//       }
//     }

//     // ── Contar incentivos ──
//     let totalIncentives = 0;
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       if (!variantHasIncentive(extras)) return;
//       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//       const fps    = getVariantFreeProducts(extras);
//       const fqs    = getVariantFreeQtys(extras);
//       const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//       const priorityNow2 = Number(window.b2bCollectionPriority || 1);

//       if (fps.length > 1 && choice?.confirmed) {
//         totalIncentives += choice.chosenQty || 0;
//       } else if (fps.length <= 1 && priorityNow2 !== 2 && priorityNow2 !== 3) {
//         // ⚠️ FIX: mismo criterio — no contar acá si priority 2/3 ya lo cuenta vía p2i/p3i más abajo
//         fps.forEach((fp, i) => { totalIncentives += fqs[i] || 1; });
//       }
//     });
//     const p2i = window.b2bPriority2Choice || {};
//     if (p2i.confirmed && Array.isArray(p2i.selections)) {
//       p2i.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => { totalIncentives += s.selectedQty; });
//     }
//     const p3i = window.b2bPriority3Choice || {};
//     if (p3i.confirmed && Array.isArray(p3i.selections)) {
//       p3i.selections.forEach(sel => {
//         (sel.choices || []).forEach(c => { totalIncentives += c.chosenQty || 0; });
//       });
//     }

//      // ── Master FOC ──
//     if (window.b2bIsMasterUser) {
//       Object.values(window.b2bMasterFreeItems || {}).forEach(q => {
//         totalIncentives += parseInt(q) || 0;
//       });
//     }

//     // ── Totales ──
//     const p2       = window.b2bPriority2Choice || {};
//     let p2Subtotal = 0;
//     if (p2.confirmed && Array.isArray(p2.selections)) {
//       p2.selections.filter(s => s.selectedQty > 0).forEach(s => {
//         const price    = getSelectionPrice(s);
//         const discPct2 = parseFloat(p2.discountPct || 0);
//         p2Subtotal += price * (1 - discPct2 / 100) * s.selectedQty;
//       });
//     }
//     const discPct    = rewardChoice?.discountPct || 0;
//     const discAmount = discPct > 0 ? grandTotal * discPct / 100 : 0;
//     const finalTotal = grandTotal - discAmount;
//     const fmt = n => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     // ── Construir HTML final ──
//     let html = '';

//     const tableHeader = `
//       <thead>
//         <tr style="background:#686a6c;">
//           <th style="${thStyle}">Photo</th>
//           <th style="${thStyle}">Product</th>
//           <th style="${thStyle}">SKU</th>
//           <th style="${thStyle}">ML</th>
//           <th style="${thStyle}">Presentation</th>
//           <th style="${thStyle}">Collection</th>
//           <th style="${thStyle}">Coefficient</th>
//           <th style="${thStyle}">Qty</th>
//           <th style="${thStyle}">Total</th>
//         </tr>
//       </thead>`;

//     const preferredOrder = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
//     const sortedGroups   = [
//       ...preferredOrder.filter(g => groupedRows[g]),
//       ...groupOrder.filter(g => !preferredOrder.includes(g))
//     ];

//     const groupIcons = {
//       'Perfumes':        '',
//       'Vials & Testers': '',
//       'Retail':          '',
//       'Others':          ''
//     };

//     sortedGroups.forEach(groupKey => {
//       const group = groupedRows[groupKey];
//       if (!group?.rows?.length) return;
//       const icon = groupIcons[groupKey] || '';

//       html += `
//         <div style="margin-bottom:28px;">
//           <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">
//             <div style="width:4px;height:28px;background:#b8a77d;border-radius:2px;"></div>
//             <span style="font-size:20px;">${icon}</span>
//             <h3 style="margin:0;font-size:19px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;">${groupKey}</h3>
//             <span style="background:#f3f4f6;color:#6b7280;font-size:13px;font-weight:600;padding:2px 10px;border-radius:99px;">
//               ${group.rows.length} item${group.rows.length > 1 ? 's' : ''}
//             </span>
//           </div>
//           <div style="overflow-x:auto;border-radius:8px;border:1px solid #e5e7eb;overflow:hidden;">
//             <table style="${tableStyle}">
//               ${tableHeader}
//               <tbody>${group.rows.join('')}</tbody>
//               <tfoot>
//                 <tr style="border-top:2px solid #b8a77d;">
//                   <td colspan="7" style="padding:10px 8px;"></td>
//                   <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">${group.qty}</td>
//                   <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">$${fmt(group.subtotal)}</td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         </div>`;
//     });

//     // ── Sección Incentives Included ──
//     // if (freeRows.length) {
//     //   html += `
//     //     <div style="margin-top:16px;overflow-x:auto;">
//     //       <div class="b2b-free-gifts-header">Foc</div>
//     //       <table style="${tableStyle}">
//     //         <thead>
//     //           <tr style="background:#686a6c;">
//     //             <th style="${thStyle}">Photo</th>
//     //             <th style="${thStyle}">Product</th>
//     //             <th style="${thStyle}">SKU</th>
//     //             <th style="${thStyle}">ML</th>
//     //             <th style="${thStyle}">Presentation</th>
//     //             <th style="${thStyle}">Collection</th>
//     //             <th style="${thStyle}">Units/Pack</th>
//     //             <th style="${thStyle}">Qty</th>
//     //             <th style="${thStyle}">Total</th>
//     //           </tr>
//     //         </thead>
//     //         <tbody>${freeRows.join('')}</tbody>
//     //       </table>
//     //     </div>`;
//     // }

//     // ── Sección Incentives Included (separado por Vials / Testers / Others) ──
//     if (freeRows.length) {
//       const focGroups     = {};
//       const focGroupOrder = [];

//       freeRows.forEach(item => {
//         if (!focGroups[item.groupKey]) {
//           focGroups[item.groupKey] = { rows: [], qty: 0 };
//           focGroupOrder.push(item.groupKey);
//         }
//         focGroups[item.groupKey].rows.push(item.html);
//         focGroups[item.groupKey].qty += item.qty;
//       });

//       const focLabels = { Vials: 'FOC — Vials', Testers: 'FOC — Testers', Others: 'FOC — Others', Pending: 'FOC — Pending Selection' };
//       const focPreferredOrder = ['Vials', 'Testers', 'Others', 'Pending'];
//       const focSortedGroups = [
//         ...focPreferredOrder.filter(g => focGroups[g]),
//         ...focGroupOrder.filter(g => !focPreferredOrder.includes(g))
//       ];

//       focSortedGroups.forEach(groupKey => {
//         const group = focGroups[groupKey];
//         if (!group?.rows?.length) return;

//         html += `
//           <div style="margin-top:16px;overflow-x:auto;">
//             <div class="b2b-free-gifts-header">${focLabels[groupKey] || `FOC — ${groupKey}`}</div>
//             <table style="${tableStyle}">
//               <thead>
//                 <tr style="background:#686a6c;">
//                   <th style="${thStyle}">Photo</th>
//                   <th style="${thStyle}">Product</th>
//                   <th style="${thStyle}">SKU</th>
//                   <th style="${thStyle}">ML</th>
//                   <th style="${thStyle}">Presentation</th>
//                   <th style="${thStyle}">Collection</th>
//                   <th style="${thStyle}">Units/Pack</th>
//                   <th style="${thStyle}">Qty</th>
//                   <th style="${thStyle}">Total</th>
//                 </tr>
//               </thead>
//               <tbody>${group.rows.join('')}</tbody>
//             </table>
//           </div>`;
//       });
//     }

//     // ── Breakdown GWP por presentación ──
//     const incentiveByPres = {};
//     const packByPres      = {};
//     freeRowsData.forEach(item => {
//       const key  = item.pres && item.pres !== '—' ? item.pres : 'Other';
//       const pack = parseInt(item.pack) || 1;
//       incentiveByPres[key] = (incentiveByPres[key] || 0) + item.qty;
//       if (!packByPres[key]) packByPres[key] = pack;
//     });

//     const totalIncentiveQty = totalIncentives;

//     // ── Order Summary ──
//     const summaryRows = [];

//     if (totalIncentiveQty > 0) {
//       Object.entries(incentiveByPres).forEach(([pres, qty]) => {
//         const packVal = (packByPres[pres] && packByPres[pres] > 1) ? packByPres[pres] : '—';
//         summaryRows.push(`
//           <tr style="border-bottom:1px solid #f3f4f6;">
//             <td style="padding:10px 16px;font-size:15px;color:#374151;">FOC ${pres}</td>
//             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${packVal}</td>
//             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${qty}</td>
//             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
//           </tr>`);
//       });
//       summaryRows.push(`
//         <tr style="border-bottom:2px solid #e5e7eb;background:#f9fafb;">
//           <td style="padding:10px 16px;font-size:15px;font-weight:700;color:#111;">Total FOC</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">${totalIncentiveQty}</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">$0.00</td>
//         </tr>`);
//     }

//     const preferredSummary = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
//     const allSummaryGroups = [
//       ...preferredSummary.filter(g => groupedRows[g]),
//       ...groupOrder.filter(g => !preferredSummary.includes(g) && groupedRows[g])
//     ];

//     allSummaryGroups.forEach(groupKey => {
//       const group = groupedRows[groupKey];
//       if (!group?.qty) return;
//       const icon = groupIcons[groupKey] || '';
//       summaryRows.push(`
//         <tr style="border-bottom:1px solid #f3f4f6;">
//           <td style="padding:10px 16px;font-size:15px;color:#374151;">${icon} ${groupKey}</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${group.qty}</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">$${fmt(group.subtotal)}</td>
//         </tr>`);
//     });

//     if (discPct > 0) {
//       summaryRows.push(`
//         <tr style="border-bottom:1px solid #e5e7eb;">
//           <td style="padding:10px 16px;font-size:15px;color:#b45309;">Discount (${discPct}%)</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#b45309;">-$${fmt(discAmount)}</td>
//         </tr>`);
//     }

//     summaryRows.push(`
//       <tr style="background:#686a6c;">
//         <td style="padding:0px 7px;font-size:17px;font-weight:700;color:#fff;">Estimated Total</td>
//         <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
//         <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
//         <td style="padding:14px 16px;text-align:right;font-size:18px;font-weight:800;color:#fff;">$${fmt(finalTotal)}</td>
//       </tr>`);

//     html += `
//       <div style="margin-top:24px;padding-top:16px;border-top:2px solid #e5e7eb;padding-bottom:40px;">
//         <div style="display:flex;align-items:center;gap:10px;margin-bottom:12px;">
//           <div style="width:4px;height:24px;background:#b8a77d;border-radius:2px;"></div>
//           <h3 style="margin:0;font-size:18px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;"></h3>
//         </div>
//         <div style="overflow-x:auto;border-radius:10px;border:1px solid #e5e7eb;overflow:hidden;max-width:550px;margin-left:auto;">
//           <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
//             <thead>
//               <tr style="background:#686a6c;">
//                 <th style="padding:10px 16px;text-align:left;font-size:16px;font-weight:600;color:#fff;">Category</th>
//                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Units/Pack</th>
//                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Qty</th>
//                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Amount</th>
//               </tr>
//             </thead>
//             <tbody>${summaryRows.join('')}</tbody>
//           </table>
//         </div>
//       </div>`;

//     if (!Object.keys(groupedRows).length) {
//       if (noMsg) noMsg.style.display = 'block';
//     } else {
//       content.innerHTML = html;
//       content.querySelectorAll('.detail-img-hover').forEach(img => {
//         img.addEventListener('mouseenter', e => {
//           skuPopup.querySelector('.sku-popup-img').src = img.src || '';
//           skuPopup.querySelector('.popup-description').textContent  = img.dataset.description || '';
//           skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(img.dataset.topNotes);
//           skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(img.dataset.middleNotes);
//           skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(img.dataset.baseNotes);
//           positionPopup(e); skuPopup.classList.add('visible');
//         });
//         img.addEventListener('mousemove', positionPopup);
//         img.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
//       });
//     }

//     getEl('dash-count-product').textContent    = uniqueProducts.size;
//     getEl('dash-unique-types').textContent     = uniqueCollections.size;
//     getEl('dash-total-items').textContent      = totalItems;
//     getEl('dash-total-incentives').textContent = totalIncentives;
//     getEl('dash-total-purchase').textContent   = '$' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     getEl('b2b-incentive-summary-panel').style.display = 'none';
//   }

// /* ============================================================
//    MODALES DE VALIDACIÓN
//    ============================================================ */

// function showMinQtyModal() {
//   const violations = [];
//   variantRows().forEach(row => {
//     if (row.style.display === 'none') return;
//     const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;
//     const minQty = parseInt(row.dataset.minQty || 1);
//     if (qty >= minQty) return;
//     violations.push({
//       productName: row.cells[5]?.textContent.trim() || 'Product',
//       sku: (row.dataset.sku || '-').toUpperCase(),
//       ml: row.cells[7]?.textContent.trim() || '',
//       qty, minQty
//     });
//   });
//   if (!violations.length) return false;
//   getEl('min-qty-modal-list').innerHTML = violations.map(v =>
//     `<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:12px 16px;">
//       <div style="font-weight:700;color:#111;margin-bottom:4px;">${v.productName}</div>
//       <div style="font-size:14px;color:#555;">SKU: ${v.sku}${v.ml ? ' | ' + v.ml : ''}</div>
//       <div style="margin-top:6px;font-size:16px;display:flex;gap:16px;flex-wrap:wrap;">
//         <span style="color:#000;font-weight:600;">You have: ${v.qty}</span>
//         <span style="color:#16a34a;font-weight:600;">Minimum: ${v.minQty}</span>
//         <span style="color:#2563eb;font-weight:600;">Need ${v.minQty - v.qty} more</span>
//       </div>
//     </div>`
//   ).join('');
//   getEl('min-qty-modal').style.display = 'flex';
//   return true;
// }

// function showSellLimitModal(limit, productName) {
//   const modal = getEl('sell-limit-modal');
//   const text  = getEl('sell-limit-modal-text');
//   if (!modal || !text) return;
//   text.innerHTML = `You are only allowed to purchase up to <strong>${limit}</strong> unit${limit > 1 ? 's' : ''}` +
//     (productName ? ` of <strong>${productName}</strong>` : '') + `.`;
//   modal.style.display = 'flex';
// }

// function showMasterOrderCreatedModal(data) {
//   const overlay = getEl('b2b-processing-overlay') || (() => {
//     const el = document.createElement('div');
//     el.id = 'b2b-processing-overlay';
//     el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
//     document.body.appendChild(el);
//     return el;
//   })();

//   const ctx     = window.b2bMasterOrderContext || {};
//   const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
//   const total   = data.totalAmount
//     ? parseFloat(data.totalAmount).toLocaleString('en-US', { style: 'currency', currency: data.currency || 'USD' })
//     : '';

//   overlay.innerHTML = `
//     <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
//                 box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
//                 max-width:460px;width:90%;">
//       <img src="${logoUrl}" alt="Logo"
//         style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
//         onerror="this.style.display='none'">
//       <div style="width:64px;height:64px;border-radius:50%;background:#f5f3ee;
//                   display:flex;align-items:center;justify-content:center;
//                   margin:0 auto 16px;font-size:32px;color:#b8a77d;">✓</div>
//       <div style="font-size:1.4rem;font-weight:700;color:#b8a77d;margin-bottom:6px;">
//         Order created in Drafts
//       </div>
//       <div style="font-size:1.6rem;font-weight:800;color:#1f2937;margin-bottom:14px;">
//         ${data.draftOrderName || ''}
//       </div>
//       <div style="font-size:15px;color:#6b7280;line-height:1.7;margin-bottom:20px;text-align:left;background:#f9fafb;border-radius:10px;padding:14px 16px;">
//         <div><strong>Company:</strong> ${ctx.companyName || '—'}</div>
//         <div><strong>Customer:</strong> ${ctx.customerName || '—'}</div>
//         ${total ? `<div><strong>Total:</strong> ${total}</div>` : ''}
//       </div>
//       <button type="button" id="master-order-created-ok"
//         style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
//               border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
//               font-family:'Crimson Pro',serif;width:100%;">
//         OK
//       </button>
//     </div>`;

//   overlay.style.display = 'flex';

//   getEl('master-order-created-ok').addEventListener('click', () => {
//     overlay.style.display = 'none';
//     resetMasterOrderAfterSuccess();
//   });
// }

// function resetMasterOrderAfterSuccess() {
//   // Reset de cantidades y filtros: reutiliza el handler del botón Clear
//   getEl('reset-btn')?.click();

//   // Limpiar FOC manuales
//   window.b2bMasterFreeItems = {};

//   // Limpiar selección de company/customer
//   window.b2bMasterOrderContext = {
//     companyId: null, companyName: null, companyContactId: null,
//     companyLocationId: null, customerId: null, customerName: null, customerEmail: null
//   };
//   const companySel  = getEl('master-company-select');
//   const customerSel = getEl('master-customer-select');
//   if (companySel)  companySel.value = '';
//   if (customerSel) { customerSel.innerHTML = '<option value="">Select a company first</option>'; customerSel.disabled = true; }

//   updateMasterOrderBadge();
//   updateMasterOrderLock();
//   applyFreeProductStockDeductions();
//   updateTotals();
//   unlockUI();
// }

// function showBrandMinQtyModal() {
//   const brandMin = parseInt(window.b2bBrandMinQty || 0);
//   if (brandMin <= 0) return false;
//   let totalUnits = 0;
//   variantRows().forEach(row => {
//     if (row.style.display === 'none') return;
//     totalUnits += parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//   });
//   if (totalUnits >= brandMin) return false;
//   getEl('brand-min-qty-modal-body').innerHTML = `
//     <div style="font-size:16px;color:#111;margin-bottom:8px;"><strong>This brand requires a minimum of ${brandMin} units</strong></div>
//     <div style="font-size:16px;display:flex;gap:20px;flex-wrap:wrap;margin-top:8px;">
//       <span style="color:#000;font-weight:600;">You have: ${totalUnits}</span>
//       <span style="color:#2563eb;font-weight:600;">Need ${brandMin - totalUnits} more</span>
//     </div>`;
//   getEl('brand-min-qty-modal').style.display = 'flex';
//   return true;
// }

// function showBrandMinValueModal() {
//   const minValue = parseFloat(window.b2bBrandMinValue || 0);
//   if (minValue <= 0) return false;
//   let totalValue = 0;
//   variantRows().forEach(row => {
//     if (row.style.display === 'none') return;
//     totalValue += (parseInt(row.querySelector('.hidden-qty')?.value) || 0) * parseFloat(row.dataset.unitPrice || 0);
//   });
//   if (totalValue >= minValue) return false;
//   getEl('brand-min-value-modal-body').innerHTML = `
//     <div style="font-size:16px;color:#111;margin-bottom:8px;"><strong>Minimum order value: $${minValue.toFixed(2)}</strong></div>
//     <div style="font-size:16px;display:flex;gap:20px;flex-wrap:wrap;margin-top:8px;">
//       <span style="color:#000;font-weight:600;">Your total: $${totalValue.toFixed(2)}</span>
//       <span style="color:#2563eb;font-weight:600;">Need $${(minValue - totalValue).toFixed(2)} more</span>
//     </div>`;
//   getEl('brand-min-value-modal').style.display = 'flex';
//   return true;
// }

// /* ============================================================
//    COMBOBOX MULTISELECT
//    ============================================================ */

// class B2BCombo {
//   constructor(root) {
//     this.root   = root;
//     this.select = root.querySelector('select[multiple]');
//     this.btn    = root.querySelector('.b2b-toggle');
//     this.label  = root.querySelector('.b2b-label');
//     this.panel  = root.querySelector('.b2b-panel');
//     this.search = root.querySelector('.b2b-search');
//     this.list   = root.querySelector('.b2b-options');
//     this.btnApply = root.querySelector('.apply');
//     this.btnClear = root.querySelector('.clear');
//     this.btnAll   = root.querySelector('.select-all');
//     this._bind(); this._render(''); this._updateLabel();
//   }

//   _bind() {
//     this.btn.addEventListener('click', () => {
//       const open = this.root.getAttribute('aria-expanded') === 'true';
//       document.querySelectorAll('.b2b-combo[aria-expanded="true"]').forEach(el => {
//         if (el !== this.root) el.setAttribute('aria-expanded', 'false');
//       });
//       this.root.setAttribute('aria-expanded', open ? 'false' : 'true');
//       if (!open) {
//         setTimeout(() => {
//           const rect = this.btn.getBoundingClientRect();
//           this.panel.style.position = 'fixed';
//           this.panel.style.top  = (rect.bottom + 4) + 'px';
//           this.panel.style.left = rect.left + 'px';
//           this.panel.style.width = Math.max(rect.width, 300) + 'px';
//           this.panel.style.zIndex = '99999';
//           this.search.focus();
//         }, 0);
//       }
//     });
//     document.addEventListener('click', e => { if (!this.root.contains(e.target)) this.root.setAttribute('aria-expanded', 'false'); });
//     this.root.addEventListener('keydown', e => { if (e.key === 'Escape') this.root.setAttribute('aria-expanded', 'false'); });
//     this.search.addEventListener('input', e => this._render(e.target.value.trim().toLowerCase()));
//     this.btnClear.addEventListener('click', () => { Array.from(this.select.options).forEach(o => o.selected = false); this._render(this.search.value.trim().toLowerCase()); this._updateLabel(); });
//     this.btnAll.addEventListener('click', () => { Array.from(this.select.options).forEach(o => o.selected = true); this._render(this.search.value.trim().toLowerCase()); this._updateLabel(); });
//     this.btnApply.addEventListener('click', () => { this._updateLabel(); this.root.setAttribute('aria-expanded', 'false'); b2bApplyFilters(); });
//     this.select.addEventListener('change', () => { this._render(this.search.value.trim().toLowerCase()); this._updateLabel(); });
//   }

//   _render(query) {
//     this.list.innerHTML = '';
//     let count = 0;
//     Array.from(this.select.options).forEach(opt => {
//       const label = opt.text || opt.value;
//       if (query && !label.toLowerCase().includes(query)) return;
//       const row = document.createElement('label'); row.className = 'b2b-opt';
//       const chk = document.createElement('input'); chk.type = 'checkbox'; chk.checked = opt.selected;
//       chk.addEventListener('change', () => { opt.selected = chk.checked; });
//       const span = document.createElement('span'); span.textContent = label;
//       row.appendChild(chk); row.appendChild(span); this.list.appendChild(row); count++;
//     });
//     this.list.classList.toggle('empty', count === 0);
//   }

//   _updateLabel() {
//     const selected = Array.from(this.select.selectedOptions || []);
//     if (!selected.length) { this.label.textContent = 'All'; return; }
//     const labels  = selected.map(o => o.text);
//     const preview = labels.slice(0, 2).join(', ');
//     this.label.textContent = labels.length > 2 ? `${preview} +${labels.length - 2}` : preview;
//   }
// }

// let B2B_COMBOS = [];

// /* ============================================================
//    BUILD FILTER OPTIONS
//    ── type, coefficient y msrp se leen desde extras (variante)
//       con fallback a notes (producto)
//    ============================================================ */

// function b2bBuildFilterOptions() {
//   const rows = variantRows();
//   const S = {
//     stock: new Map(), collection: new Map(), perfume: new Map(),
//     type: new Map(), ml: new Map(), presentation: new Map(),
//     msrp: new Map(), wholesale: new Map(),
//     coefficient: new Map(), references: new Map()
//   };

//   rows.forEach(r => {
//     const handle = r.dataset.handle || '';
//     const notes  = window.b2bNotesMap?.[handle] || {};
//     const extras = window.b2bVariantExtrasMap?.[r.dataset.variantId] || {};

//     // ── Campos resueltos desde variante con fallback a producto ──
//     const typeVal        = getTypeVal(extras, notes);
//     // const coefficientVal = getCoefficientVal(extras, notes);
//     const coefficientVal = r.cells[10]?.textContent?.trim() || 'N/A';
//     // const msrpVal        = getMsrpVal(extras, notes);
//     const msrpVal        = r.dataset.msrp || '0';

//     const vStock = r.dataset.stock || '0';
//     if (vStock) S.stock.set(vStock, r.cells[3]?.textContent?.trim() || '0');

//     const vColl = normalize(r.dataset.collection || r.cells[4]?.textContent);
//     const vPerf = normalize(r.dataset.perfume    || r.cells[5]?.textContent);
//     const vType = normalize(typeVal);
//     const vML   = normalize(r.dataset.ml         || r.cells[7]?.textContent);
//     const vPres = normalize(r.dataset.presentation || r.cells[8]?.textContent);

//     if (vColl) S.collection.set(vColl, r.cells[4]?.textContent?.trim() || '');
//     if (vPerf) S.perfume.set(vPerf,    r.cells[5]?.textContent?.trim() || '');
//     if (vType && vType !== 'n/a') S.type.set(vType, typeVal || '');
//     if (vML   && vML   !== 'n/a') S.ml.set(vML,    r.cells[7]?.textContent?.trim() || '');
//     if (vPres && vPres !== 'n/a') S.presentation.set(vPres, r.cells[8]?.textContent?.trim() || '');

//     const mC = toCents(msrpVal);
//     const wC = toCents(r.dataset.wholesale || '0');
//     if (mC > 0) S.msrp.set(String(mC),     r.cells[11]?.textContent?.trim() || '');
//     if (wC > 0) S.wholesale.set(String(wC), r.cells[12]?.textContent?.trim() || '');

//     if (coefficientVal && coefficientVal !== 'N/A') S.coefficient.set(String(coefficientVal), String(coefficientVal));
//     if (notes.references) S.references.set(String(notes.references), String(notes.references));
//   });

//   const toOptions = (map, numeric = false) => {
//     const arr = Array.from(map, ([value, label]) => ({ value, label }));
//     return numeric
//       ? arr.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10))
//       : arr.sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }));
//   };

//   const fill = (id, options) => {
//     const sel = getEl('b2b-filter-' + id);
//     if (sel) sel.innerHTML = options.map(o => `<option value="${o.value}">${o.label}</option>`).join('');
//   };

//   fill('stock',        toOptions(S.stock, true));
//   fill('collection',   toOptions(S.collection));
//   fill('perfume',      toOptions(S.perfume));
//   fill('type',         toOptions(S.type));
//   fill('ml',           toOptions(S.ml, true));
//   fill('presentation', toOptions(S.presentation));
//   fill('msrp',         toOptions(S.msrp, true));
//   fill('wholesale',    toOptions(S.wholesale, true));
//   fill('coefficient',  toOptions(S.coefficient, true));
//   fill('references',   toOptions(S.references, true));
// }

// function b2bInitCombos() {
//   B2B_COMBOS = qsa('.b2b-combo').map(c => new B2BCombo(c));
// }

// function getSelected(id) {
//   const sel = getEl('b2b-filter-' + id);
//   return sel ? Array.from(sel.selectedOptions).map(o => o.value) : [];
// }

// /* ============================================================
//    APPLY FILTERS
//    ── type, coefficient y msrp comparan contra extras/variante
//    ============================================================ */

// function b2bApplyFilters() {
//   const sel = {
//     stock: getSelected('stock'), collection: getSelected('collection'),
//     perfume: getSelected('perfume'), type: getSelected('type'),
//     ml: getSelected('ml'), presentation: getSelected('presentation'),
//     msrp: getSelected('msrp'), wholesale: getSelected('wholesale'),
//     coefficient: getSelected('coefficient'),
//     references: getSelected('references')
//   };

//   variantRows().forEach(r => {
//     const handle = r.dataset.handle || '';
//     const notes  = window.b2bNotesMap?.[handle] || {};
//     const extras = window.b2bVariantExtrasMap?.[r.dataset.variantId] || {};

//     // ── Resolver valores reales para filtrar ──
//     const typeVal        = getTypeVal(extras, notes);
//     // const coefficientVal = getCoefficientVal(extras, notes);
//     // const msrpVal        = getMsrpVal(extras, notes);
//     const coefficientVal = r.cells[10]?.textContent?.trim() || 'N/A';
//     const msrpVal        = r.dataset.msrp || '0';

//     const mC = String(toCents(msrpVal));
//     const wC = String(toCents(r.dataset.wholesale || '0'));

//     const visible =
//       (!sel.stock.length        || sel.stock.includes(r.dataset.stock)) &&
//       (!sel.collection.length   || sel.collection.includes(normalize(r.dataset.collection || r.cells[4]?.textContent))) &&
//       (!sel.perfume.length      || sel.perfume.includes(normalize(r.dataset.perfume || r.cells[5]?.textContent))) &&
//       (!sel.type.length         || sel.type.includes(normalize(typeVal))) &&
//       (!sel.ml.length           || sel.ml.includes(normalize(r.dataset.ml || r.cells[7]?.textContent))) &&
//       (!sel.presentation.length || sel.presentation.includes(normalize(r.dataset.presentation || r.cells[8]?.textContent))) &&
//       (!sel.msrp.length         || sel.msrp.includes(mC)) &&
//       (!sel.wholesale.length    || sel.wholesale.includes(wC)) &&
//       (!sel.coefficient.length  || sel.coefficient.includes(String(coefficientVal))) &&
//       (!sel.references.length   || sel.references.includes(String(notes.references || '')));

//     r.style.display = visible ? '' : 'none';
//     r.dataset.filteredOut = visible ? 'false' : 'true';
//   });
// }

// /* ============================================================
//    SEARCH
//    ============================================================ */

// function initSearch() {
//   const searchInput = getEl('b2b-search-input');
//   const clearBtn    = getEl('b2b-search-clear');

//   function applySearch() {
//     const query = searchInput.value.trim().toLowerCase();
//     clearBtn.style.display = query ? 'block' : 'none';
//     variantRows().forEach(row => {
//       if (!query) { row.style.display = ''; return; }
//       const texts = [row.dataset.sku, row.dataset.perfume, row.dataset.type, row.dataset.ml, row.dataset.collection].join(' ');
//       row.style.display = texts.includes(query) ? '' : 'none';
//     });
//     updateTotals();
//   }

//   searchInput.addEventListener('input', applySearch);
//   clearBtn.addEventListener('click', () => { searchInput.value = ''; applySearch(); searchInput.focus(); });
// }

// /* ============================================================
//    SORT
//    ============================================================ */

// function initSort() {
//   document.querySelectorAll('.sortable').forEach(th => {
//     th.addEventListener('click', () => {
//       const tbody = th.closest('table').querySelector('tbody');
//       const rows  = Array.from(tbody.querySelectorAll('tr.b2b-variant-row'));
//       const index = Array.from(th.parentElement.children).indexOf(th);
//       const dir   = th.classList.contains('asc') ? 'desc' : 'asc';
//       document.querySelectorAll('.sortable').forEach(h => h.classList.remove('asc', 'desc'));
//       th.classList.add(dir);
//       rows.sort((a, b) => {
//         let aV = a.children[index]?.textContent.trim().toLowerCase() || '';
//         let bV = b.children[index]?.textContent.trim().toLowerCase() || '';
//         if (['stock', 'msrp', 'wholesale', 'ranking', 'coefficient'].includes(th.dataset.column)) {
//           aV = parseFloat(aV) || 0; bV = parseFloat(bV) || 0;
//         }
//         return dir === 'asc' ? (aV > bV ? 1 : -1) : (aV < bV ? 1 : -1);
//       });
//       rows.forEach(row => tbody.appendChild(row));
//     });
//   });
// }

// /* ============================================================
//    PRESENTATION FILTER
//    ============================================================ */

// function initPresentationFilter() {
//   const filterBtn = getEl('presentation-btn');
//   const dropdown  = getEl('presentation-dropdown');
//   if (!filterBtn || !dropdown) return;

//   const options = dropdown.querySelectorAll('.b2b-filter-option');
//   let currentFilter = 'all';

//   function applyPresentationFilter() {
//     variantRows().forEach(row => {
//       const visible = currentFilter === 'all' || row.dataset.presentation.includes(currentFilter);
//       row.style.display = visible ? '' : 'none';
//       row.dataset.filteredOut = visible ? 'false' : 'true';
//     });
//     const searchInput = getEl('b2b-search-input');
//     if (searchInput?.value.trim()) {
//       const query = searchInput.value.trim().toLowerCase();
//       variantRows().forEach(row => {
//         if (row.style.display === 'none') return;
//         const texts = [row.dataset.sku, row.dataset.perfume, row.dataset.type, row.dataset.ml, row.dataset.collection].join(' ');
//         if (!texts.includes(query)) row.style.display = 'none';
//       });
//     }
//     updateTotals();
//   }

//   filterBtn.addEventListener('click', () => dropdown.classList.toggle('show'));
//   options.forEach(opt => {
//     opt.addEventListener('click', () => {
//       options.forEach(o => o.classList.remove('selected'));
//       opt.classList.add('selected');
//       currentFilter = opt.dataset.value;
//       filterBtn.firstChild.textContent = opt.textContent.trim() + ' ';
//       dropdown.classList.remove('show');
//       applyPresentationFilter();
//     });
//   });
//   document.addEventListener('click', e => {
//     if (!filterBtn.contains(e.target) && !dropdown.contains(e.target)) dropdown.classList.remove('show');
//   });

//   window._applyPresentationFilter = applyPresentationFilter;
//   applyPresentationFilter();
// }

// /* ============================================================
//    VIEW / HIDE DETAILS PANEL
//    ============================================================ */

// function initDetailsPanel() {
//   const viewBtn = getEl('b2b-view-details-btn');
//   const hideBtn = getEl('b2b-hide-details-btn');
//   const panel   = getEl('b2b-details-panel');
//   if (!viewBtn || !hideBtn || !panel) return;

//   // ── Elementos del footer a ocultar (excepto el panel) ──
//   function setFooterItemsVisibility(visible) {
//     const display = visible ? '' : 'none';
//     const ids = ['b2b-buy-btn', 'b2b-view-details-btn', 'b2b-choose-reward-btn',
//                  'b2b-incentive-banner', 'b2b-variant-incentive-banner', 'b2b-incentive-next'];
//     ids.forEach(id => {
//       const el = getEl(id);
//       if (el) el.style.display = display;
//     });
//     // Ocultar summary info y boton container
//     document.querySelectorAll('.b2b-summary-main').forEach(el => {
//       el.style.display = visible ? '' : 'none';
//     });
//   }

//   viewBtn.addEventListener('click', () => {
//     if (showMinQtyModal() || showBrandMinQtyModal() || showBrandMinValueModal()) return;
//     panel.classList.add('expanded');
//     setFooterItemsVisibility(false);
//     renderPurchaseDetails();
//   });

//   hideBtn.addEventListener('click', () => {
//     panel.classList.remove('expanded');
//     setFooterItemsVisibility(true);
//     updateIncentiveBanners();
//   });

//   // ── Hide Order bottom ──
//   getEl('b2b-hide-details-btn-bottom')?.addEventListener('click', () => {
//     panel.classList.remove('expanded');
//     setFooterItemsVisibility(true);
//     updateIncentiveBanners();
//   });
// }

// /* ============================================================
//    EXPORT EXCEL — PRE ORDERS
//    ============================================================ */

// function initExcelExport() {
//   const btn = getEl('export-excel-btn');
//   if (!btn || btn.dataset.listenerAttached) return;

//   btn.onclick = () => {
//     const vendor  = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const headers = ['SKU','Product','Collection','Type','ML','Presentation','MSRP','Wholesale Price','Qty','Subtotal'];
//     const data    = [headers];

//     // ── Items principales ──
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (!qty) return;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
//       data.push([
//         (row.dataset.sku || '-').toUpperCase(),
//         row.cells[5]?.textContent?.trim() || '',
//         row.cells[4]?.textContent?.trim() || '',
//         row.cells[6]?.textContent?.trim() || '',
//         row.cells[7]?.textContent?.trim() || '',
//         row.cells[8]?.textContent?.trim() || '',
//         row.cells[11]?.textContent?.trim() || '',
//         unitPrice, qty,
//         qty * unitPrice
//       ]);
//     });

//     let grandTotal = 0;
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       grandTotal += qty * parseFloat(row.dataset.unitPrice || 0);
//     });

//     // ── Free gifts prioridad 1: collection rules ──
//     const colHandle = getColHandle();
//     const rules     = window.b2bCollectionIncentivesMap?.[colHandle] || [];
//     let totalUnits  = 0;
//     variantRows().forEach(row => {
//       totalUnits += parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     });
//     const active = rules.length ? calcActiveIncentive(rules, totalUnits, grandTotal) : null;
//     if (active) {
//       (active.free_products || []).forEach((fp, i) => {
//         if (!fp?.title) return;
//         const qty = normalizeQtyArray(active.free_product_quantities)[i] || 1;
//         data.push(['-', fp.title + (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ' — ' + fp.variant_title : ''), '', '', '', '', '', 0, qty, 0]);
//       });
//       (active.free_testers || []).forEach((tp, i) => {
//         if (!tp?.title) return;
//         const qty = getTesterQty(active, i);
//         data.push(['-', tp.title + ' (Tester)', '', '', '', '', '', 0, qty, 0]);
//       });
//     }

//     // ── Free gifts prioridad 1: por variante ──
//     variantRows().forEach(row => {
//       const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       if (!variantHasIncentive(extras)) return;
//       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

//       const fps  = getVariantFreeProducts(extras);
//       const fqs  = getVariantFreeQtys(extras);
//       const mult = calcVariantMultiplier(extras, qty, lineV);
//       const pName = row.cells[5]?.textContent?.trim() || '';

//       const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//       if (fps.length > 1 && choice?.confirmed) {
//         data.push(['-', choice.chosenTitle + ' (Free — ' + pName + ' incentive)', '', '', '', '', '', 0, choice.chosenQty, 0]);
//       } else if (fps.length === 1) {
//         fps.forEach((fp, i) => {
//           if (!fp?.title) return;
//           const giftQty = (fqs[i] || 1) * mult;
//           const fpVar   = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ' — ' + fp.variant_title : '';
//           data.push(['-', fp.title + fpVar + ' (Free — ' + pName + ' incentive)', '', '', '', '', '', 0, giftQty, 0]);
//         });
//       }
//     });

//     // ── Free gifts prioridad 2 ──
//     const p2 = window.b2bPriority2Choice || {};
//     if (p2.confirmed && Array.isArray(p2.selections)) {
//       p2.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => {
//         const vid    = String(s.variant_id || '');
//         const vd     = window.b2bAllVariantsMap?.[vid] || {};
//         const metaP  = parseFloat(s.incentive_product_price || vd.incentive_product_price || 0);
//         const price  = metaP > 0 ? metaP : parseFloat(s.price || 0);
//         const disc   = parseFloat(p2.discountPct || 0);
//         const final  = price * (1 - disc / 100);
//         const fpVar  = s.variant_title && s.variant_title.toLowerCase() !== 'default title' ? ' — ' + s.variant_title : '';
//         data.push([
//           vd.sku || '-',
//           s.title + fpVar + ` (${disc}% Credit)`,
//           vd.collection || '-',
//           '-',
//           vd.ml || '-',
//           vd.pres || '-',
//           '-',
//           final,
//           s.selectedQty,
//           final * s.selectedQty
//         ]);
//       });
//     }

//     data.push([]);
//     data.push(['', '', '', '', '', '', '', '', 'TOTAL', grandTotal]);

//     const ws = XLSX.utils.aoa_to_sheet(data);
//     ws['!cols'] = [{wch:18},{wch:30},{wch:20},{wch:18},{wch:10},{wch:14},{wch:12},{wch:16},{wch:8},{wch:14}];
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Pre-Order');
//     XLSX.writeFile(wb, 'pre-order-' + vendor.toLowerCase().replace(/\s+/g, '-') + '.xlsx');
//   };

//   btn.dataset.listenerAttached = 'true';
// }

// /* ============================================================
//    EXPORT EXCEL — CATÁLOGO COMPLETO
//    ============================================================ */

// function initCatalogExport() {
//   const btn = getEl('export-all-products-btn');
//   if (!btn || btn.dataset.listenerAttached) return;

//   btn.onclick = () => {
//     // Limpiar botones anteriores
//     getEl('catalog-download-btns')?.remove();
//     getEl('incentives-download-btns')?.remove();
//     getEl('preorder-download-btns')?.remove();
//     document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

//     const modeEl        = getEl('send-modal-mode');
//     const titleEl       = getEl('send-modal-title');
//     const formatSection = getEl('send-format-section');

//     if (modeEl)         modeEl.value        = 'catalog';
//     if (titleEl)        titleEl.textContent  = 'Product List';
//     if (formatSection)  formatSection.style.display = '';

//     const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
//     if (excelRadio) excelRadio.checked = true;

//     // ── Bloque descarga + separador OR + email ──
//     const downloadBtns = document.createElement('div');
//     downloadBtns.id = 'catalog-download-btns';
//     downloadBtns.innerHTML = `
//       <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">
//         <div style="width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//             <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
//             <polyline points="7 10 12 15 17 10"/>
//             <line x1="12" y1="15" x2="12" y2="3"/>
//           </svg>
//         </div>
//         <div>
//           <div style="    font-family: 'Crimson Pro';font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Product List</div>
//           <div style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
//         </div>
//       </div>

//       <div style="display:flex;gap:12px;margin-bottom:12px;">
//         <button type="button" id="catalog-dl-excel"
//           style="      font-family: 'Crimson Pro';  border: none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
//           border-radius:10px;cursor:pointer;
//           font-family:'Crimson Pro',serif;transition:all 0.2s;">
//           <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
//           <div style="text-align:left;">
//             <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
//             <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
//           </div>
//         </button>
//         <button type="button" id="catalog-dl-pdf"
//           style="    font-family: 'Crimson Pro';border: none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
//           border-radius:10px;cursor:pointer;
//           font-family:'Crimson Pro',serif;transition:all 0.2s;">
//           <img src="${window._b2bPdfIconUrl}" width="40" height="30" alt="PDF">
//           <div style="text-align:left;">
//             <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
//             <div style="font-size:12px;color:#6b7280;">.pdf format</div>
//           </div>
//         </button>
//       </div>

//       <div style="text-align:center;margin-bottom:16px;">
//         <span style="font-family: 'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:14px;color:#b8a77d;font-weight:600;">
//            Instant download – No email required
//         </span>
//       </div>

//      <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//       <span style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//     </div>

//       <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">
//         <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//           <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//             <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
//             <polyline points="22,6 12,13 2,6"/>
//           </svg>
//         </div>
//         <div>
//           <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Product List by Email</div>
//           <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
//         </div>
//       </div>`;

//     const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
//     const firstLabel     = sendModalInner?.querySelector('label');
//     if (firstLabel) {
//       firstLabel.parentNode.insertBefore(downloadBtns, firstLabel);
//     }

//     // Listeners descarga directa
//     getEl('catalog-dl-excel')?.addEventListener('click', async () => {
//       const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//       const base64 = await generateCatalogBase64();
//       if (!base64) return;
//       const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//       const url  = URL.createObjectURL(blob);
//       const a    = document.createElement('a');
//       a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
//       a.click(); URL.revokeObjectURL(url);
//     });

//     getEl('catalog-dl-pdf')?.addEventListener('click', async () => {
//       const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//       const base64 = await generateCatalogPdfBase64();
//       if (!base64) return;
//       const blob = base64toBlob(base64, 'application/pdf');
//       const url  = URL.createObjectURL(blob);
//       const a    = document.createElement('a');
//       a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
//       a.click(); URL.revokeObjectURL(url);
//     });

//     // Nota al pie
//     const footer = document.createElement('div');
//     footer.className = 'send-modal-separator';
//     footer.innerHTML = `
//       `;
//     const cancelBtn = sendModalInner?.querySelector('#send-modal-cancel');
//     if (cancelBtn) cancelBtn.parentNode.parentNode.appendChild(footer);

//     const modal = getEl('send-modal');
//     if (modal) modal.style.display = 'flex';
//     document.body.style.overflow = 'hidden';
//   };

//   btn.dataset.listenerAttached = 'true';
// }

// // ── Helper base64 a Blob ──
// function base64toBlob(base64, mimeType) {
//   const bytes  = atob(base64);
//   const buffer = new ArrayBuffer(bytes.length);
//   const view   = new Uint8Array(buffer);
//   for (let i = 0; i < bytes.length; i++) view[i] = bytes.charCodeAt(i);
//   return new Blob([buffer], { type: mimeType });
// }


// /* ============================================================
//    EXPORT PDF
//    ============================================================ */

// function initPdfExport() {
//   const btn = getEl('export-pdf-btn');
//   if (!btn || btn.dataset.listenerAttached) return;

//   let _logoDataUrl = null;
//   const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
//   if (logoUrl) {
//     const li = new Image();
//     li.crossOrigin = 'anonymous';
//     li.onload = () => {
//       try {
//         const c = document.createElement('canvas');
//         c.width = li.width; c.height = li.height;
//         c.getContext('2d').drawImage(li, 0, 0);
//         _logoDataUrl = c.toDataURL('image/png');
//       } catch {}
//     };
//     li.src = logoUrl;
//   }

//   btn.onclick = () => {
//     const { jsPDF } = window.jspdf;
//     const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
//     const pageW = doc.internal.pageSize.getWidth();
//     const pageH = doc.internal.pageSize.getHeight();
//     const margin = 14, colW = pageW - margin * 2;
//     let y = margin;

//     const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
//     const drawLine = () => { doc.setDrawColor(220,220,220); doc.line(margin, y, pageW - margin, y); y += 3; };

//     if (_logoDataUrl) {
//       try {
//         const li = new Image(); li.src = _logoDataUrl;
//         const lw = 40, lh = li.height > 0 ? (li.height * lw) / li.width : 20;
//         doc.addImage(_logoDataUrl, 'PNG', (pageW - lw) / 2, y, lw, Math.min(lh, 30));
//         y += Math.min(lh, 30) + 6;
//       } catch {}
//     }

//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     doc.setFontSize(16); doc.setFont('helvetica', 'bold');
//     doc.text(vendor, pageW / 2, y, { align: 'center' }); y += 7;
//     doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120,120,120);
//     doc.text(new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }), pageW / 2, y, { align: 'center' });
//     doc.setTextColor(0,0,0); y += 8; drawLine();

//     const dashData = [
//       { label: 'Products',    value: getEl('dash-count-product')?.textContent || '0' },
//       { label: 'Collections', value: getEl('dash-unique-types')?.textContent  || '0' },
//       { label: 'Items',       value: getEl('dash-total-items')?.textContent   || '0' },
//       { label: 'Est. Total',  value: getEl('dash-total-purchase')?.textContent || '$0' }
//     ];
//     const cardW = colW / 4 - 2;
//     dashData.forEach((d, i) => {
//       const cx = margin + i * (cardW + 2.5);
//       doc.setFillColor(248,248,248); doc.setDrawColor(220,220,220);
//       doc.roundedRect(cx, y, cardW, 18, 2, 2, 'FD');
//       doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(100,100,100);
//       doc.text(d.label, cx + cardW / 2, y + 6, { align: 'center' });
//       doc.setFontSize(12); doc.setFont('helvetica','bold'); doc.setTextColor(30,30,30);
//       doc.text(d.value, cx + cardW / 2, y + 14, { align: 'center' });
//     });
//     doc.setTextColor(0,0,0); y += 24; drawLine();

//     const cols = { sku: 32, product: 48, type: 26, ml: 14, qty: 12, price: 24, total: 26 };
//     const colWidths = [cols.sku, cols.product, cols.type, cols.ml, cols.qty, cols.price, cols.total];
//     doc.setFillColor(30,30,30); doc.rect(margin, y, colW, 7, 'F');
//     doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     let cx = margin + 2;
//     ['SKU','Product','Type','ML','Qty','Unit Price','Subtotal'].forEach((lbl, i) => {
//       doc.text(lbl, cx, y + 5); cx += colWidths[i];
//     });
//     doc.setTextColor(0,0,0); y += 9;

//     let rowCount = 0, totalItemsPDF = 0, grandTotalPDF = 0;
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (!qty) return;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0), subtotal = qty * unitPrice;
//       checkPage(8);
//       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
//       doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(8); doc.setFont('helvetica','normal');
//       let cx2 = margin + 2;
//       [
//         (row.dataset.sku || '-').toUpperCase().substring(0, 12),
//         (row.cells[5]?.textContent?.trim() || '-').substring(0, 30),
//         (row.cells[6]?.textContent?.trim() || '-').substring(0, 14),
//         (row.cells[7]?.textContent?.trim() || '-').substring(0, 8),
//         String(qty), '$' + unitPrice.toFixed(2), '$' + subtotal.toFixed(2)
//       ].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += colWidths[i]; });
//       y += 7; rowCount++; totalItemsPDF += qty; grandTotalPDF += subtotal;
//     });

//   const colH2    = getColHandle();
//     const rulesPDF = window.b2bCollectionIncentivesMap?.[colH2] || [];
//     const activePDF = rulesPDF.length ? calcActiveIncentive(rulesPDF, totalItemsPDF, grandTotalPDF) : null;

//     // ── Sección FREE GIFTS ──
//     const freeRowsPDF = [];

//     // Collection rules auto-apply
//     if (activePDF && isAutoApply(activePDF)) {
//       (activePDF.free_products || []).forEach((fp, i) => {
//         if (!fp?.title) return;
//         const qty   = normalizeQtyArray(activePDF.free_product_quantities)[i] || 1;
//         const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
//         freeRowsPDF.push({ label: fp.title + fpVar, qty, badge: 'FREE', color: [22,101,52], bg: [220,252,231] });
//       });
//       (activePDF.free_testers || []).forEach((tp, i) => {
//         if (!tp?.title) return;
//         freeRowsPDF.push({ label: tp.title + ' (Tester)', qty: getTesterQty(activePDF, i), badge: 'TESTER', color: [29,78,216], bg: [219,234,254] });
//       });
//     }

//     // Variant incentives
//     variantRows().forEach(row => {
//       const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       if (!variantHasIncentive(extras)) return;
//       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

//       const fps    = getVariantFreeProducts(extras);
//       const fqs    = getVariantFreeQtys(extras);
//       const mult   = calcVariantMultiplier(extras, qty, lineV);
//       const pName  = row.cells[5]?.textContent?.trim() || '';
//       const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

//       if (fps.length > 1 && choice?.confirmed) {
//         freeRowsPDF.push({ label: `${choice.chosenTitle} (${pName} incentive)`, qty: choice.chosenQty, badge: 'FREE', color: [22,101,52], bg: [220,252,231] });
//       } else {
//         fps.forEach((fp, i) => {
//           if (!fp?.title) return;
//           const giftQty = (fqs[i] || 1) * mult;
//           const fpVar   = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
//           freeRowsPDF.push({ label: `${fp.title}${fpVar} (${pName} incentive)`, qty: giftQty, badge: 'FREE', color: [22,101,52], bg: [220,252,231] });
//         });
//       }
//     });

//     // Prioridad 2
//     const p2PDF = window.b2bPriority2Choice || {};
//     if (p2PDF.confirmed && Array.isArray(p2PDF.selections)) {
//       p2PDF.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => {
//         const vid   = String(s.variant_id || '');
//         const vd    = window.b2bAllVariantsMap?.[vid] || {};
//         const metaP = parseFloat(s.incentive_product_price || vd.incentive_product_price || 0);
//         const price = metaP > 0 ? metaP : parseFloat(s.price || 0);
//         const disc  = parseFloat(p2PDF.discountPct || 0);
//         const fpVar = s.variant_title && s.variant_title.toLowerCase() !== 'default title' ? ` — ${s.variant_title}` : '';
//         freeRowsPDF.push({ label: `${s.title}${fpVar} (${disc}% credit)`, qty: s.selectedQty, badge: `${disc}%`, color: [29,78,216], bg: [219,234,254] });
//       });
//     }

//     // ── Renderizar sección free gifts ──
//     if (freeRowsPDF.length) {
//       checkPage(12);
//       doc.setFillColor(30,30,30); doc.rect(margin, y, colW, 7, 'F');
//       doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//       doc.text('FREE GIFTS INCLUDED', margin + 2, y + 4.5);
//       doc.setTextColor(0,0,0); y += 10;

//       freeRowsPDF.forEach(item => {
//         checkPage(8);
//         doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, 7, 'F');
//         doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(...item.color);
//         doc.text(item.badge, margin + 2, y + 4);
//         doc.setFont('helvetica','normal');
//         doc.text(item.label.substring(0, 50), margin + 16, y + 4);
//         doc.text(`Qty: ${item.qty}`, pageW - margin - 2, y + 4, { align: 'right' });
//         doc.setTextColor(0,0,0); y += 7;
//       });
//     }

//     const discPctPDF    = rewardChoice?.discountPct || 0;
//     const discAmountPDF = discPctPDF > 0 ? grandTotalPDF * discPctPDF / 100 : 0;
//     const finalTotalPDF = grandTotalPDF - discAmountPDF;

//     checkPage(20); y += 3; drawLine();
//     doc.setFontSize(11); doc.setFont('helvetica','bold');
//     doc.text('Total Items: ' + totalItemsPDF, margin, y + 6);
//     if (discPctPDF > 0) {
//       doc.setFontSize(9); doc.setFont('helvetica','normal'); doc.setTextColor(150,80,0);
//       doc.text(`Discount (${discPctPDF}%): -$${discAmountPDF.toFixed(2)}`, pageW - margin, y + 6, { align: 'right' });
//       y += 7; doc.setFontSize(11); doc.setFont('helvetica','bold'); doc.setTextColor(0,0,0);
//     }
//     doc.text('Estimated Total: $' + finalTotalPDF.toFixed(2), pageW - margin, y + 6, { align: 'right' });
//     doc.save('pre-order-' + vendor.toLowerCase().replace(/\s+/g, '-') + '.pdf');
//   };

//   btn.dataset.listenerAttached = 'true';
// }



// async function cartAddWithRetry(payload, retries = 5, delay = 1500) {
//   const root = window.Shopify?.routes?.root || '/';
//   for (let i = 0; i < retries; i++) {
//     const res = await fetch(`${root}cart/add.js`, {
//       method: 'POST',
//       credentials: 'same-origin',
//       headers: {
//         'Content-Type': 'application/json',
//         'Accept': 'application/json',
//         'X-Requested-With': 'XMLHttpRequest'
//       },
//       body: JSON.stringify(payload)
//     });

//     console.log(`[b2b] Intento ${i + 1}/${retries} - Status: ${res.status}`);

//     if (res.status === 403 && i < retries - 1) {
//       await new Promise(r => setTimeout(r, delay));
//       continue;
//     }

//     return res;
//   }
// }



// /* ============================================================
//    BUY NOW
//    ============================================================ */

// // async function handleBuyNow() {
// //   const buyBtns = [getEl('b2b-buy-btn'), getEl('b2b-buy-now-bottom')];
// //   if (buyBtns[0]?.dataset.processing === 'true') return;

// //   buyBtns.forEach(btn => {
// //     if (btn) { btn.dataset.processing = 'true'; btn.disabled = true; btn.textContent = 'Processing...'; }
// //   });

// //   function resetBuyBtns() {
// //     buyBtns.forEach(btn => {
// //       if (btn) { btn.dataset.processing = 'false'; btn.disabled = false; btn.textContent = 'Buy Now'; }
// //     });
// //   }

// //   if (showMinQtyModal() || showBrandMinQtyModal() || showBrandMinValueModal()) {
// //     resetBuyBtns(); return;
// //   }

// //   let anyVariantActive = false;
// //   variantRows().forEach(row => {
// //     const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //     if (qty <= 0) return;
// //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
// //     const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
// //     if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) anyVariantActive = true;
// //   });

// //   if (!anyVariantActive && rewardChoice.active && !isAutoApply(rewardChoice.active) && !rewardChoice.confirmed) {
// //     alert('Please choose your collection reward first by clicking Choose Your Reward.');
// //     resetBuyBtns(); return;
// //   }

// //   let pendingVariantChoice = false;
// //   if (Number(window.b2bCollectionPriority || 1) !== 2  && Number(window.b2bCollectionPriority || 1) !== 3) {
// //     variantRows().forEach(row => {
// //       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       if (qty <= 0) return;
// //       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
// //       if (!variantHasIncentive(extras)) return;
// //       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
// //       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
// //       if (getVariantFreeProducts(extras).length > 1) {
// //         const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
// //         if (!choice?.confirmed) pendingVariantChoice = true;
// //       }
// //     });
// //     if (pendingVariantChoice) {
// //       alert('Please choose your free product gift before continuing.');
// //       resetBuyBtns(); return;
// //     }
// //   }

// //   const items = [];
// //   document.querySelectorAll('.hidden-qty').forEach(input => {
// //     const qty = parseInt(input.value) || 0;
// //     if (qty > 0) {
// //       const vid = input.nextElementSibling?.value;
// //       if (vid) items.push({ id: Number(vid), quantity: qty });
// //     }
// //   });
// //   if (!items.length) { resetBuyBtns(); return; }

// //   lockUI();

// //   const colHandle = getColHandle();
// //   const rules     = window.b2bCollectionIncentivesMap?.[colHandle] || [];
// //   let freeItems   = [];

// //   if (rules.length) {
// //     let unitsCol = 0, valueCol = 0;
// //     items.forEach(item => {
// //       const extras = window.b2bVariantExtrasMap?.[String(item.id)];
// //       const row    = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
// //       const lineV  = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
// //       if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, item.quantity, lineV)) return;
// //       unitsCol += item.quantity;
// //       valueCol += lineV;
// //     });

// //     const active = calcActiveIncentive(rules, unitsCol, valueCol);
// //     if (active && (isAutoApply(active) || rewardChoice.confirmed)) {
// //       if (isAutoApply(active)) {
// //         await Promise.all((active.free_products || []).map(async (fp, i) => {
// //           const giftQty = normalizeQtyArray(active.free_product_quantities)[i] || 1;
// //           if (fp?.variant_id && fp.variant_id !== '0') {
// //             freeItems.push({ id: Number(fp.variant_id), quantity: giftQty, properties: { 'Free Gift': 'Volume Incentive Reward' } });
// //             return;
// //           }
// //           if (!fp?.handle) return;
// //           const v = await fetchFreeGiftVariant(fp.handle);
// //           if (v) freeItems.push({ id: Number(v.id), quantity: giftQty, properties: { 'Free Gift': 'Volume Incentive Reward' } });
// //         }));
// //         const testers = active.free_testers || [];
// //         if (testers.length) {
// //           await Promise.all(testers.map(async (tp, i) => {
// //             const q = getTesterQty(active, i);
// //             if (tp.variant_id && tp.variant_id !== '0') {
// //               freeItems.push({ id: Number(tp.variant_id), quantity: q, properties: { '🧴 Tester': 'Volume Incentive Reward' } });
// //               return;
// //             }
// //             if (!tp?.handle) return;
// //             const v = await fetchFreeGiftVariant(tp.handle, 'tester');
// //             if (v) freeItems.push({ id: Number(v.id), quantity: q, properties: { '🧴 Tester': 'Volume Incentive Reward' } });
// //           }));
// //         } else {
// //           const tTotal = normalizeQtyArray(active.testers_qty).reduce((s, q) => s + q, 0);
// //           if (tTotal > 0) window._pendingTesters = tTotal;
// //         }
// //       } else {
// //         const ct = rewardChoice.chosenType, chosenQty = rewardChoice.chosenQty || 1;
// //         if (ct === 'product' || ct === 'tester') {
// //           let chosenVid = rewardChoice.chosenVariantId;
// //           if (!chosenVid && rewardChoice.chosenProductHandle) {
// //             const v = await fetchFreeGiftVariant(rewardChoice.chosenProductHandle, ct);
// //             if (v) { chosenVid = String(v.id); rewardChoice.chosenVariantId = chosenVid; }
// //           }
// //           if (chosenVid) {
// //             const prop = ct === 'tester' ? '🧴 Tester' : 'Free Gift';
// //             freeItems.push({ id: Number(chosenVid), quantity: chosenQty, properties: { [prop]: 'Volume Incentive — User Choice' } });
// //           }
// //         }
// //       }
// //       rewardChoice.discountPct = Number(active.discount || 0);
// //     }
// //   }

// //   const alreadyAdded = new Set(freeItems.map(fi => String(fi.id)));
// //   await Promise.all(items.map(async item => {
// //     const extras = window.b2bVariantExtrasMap?.[String(item.id)];
// //     if (!variantHasIncentive(extras)) return;
// //     const row   = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
// //     const lineV = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
// //     if (!checkVariantIncentiveMet(extras, item.quantity, lineV)) return;

// //     const fps  = getVariantFreeProducts(extras);
// //     const fqs  = getVariantFreeQtys(extras);
// //     const mult = calcVariantMultiplier(extras, item.quantity, lineV);

// //     if (fps.length > 1) {
// //       const choice = window.b2bVariantRewardChoices?.[String(item.id)];
// //       if (choice?.confirmed && choice.chosenVariantId && !alreadyAdded.has(choice.chosenVariantId)) {
// //         alreadyAdded.add(choice.chosenVariantId);
// //         freeItems.push({ id: Number(choice.chosenVariantId), quantity: choice.chosenQty, properties: { 'Free Gift': 'Variant Incentive — User Choice' } });
// //       }
// //     } else {
// //       await Promise.all(fps.map(async (fp, i) => {
// //         const giftQty = (fqs[i] || 1) * mult;
// //         if (fp?.variant_id && fp.variant_id !== '0') {
// //           if (!alreadyAdded.has(String(fp.variant_id))) {
// //             alreadyAdded.add(String(fp.variant_id));
// //             freeItems.push({ id: Number(fp.variant_id), quantity: giftQty, properties: { 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` } });
// //           }
// //           return;
// //         }
// //         if (!fp?.handle) return;
// //         const variant = await fetchFreeGiftVariant(fp.handle);
// //         if (variant && !alreadyAdded.has(String(variant.id))) {
// //           alreadyAdded.add(String(variant.id));
// //           freeItems.push({ id: Number(variant.id), quantity: giftQty, properties: { 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` } });
// //         }
// //       }));
// //     }
// //   }));

// // try {
// //     const root = window.Shopify?.routes?.root || '/';

// //     // ✅ Warm-up: despertar la sesión
// //     await fetch(`${root}cart.js`, {
// //       credentials: 'same-origin',
// //       headers: { 'Accept': 'application/json' }
// //     });
// //     await new Promise(r => setTimeout(r, 400));

// //     // ✅ Limpiar carrito vía update.js en lugar de clear.js
// //     const currentCartRes = await fetch(`${root}cart.js`, {
// //       credentials: 'same-origin',
// //       headers: { 'Accept': 'application/json' }
// //     });
// //     const currentCart = await currentCartRes.json();
// //     if (currentCart.items?.length) {
// //       const updates = {};
// //       currentCart.items.forEach(item => { updates[item.key] = 0; });
// //       await fetch(`${root}cart/update.js`, {
// //         method: 'POST',
// //         credentials: 'same-origin',
// //         headers: {
// //           'Content-Type': 'application/json',
// //           'Accept': 'application/json',
// //           'X-Requested-With': 'XMLHttpRequest'
// //         },
// //         body: JSON.stringify({ updates })
// //       });
// //       await new Promise(r => setTimeout(r, 400));
// //     }

// //     // ── Agregar items principales ──
// //     const mainRes = await cartAddWithRetry({ items });

// //     if (mainRes.status === 403 || mainRes.status === 401) {
// //       resetBuyBtns();
// //       window.location.href = `${root}account/login?return_url=` + encodeURIComponent(window.location.pathname + window.location.search);
// //       return;
// //     }

// //     if (!mainRes.ok) {
// //       const errText = await getSafeError(mainRes);
// //       throw new Error(`Cart add failed. Status ${mainRes.status}: ${errText}`);
// //     }

// //     // ── Prioridad 1: free gifts principales ──
// //     if (freeItems.length) {
// //       const freeRes = await cartAddWithRetry({ items: freeItems });
// //       if (!freeRes.ok) {
// //         const freeErr = await getSafeError(freeRes);
// //         console.warn('[b2b] Free items add failed:', freeErr);
// //       }
// //     }

// //     // ── Prioridad 2: productos con descuento ──
// //     const p2choice = window.b2bPriority2Choice || {};
// //     if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
// //       const p2Items = [];
// //       for (const sel of p2choice.selections) {
// //         const qty = parseInt(sel.selectedQty || 0);
// //         if (qty <= 0) continue;
// //         const vid = sel.variant_id && String(sel.variant_id) !== '0'
// //           ? String(sel.variant_id)
// //           : null;
// //         if (!vid) continue;
// //         p2Items.push({
// //           id:       Number(vid),
// //           quantity: qty,
// //           properties: { 'Discount Gift': `${p2choice.discountPct}% credit applied` }
// //         });
// //       }

// //       if (p2Items.length) {
// //         try {
// //           const p2Res = await cartAddWithRetry({ items: p2Items });
// //           if (!p2Res.ok) {
// //             const p2Err = await getSafeError(p2Res);
// //             console.warn('[P2] No se pudieron agregar productos gift:', p2Err);
// //           }
// //         } catch (p2Err) {
// //           console.warn('[P2] Error al agregar productos gift:', p2Err);
// //         }
// //       }
// //     }

// //     // ── Prioridad 3: free gifts distribuidos ──
// //     const p3choice = window.b2bPriority3Choice || {};
// //     if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
// //       const p3Items = [];
// //       for (const sel of p3choice.selections) {
// //         for (const choice of (sel.choices || [])) {
// //           if (!choice.chosenQty || choice.chosenQty <= 0) continue;
// //           let vid3 = choice.chosenVariantId;
// //           if (!vid3 && choice.handle) {
// //             const v = await fetchFreeGiftVariant(choice.handle);
// //             if (v) vid3 = String(v.id);
// //           }
// //           if (!vid3) continue;
// //           p3Items.push({
// //             id:       Number(vid3),
// //             quantity: choice.chosenQty,
// //             properties: { 'Free Gift': `Priority 3 — ${sel.pName}` }
// //           });
// //         }
// //       }
// //       if (p3Items.length) {
// //         try {
// //           const p3Res = await cartAddWithRetry({ items: p3Items });
// //           if (!p3Res.ok) {
// //             const p3Err = await getSafeError(p3Res);
// //             console.warn('[P3] Error adding gifts:', p3Err);
// //           }
// //         } catch (e) {
// //           console.warn('[P3] Error adding gifts:', e);
// //         }
// //       }
// //     }

// //     // ── Cart attributes ──
// //     const discPct = rewardChoice?.discountPct || 0;
// //     const attribs = {};
// //     if (freeItems.length)           { attribs['Free Gifts'] = freeItems.map(fi => `${fi.quantity}x variant ${fi.id}`).join(', '); attribs['Incentive Applied'] = 'Yes'; }
// //     if (discPct > 0)                { attribs['Discount Applied'] = `${discPct}% Volume Incentive`; attribs['Incentive Discount'] = String(discPct); }
// //     if (window._pendingTesters > 0) { attribs['Testers Requested'] = String(window._pendingTesters); window._pendingTesters = 0; }
// //     if (Object.keys(attribs).length) {
// //       await fetch(`${root}cart/update.js`, {
// //         method: 'POST',
// //         credentials: 'same-origin',
// //         headers: {
// //           'Content-Type': 'application/json',
// //           'Accept': 'application/json',
// //           'X-Requested-With': 'XMLHttpRequest'
// //         },
// //         body: JSON.stringify({ attributes: attribs })
// //       });
// //     }

// //     // ── Verificar items principales ──
// //     const cartRes = await fetch(`${root}cart.js`, {
// //       credentials: 'same-origin',
// //       headers: { 'Accept': 'application/json' }
// //     });
// //     const cart = await cartRes.json();
// //     const addedVariantIds = new Set(items.map(i => i.id));
// //     const cartVariantIds  = new Set(cart.items.map(i => i.variant_id));
// //     const missing = [...addedVariantIds].filter(id => !cartVariantIds.has(id));
// //     if (missing.length) throw new Error(`Some items could not be added to the cart (variant IDs: ${missing.join(', ')})`);

// //     // ✅ Pausa final y checkout locale-aware
// //     await new Promise(resolve => setTimeout(resolve, 300));
// //     window.location.assign(`${root}checkout`);

// //   } catch (err) {
// //     console.error('[b2b] Buy Now error:', err);
// //     alert('There was an error processing your purchase. Please try again.\n\n' + err.message);
// //     resetBuyBtns();
// //   }
// // }


// async function handleBuyNow() {
//   const buyBtns = [getEl('b2b-buy-btn'), getEl('b2b-buy-now-bottom')];
//   if (buyBtns[0]?.dataset.processing === 'true') return;

//   buyBtns.forEach(btn => {
//     if (btn) { btn.dataset.processing = 'true'; btn.disabled = true; btn.textContent = 'Processing...'; }
//   });

//   function resetBuyBtns() {
//     buyBtns.forEach(btn => {
//       if (btn) { btn.dataset.processing = 'false'; btn.disabled = false; btn.textContent = 'Buy Now'; }
//     });
//   }

//   if (showMinQtyModal() || showBrandMinQtyModal() || showBrandMinValueModal()) {
//     resetBuyBtns(); return;
//   }

//   // ── Estas validaciones no aplican a master ──
//   if (!window.b2bIsMasterUser) {
//     let anyVariantActive = false;
//     variantRows().forEach(row => {
//       const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) anyVariantActive = true;
//     });

//     if (!anyVariantActive && rewardChoice.active && !isAutoApply(rewardChoice.active) && !rewardChoice.confirmed) {
//       alert('Please choose your collection reward first by clicking Choose Your Reward.');
//       resetBuyBtns(); return;
//     }

//     let pendingVariantChoice = false;
//     if (Number(window.b2bCollectionPriority || 1) !== 2  && Number(window.b2bCollectionPriority || 1) !== 3) {
//       variantRows().forEach(row => {
//         const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//         if (qty <= 0) return;
//         const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//         if (!variantHasIncentive(extras)) return;
//         const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//         if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//         if (getVariantFreeProducts(extras).length > 1) {
//           const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//           if (!choice?.confirmed) pendingVariantChoice = true;
//         }
//       });
//       if (pendingVariantChoice) {
//         alert('Please choose your free product gift before continuing.');
//         resetBuyBtns(); return;
//       }
//     }
//   }

//   const items = [];
//   document.querySelectorAll('.hidden-qty').forEach(input => {
//     const qty = parseInt(input.value) || 0;
//     if (qty > 0) {
//       const vid = input.nextElementSibling?.value;
//       if (vid) items.push({ id: Number(vid), quantity: qty });
//     }
//   });
//   if (!items.length) { resetBuyBtns(); return; }

//   if (window.b2bIsMasterUser) {
//     const ctx = window.b2bMasterOrderContext;
//     if (!ctx.companyId || !ctx.customerId) {
//       alert('Please select a Company and a Customer before placing this order.');
//       resetBuyBtns(); return;
//     }
//   }

//   lockUI();

//   const colHandle = getColHandle();
//   const rules     = window.b2bCollectionIncentivesMap?.[colHandle] || [];
//   let freeItems   = [];

//   // ══════════════════════════════════════════════
//   // MASTER: FOC manual, sin reglas de incentivo
//   // NO MASTER: reglas de colección auto-apply / reward choice
//   // ══════════════════════════════════════════════
//   if (window.b2bIsMasterUser) {
//     Object.entries(window.b2bMasterFreeItems || {}).forEach(([vid, qty]) => {
//       qty = parseInt(qty) || 0;
//       if (qty <= 0) return;
//       freeItems.push({
//         id: Number(vid),
//         quantity: qty,
//         properties: { '_gift_type': 'free_sample', 'Free Gift': 'Master Manual FOC' }
//       });
//     });
//   } else if (rules.length) {
//     let unitsCol = 0, valueCol = 0;
//     items.forEach(item => {
//       const extras = window.b2bVariantExtrasMap?.[String(item.id)];
//       const row    = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
//       const lineV  = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
//       if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, item.quantity, lineV)) return;
//       unitsCol += item.quantity;
//       valueCol += lineV;
//     });

//     const active = calcActiveIncentive(rules, unitsCol, valueCol);
//     if (active && (isAutoApply(active) || rewardChoice.confirmed)) {
//       if (isAutoApply(active)) {
//         await Promise.all((active.free_products || []).map(async (fp, i) => {
//           const giftQty = normalizeQtyArray(active.free_product_quantities)[i] || 1;
//           if (fp?.variant_id && fp.variant_id !== '0') {
//             freeItems.push({ id: Number(fp.variant_id), quantity: giftQty, properties: { '_gift_type': 'free_sample', 'Free Gift': 'Volume Incentive Reward' } });
//             return;
//           }
//           if (!fp?.handle) return;
//           const v = await fetchFreeGiftVariant(fp.handle);
//           if (v) freeItems.push({ id: Number(v.id), quantity: giftQty, properties: { '_gift_type': 'free_sample', 'Free Gift': 'Volume Incentive Reward' } });
//         }));
//         const testers = active.free_testers || [];
//         if (testers.length) {
//           await Promise.all(testers.map(async (tp, i) => {
//             const q = getTesterQty(active, i);
//             if (tp.variant_id && tp.variant_id !== '0') {
//               freeItems.push({ id: Number(tp.variant_id), quantity: q, properties: { '_gift_type': 'free_sample', '🧴 Tester': 'Volume Incentive Reward' } });
//               return;
//             }
//             if (!tp?.handle) return;
//             const v = await fetchFreeGiftVariant(tp.handle, 'tester');
//             if (v) freeItems.push({ id: Number(v.id), quantity: q, properties: { '_gift_type': 'free_sample', '🧴 Tester': 'Volume Incentive Reward' } });
//           }));
//         } else {
//           const tTotal = normalizeQtyArray(active.testers_qty).reduce((s, q) => s + q, 0);
//           if (tTotal > 0) window._pendingTesters = tTotal;
//         }
//       } else {
//         const ct = rewardChoice.chosenType, chosenQty = rewardChoice.chosenQty || 1;
//         if (ct === 'product' || ct === 'tester') {
//           let chosenVid = rewardChoice.chosenVariantId;
//           if (!chosenVid && rewardChoice.chosenProductHandle) {
//             const v = await fetchFreeGiftVariant(rewardChoice.chosenProductHandle, ct);
//             if (v) { chosenVid = String(v.id); rewardChoice.chosenVariantId = chosenVid; }
//           }
//           if (chosenVid) {
//             const prop = ct === 'tester' ? '🧴 Tester' : 'Free Gift';
//             freeItems.push({ id: Number(chosenVid), quantity: chosenQty, properties: { '_gift_type': 'free_sample', [prop]: 'Volume Incentive — User Choice' } });
//           }
//         }
//       }
//       rewardChoice.discountPct = Number(active.discount || 0);
//     }
//   }

//   const alreadyAdded = new Set(freeItems.map(fi => String(fi.id)));
//   const priorityForBuy = Number(window.b2bCollectionPriority || 1);

//   // ── El auto-detect de free gifts por variante (P1) tampoco aplica a master ──
//   if (!window.b2bIsMasterUser) {
//     await Promise.all(items.map(async item => {
//       const extras = window.b2bVariantExtrasMap?.[String(item.id)];
//       if (!variantHasIncentive(extras)) return;
//       const row   = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
//       const lineV = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, item.quantity, lineV)) return;

//       const fps  = getVariantFreeProducts(extras);
//       const fqs  = getVariantFreeQtys(extras);
//       const mult = calcVariantMultiplier(extras, item.quantity, lineV);

//       if (fps.length > 1) {
//         const choice = window.b2bVariantRewardChoices?.[String(item.id)];
//         if (choice?.confirmed && choice.chosenVariantId && !alreadyAdded.has(choice.chosenVariantId)) {
//           alreadyAdded.add(choice.chosenVariantId);
//           freeItems.push({
//             id: Number(choice.chosenVariantId),
//             quantity: computeCartGiftQty(choice.chosenVariantId, choice.chosenQty),
//             properties: { '_gift_type': 'free_sample', 'Free Gift': 'Variant Incentive — User Choice' }
//           });
//         }
//       } else if (priorityForBuy !== 2 && priorityForBuy !== 3) {
//         await Promise.all(fps.map(async (fp, i) => {
//           const giftQty = (fqs[i] || 1) * mult;
//           if (fp?.variant_id && fp.variant_id !== '0') {
//             if (!alreadyAdded.has(String(fp.variant_id))) {
//               alreadyAdded.add(String(fp.variant_id));
//               freeItems.push({
//                 id: Number(fp.variant_id),
//                 quantity: computeCartGiftQty(fp.variant_id, giftQty),
//                 properties: { '_gift_type': 'free_sample', 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` }
//               });
//             }
//             return;
//           }
//           if (!fp?.handle) return;
//           const variant = await fetchFreeGiftVariant(fp.handle);
//           if (variant && !alreadyAdded.has(String(variant.id))) {
//             alreadyAdded.add(String(variant.id));
//             freeItems.push({
//               id: Number(variant.id),
//               quantity: computeCartGiftQty(variant.id, giftQty),
//               properties: { '_gift_type': 'free_sample', 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` }
//             });
//           }
//         }));
//       }
//     }));
//   }

//   // ══════════════════════════════════════════════
//   // MASTER: crear Draft Order vía backend, atribuido
//   // al customer/company seleccionado. NO usa cart/add.js.
//   // Corta la ejecución aquí (return) y no toca el checkout normal.
//   // ══════════════════════════════════════════════
//   if (window.b2bIsMasterUser) {
//     const ctx = window.b2bMasterOrderContext;

//     const orderItems = items.map(it => ({
//       variantId: String(it.id),
//       quantity: it.quantity
//     }));

//     const orderFreeItems = freeItems.map(fi => ({
//       variantId: String(fi.id),
//       quantity: fi.quantity
//     }));

//     try {
//       const res = await fetch('https://shopifyadminapi.8motiv.com/api/Master/CreateOrder', {
//         method: 'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           customerId: ctx.customerId,
//           companyId: ctx.companyId,
//           companyContactId: ctx.companyContactId,
//           companyLocationId: ctx.companyLocationId,
//           items: orderItems,
//           freeItems: orderFreeItems,
//           note: `Master order — ${ctx.customerName} / ${ctx.companyName}`
//         })
//       });

//       const data = await res.json();
//       console.log('[Master CreateOrder] Full response:', data);
//       if (!data.success) {
//          console.error('[Master CreateOrder] Error detail:', JSON.stringify(data, null, 2));
//         throw new Error(data.message || (data.errors ? JSON.stringify(data.errors) : 'Unknown error'));
//       }

//       resetBuyBtns();
//       showMasterOrderCreatedModal(data);
//       return;

//     } catch (err) {
//       console.error('[Master] CreateOrder error:', err);
//       alert('There was an error creating the order. Please try again.\n\n' + err.message);
//       resetBuyBtns();
//       return;
//     }
//   }

//   // ══════════════════════════════════════════════
//   // A partir de aquí: flujo normal de carrito/checkout, SOLO no-master
//   // ══════════════════════════════════════════════
//   try {
//     const root = window.Shopify?.routes?.root || '/';

//     // ✅ Warm-up: despertar la sesión
//     await fetch(`${root}cart.js`, {
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json' }
//     });
//     await new Promise(r => setTimeout(r, 400));

//     // ✅ Limpiar carrito vía update.js en lugar de clear.js
//     const currentCartRes = await fetch(`${root}cart.js`, {
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json' }
//     });
//     const currentCart = await currentCartRes.json();
//     if (currentCart.items?.length) {
//       const updates = {};
//       currentCart.items.forEach(item => { updates[item.key] = 0; });
//       await fetch(`${root}cart/update.js`, {
//         method: 'POST',
//         credentials: 'same-origin',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({ updates })
//       });
//       await new Promise(r => setTimeout(r, 400));
//     }

//     // ── Agregar items principales ──
//     const mainRes = await cartAddWithRetry({ items });

//     if (mainRes.status === 403 || mainRes.status === 401) {
//       resetBuyBtns();
//       window.location.href = `${root}account/login?return_url=` + encodeURIComponent(window.location.pathname + window.location.search);
//       return;
//     }

//     if (!mainRes.ok) {
//       const errText = await getSafeError(mainRes);
//       throw new Error(`Cart add failed. Status ${mainRes.status}: ${errText}`);
//     }

//     // ── Free gifts (P1) ──
//     if (freeItems.length) {
//       const freeRes = await cartAddWithRetry({ items: freeItems });
//       if (!freeRes.ok) {
//         const freeErr = await getSafeError(freeRes);
//         console.warn('[b2b] Free items add failed:', freeErr);
//       }
//     }

//     // ── Prioridad 2: productos con descuento ──
//     const p2choice = window.b2bPriority2Choice || {};
//     if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
//       const p2Items = [];
//       for (const sel of p2choice.selections) {
//         const qty = parseInt(sel.selectedQty || 0);
//         if (qty <= 0) continue;
//         const vid = sel.variant_id && String(sel.variant_id) !== '0'
//           ? String(sel.variant_id)
//           : null;
//         if (!vid) continue;
//         p2Items.push({
//           id: Number(vid),
//           quantity: computeCartGiftQty(vid, qty),
//           properties: { '_gift_type': 'free_sample', 'Discount Gift': `${p2choice.discountPct}% credit applied` }
//         });
//       }

//       if (p2Items.length) {
//         try {
//           const p2Res = await cartAddWithRetry({ items: p2Items });
//           if (!p2Res.ok) {
//             const p2Err = await getSafeError(p2Res);
//             console.warn('[P2] No se pudieron agregar productos gift:', p2Err);
//           }
//         } catch (p2Err) {
//           console.warn('[P2] Error al agregar productos gift:', p2Err);
//         }
//       }
//     }

//     // ── Prioridad 3: free gifts distribuidos ──
//     const p3choice = window.b2bPriority3Choice || {};
//     if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
//       const p3Items = [];
//       for (const sel of p3choice.selections) {
//         for (const choice of (sel.choices || [])) {
//           if (!choice.chosenQty || choice.chosenQty <= 0) continue;
//           let vid3 = choice.chosenVariantId;
//           if (!vid3 && choice.handle) {
//             const v = await fetchFreeGiftVariant(choice.handle);
//             if (v) vid3 = String(v.id);
//           }
//           if (!vid3) continue;
//           p3Items.push({
//             id: Number(vid3),
//             quantity: computeCartGiftQty(vid3, choice.chosenQty),
//             properties: { '_gift_type': 'free_sample', 'Free Gift': `${sel.pName}` }
//           });
//         }
//       }
//       if (p3Items.length) {
//         try {
//           const p3Res = await cartAddWithRetry({ items: p3Items });
//           if (!p3Res.ok) {
//             const p3Err = await getSafeError(p3Res);
//             console.warn('[P3] Error adding gifts:', p3Err);
//           }
//         } catch (e) {
//           console.warn('[P3] Error adding gifts:', e);
//         }
//       }
//     }

//     // ── Cart attributes ──
//     const discPct = rewardChoice?.discountPct || 0;
//     const attribs = {};
//     if (freeItems.length)           { attribs['Free Gifts'] = freeItems.map(fi => `${fi.quantity}x variant ${fi.id}`).join(', '); attribs['Incentive Applied'] = 'Yes'; }
//     if (discPct > 0)                { attribs['Discount Applied'] = `${discPct}% Volume Incentive`; attribs['Incentive Discount'] = String(discPct); }
//     if (window._pendingTesters > 0) { attribs['Testers Requested'] = String(window._pendingTesters); window._pendingTesters = 0; }
//     if (Object.keys(attribs).length) {
//       await fetch(`${root}cart/update.js`, {
//         method: 'POST',
//         credentials: 'same-origin',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({ attributes: attribs })
//       });
//     }

//     // ── Verificar items principales ──
//     const cartRes = await fetch(`${root}cart.js`, {
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json' }
//     });
//     const cart = await cartRes.json();
//     const addedVariantIds = new Set(items.map(i => i.id));
//     const cartVariantIds  = new Set(cart.items.map(i => i.variant_id));
//     const missing = [...addedVariantIds].filter(id => !cartVariantIds.has(id));
//     if (missing.length) throw new Error(`Some items could not be added to the cart (variant IDs: ${missing.join(', ')})`);

//     // ✅ Pausa final y checkout locale-aware
//     // await new Promise(resolve => setTimeout(resolve, 300));
//     // window.location.assign(`${root}checkout`);

//         // ── Aplicar el código del metaobject al carrito y al checkout ──
//     const pdCode = (window.b2bProductDiscount?.code || '').trim();
//     if (pdCode) {
//       try {
//         await fetch(`${root}cart/update.js`, {
//           method: 'POST',
//           credentials: 'same-origin',
//           headers: {
//             'Content-Type': 'application/json',
//             'Accept': 'application/json',
//             'X-Requested-With': 'XMLHttpRequest'
//           },
//           body: JSON.stringify({ discount: pdCode })
//         });

//         const chk = await (await fetch(`${root}cart.js`, {
//           credentials: 'same-origin',
//           headers: { 'Accept': 'application/json' }
//         })).json();
//         console.log('[ProductDiscount] discount_codes:', chk.discount_codes,
//                     '| total_discount:', chk.total_discount / 100);
//       } catch (e) {
//         console.warn('[ProductDiscount] No se pudo aplicar el código al carrito:', e);
//       }
//     }

//     // ✅ Pausa final y checkout con el código
//     await new Promise(resolve => setTimeout(resolve, 300));
//     window.location.assign(`${root}checkout${pdCode ? '?discount=' + encodeURIComponent(pdCode) : ''}`);

//   } catch (err) {
//     console.error('[b2b] Buy Now error:', err);
//     alert('There was an error processing your purchase. Please try again.\n\n' + err.message);
//     resetBuyBtns();
//   }
// }





// /* ============================================================
//    GUIDELINES MODAL
//    ============================================================ */

//   function initGuidelinesModal() {
//     getEl('conditions-btn')?.addEventListener('click', async () => {
//       const colHandle = getColHandle();
//       getEl('cond-first-units').textContent = window.b2bBrandMinQtyMap?.[colHandle]        ? window.b2bBrandMinQtyMap[colHandle] + ' Units' : '—';
//       getEl('cond-first-value').textContent = window.b2bBrandMinValueMap?.[colHandle]       ? '$' + parseFloat(window.b2bBrandMinValueMap[colHandle]).toFixed(2) : '—';
//       getEl('cond-next-units').textContent  = window.b2bBrandNextOrderMap?.[colHandle]      ? window.b2bBrandNextOrderMap[colHandle] + ' Units' : '—';
//       getEl('cond-next-value').textContent  = window.b2bBrandNextOrderValueMap?.[colHandle] ? '$' + parseFloat(window.b2bBrandNextOrderValueMap[colHandle]).toFixed(2) : '—';

//       const rules            = window.b2bCollectionIncentivesMap?.[colHandle] || [];
//       const incentivesSection = getEl('cond-incentives-section');
//       const incentivesList    = getEl('cond-incentives-list');

//       const priority     = Number(window.b2bCollectionPriority || 1);
//       const discPct      = parseFloat(window.b2bCollectionDiscount || 0);
//       const minAmount    = parseFloat(window.b2bDiscountMinAmount  || 0);
//       const discProducts = window.b2bDiscountProducts || [];

//       if (priority === 2 && discPct > 0 && discProducts.length > 0) {
//         // ════════════════════════════════════
//         //  PRIORIDAD 2
//         // ════════════════════════════════════
//         incentivesSection.style.display = 'block';

//         function getProductPrice(p) {
//           const metaP = parseFloat(p.incentive_product_price || 0);
//           if (metaP > 0) return metaP;
//           const vid2    = String(p.variant_id || '');
//           const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
//           const metaP2  = parseFloat(extras2.incentive_product_price || 0);
//           if (metaP2 > 0) return metaP2;
//           return parseFloat(p.price || 0);
//         }

//         // ── Construir cards ──
//         const p2Cards = discProducts.map(p => {
//           if (!p?.title) return '';
//           const imgSrc    = (p.image || '').replace(/^\/\//, 'https://');
//           const realPrice = getProductPrice(p);
//           const varTitle  = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
//           const vid       = String(p.variant_id || '');
//           const varData   = window.b2bAllVariantsMap?.[vid] || {};
//           const notes     = window.b2bNotesMap?.[p.handle] || {};
//           const sku        = varData.sku || '—';
//           const ml         = varData.ml || varTitle || '—';
//           const pres       = varData.pres || '—';
//           const collection = varData.collection || notes.collection || '—';
//           const coeff      = varData.coefficient || notes.coefficient || '—';
//           return `
//             <div style="display:flex;align-items:center;gap:12px;padding:12px;background:#fff;border:1px solid #e5e7eb;border-radius:8px;">
//               ${imgSrc
//                 ? `<img src="${imgSrc}" style="width:60px;height:60px;object-fit:cover;border-radius:8px;flex-shrink:0;">`
//                 : '<div style="width:60px;height:60px;border-radius:8px;background:#dbeafe;display:flex;align-items:center;justify-content:center;font-size:24px;">🏷️</div>'}
//               <div style="flex:1;min-width:0;">
//                 <div style="font-weight:700;color:#111;font-size:14px;margin-bottom:2px;">
//                   ${p.title}${varTitle ? ` <span style="font-size:12px;color:#6b7280;font-weight:400;">— ${varTitle}</span>` : ''}
//                 </div>
//                 <div style="font-size:12px;color:#6b7280;margin-bottom:3px;">SKU: ${sku} | ${ml} | ${pres}</div>
//                 <div style="font-size:11px;color:#9ca3af;">Collection: ${collection} | Coefficient: ${coeff}</div>
//               </div>
//               <div style="text-align:right;flex-shrink:0;">
//                 <div style="font-size:16px;font-weight:700;color:#16a34a;">$${realPrice.toFixed(2)}</div>
//               </div>
//             </div>`;
//         });

//         // ── Paginación P2 ──
//         const P2_PAGE_SIZE = 5;
//         let p2CurrentPage  = 0;
//         const p2TotalPages = Math.ceil(p2Cards.length / P2_PAGE_SIZE);

//         function renderP2Page() {
//           const start     = p2CurrentPage * P2_PAGE_SIZE;
//           const end       = start + P2_PAGE_SIZE;
//           const pageItems = p2Cards.slice(start, end);
//           const total     = p2Cards.length;

//           const paginationHTML = total > P2_PAGE_SIZE ? `
//             <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding:10px 0;border-top:1px solid #e5e7eb;">
//               <button type="button" onclick="window._p2Prev()"
//                 style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
//                   background:${p2CurrentPage === 0 ? '#f3f4f6' : '#b8a77d'};
//                   color:${p2CurrentPage === 0 ? '#9ca3af' : '#fff'};
//                   font-size:14px;cursor:${p2CurrentPage === 0 ? 'not-allowed' : 'pointer'};
//                   font-family:'Crimson Pro',serif;font-weight:600;">
//                 ← Prev
//               </button>
//               <span style="font-size:13px;color:#6b7280;">
//                 ${start + 1}–${Math.min(end, total)} of ${total} products
//               </span>
//               <button type="button" onclick="window._p2Next()"
//                 style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
//                   background:${p2CurrentPage >= p2TotalPages - 1 ? '#f3f4f6' : '#b8a77d'};
//                   color:${p2CurrentPage >= p2TotalPages - 1 ? '#9ca3af' : '#fff'};
//                   font-size:14px;cursor:${p2CurrentPage >= p2TotalPages - 1 ? 'not-allowed' : 'pointer'};
//                   font-family:'Crimson Pro',serif;font-weight:600;">
//                 Next →
//               </button>
//             </div>` : '';

//           const container = document.getElementById('p2-products-container');
//           if (container) container.innerHTML = pageItems.join('') + paginationHTML;
//         }

//         window._p2Prev = () => {
//           if (p2CurrentPage > 0) { p2CurrentPage--; renderP2Page(); }
//         };
//         window._p2Next = () => {
//           if (p2CurrentPage < p2TotalPages - 1) { p2CurrentPage++; renderP2Page(); }
//         };

//         incentivesList.innerHTML = `
//           <div style="background:#fff;border-radius:12px;padding:16px;margin-bottom:12px;">
//             <p style="margin:0 0 8px;font-size:18px;color:#1f2937;line-height:1.6;">
//               Spend <strong style="color:#000;">$${minAmount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong> or more and receive a credit worth
//                <strong style="color:#000;font-size:18px;">${discPct}%</strong>
//                 of your purchase, redeemable on the selected products below.
//             </p>
//             <div style="background:#fff;border-left:4px solid #f59e0b;padding:10px 12px;margin-top:10px;border-radius:6px;">
//               <p style="margin:0;font-size:16px;color:#78350f;font-weight:600;">
//                 ⚠ Credits must be used on the same day of purchase and cannot be transferred or accumulated for future orders.
//               </p>
//             </div>
//           </div>
//           <div style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:14px;">
//             <h4 style="margin:0 0 12px;font-size:15px;font-weight:700;color:#111;">
             
//             </h4>
//             <div id="p2-products-container" style="display:flex;flex-direction:column;gap:10px;"></div>
//           </div>`;

//         renderP2Page();

//       } else {
//         // ════════════════════════════════════
//         //  PRIORIDAD 1
//         // ════════════════════════════════════
//         const hasVariantIncentives = variantRows().some(row => {
//           const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId] || {};
//           return variantHasIncentive(extras);
//         });

//         if (!hasVariantIncentives && !rules.length) {
//           incentivesSection.style.display = 'none';
//         } else {
//           incentivesSection.style.display = 'block';
//           incentivesList.innerHTML = '<p style="text-align:center;color:#6b7280;padding:12px;">Loading...</p>';

//           const allFPs = {};
//           rules.forEach((rule, ri) => {
//             rule._cacheKey = 'rule_' + ri;
//             (rule.free_products || []).forEach(fp => { if (fp?.handle) allFPs[fp.handle] = fp; });
//             (rule.free_testers  || []).forEach(tp => { if (tp?.handle) allFPs[tp.handle] = tp; });
//           });

//           const productDataMap = {};
//           await Promise.all(Object.keys(allFPs).map(async handle => {
//             if (productDataMap[handle]) return;
//             try { const res = await fetch(`/products/${handle}.js`); if (res.ok) productDataMap[handle] = await res.json(); } catch {}
//           }));

//           const cache = {};
//           rules.forEach(rule => {
//             const mapItem = fp => {
//               const pd    = productDataMap[fp.handle];
//               const image = fp.image || (pd?.featured_image ? pd.featured_image.replace(/^\/\//, 'https://') : '');
//               return { title: fp.title, variant_title: fp.variant_title || '', image };
//             };
//             cache[rule._cacheKey] = {
//               products: (rule.free_products || []).map(mapItem),
//               testers:  (rule.free_testers  || []).map(mapItem)
//             };
//           });

//           // ── Collection rules HTML ──
//           const collectionRulesHTML = rules.map((rule, idx) => {
//             const minQ = Number(rule.min_qty || 0), minV = Number(rule.min_order_value || 0), disc = Number(rule.discount || 0);
//             const auto = isAutoApply(rule);
//             const condParts = [];
//             if (minQ > 0) condParts.push(`<strong>${minQ} units</strong>`);
//             if (minV > 0) condParts.push(`<strong>$${minV.toLocaleString()}</strong>`);
//             const condSentence  = condParts.length ? 'When ordering at least ' + condParts.join(' and ') : '';
//             const rewardParts   = [];
//             if (Array.isArray(rule.free_testers) && rule.free_testers.length) {
//               rule.free_testers.forEach((tp, i) => { if (tp?.title) rewardParts.push(`<strong>${getTesterQty(rule, i)}x tester:</strong> ${tp.title}`); });
//             } else {
//               const tot = normalizeQtyArray(rule.testers_qty).reduce((s, q) => s + q, 0);
//               if (tot > 0) rewardParts.push(`<strong>${tot} tester${tot > 1 ? 's' : ''}</strong>`);
//             }
//             if (disc > 0) rewardParts.push(`<strong>${disc}% discount</strong>`);
//             (rule.free_products || []).forEach((fp, i) => {
//               if (!fp?.title) return;
//               const dName = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? `${fp.title} — ${fp.variant_title}` : fp.title;
//               rewardParts.push(`<strong>${normalizeQtyArray(rule.free_product_quantities)[i] || 1}x free:</strong> ${dName}`);
//             });
//             const sep            = auto ? ' + ' : ' <em>or</em> ';
//             const rewardSentence = rewardParts.length ? ', ' + (auto ? 'you receive: ' : 'choose one: ') + rewardParts.join(sep) : '';
//             const applyBadge     = auto
//               ? '<span style="display:inline-block;background:#dcfce7;color:#166534;font-size:11px;font-weight:700;padding:2px 8px;border-radius:12px;margin-left:8px;">Auto</span>'
//               : '<span style="display:inline-block;background:#fef9c3;color:#92400e;font-size:11px;font-weight:700;padding:2px 8px;border-radius:12px;margin-left:8px;">Choose reward</span>';
//             let freeImgsRow = '';
//             const cd = cache[rule._cacheKey];
//             if (cd) {
//               const makeCard = (item, qty, badge) => {
//                 const imgTag  = item.image ? `<img src="${item.image}" style="width:72px;height:72px;object-fit:cover;border-radius:10px;border:1px solid #e5e7eb;" onerror="this.style.display='none'">` : '<div style="width:72px;height:72px;border-radius:10px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:28px;"></div>';
//                 const badgeEl = `<span style="display:inline-block;background:#dcfce7;color:#166534;font-size:11px;font-weight:700;padding:1px 7px;border-radius:10px;margin-bottom:2px;">${qty}x ${badge}</span>`;
//                 const dName   = item.variant_title && item.variant_title.toLowerCase() !== 'default title' ? `${item.title}<br><span style="font-size:10px;color:#6b7280;font-weight:400;">${item.variant_title}</span>` : item.title;
//                 return `<div style="display:flex;flex-direction:column;align-items:center;gap:4px;text-align:center;max-width:90px;">${imgTag}${badgeEl}<span style="font-size:12px;color:#111;font-weight:600;line-height:1.3;">${dName}</span></div>`;
//               };
//               const allCards = [
//                 ...(cd.testers  || []).map((t, i) => makeCard(t, getTesterQty(rule, i), 'tester')),
//                 ...(cd.products || []).map((p, i) => makeCard(p, normalizeQtyArray(rule.free_product_quantities)[i] || 1, 'free'))
//               ];
//               if (allCards.length) freeImgsRow = `<div style="display:flex;flex-wrap:wrap;gap:16px;margin-top:12px;">${allCards.join('')}</div>`;
//             }
//             return `<div style="background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:14px 16px;${idx < rules.length - 1 ? 'margin-bottom:10px;' : ''}">
//               <p style="margin:0;font-size:15px;color:#111;line-height:1.7;">${condSentence}${rewardSentence}${applyBadge}</p>
//               ${freeImgsRow}
//             </div>`;
//           }).join('');

//           // ── Acordeón por variante ──
//           // ── Acordeón por variante ──
//             const variantAccordions = [];
//             variantRows().forEach(row => {
//               const vid    = row.dataset.variantId;
//               const extras = window.b2bVariantExtrasMap?.[vid] || {};
//               if (!variantHasIncentive(extras)) return;

//               const pName  = row.cells[5]?.textContent?.trim() || '';
//               const ml     = row.cells[7]?.textContent?.trim() || '';
//               const imgUrl = row.dataset.imgUrl || '';
//               const fps    = getVariantFreeProducts(extras);
//               const fqs    = getVariantFreeQtys(extras);
//               const { minU, minV } = getVariantThresholds(extras);

//               const condParts = [];
//               if (minU > 0) condParts.push(`<strong>${minU} units</strong>`);
//               if (minV > 0) condParts.push(`<strong>$${Number(minV).toLocaleString()}</strong>`);
//               const condText = condParts.length ? 'Buy ' + condParts.join(' and ') : '';

//               // ── Construir purchaseToGwp para este variante ──
//               const purchaseToGwpAcc = fps.map((fp, fi) => {
//                 const fpImg2 = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//                 const vid2   = String(fp.variant_id || '');
//                 const vd2    = window.b2bAllVariantsMap?.[vid2] || {};
//                 const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
//                 const ml2    = vd2.ml || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
//                 const pres2  = ex2.presentation || vd2.pres || '—';
//                 const pack2  = ex2.quantity > 0 ? ex2.quantity : '—';
//                 const qty2   = fqs[fi] || 1;
//                 return { fpImg: fpImg2, title: fp.title, ml: ml2, pres: pres2, pack: pack2, qty: qty2 };
//               });

//               const minUVal    = minU || '?';
//               const arrowColors = ['#22c55e','#ec4899','#f59e0b','#3b82f6'];

//               // ── EXAMPLES ──
//               const examplesAccHTML = `
//                 <div style="margin-bottom:20px;">
//                   <div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
//                     <span style="font-size:16px;">⭐</span>
//                     <span style="font-size:16px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Examples</span>
//                   </div>
//                   <div style="display:flex;flex-wrap:wrap;gap:10px;">
//                     ${purchaseToGwpAcc.map(item => `
//                       <div style="display:flex;align-items:center;gap:0;border-radius:14px;overflow:hidden;border:1px solid #e5e7eb;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,0.06);flex:1;min-width:200px;max-width:360px;">
//                         <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:12px 8px;text-align:center;flex:1;">
//                           ${imgUrl
//                             ? `<img src="${imgUrl}" style="width:80px;height:110px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;">`
//                             : `<div style="width:44px;height:44px;border-radius:8px;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-size:20px;">🛍️</div>`}
//                           <div style="font-size:16px;font-weight:700;color:#111;">Buy ${minUVal} units</div>
//                           <div style="font-size:14px;font-weight:600;color:#374151;">${pName}</div>
//                         </div>
//                         <div style="display:flex;align-items:center;justify-content:center;width:26px;flex-shrink:0;font-size:16px;font-weight:700;color:#276e31;background:#fff;">=</div>
//                         <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:12px 8px;text-align:center;flex:1;">
//                           ${item.fpImg
//                             ? `<img src="${item.fpImg}" style="width:80px;height:110px;object-fit:cover;border-radius:8px;">`
//                             : `<div style="width:44px;height:44px;border-radius:8px;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>`}
//                           <div style="font-size:12px;font-weight:700;color:#111;"></div>
//                           <div style="font-size:16px;font-weight:700;color:#111;line-height:1.3;">${item.pack} x ${item.title}</div>
//                           <div style="font-size:14px;color:#111;font-family: Crimson pro;">${item.pres} | ${item.ml} | Pack: ${item.qty}</div>
                         
//                         </div>
//                       </div>`).join('')}
//                   </div>
//                 </div>`;

//               // ── CONVERSION EQUIVALENCIES ──
//               const equivAccHTML = `
//                 <div>
//                   <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
//                     <span style="font-size:16px;">⇄</span>
//                     <span style="font-size:16px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Conversion Equivalencies</span>
//                   </div>
//                   <div style="overflow-x:auto;">
//                     <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
//                       <thead>
//                         <tr style="background:#686a6c;color:#fff;">
//                           <th style="padding:8px 12px;text-align:left;font-size:16px;font-weight:600;border-radius:6px 0 0 0;">If You Purchase</th>
//                           <th style="padding:8px 12px;text-align:center;font-size:16px;font-weight:600;">You Can Receive (FOC)</th>
//                           <th style="padding:8px 12px;text-align:center;font-size:16px;font-weight:600;border-radius:0 6px 0 0;">Equivalency (Either Way)</th>
//                         </tr>
//                       </thead>
//                       <tbody>
//                         ${purchaseToGwpAcc.map((item, idx) => `
//                           <tr style="background:${idx % 2 === 0 ? '#fff' : '#f9fafb'};border-bottom:1px solid #e5e7eb;">
//                             <td style="padding:10px 12px;vertical-align:middle;">
//                               <div style="display:flex;align-items:center;gap:8px;">
//                                 ${imgUrl
//                                   ? `<img src="${imgUrl}" style="width:80px;height:110px;object-fit:cover;border-radius:6px;border:1px solid #e5e7eb;flex-shrink:0;">`
//                                   : `<div style="width:34px;height:34px;border-radius:6px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0;">🛍️</div>`}
//                                 <div>
//                                   <div style="font-size:16px;color:#111;">${minUVal} units of</div>
//                                   <div style="font-size:16px;font-weight:700;color:#111;">${pName}</div>
//                                 </div>
//                               </div>
//                             </td>
//                             <td style="padding:10px 12px;text-align:center;vertical-align:middle;">
//                               <div style="display:flex;align-items:center;justify-content:center;gap:8px;">
                                
//                                 <div style="display:flex;flex-direction:column;align-items:center;gap:2px;">
//                                   ${item.fpImg
//                                     ? `<div style="width:80px;height:110px;overflow:hidden;background:#f0fdf4;">
//                                         <img src="${item.fpImg}" style="width:100%;height:100%;object-fit:cover;">
//                                       </div>`
//                                     : `<div style="width:36px;height:36px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;font-size:16px;border:2px solid #bbf7d0;">🎁</div>`}
//                                   <div style="font-size:16px;font-weight:700;color:#111;">${item.pack} x ${item.title}</div>
//                                   <div style="font-size:16px;color:#111;">${item.pres} | ${item.ml} | Pack: ${item.qty}</div>
//                                 </div>
//                               </div>
//                             </td>
//                             <td style="padding:10px 12px;text-align:center;vertical-align:middle;">
//                               <div style="display:flex;align-items:center;justify-content:center;gap:6px;">
                                
//                                 <div style="font-size:14px;color:#111;text-align:left;">
//                                   <div style="font-size:16px;font-weight:700;">${item.pack} ${item.pres} ${item.ml} = ${minU} units ${item.title} </div>
                                  
//                                 </div>
//                               </div>
//                             </td>
//                           </tr>`).join('')}
//                       </tbody>
//                     </table>
//                   </div>
//                 </div>`;

//               const aId = `vacc-${vid}`;
//               variantAccordions.push(`
//                 <div style="border:1px solid #e5e7eb;border-radius:10px;margin-bottom:8px;overflow:hidden;background:#fff;">
//                   <button type="button" onclick="
//                     var p=document.getElementById('${aId}');
//                     var a=document.getElementById('aarr-${aId}');
//                     var o=p.style.display!=='none';
//                     p.style.display=o?'none':'block';
//                     a.style.transform=o?'rotate(0deg)':'rotate(180deg)';
//                   " style="width:100%;display:flex;align-items:center;gap:12px;padding:12px 14px;background:#fff;border:none;cursor:pointer;text-align:left;">
//                     ${imgUrl
//                       ? `<img src="${imgUrl}" style="width:46px;height:46px;object-fit:cover;border-radius:8px;flex-shrink:0;">`
//                       : '<div style="width:46px;height:46px;border-radius:8px;background:#f3f4f6;flex-shrink:0;"></div>'}
//                     <div style="flex:1;min-width:0;">
//                       <div style="font-size:15px;font-weight:700;color:#111;">
//                         ${pName} <span style="font-size:13px;color:#6b7280;font-weight:400;">— ${ml}</span>
//                       </div>
//                       <div style="font-size:14px;color:#111;margin-top:2px;font-family:'Crimson Pro',serif;">
//                         ${condText} — choose 1 of ${fps.length} product${fps.length > 1 ? 's' : ''} for free
//                       </div>
//                     </div>
//                     <svg id="aarr-${aId}" width="18" height="18" viewBox="0 0 16 16"
//                       style="flex-shrink:0;transition:transform 0.25s;color:#9ca3af;">
//                       <polyline points="4,6 8,10 12,6" stroke="currentColor" stroke-width="2"
//                         fill="none" stroke-linecap="round" stroke-linejoin="round"/>
//                     </svg>
//                   </button>
//                   <div id="${aId}" style="display:none;padding:14px;background:#fafafa;">
//                     ${examplesAccHTML}
//                     ${equivAccHTML}
//                   </div>
//                 </div>`);
//             });

//           // ── Texto introductorio ──
//           const introHTML = `
//             <div style="margin-bottom:5px;margin:0px font-family:'Crimson Pro',serif;background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:15px 16px;font-size:17px;color:#374151;line-height:1.6;">
//               <p style="margin:0px">For this brand, rewards are based on purchase volume.</p>
//               <p style="margin:0px">By purchasing the eligible quantities, you can receive one of the selected products for free as part of the promotion.</p>
//               <p style="margin:0px">Below you will find the list of available reward options.</p>
//               </div>`;
              
//               // <p style="margin:0;font-size:15px;color:#6b7280;">Note: Promotions may apply individually to each product.</p>
//           // ── Paginación P1 ──
//           const PAGE_SIZE  = 5;
//           let currentPage  = 0;
//           const totalPages = Math.ceil(variantAccordions.length / PAGE_SIZE);

//           function renderAccordionPage() {
//             const start     = currentPage * PAGE_SIZE;
//             const end       = start + PAGE_SIZE;
//             const pageItems = variantAccordions.slice(start, end);
//             const total     = variantAccordions.length;

//             const paginationHTML = total > PAGE_SIZE ? `
//               <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding:10px 0;border-top:1px solid #e5e7eb;">
//                 <button type="button" onclick="window._accPrev()"
//                   style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
//                     background:${currentPage === 0 ? '#f3f4f6' : '#b8a77d'};
//                     color:${currentPage === 0 ? '#9ca3af' : '#fff'};
//                     font-size:14px;cursor:${currentPage === 0 ? 'not-allowed' : 'pointer'};
//                     font-family:'Crimson Pro',serif;font-weight:600;">
//                   ← Prev
//                 </button>
//                 <span style="font-size:13px;color:#6b7280;">
//                   ${start + 1}–${Math.min(end, total)} of ${total} products
//                 </span>
//                 <button type="button" onclick="window._accNext()"
//                   style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
//                     background:${currentPage >= totalPages - 1 ? '#f3f4f6' : '#b8a77d'};
//                     color:${currentPage >= totalPages - 1 ? '#9ca3af' : '#fff'};
//                     font-size:14px;cursor:${currentPage >= totalPages - 1 ? 'not-allowed' : 'pointer'};
//                     font-family:'Crimson Pro',serif;font-weight:600;">
//                   Next →
//                 </button>
//               </div>` : '';

//             const container = document.getElementById('acc-page-container');
//             if (container) container.innerHTML = pageItems.join('') + paginationHTML;
//           }

//           window._accPrev = () => {
//             if (currentPage > 0) { currentPage--; renderAccordionPage(); }
//           };
//           window._accNext = () => {
//             if (currentPage < totalPages - 1) { currentPage++; renderAccordionPage(); }
//           };

//           // ── Combinar todo ──
//           incentivesList.innerHTML =
//             introHTML +
//             (variantAccordions.length
//               ? `<div style="margin-bottom:${collectionRulesHTML ? '16px' : '0'};">
//                   <div id="acc-page-container"></div>
//                 </div>`
//               : '') +
//             (collectionRulesHTML
//               ? (variantAccordions.length
//                   ? `<div style="border-top:1px solid #e5e7eb;padding-top:16px;">${collectionRulesHTML}</div>`
//                   : collectionRulesHTML)
//               : '');

//           if (variantAccordions.length) renderAccordionPage();
//         }
//       }

//       // ── Botones exportación ──
//       const expExcel = getEl('guidelines-export-excel-btn');
//       const expPdf   = getEl('guidelines-export-pdf-btn');
//       if (expExcel) {
//         expExcel.onclick = () => exportGuidelines('excel');
//         expExcel.style.display = (typeof XLSX !== 'undefined') ? '' : 'none';
//       }
//       if (expPdf) {
//         expPdf.onclick = () => exportGuidelines('pdf');
//         expPdf.style.display = (window.jspdf) ? '' : 'none';
//       }
//        const expSend = getEl('guidelines-export-send-btn');
//       if (expSend) expSend.style.display = '';
//       getEl('conditions-modal').style.display = 'flex';
//     });
//   }
// /* ============================================================
//    LISTENERS GLOBALES
//    ============================================================ */

// function initGlobalListeners() {
//   const modalPairs = [
//     ['brand-min-qty-modal-close', 'brand-min-qty-modal'],
//     ['brand-min-qty-overlay',     'brand-min-qty-modal'],
//     ['brand-min-value-modal-close','brand-min-value-modal'],
//     ['brand-min-value-overlay',   'brand-min-value-modal'],
//     ['min-qty-modal-close',       'min-qty-modal'],
//     ['min-qty-overlay',           'min-qty-modal'],
//     ['conditions-modal-close',    'conditions-modal'],
//     ['conditions-modal-ok',       'conditions-modal'],
//     ['conditions-overlay',        'conditions-modal'],
//     ['reward-choice-close',       'reward-choice-modal'],
//     ['reward-choice-overlay',     'reward-choice-modal'],
//     ['sell-limit-modal-close',    'sell-limit-modal'],   
//     ['sell-limit-overlay',        'sell-limit-modal'], 
//   ];
//   modalPairs.forEach(([triggerId, modalId]) => {
//     getEl(triggerId)?.addEventListener('click', () => {
//       const el = getEl(modalId);
//       if (el) el.style.display = 'none';
//       document.body.style.overflow = '';
//     });
//   });

//   getEl('reward-choice-confirm')?.addEventListener('click', async () => {
//     const rule = rewardChoice.active;
//     if (!rule) return;
//     const chosen = rewardChoice.chosenType;
//     if (!chosen) { alert('Please select one reward option.'); return; }

//     if (chosen === 'product' || chosen === 'tester') {
//       if (!rewardChoice.chosenVariantId) {
//         const handle = rewardChoice.chosenProductHandle;
//         if (handle) {
//           const v = await fetchFreeGiftVariant(handle, chosen);
//           if (v) rewardChoice.chosenVariantId = String(v.id);
//         }
//         if (!rewardChoice.chosenVariantId && rewardChoice.chosenProductTitle) {
//           try {
//             const res = await fetch('/collections/' + getColHandle() + '/products.json?limit=250');
//             if (res.ok) {
//               const data  = await res.json();
//               const match = (data.products || []).find(p => p.title.trim().toLowerCase() === rewardChoice.chosenProductTitle.trim().toLowerCase());
//               if (match) {
//                 const v = chosen === 'tester' ? (match.variants.find(v => v.available) || match.variants[0]) : (match.variants.find(v => parseFloat(v.price) === 0) || match.variants[0]);
//                 if (v) { rewardChoice.chosenProductHandle = match.handle; rewardChoice.chosenVariantId = String(v.id); }
//               }
//             }
//           } catch {}
//         }
//       }
//       if (!rewardChoice.chosenVariantId) {
//         alert('Could not find variant for: ' + (rewardChoice.chosenProductTitle || 'the selected product') + '. Please contact support.');
//         return;
//       }
//     }

//     rewardChoice.discountPct = chosen === 'discount' ? Number(rule.discount || 0) : 0;
//     rewardChoice.confirmed   = true;
//     closeRewardChoiceModal();
//     updateIncentiveBanners();
//     if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
//   });

//   getEl('variant-reward-close')?.addEventListener('click', closeVariantRewardModal);
//   getEl('variant-reward-overlay')?.addEventListener('click', closeVariantRewardModal);
//   getEl('b2b-choose-reward-btn')?.addEventListener('click', openRewardChoiceModal);
//   getEl('b2b-buy-btn')?.addEventListener('click', handleBuyNow);
//   getEl('b2b-buy-now-bottom')?.addEventListener('click', handleBuyNow);

//   initDetailsPanel();


//   // ── Pre Order Share btn ──
//  getEl('preorder-share-btn-panel')?.addEventListener('click', () => {
//   getEl('catalog-download-btns')?.remove();
//   getEl('incentives-download-btns')?.remove();
//   getEl('preorder-download-btns')?.remove();
//   document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

//   const modeEl        = getEl('send-modal-mode');
//   const titleEl       = getEl('send-modal-title');
//   const formatSection = getEl('send-format-section');

//   if (modeEl)        modeEl.value       = 'preorder';
//   if (titleEl)       titleEl.textContent = 'Share Pre Order';
//   if (formatSection) formatSection.style.display = '';

//   const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
//   if (excelRadio) excelRadio.checked = true;

//   const dlBtns = document.createElement('div');
//   dlBtns.id = 'preorder-download-btns';
//   dlBtns.innerHTML = `
//     <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
//       <div style="width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//           <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
//           <polyline points="7 10 12 15 17 10"/>
//           <line x1="12" y1="15" x2="12" y2="3"/>
//         </svg>
//       </div>
//       <div>
//         <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Pre Order</div>
//         <div style="font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
//       </div>
//     </div>
//     <div style="display:flex;gap:12px;margin-bottom:12px;">
//       <button type="button" id="preorder-dl-excel"
//         style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
//         <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
//         <div style="text-align:left;">
//           <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
//           <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
//         </div>
//       </button>
//       <button type="button" id="preorder-dl-pdf"
//         style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
//         <img src="${window._b2bPdfIconUrl}" width="32" height="28" alt="PDF">
//         <div style="text-align:left;">
//           <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
//           <div style="font-size:12px;color:#6b7280;">.pdf format</div>
//         </div>
//       </button>
//     </div>
//     <div style="text-align:center;margin-bottom:16px;">
//       <span style="font-family:'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:14px;color:#b8a77d;font-weight:600;">
//         Instant download – No email required
//       </span>
//     </div>
//     <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//       <span style="font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//     </div>
//     <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
//       <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//           <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
//           <polyline points="22,6 12,13 2,6"/>
//         </svg>
//       </div>
//       <div>
//         <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Pre Order by Email</div>
//         <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
//       </div>
//     </div>`;

//   const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
//   const firstLabel     = sendModalInner?.querySelector('label');
//   if (firstLabel) firstLabel.parentNode.insertBefore(dlBtns, firstLabel);

//   getEl('preorder-dl-excel')?.addEventListener('click', async () => {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generatePreOrderExcelBase64();
//     if (!base64) return;
//     const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement('a');
//     a.href = url; a.download = `pre-order-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
//     a.click(); URL.revokeObjectURL(url);
//   });

//   getEl('preorder-dl-pdf')?.addEventListener('click', async () => {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generatePreOrderPdfBase64();
//     if (!base64) return;
//     const blob = base64toBlob(base64, 'application/pdf');
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement('a');
//     a.href = url; a.download = `pre-order-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
//     a.click(); URL.revokeObjectURL(url);
//   });

//   const modal = getEl('send-modal');
//   if (modal) modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// });

// getEl('catalog-share-btn')?.addEventListener('click', () => {
//   // Limpiar botones anteriores
//   getEl('catalog-download-btns')?.remove();
//   getEl('incentives-download-btns')?.remove();
//   getEl('preorder-download-btns')?.remove();
//   document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

//   const modeEl        = getEl('send-modal-mode');
//   const titleEl       = getEl('send-modal-title');
//   const formatSection = getEl('send-format-section');

//   if (modeEl)        modeEl.value       = 'catalog';
//   if (titleEl)       titleEl.textContent = 'Product List';
//   if (formatSection) formatSection.style.display = '';

//   const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
//   if (excelRadio) excelRadio.checked = true;

//   const downloadBtns = document.createElement('div');
//   downloadBtns.id = 'catalog-download-btns';
//   downloadBtns.innerHTML = `
//     <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
//       <div style="width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//           <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
//           <polyline points="7 10 12 15 17 10"/>
//           <line x1="12" y1="15" x2="12" y2="3"/>
//         </svg>
//       </div>
//       <div>
//         <div style="font-family:'Crimson Pro';font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Product List</div>
//         <div style="font-family:'Crimson Pro';font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
//       </div>
//     </div>
//     <div style="display:flex;gap:12px;margin-bottom:12px;">
//       <button type="button" id="catalog-dl-excel"
//         style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
//         <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
//         <div style="text-align:left;">
//           <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
//           <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
//         </div>
//       </button>
//       <button type="button" id="catalog-dl-pdf"
//         style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
//         <img src="${window._b2bPdfIconUrl}" width="40" height="30" alt="PDF">
//         <div style="text-align:left;">
//           <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
//           <div style="font-size:12px;color:#6b7280;">.pdf format</div>
//         </div>
//       </button>
//     </div>
//     <div style="text-align:center;margin-bottom:16px;">
//       <span style="font-family:'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:14px;color:#b8a77d;font-weight:600;">
//         Instant download – No email required
//       </span>
//     </div>
//     <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//       <span style="font-family:'Crimson Pro';font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//     </div>
//     <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
//       <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//           <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
//           <polyline points="22,6 12,13 2,6"/>
//         </svg>
//       </div>
//       <div>
//         <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Product List by Email</div>
//         <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
//       </div>
//     </div>`;

//   const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
//   const firstLabel     = sendModalInner?.querySelector('label');
//   if (firstLabel) firstLabel.parentNode.insertBefore(downloadBtns, firstLabel);

//   getEl('catalog-dl-excel')?.addEventListener('click', async () => {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generateCatalogBase64();
//     if (!base64) return;
//     const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement('a');
//     a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
//     a.click(); URL.revokeObjectURL(url);
//   });

//   getEl('catalog-dl-pdf')?.addEventListener('click', async () => {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generateCatalogPdfBase64();
//     if (!base64) return;
//     const blob = base64toBlob(base64, 'application/pdf');
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement('a');
//     a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
//     a.click(); URL.revokeObjectURL(url);
//   });

//   const modal = getEl('send-modal');
//   if (modal) modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// });


// // getEl('header-dl-excel')?.addEventListener('click', async () => {
// //   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
// //   const base64 = await generateCatalogBase64();
// //   if (!base64) return;
// //   const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
// //   const url  = URL.createObjectURL(blob);
// //   const a    = document.createElement('a');
// //   a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
// //   a.click(); URL.revokeObjectURL(url);
// // });

// // getEl('header-dl-pdf')?.addEventListener('click', async () => {
// //   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
// //   const base64 = await generateCatalogPdfBase64();
// //   if (!base64) return;
// //   const blob = base64toBlob(base64, 'application/pdf');
// //   const url  = URL.createObjectURL(blob);
// //   const a    = document.createElement('a');
// //   a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
// //   a.click(); URL.revokeObjectURL(url);
// // });

// function setIconBtnLoading(btn, loading) {
//   if (!btn) return;
//   const img     = btn.querySelector('.b2b-icon-btn-img');
//   const spinner = btn.querySelector('.b2b-icon-btn-spinner');
//   btn.classList.toggle('is-loading', loading);
//   if (img)     img.style.display     = loading ? 'none'  : '';
//   if (spinner) spinner.style.display = loading ? 'block' : 'none';
// }

// getEl('header-dl-excel')?.addEventListener('click', async function() {
//   const btn = this;
//   if (btn.classList.contains('is-loading')) return;
//   setIconBtnLoading(btn, true);
//   try {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generateCatalogBase64();
//     if (base64) {
//       const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//       const url  = URL.createObjectURL(blob);
//       const a    = document.createElement('a');
//       a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
//       a.click(); URL.revokeObjectURL(url);
//     }
//   } catch (err) {
//     console.error('Error generating Excel:', err);
//   } finally {
//     setIconBtnLoading(btn, false);
//   }
// });

// getEl('header-dl-pdf')?.addEventListener('click', async function() {
//   const btn = this;
//   if (btn.classList.contains('is-loading')) return;
//   setIconBtnLoading(btn, true);
//   try {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generateCatalogPdfBase64();
//     if (base64) {
//       const blob = base64toBlob(base64, 'application/pdf');
//       const url  = URL.createObjectURL(blob);
//       const a    = document.createElement('a');
//       a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
//       a.click(); URL.revokeObjectURL(url);
//     }
//   } catch (err) {
//     console.error('Error generating PDF:', err);
//   } finally {
//     setIconBtnLoading(btn, false);
//   }
// });

//   document.addEventListener('click', e => {
//     if (e.target.matches('.quickview-trigger')) {
//       e.preventDefault();
//       const handle = e.target.dataset.handle;
//       if (!handle) return;
//       const modal = getEl('quickview-modal'), body = getEl('quickview-body');
//       body.innerHTML = '<p style="text-align:center;padding:60px 0;">Loading product...</p>';
//       modal.style.display = 'flex';
//       fetch(`/products/${handle}.js`)
//         .then(r => { if (!r.ok) throw new Error('Not found'); return r.json(); })
//         .then(product => {
//           const price = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(product.price / 100);
//           body.innerHTML = `<div class="quickview-header"><h2>${product.title}</h2></div><div class="quickview-info"><div class="price">${price}</div><div>${product.description || ''}</div></div>`;
//         })
//         .catch(err => { body.innerHTML = `<p style="color:#c53030;text-align:center;padding:60px 0;">${err.message}</p>`; });
//     }
//     if (e.target.matches('.quickview-close') || e.target.matches('.quickview-overlay')) {
//       getEl('quickview-modal').style.display = 'none';
//     }
//   });

//   document.addEventListener('keydown', e => {
//     if (e.key !== 'Escape') return;
//     ['sku-detail-modal','min-qty-modal','brand-min-qty-modal','brand-min-value-modal',
//      'conditions-modal','reward-choice-modal','variant-reward-modal'].forEach(id => {
//       const el = getEl(id);
//       if (el) el.style.display = 'none';
//     });
//     document.body.style.overflow = '';
//   });

//   const excelBtn = getEl('export-excel-btn');
//   const excelTip = getEl('excel-tooltip');
//   const MODAL_IDS = ['sku-detail-modal','conditions-modal','reward-choice-modal',
//     'variant-reward-modal','min-qty-modal','brand-min-qty-modal','brand-min-value-modal'];
//   if (excelBtn && excelTip) {
//     excelBtn.addEventListener('mouseenter', () => {
//       const anyOpen = MODAL_IDS.some(id => getEl(id)?.style.display === 'flex');
//       if (!anyOpen) excelTip.style.display = 'block';
//     });
//     excelBtn.addEventListener('mouseleave', () => { excelTip.style.display = 'none'; });
//   }

//   const pdfBtn = getEl('export-pdf-btn');
//   const pdfTip = getEl('pdf-tooltip');
//   if (pdfBtn && pdfTip) {
//     pdfBtn.addEventListener('mouseenter', () => {
//       const anyOpen = MODAL_IDS.some(id => getEl(id)?.style.display === 'flex');
//       if (!anyOpen) pdfTip.style.display = 'block';
//     });
//     pdfBtn.addEventListener('mouseleave', () => { pdfTip.style.display = 'none'; });
//   }

//     // Al final de initGlobalListeners(), antes del cierre
//     getEl('reset-btn')?.addEventListener('click', () => {
//       // Limpiar cantidades visuales
//       variantRows().forEach(row => {
//         const stepVal = row.querySelector('.step-value');
//         const hidQty  = row.querySelector('.hidden-qty');
//         const total   = row.querySelector('.b2b-row-total');
//         const badge   = row.querySelector('.qty-badge');
//         const plus    = row.querySelector('.step-plus');
//         const minus   = row.querySelector('.step-minus');
//         const stock   = parseInt(row.dataset.stock || 0);

//         if (stepVal) stepVal.textContent = '0';
//         if (hidQty)  hidQty.value = '0';
//         if (total)   total.textContent = '0.00';
//         if (badge)   { badge.textContent = '0'; badge.style.display = 'none'; }
//         if (plus)    plus.disabled  = stock <= 0;
//         if (minus)   minus.disabled = true;
//         row.style.display = '';
//       });

//       // Limpiar combos multiselect
//       B2B_COMBOS.forEach(combo => {
//         Array.from(combo.select.options).forEach(o => o.selected = false);
//         combo._updateLabel();
//       });

//       // Limpiar search
//       const searchInput = getEl('b2b-search-input');
//       const clearBtn    = getEl('b2b-search-clear');
//       if (searchInput) searchInput.value = '';
//       if (clearBtn)    clearBtn.style.display = 'none';

//       // ── Resetear TODOS los estados de incentivos ──
//       window.b2bVariantRewardChoices = {};
//       window.b2bPriority2Choice = { confirmed: false, selections: [], totalSpent: 0, discountPct: 0 };
//       window.b2bPriority3Choice = { confirmed: false, selections: [] };
//       window.b2bVariantRewardChoices = {};
//       window.b2bRewardChoice = {
//         active: null, confirmed: false, chosenType: null,
//         chosenVariantId: null, chosenProductHandle: null,
//         chosenProductTitle: null, chosenProductImage: null,
//         chosenQty: 1, discountPct: 0
//       };

//       b2bApplyFilters();
//       updateTotals();
//     });
// }

// /* ============================================================
//    VIEW TOGGLE (View1 / View2)
//    ============================================================ */

// function initViewToggle() {
//   const btn1 = getEl('view1-btn');
//   const btn2 = getEl('view2-btn');
//   if (!btn1 || !btn2) return;

//   const colsToHide  = [3, 7, 8, 9, 10, 12];
//   const filtersRow  = document.querySelector('.b2b-filters-row');
//   let view2Inserted = false;

//   function applyVisibility(show, table) {
//   const headThs   = Array.from(table.querySelectorAll('thead tr:first-child th'));
//   const filterThs = filtersRow ? Array.from(filtersRow.querySelectorAll('th')) : [];
//   const bodyRows  = Array.from(table.querySelectorAll('tbody tr.b2b-variant-row'));

//   colsToHide.forEach(i => {
//     const disp = show ? '' : 'none';
//     if (headThs[i])   headThs[i].style.display   = disp;
//     if (filterThs[i]) filterThs[i].style.display = disp;
//     bodyRows.forEach(row => {
//       if (row.cells[i]) row.cells[i].style.display = disp;
//     });
//   });

//   // ── INCENTIVES (col 13): visible en Price View, oculta en Score View ──
//   const incentivesDisp = show ? '' : 'none';  // show=true es Price View
//   if (headThs[13])   headThs[13].style.display   = incentivesDisp;
//   if (filterThs[13]) filterThs[13].style.display = incentivesDisp;
//   bodyRows.forEach(row => {
//     if (row.cells[13]) row.cells[13].style.display = incentivesDisp;
//   });
// }

//   function setView(view) {
//     const table    = document.getElementById('ordenesTable');
//     const bodyRows = Array.from(table.querySelectorAll('tbody tr.b2b-variant-row'));

//     if (view === 'view1') {
//        applyVisibility(true, table);
//         table.querySelectorAll('.view2-th').forEach(el => el.remove());
//         if (filtersRow) filtersRow.querySelectorAll('.view2-filter-th').forEach(el => el.remove());
//         bodyRows.forEach(row => row.querySelectorAll('.view2-col').forEach(el => el.remove()));
//         if (filtersRow) filtersRow.style.display = '';
//         view2Inserted = false;

//         // ── Restaurar columna INCENTIVES explícitamente ──
//         const headThs2  = Array.from(table.querySelectorAll('thead tr:first-child th'));
//         const filterThs2 = filtersRow ? Array.from(filtersRow.querySelectorAll('th')) : [];
//         if (headThs2[13])  headThs2[13].style.display  = '';
//         if (filterThs2[13]) filterThs2[13].style.display = '';
//         variantRows().forEach(row => {
//           if (row.cells[13]) row.cells[13].style.display = '';
//         });

//         btn1.style.background = '#b8a77d'; btn1.style.color = '#fff';
//         btn2.style.background = '#afb0b0'; btn2.style.color = '#fff';

//     } else {
//       applyVisibility(false, table);

//       if (!view2Inserted) {
//         const headerRow = table.querySelector('thead tr:first-child');
//         const qtyTh     = headerRow.querySelector('th:nth-last-child(2)');

//         [
//           { html: 'AI Artistic <br> Score',    col: 'combined_score' },
//           { html: 'AI Commercial <br> Score',  col: 'brand_ranking'  },
//           { html: 'AI Combined <br> Score',    col: 'total_score'    }
//         ].forEach(({ html, col }) => {
//           const th = document.createElement('th');
//           th.className = 'b2b-th sortable view2-th';
//           th.dataset.column = col;
//           th.innerHTML = html;
//           th.addEventListener('click', () => {
//             const tbody = document.getElementById('ordenesTable').querySelector('tbody');
//             const rows  = Array.from(tbody.querySelectorAll('tr.b2b-variant-row'));
//             const dir   = th.classList.contains('asc') ? 'desc' : 'asc';
//             document.querySelectorAll('.sortable').forEach(h => h.classList.remove('asc', 'desc'));
//             th.classList.add(dir);
//             rows.sort((a, b) => {
//               const getCellVal = row => {
//                 const c = Array.from(row.querySelectorAll('td.view2-col'));
//                 const idx = col === 'combined_score' ? 0 : col === 'brand_ranking' ? 1 : 2;
//                 return parseFloat(c[idx]?.textContent) || 0;
//               };
//               const aV = getCellVal(a), bV = getCellVal(b);
//               return dir === 'asc' ? aV - bV : bV - aV;
//             });
//             rows.forEach(row => tbody.appendChild(row));
//           });
//           headerRow.insertBefore(th, qtyTh);
//         });

//         if (filtersRow) {
//           const filterQtyTh = filtersRow.querySelector('th:nth-last-child(2)');
//           ['combined_score', 'brand_ranking'].forEach(col => {
//             const th = document.createElement('th');
//             th.className = 'b2b-th view2-filter-th';
//             const uniqueVals = [];
//             Array.from(document.getElementById('ordenesTable').querySelectorAll('tbody tr.b2b-variant-row')).forEach(row => {
//               const handle = row.dataset.handle || '';
//               const notes  = window.b2bNotesMap?.[handle] || {};
//               const val = col === 'combined_score' ? notes.artistic_score : notes.brand_ranking;
//               if (val && !uniqueVals.includes(String(val))) uniqueVals.push(String(val));
//             });
//             uniqueVals.sort((a, b) => parseFloat(a) - parseFloat(b));
//             const label   = col === 'combined_score' ? 'Combined Score' : 'Brand Ranking';
//             const selectId = `b2b-filter-${col}`;
//             th.innerHTML = `
//               <div class="b2b-combo" data-col="${col}" aria-expanded="false">
//                 <select id="${selectId}" multiple>
//                   ${uniqueVals.map(v => `<option value="${v}">${v}</option>`).join('')}
//                 </select>
//                 <button type="button" class="b2b-toggle">
//                   <span class="b2b-label">All</span><span class="b2b-caret">▼</span>
//                 </button>
//                 <div class="b2b-panel">
//                   <input type="text" class="b2b-search" placeholder="Search ${label}...">
//                   <div class="b2b-options"></div>
//                   <div class="b2b-actions">
//                     <button type="button" class="b2b-btn select-all">Select all</button>
//                     <button type="button" class="b2b-btn clear">Clear</button>
//                     <button type="button" class="b2b-btn apply">Apply</button>
//                   </div>
//                 </div>
//               </div>`;
//             const comboRoot = th.querySelector('.b2b-combo');
//             new B2BCombo(comboRoot);
//             comboRoot.querySelector('.apply').addEventListener('click', applyView2Filters);
//             filtersRow.insertBefore(th, filterQtyTh);
//           });

//           const totalScoreTh = document.createElement('th');
//           totalScoreTh.className = 'b2b-th view2-filter-th';
//           const totalScoreVals = [];
//           Array.from(document.getElementById('ordenesTable').querySelectorAll('tbody tr.b2b-variant-row')).forEach(row => {
//             const handle = row.dataset.handle || '';
//             const notes  = window.b2bNotesMap?.[handle] || {};
//             const val = String(notes.combined_score || '');
//             if (val && !totalScoreVals.includes(val)) totalScoreVals.push(val);
//           });
//           totalScoreVals.sort((a, b) => parseFloat(a) - parseFloat(b));
//           totalScoreTh.innerHTML = `
//             <div class="b2b-combo" data-col="total_score" aria-expanded="false">
//               <select id="b2b-filter-total_score" multiple>
//                 ${totalScoreVals.map(v => `<option value="${v}">${v}</option>`).join('')}
//               </select>
//               <button type="button" class="b2b-toggle">
//                 <span class="b2b-label">All</span><span class="b2b-caret">▼</span>
//               </button>
//               <div class="b2b-panel">
//                 <input type="text" class="b2b-search" placeholder="Search Total Score...">
//                 <div class="b2b-options"></div>
//                 <div class="b2b-actions">
//                   <button type="button" class="b2b-btn select-all">Select all</button>
//                   <button type="button" class="b2b-btn clear">Clear</button>
//                   <button type="button" class="b2b-btn apply">Apply</button>
//                 </div>
//               </div>
//             </div>`;
//           const totalScoreComboRoot = totalScoreTh.querySelector('.b2b-combo');
//           new B2BCombo(totalScoreComboRoot);
//           totalScoreComboRoot.querySelector('.apply').addEventListener('click', applyView2Filters);
//           filtersRow.insertBefore(totalScoreTh, filterQtyTh);
//         }

//         bodyRows.forEach(row => {
//           const qtyTd  = row.cells[13];
//           const handle = row.dataset.handle || '';
//           const notes  = window.b2bNotesMap?.[handle] || {};
//           [
//             notes.artistic_score || '—',
//             notes.brand_ranking  || '—',
//             notes.combined_score || '—'
//           ].forEach(val => {
//             const td = document.createElement('td');
//             td.className = 'b2b-td view2-col';
//             td.textContent = val;
//             row.insertBefore(td, qtyTd);
//           });
//         });

//         view2Inserted = true;
//       }

//       if (filtersRow) filtersRow.style.display = '';
//       btn2.style.background = '#b8a77d'; btn2.style.color = '#fff';
//       btn1.style.background = '#afb0b0'; btn1.style.color = '#fff';
//     }
//   }

//   btn1.addEventListener('click', () => setView('view1'));
//   btn2.addEventListener('click', () => setView('view2'));
// }

// function applyView2Filters() {
//   const getSelectedVals = id => {
//     const sel = document.getElementById(id);
//     if (!sel) return [];
//     return Array.from(sel.selectedOptions).map(o => o.value);
//   };
//   const csVals  = getSelectedVals('b2b-filter-combined_score');
//   const brVals  = getSelectedVals('b2b-filter-brand_ranking');
//   const refVals = getSelectedVals('b2b-filter-references');
//   const tsVals  = getSelectedVals('b2b-filter-total_score');

//   document.querySelectorAll('tbody tr.b2b-variant-row').forEach(row => {
//     const cols = Array.from(row.querySelectorAll('td.view2-col'));
//     if (!cols.length) return;
//     const cs  = cols[0]?.textContent?.trim();
//     const br  = cols[1]?.textContent?.trim();
//     const ts  = cols[2]?.textContent?.trim();
//     const handle = row.dataset.handle || '';
//     const notes  = window.b2bNotesMap?.[handle] || {};
//     const ref    = String(notes.references || '');

//     const match =
//       (!csVals.length  || csVals.includes(cs))   &&
//       (!brVals.length  || brVals.includes(br))   &&
//       (!refVals.length || refVals.includes(ref)) &&
//       (!tsVals.length  || tsVals.includes(ts));

//     row.style.display = match ? '' : 'none';
//   });
// }

// /* ============================================================
//    FOOTER PADDING DINÁMICO
//    ============================================================ */

// function initFooterPadding() {
//   const footer  = getEl('b2b-footer');
//   const wrapper = document.querySelector('.b2b-wrapper');
//   if (!footer || !wrapper) return;
//   function applyPadding() { wrapper.style.paddingBottom = footer.offsetHeight + 'px'; }
//   applyPadding();
//   if (window.ResizeObserver) {
//     new ResizeObserver(applyPadding).observe(footer);
//   } else {
//     window.addEventListener('resize', applyPadding);
//   }
// }

// /* ============================================================
//    LOCK / UNLOCK UI
//    ============================================================ */

// function lockUI(mode = 'order') {
//   document.querySelectorAll('.step-btn').forEach(btn => {
//     btn.disabled = true; btn.style.pointerEvents = 'none';
//   });
//   const inputsToDisable = [
//     getEl('b2b-search-input'), getEl('presentation-btn'), getEl('reset-btn'),
//     getEl('conditions-btn'), getEl('export-all-products-btn'), getEl('export-excel-btn'),
//     getEl('export-pdf-btn'), getEl('b2b-view-details-btn'), getEl('b2b-choose-reward-btn'),
//     getEl('view1-btn'), getEl('view2-btn'),
//   ];
//   inputsToDisable.forEach(el => {
//     if (el) { el.disabled = true; el.style.pointerEvents = 'none'; el.style.opacity = '0.5'; }
//   });
//   document.querySelectorAll('.b2b-toggle').forEach(btn => {
//     btn.disabled = true; btn.style.pointerEvents = 'none'; btn.style.opacity = '0.5';
//   });

//   let overlay = getEl('b2b-processing-overlay');
//   if (!overlay) {
//     overlay = document.createElement('div');
//     overlay.id = 'b2b-processing-overlay';
//     overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;cursor:not-allowed;';
//     document.body.appendChild(overlay);
//   }

//   // ── Siempre actualizar el contenido según el modo ──
//   const title    = mode === 'email' ? 'Sending email...'                    : 'Processing your order...';
//   const subtitle = mode === 'email' ? 'Please wait, do not close this page.' : 'Please wait, do not close this page.';

//   overlay.innerHTML = `
//     <div style="background:white;border-radius:16px;padding:32px 48px;text-align:center;box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;">
//       <img src="${(window._b2bLogoUrl || '').replace(/^\/\//, 'https://')}" alt="Logo"
//         style="width:140px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
//         onerror="this.style.display='none'">
//       <div style="font-size:1.6rem;font-weight:700;color:#1f2937;margin-bottom:6px;">${title}</div>
//       <div style="font-size:1.2rem;color:#6b7280;">${subtitle}</div>
//     </div>`;

//   overlay.style.display = 'flex';
  
// }

// function unlockUI() {
//   document.querySelectorAll('.step-btn').forEach(btn => {
//     const row = btn.closest('tr');
//     const stock = parseInt(row?.dataset.stock || 0);
//     if (stock > 0) { btn.disabled = false; btn.style.pointerEvents = ''; }
//   });
//   const inputsToEnable = [
//     getEl('b2b-search-input'), getEl('presentation-btn'), getEl('reset-btn'),
//     getEl('conditions-btn'), getEl('export-all-products-btn'), getEl('export-excel-btn'),
//     getEl('export-pdf-btn'), getEl('b2b-view-details-btn'), getEl('b2b-choose-reward-btn'),
//     getEl('view1-btn'), getEl('view2-btn'),
//   ];
//   inputsToEnable.forEach(el => {
//     if (el) { el.disabled = false; el.style.pointerEvents = ''; el.style.opacity = ''; }
//   });
//   document.querySelectorAll('.b2b-toggle').forEach(btn => {
//     btn.disabled = false; btn.style.pointerEvents = ''; btn.style.opacity = '';
//   });
//   const overlay = getEl('b2b-processing-overlay');
//   if (overlay) overlay.style.display = 'none';
// }



// function openOrderRulesModal(btn) {
//   var vid    = btn.dataset.variantId;
//   var handle = btn.dataset.handle;
//   var row    = document.querySelector('.b2b-variant-row[data-variant-id="' + vid + '"]');
//   var notes  = window.b2bNotesMap?.[handle] || {};
//   var extras = window.b2bVariantExtrasMap?.[vid] || {};

//   // Nombre producto
//   var productName = row ? (row.cells[5]?.textContent?.trim() || handle) : handle;
//   document.getElementById('orm-product-name').textContent = productName;

//   // SKU / Collection / ML
//   var sku  = (row?.dataset?.sku || '').toUpperCase();
//   var coll = row ? (row.cells[4]?.textContent?.trim() || '') : (notes.collection || '');
//   var ml   = row ? (row.cells[7]?.textContent?.trim() || '') : '';
//   document.getElementById('orm-sku').textContent        = sku  ? sku  : '';
//   document.getElementById('orm-collection').textContent = coll ? coll : '';
//   document.getElementById('orm-ml').textContent         = ml   ? ml   : '';
//   document.getElementById('orm-collection-sep').style.display = (sku && coll) ? '' : 'none';
//   document.getElementById('orm-ml-sep').style.display         = (coll && ml)  ? '' : 'none';

//   // Precio wholesale
//   var wholesale = row ? parseFloat(row.dataset.unitPrice || 0) : 0;
//   document.getElementById('orm-wholesale').textContent = wholesale > 0
//     ? '$' + wholesale.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})
//     : '—';

//   // Descripción
//   var desc = row ? (row.dataset.description || 'No description available.') : 'No description available.';
//   document.getElementById('orm-description').textContent = desc;

//   // Notas olfativas
//   var topN    = row ? parseNotes(row.dataset.topNotes)    : (parseNotes(notes.top)    || '—');
//   var middleN = row ? parseNotes(row.dataset.middleNotes) : (parseNotes(notes.middle) || '—');
//   var baseN   = row ? parseNotes(row.dataset.baseNotes)   : (parseNotes(notes.base)   || '—');
//   document.getElementById('orm-top').textContent    = topN    || '—';
//   document.getElementById('orm-middle').textContent = middleN || '—';
//   document.getElementById('orm-base').textContent   = baseN   || '—';

//   // MSRP / Coeff
//   var msrp  = row ? (row.cells[11]?.textContent?.trim() || '—') : '—';
//   var coeff = row ? (row.cells[10]?.textContent?.trim() || '—') : '—';
//   document.getElementById('orm-msrp').textContent  = msrp;
//   document.getElementById('orm-coeff').textContent = coeff;

//   // Incentivos
//   var incSection = document.getElementById('orm-incentives-section');
//   var incBody    = document.getElementById('orm-incentive-body');
//   var incProds   = document.getElementById('orm-incentive-products');
//   var priority   = Number(window.b2bCollectionPriority || 1);

//   if (priority === 2) {
//     var discPct      = parseFloat(window.b2bCollectionDiscount || 0);
//     var minAmount    = parseFloat(window.b2bDiscountMinAmount  || 0);
//     var discProducts = window.b2bDiscountProducts || [];

//     if (discPct > 0 && discProducts.length > 0) {
//       incSection.style.display = 'block';

//       incBody.innerHTML =
//         '<div style="margin-bottom:14px;">'
//         + '<p style="font-size:17px;color:#1f2937;line-height:1.7;margin:0 0 12px 0;">'
//           + 'For purchases of <strong style="color:#000;">$' + minAmount.toLocaleString('en-US', { minimumFractionDigits: 2 }) + '</strong> '
//           + 'or more, you will receive a <strong style="color:#000;">' + discPct + '%</strong> '
//           + 'credit that can be used on selected products.'
//         + '</p>'
//         + '<div style="border-left:5px solid #d97706;padding:12px 15px;border-radius:8px;margin-top:10px;">'
//           + '<p style="margin:0 0 6px 0;font-size:15px;font-weight:700;color:#92400e;">⚠ Important Notice</p>'
//           + '<p style="margin:0;font-size:15px;line-height:1.6;color:#78350f;font-weight:700;">'
//             + 'Credits must be used during the current purchase and cannot be carried over or accumulated for future orders.'
//           + '</p>'
//         + '</div>'
//         + '</div>';

//       // ── Construir filas de tabla ──
//      // ── Construir filas de tabla ──
//       var ormRows = discProducts.map(function(p, ri) {
//         if (!p?.title) return '';
//         var imgSrc    = (p.image || '').replace(/^\/\//, 'https://');
//         var varTitle  = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
//         var vid2      = String(p.variant_id || '');
//         var extras2   = window.b2bVariantExtrasMap?.[vid2] || {};
//         var notes2    = window.b2bNotesMap?.[p.handle]     || {};
//         var varData2  = window.b2bAllVariantsMap?.[vid2]   || {};
//         var tableRow2 = document.querySelector('.b2b-variant-row[data-variant-id="' + vid2 + '"]');
//         var metaPrice = parseFloat(p.incentive_product_price || extras2.incentive_product_price || 0);
//         var realPrice = metaPrice > 0 ? metaPrice : tableRow2 ? parseFloat(tableRow2.dataset.unitPrice || p.price || 0) : parseFloat(p.price || 0);
//         var sku2       = varData2.sku        || (tableRow2 ? (tableRow2.dataset.sku || '').toUpperCase() : '—');
//         var ml2        = varData2.ml         || (tableRow2 ? tableRow2.cells[7]?.textContent?.trim() : '') || varTitle || '—';
//         var pres2      = varData2.pres       || (tableRow2 ? tableRow2.cells[8]?.textContent?.trim() : '') || '—';
//         var collection2= varData2.collection || notes2.collection || (tableRow2 ? tableRow2.cells[4]?.textContent?.trim() : '') || '—';
//         // var coeff2     = varData2.coefficient || notes2.coefficient || (tableRow2 ? tableRow2.cells[10]?.textContent?.trim() : '') || '—';
//         var bgColor    = ri % 2 === 0 ? '#fff' : '#f9fafb';

//         var tdStyle   = 'padding:10px 8px;vertical-align:middle;font-size:13px;color:#374151;text-align:center;max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
//         var tdStyleSm = 'padding:10px 8px;vertical-align:middle;font-size:13px;color:#374151;text-align:center;max-width:70px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

//         return ''
//           + '<tr style="background:' + bgColor + ';border-bottom:1px solid #e5e7eb;">'

//           // Photo
//           + '<td style="padding:10px 8px;text-align:center;vertical-align:middle;width:72px;">'
//           + (imgSrc
//             ? '<img src="' + imgSrc + '" style="width:56px;height:56px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;" onerror="this.style.display=\'none\'">'
//             : '<div style="width:56px;height:56px;border-radius:8px;background:#dbeafe;display:inline-flex;align-items:center;justify-content:center;font-size:20px;margin:0 auto;">🏷️</div>')
//           + '</td>'

//           // Product
//           + '<td style="padding:10px 8px;vertical-align:center;min-width:100px;max-width:150px;">'
//           + '<div style="font-weight:700;color:#111;font-size:16px;white-space:normal;word-break:break-word;">' + p.title + '</div>'
          
//           + '</td>'

//           // SKU
//           + '<td style="' + tdStyle + '" title="' + sku2 + '">' + sku2 + '</td>'

//           // ML
//           + '<td style="' + tdStyleSm + '">' + ml2 + '</td>'

//           // Presentation
//           + '<td style="' + tdStyle + '">' + pres2 + '</td>'

//           // Collection
//           + '<td style="' + tdStyle + ';max-width:130px;" title="' + collection2 + '">' + collection2 + '</td>'

//           // Coefficient
//           // + '<td style="' + tdStyleSm + '">' + coeff2 + '</td>'

//           // Price
//           + '<td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;white-space:nowrap;min-width:70px;">$' + realPrice.toFixed(2) + '</td>'

//           + '</tr>';
//       });

//       // ── Paginación ──
//       var ORM_PAGE_SIZE  = 10;
//       var ormPage        = 0;
//       var ormTotalPages  = Math.ceil(ormRows.length / ORM_PAGE_SIZE);

//       function renderOrmPage() {
//         var start     = ormPage * ORM_PAGE_SIZE;
//         var end       = start + ORM_PAGE_SIZE;
//         var total     = ormRows.length;
//         var pageItems = ormRows.slice(start, end);

//         var tbody = document.getElementById('orm-table-body');
//         if (tbody) tbody.innerHTML = pageItems.join('');

//         var paginationEl = document.getElementById('orm-pagination');
//         if (paginationEl) {
//           paginationEl.innerHTML = total > ORM_PAGE_SIZE
//             ? '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding:10px 0;border-top:1px solid #e5e7eb;">'
//                 + '<button type="button" onclick="window._ormPrev()" style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;background:' + (ormPage === 0 ? '#f3f4f6' : '#b8a77d') + ';color:' + (ormPage === 0 ? '#9ca3af' : '#fff') + ';font-size:14px;cursor:' + (ormPage === 0 ? 'not-allowed' : 'pointer') + ';font-family:\'Crimson Pro\',serif;font-weight:600;">← Prev</button>'
//                 + '<span style="font-size:13px;color:#6b7280;">' + (start + 1) + '–' + Math.min(end, total) + ' of ' + total + ' products</span>'
//                 + '<button type="button" onclick="window._ormNext()" style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;background:' + (ormPage >= ormTotalPages - 1 ? '#f3f4f6' : '#b8a77d') + ';color:' + (ormPage >= ormTotalPages - 1 ? '#9ca3af' : '#fff') + ';font-size:14px;cursor:' + (ormPage >= ormTotalPages - 1 ? 'not-allowed' : 'pointer') + ';font-family:\'Crimson Pro\',serif;font-weight:600;">Next →</button>'
//               + '</div>'
//             : '';
//         }
//       }

//       window._ormPrev = function() { if (ormPage > 0) { ormPage--; renderOrmPage(); } };
//       window._ormNext = function() { if (ormPage < ormTotalPages - 1) { ormPage++; renderOrmPage(); } };

//       incProds.innerHTML =
//         '<div style="overflow-x:auto;margin-top:8px;-webkit-overflow-scrolling:touch;">'
//         + '<table style="width:100%;min-width:600px;border-collapse:collapse;font-family:\'Crimson Pro\',serif;table-layout:fixed;">'
//         + '<colgroup>'
//         + '<col style="width:72px;">'
//         + '<col style="width:150px;">'
//         + '<col style="width:130px;">'
//         + '<col style="width:70px;">'
//         + '<col style="width:90px;">'
//         + '<col style="width:130px;">'
     
//         + '<col style="width:80px;">'
//         + '</colgroup>'
//         + '<thead>'
//         + '<tr style="background:#686a6c;color:#fff;">'
//         + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Photo</th>'
//         + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Product</th>'
//         + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">SKU</th>'
//         + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">ML</th>'
//         + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Presentation</th>'
//         + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Collection</th>'
        
//         + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Price</th>'
//         + '</tr>'
//         + '</thead>'
//         + '<tbody id="orm-table-body"></tbody>'
//         + '</table>'
//         + '</div>'
//         + '<div id="orm-pagination"></div>';

//       renderOrmPage();

//     } else {
//       incSection.style.display = 'none';
//       incBody.innerHTML  = '';
//       incProds.innerHTML = '';
//     }

//   } else {
//    var isFirst = (window._b2bOrdersCount || 0) === 0;

      
//       var listFirst = (extras.free_product_first_order && extras.free_product_first_order.length)
//         ? extras.free_product_first_order : (extras.free_products || []);
//       var listNext  = (extras.free_product_next_order && extras.free_product_next_order.length)
//         ? extras.free_product_next_order : (extras.free_products || []);
//       var fps = isFirst ? (listFirst.length ? listFirst : listNext)
//                         : (listNext.length  ? listNext  : listFirst);

//       var qtyFirst = (extras.free_product_first_qty && extras.free_product_first_qty.length)
//         ? extras.free_product_first_qty : (extras.free_product_quantities || []);
//       var qtyNext  = (extras.free_product_next_qty && extras.free_product_next_qty.length)
//         ? extras.free_product_next_qty : (extras.free_product_quantities || []);
//       var fqs = isFirst ? (qtyFirst.length ? qtyFirst : qtyNext)
//                         : (qtyNext.length  ? qtyNext  : qtyFirst);

//       var uFirst = Number(extras.incentive_product || 0), uNext = Number(extras.next_incentive_product || 0);
//       var vFirst = Number(extras.incentive_value   || 0), vNext = Number(extras.next_incentive_value   || 0);
//       var minU = isFirst ? (uFirst > 0 ? uFirst : uNext) : (uNext > 0 ? uNext : uFirst);
//       var minV = isFirst ? (vFirst > 0 ? vFirst : vNext) : (vNext > 0 ? vNext : vFirst);

//       console.log('[FOC modal]', { vid, priority, isFirst, minU, minV, fps, fqs, extras });
//     if (fps.length > 0 && (minU > 0 || minV > 0)) {
//       incSection.style.display = 'block';
//       var condParts = [];
//       if (minU > 0) condParts.push('<strong>' + minU + ' units</strong>');
//       if (minV > 0) condParts.push('order value of <strong>$' + Number(minV).toLocaleString() + '</strong>');
//       var getText = fps.map(function(fp, i) {
//         var qty  = fqs[i] || 1;
//         var name = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
//           ? fp.title + ' ' + fp.variant_title : fp.title;
//         return '<br><strong>' + qty + 'x</strong> ' + name;
//       }).join(' or ');
//       incBody.innerHTML = (condParts.length ? 'For every ' + condParts.join(' and ') + '. ' : '')
//         + (getText ? 'purchased, receive FOC ' : '');
//           // ── Construir datos agrupados ──
//           var purchaseToGwp = fps.map(function(fp, i) {
//             var qty2         = fqs[i] || 1;
//             var vid2         = String(fp.variant_id || '');
//             var varData2     = window.b2bAllVariantsMap?.[vid2] || {};
//             var extras2      = window.b2bVariantExtrasMap?.[vid2] || {};
//             var imgSrc       = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//             var ml2          = varData2.ml || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
//             var pres2 = extras2.presentation || varData2.pres || '—';
//             var unitsPerPack = extras2.quantity > 0 ? extras2.quantity : '—';
//             var name         = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
//               ? fp.title  : fp.title;
//             return { imgSrc, name, ml2, pres2, unitsPerPack, qty: qty2 };
//           });

//           var condText = condParts.length ? condParts.join(' and ') : '';

//           // ── Imagen y nombre del producto principal ──
//           var mainImgSrc      = row ? (row.dataset.imgUrl || '') : '';
//           var mainProductName = row ? (row.cells[5]?.textContent?.trim() || '') : '';

//           // ── EXAMPLES ──
//           var examplesHTML = '<div style="margin-bottom:24px;">'
//             + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">'
//             + '<span style="font-size:18px;">⭐</span>'
//             + '<span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Examples</span>'
//             + '</div>'
//             + '<div style="display:flex;flex-wrap:wrap;gap:14px;justify-content:flex-start;">'
//             + purchaseToGwp.map(function(item) {
//                 var gwpBg = '#f0fdf4';
//                 var gwpBorder = '#bbf7d0';
//                 return '<div style="display:flex;align-items:center;gap:0;border-radius:14px;overflow:hidden;border:1px solid #e5e7eb;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,0.06);flex:1;min-width:220px;max-width:409px;">'

//                   // Lado izquierdo: producto comprado
//                   + '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:16px 12px;text-align:center;flex:1;">'
//                   + (mainImgSrc
//                     ? '<img src="' + mainImgSrc + '" style="width:80px;height:110px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;">'
//                     : '<div style="width:54px;height:54px;border-radius:8px;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-size:24px;">🛍️</div>')
//                   + '<div style="font-size:16px;font-weight:700;color:#111;">Buy ' + condText + ' units</div>'
//                   + '<div style="font-size:16px;font-weight:600;color:#374151;">' + mainProductName + '</div>'
//                   + '<div style="font-size:13px;color:#9ca3af;"></div>'
//                   + '</div>'

//                   // Signo = centrado entre los dos lados
//                   + '<div style="display:flex;align-items:center;justify-content:center;width:32px;flex-shrink:0;font-size:20px;font-weight:700;color:#276e31;background:#fff;">=</div>'

//                   // Lado derecho: GWP
//                   + '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:16px 12px;text-align:center;flex:1;">'
//                   + (item.imgSrc
//                     ? '<img src="' + item.imgSrc + '" style="width:80px;height:110px;object-fit:cover;border-radius:8px;">'
//                     : '<div style="width:54px;height:54px;border-radius:8px;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:24px;"></div>')
                  
//                   + '<div style="font-size:16px;font-weight:700;color:#000;line-height:1.3;"> ' + item.unitsPerPack  + ' x ' + item.name + '</div>'
//                   + '<div style="font-size:16px;color:#111;font-family:Crimson pro;">' + item.pres2 + ' | ' + item.ml2 + ' | Pack: ' + item.qty + '</div>'
//                   // + '<div style="font-size:13px;font-weight:700;color:#000;margin-top:2px;">as GWP</div>'
//                   + '</div>'

//                   + '</div>';
//               }).join('')
//             + '</div>'
//             + '</div>';

//           // ── CONVERSION EQUIVALENCIES ──
//           var tableHTML = '<div>'
//             + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">'
//             + '<span style="font-size:18px;">⇄</span>'
//             + '<span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Conversion Equivalencies</span>'
//             + '</div>'
//             + '<div style="overflow-x:auto;">'
//             + '<table style="width:100%;border-collapse:collapse;font-family:\'Crimson Pro\',serif;">'
//             + '<thead>'
//             + '<tr style="background:#686a6c;color:#fff;">'
//             + '<th style="padding:10px 14px;text-align:left;font-size:16px;font-weight:600;border-radius:8px 0 0 0;">If You Purchase</th>'
//             + '<th style="padding:10px 14px;text-align:center;font-size:16px;font-weight:600;">You Can Receive (FOC)</th>'
//             + '<th style="padding:10px 14px;text-align:center;font-size:16px;font-weight:600;border-radius:0 8px 0 0;">Equivalency (Either Way)</th>'
//             + '</tr>'
//             + '</thead>'
//             + '<tbody>'
//             + purchaseToGwp.map(function(item, idx) {
//                 var arrowColors = ['#22c55e','#ec4899','#f59e0b','#3b82f6'];
//                 var arrowColor  = arrowColors[idx % arrowColors.length];
//                 var bgColor     = idx % 2 === 0 ? '#fff' : '#f9fafb';
//                 return '<tr style="background:' + bgColor + ';border-bottom:1px solid #e5e7eb;">'

//                   // Col 1
//                   + '<td style="padding:12px 14px;vertical-align:middle;">'
//                   + '<div style="display:flex;align-items:center;gap:10px;">'
//                   + (mainImgSrc
//                     ? '<img src="' + mainImgSrc + '" style="width:80px;height:110px;object-fit:cover;border-radius:6px;border:1px solid #e5e7eb;flex-shrink:0;">'
//                     : '<div style="width:38px;height:38px;border-radius:6px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;">🛍️</div>')
//                   + '<div>'
//                   + '<div style="font-size:16px;color:#111;">' + condText + ' units of</div>'
//                   + '<div style="font-size:16px;font-weight:700;color:#111;">' + mainProductName + '</div>'
//                   + '</div>'
//                   + '</div>'
//                   + '</td>'

//                   // Col 2
//                   + '<td style="padding:12px 14px;text-align:center;vertical-align:middle;">'
//                   + '<div style="display:flex;align-items:center;justify-content:center;gap:10px;">'
//                   // + '<span style="font-size:18px;color:' + arrowColor + ';">→</span>'
//                   + '<div style="display:flex;flex-direction:column;align-items:center;gap:3px;">'
//                   + (item.imgSrc
//                     ? '<div style="width:80px;height:110px;;overflow:hidden;display:flex;align-items:center;justify-content:center;">'
//                       + '<img src="' + item.imgSrc + '" style="width:80px;height:110px;object-fit:cover;">'
//                       + '</div>'
//                     : '<div style="width:40px;height:40px;background:#f0fdf4;display:flex;align-items:center;justify-content:center;font-size:18px;border:2px solid #bbf7d0;">🎁</div>')
//                   + '<div style="font-size:16px;font-weight:700;color:#111;">' + item.unitsPerPack + 'x ' + item.name + '</div>'
//                   + '<div style="font-size:16px;color:#111;">'+ item.pres2 + ' | ' + item.ml2 + ' | Pack: ' + item.qty  + '</div>'
//                   + '</div>'
//                   + '</div>'
//                   + '</td>'

//                   // Col 3
//                   + '<td style="padding:12px 14px;text-align:center;vertical-align:middle;">'
//                   + '<div style="display:flex;align-items:center;justify-content:center;gap:8px;">'
//                   // + '<span style="font-size:16px;color:#f59e0b;">⇄</span>'
//                   + '<div style="font-size:16px;color:#111;font-family: Crimson pro;text-align:left;">'
//                   + '<div style="font-weight:700;">' + item.unitsPerPack + ' '+ item.pres2 + ' '+ item.ml2 +' = '+ condText + '  ' + item.name + '</div>'
//                   // + '<div style="color:#6b7280;">= ' + condText + ' units</div>'
//                   + '</div>'
//                   + '</div>'
//                   + '</td>'
//                   + '</tr>';
//               }).join('')
//             + '</tbody></table></div></div>';

//           incProds.innerHTML = examplesHTML + tableHTML;


//     } else {
//       incSection.style.display = 'none';
//       incBody.innerHTML  = '';
//       incProds.innerHTML = '';
//     }
//   }

//   // Galería de imágenes (fetch producto)
//   var mainImg  = document.getElementById('orm-main-img');
//   var thumbsEl = document.getElementById('orm-thumbs');
//   mainImg.src  = row ? (row.dataset.imgUrl || '') : '';
//   thumbsEl.innerHTML = '';

//   if (handle) {
//     fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(product) {
//       if (!product?.images?.length) return;
//       product.images.forEach(function(img, i) {
//         var src = (typeof img === 'string' ? img : img.src || '').replace(/^\/\//, 'https://');
//         var thumb = document.createElement('img');
//         thumb.className = 'sku-modal-thumb' + (i === 0 ? ' active' : '');
//         thumb.src = src; thumb.width = 56; thumb.height = 56;
//         thumb.addEventListener('click', function() {
//           mainImg.src = src;
//           document.querySelectorAll('#orm-thumbs .sku-modal-thumb').forEach(function(t){ t.classList.remove('active'); });
//           thumb.classList.add('active');
//         });
//         thumbsEl.appendChild(thumb);
//         if (i === 0) mainImg.src = src;
//       });
//     }).catch(function(){});
//   }

//   document.getElementById('order-rules-modal').style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// }

// function closeOrderRulesModal() {
//   document.getElementById('order-rules-modal').style.display = 'none';
//   document.body.style.overflow = '';
// }

// document.getElementById('order-rules-overlay')?.addEventListener('click', closeOrderRulesModal);



// /* ============================================================
// EXPORT GUIDELINES — PDF y Excel
// ============================================================ */
// function exportGuidelines(format) {
//   const vendor    = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//   const colHandle = getColHandle();
//   const priority  = Number(window.b2bCollectionPriority || 1);

//   // const firstUnits = window.b2bBrandMinQtyMap?.[colHandle] || '—';
//   // const firstValue = window.b2bBrandMinValueMap?.[colHandle]
//   //   ? '$' + parseFloat(window.b2bBrandMinValueMap[colHandle]).toFixed(2) : '—';
//   const nextUnits  = window.b2bBrandNextOrderMap?.[colHandle] || '—';
//   const nextValue  = window.b2bBrandNextOrderValueMap?.[colHandle]
//     ? '$' + parseFloat(window.b2bBrandNextOrderValueMap[colHandle]).toFixed(2) : '—';

//   // ── Helper precio ──
//   function getIncentivePrice(p) {
//     const metaP = parseFloat(p.incentive_product_price || 0);
//     if (metaP > 0) return metaP;
//     const vid2    = String(p.variant_id || '');
//     const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
//     const metaP2  = parseFloat(extras2.incentive_product_price || 0);
//     if (metaP2 > 0) return metaP2;
//     return parseFloat(p.price || 0);
//   }

//   if (format === 'excel') {
//     const data = [];

//     // ── Cabecera ──
//     data.push([`Brand Incentive — ${vendor}`]);
//     data.push([]);
//     // data.push(['First Order — Min Units:', firstUnits, 'Min Value:', firstValue]);
//     // data.push(['Next Order  — Min Units:', nextUnits,  'Min Value:', nextValue]);
//     data.push([]);

//     if (priority === 2) {
//       // ── P2 ──
//       const discPct    = parseFloat(window.b2bCollectionDiscount || 0);
//       const minAmount  = parseFloat(window.b2bDiscountMinAmount  || 0);
//       const discProds  = window.b2bDiscountProducts || [];

//       data.push([`Volume Incentives — ${discPct}% Credit`]);
//       data.push([`Minimum purchase: $${minAmount.toFixed(2)}`]);
//       data.push(['⚠ Credits must be used during the current purchase.']);
//       data.push([]);
//       data.push(['Product', 'Variant', 'SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'Price']);

//       discProds.forEach(p => {
//         if (!p?.title) return;
//         const vid    = String(p.variant_id || '');
//         const vd     = window.b2bAllVariantsMap?.[vid] || {};
//         const notes  = window.b2bNotesMap?.[p.handle] || {};
//         const price  = getIncentivePrice(p);
//         const vTitle = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
//         data.push([
//           p.title,
//           vTitle,
//           vd.sku || '—',
//           vd.ml  || vTitle || '—',
//           vd.pres || '—',
//           vd.collection || notes.collection || '—',
//           vd.coefficient || notes.coefficient || '—',
         
//           `$${price.toFixed(2)}`
//         ]);
//       });

//     } else {
//       // ── P1: variantes ──
//       data.push(['Volume Incentives — By Product']);
//       data.push([]);

//       variantRows().forEach(row => {
//         const vid    = row.dataset.variantId;
//         const extras = window.b2bVariantExtrasMap?.[vid] || {};
//         if (!variantHasIncentive(extras)) return;

//         const pName  = row.cells[5]?.textContent?.trim() || '';
//         const ml     = row.cells[7]?.textContent?.trim() || '';
//         const pres   = row.cells[8]?.textContent?.trim() || '';
//         const coll   = row.cells[4]?.textContent?.trim() || '';
//         const coeff  = row.cells[10]?.textContent?.trim() || '';
//         const msrp   = row.cells[11]?.textContent?.trim() || '';
//         const price  = parseFloat(row.dataset.unitPrice || 0);
//         const sku    = (row.dataset.sku || '').toUpperCase();

//         const { minU, minV } = getVariantThresholds(extras);
//         const fps = getVariantFreeProducts(extras);
//         const fqs = getVariantFreeQtys(extras);

//         const condParts = [];
//         if (minU > 0) condParts.push(`${minU} units`);
//         if (minV > 0) condParts.push(`$${Number(minV).toLocaleString()}`);
//         const condition = condParts.length ? 'Buy ' + condParts.join(' and ') : '';

//         data.push([`${pName} — ${ml}`]);
//         data.push(['SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'MSRP', 'Price', 'Condition']);
//         data.push([sku, ml, pres, coll, coeff, msrp, `$${price.toFixed(2)}`, condition]);
//         data.push(['']);
//         data.push(['Free Gifts:']);
//         data.push(['Gift Product', 'Variant', 'Qty']);
//         fps.forEach((fp, i) => {
//           const qty   = fqs[i] || 1;
//           const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '';
//           data.push([fp.title, fpVar, qty]);
//         });
//         data.push([]);
//       });

//       // ── Collection rules ──
//       const rules = window.b2bCollectionIncentivesMap?.[colHandle] || [];
//       if (rules.length) {
//         data.push(['Collection Volume Rules']);
//         data.push([]);
//         rules.forEach((rule, idx) => {
//           const minQ = Number(rule.min_qty || 0);
//           const minV = Number(rule.min_order_value || 0);
//           const disc = Number(rule.discount || 0);
//           const condParts = [];
//           if (minQ > 0) condParts.push(`${minQ} units`);
//           if (minV > 0) condParts.push(`$${minV.toLocaleString()}`);
//           data.push([`Rule ${idx + 1}: ${condParts.join(' + ')}`]);
//           if (disc > 0) data.push(['Discount:', `${disc}%`]);
//           (rule.free_products || []).forEach((fp, i) => {
//             if (!fp?.title) return;
//             const qty   = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
//             const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '';
//             data.push(['Free:', `${qty}x ${fp.title}${fpVar ? ' — ' + fpVar : ''}`]);
//           });
//           (rule.free_testers || []).forEach((tp, i) => {
//             if (!tp?.title) return;
//             data.push(['Tester:', `${getTesterQty(rule, i)}x ${tp.title}`]);
//           });
//           data.push([]);
//         });
//       }
//     }

//     const ws = XLSX.utils.aoa_to_sheet(data);
//     ws['!cols'] = [{wch:30},{wch:20},{wch:18},{wch:12},{wch:14},{wch:20},{wch:14},{wch:12},{wch:12}];
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Guidelines');
//     XLSX.writeFile(wb, `guidelines-${vendor.toLowerCase().replace(/\s+/g, '-')}.xlsx`);

//   } else if (format === 'pdf') {
//     const { jsPDF } = window.jspdf;
//     const doc    = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
//     const pageW  = doc.internal.pageSize.getWidth();
//     const pageH  = doc.internal.pageSize.getHeight();
//     const margin = 14, colW = pageW - margin * 2;
//     let y = margin;

//     const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
//     const drawLine  = () => { doc.setDrawColor(220,220,220); doc.line(margin, y, pageW - margin, y); y += 4; };

//     // ── Logo ──
//     const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
//     if (logoUrl) {
//       try {
//         const li = new Image(); li.src = logoUrl; li.crossOrigin = 'anonymous';
//         const lw = 40, lh = li.height > 0 ? (li.height * lw) / li.width : 20;
//         doc.addImage(logoUrl, 'PNG', (pageW - lw) / 2, y, lw, Math.min(lh, 28));
//         y += Math.min(lh, 28) + 6;
//       } catch {}
//     }

//     // ── Título ──
//     doc.setFontSize(18); doc.setFont('helvetica', 'bold');
//     doc.text('Brand Incentives', pageW / 2, y, { align: 'center' }); y += 7;
//     doc.setFontSize(11); doc.setFont('helvetica', 'normal'); doc.setTextColor(100,100,100);
//     doc.text(vendor, pageW / 2, y, { align: 'center' });
//     doc.setTextColor(0,0,0); y += 8; drawLine();

//     // ── Mínimos ──
//     // doc.setFillColor(184,167,125); doc.roundedRect(margin, y, colW / 2 - 4, 18, 2, 2, 'F');
//     // doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     // doc.text('First Order', margin + 4, y + 6);
//     // doc.setFont('helvetica','normal'); doc.setFontSize(8);
//     // // doc.text(`Units: ${firstUnits}  |  Value: ${firstValue}`, margin + 4, y + 13);
//     // doc.setFillColor(156,163,175); doc.roundedRect(pageW / 2 + 2, y, colW / 2 - 4, 18, 2, 2, 'F');
//     // doc.setFontSize(9); doc.setFont('helvetica','bold');
//     // doc.text('Next Order', pageW / 2 + 6, y + 6);
//     // doc.setFont('helvetica','normal'); doc.setFontSize(8);
//     // doc.text(`Units: ${nextUnits}  |  Value: ${nextValue}`, pageW / 2 + 6, y + 13);
//     // doc.setTextColor(0,0,0); y += 24; drawLine();

//     // ── Incentivos ──
//     doc.setFillColor(30,30,30); doc.roundedRect(margin, y, colW, 8, 2, 2, 'F');
//     doc.setFontSize(11); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     doc.text('Volume Incentives', margin + 4, y + 5.5);
//     doc.setTextColor(0,0,0); y += 13;

//     if (priority === 2) {
//       const discPct   = parseFloat(window.b2bCollectionDiscount || 0);
//       const minAmount = parseFloat(window.b2bDiscountMinAmount  || 0);
//       const discProds = window.b2bDiscountProducts || [];

//       checkPage(20);
//       doc.setFontSize(10); doc.setFont('helvetica','bold');
//       doc.text(`${discPct}% Credit — Minimum purchase: $${minAmount.toFixed(2)}`, margin, y); y += 6;
//       doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(120,80,0);
//       doc.text('Credits must be used during the current purchase.', margin, y);
//       doc.setTextColor(0,0,0); y += 8;

//       // Cabecera tabla
//       const cols2 = [40, 16, 14, 14, 20, 14, 14];
//       doc.setFillColor(240,240,240); doc.rect(margin, y - 2, colW, 7, 'F');
//       doc.setFontSize(7); doc.setFont('helvetica','bold');
//       let cx = margin + 1;
//       ['Product','SKU','ML','Pres.','Collection','Coeff.','Price'].forEach((h, i) => {
//         doc.text(h, cx, y + 3); cx += cols2[i];
//       });
//       y += 7;

//       discProds.forEach((p, ri) => {
//         if (!p?.title) return;
//         checkPage(8);
//         const vid   = String(p.variant_id || '');
//         const vd    = window.b2bAllVariantsMap?.[vid] || {};
//         const notes = window.b2bNotesMap?.[p.handle] || {};
//         const price = getIncentivePrice(p);
//         const vTitle = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
//         doc.setFillColor(...(ri % 2 === 0 ? [255,255,255] : [248,249,250]));
//         doc.rect(margin, y - 1, colW, 7, 'F');
//         doc.setFontSize(7); doc.setFont('helvetica','normal');
//         let cx2 = margin + 1;
//         [
//           `${p.title}${vTitle ? ' — ' + vTitle : ''}`.substring(0, 22),
//           (vd.sku || '—').substring(0, 10),
//           (vd.ml || vTitle || '—').substring(0, 8),
//           (vd.pres || '—').substring(0, 8),
//           (vd.collection || notes.collection || '—').substring(0, 14),
//           String(vd.coefficient || notes.coefficient || '—').substring(0, 6),
//           `$${price.toFixed(2)}`
//         ].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += cols2[i]; });
//         y += 7;
//       });

//     } else {
//       // ── P1: por variante ──
//       variantRows().forEach(row => {
//         const vid    = row.dataset.variantId;
//         const extras = window.b2bVariantExtrasMap?.[vid] || {};
//         if (!variantHasIncentive(extras)) return;

//         const pName = row.cells[5]?.textContent?.trim() || '';
//         const ml    = row.cells[7]?.textContent?.trim() || '';
//         const pres  = row.cells[8]?.textContent?.trim() || '';
//         const coll  = row.cells[4]?.textContent?.trim() || '';
//         const coeff = row.cells[10]?.textContent?.trim() || '';
//         const msrp  = row.cells[11]?.textContent?.trim() || '';
//         const price = parseFloat(row.dataset.unitPrice || 0);
//         const sku   = (row.dataset.sku || '').toUpperCase();
//         const imgUrl = row.dataset.imgUrl || '';

//         const { minU, minV } = getVariantThresholds(extras);
//         const fps = getVariantFreeProducts(extras);
//         const fqs = getVariantFreeQtys(extras);

//         const condParts = [];
//         if (minU > 0) condParts.push(`${minU} units`);
//         if (minV > 0) condParts.push(`$${Number(minV).toLocaleString()}`);
//         const condition = condParts.length ? 'Buy ' + condParts.join(' and ') + ' → get free gift' : '';

//         checkPage(40);

//         // Header producto
//         doc.setFillColor(245,245,245); doc.roundedRect(margin, y, colW, 10, 2, 2, 'F');
//         doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(30,30,30);
//         doc.text(`${pName} — ${ml}`, margin + 4, y + 7);
//         doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(80,80,80);
//         // doc.text(condition, pageW - margin - 2, y + 7, { align: 'right' });
//         doc.setTextColor(0,0,0); y += 13;

//         // Info variante
//         doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(100,100,100);
//         doc.text(`SKU: ${sku}  |  ML: ${ml}  |  Pres: ${pres}  |  Collection: ${coll}  |  Coeff: ${coeff}  |  MSRP: ${msrp}  |  Price: $${price.toFixed(2)}`, margin, y);
//         doc.setTextColor(0,0,0); y += 6;

//         // Gifts
//         if (fps.length) {
//           doc.setFontSize(8); doc.setFont('helvetica','bold');
//           doc.text('Free Gifts:', margin, y); y += 5;
//           fps.forEach((fp, i) => {
//             checkPage(7);
//             const qty   = fqs[i] || 1;
//             const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
//             doc.setFillColor(220,252,231); doc.roundedRect(margin, y - 1, colW, 6, 1, 1, 'F');
//             doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(22,101,52);
//             doc.text(`${qty}x FREE  ${fp.title}${fpVar}`, margin + 3, y + 3);
//             doc.setTextColor(0,0,0); y += 7;
//           });
//         }
//         y += 4; drawLine();
//       });

//       // ── Collection rules ──
//       const rules = window.b2bCollectionIncentivesMap?.[colHandle] || [];
//       if (rules.length) {
//         checkPage(12);
//         doc.setFillColor(50,50,50); doc.roundedRect(margin, y, colW, 8, 2, 2, 'F');
//         doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//         doc.text('Collection Volume Rules', margin + 4, y + 5.5);
//         doc.setTextColor(0,0,0); y += 12;

//         rules.forEach((rule, idx) => {
//           checkPage(24);
//           const minQ = Number(rule.min_qty || 0);
//           const minV = Number(rule.min_order_value || 0);
//           const disc = Number(rule.discount || 0);
//           const condParts = [];
//           if (minQ > 0) condParts.push(`${minQ} units`);
//           if (minV > 0) condParts.push(`$${minV.toLocaleString()}`);

//           doc.setFillColor(248,249,250); doc.roundedRect(margin, y, colW, 8, 2, 2, 'F');
//           doc.setFontSize(9); doc.setFont('helvetica','bold');
//           doc.text(`Rule ${idx + 1}: ${condParts.join(' + ')}${disc > 0 ? `  —  ${disc}% discount` : ''}`, margin + 3, y + 5.5);
//           y += 11;

//           (rule.free_products || []).forEach((fp, i) => {
//             if (!fp?.title) return;
//             checkPage(7);
//             const qty   = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
//             const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
//             doc.setFillColor(220,252,231); doc.roundedRect(margin, y - 1, colW, 6, 1, 1, 'F');
//             doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(22,101,52);
//             doc.text(`${qty}x FREE  ${fp.title}${fpVar}`, margin + 3, y + 3);
//             doc.setTextColor(0,0,0); y += 7;
//           });

//           (rule.free_testers || []).forEach((tp, i) => {
//             if (!tp?.title) return;
//             checkPage(7);
//             doc.setFillColor(219,234,254); doc.roundedRect(margin, y - 1, colW, 6, 1, 1, 'F');
//             doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(29,78,216);
//             doc.text(`${getTesterQty(rule, i)}x TESTER  ${tp.title}`, margin + 3, y + 3);
//             doc.setTextColor(0,0,0); y += 7;
//           });
//           y += 4;
//         });
//       }
//     }

//     doc.save(`Incentives-${vendor.toLowerCase().replace(/\s+/g, '-')}.pdf`);
//   }
// }



// async function generateGuidelinesBase64(format) {
//   const vendor    = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//   const colHandle = getColHandle();
//   const priority  = Number(window.b2bCollectionPriority || 1);

//   if (format === 'excel') {
//     const data = [];
//     data.push([`Brand Incentive — ${vendor}`]);
//     data.push([]);

//     if (priority === 2) {
//       const discPct   = parseFloat(window.b2bCollectionDiscount || 0);
//       const minAmount = parseFloat(window.b2bDiscountMinAmount  || 0);
//       const discProds = window.b2bDiscountProducts || [];
//       data.push([`Volume Incentives — ${discPct}% Credit`]);
//       data.push([`Minimum purchase: $${minAmount.toFixed(2)}`]);
//       data.push([]);
//       data.push(['Product', 'Variant', 'SKU', 'ML', 'Presentation', 'Collection', 'Price']);
//       discProds.forEach(p => {
//         if (!p?.title) return;
//         const vid   = String(p.variant_id || '');
//         const vd    = window.b2bAllVariantsMap?.[vid] || {};
//         const note  = window.b2bNotesMap?.[p.handle] || {};
//         const metaP = parseFloat(p.incentive_product_price || 0);
//         const price = metaP > 0 ? metaP : parseFloat(p.price || 0);
//         data.push([p.title, p.variant_title || '', vd.sku || '—', vd.ml || '—', vd.pres || '—', vd.collection || note.collection || '—', `$${price.toFixed(2)}`]);
//       });
//     } else {
//       data.push(['Volume Incentives — By Product']);
//       data.push([]);
//       variantRows().forEach(row => {
//         const vid    = row.dataset.variantId;
//         const extras = window.b2bVariantExtrasMap?.[vid] || {};
//         if (!variantHasIncentive(extras)) return;
//         const fps = getVariantFreeProducts(extras);
//         const fqs = getVariantFreeQtys(extras);
//         const { minU, minV } = getVariantThresholds(extras);
//         const condParts = [];
//         if (minU > 0) condParts.push(`${minU} units`);
//         if (minV > 0) condParts.push(`$${Number(minV).toLocaleString()}`);
//         data.push([`${row.cells[5]?.textContent?.trim()} — ${row.cells[7]?.textContent?.trim()}`]);
//         data.push(['Condition', condParts.join(' and ')]);
//         fps.forEach((fp, i) => {
//           data.push(['Free:', `${fqs[i] || 1}x ${fp.title}${fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ' — ' + fp.variant_title : ''}`]);
//         });
//         data.push([]);
//       });
//     }

//     const ws = XLSX.utils.aoa_to_sheet(data);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, 'Incentives');
//     return XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });

//   } else if (format === 'pdf') {
//     try {
//       const { jsPDF } = window.jspdf;
//       if (!jsPDF) { console.error('jsPDF not loaded'); return null; }

//       const doc    = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
//       const pageW  = doc.internal.pageSize.getWidth();
//       const pageH  = doc.internal.pageSize.getHeight();
//       const margin = 14;
//       const colW   = pageW - margin * 2;
//       let y = margin;

//       const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };

//       // ── Título ──
//       doc.setFontSize(16); doc.setFont('helvetica', 'bold');
//       doc.text(`${vendor} — Brand Incentives`, pageW / 2, y, { align: 'center' }); y += 10;
//       doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
//       doc.text(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pageW / 2, y, { align: 'center' });
//       doc.setTextColor(0, 0, 0); y += 12;

//       if (priority === 2) {
//         const discPct   = parseFloat(window.b2bCollectionDiscount || 0);
//         const minAmount = parseFloat(window.b2bDiscountMinAmount  || 0);
//         doc.setFontSize(10); doc.setFont('helvetica', 'bold');
//         doc.text(`${discPct}% Credit — Min purchase: $${minAmount.toFixed(2)}`, margin, y); y += 8;
//         doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 80, 0);
//         doc.text('Credits must be used during the current purchase.', margin, y);
//         doc.setTextColor(0, 0, 0); y += 10;

//         (window.b2bDiscountProducts || []).forEach((p, ri) => {
//           if (!p?.title) return;
//           checkPage(8);
//           const vid   = String(p.variant_id || '');
//           const vd    = window.b2bAllVariantsMap?.[vid] || {};
//           const metaP = parseFloat(p.incentive_product_price || 0);
//           const price = metaP > 0 ? metaP : parseFloat(p.price || 0);
//           doc.setFillColor(...(ri % 2 === 0 ? [255,255,255] : [248,249,250]));
//           doc.rect(margin, y - 1, colW, 7, 'F');
//           doc.setFontSize(8); doc.setFont('helvetica', 'normal');
//           doc.text(`${p.title} | ${vd.ml || '—'} | ${vd.pres || '—'} | $${price.toFixed(2)}`, margin + 2, y + 4);
//           y += 7;
//         });

//       } else {
//         variantRows().forEach(row => {
//           const vid    = row.dataset.variantId;
//           const extras = window.b2bVariantExtrasMap?.[vid] || {};
//           if (!variantHasIncentive(extras)) return;
//           const fps    = getVariantFreeProducts(extras);
//           const fqs    = getVariantFreeQtys(extras);
//           const { minU } = getVariantThresholds(extras);

//           checkPage(20);
//           doc.setFontSize(9); doc.setFont('helvetica', 'bold');
//           doc.text(`${row.cells[5]?.textContent?.trim()} — Buy ${minU} units`, margin, y); y += 6;

//           fps.forEach((fp, i) => {
//             checkPage(6);
//             doc.setFont('helvetica', 'normal'); doc.setFontSize(8);
//             doc.setFillColor(220, 252, 231);
//             doc.rect(margin, y - 1, colW, 6, 'F');
//             doc.setTextColor(22, 101, 52);
//             doc.text(`  ${fqs[i] || 1}x FREE: ${fp.title}`, margin + 2, y + 3);
//             doc.setTextColor(0, 0, 0);
//             y += 6;
//           });
//           y += 4;
//         });
//       }

//       // ── Retornar base64 ──
//       const pdfBase64 = doc.output('datauristring').split(',')[1];
//       if (!pdfBase64) { console.error('PDF base64 is empty'); return null; }
//       return pdfBase64;

//     } catch (err) {
//       console.error('Error generating PDF base64:', err);
//       return null;
//     }
//   }

//   return null;
// }

// /* ══════════════════════════════════════════════════════════════
//    PATCH — Agrupación por categoría + orden por ML para el
//    "Product List" completo (generateCatalogBase64 / generateCatalogPdfBase64)

//    INSTRUCCIONES:
//    1) Pega el bloque "HELPERS NUEVOS" en cualquier parte del archivo
//       b2b-marca-tabla.js ANTES de generateCatalogBase64 (por ejemplo,
//       justo debajo de la función getColHandle()).
//    2) Reemplaza tu función `async function generateCatalogBase64() {...}`
//       completa por la nueva versión de este archivo.
//    3) Reemplaza tu función `async function generateCatalogPdfBase64() {...}`
//       completa por la nueva versión de este archivo.
//    4) NO toques generatePreOrderExcelBase64 / generatePreOrderPdfBase64 /
//       initExcelExport / initPdfExport — esos exports (Pre-Order) quedan igual.
//    ══════════════════════════════════════════════════════════════ */


// /* ══════════════════════════════════════════════
//    HELPERS NUEVOS — pegar antes de generateCatalogBase64
//    ══════════════════════════════════════════════ */

// // Valores de presentation (ya normalizados) que pertenecen a Bath & Body Care.
// const CATALOG_BATH_BODY_PRESENTATIONS = new Set([
//   'body butter', 'body lotion', 'body scrub', 'body wash', 'soap', 'shampoo & conditioner'
// ]);

// const CATALOG_CATEGORY_ORDER = ['perfume', 'tester', 'bathbody', 'others'];

// const CATALOG_CATEGORY_TITLES = {
//   perfume:  'Perfume',
//   tester:   'Perfume Tester and Vials',
//   bathbody: 'Bath & Body Care',
//   others:   'Others',
// };

// // Limpia espacios normales e invisibles (NBSP, etc.) y normaliza a minúsculas,
// // para que la comparación no falle por diferencias invisibles en el dato guardado.
// function catalogNormalizePresentation(presentation) {
//   return (presentation || '')
//     .replace(/[\u00A0\u200B\u2028\u2029]/g, ' ')
//     .trim()
//     .toLowerCase();
// }

// // Decide la categoría de una fila (variante) según su presentation:
// //  - Body Butter / Body Lotion / Body Scrub / Body Wash / Soap / Shampoo & Conditioner -> bathbody
// //  - Tester / Vial -> tester
// //  - Perfume (exacto) -> perfume
// //  - cualquier otro valor (Retail, Sample, Travel Set, Discovery Set, Other, etc.) -> others
// function getCatalogRowCategory(presentation) {
//   const norm = catalogNormalizePresentation(presentation);
//   if (norm && CATALOG_BATH_BODY_PRESENTATIONS.has(norm)) return 'bathbody';
//   if (norm === 'tester' || norm === 'vial') return 'tester';
//   if (norm === 'perfume') return 'perfume';
//   return 'others';
// }

// // Extrae el número de ML de un string tipo "100 ml" -> 100. Sin número (Sample,
// // Tester suelto, etc.) devuelve -1 para que quede al final al ordenar desc.
// function getCatalogMlSortValue(mlStr) {
//   const match = (mlStr || '').match(/(\d+(\.\d+)?)/);
//   return match ? parseFloat(match[1]) : -1;
// }

// // Agrupa las filas del catálogo (variantRows()) en las 4 categorías y ordena
// // cada grupo por ML de mayor a menor. row.dataset.presentation y row.dataset.ml
// // ya vienen en minúsculas desde el render (ver script inline del .liquid).
// function groupAndSortCatalogRows(rows) {
//   const groups = { perfume: [], tester: [], bathbody: [], others: [] };
//   rows.forEach(row => {
//     const category = getCatalogRowCategory(row.dataset.presentation);
//     groups[category].push(row);
//   });
//   CATALOG_CATEGORY_ORDER.forEach(key => {
//     groups[key].sort((a, b) => getCatalogMlSortValue(b.dataset.ml) - getCatalogMlSortValue(a.dataset.ml));
//   });
//   return groups;
// }

// // Construye una hoja de Excel para una categoría del catálogo completo:
// // fila de resumen + encabezados + filas (ya ordenadas por ML) + fotos.
// function buildCatalogSheet(workbook, categoryKey, categoryRows, imageCache) {
//   const sheet = workbook.addWorksheet(CATALOG_CATEGORY_TITLES[categoryKey].substring(0, 31)); // Excel limita a 31 chars

//   const columnDefs = [
//     { key: 'sku',           width: 30 },
//     { key: 'photo',         width: 12 },
//     { key: 'product',       width: 30 },
//     { key: 'collection',    width: 20 },
//     { key: 'concentration', width: 18 },
//     { key: 'ml',            width: 10 },
//     { key: 'presentation',  width: 14 },
//     { key: 'msrp',          width: 14 },
//     { key: 'wholesale',     width: 16 },
//   ];
//   sheet.columns = columnDefs;

//   // Fila 1: resumen
//   const uniqueProducts = new Set(categoryRows.map(r => r.dataset.handle));
//   const summaryText = `Products: ${uniqueProducts.size}   |   Unique References: ${categoryRows.length}`;
//   const summaryRow = sheet.addRow([summaryText]);
//   sheet.mergeCells(1, 1, 1, columnDefs.length);
//   summaryRow.font = { bold: true, color: { argb: 'FFB7AC7E' } };
//   summaryRow.alignment = { vertical: 'middle', horizontal: 'left' };
//   summaryRow.height = 20;

//   // Fila 2: encabezados
//   const headerLabels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Brand MSRP', 'Wholesale Price'];
//   const headerRow = sheet.addRow(headerLabels);
//   headerRow.eachCell((cell) => {
//     cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
//     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
//     cell.alignment = { vertical: 'middle', horizontal: 'center' };
//   });
//   headerRow.height = 18;

//   // Filas 3+: datos (ya ordenados por ML desc)
//   categoryRows.forEach((row, index) => {
//     const excelRow = sheet.addRow({
//       sku:           (row.dataset.sku || '-').toUpperCase(),
//       photo:         '',
//       product:       row.cells[5]?.textContent?.trim() || '',
//       collection:    row.cells[4]?.textContent?.trim() || '',
//       concentration: row.cells[6]?.textContent?.trim() || '',
//       ml:            row.cells[7]?.textContent?.trim() || '',
//       presentation:  row.cells[8]?.textContent?.trim() || '',
//       msrp:          row.cells[11]?.textContent?.trim() || '',
//       wholesale:     parseFloat(row.dataset.unitPrice || 0),
//     });
//     excelRow.height = 50;
//     excelRow.alignment = { vertical: 'middle' };

//     const url = row.dataset.imgUrl;
//     if (url && imageCache[url]) {
//       const rowNumber = index + 3; // +1 resumen, +1 encabezado, +1 porque ExcelJS es 1-based
//       const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
//       sheet.addImage(imageId, {
//         tl: { col: 1.25, row: rowNumber - 1 + 0.28 },
//         ext: { width: 50, height: 50 },
//       });
//     }
//   });
// }


// /* ══════════════════════════════════════════════
//    NUEVA VERSIÓN — reemplaza tu generateCatalogBase64() actual
//    ══════════════════════════════════════════════ */

// async function generateCatalogBase64() {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

//   const workbook = new ExcelJS.Workbook();
//   workbook.creator = vendor;
//   workbook.created = new Date();

//   const rows = variantRows();

//   // Pre-cargar imágenes únicas EN PARALELO (una sola vez para todas las categorías)
//   const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
//   const imageCache = {};
//   await Promise.all(uniqueUrls.map(async url => {
//     try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
//     catch (e) { imageCache[url] = null; }
//   }));

//   // Agrupar por categoría (Perfume / Perfume Tester and Vials / Bath & Body Care / Others)
//   // y ordenar cada grupo por ML de mayor a menor.
//   const groups = groupAndSortCatalogRows(rows);

//   // Una hoja por cada categoría con filas (las vacías se omiten)
//   CATALOG_CATEGORY_ORDER.forEach(categoryKey => {
//     const categoryRows = groups[categoryKey];
//     if (categoryRows.length > 0) {
//       buildCatalogSheet(workbook, categoryKey, categoryRows, imageCache);
//     }
//   });

//   const buffer = await workbook.xlsx.writeBuffer();
//   let binary = '';
//   const bytes = new Uint8Array(buffer);
//   for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
//   return btoa(binary);
// }


// /* ══════════════════════════════════════════════
//    NUEVA VERSIÓN — reemplaza tu generateCatalogPdfBase64() actual
//    ══════════════════════════════════════════════ */

// async function generateCatalogPdfBase64() {
//   try {
//     const { jsPDF } = window.jspdf;
//     if (!jsPDF) { console.error('jsPDF not loaded'); return null; }

//     const vendor  = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const doc     = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
//     const pageW   = doc.internal.pageSize.getWidth();
//     const pageH   = doc.internal.pageSize.getHeight();
//     const margin  = 10;
//     const colW    = pageW - margin * 2;

//     // Ahora recibe/devuelve y explícitamente (antes vivía en el scope de la función,
//     // pero ahora cada categoría empieza una página nueva con su propio y).
//     const checkPage = (y, n) => { if (y + n > pageH - margin) { doc.addPage(); return margin; } return y; };

//     const rows = variantRows();

//     // Pre-cargar imágenes únicas EN PARALELO (fotos chicas, una sola vez para todo)
//     const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
//     const imageCache = {};
//     await Promise.all(uniqueUrls.map(async url => {
//       try { imageCache[url] = await loadImgAsBase64ForExport(url, 100); }
//       catch (e) { imageCache[url] = null; }
//     }));

//     // Agrupar por categoría y ordenar por ML de mayor a menor
//     const groups = groupAndSortCatalogRows(rows);
//     const nonEmptyCategories = CATALOG_CATEGORY_ORDER.filter(key => groups[key].length > 0);

//     // Cabecera tabla — misma estructura que antes
//     const cols   = [24, 18, 44, 26, 24, 14, 20, 20, 22];
//     const labels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Brand MSRP', 'Wholesale'];
//     const IMG_SIZE = 12;

//     nonEmptyCategories.forEach((categoryKey, catIndex) => {
//       const categoryRows = groups[categoryKey];
//       let y = margin;

//       if (catIndex > 0) {
//         doc.addPage();
//       }

//       // Título / fecha (se repite en cada página de categoría)
//       doc.setFontSize(14); doc.setFont('helvetica', 'bold');
//       doc.text(`${vendor} — Product List`, pageW / 2, y, { align: 'center' }); y += 7;
//       doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
//       doc.text(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pageW / 2, y, { align: 'center' });
//       doc.setTextColor(0, 0, 0); y += 8;

//       // Título de la categoría
//       doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(183, 172, 126);
//       doc.text(CATALOG_CATEGORY_TITLES[categoryKey], margin, y);
//       doc.setTextColor(0, 0, 0); y += 6;

//       // Cabecera tabla
//       doc.setFillColor(30, 30, 30);
//       doc.rect(margin, y, colW, 7, 'F');
//       doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
//       let cx = margin + 1;
//       labels.forEach((lbl, i) => { doc.text(lbl, cx, y + 4.5); cx += cols[i]; });
//       doc.setTextColor(0, 0, 0); y += 8;

//       // Filas (ya ordenadas por ML desc)
//       let rowCount = 0;
//       categoryRows.forEach(row => {
//         y = checkPage(y, IMG_SIZE + 2);
//         doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
//         doc.rect(margin, y - 1, colW, IMG_SIZE + 2, 'F');
//         doc.setFontSize(6.5); doc.setFont('helvetica', 'normal');

//         let cx2 = margin + 1;

//         // SKU
//         doc.text((row.dataset.sku || '-').toUpperCase().substring(0, 12), cx2, y + (IMG_SIZE / 2) + 1);
//         cx2 += cols[0];

//         // Photo
//         const url = row.dataset.imgUrl;
//         const imgData = url ? imageCache[url] : null;
//         if (imgData) {
//           doc.addImage(imgData, 'JPEG', cx2 + 1, y, IMG_SIZE, IMG_SIZE);
//         }
//         cx2 += cols[1];

//         // Product, Collection, Concentration, ML, Presentation, Brand MSRP, Wholesale
//         const values = [
//           (row.cells[5]?.textContent?.trim() || '').substring(0, 24),
//           (row.cells[4]?.textContent?.trim() || '').substring(0, 16),
//           (row.cells[6]?.textContent?.trim() || '').substring(0, 14),
//           (row.cells[7]?.textContent?.trim() || '').substring(0, 8),
//           (row.cells[8]?.textContent?.trim() || '').substring(0, 12),
//           (row.cells[11]?.textContent?.trim() || '').substring(0, 10),
//           '$' + parseFloat(row.dataset.unitPrice || 0).toFixed(2),
//         ];
//         values.forEach((v, i) => { doc.text(v, cx2, y + (IMG_SIZE / 2) + 1); cx2 += cols[i + 2]; });

//         y += IMG_SIZE + 2;
//         rowCount++;
//       });
//     });

//     const pdfBase64 = doc.output('datauristring').split(',')[1];
//     if (!pdfBase64) { console.error('Catalog PDF base64 is empty'); return null; }
//     return pdfBase64;

//   } catch (err) {
//     console.error('Error generating catalog PDF base64:', err);
//     return null;
//   }
// }


// function getPresentationCategory(presentationText) {
//   const p = (presentationText || '').toLowerCase();

//   if (p.includes('perfume')) return 'Perfume';
//   if (p.includes('tester'))  return 'Tester';
//   if (p.includes('vial'))    return 'Vial';

//   const bathBodyKeywords = [
//     'body butter',
//     'body lotion',
//     'body scrub',
//     'body wash',
//     'soap',
//     'shampoo',
//     'conditioner',
//   ];
//   if (bathBodyKeywords.some(k => p.includes(k))) return 'Bath & Body Care';

//   return 'Other';
// }


// // async function generateOfflineOrderTemplateBase64() {
// //   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

// //   const workbook = new ExcelJS.Workbook();
// //   workbook.creator = vendor;
// //   workbook.created = new Date();

// //   const sheet = workbook.addWorksheet('Offline Order');

// //   // Columnas SIN "header" (evita el patrón frágil de mezclar
// //   // sheet.columns-con-header + insertRow que ya nos dio problemas antes).
// //   const columnDefs = [
// //     { key: 'sku',           width: 24 },
// //     { key: 'photo',         width: 12 },
// //     { key: 'product',       width: 30 },
// //     { key: 'collection',    width: 20 },
// //     { key: 'concentration', width: 18 },
// //     { key: 'ml',            width: 10 },
// //     { key: 'presentation',  width: 16 },
// //     { key: 'wholesale',     width: 16 },
// //     { key: 'qty',           width: 16 },
// //     { key: 'total',         width: 16 },
// //   ];
// //   sheet.columns = columnDefs;

// //   // ── Fila 1: título ──
// //   const titleRow = sheet.addRow([`${vendor} — Offline Order`]);
// //   sheet.mergeCells(1, 1, 1, columnDefs.length);
// //   titleRow.font = { bold: true, size: 14, color: { argb: 'FFB7AC7E' } };
// //   titleRow.height = 22;

// //   // ── Fila 2: instrucciones ──
// //   const noteRow = sheet.addRow([
// //     'Enter the quantity you want in the "Order Quantity" column (highlighted). The Line Total and the grand total at the bottom update automatically.'
// //   ]);
// //   sheet.mergeCells(2, 1, 2, columnDefs.length);
// //   noteRow.font = { italic: true, color: { argb: 'FF6B7280' } };
// //   noteRow.height = 18;

// //   // ── Fila 3: encabezados ──
// //   const headerLabels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Wholesale Price', 'Order Quantity', 'Line Total'];
// //   const headerRow = sheet.addRow(headerLabels);
// //   headerRow.eachCell(cell => {
// //     cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
// //     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
// //     cell.alignment = { vertical: 'middle', horizontal: 'center' };
// //   });
// //   headerRow.height = 20;

// //   // Obtenemos las filas y las convertimos a Array para poder usar .sort() de forma segura
// //   const rows = Array.from(variantRows());

// //   // ══════════════════════════════════════════════════════════════
// //   // NUEVO: Lógica de ordenamiento (Perfume > Tester > Demás, y por ML descendente)
// //   // ══════════════════════════════════════════════════════════════
// //   const getMlValue = (row) => {
// //     const mlText = (row.cells[7]?.textContent || '').trim();
// //     const match = mlText.match(/(\d+(?:\.\d+)?)/); // Extrae el número (ej: "100ml" -> 100)
// //     return match ? parseFloat(match[1]) : 0;
// //   };

// //   const getSortPriority = (row) => {
// //     const presentation = (row.cells[8]?.textContent || '').toLowerCase();
// //     if (presentation.includes('perfume')) return 1;
// //     if (presentation.includes('tester')) return 2;
// //     return 3; // "demás"
// //   };

// //   rows.sort((a, b) => {
// //     const prioA = getSortPriority(a);
// //     const prioB = getSortPriority(b);

// //     // 1. Ordenar por prioridad de presentación
// //     if (prioA !== prioB) {
// //       return prioA - prioB;
// //     }

// //     // 2. Si la prioridad es igual, ordenar por ML de mayor a menor (descendente)
// //     const mlA = getMlValue(a);
// //     const mlB = getMlValue(b);
// //     return mlB - mlA;
// //   });
// //   // ══════════════════════════════════════════════════════════════

// //   const firstDataRow = 4; // 1=título, 2=nota, 3=encabezado -> datos desde la fila 4

// //   // Pre-cargar imágenes únicas EN PARALELO (misma técnica que en el catálogo completo)
// //   const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
// //   const imageCache = {};
// //   await Promise.all(uniqueUrls.map(async url => {
// //     try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
// //     catch (e) { imageCache[url] = null; }
// //   }));

// //   // ── Filas de datos, una por variante en pantalla, con Qty vacío y
// //   //    Line Total como fórmula = Wholesale (H) * Order Quantity (I) ──
// //   rows.forEach((row, idx) => {
// //     const excelRowNumber = firstDataRow + idx;
// //     const wholesale = parseFloat(row.dataset.unitPrice || 0);

// //     const excelRow = sheet.addRow({
// //       sku:           (row.dataset.sku || '-').toUpperCase(),
// //       photo:         '',
// //       product:       row.cells[5]?.textContent?.trim() || '',
// //       collection:    row.cells[4]?.textContent?.trim() || '',
// //       concentration: row.cells[6]?.textContent?.trim() || '',
// //       ml:            row.cells[7]?.textContent?.trim() || '',
// //       presentation:  row.cells[8]?.textContent?.trim() || '',
// //       wholesale:     wholesale,
// //       qty:           null, // el cliente lo llena
// //       total:         { formula: `H${excelRowNumber}*I${excelRowNumber}` },
// //     });
// //     excelRow.height = 50;
// //     excelRow.alignment = { vertical: 'middle' };

// //     excelRow.getCell('wholesale').numFmt = '$#,##0.00';
// //     excelRow.getCell('total').numFmt = '$#,##0.00';

// //     // Resaltar la celda de cantidad como "editable"
// //     const qtyCell = excelRow.getCell('qty');
// //     qtyCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF7D6' } };
// //     qtyCell.border = {
// //       top:    { style: 'thin', color: { argb: 'FFB8A77D' } },
// //       left:   { style: 'thin', color: { argb: 'FFB8A77D' } },
// //       bottom: { style: 'thin', color: { argb: 'FFB8A77D' } },
// //       right:  { style: 'thin', color: { argb: 'FFB8A77D' } },
// //     };

// //     // Insertar la foto del producto (columna B) si se pudo cargar
// //     const url = row.dataset.imgUrl;
// //     if (url && imageCache[url]) {
// //       const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
// //       sheet.addImage(imageId, {
// //         tl: { col: 1.1, row: excelRowNumber - 1 + 0.1 },
// //         ext: { width: 45, height: 45 },
// //       });
// //     }
// //   });

// //   // ── Fila de totales al final (SUM sobre Order Quantity y Line Total) ──
// //   const lastDataRow    = firstDataRow + rows.length - 1;
// //   const totalRowNumber = lastDataRow + 2; // deja una fila en blanco de separación

// //   const totalRow = sheet.getRow(totalRowNumber);
// //   totalRow.getCell(1).value = 'Estimated Total';
// //   totalRow.getCell(1).font  = { bold: true, size: 12 };
// //   sheet.mergeCells(totalRowNumber, 1, totalRowNumber, 7);

// //   const totalQtyCell = totalRow.getCell('qty');
// //   totalQtyCell.value = { formula: `SUM(I${firstDataRow}:I${lastDataRow})` };
// //   totalQtyCell.font  = { bold: true };

// //   const totalAmountCell = totalRow.getCell('total');
// //   totalAmountCell.value  = { formula: `SUM(J${firstDataRow}:J${lastDataRow})` };
// //   totalAmountCell.font   = { bold: true, size: 12 };
// //   totalAmountCell.numFmt = '$#,##0.00';

// //   totalRow.eachCell(cell => {
// //     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEDE9E4' } };
// //   });
// //   totalRow.height = 22;

// //   // Congela título + nota + encabezado al hacer scroll
// //   sheet.views = [{ state: 'frozen', ySplit: 3 }];

// //   const buffer = await workbook.xlsx.writeBuffer();
// //   let binary = '';
// //   const bytes = new Uint8Array(buffer);
// //   for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
// //   return btoa(binary);
// // }

// async function generateOfflineOrderTemplateBase64() {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

//   const workbook = new ExcelJS.Workbook();
//   workbook.creator = vendor;
//   workbook.created = new Date();

//   const sheet = workbook.addWorksheet('Offline Order');

//   // Columnas SIN "header" (evita el patrón frágil de mezclar
//   // sheet.columns-con-header + insertRow que ya nos dio problemas antes).
//   const columnDefs = [
//     { key: 'sku',           width: 24 },
//     { key: 'photo',         width: 12 },
//     { key: 'product',       width: 30 },
//     { key: 'collection',    width: 20 },
//     { key: 'concentration', width: 18 },
//     { key: 'ml',            width: 10 },
//     { key: 'presentation',  width: 16 },
//     { key: 'wholesale',     width: 16 },
//     { key: 'qty',           width: 16 },
//     { key: 'total',         width: 16 },
//   ];
//   sheet.columns = columnDefs;

//   // ── Fila 1: título ──
//   const titleRow = sheet.addRow([`${vendor} — Offline Order`]);
//   sheet.mergeCells(1, 1, 1, columnDefs.length);
//   titleRow.font = { bold: true, size: 14, color: { argb: 'FFB7AC7E' } };
//   titleRow.height = 22;

//   // ── Fila 2: instrucciones ──
//   const noteRow = sheet.addRow([
//     'Enter the quantity you want in the "Order Quantity" column (highlighted). The Line Total and the grand total at the bottom update automatically. Use the filter arrows on the header row to filter by Presentation (Perfume, Tester, Vial, etc.).'
//   ]);
//   sheet.mergeCells(2, 1, 2, columnDefs.length);
//   noteRow.font = { italic: true, color: { argb: 'FF6B7280' } };
//   noteRow.height = 18;

//   // ── Fila 3: encabezados ──
//   const headerLabels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Wholesale Price', 'Order Quantity', 'Line Total'];
//   const headerRow = sheet.addRow(headerLabels);
//   headerRow.eachCell(cell => {
//     cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
//     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
//     cell.alignment = { vertical: 'middle', horizontal: 'center' };
//   });
//   headerRow.height = 20;

//   // Obtenemos las filas y las convertimos a Array para poder usar .sort() de forma segura
//   const rows = Array.from(variantRows());

//   // ══════════════════════════════════════════════════════════════
//   // Lógica de ordenamiento (Perfume > Tester > Demás, y por ML descendente)
//   // ══════════════════════════════════════════════════════════════
//   const getMlValue = (row) => {
//     const mlText = (row.cells[7]?.textContent || '').trim();
//     const match = mlText.match(/(\d+(?:\.\d+)?)/); // Extrae el número (ej: "100ml" -> 100)
//     return match ? parseFloat(match[1]) : 0;
//   };

//   const getSortPriority = (row) => {
//     const presentation = (row.cells[8]?.textContent || '').toLowerCase();
//     if (presentation.includes('perfume')) return 1;
//     if (presentation.includes('tester')) return 2;
//     return 3; // "demás"
//   };

//   rows.sort((a, b) => {
//     const prioA = getSortPriority(a);
//     const prioB = getSortPriority(b);

//     if (prioA !== prioB) {
//       return prioA - prioB;
//     }

//     const mlA = getMlValue(a);
//     const mlB = getMlValue(b);
//     return mlB - mlA;
//   });
//   // ══════════════════════════════════════════════════════════════

//   const firstDataRow = 4; // 1=título, 2=nota, 3=encabezado -> datos desde la fila 4

//   // Pre-cargar imágenes únicas EN PARALELO (misma técnica que en el catálogo completo)
//   const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
//   const imageCache = {};
//   await Promise.all(uniqueUrls.map(async url => {
//     try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
//     catch (e) { imageCache[url] = null; }
//   }));

//   // ── Filas de datos, una por variante en pantalla, con Qty vacío y
//   //    Line Total como fórmula = Wholesale (H) * Order Quantity (I) ──
//   rows.forEach((row, idx) => {
//     const excelRowNumber = firstDataRow + idx;
//     const wholesale = parseFloat(row.dataset.unitPrice || 0);

//     const excelRow = sheet.addRow({
//       sku:           (row.dataset.sku || '-').toUpperCase(),
//       photo:         '',
//       product:       row.cells[5]?.textContent?.trim() || '',
//       collection:    row.cells[4]?.textContent?.trim() || '',
//       concentration: row.cells[6]?.textContent?.trim() || '',
//       ml:            row.cells[7]?.textContent?.trim() || '',
//       presentation:  row.cells[8]?.textContent?.trim() || '',
//       wholesale:     wholesale,
//       qty:           null, // el cliente lo llena
//       total:         { formula: `H${excelRowNumber}*I${excelRowNumber}` },
//     });
//     excelRow.height = 50;
//     excelRow.alignment = { vertical: 'middle' };

//     excelRow.getCell('wholesale').numFmt = '$#,##0.00';
//     excelRow.getCell('total').numFmt = '$#,##0.00';

//     // Resaltar la celda de cantidad como "editable"
//     const qtyCell = excelRow.getCell('qty');
//     qtyCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF7D6' } };
//     qtyCell.border = {
//       top:    { style: 'thin', color: { argb: 'FFB8A77D' } },
//       left:   { style: 'thin', color: { argb: 'FFB8A77D' } },
//       bottom: { style: 'thin', color: { argb: 'FFB8A77D' } },
//       right:  { style: 'thin', color: { argb: 'FFB8A77D' } },
//     };

//     // Insertar la foto del producto (columna B) si se pudo cargar
//     const url = row.dataset.imgUrl;
//     if (url && imageCache[url]) {
//       const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
//       sheet.addImage(imageId, {
//         tl: { col: 1.1, row: excelRowNumber - 1 + 0.1 },
//         ext: { width: 45, height: 45 },
//       });
//     }
//   });

//   // ── Fila de totales al final (SUM sobre Order Quantity y Line Total) ──
//   const lastDataRow    = firstDataRow + rows.length - 1;
//   const totalRowNumber = lastDataRow + 2; // deja una fila en blanco de separación

//   const totalRow = sheet.getRow(totalRowNumber);
//   totalRow.getCell(1).value = 'Estimated Total';
//   totalRow.getCell(1).font  = { bold: true, size: 12 };
//   sheet.mergeCells(totalRowNumber, 1, totalRowNumber, 7);

//   const totalQtyCell = totalRow.getCell('qty');
//   totalQtyCell.value = { formula: `SUM(I${firstDataRow}:I${lastDataRow})` };
//   totalQtyCell.font  = { bold: true };

//   const totalAmountCell = totalRow.getCell('total');
//   totalAmountCell.value  = { formula: `SUM(J${firstDataRow}:J${lastDataRow})` };
//   totalAmountCell.font   = { bold: true, size: 12 };
//   totalAmountCell.numFmt = '$#,##0.00';

//   totalRow.eachCell(cell => {
//     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEDE9E4' } };
//   });
//   totalRow.height = 22;

//   // ── AutoFilter en la fila de encabezados (fila 3) ──
//   sheet.autoFilter = {
//     from: { row: 3, column: 1 },
//     to:   { row: lastDataRow, column: columnDefs.length },
//   };

//   // Congela título + nota + encabezado al hacer scroll
//   sheet.views = [{ state: 'frozen', ySplit: 3 }];

//   const buffer = await workbook.xlsx.writeBuffer();
//   let binary = '';
//   const bytes = new Uint8Array(buffer);
//   for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
//   return btoa(binary);
// }



// // async function generateCatalogPdfBase64() {
// //   try {
// //     const { jsPDF } = window.jspdf;
// //     if (!jsPDF) { console.error('jsPDF not loaded'); return null; }

// //     const vendor  = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
// //     const doc     = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
// //     const pageW   = doc.internal.pageSize.getWidth();
// //     const pageH   = doc.internal.pageSize.getHeight();
// //     const margin  = 10;
// //     const colW    = pageW - margin * 2;
// //     let y = margin;

// //     const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };

// //     // ── Título ──
// //     doc.setFontSize(14); doc.setFont('helvetica', 'bold');
// //     doc.text(`${vendor} — Product List`, pageW / 2, y, { align: 'center' }); y += 7;
// //     doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
// //     doc.text(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pageW / 2, y, { align: 'center' });
// //     doc.setTextColor(0, 0, 0); y += 8;

// //     // ── Cabecera tabla ──
// //     const cols   = [28, 50, 30, 24, 16, 20, 20, 22, 16, 22, 22];
// //     const labels = ['SKU', 'Product', 'Collection', 'Type', 'ML', 'Presentation', 'Brand MSRP', 'Wholesale', 'Stock', 'First Min Qty', 'Next Min Qty'];

// //     doc.setFillColor(30, 30, 30);
// //     doc.rect(margin, y, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
// //     let cx = margin + 1;
// //     labels.forEach((lbl, i) => { doc.text(lbl, cx, y + 4.5); cx += cols[i]; });
// //     doc.setTextColor(0, 0, 0); y += 8;

// //     // ── Filas ──
// //     let rowCount = 0;
// //     variantRows().forEach(row => {
// //       checkPage(7);
// //       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
// //       doc.rect(margin, y - 1, colW, 7, 'F');
// //       doc.setFontSize(6.5); doc.setFont('helvetica', 'normal');

// //       const values = [
// //         (row.dataset.sku || '-').toUpperCase().substring(0, 14),
// //         (row.cells[5]?.textContent?.trim() || '').substring(0, 28),
// //         (row.cells[4]?.textContent?.trim() || '').substring(0, 18),
// //         (row.cells[6]?.textContent?.trim() || '').substring(0, 14),
// //         (row.cells[7]?.textContent?.trim() || '').substring(0, 8),
// //         (row.cells[8]?.textContent?.trim() || '').substring(0, 12),
// //         (row.cells[11]?.textContent?.trim() || '').substring(0, 10),
// //         '$' + parseFloat(row.dataset.unitPrice || 0).toFixed(2),
// //         String(parseInt(row.dataset.stock || 0)),
// //         row.dataset.firstMinQty || '1',
// //         row.dataset.nextMinQty  || '—'
// //       ];

// //       let cx2 = margin + 1;
// //       values.forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += cols[i]; });
// //       y += 7; rowCount++;
// //     });

// //     const pdfBase64 = doc.output('datauristring').split(',')[1];
// //     if (!pdfBase64) { console.error('Catalog PDF base64 is empty'); return null; }
// //     return pdfBase64;

// //   } catch (err) {
// //     console.error('Error generating catalog PDF base64:', err);
// //     return null;
// //   }
// // }


// // async function generateCatalogBase64() {
// //   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
 
// //   const workbook = new ExcelJS.Workbook();
// //   workbook.creator = vendor;
// //   workbook.created = new Date();
 
// //   const sheet = workbook.addWorksheet('Catalog');
 
// //   sheet.columns = [
// //     { header: 'SKU',             key: 'sku',           width: 20 },
// //     { header: 'Photo',           key: 'photo',         width: 14 },
// //     { header: 'Product',         key: 'product',       width: 30 },
// //     { header: 'Collection',      key: 'collection',    width: 20 },
// //     { header: 'Concentration',   key: 'concentration', width: 18 },
// //     { header: 'ML',              key: 'ml',             width: 10 },
// //     { header: 'Presentation',    key: 'presentation',  width: 14 },
// //     { header: 'Brand MSRP',      key: 'msrp',          width: 14 },
// //     { header: 'Wholesale Price', key: 'wholesale',     width: 16 },
// //     { header: 'Stock',           key: 'stock',         width: 10 },
// //   ];
 
// //   const headerRow = sheet.getRow(1);
// //   headerRow.eachCell((cell) => {
// //     cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
// //     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
// //     cell.alignment = { vertical: 'middle', horizontal: 'center' };
// //   });
// //   headerRow.height = 20;
 
// //   const rows = variantRows();
 
// //   // ── Pre-cargar imágenes únicas EN PARALELO (fotos chicas, no las originales) ──
// //   const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
// //   const imageCache = {};
// //   await Promise.all(uniqueUrls.map(async url => {
// //     try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
// //     catch (e) { imageCache[url] = null; }
// //   }));
 
// //   rows.forEach((row, index) => {
// //     const excelRow = sheet.addRow({
// //       sku:           (row.dataset.sku || '-').toUpperCase(),
// //       photo:         '',
// //       product:       row.cells[5]?.textContent?.trim() || '',
// //       collection:    row.cells[4]?.textContent?.trim() || '',
// //       concentration: row.cells[6]?.textContent?.trim() || '',
// //       ml:            row.cells[7]?.textContent?.trim() || '',
// //       presentation:  row.cells[8]?.textContent?.trim() || '',
// //       msrp:          row.cells[11]?.textContent?.trim() || '',
// //       wholesale:     parseFloat(row.dataset.unitPrice || 0),
// //       stock:         parseInt(row.dataset.stock || 0),
// //     });
// //     excelRow.height = 60;
// //     excelRow.alignment = { vertical: 'middle' };
 
// //     const url = row.dataset.imgUrl;
// //     if (url && imageCache[url]) {
// //       const rowNumber = index + 2; // +1 header, +1 base 1
// //       const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
// //       sheet.addImage(imageId, {
// //         tl: { col: 1.05, row: rowNumber - 1 + 0.05 },
// //         ext: { width: 55, height: 55 },
// //       });
// //     }
// //   });
 
// //   const buffer = await workbook.xlsx.writeBuffer();
// //   let binary = '';
// //   const bytes = new Uint8Array(buffer);
// //   for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
// //   return btoa(binary);
// // }


//   function resetSendModal() {
//       getEl('send-modal').style.display = 'none';
//       document.body.style.overflow = '';
//       // ── Restaurar siempre a modo incentives ──
//       const modeEl      = getEl('send-modal-mode');
//       const titleEl     = getEl('send-modal-title');
//       const formatSection = getEl('send-format-section');
//       if (modeEl)       modeEl.value        = 'incentives';
//       if (titleEl)      titleEl.textContent  = 'Send Incentives';
//       if (formatSection) formatSection.style.display = '';
//       // ── Limpiar campos ──
//       const nameEl  = getEl('send-name');
//       const emailEl = getEl('send-to-email');
//       const msgEl   = getEl('send-message');
//       if (nameEl)  nameEl.value  = '';
//       if (emailEl) emailEl.value = '';
//       if (msgEl)   msgEl.value   = '';
//       // ── Restaurar radio a Excel ──
//       const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
//       if (excelRadio) excelRadio.checked = true;
//   }





// function initSendModal() {
//   const sendBtn = getEl('guidelines-export-send-btn');
//   if (!sendBtn || sendBtn.dataset.listenerAttached) return;

//  sendBtn.addEventListener('click', () => {
//   // Limpiar botones anteriores
//   getEl('catalog-download-btns')?.remove();
//   getEl('incentives-download-btns')?.remove();
//   getEl('preorder-download-btns')?.remove();
//   document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

//   const modeEl        = getEl('send-modal-mode');
//   const titleEl       = getEl('send-modal-title');
//   const formatSection = getEl('send-format-section');

//   if (modeEl)         modeEl.value        = 'incentives';
//   if (titleEl)        titleEl.textContent  = 'Share Incentives';
//   if (formatSection)  formatSection.style.display = '';

//   const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
//   if (excelRadio) excelRadio.checked = true;

//   // ── Botones descarga directa ──
//   const dlBtns = document.createElement('div');
//   dlBtns.id = 'incentives-download-btns';
//   dlBtns.innerHTML = `
//     <div style="    font-family: 'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #e5e7eb;">
//       <div style="    font-family: 'Crimson Pro';width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//           <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
//           <polyline points="7 10 12 15 17 10"/>
//           <line x1="12" y1="15" x2="12" y2="3"/>
//         </svg>
//       </div>
//       <div>
//         <div style="    font-family: 'Crimson Pro';font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Incentives</div>
//         <div style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
//       </div>
//     </div>

//     <div style="display:flex;gap:12px;margin-bottom:12px;">
//       <button type="button" id="incentives-dl-excel"
//         style="    font-family: 'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
//         border-radius:10px;cursor:pointer;font-family:'Crimson Pro',serif;">
//         <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
//         <div style="text-align:left;">
//           <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
//           <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
//         </div>
//       </button>
//       <button type="button" id="incentives-dl-pdf"
//         style="    font-family: 'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
//         border-radius:10px;cursor:pointer;font-family:'Crimson Pro',serif;">
//         <img src="${window._b2bPdfIconUrl}" width="32" height="28" alt="PDF">
//         <div style="text-align:left;">
//           <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
//           <div style="font-size:12px;color:#6b7280;">.pdf format</div>
//         </div>
//       </button>
//     </div>

//     <div style="text-align:center;margin-bottom:16px;">
//       <span style="    font-family: 'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:13px;color:#b8a77d;font-weight:600;">
//          Instant download – No email required
//       </span>
//     </div>

//     <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//       <span style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
//       <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
//     </div>

//     <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">
//       <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
//         <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
//           <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
//           <polyline points="22,6 12,13 2,6"/>
//         </svg>
//       </div>
//       <div>
//         <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Incentives by Email</div>
//         <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
//       </div>
//     </div>`;

//   const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
//   const firstLabel     = sendModalInner?.querySelector('label');
//   if (firstLabel) {
//     firstLabel.parentNode.insertBefore(dlBtns, firstLabel);
//   }

//   getEl('incentives-dl-excel')?.addEventListener('click', async () => {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generateGuidelinesBase64('excel');
//     if (!base64) return;
//     const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement('a');
//     a.href = url; a.download = `incentives-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
//     a.click(); URL.revokeObjectURL(url);
//   });

//   getEl('incentives-dl-pdf')?.addEventListener('click', async () => {
//     const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const base64 = await generateGuidelinesBase64('pdf');
//     if (!base64) return;
//     const blob = base64toBlob(base64, 'application/pdf');
//     const url  = URL.createObjectURL(blob);
//     const a    = document.createElement('a');
//     a.href = url; a.download = `incentives-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
//     a.click(); URL.revokeObjectURL(url);
//   });

//   const modal = getEl('send-modal');
//   if (modal) modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// });

//   sendBtn.dataset.listenerAttached = 'true';

//   // Mostrar/ocultar campo "otro correo"
//   getEl('send-email-select')?.addEventListener('change', function() {
//     const wrap = getEl('send-other-email-wrap');
//     if (wrap) wrap.style.display = this.value === 'other' ? 'block' : 'none';
//   });

//   // Cerrar
//   getEl('send-modal-cancel')?.addEventListener('click', resetSendModal);
//   getEl('send-overlay')?.addEventListener('click', resetSendModal);

//   // Confirmar envío
//   getEl('send-modal-confirm')?.addEventListener('click', async () => {
//     const name          = (getEl('send-name')?.value || '').trim();
//     const extraEmail    = (getEl('send-to-email')?.value || '').trim();
//     const message       = (getEl('send-message')?.value || '').trim();
//     const format        = document.querySelector('input[name="send-format"]:checked')?.value || 'excel';
//     const vendor        = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const customerEmail = window._b2bCustomerEmail || '';
//     const mode          = getEl('send-modal-mode')?.value || 'incentives';

//     if (!customerEmail && !extraEmail) {
//       alert('No valid email address available.'); return;
//     }

//     const confirmBtn = getEl('send-modal-confirm');
//     confirmBtn.disabled    = true;
//     confirmBtn.textContent = 'Sending...';

//     getEl('send-modal').style.display = 'none';
//     document.body.style.overflow = '';
//     lockUI('email');

//     try {
//       let excelBase64 = null;
//       let pdfBase64   = null;

//      if (mode === 'catalog') {
//         if (format === 'excel' || format === 'both') excelBase64 = await generateCatalogBase64();
//         if (format === 'pdf'   || format === 'both') pdfBase64   = await generateCatalogPdfBase64();
//       } else if (mode === 'preorder') {
//         // reusar las mismas funciones del export excel/pdf de pre-order
//         if (format === 'excel' || format === 'both') excelBase64 = await generatePreOrderExcelBase64();
//         if (format === 'pdf'   || format === 'both') pdfBase64   = await generatePreOrderPdfBase64();
//       } else {
//         if (format === 'excel' || format === 'both') excelBase64 = await generateGuidelinesBase64('excel');
//         if (format === 'pdf'   || format === 'both') pdfBase64   = await generateGuidelinesBase64('pdf');
// }

//       const res = await fetch('https://shopifyadminapi.8motiv.com/api/SendEmailNiche', {
//         method:  'POST',
//         headers: { 'Content-Type': 'application/json' },
//         body: JSON.stringify({
//           toEmail:       customerEmail || null,
//           extraEmail:    extraEmail    || null,
//           recipientName: name,
//           vendorName:    vendor,
//           message:       message,
//           format:        format,
//           mode:          mode,
//           excelBase64:   excelBase64,
//           pdfBase64:     pdfBase64
//         })
//       });

//       const data = await res.json();
//       if (data.success) {
//         const recipients = [customerEmail, extraEmail].filter(Boolean).join(' and ');
//         showOverlayResult(true, `Sent to ${recipients}`);
//         resetSendModal();
//       } else {
//         showOverlayResult(false, data.message || 'Please try again.');
//       }
//     } catch (err) {
//       showOverlayResult(false, 'We are currently unable to send emails. Please try again later or contact support.');
//       console.log(false, 'Connection error: ' + err.message);
//     } finally {
//       confirmBtn.disabled  = false;
//       confirmBtn.innerHTML = '✉ Send';
//     }
//   });
// }

// // ── Helper base64 a Blob ──
// function base64toBlob(base64, mimeType) {
//   const bytes  = atob(base64);
//   const buffer = new ArrayBuffer(bytes.length);
//   const view   = new Uint8Array(buffer);
//   for (let i = 0; i < bytes.length; i++) view[i] = bytes.charCodeAt(i);
//   return new Blob([buffer], { type: mimeType });
// }

// // async function generatePreOrderExcelBase64() {
// //   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

// //   const wb = XLSX.utils.book_new();

// //   // ── Agrupar filas principales por presentación ──
// //   const groupedRows = {};
// //   const groupOrder  = [];

// //   variantRows().forEach(row => {
// //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //     if (!qty) return;
// //     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
// //     const presLower = presDisp.toLowerCase();
// //     let groupKey = 'Others';
// //     if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
// //     else if (presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
// //     else if (presLower.includes('retail'))                               groupKey = 'Retail';
// //     else if (presLower.includes('travel'))                               groupKey = 'Travel Set';
// //     else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;

// //     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
// //     groupedRows[groupKey].push(row);
// //   });

// //   // ── Hoja principal con grupos ──
// //   const mainData = [];
// //   mainData.push([`${vendor} — Pre Order`]);
// //   mainData.push([new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' })]);
// //   mainData.push([]);

// //   let grandTotal = 0, totalItems = 0;
// //   const groupSummary = [];

// //   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
// //   const sortedGroups = [
// //     ...preferredOrder.filter(g => groupedRows[g]),
// //     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
// //   ];

// //   sortedGroups.forEach(groupKey => {
// //     const rows = groupedRows[groupKey];
// //     if (!rows?.length) return;

// //     mainData.push([groupKey.toUpperCase()]);
// //     mainData.push(['Photo', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'Qty', 'Unit Price', 'Total']);

// //     let groupTotal = 0, groupQty = 0;

// //     rows.forEach(row => {
// //       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
// //       const subtotal  = qty * unitPrice;
// //       groupTotal += subtotal;
// //       groupQty   += qty;
// //       grandTotal += subtotal;
// //       totalItems += qty;

// //       mainData.push([
// //         '',
// //         row.cells[5]?.textContent?.trim() || '',
// //         (row.dataset.sku || '-').toUpperCase(),
// //         row.cells[7]?.textContent?.trim() || '',
// //         row.cells[8]?.textContent?.trim() || '',
// //         row.cells[4]?.textContent?.trim() || '',
// //         row.cells[10]?.textContent?.trim() || '',
// //         qty,
// //         unitPrice,
// //         subtotal
// //       ]);
// //     });

// //     mainData.push(['', '', '', '', '', '', '', groupQty, '', groupTotal]);
// //     mainData.push([]);
// //     groupSummary.push({ key: groupKey, qty: groupQty, total: groupTotal });
// //   });

// //   // ── Incentivos ──
// //   const freeRowsExcel = [];
// //   const incentiveByPres = {};

// //   const addIncentivePres = (pres, qty, pack) => {
// //     const isVails = (pres || '').toLowerCase().includes('vail');
// //     const total   = isVails ? qty * (parseInt(pack) || 1) : qty;
// //     incentiveByPres[pres || '—'] = (incentiveByPres[pres || '—'] || 0) + total;
// //   };

// //   variantRows().forEach(row => {
// //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //     if (!qty) return;
// //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
// //     if (!variantHasIncentive(extras)) return;
// //     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
// //     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
// //     const fps    = getVariantFreeProducts(extras);
// //     const fqs    = getVariantFreeQtys(extras);
// //     const mult   = calcVariantMultiplier(extras, qty, lineV);
// //     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

// //     if (fps.length > 1) {
// //       if (!choice?.confirmed) return;
// //       const vid2 = String(choice.chosenVariantId || '');
// //       const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
// //       const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
// //       freeRowsExcel.push(['FREE', choice.chosenTitle, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', choice.chosenQty, 0, 0]);
// //       addIncentivePres(vd2.pres, choice.chosenQty, ex2.quantity);
// //     } else {
// //       fps.forEach((fp, i) => {
// //         if (!fp?.title) return;
// //         const giftQty = (fqs[i] || 1) * mult;
// //         const vid2    = String(fp.variant_id || '');
// //         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
// //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //         freeRowsExcel.push(['FREE', fp.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', giftQty, 0, 0]);
// //         addIncentivePres(vd2.pres, giftQty, ex2.quantity);
// //       });
// //     }
// //   });

// //   const p2 = window.b2bPriority2Choice || {};
// //   let p2Subtotal = 0;
// //   if (p2.confirmed) {
// //     (p2.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
// //       const vid2  = String(s.variant_id || '');
// //       const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
// //       const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
// //       const price = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
// //       const disc  = parseFloat(p2.discountPct || 0);
// //       const final = price * (1 - disc / 100) * s.selectedQty;
// //       p2Subtotal += final;
// //       freeRowsExcel.push([`${disc}% Credit`, `${s.title}`, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', s.selectedQty, price*(1-disc/100), final]);
// //       addIncentivePres(vd2.pres, s.selectedQty, ex2.quantity);
// //     });
// //   }

// //   const p3 = window.b2bPriority3Choice || {};
// //   if (p3.confirmed) {
// //     (p3.selections || []).forEach(sel => {
// //       (sel.choices || []).forEach(choice => {
// //         if (!choice.chosenQty || choice.chosenQty <= 0) return;
// //         const vid2 = String(choice.chosenVariantId || '');
// //         const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
// //         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
// //         freeRowsExcel.push(['FREE', choice.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', choice.chosenQty, 0, 0]);
// //         addIncentivePres(vd2.pres, choice.chosenQty, ex2.quantity);
// //       });
// //     });
// //   }

// //   if (freeRowsExcel.length) {
// //     mainData.push(['INCENTIVES INCLUDED']);
// //     mainData.push(['Type', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Units/Pack', 'Qty', 'Unit Price', 'Total']);
// //     freeRowsExcel.forEach(r => mainData.push(r));
// //     mainData.push([]);
// //   }

// //   // ── Order Summary ──
// //   mainData.push(['ORDER SUMMARY']);
// //   mainData.push(['Category', 'Units/Pack', 'Qty', 'Amount']);

// //   const totalIncentiveQty = parseInt(getEl('dash-total-incentives')?.textContent || '0');
// //   if (totalIncentiveQty > 0) {
// //     Object.entries(incentiveByPres).forEach(([pres, qty]) => {
// //       mainData.push([`GWP ${pres}`, '—', qty, '$0.00']);
// //     });
// //     mainData.push(['Total GWP', '—', totalIncentiveQty, '$0.00']);
// //   }

// //   groupSummary.forEach(g => {
// //     mainData.push([g.key, '—', g.qty, g.total]);
// //   });

// //   if (p2Subtotal > 0) {
// //     mainData.push([`Reward Credit (${p2.discountPct}%)`, '—', '—', p2Subtotal]);
// //   }

// //   mainData.push(['Estimated Total', '—', totalItems, grandTotal]);

// //   const ws = XLSX.utils.aoa_to_sheet(mainData);
// //   ws['!cols'] = [{wch:12},{wch:32},{wch:20},{wch:10},{wch:14},{wch:20},{wch:12},{wch:8},{wch:14},{wch:14}];
// //   XLSX.utils.book_append_sheet(wb, ws, 'Pre-Order');

// //   return XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });
// // }

// // async function generatePreOrderPdfBase64() {
// //   const { jsPDF } = window.jspdf;
// //   if (!jsPDF) return null;

// //   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
// //   const doc    = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
// //   const pageW  = doc.internal.pageSize.getWidth();
// //   const pageH  = doc.internal.pageSize.getHeight();
// //   const margin = 10, colW = pageW - margin * 2;
// //   let y = margin;

// //   const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
// //   const fmt2 = n => parseFloat(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

// //   // ── Título ──
// //   doc.setFontSize(16); doc.setFont('helvetica', 'bold');
// //   doc.text(`${vendor} — Pre Order`, pageW / 2, y + 6, { align: 'center' }); y += 10;
// //   doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120,120,120);
// //   doc.text(new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }), pageW / 2, y, { align: 'center' });
// //   doc.setTextColor(0,0,0); y += 8;

// //   // ── Columnas tabla principal ──
// //   const cols  = [52, 20, 14, 22, 30, 14, 12, 22, 22];
// //   const hdrs  = ['Product','SKU','ML','Presentation','Collection','Coefficient','Qty','Unit Price','Total'];

// //   function drawTableHeader(bgR, bgG, bgB) {
// //     doc.setFillColor(bgR||50, bgG||50, bgB||50);
// //     doc.rect(margin, y, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     let cx = margin + 2;
// //     hdrs.forEach((h, i) => { doc.text(h, cx, y + 4.5); cx += cols[i]; });
// //     doc.setTextColor(0,0,0); y += 8;
// //   }

// //   function drawGroupFooter(groupQty, groupTotal) {
// //     checkPage(8);
// //     doc.setFillColor(230,230,230);
// //     doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold');
// //     let cx2 = margin + 2;
// //     cols.slice(0,-2).forEach(w => { cx2 += w; });
// //     doc.text('Subtotal', cx2 - 20, y + 4);
// //     cx2 = margin + 2; cols.slice(0,6).forEach(w => cx2 += w);
// //     doc.text(String(groupQty), cx2, y + 4);
// //     cx2 += cols[6] + cols[7];
// //     doc.text('$' + fmt2(groupTotal), cx2, y + 4);
// //     doc.setFont('helvetica','normal');
// //     y += 9;
// //   }

// //   // ── Agrupar por presentación ──
// //   const groupedRows = {};
// //   const groupOrder  = [];

// //   variantRows().forEach(row => {
// //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //     if (!qty) return;
// //     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
// //     const presLower = presDisp.toLowerCase();
// //     let groupKey = 'Others';
// //     if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
// //     else if (presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
// //     else if (presLower.includes('retail'))                               groupKey = 'Retail';
// //     else if (presLower.includes('travel'))                               groupKey = 'Travel Set';
// //     else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;
// //     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
// //     groupedRows[groupKey].push(row);
// //   });

// //   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
// //   const sortedGroups   = [
// //     ...preferredOrder.filter(g => groupedRows[g]),
// //     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
// //   ];

// //   let grandTotal = 0, totalItems = 0, rowCount = 0;
// //   const groupSummaryPdf = [];

// //   sortedGroups.forEach(groupKey => {
// //     const rows = groupedRows[groupKey];
// //     if (!rows?.length) return;

// //     checkPage(20);
// //     // ── Header grupo ──
// //     doc.setFillColor(184,167,125);
// //     doc.rect(margin, y, colW, 8, 'F');
// //     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     doc.text(`${groupKey}  (${rows.length} item${rows.length > 1 ? 's' : ''})`, margin + 3, y + 5.5);
// //     doc.setTextColor(0,0,0); y += 10;

// //     drawTableHeader();

// //     let groupTotal = 0, groupQty = 0;

// //     rows.forEach(row => {
// //       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
// //       const subtotal  = qty * unitPrice;
// //       checkPage(8);
// //       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
// //       doc.rect(margin, y - 1, colW, 7, 'F');
// //       doc.setFontSize(7); doc.setFont('helvetica','normal');
// //       let cx = margin + 2;
// //       [
// //         (row.cells[5]?.textContent?.trim() || '').substring(0,30),
// //         (row.dataset.sku || '-').toUpperCase().substring(0,12),
// //         (row.cells[7]?.textContent?.trim() || '').substring(0,8),
// //         (row.cells[8]?.textContent?.trim() || '').substring(0,14),
// //         (row.cells[4]?.textContent?.trim() || '').substring(0,18),
// //         (row.cells[10]?.textContent?.trim() || '').substring(0,8),
// //         String(qty),
// //         '$' + unitPrice.toFixed(2),
// //         '$' + subtotal.toFixed(2)
// //       ].forEach((v, i) => { doc.text(v, cx, y + 4); cx += cols[i]; });
// //       y += 7; rowCount++;
// //       groupTotal += subtotal; groupQty += qty;
// //       grandTotal += subtotal; totalItems += qty;
// //     });

// //     drawGroupFooter(groupQty, groupTotal);
// //     groupSummaryPdf.push({ key: groupKey, qty: groupQty, total: groupTotal });
// //   });

// //   // ── Incentivos ──
// //   const freeRowsPDF = [];
// //   const incentiveByPresPDF = {};

// //   const addPresPDF = (pres, qty, pack) => {
// //     // const isVails = (pres || '').toLowerCase().includes('vail');
// //     const isVails = (pres || '').toLowerCase().includes('vial') || 
// //                 (pres || '').toLowerCase().includes('vail');
// //     const total   = isVails ? qty * (parseInt(pack) || 1) : qty;
// //     incentiveByPresPDF[pres || '—'] = (incentiveByPresPDF[pres || '—'] || 0) + total;
// //   };

// //   variantRows().forEach(row => {
// //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //     if (!qty) return;
// //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
// //     if (!variantHasIncentive(extras)) return;
// //     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
// //     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
// //     const fps    = getVariantFreeProducts(extras);
// //     const fqs    = getVariantFreeQtys(extras);
// //     const mult   = calcVariantMultiplier(extras, qty, lineV);
// //     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
// //     if (fps.length > 1) {
// //       if (!choice?.confirmed) return;
// //       const vid2 = String(choice.chosenVariantId || '');
// //       const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
// //       const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
// //       freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.chosenTitle, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:choice.chosenQty, price:'$0.00', color:[50,50,50], bg:[248,249,250]});
// //       addPresPDF(vd2.pres, choice.chosenQty, ex2.quantity);
// //     } else {
// //       fps.forEach((fp, i) => {
// //         if (!fp?.title) return;
// //         const giftQty = (fqs[i] || 1) * mult;
// //         const vid2    = String(fp.variant_id || '');
// //         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
// //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:fp.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:giftQty, price:'$0.00', color:[50,50,50], bg:[248,249,250]});
// //         addPresPDF(vd2.pres, giftQty, ex2.quantity);
// //       });
// //     }
// //   });

// //   const p2pdf = window.b2bPriority2Choice || {};
// //   let p2SubtotalPDF = 0;
// //   if (p2pdf.confirmed) {
// //     (p2pdf.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
// //       const vid2  = String(s.variant_id || '');
// //       const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
// //       const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
// //       const price = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
// //       const disc  = parseFloat(p2pdf.discountPct || 0);
// //       const final = price * (1 - disc / 100) * s.selectedQty;
// //       p2SubtotalPDF += final;
// //       freeRowsPDF.push({ badge:`${disc}%`, sku:vd2.sku||'—', title:s.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:s.selectedQty, price:`$${(price*(1-disc/100)).toFixed(2)}`, color:[50,50,50], bg:[248,249,250]});
// //       addPresPDF(vd2.pres, s.selectedQty, ex2.quantity);
// //     });
// //   }

// //   const p3pdf = window.b2bPriority3Choice || {};
// //   if (p3pdf.confirmed) {
// //     (p3pdf.selections || []).forEach(sel => {
// //       (sel.choices || []).forEach(choice => {
// //         if (!choice.chosenQty || choice.chosenQty <= 0) return;
// //         const vid2 = String(choice.chosenVariantId || '');
// //         const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
// //         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
// //         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:choice.chosenQty, price:'$0.00', color:[22,101,52], bg:[220,252,231] });
// //         addPresPDF(vd2.pres, choice.chosenQty, ex2.quantity);
// //       });
// //     });
// //   }

// //   if (freeRowsPDF.length) {
// //     checkPage(20);
// //     y += 4;
// //     doc.setFillColor(39,110,49);
// //     doc.rect(margin, y, colW, 8, 'F');
// //     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     doc.text('INCENTIVES INCLUDED', margin + 3, y + 5.5);
// //     doc.setTextColor(0,0,0); y += 10;

// //     const colsF = [12,50,14,20,14,12,10,14];
// //     const hdrsF = ['Type','Product','SKU','ML','Presentation','Pack','Qty','Price'];
// //     doc.setFillColor(50,50,50); doc.rect(margin, y, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     let cxH = margin + 2;
// //     hdrsF.forEach((h, i) => { doc.text(h, cxH, y + 4.5); cxH += colsF[i]; });
// //     doc.setTextColor(0,0,0); y += 8;

// //     freeRowsPDF.forEach(item => {
// //       checkPage(8);
// //       doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, 7, 'F');
// //       doc.setFontSize(7);
// //       let cxF = margin + 2;
// //       doc.setFont('helvetica','bold'); doc.setTextColor(...item.color);
// //       doc.text(String(item.badge), cxF, y + 4); cxF += colsF[0];
// //       doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
// //       [item.title.substring(0,30), item.sku.substring(0,10), item.ml.substring(0,8), item.pres.substring(0,12), String(item.pack), String(item.qty), item.price].forEach((v, i) => {
// //         doc.text(v, cxF, y + 4); cxF += colsF[i + 1];
// //       });
// //       y += 7;
// //     });
// //   }

// //   // ── Order Summary ──
// //   checkPage(60);
// //   y += 8;
// //   doc.setFillColor(50,50,50); doc.rect(margin, y, colW, 8, 'F');
// //   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //   doc.text('ORDER SUMMARY', margin + 3, y + 5.5);
// //   doc.setTextColor(0,0,0); y += 10;

// //   const sumCols = [120, 40, 30, 40];
// //   const sumHdrs = ['Category','Units/Pack','Qty','Amount'];
// //   doc.setFillColor(80,80,80); doc.rect(margin, y, colW, 7, 'F');
// //   doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //   let cxS = margin + 2;
// //   sumHdrs.forEach((h, i) => { doc.text(h, cxS, y + 4.5); cxS += sumCols[i]; });
// //   doc.setTextColor(0,0,0); y += 8;

// //   let sumRow = 0;

// //   const totalIncentiveQtyPDF = parseInt(getEl('dash-total-incentives')?.textContent || '0');
// //   if (totalIncentiveQtyPDF > 0) {
// //     Object.entries(incentiveByPresPDF).forEach(([pres, qty]) => {
// //       checkPage(7);
// //       doc.setFillColor(...(sumRow % 2 === 0 ? [240,252,244] : [220,252,231]));
// //       doc.rect(margin, y - 1, colW, 7, 'F');
// //       doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(22,101,52);
// //       let cx2 = margin + 2;
// //       [`GWP ${pres}`, '—', String(qty), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //       doc.setTextColor(0,0,0); y += 7; sumRow++;
// //     });
// //     checkPage(7);
// //     doc.setFillColor(200,240,210); doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(22,101,52);
// //     let cx2 = margin + 2;
// //     ['Total GWP', '—', String(totalIncentiveQtyPDF), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //     doc.setTextColor(0,0,0); y += 8; sumRow++;
// //   }

// //   groupSummaryPdf.forEach(g => {
// //     checkPage(7);
// //     doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [248,249,250]));
// //     doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','normal');
// //     let cx2 = margin + 2;
// //     [g.key, '—', String(g.qty), '$' + fmt2(g.total)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //     y += 7; sumRow++;
// //   });

// //   if (p2SubtotalPDF > 0) {
// //     checkPage(7);
// //     doc.setFillColor(219,234,254); doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(29,78,216);
// //     let cx2 = margin + 2;
// //     [`Reward Credit (${p2pdf.discountPct}%)`, '—', '—', '$' + fmt2(p2SubtotalPDF)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //     doc.setTextColor(0,0,0); y += 7;
// //   }

// //   checkPage(9);
// //   doc.setFillColor(50,50,50); doc.rect(margin, y - 1, colW, 9, 'F');
// //   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //   let cx2 = margin + 2;
// //   ['Estimated Total', '—', String(totalItems), '$' + fmt2(grandTotal)].forEach((v, i) => { doc.text(v, cx2, y + 5.5); cx2 += sumCols[i]; });

// //   return doc.output('datauristring').split(',')[1];
// // }


// async function generatePreOrderExcelBase64() {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
 
//   const wb = XLSX.utils.book_new();
 
//   const groupedRows = {};
//   const groupOrder  = [];
 
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
//     const presLower = presDisp.toLowerCase();
//     let groupKey = 'Others';
//     if (presLower.includes('perfume'))                                              groupKey = 'Perfumes';
//     else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
//     else if (presLower.includes('retail'))                                          groupKey = 'Retail';
//     else if (presLower.includes('travel'))                                          groupKey = 'Travel Set';
//     else if (presDisp && presDisp !== 'N/A')                                        groupKey = presDisp;
 
//     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
//     groupedRows[groupKey].push(row);
//   });
 
//   const mainData = [];
//   mainData.push([`${vendor} — Pre Order`]);
//   mainData.push([new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' })]);
//   mainData.push([]);
 
//   let grandTotal = 0, totalItems = 0;
//   const groupSummary = [];
 
//   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
//   const sortedGroups = [
//     ...preferredOrder.filter(g => groupedRows[g]),
//     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
//   ];
 
//   sortedGroups.forEach(groupKey => {
//     const rows = groupedRows[groupKey];
//     if (!rows?.length) return;
 
//     mainData.push([groupKey.toUpperCase()]);
//     mainData.push(['Photo', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'Qty', 'Unit Price', 'Total']);
 
//     let groupTotal = 0, groupQty = 0;
 
//     rows.forEach(row => {
//       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
//       const subtotal  = qty * unitPrice;
//       groupTotal += subtotal;
//       groupQty   += qty;
//       grandTotal += subtotal;
//       totalItems += qty;
 
//       mainData.push([
//         '',
//         row.cells[5]?.textContent?.trim() || '',
//         (row.dataset.sku || '-').toUpperCase(),
//         row.cells[7]?.textContent?.trim() || '',
//         row.cells[8]?.textContent?.trim() || '',
//         row.cells[4]?.textContent?.trim() || '',
//         row.cells[10]?.textContent?.trim() || '',
//         qty,
//         unitPrice,
//         subtotal
//       ]);
//     });
 
//     mainData.push(['', '', '', '', '', '', '', groupQty, '', groupTotal]);
//     mainData.push([]);
//     groupSummary.push({ key: groupKey, qty: groupQty, total: groupTotal });
//   });
 
//   const freeRowsExcel = [];
//   const incentiveByPres = {};
 
//   const addIncentivePres = (pres, qty, pack) => {
//     const isVials = (pres || '').toLowerCase().includes('vial') ||
//                     (pres || '').toLowerCase().includes('vail');
//     const packVal = parseInt(pack) > 0 ? parseInt(pack) : 1;
//     const total   = isVials ? qty * packVal : qty;
//     incentiveByPres[pres || '—'] = (incentiveByPres[pres || '—'] || 0) + total;
//   };
 
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     const fps    = getVariantFreeProducts(extras);
//     const fqs    = getVariantFreeQtys(extras);
//     const mult   = calcVariantMultiplier(extras, qty, lineV);
//     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
 
//     if (fps.length > 1) {
//       if (!choice?.confirmed) return;
//       const vid2   = String(choice.chosenVariantId || '');
//       const vd2    = window.b2bAllVariantsMap?.[vid2] || {};
//       const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
//       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//       freeRowsExcel.push(['FREE', choice.chosenTitle, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', choice.chosenQty, 0, 0]);
//       addIncentivePres(vd2.pres, choice.chosenQty, packVal);
//     } else {
//       fps.forEach((fp, i) => {
//         if (!fp?.title) return;
//         const giftQty = (fqs[i] || 1) * mult;
//         const vid2    = String(fp.variant_id || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//         freeRowsExcel.push(['FREE', fp.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', giftQty, 0, 0]);
//         addIncentivePres(vd2.pres, giftQty, packVal);
//       });
//     }
//   });
 
//   const p2 = window.b2bPriority2Choice || {};
//   let p2Subtotal = 0;
//   if (p2.confirmed) {
//     (p2.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
//       const vid2    = String(s.variant_id || '');
//       const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//       const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//       const price   = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
//       const disc    = parseFloat(p2.discountPct || 0);
//       const final   = price * (1 - disc / 100) * s.selectedQty;
//       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//       p2Subtotal += final;
//       freeRowsExcel.push([`${disc}% Credit`, `${s.title}`, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', s.selectedQty, price*(1-disc/100), final]);
//       addIncentivePres(vd2.pres, s.selectedQty, packVal);
//     });
//   }
 
//   const p3 = window.b2bPriority3Choice || {};
//   if (p3.confirmed) {
//     (p3.selections || []).forEach(sel => {
//       (sel.choices || []).forEach(choice => {
//         if (!choice.chosenQty || choice.chosenQty <= 0) return;
//         const vid2    = String(choice.chosenVariantId || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//         freeRowsExcel.push(['FREE', choice.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', choice.chosenQty, 0, 0]);
//         addIncentivePres(vd2.pres, choice.chosenQty, packVal);
//       });
//     });
//   }
 
//   if (freeRowsExcel.length) {
//     mainData.push(['INCENTIVES INCLUDED']);
//     mainData.push(['Type', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Units/Pack', 'Qty', 'Unit Price', 'Total']);
//     freeRowsExcel.forEach(r => mainData.push(r));
//     mainData.push([]);
//   }
 
//   mainData.push(['ORDER SUMMARY']);
//   mainData.push(['Category', 'Units/Pack', 'Qty', 'Amount']);
 
//   const totalIncentiveQty = parseInt(getEl('dash-total-incentives')?.textContent || '0');
//   if (totalIncentiveQty > 0) {
//     Object.entries(incentiveByPres).forEach(([pres, qty]) => {
//       mainData.push([`GWP ${pres}`, '—', qty, '$0.00']);
//     });
//     mainData.push(['Total GWP', '—', totalIncentiveQty, '$0.00']);
//   }
 
//   groupSummary.forEach(g => {
//     mainData.push([g.key, '—', g.qty, g.total]);
//   });
 
//   if (p2Subtotal > 0) {
//     mainData.push([`Reward Credit (${p2.discountPct}%)`, '—', '—', p2Subtotal]);
//   }
 
//   mainData.push(['Estimated Total', '—', totalItems, grandTotal]);
 
//   const ws = XLSX.utils.aoa_to_sheet(mainData);
//   ws['!cols'] = [{wch:12},{wch:32},{wch:20},{wch:10},{wch:14},{wch:20},{wch:12},{wch:8},{wch:14},{wch:14}];
//   XLSX.utils.book_append_sheet(wb, ws, 'Pre-Order');
 
//   return XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });
// }
 
 
// // async function generatePreOrderPdfBase64() {
// //   const { jsPDF } = window.jspdf;
// //   if (!jsPDF) return null;
 
// //   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
// //   const doc    = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
// //   const pageW  = doc.internal.pageSize.getWidth();
// //   const pageH  = doc.internal.pageSize.getHeight();
// //   const margin = 10, colW = pageW - margin * 2;
// //   let y = margin;
 
// //   const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
// //   const fmt2 = n => parseFloat(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
 
// //   doc.setFontSize(16); doc.setFont('helvetica', 'bold');
// //   doc.text(`${vendor} — Pre Order`, pageW / 2, y + 6, { align: 'center' }); y += 10;
// //   doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120,120,120);
// //   doc.text(new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }), pageW / 2, y, { align: 'center' });
// //   doc.setTextColor(0,0,0); y += 8;
 
// //   const cols = [52, 20, 14, 22, 30, 14, 12, 22, 22];
// //   const hdrs = ['Product','SKU','ML','Presentation','Collection','Coefficient','Qty','Unit Price','Total'];
 
// //   function drawTableHeader() {
// //     doc.setFillColor(50,50,50);
// //     doc.rect(margin, y, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     let cx = margin + 2;
// //     hdrs.forEach((h, i) => { doc.text(h, cx, y + 4.5); cx += cols[i]; });
// //     doc.setTextColor(0,0,0); y += 8;
// //   }
 
// //   function drawGroupFooter(groupQty, groupTotal) {
// //     checkPage(8);
// //     doc.setFillColor(230,230,230);
// //     doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold');
// //     let cx2 = margin + 2;
// //     cols.slice(0,6).forEach(w => cx2 += w);
// //     doc.text(String(groupQty), cx2, y + 4);
// //     cx2 += cols[6] + cols[7];
// //     doc.text('$' + fmt2(groupTotal), cx2, y + 4);
// //     doc.setFont('helvetica','normal');
// //     y += 9;
// //   }
 
// //   const groupedRows = {};
// //   const groupOrder  = [];
 
// //   variantRows().forEach(row => {
// //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //     if (!qty) return;
// //     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
// //     const presLower = presDisp.toLowerCase();
// //     let groupKey = 'Others';
// //     if (presLower.includes('perfume'))                                              groupKey = 'Perfumes';
// //     else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
// //     else if (presLower.includes('retail'))                                          groupKey = 'Retail';
// //     else if (presLower.includes('travel'))                                          groupKey = 'Travel Set';
// //     else if (presDisp && presDisp !== 'N/A')                                        groupKey = presDisp;
// //     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
// //     groupedRows[groupKey].push(row);
// //   });
 
// //   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
// //   const sortedGroups   = [
// //     ...preferredOrder.filter(g => groupedRows[g]),
// //     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
// //   ];
 
// //   let grandTotal = 0, totalItems = 0, rowCount = 0;
// //   const groupSummaryPdf = [];
 
// //   sortedGroups.forEach(groupKey => {
// //     const rows = groupedRows[groupKey];
// //     if (!rows?.length) return;
 
// //     checkPage(20);
// //     doc.setFillColor(184,167,125);
// //     doc.rect(margin, y, colW, 8, 'F');
// //     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     doc.text(`${groupKey}  (${rows.length} item${rows.length > 1 ? 's' : ''})`, margin + 3, y + 5.5);
// //     doc.setTextColor(0,0,0); y += 10;
 
// //     drawTableHeader();
 
// //     let groupTotal = 0, groupQty = 0;
 
// //     rows.forEach(row => {
// //       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
// //       const subtotal  = qty * unitPrice;
// //       checkPage(8);
// //       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
// //       doc.rect(margin, y - 1, colW, 7, 'F');
// //       doc.setFontSize(7); doc.setFont('helvetica','normal');
// //       let cx = margin + 2;
// //       [
// //         (row.cells[5]?.textContent?.trim() || '').substring(0,30),
// //         (row.dataset.sku || '-').toUpperCase().substring(0,12),
// //         (row.cells[7]?.textContent?.trim() || '').substring(0,8),
// //         (row.cells[8]?.textContent?.trim() || '').substring(0,14),
// //         (row.cells[4]?.textContent?.trim() || '').substring(0,18),
// //         (row.cells[10]?.textContent?.trim() || '').substring(0,8),
// //         String(qty),
// //         '$' + unitPrice.toFixed(2),
// //         '$' + subtotal.toFixed(2)
// //       ].forEach((v, i) => { doc.text(v, cx, y + 4); cx += cols[i]; });
// //       y += 7; rowCount++;
// //       groupTotal += subtotal; groupQty += qty;
// //       grandTotal += subtotal; totalItems += qty;
// //     });
 
// //     drawGroupFooter(groupQty, groupTotal);
// //     groupSummaryPdf.push({ key: groupKey, qty: groupQty, total: groupTotal });
// //   });
 
// //   const freeRowsPDF = [];
// //   const incentiveByPresPDF = {};
 
// //   const addPresPDF = (pres, qty, pack) => {
// //     const isVials = (pres || '').toLowerCase().includes('vial') ||
// //                     (pres || '').toLowerCase().includes('vail');
// //     const packVal = parseInt(pack) > 0 ? parseInt(pack) : 1;
// //     const total   = isVials ? qty * packVal : qty;
// //     incentiveByPresPDF[pres || '—'] = (incentiveByPresPDF[pres || '—'] || 0) + total;
// //   };
 
// //   variantRows().forEach(row => {
// //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //     if (!qty) return;
// //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
// //     if (!variantHasIncentive(extras)) return;
// //     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
// //     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
// //     const fps    = getVariantFreeProducts(extras);
// //     const fqs    = getVariantFreeQtys(extras);
// //     const mult   = calcVariantMultiplier(extras, qty, lineV);
// //     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
 
// //     if (fps.length > 1) {
// //       if (!choice?.confirmed) return;
// //       const vid2    = String(choice.chosenVariantId || '');
// //       const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
// //       const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
// //       freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.chosenTitle, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', color:[50,50,50], bg:[248,249,250] });
// //       addPresPDF(vd2.pres, choice.chosenQty, packVal);
// //     } else {
// //       fps.forEach((fp, i) => {
// //         if (!fp?.title) return;
// //         const giftQty = (fqs[i] || 1) * mult;
// //         const vid2    = String(fp.variant_id || '');
// //         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
// //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
// //         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:fp.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:giftQty, price:'$0.00', color:[50,50,50], bg:[248,249,250] });
// //         addPresPDF(vd2.pres, giftQty, packVal);
// //       });
// //     }
// //   });
 
// //   const p2pdf = window.b2bPriority2Choice || {};
// //   let p2SubtotalPDF = 0;
// //   if (p2pdf.confirmed) {
// //     (p2pdf.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
// //       const vid2    = String(s.variant_id || '');
// //       const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //       const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
// //       const price   = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
// //       const disc    = parseFloat(p2pdf.discountPct || 0);
// //       const final   = price * (1 - disc / 100) * s.selectedQty;
// //       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
// //       p2SubtotalPDF += final;
// //       freeRowsPDF.push({ badge:`${disc}%`, sku:vd2.sku||'—', title:s.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:s.selectedQty, price:`$${(price*(1-disc/100)).toFixed(2)}`, color:[50,50,50], bg:[248,249,250] });
// //       addPresPDF(vd2.pres, s.selectedQty, packVal);
// //     });
// //   }
 
// //   const p3pdf = window.b2bPriority3Choice || {};
// //   if (p3pdf.confirmed) {
// //     (p3pdf.selections || []).forEach(sel => {
// //       (sel.choices || []).forEach(choice => {
// //         if (!choice.chosenQty || choice.chosenQty <= 0) return;
// //         const vid2    = String(choice.chosenVariantId || '');
// //         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
// //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
// //         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
// //         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', color:[50,50,50], bg:[248,249,250] });
// //         addPresPDF(vd2.pres, choice.chosenQty, packVal);
// //       });
// //     });
// //   }
 
// //   if (freeRowsPDF.length) {
// //     checkPage(20);
// //     y += 4;
// //     doc.setFillColor(50,50,50);
// //     doc.rect(margin, y, colW, 8, 'F');
// //     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     doc.text('INCENTIVES INCLUDED', margin + 3, y + 5.5);
// //     doc.setTextColor(0,0,0); y += 10;
 
// //     const colsF = [12,50,14,20,14,12,10,14];
// //     const hdrsF = ['Type','Product','SKU','ML','Presentation','Pack','Qty','Price'];
// //     doc.setFillColor(80,80,80); doc.rect(margin, y, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //     let cxH = margin + 2;
// //     hdrsF.forEach((h, i) => { doc.text(h, cxH, y + 4.5); cxH += colsF[i]; });
// //     doc.setTextColor(0,0,0); y += 8;
 
// //     freeRowsPDF.forEach(item => {
// //       checkPage(8);
// //       doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, 7, 'F');
// //       doc.setFontSize(7);
// //       let cxF = margin + 2;
// //       doc.setFont('helvetica','bold'); doc.setTextColor(...item.color);
// //       doc.text(String(item.badge), cxF, y + 4); cxF += colsF[0];
// //       doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
// //       [item.title.substring(0,30), item.sku.substring(0,10), item.ml.substring(0,8), item.pres.substring(0,12), String(item.pack), String(item.qty), item.price].forEach((v, i) => {
// //         doc.text(v, cxF, y + 4); cxF += colsF[i + 1];
// //       });
// //       y += 7;
// //     });
// //   }
 
// //   checkPage(60);
// //   y += 8;
// //   doc.setFillColor(50,50,50); doc.rect(margin, y, colW, 8, 'F');
// //   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //   doc.text('ORDER SUMMARY', margin + 3, y + 5.5);
// //   doc.setTextColor(0,0,0); y += 10;
 
// //   const sumCols = [120, 40, 30, 40];
// //   const sumHdrs = ['Category','Units/Pack','Qty','Amount'];
// //   doc.setFillColor(80,80,80); doc.rect(margin, y, colW, 7, 'F');
// //   doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //   let cxS = margin + 2;
// //   sumHdrs.forEach((h, i) => { doc.text(h, cxS, y + 4.5); cxS += sumCols[i]; });
// //   doc.setTextColor(0,0,0); y += 8;
 
// //   let sumRow = 0;
 
// //   const totalIncentiveQtyPDF = parseInt(getEl('dash-total-incentives')?.textContent || '0');
// //   if (totalIncentiveQtyPDF > 0) {
// //     Object.entries(incentiveByPresPDF).forEach(([pres, qty]) => {
// //       checkPage(7);
// //       doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [248,249,250]));
// //       doc.rect(margin, y - 1, colW, 7, 'F');
// //       doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
// //       let cx2 = margin + 2;
// //       [`GWP ${pres}`, '—', String(qty), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //       doc.setTextColor(0,0,0); y += 7; sumRow++;
// //     });
// //     checkPage(7);
// //     doc.setFillColor(230,230,230); doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(50,50,50);
// //     let cx2 = margin + 2;
// //     ['Total GWP', '—', String(totalIncentiveQtyPDF), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //     doc.setTextColor(0,0,0); y += 8; sumRow++;
// //   }
 
// //   groupSummaryPdf.forEach(g => {
// //     checkPage(7);
// //     doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [248,249,250]));
// //     doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
// //     let cx2 = margin + 2;
// //     [g.key, '—', String(g.qty), '$' + fmt2(g.total)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //     y += 7; sumRow++;
// //   });
 
// //   if (p2SubtotalPDF > 0) {
// //     checkPage(7);
// //     doc.setFillColor(248,249,250); doc.rect(margin, y - 1, colW, 7, 'F');
// //     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(50,50,50);
// //     let cx2 = margin + 2;
// //     [`Reward Credit (${p2pdf.discountPct}%)`, '—', '—', '$' + fmt2(p2SubtotalPDF)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
// //     doc.setTextColor(0,0,0); y += 7;
// //   }
 
// //   checkPage(9);
// //   doc.setFillColor(50,50,50); doc.rect(margin, y - 1, colW, 9, 'F');
// //   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
// //   let cx2 = margin + 2;
// //   ['Estimated Total', '—', String(totalItems), '$' + fmt2(grandTotal)].forEach((v, i) => { doc.text(v, cx2, y + 5.5); cx2 += sumCols[i]; });
 
// //   return doc.output('datauristring').split(',')[1];
// // }

// // ══════════════════════════════════════════════════════════════
// // ESTILO NICHE305 aplicado al PDF de Pre Order — v3
// // Cambios sobre v2:
// //   1) Las 3 stat-boxes ahora usan el mismo ancho que la tabla
// //      (antes usaban una fórmula distinta y quedaban más angostas).
// //   2) Letra más grande en toda la tabla (encabezados y filas).
// //   3) Foto de producto más grande (16mm en vez de 11mm) y filas
// //      más altas para que entre cómoda.
// // ══════════════════════════════════════════════════════════════

// // ── Helper: convierte una imagen a base64 para jsPDF ──
// function loadImageAsBase64(url) {
//   return new Promise((resolve, reject) => {
//     const img = new Image();
//     img.crossOrigin = 'Anonymous';
//     img.onload = function () {
//       const canvas = document.createElement('canvas');
//       canvas.width = img.width;
//       canvas.height = img.height;
//       const ctx = canvas.getContext('2d');
//       ctx.drawImage(img, 0, 0);
//       resolve(canvas.toDataURL('image/png'));
//     };
//     img.onerror = reject;
//     img.src = url;
//   });
// }

// // ── AJUSTAR AQUÍ si tu tabla de producto usa otro selector/atributo ──
// function getRowImageUrl(row) {
//   const img = row.querySelector('img');
//   if (img) return img.currentSrc || img.src || null;
//   if (row.dataset.image) return row.dataset.image;
//   if (row.dataset.imageUrl) return row.dataset.imageUrl;
//   return null;
// }

// // ── AJUSTAR AQUÍ si el mapa de variantes usa otro campo para la imagen ──
// // FIX: los objetos de window.b2bAllVariantsMap normalmente no traen imagen,
// // así que como respaldo buscamos la foto en el DOM (variantRows()) por
// // variantId — el mismo método que ya funciona para la tabla principal.
// function getFreeItemImageUrl(vd2, variantId) {
//   const fromMap = vd2?.image || vd2?.img || vd2?.photo || vd2?.imageUrl || null;
//   if (fromMap) return fromMap;
//   if (variantId) return getVariantImageFromDom(variantId);
//   return null;
// }

// let _variantImageDomCache = null;
// function getVariantImageFromDom(variantId) {
//   if (!_variantImageDomCache) {
//     _variantImageDomCache = {};
//     variantRows().forEach(r => {
//       const vid = String(r.dataset.variantId || '');
//       if (vid && !_variantImageDomCache[vid]) {
//         const url = getRowImageUrl(r);
//         if (url) _variantImageDomCache[vid] = url;
//       }
//     });
//   }
//   return _variantImageDomCache[String(variantId)] || null;
// }

// // ── Encabezado con logo (o fallback de texto) ──
// async function drawPreOrderHeader(doc, pageW, margin, vendor) {
//   doc.setFillColor(255, 255, 255);
//   doc.rect(0, 0, pageW, 42, 'F');

//   const logoUrl   = window.NICHE_LOGO_URL;
//   const logoOrigW = window.NICHE_LOGO_WIDTH;
//   const logoOrigH = window.NICHE_LOGO_HEIGHT;

//   let logoDrawn = false;

//   if (logoUrl) {
//     try {
//       const logoImg = await loadImageAsBase64(logoUrl);
//       const maxH  = 18;
//       const ratio = (logoOrigW && logoOrigH) ? logoOrigW / logoOrigH : 3;
//       const logoH = maxH;
//       const logoW = logoH * ratio;
//       doc.addImage(logoImg, 'PNG', (pageW - logoW) / 2, 6, logoW, logoH);
//       logoDrawn = true;
//     } catch (e) {
//       logoDrawn = false;
//     }
//   }

//   if (!logoDrawn) {
//     doc.setFont('helvetica', 'bold');
//     doc.setFontSize(16);
//     const nicheW     = doc.getTextWidth('NICHE');
//     const totalLogoW = nicheW + doc.getTextWidth('305') + 2;
//     const logoStartX = (pageW - totalLogoW) / 2;
//     doc.setTextColor(60, 55, 45);
//     doc.text('NICHE', logoStartX, 13);
//     doc.setTextColor(183, 172, 126);
//     doc.text('305', logoStartX + nicheW + 2, 13);
//   }

//   doc.setDrawColor(220, 215, 205);
//   doc.setLineWidth(0.3);
//   doc.line(margin, 27, pageW - margin, 27);

//   doc.setFont('helvetica', 'bold');
//   doc.setFontSize(13);
//   doc.setTextColor(30, 30, 30);
//   doc.text(`${vendor} — Pre Order`, pageW / 2, 33, { align: 'center' });

//   doc.setFont('helvetica', 'normal');
//   doc.setFontSize(8);
//   doc.setTextColor(160, 160, 160);
//   doc.text(
//     new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
//     pageW / 2, 38, { align: 'center' }
//   );

//   doc.setDrawColor(220, 215, 205);
//   doc.line(margin, 40, pageW - margin, 40);

//   return 42;
// }

// // ── 3 stat-boxes: ahora usan EXACTAMENTE el mismo ancho que la tabla (colW) ──
// function drawPreOrderStatBoxes(doc, stats, margin, colW, y) {
//   const boxH = 22;
//   const gap  = 4;
//   const boxW = (colW - (stats.length - 1) * gap) / stats.length;

//   stats.forEach((s, i) => {
//     const bx = margin + i * (boxW + gap);
//     doc.setFillColor(248, 247, 244);
//     doc.setDrawColor(220, 215, 205);
//     doc.setLineWidth(0.3);
//     doc.roundedRect(bx, y, boxW, boxH, 1.5, 1.5, 'FD');

//     doc.setFont('helvetica', 'normal');
//     doc.setFontSize(8);
//     doc.setTextColor(150, 140, 120);
//     doc.text(s.label, bx + boxW / 2, y + 7, { align: 'center' });

//     doc.setFont('helvetica', 'bold');
//     doc.setFontSize(14);
//     doc.setTextColor(30, 30, 30);
//     doc.text(String(s.value), bx + boxW / 2, y + 16, { align: 'center' });
//   });

//   return y + boxH;
// }

// // ══════════════════════════════════════════════════════════════
// // GENERADOR PRINCIPAL (misma lógica de datos que el original)
// // ══════════════════════════════════════════════════════════════
// async function generatePreOrderPdfBase64() {
//   const { jsPDF } = window.jspdf;
//   if (!jsPDF) return null;

//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//   const doc    = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
//   const pageW  = doc.internal.pageSize.getWidth();
//   const pageH  = doc.internal.pageSize.getHeight();
//   const margin = 14, colW = pageW - margin * 2;
//   let y = 0;

//   const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
//   const fmt2 = n => parseFloat(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//   // ── 1) Primera pasada: agrupar filas y calcular totales SIN dibujar ──
//   const groupedRows = {};
//   const groupOrder  = [];

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
//     const presLower = presDisp.toLowerCase();
//     let groupKey = 'Others';
//     if (presLower.includes('perfume'))                                              groupKey = 'Perfumes';
//     else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
//     else if (presLower.includes('retail'))                                          groupKey = 'Retail';
//     else if (presLower.includes('travel'))                                          groupKey = 'Travel Set';
//     else if (presDisp && presDisp !== 'N/A')                                        groupKey = presDisp;
//     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
//     groupedRows[groupKey].push(row);
//   });

//   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
//   const sortedGroups   = [
//     ...preferredOrder.filter(g => groupedRows[g]),
//     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
//   ];

//   let grandTotal = 0, totalItems = 0;
//   sortedGroups.forEach(groupKey => {
//     groupedRows[groupKey].forEach(row => {
//       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
//       grandTotal += qty * unitPrice;
//       totalItems += qty;
//     });
//   });

//   // ── 1b) Pre-cargar imágenes únicas ──
//   const imageCache = {};
//   async function cacheImage(url) {
//     if (!url || imageCache[url] !== undefined) return;
//     try { imageCache[url] = await loadImageAsBase64(url); }
//     catch (e) { imageCache[url] = null; }
//   }
//   for (const key of sortedGroups) {
//     for (const row of groupedRows[key]) {
//       await cacheImage(getRowImageUrl(row));
//     }
//   }

//   // ── 2) Header + stat boxes (mismo ancho que la tabla) ──
//   y = await drawPreOrderHeader(doc, pageW, margin, vendor);
//   y = drawPreOrderStatBoxes(doc, [
//     { label: 'Total Items',     value: totalItems },
//     { label: 'Categories',      value: sortedGroups.length },
//     { label: 'Estimated Total', value: '$' + fmt2(grandTotal) },
//   ], margin, colW, y + 6);
//   y += 8;

//   // ── 3) Tablas por grupo (letra e imagen más grandes) ──
//   // Orden de columnas: Product, Photo, SKU, ML, Presentation, Collection, Coefficient, Qty, Unit Price, Total
//   const cols = [46, 22, 24, 16, 26, 30, 16, 14, 24, 24];
//   const hdrs = ['Product','Photo','SKU','ML','Presentation','Collection','Coefficient','Qty','Unit Price','Total'];
//   const IMG_SIZE = 16;
//   const ROW_H    = 22; // más alto para que quepa la foto más grande

//   const colX = idx => margin + 2 + cols.slice(0, idx).reduce((a, b) => a + b, 0);

//   function drawTableHeader() {
//     checkPage(9);
//     doc.setFillColor(40, 38, 35);
//     doc.rect(margin, y, colW, 8, 'F');
//     doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     hdrs.forEach((h, i) => { doc.text(h, colX(i), y + 5.5); });
//     doc.setTextColor(0,0,0); y += 9;
//   }

//   function drawGroupFooter(groupQty, groupTotal) {
//     checkPage(9);
//     doc.setFillColor(238, 233, 222);
//     doc.rect(margin, y - 1, colW, 8, 'F');
//     doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(120,110,85);
//     doc.text(String(groupQty), colX(7), y + 4.5);
//     doc.text('$' + fmt2(groupTotal), colX(9), y + 4.5);
//     doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
//     y += 10;
//   }

//   let rowCount = 0;
//   const groupSummaryPdf = [];

//   sortedGroups.forEach(groupKey => {
//     const rows = groupedRows[groupKey];
//     if (!rows?.length) return;

//     // Reserva espacio para: barra de título (9) + fila de encabezados (9) +
//     // al menos la primera fila de datos (ROW_H). Así, si no entra completo,
//     // salta de página ANTES de dibujar el título — nunca lo deja solo arriba.
//     checkPage(9 + 9 + ROW_H + 4);
//     doc.setFillColor(183, 172, 126);
//     doc.rect(margin, y, colW, 9, 'F');
//     doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     doc.text(`${groupKey}  (${rows.length} item${rows.length > 1 ? 's' : ''})`, margin + 3, y + 6.2);
//     doc.setTextColor(0,0,0); y += 11;

//     drawTableHeader();

//     let groupTotal = 0, groupQty = 0;

//     rows.forEach(row => {
//       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
//       const subtotal  = qty * unitPrice;
//       checkPage(ROW_H + 1);

//       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [250,249,247]));
//       doc.rect(margin, y - 1, colW, ROW_H, 'F');
//       doc.setDrawColor(220,215,205); doc.setLineWidth(0.15);
//       doc.line(margin, y - 1 + ROW_H, margin + colW, y - 1 + ROW_H);

//       const textY = y - 1 + ROW_H / 2 + 1.8;

//       const imgData = imageCache[getRowImageUrl(row)];
//       const imgX = colX(1) - 1;
//       const imgY = y - 1 + (ROW_H - IMG_SIZE) / 2;
//       if (imgData) {
//         doc.addImage(imgData, 'PNG', imgX, imgY, IMG_SIZE, IMG_SIZE);
//       } else {
//         doc.setFillColor(237, 233, 228);
//         doc.rect(imgX, imgY, IMG_SIZE, IMG_SIZE, 'F');
//       }

//       doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
//       doc.text((row.cells[5]?.textContent?.trim() || '').substring(0,26), colX(0), textY);
//       doc.text((row.dataset.sku || '-').toUpperCase().substring(0,12), colX(2), textY);
//       doc.text((row.cells[7]?.textContent?.trim() || '').substring(0,8), colX(3), textY);
//       doc.text((row.cells[8]?.textContent?.trim() || '').substring(0,14), colX(4), textY);
//       doc.text((row.cells[4]?.textContent?.trim() || '').substring(0,18), colX(5), textY);
//       doc.text((row.cells[10]?.textContent?.trim() || '').substring(0,8), colX(6), textY);
//       doc.text(String(qty), colX(7), textY);
//       doc.text('$' + unitPrice.toFixed(2), colX(8), textY);
//       doc.text('$' + subtotal.toFixed(2), colX(9), textY);
//       doc.setTextColor(0,0,0);

//       y += ROW_H; rowCount++;
//       groupTotal += subtotal; groupQty += qty;
//     });

//     drawGroupFooter(groupQty, groupTotal);
//     groupSummaryPdf.push({ key: groupKey, qty: groupQty, total: groupTotal });
//   });

//   // ── 4) Incentivos ──
//   const freeRowsPDF = [];
//   const incentiveByPresPDF = {};

//   const addPresPDF = (pres, qty, pack) => {
//     const isVials = (pres || '').toLowerCase().includes('vial') ||
//                     (pres || '').toLowerCase().includes('vail');
//     const packVal = parseInt(pack) > 0 ? parseInt(pack) : 1;
//     const total   = isVials ? qty * packVal : qty;
//     incentiveByPresPDF[pres || '—'] = (incentiveByPresPDF[pres || '—'] || 0) + total;
//   };

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     const fps    = getVariantFreeProducts(extras);
//     const fqs    = getVariantFreeQtys(extras);
//     const mult   = calcVariantMultiplier(extras, qty, lineV);
//     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

//     if (fps.length > 1) {
//       if (!choice?.confirmed) return;
//       const vid2    = String(choice.chosenVariantId || '');
//       const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//       const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//       freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.chosenTitle, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
//       addPresPDF(vd2.pres, choice.chosenQty, packVal);
//     } else {
//       fps.forEach((fp, i) => {
//         if (!fp?.title) return;
//         const giftQty = (fqs[i] || 1) * mult;
//         const vid2    = String(fp.variant_id || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:fp.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:giftQty, price:'$0.00', image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
//         addPresPDF(vd2.pres, giftQty, packVal);
//       });
//     }
//   });

//   const p2pdf = window.b2bPriority2Choice || {};
//   let p2SubtotalPDF = 0;
//   if (p2pdf.confirmed) {
//     (p2pdf.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
//       const vid2    = String(s.variant_id || '');
//       const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//       const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//       const price   = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
//       const disc    = parseFloat(p2pdf.discountPct || 0);
//       const final   = price * (1 - disc / 100) * s.selectedQty;
//       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//       p2SubtotalPDF += final;
//       freeRowsPDF.push({ badge:`${disc}%`, sku:vd2.sku||'—', title:s.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:s.selectedQty, price:`$${(price*(1-disc/100)).toFixed(2)}`, image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
//       addPresPDF(vd2.pres, s.selectedQty, packVal);
//     });
//   }

//   const p3pdf = window.b2bPriority3Choice || {};
//   if (p3pdf.confirmed) {
//     (p3pdf.selections || []).forEach(sel => {
//       (sel.choices || []).forEach(choice => {
//         if (!choice.chosenQty || choice.chosenQty <= 0) return;
//         const vid2    = String(choice.chosenVariantId || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
//         addPresPDF(vd2.pres, choice.chosenQty, packVal);
//       });
//     });
//   }

//   for (const item of freeRowsPDF) {
//     await cacheImage(item.image);
//   }

//   if (freeRowsPDF.length) {
//     // Igual que con los grupos: reserva espacio para el gap superior (4) +
//     // barra de título (9) + fila de encabezados (9) + al menos la primera
//     // fila (ROW_H), para que el título nunca quede solo al final de una página.
//     checkPage(4 + 9 + 9 + ROW_H + 4);
//     y += 4;
//     doc.setFillColor(40, 38, 35);
//     doc.rect(margin, y, colW, 9, 'F');
//     doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     doc.text('INCENTIVES INCLUDED', margin + 3, y + 6.2);
//     doc.setTextColor(0,0,0); y += 11;

//     // Type, Product, Photo, SKU, ML, Presentation, Pack, Qty, Price
//     const colsF = [14, 40, 22, 18, 16, 22, 12, 12, 16];
//     const hdrsF = ['Type','Product','Photo','SKU','ML','Presentation','Pack','Qty','Price'];
//     const colXF = idx => margin + 2 + colsF.slice(0, idx).reduce((a, b) => a + b, 0);

//     doc.setFillColor(70, 66, 60); doc.rect(margin, y, colW, 8, 'F');
//     doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     hdrsF.forEach((h, i) => { doc.text(h, colXF(i), y + 5.5); });
//     doc.setTextColor(0,0,0); y += 9;

//     freeRowsPDF.forEach(item => {
//       checkPage(ROW_H + 1);
//       doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, ROW_H, 'F');
//       doc.setDrawColor(220,215,205); doc.setLineWidth(0.15);
//       doc.line(margin, y - 1 + ROW_H, margin + colW, y - 1 + ROW_H);

//       const textY = y - 1 + ROW_H / 2 + 1.8;

//       const imgData = imageCache[item.image];
//       const imgX = colXF(2) - 1;
//       const imgY = y - 1 + (ROW_H - IMG_SIZE) / 2;
//       if (imgData) {
//         doc.addImage(imgData, 'PNG', imgX, imgY, IMG_SIZE, IMG_SIZE);
//       } else {
//         doc.setFillColor(237, 233, 228);
//         doc.rect(imgX, imgY, IMG_SIZE, IMG_SIZE, 'F');
//       }

//       doc.setFontSize(8);
//       doc.setFont('helvetica','bold'); doc.setTextColor(183,172,126);
//       doc.text(String(item.badge), colXF(0), textY);
//       doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
//       doc.text(item.title.substring(0,20), colXF(1), textY);
//       doc.text(item.sku.substring(0,10), colXF(3), textY);
//       doc.text(item.ml.substring(0,8), colXF(4), textY);
//       doc.text(item.pres.substring(0,12), colXF(5), textY);
//       doc.text(String(item.pack), colXF(6), textY);
//       doc.text(String(item.qty), colXF(7), textY);
//       doc.text(item.price, colXF(8), textY);
//       doc.setTextColor(0,0,0);
//       y += ROW_H;
//     });
//   }

//   // ── 5) Order summary ──
//   checkPage(60);
//   y += 8;
//   doc.setFillColor(40, 38, 35); doc.rect(margin, y, colW, 9, 'F');
//   doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   doc.text('ORDER SUMMARY', margin + 3, y + 6.2);
//   doc.setTextColor(0,0,0); y += 11;

//   const sumCols = [120, 40, 30, 40];
//   const sumHdrs = ['Category','Units/Pack','Qty','Amount'];
//   doc.setFillColor(70, 66, 60); doc.rect(margin, y, colW, 8, 'F');
//   doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   let cxS = margin + 2;
//   sumHdrs.forEach((h, i) => { doc.text(h, cxS, y + 5.5); cxS += sumCols[i]; });
//   doc.setTextColor(0,0,0); y += 9;

//   let sumRow = 0;

//   const totalIncentiveQtyPDF = parseInt(getEl('dash-total-incentives')?.textContent || '0');
//   if (totalIncentiveQtyPDF > 0) {
//     Object.entries(incentiveByPresPDF).forEach(([pres, qty]) => {
//       checkPage(8);
//       doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [250,249,247]));
//       doc.rect(margin, y - 1, colW, 8, 'F');
//       doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
//       let cx2 = margin + 2;
//       [`GWP ${pres}`, '—', String(qty), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
//       doc.setTextColor(0,0,0); y += 8; sumRow++;
//     });
//     checkPage(8);
//     doc.setFillColor(238, 233, 222); doc.rect(margin, y - 1, colW, 8, 'F');
//     doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(120,110,85);
//     let cx2 = margin + 2;
//     ['Total GWP', '—', String(totalIncentiveQtyPDF), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
//     doc.setTextColor(0,0,0); y += 9; sumRow++;
//   }

//   groupSummaryPdf.forEach(g => {
//     checkPage(8);
//     doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [250,249,247]));
//     doc.rect(margin, y - 1, colW, 8, 'F');
//     doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
//     let cx2 = margin + 2;
//     [g.key, '—', String(g.qty), '$' + fmt2(g.total)].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
//     y += 8; sumRow++;
//   });

//   if (p2SubtotalPDF > 0) {
//     checkPage(8);
//     doc.setFillColor(250,249,247); doc.rect(margin, y - 1, colW, 8, 'F');
//     doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(183,172,126);
//     let cx2 = margin + 2;
//     [`Reward Credit (${p2pdf.discountPct}%)`, '—', '—', '$' + fmt2(p2SubtotalPDF)].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
//     doc.setTextColor(0,0,0); y += 8;
//   }

//   checkPage(10);
//   doc.setFillColor(40, 38, 35); doc.rect(margin, y - 1, colW, 10, 'F');
//   doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   let cxTot = margin + 2;
//   ['Estimated Total', '—', String(totalItems), '$' + fmt2(grandTotal)].forEach((v, i) => { doc.text(v, cxTot, y + 6); cxTot += sumCols[i]; });

//   // ── 6) Números de página ──
//   const totalPages = doc.getNumberOfPages();
//   for (let i = 1; i <= totalPages; i++) {
//     doc.setPage(i);
//     doc.setFont('helvetica', 'normal');
//     doc.setFontSize(7);
//     doc.setTextColor(180, 180, 180);
//     doc.text(`Page ${i} of ${totalPages}`, pageW / 2, pageH - 5, { align: 'center' });
//   }

//   return doc.output('datauristring').split(',')[1];
// }


// /* ============================================================
//    PRESENTATION QUICK FILTER
//    ============================================================ */

// function initPresQuickFilter() {
//   const btn      = getEl('pres-filter-btn');
//   const dropdown = getEl('pres-filter-dropdown');
//   const optsCont = getEl('pres-filter-options');
//   const label    = getEl('pres-filter-label');
//   if (!btn || !dropdown || !optsCont) return;

//   let currentPres = 'all';

//   // ── Build options with counts ──
//   function buildOptions() {
//     // Count per presentation value
//     const counts = { all: 0 };
//     variantRows().forEach(row => {
//       counts.all++;
//       const pres = (row.dataset.presentation || '').toLowerCase().trim();
//       if (!pres || pres === 'n/a') {
//         counts['others'] = (counts['others'] || 0) + 1;
//         return;
//       }
//       if (pres.includes('perfume')) {
//           counts['perfume'] = (counts['perfume'] || 0) + 1;
//         } else if (pres.includes('vial') || pres.includes('tester')) {
//           counts['vial'] = (counts['vial'] || 0) + 1;
//         } else {
//           counts['others'] = (counts['others'] || 0) + 1;
//         }
//     });

//     const options = [
//       { key: 'all',     label: 'All Products',              count: counts.all     || 0 },
//       { key: 'perfume', label: 'Perfume',           count: counts.perfume || 0 },
//       { key: 'vial',   label: 'Vials & Tester',   count: counts.vial   || 0 },
//       { key: 'others',  label: 'Others',            count: counts.others  || 0 },
//     ];

//     optsCont.innerHTML = options.map(opt => `
//       <div class="pres-filter-opt" data-key="${opt.key}"
//         style="display:flex;align-items:center;justify-content:space-between;
//                padding:10px 16px;cursor:pointer;font-family:'Crimson Pro',serif;
//                font-size:15px;color:#374151;transition:background 0.1s;
//                background:${currentPres === opt.key ? '#f9f5ef' : '#fff'};
//                font-weight:${currentPres === opt.key ? '700' : '400'};">
//         <span>${opt.label}</span>
//         <span style="background:${currentPres === opt.key ? '#b8a77d' : '#f3f4f6'};
//                      color:${currentPres === opt.key ? '#fff' : '#6b7280'};
//                      font-size:13px;font-weight:700;padding:2px 9px;
//                      border-radius:99px;min-width:28px;text-align:center;">
//           ${opt.count}
//         </span>
//       </div>`).join('');

//     // Hover effect
//     optsCont.querySelectorAll('.pres-filter-opt').forEach(el => {
//       el.addEventListener('mouseenter', () => {
//         if (el.dataset.key !== currentPres) el.style.background = '#f9f5ef';
//       });
//       el.addEventListener('mouseleave', () => {
//         if (el.dataset.key !== currentPres) el.style.background = '#fff';
//       });
//       el.addEventListener('click', () => {
//         // currentPres = el.dataset.key;
//         // applyPresFilter();
//         // dropdown.style.display = 'none';
//         // btn.style.background = currentPres === 'all' ? '#b8a77d' : '#b8a77d';
//         // buildOptions(); // refresh badges
//             currentPres = el.dataset.key;
//             applyPresFilter();
//             dropdown.style.display = 'none';
//             btn.classList.remove('pres-filter-open');
//             buildOptions(); // refresh badges
//       });
//     });
//   }

//   function applyPresFilter() {
//     const labelMap = {
//       all:     'All Product',
//       perfume: 'Perfume',
//       vails:   'Vials & Tester',
//       others:  'Others',
//     };
//     label.textContent = labelMap[currentPres] || 'All Product';

//     variantRows().forEach(row => {
//       const pres = (row.dataset.presentation || '').toLowerCase().trim();
//       let match = false;
//       if (currentPres === 'all') {
//         match = true;
//       } else if (currentPres === 'perfume') {
//         match = pres.includes('perfume');
//       } else if (currentPres === 'vial') {
//         match = pres.includes('vial') || pres.includes('tester');
//       } else if (currentPres === 'others') {
//           match = !pres.includes('perfume') &&
//                   !pres.includes('vial') &&
//                   !pres.includes('tester');
//         }
//       row.style.display = match ? '' : 'none';
//     });

//     updateTotals();
//   }

//   // ── Toggle dropdown ──
//   // btn.addEventListener('click', () => {
//   //   const open = dropdown.style.display !== 'none';
//   //   if (!open) buildOptions();
//   //   dropdown.style.display = open ? 'none' : 'block';
//   // });

//   // // ── Close on outside click ──
//   // document.addEventListener('click', e => {
//   //   if (!getEl('pres-filter-wrapper')?.contains(e.target)) {
//   //     dropdown.style.display = 'none';
//   //   }
//   // });

//     // ── Toggle dropdown ──
//   btn.addEventListener('click', () => {
//     const open = dropdown.style.display !== 'none';
//     if (!open) buildOptions();
//     dropdown.style.display = open ? 'none' : 'block';
//     btn.classList.toggle('pres-filter-open', !open);
//   });

//   // ── Close on outside click ──
//   document.addEventListener('click', e => {
//     if (!getEl('pres-filter-wrapper')?.contains(e.target)) {
//       dropdown.style.display = 'none';
//       btn.classList.remove('pres-filter-open');
//     }
//   });
// }

// function showOverlayResult(success, message) {
//   const overlay = getEl('b2b-processing-overlay');
//   if (!overlay) return;
  
//   const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
//   const color   = success ? '#b8a77d' : '#dc2626';
//   const icon    = success ? '✓' : '✗';
//   //  ${message}
//   overlay.innerHTML = `
//     <div style="background:white;border-radius:16px;padding:32px 48px;text-align:center;
//                 box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;max-width:400px;">
//       <img src="${logoUrl}" alt="Logo"
//         style="width:140px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
//         onerror="this.style.display='none'">
//       <div style="width:64px;height:64px;border-radius:50%;background:${success ? '#fff' : '#fee2e2'};
//                   display:flex;align-items:center;justify-content:center;
//                   margin:0 auto 16px;font-size:32px;color:${color};">
//         ${icon}
//       </div>
//       <div style="font-size:1.4rem;font-weight:700;color:${color};margin-bottom:8px;">
//         ${success ? 'Email sent successfully!' : 'Error sending email'}
//       </div>
//       <div style="font-size:1rem;color:#6b7280;margin-bottom:24px;line-height:1.5;">
       
//       </div>
//       <button type="button" onclick="unlockUI()"
//         style="padding:10px 32px;background:#b8a77d;color:#fff;border:none;
//                border-radius:8px;font-size:16px;font-weight:700;cursor:pointer;
//                font-family:'Crimson Pro',serif;">
//         OK
//       </button>
//     </div>`;
// }



// /* ── Stock disponible real para poder regalar (descontando lo ya comprado de esa misma variante) ── */
// // function getRemainingStockForGift(variantId, extraReserved = 0) {
// //   const vid = String(variantId || '');
// //   if (!vid) return Infinity; // sin variante trazable, no restringimos
// //   const row = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
// //   if (!row) return Infinity; // no se vende en este catálogo, no compite por stock
// //   const totalStock   = parseInt(row.dataset.realStock || row.dataset.stock || 0);
// //   const purchasedQty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
// //   return totalStock - purchasedQty - extraReserved;
// // }


// /* ── Stock disponible real para poder regalar (descontando lo ya comprado de esa misma variante) ── */
// function getRemainingStockForGift(variantId, extraReserved = 0) {
//   const vid = String(variantId || '');
//   if (!vid) return Infinity; 

//   const row = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
//   if (row) {
//     const totalStock   = parseInt(row.dataset.realStock || row.dataset.stock || 0);
//     const purchasedQty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     return totalStock - purchasedQty - extraReserved;
//   }

//   const rawStock = window.b2bStockMap ? window.b2bStockMap[vid] : undefined;
//   if (rawStock == null) return Infinity;
//   return rawStock - extraReserved;
// }

// function getProductPresentationPurchasedQty(handle, presKeyword) {
//   let total = 0;
//   variantRows().forEach(row => {
//     if (row.dataset.handle !== handle) return;
//     const pres = (row.dataset.presentation || '').toLowerCase();
//     if (!pres.includes(presKeyword)) return;
//     total += parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//   });
//   return total;
// }

// function getUnlockCap(row) {
//   const unlockPres = (row.dataset.unlockPres || '').trim();
//   const unlockQty  = parseInt(row.dataset.unlockQty || 0);
//   const unlockStep = parseInt(row.dataset.unlockStep || 1) || 1;
//   if (!unlockPres || unlockQty <= 0) return Infinity; // sin configuración = sin restricción
//   const basePurchased = getProductPresentationPurchasedQty(row.dataset.handle, unlockPres);
//   return Math.floor(basePurchased / unlockQty) * unlockStep;
// }

// /* ── Máximo de FOC que realmente se puede asignar en un grupo, limitado por stock ── */
// function computeMaxAchievableFoc(fps, totalFree) {
//   let capSum = 0;
//   let anyUnlimited = false;

//   fps.forEach(fp => {
//     const vid = String(fp.variant_id || '');
//     const remaining = getRemainingStockForGift(vid);
//     if (remaining === Infinity) {
//       anyUnlimited = true;
//     } else {
//       capSum += Math.max(0, remaining);
//     }
//   });

//   if (anyUnlimited) return totalFree; // al menos un producto no compite por stock, no hay límite real
//   return Math.min(totalFree, capSum);
// }


// function hasAnyGiftStock(fps) {
//   if (!fps || !fps.length) return false;
//   return fps.some(fp => {
//     const vid = String(fp.variant_id || '');
//     if (!vid || vid === '0') return true; // no trazable en catálogo → no lo limitamos
//     const remaining = getRemainingStockForGift(vid);
//     return remaining > 0;
//   });
// }






// /* ══════════════════════════════════════════════
//    OFFLINE ORDER MODAL — lógica de apertura/cierre
//    Pegar esto dentro de initGlobalListeners() en b2b-marca-tabla.js
//    ══════════════════════════════════════════════ */

// function openOfflineOrderModal() {
//   const overlay = getEl('offline-order-modal-overlay');
//   if (overlay) overlay.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// }

// function closeOfflineOrderModal() {
//   const overlay = getEl('offline-order-modal-overlay');
//   if (overlay) overlay.style.display = 'none';
//   document.body.style.overflow = '';
// }

// // Abrir modal al hacer click en el botón "Offline Order" del header
// // (delegación de eventos: funciona aunque este script se cargue antes
// // de que el botón exista en el DOM)
// document.addEventListener('click', (e) => {
//   if (e.target.closest('#offline-order-btn')) {
//     openOfflineOrderModal();
//   }
// });

// // Cerrar con la X
// document.addEventListener('click', (e) => {
//   if (e.target.closest('#offline-order-modal-close')) {
//     closeOfflineOrderModal();
//   }
// });

// // Cerrar con "Got it"
// document.addEventListener('click', (e) => {
//   if (e.target.closest('#offline-order-modal-gotit')) {
//     closeOfflineOrderModal();
//   }
// });

// // Cerrar haciendo click fuera del modal (en el overlay)
// document.addEventListener('click', (e) => {
//   if (e.target.id === 'offline-order-modal-overlay') closeOfflineOrderModal();
// });

// // Cerrar con la tecla Escape
// document.addEventListener('keydown', (e) => {
//   if (e.key === 'Escape') {
//     const overlay = getEl('offline-order-modal-overlay');
//     if (overlay && overlay.style.display !== 'none') closeOfflineOrderModal();
//   }
// });

// // ── Botón "Download Offline Order Excel" (Paso 1) ──
// document.addEventListener('click', async (e) => {
//   const btn = e.target.closest('#offline-order-download-template');
//   if (!btn) return;
//   if (btn.classList.contains('is-loading')) return;

//   const label   = btn.querySelector('.oo-download-btn-label');
//   const spinner = btn.querySelector('.oo-download-btn-spinner');

//   btn.classList.add('is-loading');
//   label.style.display = 'none';
//   spinner.style.display = 'inline-block';

//   try {
//     // TODO: reemplazar por la función real que genera la plantilla en blanco
//     // (por ejemplo una versión de generateCatalogBase64 sin precios, solo
//     // columnas para que el cliente complete cantidades).
//     const base64 = await generateOfflineOrderTemplateBase64();
//     if (base64) {
//       const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//       const url  = URL.createObjectURL(blob);
//       const a    = document.createElement('a');
//       a.href = url;
//       a.download = 'offline-order-template.xlsx';
//       a.click();
//       URL.revokeObjectURL(url);
//     }
//   } catch (err) {
//     console.error('Error generating offline order template:', err);
//   } finally {
//     btn.classList.remove('is-loading');
//     label.style.display = '';
//     spinner.style.display = 'none';
//   }
// });

// // ── Botón "Upload Excel File" (Paso 3 - Opción B) ──
// document.addEventListener('click', (e) => {
//   if (e.target.closest('#offline-order-upload-btn')) {
//     getEl('offline-order-file-input')?.click();
//   }
// });

// document.addEventListener('change', async (e) => {
//   if (e.target.id !== 'offline-order-file-input') return;
//   const file = e.target.files[0];
//   if (!file) return;

//   const filenameEl = getEl('offline-order-upload-filename');
//   const uploadBtn   = getEl('offline-order-upload-btn');
//   const label       = getEl('offline-order-upload-label');
//   const spinner     = uploadBtn?.querySelector('.oo-upload-btn-spinner');

//   uploadBtn?.classList.add('is-loading');
//   if (label)   label.style.display = 'none';
//   if (spinner) spinner.style.display = 'inline-block';

//   try {
//     // TODO: reemplazar por la lógica real de subida (ej: enviar a un endpoint
//     // propio, a una Shopify App Proxy, o a un servicio externo).
//     await uploadOfflineOrderFile(file);
//     if (filenameEl) filenameEl.textContent = `Uploaded: ${file.name}`;
//   } catch (err) {
//     console.error('Error uploading offline order file:', err);
//     if (filenameEl) filenameEl.textContent = 'Upload failed. Please try again.';
//   } finally {
//     uploadBtn?.classList.remove('is-loading');
//     if (label)   label.style.display = '';
//     if (spinner) spinner.style.display = 'none';
//   }
// });

// /* ══════════════════════════════════════════════
//    Funciones a implementar según tu backend real
//    ══════════════════════════════════════════════ */


// // Sube el archivo completado por el cliente. Ajustar a tu backend real.
// async function uploadOfflineOrderFile(file) {
//   // Ejemplo con Shopify App Proxy / endpoint propio:
//   // const formData = new FormData();
//   // formData.append('file', file);
//   // const res = await fetch('/apps/offline-orders/upload', { method: 'POST', body: formData });
//   // if (!res.ok) throw new Error('Upload failed');
//   // return res.json();

//   // Placeholder temporal: simula una subida.
//   await new Promise(resolve => setTimeout(resolve, 800));
// }











// /* ============================================================
//    SKU MODAL VIDEO CAROUSEL
//    ============================================================ */
// let skuVideoPlaylist = [];
// let skuVideoCurrentIndex = 0;
// let skuYtPlayer = null;
// let skuYtApiReady = false;
// let skuVideoCarouselIndex = 0;
// const SKU_VIDEO_VISIBLE_COUNT = 4;

// window.onYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady || function() {
//   skuYtApiReady = true;
// };
// if (window.YT && window.YT.Player) skuYtApiReady = true;

// function ensureYoutubeApiLoaded() {
//   if (document.getElementById('sku-youtube-api-script')) return;
//   const s = document.createElement('script');
//   s.id = 'sku-youtube-api-script';
//   s.src = 'https://www.youtube.com/iframe_api';
//   document.head.appendChild(s);
// }

// function getSkuVideoStep() {
//   const track = getEl('skuVideoTrack');
//   const firstItem = track?.querySelector('.sku-video-item');
//   if (!firstItem) return 0;
//   const gap = parseFloat(getComputedStyle(track).gap) || 0;
//   return firstItem.getBoundingClientRect().width + gap;
// }

// function updateSkuVideoCarousel() {
//   const track = getEl('skuVideoTrack');
//   if (!track) return;
//   const step = getSkuVideoStep();
//   track.style.transform = 'translateX(' + (-skuVideoCarouselIndex * step) + 'px)';
//   const prevBtn = getEl('skuVideoPrev');
//   const nextBtn = getEl('skuVideoNext');
//   if (prevBtn) prevBtn.disabled = skuVideoCarouselIndex <= 0;
//   if (nextBtn) nextBtn.disabled = skuVideoCarouselIndex >= Math.max(skuVideoPlaylist.length - SKU_VIDEO_VISIBLE_COUNT, 0);
// }

// function renderSkuVideoCarousel(videos) {
//   const section = getEl('sku-modal-videos');
//   const track   = getEl('skuVideoTrack');
//   if (!section || !track) return;
  
//   skuVideoPlaylist = videos || [];
//   skuVideoCarouselIndex = 0;
  
//   if (!skuVideoPlaylist.length) {
//     section.style.display = 'none';
//     track.innerHTML = '';
//     return;
//   }
  
//   section.style.display = 'block';
  
//   track.innerHTML = skuVideoPlaylist.map((v, i) => {
//     const thumb = v.thumb || `https://img.youtube.com/vi/${v.videoId}/hqdefault.jpg`;
    
//     // ← AGREGA ESTO: Construir HTML de productDetails
//     const productDetailsHtml = (v.prodcutDetails || []).map(pd => 
//       `<span class="sku-video-product-detail">${pd.name || ''}</span>`
//     ).join('');
    
//     console.log("data =>", v);
    
//     return `
//     <div class="sku-video-item" data-index="${i}">
//       <div class="sku-video-circle" style="position:relative;">
//         <img src="${thumb}" alt="${v.label || ''}">
//         <div style="position:absolute;inset:0;background:rgba(0,0,0,0.22);border-radius:50%;"></div>
//         <div class="sku-video-play" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:34px;height:34px;background:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;pointer-events:none;box-shadow:0 2px 8px rgba(0,0,0,0.4);z-index:5;">
//         </div>
//       </div>
//       ${productDetailsHtml ? `<div class="sku-video-products">${productDetailsHtml}</div><br/>` : ''}
//     </div>`;
//   }).join('');
  
//   track.querySelectorAll('.sku-video-item').forEach(item => {
//     item.addEventListener('click', () => {
//       openSkuVideoModal(parseInt(item.dataset.index, 10));
//     });
//   });
  
//   updateSkuVideoCarousel();
// }


// function skuVideoCarouselPrev() {
//   skuVideoCarouselIndex = Math.max(skuVideoCarouselIndex - 1, 0);
//   updateSkuVideoCarousel();
// }
// function skuVideoCarouselNext() {
//   skuVideoCarouselIndex = Math.min(skuVideoCarouselIndex + 1, Math.max(skuVideoPlaylist.length - SKU_VIDEO_VISIBLE_COUNT, 0));
//   updateSkuVideoCarousel();
// }

// function getSkuVideoPlayerSize() {
//   const wrap = document.querySelector('.sku-video-modal-wrap');
//   const rect = wrap.getBoundingClientRect();
//   return { width: Math.round(rect.width), height: Math.round(rect.height) };
// }

// function playSkuVideoCurrent() {
//   const videoId = skuVideoPlaylist[skuVideoCurrentIndex]?.videoId;
//   if (!videoId) return;
//   if (!skuYtApiReady || !window.YT || !window.YT.Player) {
//     setTimeout(playSkuVideoCurrent, 200);
//     return;
//   }
//   const size = getSkuVideoPlayerSize();

//   if (skuYtPlayer) {
//     skuYtPlayer.loadVideoById(videoId);
//     skuYtPlayer.setSize(size.width, size.height);
//   } else {
//     skuYtPlayer = new YT.Player('skuYoutubePlayer', {
//       videoId: videoId,
//       width: size.width,
//       height: size.height,
//       playerVars: { autoplay: 1, rel: 0, modestbranding: 1, playsinline: 1, controls: 1, iv_load_policy: 3 },
//       events: {
//         onReady: e => e.target.setSize(size.width, size.height),
//         onStateChange: e => { if (e.data === YT.PlayerState.ENDED) playSkuVideoNext(); }
//       }
//     });
//   }
// }

// function playSkuVideoNext() {
//   skuVideoCurrentIndex = (skuVideoCurrentIndex + 1) % skuVideoPlaylist.length;
//   playSkuVideoCurrent();
// }

// function openSkuVideoModal(index) {
//   skuVideoCurrentIndex = index;
//   const modal = getEl('skuVideoModal');
//   modal.classList.add('open');
//   document.body.style.overflow = 'hidden';
//   ensureYoutubeApiLoaded();
//   playSkuVideoCurrent();
// }

// function closeSkuVideoModal() {
//   const modal = getEl('skuVideoModal');
//   modal.classList.remove('open');
//   document.body.style.overflow = '';
//   if (skuYtPlayer && skuYtPlayer.stopVideo) skuYtPlayer.stopVideo();
// }

// function initSkuVideoCarousel() {
//   const prevBtn = getEl('skuVideoPrev');
//   const nextBtn = getEl('skuVideoNext');
//   const closeBtn = getEl('skuVideoModalClose');
//   const modal = getEl('skuVideoModal');
//   if (!prevBtn || prevBtn.dataset.listenerAttached) return;

//   prevBtn.addEventListener('click', skuVideoCarouselPrev);
//   nextBtn.addEventListener('click', skuVideoCarouselNext);
//   closeBtn.addEventListener('click', closeSkuVideoModal);
//   modal.addEventListener('click', e => { if (e.target.id === 'skuVideoModal') closeSkuVideoModal(); });
//   window.addEventListener('resize', () => {
//     if (skuYtPlayer && skuYtPlayer.setSize) {
//       const size = getSkuVideoPlayerSize();
//       skuYtPlayer.setSize(size.width, size.height);
//     }
//     updateSkuVideoCarousel();
//   });

//   prevBtn.dataset.listenerAttached = 'true';
// }










// /* ============================================================
//    MASTER ORDER CONTEXT — Company → Customer en cascada
//    ============================================================ */

// window.b2bMasterOrderContext = {
//   companyId: null,
//   companyName: null,
//    companyContactId: null,
//   companyLocationId: null,
//   customerId: null,
//   customerName: null,
//   customerEmail: null
// };

// const MASTER_API_BASE = 'https://shopifyadminapi.8motiv.com/api/Master';

// async function loadMasterCompanies() {
//   const companySel = getEl('master-company-select');
//   if (!companySel) return;

//   try {
//     const res  = await fetch(`${MASTER_API_BASE}/Companies`);
//     const data = await res.json();

//     console.log({data:data});

//     if (!data.success || !data.companies?.length) {
//       companySel.innerHTML = '<option value="">No companies found</option>';
//       return;
//     }

//     companySel.innerHTML =
//       '<option value="">— Select company —</option>' +
//       data.companies.map(c =>
//         `<option value="${c.id}" data-location-id="${c.locations?.[0]?.id || ''}">${c.name}</option>`
//       ).join('');

//   } catch (err) {
//     console.error('[Master] Error loading companies:', err);
//     companySel.innerHTML = '<option value="">Error loading companies</option>';
//   }
// }

// async function loadMasterCustomers(companyId) {
//   const customerSel = getEl('master-customer-select');
//   if (!customerSel) return;

//   customerSel.disabled = true;
//   customerSel.innerHTML = '<option value="">Loading customers...</option>';

//   if (!companyId) {
//     customerSel.innerHTML = '<option value="">Select a company first</option>';
//     return;
//   }

//   try {
//     const res  = await fetch(`${MASTER_API_BASE}/CompanyCustomers?companyId=${encodeURIComponent(companyId)}`);
//     const data = await res.json();

//     if (!data.success || !data.customers?.length) {
//       customerSel.innerHTML = '<option value="">No customers found for this company</option>';
//       customerSel.disabled = false;
//       return;
//     }

//     customerSel.innerHTML =
//       '<option value="">— Select customer —</option>' +
//       data.customers.map(c => {
//         const fullName = `${c.firstName || ''} ${c.lastName || ''}`.trim() || c.email || c.customerId;
//         return `<option value="${c.customerId}"
//           data-email="${c.email || ''}"
//           data-name="${fullName}"
//           data-contact-id="${c.contactId || ''}">${fullName}${c.isMainContact ? ' (Main Contact)' : ''}</option>`;
//       }).join('');

//     customerSel.disabled = false;

//   } catch (err) {
//     console.error('[Master] Error loading customers:', err);
//     customerSel.innerHTML = '<option value="">Error loading customers</option>';
//     customerSel.disabled = false;
//   }
// }

// function updateMasterOrderBadge() {
//   const badge     = getEl('master-order-badge');
//   const badgeName = getEl('master-order-badge-name');
//   const ctx       = window.b2bMasterOrderContext;

//   if (!badge || !badgeName) return;

//   if (ctx.customerId && ctx.customerName) {
//     badgeName.textContent = `${ctx.customerName} — ${ctx.companyName}`;
//     badge.style.display = 'inline-block';
//   } else {
//     badge.style.display = 'none';
//   }
// }


// function updateMasterOrderLock() {
//   if (!window.b2bIsMasterUser) return;

//   const overlay = getEl('master-order-lock-overlay');
//   const ctx     = window.b2bMasterOrderContext;
//   const isReady = !!(ctx.companyId && ctx.customerId);

//   window.b2bMasterOrderLocked = !isReady; // ← flag global que leen los handlers de clic

//   if (overlay) overlay.style.display = isReady ? 'none' : 'flex';

//   // ── Steppers: bloqueo VISUAL (no disabled nativo) para poder capturar el clic ──
//   variantRows().forEach(row => {
//     const plus  = row.querySelector('.step-plus');
//     const minus = row.querySelector('.step-minus');
//     const stock = parseInt(row.dataset.stock || 0);

//     if (plus) {
//       const shouldLook = !isReady || stock <= 0;
//       plus.style.opacity    = shouldLook ? '0.4' : '';
//       plus.style.cursor     = shouldLook ? 'not-allowed' : '';
//       // Solo aplicamos disabled real cuando el bloqueo es por STOCK (no por master lock)
//       plus.disabled = isReady && stock <= 0;
//     }
//     if (minus) {
//       const curQty = parseInt(row.querySelector('.hidden-qty')?.value || 0);
//       const shouldLook = !isReady || curQty <= 0;
//       minus.style.opacity = shouldLook ? '0.4' : '';
//       minus.style.cursor  = shouldLook ? 'not-allowed' : '';
//       minus.disabled = isReady && curQty <= 0;
//     }
//   });

//   // ── Search / FOC: bloqueo real está bien porque no necesitan mensaje de clic ──
//   const searchInput = getEl('b2b-search-input');
//   if (searchInput) {
//     searchInput.disabled = !isReady;
//     searchInput.style.opacity = isReady ? '' : '0.5';
//   }

//   // ── Add FOC: lo dejamos clickeable para mostrar el aviso (igual que los steppers) ──
//   const focBtn = getEl('master-foc-btn');
//   if (focBtn) {
//     focBtn.style.opacity = isReady ? '' : '0.5';
//     focBtn.style.cursor  = isReady ? '' : 'not-allowed';
//   }

//   // ── Buy buttons: mantenemos disabled real, ya que handleBuyNow() ya valida y alerta al hacer submit del form completo ──
//   const buyBtn       = getEl('b2b-buy-btn');
//   const buyBtnBottom = getEl('b2b-buy-now-bottom');
//   if (!isReady) {
//     if (buyBtn)       buyBtn.disabled = true;
//     if (buyBtnBottom) buyBtnBottom.disabled = true;
//   }
// }

// function initMasterOrderContext() {
//   const companySel  = getEl('master-company-select');
//   const customerSel = getEl('master-customer-select');
//   if (!companySel || !customerSel || companySel.dataset.listenerAttached) return;

//   loadMasterCompanies();
//   updateMasterOrderLock(); // ← estado inicial: bloqueado

//   companySel.addEventListener('change', () => {
//     const opt = companySel.selectedOptions[0];
//     const companyId = companySel.value;

//     window.b2bMasterOrderContext.companyId          = companyId || null;
//     window.b2bMasterOrderContext.companyName         = companyId ? opt.textContent : null;
//     window.b2bMasterOrderContext.companyLocationId   = companyId ? (opt.dataset.locationId || null) : null;
//     window.b2bMasterOrderContext.customerId          = null;
//     window.b2bMasterOrderContext.customerName        = null;
//     window.b2bMasterOrderContext.customerEmail       = null;
//     window.b2bMasterOrderContext.companyContactId    = null;

//     loadMasterCustomers(companyId);
//     updateMasterOrderBadge();
//     updateMasterOrderLock(); // ← se re-bloquea porque el customer se limpió
//   });

//   customerSel.addEventListener('change', () => {
//     const opt = customerSel.selectedOptions[0];
//     const customerId = customerSel.value;

//     window.b2bMasterOrderContext.customerId       = customerId || null;
//     window.b2bMasterOrderContext.customerName     = customerId ? opt.dataset.name : null;
//     window.b2bMasterOrderContext.customerEmail    = customerId ? opt.dataset.email : null;
//     window.b2bMasterOrderContext.companyContactId = customerId ? opt.dataset.contactId : null;

//     updateMasterOrderBadge();
//     updateMasterOrderLock(); // ← desbloquea si ya hay ambos
//   });

//   companySel.dataset.listenerAttached = 'true';
// }






// /* ============================================================
//    MASTER FOC — asignación libre, único límite: stock real
//    ============================================================ */

// function initMasterFocModal() {
//   if (!window.b2bIsMasterUser) return;
//   const btn   = getEl('master-foc-btn');
//   const modal = getEl('master-foc-modal');
//   if (!btn || !modal || btn.dataset.listenerAttached) return;

//  btn.addEventListener('click', () => {
//   const ctx = window.b2bMasterOrderContext;
//   if (!ctx.companyId || !ctx.customerId) {
//     showMasterLockRequiredModal();
//     return;
//   }
//   renderMasterFocTable('');
//   modal.style.display = 'flex';
//   document.body.style.overflow = 'hidden';
// });

//   getEl('master-foc-close')?.addEventListener('click', closeMasterFocModal);
//   getEl('master-foc-overlay')?.addEventListener('click', closeMasterFocModal);

//   getEl('master-foc-search')?.addEventListener('input', (e) => {
//     renderMasterFocTable(e.target.value.trim().toLowerCase());
//   });

  

// getEl('master-foc-confirm')?.addEventListener('click', () => {
//     document.querySelectorAll('#master-foc-tbody .master-foc-qty-input').forEach(input => {
//       const vid = input.dataset.variantId;
//       const max = parseInt(input.closest('.master-foc-stepper')?.dataset.max || 0); // ✅ FIX
//       let qty   = parseInt(input.value) || 0;
//       if (qty < 0)   qty = 0;
//       if (qty > max) qty = max;
//       if (qty > 0) window.b2bMasterFreeItems[vid] = qty;
//       else         delete window.b2bMasterFreeItems[vid];
//     });
//     closeMasterFocModal();
//     applyFreeProductStockDeductions();
//     updateTotals();
//     updateIncentiveBanners();
//     renderPurchaseDetails(); // ← también sin el "if expanded", para que el dashboard FOC se actualice siempre
//   });

//   btn.dataset.listenerAttached = 'true';
// }

// function closeMasterFocModal() {
//   const modal = getEl('master-foc-modal');
//   if (modal) modal.style.display = 'none';
//   document.body.style.overflow = '';
// }

// function renderMasterFocTable(filterText) {
//   const tbody = getEl('master-foc-tbody');
//   if (!tbody) return;

//   const recommended = computeMasterRecommendedFoc();

//   const rows = variantRows().filter(row => {
//     const pres = (row.dataset.presentation || '').toLowerCase();
//     const isVialOrTester = pres.includes('vial') || pres.includes('vail') || pres.includes('tester');
//     if (!isVialOrTester) return false;

//     if (!filterText) return true;
//     const hay = [row.dataset.sku, row.dataset.perfume, row.dataset.collection, row.dataset.ml, row.dataset.presentation].join(' ').toLowerCase();
//     return hay.includes(filterText);
//   });

//   tbody.innerHTML = rows.map(row => {
//     const vid           = row.dataset.variantId;
//     const realStock     = parseInt(row.dataset.realStock || 0);
//     const purchasedQty  = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     const currentMaster = parseInt(window.b2bMasterFreeItems[vid] || 0);
//     const available     = Math.max(0, realStock - purchasedQty);
//     const maxForInput   = available + currentMaster;
//     const rec           = recommended[vid] || 0;

//     const imgUrl  = row.dataset.imgUrl || '';
//     const product = row.cells[5]?.textContent?.trim() || '';
//     const sku     = (row.dataset.sku || '').toUpperCase();
//     const ml      = row.cells[7]?.textContent?.trim() || '';
//     const pres    = row.cells[8]?.textContent?.trim() || '';

//     return `
//       <tr style="border-bottom:1px solid #e5e7eb;">
//         <td style="padding:8px;text-align:center;">
//           ${imgUrl ? `<img src="${imgUrl}" style="width:48px;height:48px;object-fit:cover;border-radius:6px;">` : ''}
//         </td>
//         <td style="padding:8px;">${product}</td>
//         <td style="padding:8px;text-align:center;">${sku}</td>
//         <td style="padding:8px;text-align:center;">${ml}</td>
//         <td style="padding:8px;text-align:center;">${pres}</td>
//         <td style="padding:8px;text-align:center;font-weight:700;">${available}</td>
//         <td style="padding:8px;text-align:center;">
//           ${rec > 0
//             ? `<span style="background:#dcfce7;color:#166534;font-weight:700;padding:3px 12px;border-radius:12px;">${rec}</span>`
//             : '<span style="color:#9ca3af;">—</span>'}
//         </td>
//         <td style="padding:8px;text-align:center;">
//           <div class="master-foc-stepper" data-variant-id="${vid}" data-max="${maxForInput}"
//             style="display:inline-flex;align-items:center;gap:8px;">
//             <button type="button" class="master-foc-minus"
//               style="width:28px;height:28px;border:1px solid #e5e7eb;border-radius:6px;background:#f9fafb;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;">−</button>
//             <span class="master-foc-qty-val" style="min-width:22px;text-align:center;font-weight:700;font-size:15px;">${currentMaster}</span>
//             <button type="button" class="master-foc-plus"
//               style="width:28px;height:28px;border:1px solid #b8a77d;border-radius:6px;background:#b8a77d;color:#fff;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;">+</button>
//             <input type="hidden" class="master-foc-qty-input" data-variant-id="${vid}" value="${currentMaster}">
//           </div>
//         </td>
//       </tr>`;
//   }).join('');

//   // ── Delegación de eventos para los steppers (una sola vez) ──
//   if (!tbody.dataset.stepperListenerAttached) {
//     tbody.addEventListener('click', e => {
//       const minusBtn = e.target.closest('.master-foc-minus');
//       const plusBtn  = e.target.closest('.master-foc-plus');
//       if (!minusBtn && !plusBtn) return;

//       const wrapper = e.target.closest('.master-foc-stepper');
//       const max     = parseInt(wrapper.dataset.max || 0);
//       const valEl   = wrapper.querySelector('.master-foc-qty-val');
//       const hidden  = wrapper.querySelector('.master-foc-qty-input');
//       let qty       = parseInt(hidden.value) || 0;

//       if (minusBtn) qty = Math.max(0, qty - 1);
//       if (plusBtn)  qty = Math.min(max, qty + 1);

//       valEl.textContent = qty;
//       hidden.value = qty;
//     });
//     tbody.dataset.stepperListenerAttached = 'true';
//   }
// }


// /* Calcula el FOC recomendado por variante regalo, según lo que hay en el pedido */
// function computeMasterRecommendedFoc() {
//   const rec = {};
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;

//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!extras) return;

//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

//     const fps  = getVariantFreeProducts(extras);
//     const fqs  = getVariantFreeQtys(extras);
//     const mult = calcVariantMultiplier(extras, qty, lineV);

//     fps.forEach((fp, i) => {
//       const gvid = String(fp?.variant_id || '');
//       if (!gvid || gvid === '0') return;
//       rec[gvid] = (rec[gvid] || 0) + (fqs[i] || 1) * mult;
//     });
//   });
//   return rec;
// }

// /* ============================================================
//    INIT GLOBAL
//    ============================================================ */

// window.b2bInitAll = function() {
//   initSteppers();
//   initCopySku();
//   initSkuHover();
//   initSkuVideoCarousel();
//   initSkuModal();
//   initSkuAudioPlayer();
//   initSearch();
//   initSort();
//   initPresentationFilter();
//   b2bBuildFilterOptions();
//   b2bInitCombos();
//   b2bApplyFilters();
//   initGuidelinesModal();
//   initExcelExport();
//   initCatalogExport();
//   initPdfExport();
//   initGlobalListeners();
//   initViewToggle();
//   updateTotals();
//   initFooterPadding();
//    initSendModal();
//    initPresQuickFilter();
//    if (window.b2bIsMasterUser) initMasterOrderContext();
//     if (window.b2bIsMasterUser) initMasterFocModal();
// };

// window.openAllVariantRewardsModal = openAllVariantRewardsModal;
// window.openRewardChoiceModal      = openRewardChoiceModal;
// window.b2bApplyFilters            = b2bApplyFilters;





/* ============================================================
   B2B MARCA TABLA — JS REFACTORIZADO
   - type, coefficient y msrp vienen de la variante (extras)
     con fallback al metafield del producto (notes)
   ============================================================ */

'use strict';


/* ============================================================
   CONSTANTES Y UTILIDADES
   ============================================================ */

const formatNum = n => {
  const num = parseFloat(n);
  if (isNaN(num)) return n;
  return num.toLocaleString('en-US');
};

function getOrdersCount() { return window._b2bOrdersCount || 0; }
function isFirstOrder()   { return getOrdersCount() === 0; }

const normalize   = s => (s || '').toString().trim().toLowerCase();
const toCents     = v => { const n = parseInt(v, 10); return isNaN(n) ? 0 : n; };
const getEl       = id => document.getElementById(id);
const qsa         = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
const variantRows = () => qsa('.b2b-variant-row');

function getColHandle() {
  return (new URLSearchParams(window.location.search).get('vendor') || '')
    .toLowerCase().trim().replace(/\s+/g, '-').replace(/[^a-z0-9-]/g, '');
}

function formatMoney(val) {
  return parseFloat(val).toLocaleString('en-US', {
    style: 'currency', currency: 'USD', minimumFractionDigits: 2
  });
}

// function loadImgAsBase64ForExport(url) {
//   return new Promise((resolve, reject) => {
//     if (!url) { reject(new Error('no url')); return; }
//     const img = new Image();
//     img.crossOrigin = 'Anonymous';
//     img.onload = () => {
//       try {
//         const canvas = document.createElement('canvas');
//         canvas.width = img.width;
//         canvas.height = img.height;
//         canvas.getContext('2d').drawImage(img, 0, 0);
//         resolve(canvas.toDataURL('image/png'));
//       } catch (e) { reject(e); }
//     };
//     img.onerror = reject;
//     img.src = url;
//   });
// }
function loadImgAsBase64ForExport(url, maxSize = 120) {
  return new Promise((resolve, reject) => {
    if (!url) { reject(new Error('no url')); return; }
    const smallUrl = url.replace(/(\.[^.]+)(\?.*)?$/, `_${maxSize}x${maxSize}$1$2`);
 
    fetch(smallUrl)
      .then(res => {
        if (!res.ok) throw new Error('image fetch failed: ' + res.status);
        return res.blob();
      })
      .then(blob => {
        const blobUrl = URL.createObjectURL(blob);
        const img = new Image();
        img.onload = () => {
          try {
            const canvas = document.createElement('canvas');
            canvas.width = maxSize;
            canvas.height = maxSize;
            const ctx = canvas.getContext('2d');
            const scale = Math.max(maxSize / img.width, maxSize / img.height);
            const w = img.width * scale, h = img.height * scale;
            const dx = (maxSize - w) / 2, dy = (maxSize - h) / 2;
            ctx.drawImage(img, dx, dy, w, h);
            URL.revokeObjectURL(blobUrl);
            resolve(canvas.toDataURL('image/jpeg', 0.7));
          } catch (e) {
            URL.revokeObjectURL(blobUrl);
            reject(e);
          }
        };
        img.onerror = (e) => { URL.revokeObjectURL(blobUrl); reject(e); };
        img.src = blobUrl;
      })
      .catch(err => {
        console.warn('[export] No se pudo cargar imagen:', smallUrl, err);
        reject(err);
      });
  });
}
/* ============================================================
   HELPERS: resolver type / coefficient / msrp desde variante
   con fallback al producto
   ============================================================ */

/**
 * Devuelve el valor del campo desde extras (variante) si existe y no es vacío/nulo,
 * o cae al valor del producto (notes) como fallback.
 */
function resolveVariantField(extras, notes, field, fallbackField, defaultVal) {
  const variantVal = extras[field];
  if (variantVal != null && variantVal !== '' && variantVal !== 0) return variantVal;
  const productVal = notes[fallbackField || field];
  if (productVal != null && productVal !== '') return productVal;
  return defaultVal !== undefined ? defaultVal : 'N/A';
}

function getTypeVal(extras, notes) {
  return resolveVariantField(extras, notes, 'type', 'type', 'N/A');
}

function getCoefficientVal(extras, notes) {
  return resolveVariantField(extras, notes, 'coefficient', 'coefficient', 'N/A');
}

function getMsrpVal(extras, notes) {
  // msrp: si extras.msrp es 0 también se considera "sin valor" → cae a notes
  const v = extras.msrp;
  if (v != null && v !== '' && v !== 0) return v;
  const n = notes.msrp;
  if (n != null && n !== '') return n;
  return '0';
}

/* ============================================================
   HELPERS DE INCENTIVOS
   ============================================================ */

function isAutoApply(rule) {
  return rule.apply !== false && rule.apply !== 'false';
}

function normalizeQtyArray(arr) {
  if (!Array.isArray(arr)) return [];
  return arr.map(item => {
    if (item == null) return 1;
    if (typeof item === 'number') return item > 0 ? item : 1;
    if (typeof item === 'string') return parseInt(item, 10) || 1;
    if (typeof item === 'object') return parseInt(item.value || item, 10) || 1;
    return 1;
  });
}

function getTesterQty(rule, idx) {
  const arr = normalizeQtyArray(rule.testers_qty);
  if (!arr.length) return 1;
  return arr[idx] !== undefined ? arr[idx] : arr[0];
}

function calcActiveIncentive(rules, totalUnits, totalValue) {
  let active = null;
  for (const rule of rules) {
    const minQ = Number(rule.min_qty || 0);
    const minV = Number(rule.min_order_value || 0);
    if ((minQ <= 0 || totalUnits >= minQ) && (minV <= 0 || totalValue >= minV)) {
      active = rule;
    }
  }
  return active;
}

function calcNextIncentive(rules, totalUnits, totalValue) {
  for (const rule of rules) {
    const minQ = Number(rule.min_qty || 0);
    const minV = Number(rule.min_order_value || 0);
    if (!(minQ <= 0 || totalUnits >= minQ) || !(minV <= 0 || totalValue >= minV)) {
      return rule;
    }
  }
  return null;
}

function getVariantThresholds(extras) {
  if (isFirstOrder()) {
    const firstMin = Number(extras.incentive_product || 0);
    return {
      minU: firstMin > 0 ? firstMin : Number(extras.next_incentive_product || 0),
      minV: Number(extras.incentive_value || 0) || Number(extras.next_incentive_value || 0)
    };
  }
  return {
    minU: Number(extras.next_incentive_product || 0),
    minV: Number(extras.next_incentive_value   || 0)
  };
}


function computeCartGiftQty(variantId, baseQty) {
  const vid = String(variantId || '');
  if (!vid) return baseQty;
  const extras  = window.b2bVariantExtrasMap?.[vid] || {};
  const varData = window.b2bAllVariantsMap?.[vid] || {};
  const row     = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
  const pres = (extras.presentation || varData.pres || (row ? row.cells[8]?.textContent?.trim() : '') || '').toLowerCase();
  const isVials = pres.includes('vial') || pres.includes('vail');
  if (!isVials) return baseQty;
  const pack = parseInt(extras.quantity) || 1;
  return baseQty * (pack > 1 ? pack : 1);
}

/* ============================================================
   PRIORIDAD 4 — igual que la 2, pero los productos del crédito
   son SOLO los Tester / Vial de los productos que se compraron
   ============================================================ */

// ¿La colección usa el flujo de crédito (P2 o P4)?
function b2bIsCreditPriority(p) {
  const pr = Number(p != null ? p : (window.b2bCollectionPriority || 1));
  return pr === 2 || pr === 4;
}

function b2bIsTesterOrVial(pres) {
  const p = String(pres || '').toLowerCase();
  return p.includes('tester') || p.includes('vial') || p.includes('vail');
}

/**
 * Construye la lista de productos del crédito para la prioridad 4
 * (mismo formato que window.b2bDiscountProducts de la prioridad 2).
 *  - opts.productId → solo los tester/vial de ese producto (modal de la fila)
 *  - opts.all       → todos los tester/vial de la tabla (exports / info)
 *  - por defecto    → solo los tester/vial de los productos comprados (qty > 0)
 */
function b2bBuildP4Products(opts = {}) {
  const rows = variantRows();

  // Productos comprados: filas con qty > 0 que NO son tester / vial
  const bought = new Set();
  rows.forEach(r => {
    const qty = parseInt(r.querySelector('.hidden-qty')?.value) || 0;
    if (qty > 0 && !b2bIsTesterOrVial(r.dataset.presentation)) bought.add(String(r.dataset.productId));
  });

  const list = [];
  const seen = new Set();
  rows.forEach(r => {
    if (!b2bIsTesterOrVial(r.dataset.presentation)) return;
    const pid = String(r.dataset.productId);
    if (opts.productId != null) {
      if (pid !== String(opts.productId)) return;
    } else if (!opts.all && !bought.has(pid)) {
      return;
    }
    const vid = String(r.dataset.variantId);
    if (seen.has(vid)) return;
    seen.add(vid);

    const vd = window.b2bAllVariantsMap?.[vid]   || {};

    // Precio normal de la variante = precio que entrega la tienda (data-unit-price)
    const normalPrice = parseFloat(r.dataset.unitPrice || 0) || parseFloat(r.dataset.msrp || 0);

    // Regla de desbloqueo de la variante (unlock_requires_presentation / qty / step)
    // ej. Perfume, 6, 1 → por cada 6 Perfume de ese producto, 1 de este tester/vial
    const unlockPres = (r.dataset.unlockPres || '').trim();
    const unlockQty  = parseInt(r.dataset.unlockQty || 0) || 0;
    const unlockStep = parseInt(r.dataset.unlockStep || 1) || 1;
    const maxQty     = getUnlockCap(r); // Infinity si no tiene regla

    list.push({
      variant_id:              vid,
      product_id:              pid,
      title:                   vd.title || r.cells[5]?.textContent?.trim() || '',
      variant_title:           [vd.pres, vd.ml].filter(Boolean).join(' - '),
      handle:                  r.dataset.handle || '',
      image:                   r.dataset.imgUrl || '',
      price:                   normalPrice,
      // Se fija al precio normal para que ningún cálculo use otro precio
      incentive_product_price: normalPrice,
      max_qty:                 maxQty,
      unlock_pres:             unlockPres,
      unlock_qty:              unlockQty,
      unlock_step:             unlockStep
    });
  });
  return list;
}

// En P4 refresca window.b2bDiscountProducts según lo comprado.
// Si una selección confirmada ya no es válida (se quitó el producto), se resetea.
function b2bSyncP4Products(opts) {
  if (Number(window.b2bCollectionPriority || 1) !== 4) return window.b2bDiscountProducts || [];
  // P4: se muestran TODOS los Tester y Vial de la marca, sin importar qué producto se compró
  const list = b2bBuildP4Products(opts || { all: true });
  window.b2bDiscountProducts = list;

  const ch = window.b2bPriority2Choice;
  if (ch?.confirmed && Array.isArray(ch.selections)) {
    const byVid = {};
    list.forEach(p => { byVid[String(p.variant_id)] = p; });
    // Se rompe si el producto ya no está comprado o si la cantidad elegida
    // supera lo que permite la regla (ej. bajó los Perfume de 12 a 6)
    const broken = ch.selections.some(s => {
      const q = s.selectedQty || 0;
      if (q <= 0) return false;
      const p = byVid[String(s.variant_id)];
      return !p || q > p.max_qty;
    });
    if (broken) {
      window.b2bPriority2Choice = { confirmed: false, selections: [], totalSpent: 0, discountPct: 0 };
    }
  }
  return list;
}
// Aviso "fondos insuficientes" dentro del modal de crédito
function b2bShowFundsMsg(available, price) {
  let msg = getEl('b2b-funds-msg');
  if (!msg) {
    msg = document.createElement('div');
    msg.id = 'b2b-funds-msg';
    msg.style.cssText = 'position:fixed;left:50%;top:24px;transform:translateX(-50%);z-index:9999999;'
      + 'background:#dc2626;color:#fff;padding:12px 20px;border-radius:10px;font-size:15px;font-weight:700;'
      + 'box-shadow:0 6px 20px rgba(0,0,0,.25);font-family:inherit;transition:opacity .3s;';
    document.body.appendChild(msg);
  }
  msg.textContent = `Insufficient funds — Available $${available.toFixed(2)}, this item costs $${price.toFixed(2)}`;
  msg.style.opacity = '1';
  msg.style.display = 'block';
  clearTimeout(window.__b2bFundsTimer);
  window.__b2bFundsTimer = setTimeout(() => {
    msg.style.opacity = '0';
    setTimeout(() => { msg.style.display = 'none'; }, 300);
  }, 2500);
}

window.b2bBuildP4Products = b2bBuildP4Products;
window.b2bSyncP4Products  = b2bSyncP4Products;
window.b2bIsCreditPriority = b2bIsCreditPriority;


function calcVariantMultiplier(extras, qty, lineValue) {
  const { minU, minV } = getVariantThresholds(extras);
  let m = 1;
  if      (minU > 0 && minV <= 0) m = Math.floor(qty / minU);
  else if (minV > 0 && minU <= 0) m = Math.floor(lineValue / minV);
  else if (minU > 0 && minV > 0)  m = Math.min(Math.floor(qty / minU), Math.floor(lineValue / minV));
  return Math.max(1, m);
}

function getVariantFreeProducts(extras) {
  if (!extras) return [];
  if (isFirstOrder()) {
    const first = extras.free_product_first_order || extras.free_products || [];
    return first.length > 0 ? first : (extras.free_product_next_order || []);
  }
  return extras.free_product_next_order || extras.free_products || [];
}

function getVariantFreeQtys(extras) {
  if (!extras) return [];
  if (isFirstOrder()) {
    const firstQtys = extras.free_product_first_qty || extras.free_product_quantities || [];
    return normalizeQtyArray(firstQtys.length > 0 ? firstQtys : (extras.free_product_next_qty || []));
  }
  return normalizeQtyArray(extras.free_product_next_qty || extras.free_product_quantities || []);
}

function dedupeFreeGifts(rawProducts, rawQtys) {
  const seen = new Set();
  const products = [], qtys = [];
  (rawProducts || []).forEach((fp, i) => {
    const key = String(fp?.variant_id || fp?.handle || fp?.title || i);
    if (seen.has(key)) return; // descarta duplicado
    seen.add(key);
    products.push(fp);
    qtys.push((rawQtys || [])[i] || 1);
  });
  return { products, qtys };
}


// function variantHasIncentive(extras) {
//   if (!extras) return false;
//   const { minU, minV } = getVariantThresholds(extras);
//   const fps = getVariantFreeProducts(extras);
//   return (minU > 0 || minV > 0) && fps.length > 0;
// }

function variantHasIncentive(extras) {
  if (!extras) return false;
  const { minU, minV } = getVariantThresholds(extras);
  const fps = getVariantFreeProducts(extras);
  if (!(minU > 0 || minV > 0) || !fps.length) return false;
  return hasAnyGiftStock(fps); 
}

function checkVariantIncentiveMet(extras, qty, lineValue) {
  if (!extras) return false;
  const { minU, minV } = getVariantThresholds(extras);
  if (!minU && !minV) return false;
  const fps = getVariantFreeProducts(extras);
  if (!fps.length) return false;
  if (minU > 0 && minV <= 0) return qty >= minU;
  if (minV > 0 && minU <= 0) return lineValue >= minV;
  return qty >= minU && lineValue >= minV;
}

function formatIncentiveRule(rule, prefix = '') {
  const parts = [];
  const d    = Number(rule.discount || 0);
  const auto = isAutoApply(rule);
  const sep  = auto ? ' + ' : ' <em style="color:#92400e;">or</em> ';

  if (Array.isArray(rule.free_testers) && rule.free_testers.length) {
    rule.free_testers.forEach((tp, i) => {
      if (tp?.title) parts.push(`<strong>${getTesterQty(rule, i)}x</strong> tester: ${tp.title}`);
    });
  } else {
    const tot = normalizeQtyArray(rule.testers_qty).reduce((s, q) => s + q, 0);
    if (tot > 0) parts.push(`<strong>${tot}</strong> tester${tot > 1 ? 's' : ''}`);
  }

  if (Array.isArray(rule.free_products)) {
    rule.free_products.forEach((fp, i) => {
      if (fp?.title) {
        const qty = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
        parts.push(`<strong>${qty}x</strong> free: ${fp.title}`);
      }
    });
  }

  if (d > 0) parts.push(`<strong>${d}%</strong> discount`);
  if (!parts.length) return '';
  return prefix + (auto ? 'you receive: ' : 'choose one: ') + parts.join(sep);
}

/* ============================================================
   ESTADO GLOBAL DE INCENTIVOS
   ============================================================ */

Object.defineProperty(window, 'b2bRC', {
  get() { return window.b2bRewardChoice || {}; }
});

const rewardChoice = new Proxy({}, {
  get(_, k)    { return (window.b2bRewardChoice || {})[k]; },
  set(_, k, v) { if (window.b2bRewardChoice) { window.b2bRewardChoice[k] = v; } return true; }
});

/* ============================================================
   STOCK
   ============================================================ */

let _freeStockDeductions = {};

// function setStockBadge(row, stock) {
//   const cell = row.querySelector('.b2b-stock-cell');
//   if (!cell) return;
//   if      (stock > 5) cell.innerHTML = `<span class="b2b-stock-ok">${stock}</span>`;
//   else if (stock > 0) cell.innerHTML = `<span class="b2b-stock-low">${stock}</span>`;
//   else                cell.innerHTML = `<span class="b2b-stock-out">0</span>`;
// }

// // function refreshStepperState(row) {
// //   const stock = parseInt(row.dataset.stock || 0);
// //   const cur   = parseInt(row.querySelector('.hidden-qty')?.value || 0);
// //   const plus  = row.querySelector('.step-plus');
// //   const minus = row.querySelector('.step-minus');
// //   if (plus)  plus.disabled  = stock <= 0;
// //   if (minus) minus.disabled = stock <= 0 && cur === 0;
// // }

// function refreshStepperState(row) {
//   const stock = parseInt(row.dataset.stock || 0);
//   const cur   = parseInt(row.querySelector('.hidden-qty')?.value || 0);
//   const plus  = row.querySelector('.step-plus');
//   const minus = row.querySelector('.step-minus');
//   if (plus)  plus.disabled  = stock <= 0 || cur >= stock;
//   if (minus) minus.disabled = cur <= 0;
// }

// // function applyFreeProductStockDeductions() {
// //   Object.keys(_freeStockDeductions).forEach(variantId => {
// //     const row = document.querySelector(`.b2b-variant-row[data-variant-id="${variantId}"]`);
// //     if (!row) return;
// //     row.dataset.stock = parseInt(row.dataset.realStock || 0);
// //     setStockBadge(row, parseInt(row.dataset.stock));
// //     refreshStepperState(row);
// //   });
// //   _freeStockDeductions = {};
// // }

// function applyFreeProductStockDeductions() {
//   const reservations = computeGiftReservations();

//   variantRows().forEach(row => {
//     const vid       = row.dataset.variantId;
//     const realStock = parseInt(row.dataset.realStock || 0);
//     const reserved  = reservations[vid] || 0;
//     const newStock  = Math.max(0, realStock - reserved);

//     row.dataset.stock = newStock;
//     setStockBadge(row, newStock);

//     // Si la cantidad ya comprada supera el nuevo stock disponible, la recortamos
//     const hidden = row.querySelector('.hidden-qty');
//     const valueEl = row.querySelector('.step-value');
//     const totalCell = row.querySelector('.b2b-row-total');
//     const curQty = parseInt(hidden?.value) || 0;
//     if (curQty > newStock) {
//       const clamped = Math.max(0, newStock);
//       if (hidden)   hidden.value = clamped;
//       if (valueEl)  valueEl.textContent = clamped;
//       if (totalCell) totalCell.textContent =
//         (clamped * parseFloat(row.dataset.unitPrice || 0))
//           .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     }

//     refreshStepperState(row);
//   });
// }


function setStockBadge(row, stock) {
  const cell = row.querySelector('.b2b-stock-cell');
  if (!cell) return;
  if      (stock > 5) cell.innerHTML = `<span class="b2b-stock-ok">${stock}</span>`;
  else if (stock > 0) cell.innerHTML = `<span class="b2b-stock-low">${stock}</span>`;
  else                cell.innerHTML = `<span class="b2b-stock-out">0</span>`;
}

// function refreshStepperState(row) {
//   const stock = parseInt(row.dataset.stock || 0);
//   const cur   = parseInt(row.querySelector('.hidden-qty')?.value || 0);
//   const plus  = row.querySelector('.step-plus');
//   const minus = row.querySelector('.step-minus');
//   if (plus)  plus.disabled  = stock <= 0 || cur >= stock;
//   if (minus) minus.disabled = cur <= 0;
// }

function refreshStepperState(row) {
  const stock     = parseInt(row.dataset.stock || 0);
  const sellLimit = parseInt(row.dataset.sellLimit || 0);
  const cur       = parseInt(row.querySelector('.hidden-qty')?.value || 0);
  const plus      = row.querySelector('.step-plus');
  const minus     = row.querySelector('.step-minus');

  if (plus) {
    // Solo deshabilitar de verdad cuando no hay stock disponible (0).
    // Si el límite es por sell_limit, lo dejamos "clickeable" para poder mostrar el aviso.
    plus.disabled = stock <= 0;
    const atSellLimit = sellLimit > 0 && cur >= stock && stock > 0;
    plus.style.opacity = atSellLimit ? '0.5' : '';
    plus.style.cursor  = atSellLimit ? 'not-allowed' : '';
  }
  if (minus) minus.disabled = cur <= 0;
}

/* ── Calcula cuánto de cada variante está comprometido como regalo (P1 + P2 + P3 + reglas de colección) ── */
function computeGiftReservations() {

  if (window.b2bIsMasterUser) {
    const reservations = {};
    Object.entries(window.b2bMasterFreeItems || {}).forEach(([vid, qty]) => {
      vid = String(vid);
      if (!vid || !qty) return;
      reservations[vid] = (reservations[vid] || 0) + qty;
    });
    return reservations;
  }

  const reservations = {};
  const add = (vid, qty) => {
    vid = String(vid || '');
    if (!vid || vid === '0' || !qty) return;
    reservations[vid] = (reservations[vid] || 0) + qty;
  };

  // ── P1: incentivos por variante (single choice o multi choice confirmado) ──
  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (qty <= 0) return;
    const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
    if (!variantHasIncentive(extras)) return;
    const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
    if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

    const fps  = getVariantFreeProducts(extras);
    const fqs  = getVariantFreeQtys(extras);
    const mult = calcVariantMultiplier(extras, qty, lineV);
    const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

    if (fps.length > 1) {
      if (choice?.confirmed) add(choice.chosenVariantId, choice.chosenQty);
    } else {
      fps.forEach((fp, i) => add(fp.variant_id, (fqs[i] || 1) * mult));
    }
  });

  // ── P2 ──
  const p2 = window.b2bPriority2Choice || {};
  if (p2.confirmed && Array.isArray(p2.selections)) {
    p2.selections.forEach(s => add(s.variant_id, s.selectedQty || 0));
  }

  // ── P3 ──
  const p3 = window.b2bPriority3Choice || {};
  if (p3.confirmed && Array.isArray(p3.selections)) {
    p3.selections.forEach(sel => {
      (sel.choices || []).forEach(c => add(c.chosenVariantId, c.chosenQty || 0));
    });
  }

  // ── Reglas de colección (auto-apply o elegidas por el cliente) ──
  const rules = window.b2bCollectionIncentivesMap?.[getColHandle()] || [];
  if (rules.length) {
    let unitsCol = 0, valueCol = 0;
    variantRows().forEach(row => {
      const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
      if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) return;
      unitsCol += qty; valueCol += lineV;
    });
    const active = calcActiveIncentive(rules, unitsCol, valueCol);
    if (active) {
      if (isAutoApply(active)) {
        (active.free_products || []).forEach((fp, i) => {
          add(fp.variant_id, normalizeQtyArray(active.free_product_quantities)[i] || 1);
        });
        (active.free_testers || []).forEach((tp, i) => {
          add(tp.variant_id, getTesterQty(active, i));
        });
      } else if (rewardChoice.confirmed) {
        add(rewardChoice.chosenVariantId, rewardChoice.chosenQty || 1);
      }
    }
  }

  return reservations;
}

// function applyFreeProductStockDeductions() {
//   const reservations = computeGiftReservations();

//   variantRows().forEach(row => {
//     const vid       = row.dataset.variantId;
//     const realStock = parseInt(row.dataset.realStock || 0);
//     const reserved  = reservations[vid] || 0;
//     const sellLimit = parseInt(row.dataset.sellLimit || 0);

//     let newStock = Math.max(0, realStock - reserved);
//     if (sellLimit > 0) {
//       newStock = Math.min(newStock, sellLimit);
//     }

//     row.dataset.stock = newStock;
//     setStockBadge(row, newStock);

//     // Si la cantidad ya comprada supera el nuevo stock disponible, la recortamos
//     const hidden    = row.querySelector('.hidden-qty');
//     const valueEl   = row.querySelector('.step-value');
//     const totalCell = row.querySelector('.b2b-row-total');
//     const curQty    = parseInt(hidden?.value) || 0;

//     if (curQty > newStock) {
//       const clamped = Math.max(0, newStock);
//       if (hidden)   hidden.value = clamped;
//       if (valueEl)  valueEl.textContent = clamped;
//       if (totalCell) totalCell.textContent =
//         (clamped * parseFloat(row.dataset.unitPrice || 0))
//           .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//       const badge = row.querySelector('.qty-badge');
//       if (badge) {
//         badge.textContent = clamped;
//         badge.style.display = clamped > 0 ? 'flex' : 'none';
//       }
//     }

//     refreshStepperState(row);
//   });

//   _freeStockDeductions = {};
// }

function applyFreeProductStockDeductions() {
  const reservations = computeGiftReservations();

  variantRows().forEach(row => {
    const vid       = row.dataset.variantId;
    const realStock = parseInt(row.dataset.realStock || 0);
    const reserved  = reservations[vid] || 0;
    const sellLimit = parseInt(row.dataset.sellLimit || 0);

    // ── Stock real disponible (descuenta lo reservado como FOC, pero NO aplica el tope de venta) ──
    const availableRealStock = Math.max(0, realStock - reserved);

    // ── Stock máximo que se puede COMPRAR (sí aplica el tope de venta) ──
    let purchasableStock = availableRealStock;
    if (sellLimit > 0) {
      purchasableStock = Math.min(purchasableStock, sellLimit);
    }


     const unlockCap = getUnlockCap(row);
    purchasableStock = Math.min(purchasableStock, unlockCap);


    row.dataset.stock = purchasableStock;       // usado por steppers para limitar compra
    setStockBadge(row, availableRealStock);     // ← muestra el stock REAL, no el tope de venta

    // Si la cantidad ya comprada supera lo que ahora se puede comprar, la recortamos
    const hidden    = row.querySelector('.hidden-qty');
    const valueEl   = row.querySelector('.step-value');
    const totalCell = row.querySelector('.b2b-row-total');
    const curQty    = parseInt(hidden?.value) || 0;

    if (curQty > purchasableStock) {
      const clamped = Math.max(0, purchasableStock);
      if (hidden)   hidden.value = clamped;
      if (valueEl)  valueEl.textContent = clamped;
      if (totalCell) totalCell.textContent =
        (clamped * parseFloat(row.dataset.unitPrice || 0))
          .toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      const badge = row.querySelector('.qty-badge');
      if (badge) {
        badge.textContent = clamped;
        badge.style.display = clamped > 0 ? 'flex' : 'none';
      }
    }

    refreshStepperState(row);
  });

  _freeStockDeductions = {};
}

/* ============================================================
   FETCH HELPER — variante regalo
   ============================================================ */

async function fetchFreeGiftVariant(handle, type = 'product') {
  try {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) return null;
    const variants = (await res.json()).variants || [];
    if (type === 'tester') return variants.find(v => v.available) || variants[0] || null;
    const FREE_KW = ['free', 'gift', 'sample'];
    const isFree = v =>
      parseFloat(v.price) === 0 ||
      FREE_KW.some(k =>
        (v.sku || '').toLowerCase().includes(k) ||
        ['option1', 'option2', 'option3'].some(f => (v[f] || '').toLowerCase().includes(k))
      );
    return variants.find(v => isFree(v) && v.available)
        || variants.find(v => parseFloat(v.price) === 0)
        || variants.find(v => isFree(v))
        || variants[0] || null;
  } catch {
    return null;
  }
}

/* ============================================================
   STEPPERS
   ============================================================ */

function initSteppers() {
  document.querySelectorAll('.quantity-stepper').forEach(stepper => {
    const minus     = stepper.querySelector('.step-minus');
    const plus      = stepper.querySelector('.step-plus');
    const valueEl   = stepper.querySelector('.step-value');
    const hidden    = stepper.querySelector('.hidden-qty');
    const row       = stepper.closest('tr');
    const totalCell = row.querySelector('.b2b-row-total');
    const minQty    = parseInt(row.dataset.minQty || 0);

    // function setQty(newQty) {
    //   const stock = parseInt(row.dataset.stock || 0);
    //   // ── Leer qty SIEMPRE desde el hidden input, no del closure ──
    //   const qty = Math.max(0, newQty);
    //   valueEl.textContent = qty;
    //   hidden.value = qty;
    //   const rowTotal = qty * parseFloat(row.dataset.unitPrice || 0);
    //   totalCell.textContent = rowTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    //   plus.disabled  = qty >= stock;
    //   minus.disabled = qty <= 0;

    //   const badge = row.querySelector('.qty-badge');
    //   if (badge) {
    //     badge.textContent = qty;
    //     badge.style.display = qty > 0 ? 'flex' : 'none';
    //   }
    //   updateTotals();
    // }

    function setQty(newQty) {
      const stock = parseInt(row.dataset.stock || 0);
      const qty = Math.max(0, newQty);
      valueEl.textContent = qty;
      hidden.value = qty;
      const rowTotal = qty * parseFloat(row.dataset.unitPrice || 0);
      totalCell.textContent = rowTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

      refreshStepperState(row); // ← usa la misma lógica centralizada
      minus.disabled = qty <= 0;

      const badge = row.querySelector('.qty-badge');
      if (badge) {
        badge.textContent = qty;
        badge.style.display = qty > 0 ? 'flex' : 'none';
      }
      updateTotals();
    }

      minus.addEventListener('click', () => {
        if (window.b2bIsMasterUser && window.b2bMasterOrderLocked) {
          showMasterLockRequiredModal();
          return;
        }
        // ── Leer siempre del hidden input, no del closure ──
        const currentQty = parseInt(hidden.value) || 0;
        if (currentQty === 0) return;
        setQty(currentQty <= minQty ? 0 : currentQty - 1);
      });

      plus.addEventListener('click', () => {
        if (window.b2bIsMasterUser && window.b2bMasterOrderLocked) {
          showMasterLockRequiredModal();
          return;
        }
        const stock      = parseInt(row.dataset.stock || 0);
        const sellLimit  = parseInt(row.dataset.sellLimit || 0);
        const currentQty = parseInt(hidden.value) || 0;
        const newQty     = currentQty === 0 && minQty > 1 ? minQty : currentQty + 1;

        if (newQty > stock) {
        const unlockPres = (row.dataset.unlockPres || '').trim();
        const unlockQty  = parseInt(row.dataset.unlockQty || 0);
        const unlockCap  = getUnlockCap(row);

        // ── Prioridad: si el bloqueo es por falta de desbloqueo, avisar eso ──
        if (unlockPres && unlockQty > 0 && newQty > unlockCap) {
          const productName    = row.cells[5]?.textContent?.trim() || '';
          const currentBase    = getProductPresentationPurchasedQty(row.dataset.handle, unlockPres);
          showUnlockRequiredModal(unlockQty, unlockPres.charAt(0).toUpperCase() + unlockPres.slice(1), productName, currentBase);
          return;
        }

        // ── Si no, y el límite es por sell_limit ──
        if (sellLimit > 0 && stock <= sellLimit) {
          const productName = row.cells[5]?.textContent?.trim() || '';
          showSellLimitModal(sellLimit, productName);
        }
        return;
      }
      setQty(newQty);
    });
  });
}

/* ============================================================
   COPY SKU
   ============================================================ */

function initCopySku() {
  document.querySelectorAll('.copy-sku-icon').forEach(btn => {
    btn.addEventListener('click', () => {
      const sku = btn.dataset.sku.trim();
      if (!sku || sku === '-') {
          const overlay = getEl('b2b-processing-overlay') || (() => {
            const el = document.createElement('div');
            el.id = 'b2b-processing-overlay';
            el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
            document.body.appendChild(el);
            return el;
          })();

          const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');

          overlay.innerHTML = `
            <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
                        box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
                        max-width:400px;width:90%;">
              <img src="${logoUrl}" alt="Logo"
                style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
                onerror="this.style.display='none'">
              <div style="width:56px;height:56px;border-radius:50%;background:#fee2e2;
                          display:flex;align-items:center;justify-content:center;
                          margin:0 auto 16px;font-size:28px;">⚠️</div>
              <div style="font-size:1.3rem;font-weight:700;color:#b91c1c;margin-bottom:8px;">
                No SKU available
              </div>
              <p style="font-size:15px;color:#555;margin:0 0 20px;line-height:1.6;">
                This product does not have a SKU assigned.
              </p>
              <button type="button" onclick="unlockUI()"
                style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
                      border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
                      font-family:'Crimson Pro',serif;width:100%;">
                OK
              </button>
            </div>`;

          overlay.style.display = 'flex';
          return;
        }
      navigator.clipboard.writeText(sku).then(() => {
        const orig = btn.textContent;
        btn.textContent = '✓ Copied';
        btn.style.color = '#b8a77d';
        setTimeout(() => { btn.textContent = orig; btn.style.color = ''; }, 2000);
      });
    });
  });
}

/* ============================================================
   SKU HOVER POPUP
   ============================================================ */

let skuPopup = null;

function ensureSkuPopup() {
  if (skuPopup) return;
  skuPopup = document.createElement('div');
  skuPopup.className = 'sku-popup';
  skuPopup.innerHTML = `
    <img class="sku-popup-img" src="" alt="">
    <div class="sku-popup-body">
      <div class="popup-description"></div>
      <div class="popup-notes">
        <span><strong>Top Notes:</strong> <span class="top-notes-val"></span></span>
        <span><strong>Middle Notes:</strong> <span class="middle-notes-val"></span></span>
        <span><strong>Base Notes:</strong> <span class="base-notes-val"></span></span>
      </div>
    </div>`;
  document.body.appendChild(skuPopup);
}

function parseNotes(val) {
  if (!val) return '-';
  try { const a = JSON.parse(val); if (Array.isArray(a)) return a.join(', '); } catch {}
  return val;
}

function positionPopup(e) {
  const margin = 16, popupW = 480, popupH = skuPopup.offsetHeight || 220;
  let x = e.clientX + margin, y = e.clientY + margin;
  if (x + popupW > window.innerWidth)  x = e.clientX - popupW - margin;
  if (y + popupH > window.innerHeight) y = e.clientY - popupH - margin;
  skuPopup.style.left = x + 'px';
  skuPopup.style.top  = y + 'px';
}

function initSkuHover() {
  ensureSkuPopup();
  variantRows().forEach(row => {
    const skuCell = row.querySelector('.sku-cell');
    if (!skuCell) return;
    skuCell.style.cursor = 'pointer';
    skuCell.addEventListener('mouseenter', e => {
      skuPopup.querySelector('.sku-popup-img').src = row.dataset.imgUrl || '';
      skuPopup.querySelector('.popup-description').textContent = row.dataset.description || 'No description.';
      skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(row.dataset.topNotes);
      skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(row.dataset.middleNotes);
      skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(row.dataset.baseNotes);
      positionPopup(e);
      skuPopup.classList.add('visible');
    });
    skuCell.addEventListener('mousemove', positionPopup);
    skuCell.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
  });
}

/* ============================================================
   SKU DETAIL MODAL
   ============================================================ */
  function initSkuModal() {
    const skuModal = getEl('sku-detail-modal');

    getEl('sku-modal-close-btn')?.addEventListener('click', () => {
      skuModal.style.display = 'none';
      document.body.style.overflow = '';
    });
    skuModal?.addEventListener('click', e => {
      if (e.target === skuModal) { skuModal.style.display = 'none'; document.body.style.overflow = ''; }
    });

    variantRows().forEach(row => {
      const skuCell = row.querySelector('.sku-cell');
      if (!skuCell) return;

      skuCell.addEventListener('click', e => {
        if (e.target.closest('.copy-sku-icon')) return;
        const handle    = row.dataset.handle || '';
        const notes     = window.b2bNotesMap?.[handle] || {};
        const extras    = window.b2bVariantExtrasMap?.[row.dataset.variantId];
        const freeProds = getVariantFreeProducts(extras);
        const freeQtys  = getVariantFreeQtys(extras);
        const curQty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
        const threshold  = isFirstOrder() ? Number(extras?.incentive_product || 0) : Number(extras?.next_incentive_product || extras?.incentive_product || 0);
        const multiplier = threshold > 0 && curQty > 0 ? Math.floor(curQty / threshold) : 0;
        const incValue   = isFirstOrder() ? (extras?.incentive_value || 0) : (extras?.next_incentive_value || extras?.incentive_value || 0);

        getEl('sku-modal-main-img').src           = row.dataset.imgUrl || '';
        getEl('sku-modal-title').textContent       = row.cells[5]?.textContent.trim() || '';
        getEl('sku-modal-sku').textContent         = (row.dataset.sku || '').toUpperCase();
        getEl('sku-modal-collection').textContent  = row.cells[4]?.textContent.trim() || '';
        getEl('sku-modal-ml').textContent          = row.cells[7]?.textContent.trim() || '';
        getEl('sku-modal-price-single').textContent = formatMoney(row.dataset.wholesale || 0);
        getEl('sku-modal-description').textContent  = row.dataset.description || 'No description available.';
        getEl('sku-modal-top').textContent    = parseNotes(notes.top)    || '-';
        getEl('sku-modal-middle').textContent = parseNotes(notes.middle) || '-';
        getEl('sku-modal-base').textContent   = parseNotes(notes.base)   || '-';
        // ── Videos del producto ──
        const productVideos = window.b2bProductVideosMap?.[String(row.dataset.productId)] || [];
        renderSkuVideoCarousel(productVideos);
       // ── Audio description (mini player flotante) ──
          const audioBtnEl   = getEl('sku-modal-audio-btn');
          const audioUrl     = notes.audio || '';

          if (audioUrl) {
            audioBtnEl.style.display = 'inline-flex';
            audioBtnEl.dataset.src   = audioUrl;
          } else {
            audioBtnEl.style.display = 'none';
            audioBtnEl.dataset.src   = '';
          }

          // título/imagen del mini player
          getEl('sku-modal-audio-title').textContent = row?.cells[5]?.textContent?.trim() || productName || '';
          getEl('sku-modal-audio-thumb').src = row?.dataset?.imgUrl || '';

          // cerrar el mini player si estaba abierto de un producto anterior
          closeSkuAudioPlayer();

        const firstMinQtyEl = getEl('firstMinQty');
        const nextOrdersEl  = getEl('NextOrders');
        if (firstMinQtyEl) firstMinQtyEl.textContent = (row.dataset.firstMinQty || '1') + ' Units';
        if (nextOrdersEl)  nextOrdersEl.textContent  = row.dataset.nextMinQty === '—' ? '—' : (row.dataset.nextMinQty || '—') + ' Units';

        const incEl   = getEl('sku-modal-incentives');
        const incBody = getEl('sku-modal-incentive-body');
        const incFP   = getEl('sku-modal-free-products');
        const priority = Number(window.b2bCollectionPriority || 1);

        if (b2bIsCreditPriority(priority)) {
          // ── Prioridad 2: descuento por porcentaje ──
          const discPct2      = parseFloat(window.b2bCollectionDiscount || 0);
          const minAmount2    = parseFloat(window.b2bDiscountMinAmount  || 0);
          const discProducts2 = (Number(window.b2bCollectionPriority || 1) === 4 ? b2bBuildP4Products({ productId: row?.dataset?.productId }) : (window.b2bDiscountProducts || []));

          if (discPct2 > 0 && discProducts2.length > 0) {
            incEl.style.display = 'block';
          //  <br><span style="font-size:12px;color:#000;">
          //                     Discount budget = Order Total × ${discPct2}%
          //                   </span>
            incBody.innerHTML = `
              <div style="background:#fff;border-radius:10px;margin-bottom:12px; font-family: Crimson Pro">
                <div style="font-size:16px;font-weight:700;color:#000;margin-bottom:6px; font-family:Crimson Pro">
                  
                </div>
                <div style="font-size:17px;color:#585858;line-height:1.6;font-family: Crimson Pro;">
                  For purchases of 
                  <strong>$${minAmount2.toLocaleString('en-US', {minimumFractionDigits:2})}</strong>,
                   or more, you will receive a <strong>${discPct2}%</strong>  credit that can be used on selected products.
  
                </div>
              </div>`;

            incFP.innerHTML = discProducts2.map(p => {
              if (!p?.title) return '';
              const imgSrc   = (p.image || '').replace(/^\/\//, 'https://');
              const varTitle = p.variant_title && p.variant_title.toLowerCase() !== 'default title'
                ? p.variant_title : '';
              const vid2      = String(p.variant_id || '');
              const extras2   = window.b2bVariantExtrasMap?.[vid2] || {};
              const tableRow2 = document.querySelector(`.b2b-variant-row[data-variant-id="${vid2}"]`);

              // ── Precio desde incentive_product_price ──
              const metaPrice = parseFloat(p.incentive_product_price || extras2.incentive_product_price || 0);
              const realPrice = metaPrice > 0
                ? metaPrice
                : tableRow2
                  ? parseFloat(tableRow2.dataset.unitPrice || p.price || 0)
                  : parseFloat(p.price || 0);

              return `<div style="display:flex;flex-direction:column;align-items:center;gap:6px;text-align:center;max-width:90px;">
                ${imgSrc
                  ? `<img src="${imgSrc}" style="width:72px;height:72px;object-fit:cover;border-radius:10px;border:1px solid #000;" onerror="this.style.display='none'">`
                  : '<div style="width:72px;height:72px;border-radius:10px;background:#dbeafe;display:flex;align-items:center;justify-content:center;font-size:28px;">🏷️</div>'}
                <span style="font-size:12px;color:#111;font-weight:600;line-height:1.3;">
                  ${p.title}${varTitle ? `<br><span style="font-size:15px;color:#6b7280;">${varTitle}</span>` : ''}
                </span>
                <span style="font-size:17px;color:#000;font-weight:700; font-family: 'Crimson Pro';">$${realPrice.toFixed(2)}</span>
              </div>`;
            }).join('');

          } else {
            incEl.style.display = 'none';
            incBody.innerHTML   = '';
            incFP.innerHTML     = '';
          }

        } else {
          // ── Prioridad 1: lógica original de free gifts por variante ──
          if (extras && (incValue > 0 || threshold > 0 || freeProds.length)) {
            incEl.style.display = 'block';
            const parts = [];
            if (threshold > 0) parts.push(`minimum <strong>${threshold} units</strong>`);
            if (incValue > 0)  parts.push(`order value of <strong>$${Number(incValue).toLocaleString()}</strong>`);
            const getText = freeProds.map((fp, i) => {
              const tq   = (freeQtys[i] || 1) * (multiplier || 1);
              const name = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
                ? `${fp.title} — ${fp.variant_title}` : fp.title;
              return `<strong>${tq}x</strong> ${name}`;
            }).join(' or ');
            incBody.innerHTML = (parts.length
              ? 'When placing an order: ' + parts.join(' and ') + '.'
              : '')
              + (getText ? ' You get: ' + getText : '');

            incFP.innerHTML = freeProds.map((fp, i) => {
              const tq  = (freeQtys[i] || 1) * (multiplier || 1);
              const img = fp.image
                ? `<img src="${fp.image}" style="width:56px;height:56px;object-fit:cover;border-radius:8px;" onerror="this.style.display='none'">`
                : '';
              const name = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
                ? `${fp.title}<br><span style="font-size:15px;color:#6b7280; font-family:Crimson Pro">${fp.variant_title}</span>`
                : fp.title;
              return `<div style="display:flex;flex-direction:column;align-items:center;gap:4px;text-align:center;">
                ${img}
                <span style="font-size:12px;font-weight:700;color:#166534;background:#dcfce7;border-radius:6px;padding:2px 7px;">${tq}x</span>
                <span style="font-size:11px;font-weight:600;color:#000;max-width:70px;line-height:1.3;">${name}</span>
              </div>`;
            }).join('');

          } else {
            incEl.style.display = 'none';
            incBody.innerHTML   = '';
            incFP.innerHTML     = '';
          }
        }


       getEl('sku-modal-close-btn')?.addEventListener('click', () => {
          skuModal.style.display = 'none';
          document.body.style.overflow = '';
          closeSkuAudioPlayer();
        });
        skuModal?.addEventListener('click', e => {
          if (e.target === skuModal) {
            skuModal.style.display = 'none';
            document.body.style.overflow = '';
            closeSkuAudioPlayer();
          }
        });

        const thumbsEl = getEl('sku-modal-thumbs');
        thumbsEl.innerHTML = '';
        if (handle) {
          fetch(`/products/${handle}.js`).then(r => r.json()).then(product => {
            if (!product?.images?.length) return;
            const mainImg = getEl('sku-modal-main-img');
            product.images.forEach((img, i) => {
              const src = (typeof img === 'string' ? img : img.src || '').replace(/^\/\//, 'https://');
              const thumb = document.createElement('img');
              thumb.className = 'sku-modal-thumb' + (i === 0 ? ' active' : '');
              thumb.src = src; thumb.width = 56; thumb.height = 56;
              thumb.addEventListener('click', () => {
                mainImg.src = src;
                document.querySelectorAll('.sku-modal-thumb').forEach(t => t.classList.remove('active'));
                thumb.classList.add('active');
              });
              thumbsEl.appendChild(thumb);
              if (i === 0) mainImg.src = src;
            });
          }).catch(() => {});
        }

        skuModal.style.display = 'flex';
        document.body.style.overflow = 'hidden';
        skuPopup.classList.remove('visible');
      });
    });
  }





  function closeSkuAudioPlayer() {
  const container = getEl('sku-modal-audio-container');
  const audioEl    = getEl('sku-modal-audio');
  if (!container || !audioEl) return;
  container.classList.remove('active');
  container.style.opacity    = '0';
  container.style.visibility = 'hidden';
  container.style.transform  = 'translateX(-50%) translateY(150%)';
  audioEl.pause();
  getEl('sku-modal-audio-play-icon').style.display  = '';
  getEl('sku-modal-audio-pause-icon').style.display = 'none';
}

function initSkuAudioPlayer() {
  const audioEl     = getEl('sku-modal-audio');
  const container   = getEl('sku-modal-audio-container');
  const triggerBtn  = getEl('sku-modal-audio-btn');
  const closeBtn     = getEl('sku-modal-audio-close');
  const playPauseBtn = getEl('sku-modal-audio-playpause');
  const playIcon     = getEl('sku-modal-audio-play-icon');
  const pauseIcon    = getEl('sku-modal-audio-pause-icon');
  const progressWrap = getEl('sku-modal-audio-progress');
  const progressBar  = getEl('sku-modal-audio-progress-bar');
  const currentEl    = getEl('sku-modal-audio-current');
  const durationEl   = getEl('sku-modal-audio-duration');
  const volumeWrap   = getEl('sku-modal-audio-volume');
  const volumeBar    = getEl('sku-modal-audio-volume-bar');
  if (!audioEl || triggerBtn.dataset.listenerAttached) return;

  function formatTime(sec) {
    if (isNaN(sec)) return '0:00';
    const m = Math.floor(sec / 60), s = Math.floor(sec % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function openPlayer() {
    const src = triggerBtn.dataset.src;
    if (!src) return;
    if (audioEl.src !== src) audioEl.src = src;
    container.classList.add('active');
    container.style.opacity    = '1';
    container.style.visibility = 'visible';
    container.style.transform  = 'translateX(-50%) translateY(0)';
    audioEl.play().then(() => {
      playIcon.style.display  = 'none';
      pauseIcon.style.display = '';
    }).catch(() => {});
  }

  triggerBtn.addEventListener('click', () => {
    const isOpen = container.classList.contains('active');
    if (isOpen) closeSkuAudioPlayer(); else openPlayer();
  });

  closeBtn.addEventListener('click', closeSkuAudioPlayer);

  playPauseBtn.addEventListener('click', () => {
    if (audioEl.paused) {
      audioEl.play();
      playIcon.style.display  = 'none';
      pauseIcon.style.display = '';
    } else {
      audioEl.pause();
      playIcon.style.display  = '';
      pauseIcon.style.display = 'none';
    }
  });

  audioEl.addEventListener('loadedmetadata', () => {
    durationEl.textContent = formatTime(audioEl.duration);
  });
  audioEl.addEventListener('timeupdate', () => {
    const pct = (audioEl.currentTime / audioEl.duration) * 100 || 0;
    progressBar.style.width = pct + '%';
    currentEl.textContent   = formatTime(audioEl.currentTime);
  });
  audioEl.addEventListener('ended', () => {
    playIcon.style.display  = '';
    pauseIcon.style.display = 'none';
  });

  progressWrap.addEventListener('click', e => {
    const rect = progressWrap.getBoundingClientRect();
    const pct  = (e.clientX - rect.left) / rect.width;
    audioEl.currentTime = pct * audioEl.duration;
  });

  volumeWrap.addEventListener('click', e => {
    const rect = volumeWrap.getBoundingClientRect();
    const pct  = Math.max(0, Math.min(1, (e.clientX - rect.left) / rect.width));
    audioEl.volume = pct;
    volumeBar.style.width = (pct * 100) + '%';
  });

  triggerBtn.dataset.listenerAttached = 'true';
}







  function showUnlockRequiredModal(unlockQty, unlockPres, productName, currentBase) {
  const modal = getEl('sell-limit-modal'); // reutilizamos el mismo modal visual
  const text  = getEl('sell-limit-modal-text');
  if (!modal || !text) return;
  const needed = Math.max(0, unlockQty - (currentBase % unlockQty === 0 ? unlockQty : currentBase % unlockQty));
  text.innerHTML = `To purchase <strong>${productName}</strong>, you need to buy <strong>${unlockQty}</strong> unit${unlockQty > 1 ? 's' : ''} of <strong>${unlockPres}</strong> first.` +
    `<br><br>You currently have <strong>${currentBase}</strong> unit${currentBase !== 1 ? 's' : ''} of ${unlockPres} in your order.`;
  modal.style.display = 'flex';
}

/* ============================================================
   UPDATE TOTALS
   ============================================================ */

function updateTotals() {
   if (window.b2bIsMasterUser) updateMasterOrderLock();
  let items = 0, total = 0;

  // ── Sin check de display — contar TODAS las filas con qty ──
  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (qty <= 0) return;
    items += qty;
    total += qty * parseFloat(row.dataset.unitPrice || 0);
  });

  getEl('b2b-items').textContent = items;
  getEl('b2b-total').textContent = '$ ' + total.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  const hasItems = items > 0;
  getEl('b2b-buy-btn').disabled          = !hasItems;
  getEl('b2b-view-details-btn').disabled = !hasItems;
  getEl('b2b-buy-now-bottom').disabled   = !hasItems;

  // ── Contar incentivos ──
  let liveIncentives = 0;

  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (qty <= 0) return;
    const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
    if (!variantHasIncentive(extras)) return;
    const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
    if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
    const fps    = getVariantFreeProducts(extras);
    const fqs    = getVariantFreeQtys(extras);
    const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
    if (fps.length > 1) {
      if (choice?.confirmed) liveIncentives += choice.chosenQty || 0;
    } else {
      fps.forEach((fp, i) => { liveIncentives += fqs[i] || 1; });
    }
  });

  // P2
  const p2live = window.b2bPriority2Choice || {};
  if (p2live.confirmed && Array.isArray(p2live.selections)) {
    p2live.selections.forEach(s => { liveIncentives += s.selectedQty || 0; });
  }

  // P3
  const p3live = window.b2bPriority3Choice || {};
  if (p3live.confirmed && Array.isArray(p3live.selections)) {
    p3live.selections.forEach(sel => {
      (sel.choices || []).forEach(c => { liveIncentives += c.chosenQty || 0; });
    });
  }

    // Master FOC manual
  Object.values(window.b2bMasterFreeItems || {}).forEach(q => {
    liveIncentives += parseInt(q) || 0;
  });


  const incEl = getEl('dash-total-incentives');
  if (incEl) incEl.textContent = liveIncentives;

  if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
  updateIncentiveBanners();
}

/* ============================================================
   INCENTIVE BANNERS
   ============================================================ */

function updateIncentiveBanners() {

  if (window.b2bIsMasterUser) {
    getEl('b2b-incentive-banner').style.display = 'none';
    getEl('b2b-incentive-next').style.display   = 'none';
    const varBanner = getEl('b2b-variant-incentive-banner');
    if (varBanner) varBanner.style.display = 'none';
    const rewardBtn = getEl('b2b-choose-reward-btn');
    if (rewardBtn) rewardBtn.style.display = 'none';
    applyFreeProductStockDeductions();
    return;
  }


  const colHandle  = getColHandle();
  const rules      = window.b2bCollectionIncentivesMap?.[colHandle] || [];
  const priority   = Number(window.b2bCollectionPriority || 1);

  // ── Calcular total general de la orden ──
  let grandOrderTotal = 0;
  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    grandOrderTotal += qty * parseFloat(row.dataset.unitPrice || 0);
  });

  // ── Configuración prioridad 2 / 4 ──
  // P4: la lista se arma con los tester/vial de los productos comprados
  if (priority === 4) b2bSyncP4Products();
  const discountPct      = parseFloat(window.b2bCollectionDiscount || 0);
  const discountMinAmt   = parseFloat(window.b2bDiscountMinAmount || 0);
  const discountProducts = window.b2bDiscountProducts || [];
  const isPriority2      = b2bIsCreditPriority(priority);
  const p2HasConfig      = isPriority2 && discountMinAmt > 0 && discountPct > 0 && discountProducts.length > 0;
  const p2Unlocked       = p2HasConfig && grandOrderTotal >= discountMinAmt;

  let totalUnitsForCollection = 0, totalValueForCollection = 0;
  let anyVariantIncentiveActive = false;
  let pendingChoices = 0, confirmedChoices = 0, totalChoices = 0;
  let variantIncentiveHTML = '';

  // ── Solo evaluar incentivos de variante si prioridad = 1 ──
  if (!isPriority2) {
    variantRows().forEach(row => {
      const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0) return;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
      const met    = variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV);

      if (met) {
        anyVariantIncentiveActive = true;
        const freeProducts = getVariantFreeProducts(extras);
        const freeQtys     = getVariantFreeQtys(extras);
        const multiplier   = calcVariantMultiplier(extras, qty, lineV);
        const choice       = window.b2bVariantRewardChoices[row.dataset.variantId];
        const pName        = row.cells[5]?.textContent?.trim() || 'Product';

        if (freeProducts.length > 1) {
          totalChoices++;
          if (!choice?.confirmed) pendingChoices++;
          else confirmedChoices++;
          variantIncentiveHTML += `<div style="margin-top:4px;"></div>`;
        } else {
          const giftParts = freeProducts.map((fp, i) =>
            `<strong>${(freeQtys[i] || 1) * multiplier}x</strong> ${fp.title}`
          );
          if (giftParts.length) {
            variantIncentiveHTML += `<div style="margin-top:4px;"><strong>${pName}:</strong> you receive: ${giftParts.join(' + ')}</div>`;
          }
        }
      } else {
        totalUnitsForCollection += qty;
        totalValueForCollection += lineV;
      }
    });
  }

  const active = (!isPriority2 && rules.length) ? calcActiveIncentive(rules, totalUnitsForCollection, totalValueForCollection) : null;
  const next   = (!isPriority2 && rules.length) ? calcNextIncentive(rules, totalUnitsForCollection, totalValueForCollection)   : null;

  applyFreeProductStockDeductions();

  const rewardBtn = getEl('b2b-choose-reward-btn');
  if (rewardBtn) rewardBtn.style.display = 'none';

  function resetRewardChoice(extra) {
    const rc = window.b2bRewardChoice;
    if (!rc) return;
    rc.active = extra?.active !== undefined ? extra.active : null;
    rc.confirmed = false; rc.chosenType = null; rc.chosenVariantId = null;
    rc.chosenProductHandle = null; rc.chosenProductTitle = null;
    rc.chosenProductImage = null; rc.chosenQty = 1;
    rc.discountPct = extra?.discountPct || 0;
  }

  // ════════════════════════════════════
  //  PRIORIDAD 2 — descuento por monto
  // ════════════════════════════════════

  if (isPriority2) {
    getEl('b2b-incentive-banner').style.display = 'none';
    const varBanner = getEl('b2b-variant-incentive-banner');
    if (varBanner) varBanner.style.display = 'none';

    if (p2HasConfig) {
      const p2choice = window.b2bPriority2Choice || {};

      if (p2Unlocked) {
        // ── DESBLOQUEADO: mostrar botón activo ──
        if (rewardBtn) {
          rewardBtn.style.display    = 'inline-flex';
          rewardBtn.style.opacity    = '1';
          rewardBtn.style.cursor     = 'pointer';
          rewardBtn.disabled         = false;
          const selCount = (p2choice.selections || []).filter(s => (s.selectedQty || 0) > 0).length;
          rewardBtn.textContent = p2choice.confirmed
            ? `Incentive Selected`
            : `Choose your FOC`;
          rewardBtn.onclick = () => openPriority2Modal();
        }
        // Ocultar banner "X para desbloquear"
        const nextEl = getEl('b2b-incentive-next');
        if (nextEl) nextEl.style.display = 'none';

      } else {
        // ── NO DESBLOQUEADO ──
        if (rewardBtn) rewardBtn.style.display = 'none';

        // Mostrar banner solo si hay algo en el carrito
        const nextEl     = getEl('b2b-incentive-next');
        const nextDetail = getEl('b2b-incentive-next-detail');
        if (nextEl && nextDetail) {
          if (grandOrderTotal > 0) {
            const needed = discountMinAmt - grandOrderTotal;
            nextDetail.innerHTML = priority === 4
              ? `Add <strong>$${needed.toFixed(2)}</strong> or more to unlock: <strong>${discountPct}%</strong> reward credit on testers and vials.`
              : `Add <strong>$${needed.toFixed(2)}</strong>or more to unlock: <strong>${discountPct}%</strong> reward credit on selected products.`;
            nextEl.style.display = 'block';
          } else {
            nextEl.style.display = 'none';
          }
        }
      }
    } else {
      // Sin configuración P2 válida
      if (rewardBtn) rewardBtn.style.display = 'none';
    }
    return; // no procesar prioridad 1
  }


  // ════════════════════════════════════
  //  PRIORIDAD 3 — distribución libre
  // ════════════════════════════════════
  const isPriority3 = priority === 3;
  if (isPriority3) {
    getEl('b2b-incentive-banner').style.display = 'none';
    const varBanner = getEl('b2b-variant-incentive-banner');
    if (varBanner) varBanner.style.display = 'none';

    let anyP3Met = false;
    variantRows().forEach(row => {
      const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0) return;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
      if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) anyP3Met = true;
    });

    if (anyP3Met) {
      if (rewardBtn) {
        rewardBtn.style.display = 'inline-flex';
        rewardBtn.disabled      = false;
        rewardBtn.style.opacity = '1';
        rewardBtn.style.cursor  = 'pointer';
        const p3choice = window.b2bPriority3Choice || {};
        rewardBtn.textContent = p3choice.confirmed ? 'Incentive Selected ✓' : 'Choose Your FOC';
        rewardBtn.onclick = () => openPriority3Modal();
      }
      const nextEl = getEl('b2b-incentive-next');
      if (nextEl) nextEl.style.display = 'none';
    } else {
      if (rewardBtn) rewardBtn.style.display = 'none';

      // Banner "X más para desbloquear"
      let totalUnits = 0, totalValue = 0;
      variantRows().forEach(row => {
        const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
        totalUnits += qty;
        totalValue += qty * parseFloat(row.dataset.unitPrice || 0);
      });

      const nextEl     = getEl('b2b-incentive-next');
      const nextDetail = getEl('b2b-incentive-next-detail');
      if (nextEl && nextDetail && totalUnits > 0) {
        // Buscar el primer incentivo no cumplido
        let nextRule = null;
        variantRows().forEach(row => {
          const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
          if (!extras || nextRule) return;
          const { minU, minV } = getVariantThresholds(extras);
          const fps = getVariantFreeProducts(extras);
          if (fps.length > 0 && (minU > 0 || minV > 0)) nextRule = { minU, minV };
        });
        if (nextRule) {
          const needed = Math.max(0, (nextRule.minU || 0) - totalUnits);
          if (needed > 0) {
            // nextDetail.innerHTML = `Add <strong>${needed}</strong> more unit${needed > 1 ? 's' : ''} to unlock your free gift choices.`;
             nextDetail.innerHTML = ``;
            nextEl.style.display = 'block';
          } else {
            nextEl.style.display = 'none';
          }
        }
      } else if (nextEl) {
        nextEl.style.display = 'none';
      }
    }
    return;
  }
  

  // ════════════════════════════════════
  //  PRIORIDAD 1 — lógica original
  // ════════════════════════════════════
  //  ? `Choose your Incentive (${confirmedChoices}/${totalChoices} selected)`
  if (anyVariantIncentiveActive) {
    resetRewardChoice();
    getEl('b2b-incentive-banner').style.display = 'none';
    getEl('b2b-incentive-next').style.display   = 'none';

    if (rewardBtn && totalChoices > 0) {
      rewardBtn.style.display = 'inline-flex';
      rewardBtn.textContent = pendingChoices > 0
        ? `Choose your FOC`
        : `Gifts Selected ✓`;
      rewardBtn.onclick = () => openAllVariantRewardsModal();
    }

  } else if (active) {
    const needsChoice = !isAutoApply(active);
    if (rewardChoice.active !== active) {
      resetRewardChoice({ active, discountPct: Number(active.discount || 0) });
      if (window.b2bRewardChoice) window.b2bRewardChoice.active = active;
    }
    if (rewardBtn && needsChoice) {
      rewardBtn.style.display = 'inline-flex';
      rewardBtn.textContent = rewardChoice.confirmed ? 'Reward Selected ✓' : 'Choose Your Reward';
      rewardBtn.onclick = () => openRewardChoiceModal();
    }
    renderCollectionBanner(active, totalUnitsForCollection, totalValueForCollection, next);

  } else {
    resetRewardChoice();
    getEl('b2b-incentive-banner').style.display = 'none';
    renderNextBanner(next, totalUnitsForCollection, totalValueForCollection);
  }
// (${confirmedChoices}/${totalChoices} selected)
  const variantBannerEl = getEl('b2b-variant-incentive-banner');
  if (variantBannerEl) {
    if (variantIncentiveHTML) {
      const btnLabel = pendingChoices > 0
        ? `Choose your FOC`
        : `Gifts Selected ✓`;
      variantBannerEl.innerHTML = `
        ${variantIncentiveHTML}
        ${totalChoices > 0 ? `
          <div style="margin-top:10px;">
            <button type="button" onclick="openAllVariantRewardsModal()"
              style="width:100%;padding:12px 14px;background:#276e31;color:#fff;border:none;border-radius:8px;font-size:17px;font-weight:700;cursor:pointer;font-family:'Crimson Pro';">
              ${btnLabel}
            </button>
          </div>` : ''}`;
      variantBannerEl.style.display = 'block';
      if (rewardBtn) rewardBtn.style.display = 'none';
    } else {
      variantBannerEl.style.display = 'none';
    }
  }
}

function renderCollectionBanner(active, totalUnits, totalValue, next) {
  const bannerEl = getEl('b2b-incentive-banner');
  const detailEl = getEl('b2b-incentive-detail');
  const html = formatIncentiveRule(active, 'You earned: ');

  if (html) {
    detailEl.innerHTML = html + (rewardChoice.confirmed
      ? ' <span style="color:#000;font-weight:700;">✓ Reward confirmed — <span style="text-decoration:underline;cursor:pointer;" onclick="openRewardChoiceModal()">Change</span></span>'
      : ' <span style="color:#000;font-weight:700;"> ← Click to select your reward</span>');
    bannerEl.style.display = 'block';
  } else {
    bannerEl.style.display = 'none';
  }

  renderNextBanner(next, totalUnits, totalValue);
}

function renderNextBanner(next, totalUnits, totalValue) {
  const nextEl     = getEl('b2b-incentive-next');
  const nextDetail = getEl('b2b-incentive-next-detail');
  if (!next || totalUnits === 0) { nextEl.style.display = 'none'; return; }

  const qtyNeeded   = Math.max(0, (next.min_qty || 0) - totalUnits);
  const valueNeeded = Math.max(0, (next.min_order_value || 0) - totalValue);
  let msg = '';
  if (qtyNeeded > 0 && valueNeeded > 0)
    msg = `Add <strong>${qtyNeeded}</strong> unit${qtyNeeded > 1 ? 's' : ''} and <strong>$${valueNeeded.toFixed(2)}</strong> more to unlock: `;
  else if (qtyNeeded > 0)
    msg = `Add <strong>${qtyNeeded}</strong> unit${qtyNeeded > 1 ? 's' : ''} more to unlock: `;
  else if (valueNeeded > 0)
    msg = `Add <strong>$${valueNeeded.toFixed(2)}</strong> more to unlock: `;

  nextDetail.innerHTML = msg + formatIncentiveRule(next);
  nextEl.style.display = 'block';
}

/* ============================================================
   MODAL — VARIANT REWARD
   ============================================================ */

let _variantRewardCurrentId = null;

async function openAllVariantRewardsModal() {
  const modal      = getEl('variant-reward-modal');
  const list       = getEl('variant-reward-products-list');
  const titleEl    = getEl('variant-reward-modal-title');
  const subtitleEl = getEl('variant-reward-modal-subtitle');

  titleEl.textContent  = 'Choose Your FOC';
  subtitleEl.innerHTML = 'Select your preferred free product for each eligible item.';

  const activeChoices  = [];
  const seenVariantIds = new Set();

  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (qty <= 0) return;
    const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
    if (!variantHasIncentive(extras)) return;
    const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
    if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
    const fps = getVariantFreeProducts(extras);
    if (fps.length <= 1) return;
    if (seenVariantIds.has(row.dataset.variantId)) return;
    seenVariantIds.add(row.dataset.variantId);
    activeChoices.push({
      variantId: row.dataset.variantId,
      pName: row.cells[5]?.textContent?.trim() || 'Product',
      qty, extras, lineV, freeProducts: fps, freeQtys: getVariantFreeQtys(extras)
    });
  });

  if (!activeChoices.length) return;

  list.innerHTML = '';

  activeChoices.forEach(({ variantId, pName, qty, extras, lineV, freeProducts, freeQtys }) => {
    const multiplier = calcVariantMultiplier(extras, qty, lineV);
    const current    = window.b2bVariantRewardChoices[variantId] || {};

    // ── Header del grupo ──
    const header = document.createElement('div');
    header.style.cssText = 'margin:16px 0 8px;padding-bottom:6px;border-bottom:2px solid #e5e7eb;';
    header.innerHTML = `
      <strong style="font-size:18px;color:#686a6c;">${pName}</strong>
      <span style="font-size:18px;color:#6b7280;margin-left:8px;">(${qty} units ordered)</span>`;
    list.appendChild(header);

    // ── Tabla de opciones ──
    const tableWrap = document.createElement('div');
    tableWrap.style.cssText = 'overflow-x:auto;-webkit-overflow-scrolling:touch;margin-bottom:16px;';
    tableWrap.innerHTML = `
      <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;table-layout:fixed;">
        <colgroup>
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
        </colgroup>
        <thead>
          <tr style="background:#686a6c;color:#fff;">
          <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Photo</th>
          <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Name</th>
          <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">ML</th>
          <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Presentation</th>
          <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Quantity</th>
          <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Select</th>
            
          </tr>
        </thead>
        <tbody id="p1-tbody-${variantId}"></tbody>
      </table>`;
    list.appendChild(tableWrap);

    const tbody = tableWrap.querySelector(`#p1-tbody-${variantId}`);

    // freeProducts.forEach((fp, i) => {
    //   if (!fp?.title) return;
    //   const totalQty    = (freeQtys[i] || 1) * multiplier;
    //   const imgSrc      = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
    //   const isSelected  = current.chosenIndex === i;
    //   const resolvedVid = fp.variant_id && fp.variant_id !== '0' ? String(fp.variant_id) : '';
    freeProducts.forEach((fp, i) => {
      if (!fp?.title) return;
      const totalQty    = (freeQtys[i] || 1) * multiplier;
      const imgSrc      = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
      const isSelected  = current.chosenIndex === i;
      const resolvedVid = fp.variant_id && fp.variant_id !== '0' ? String(fp.variant_id) : '';

      // ── Validar stock disponible para regalar (mismo producto vendido y regalado) ──
      const remainingStockForGift = getRemainingStockForGift(resolvedVid);
      const isOutOfStock = resolvedVid && remainingStockForGift < totalQty;
      if (isOutOfStock) return; // no mostrar opciones que no se pueden cumplir con el stock actual

      const vid2    = String(fp.variant_id || '');
      const varData = window.b2bAllVariantsMap?.[vid2] || {};
      const ml      = varData.ml   || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
      const pres    = varData.pres || '—';
      const bgColor = isSelected ? '' : (i % 2 === 0 ? '#fff' : '#f9fafb');
      const tdC     = 'padding:9px 7px;vertical-align:middle;font-size:18px;color:#374151;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

      const tr = document.createElement('tr');
      tr.style.cssText = `background:${bgColor};border-bottom:1px solid #e5e7eb;cursor:pointer;transition:background 0.15s;`;
      tr.dataset.variantId    = variantId;
      tr.dataset.chosenIdx    = i;
      tr.dataset.chosenVid    = resolvedVid;
      tr.dataset.chosenTitle  = fp.title;
      tr.dataset.chosenImage  = imgSrc;
      tr.dataset.chosenQty    = totalQty;
      tr.dataset.chosenHandle = fp.handle || '';
      tr.dataset.idx          = i;

      tr.innerHTML = `
     
        <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
          ${imgSrc
            ? `<img src="${imgSrc}" style="width:48px;height:48px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;">`
            : `<div style="width:48px;height:48px;border-radius:8px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:18px;">🎁</div>`}
        </td>
        <td style="padding:9px 7px;vertical-align:middle;">
          <div style="font-weight:700;color:#111;font-size:18px;white-space:normal;word-break:break-word;text-align: center;">${fp.title}</div>
        </td>
        <td style="${tdC}">${ml}</td>
        <td style="${tdC}">${pres}</td>
         <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
          <span class="p1-qty-badge" style="background:${isSelected ? '#dcfce7' : '#f3f4f6'};color:${isSelected ? '#166534' : '#6b7280'};font-size:18px;font-weight:700;padding:3px 10px;border-radius:12px;white-space:nowrap;">${totalQty}</span>
        </td>
           <td style="padding:9px 7px;text-align:center;vertical-align:middle;width:40px;">
          <div class="allreward-radio" style="width:18px;height:18px;border-radius:50%;border:2px solid ${isSelected ? '#b8a77d' : '#9ca3af'};background:${isSelected ? '#b8a77d' : '#fff'};display:flex;align-items:center;justify-content:center;margin:0 auto;">
            ${isSelected ? '<svg width="9" height="9" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>' : ''}
          </div>
        </td>
        `;

      tr.addEventListener('click', () => {
        // ── Deseleccionar todas las filas del grupo ──
        tbody.querySelectorAll('tr').forEach(r => {
          r.style.background = parseInt(r.dataset.idx) % 2 === 0 ? '#fff' : '#f9fafb';
          const radio = r.querySelector('.allreward-radio');
          if (radio) { radio.style.border = '2px solid #9ca3af'; radio.style.background = '#fff'; radio.innerHTML = ''; }
          const badge = r.querySelector('.p1-qty-badge');
          if (badge) { badge.style.background = '#f3f4f6'; badge.style.color = '#6b7280'; }
        });

        // ── Seleccionar esta fila ──
        tr.style.background = '';
        const radio = tr.querySelector('.allreward-radio');
        if (radio) {
          radio.style.border = '2px solid #b8a77d';
          radio.style.background = '#b8a77d';
          radio.innerHTML = '<svg width="9" height="9" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>';
        }
        const badge = tr.querySelector('.p1-qty-badge');
        if (badge) { badge.style.background = '#dcfce7'; badge.style.color = '#166534'; }

        if (!window.b2bVariantRewardChoices[variantId]) window.b2bVariantRewardChoices[variantId] = {};
        window.b2bVariantRewardChoices[variantId]._pending = {
          chosenIndex:     parseInt(tr.dataset.chosenIdx),
          chosenTitle:     tr.dataset.chosenTitle,
          chosenImage:     tr.dataset.chosenImage,
          chosenHandle:    tr.dataset.chosenHandle,
          chosenQty:       parseInt(tr.dataset.chosenQty),
          chosenVariantId: tr.dataset.chosenVid
        };
      });

      tbody.appendChild(tr);
    });
  });

  const confirmBtn = getEl('variant-reward-confirm');
  confirmBtn.onclick = () => {
    const missing = activeChoices.filter(({ variantId }) =>
      !window.b2bVariantRewardChoices[variantId]?._pending &&
      !window.b2bVariantRewardChoices[variantId]?.confirmed
    );
     if (missing.length > 0) {
        const overlay = getEl('b2b-processing-overlay') || (() => {
          const el = document.createElement('div');
          el.id = 'b2b-processing-overlay';
          el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
          document.body.appendChild(el);
          return el;
        })();

        const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
        const names   = missing.map(m => `<li style="margin:4px 0;">${m.pName}</li>`).join('');

        overlay.innerHTML = `
          <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
                      box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
                      max-width:440px;width:90%;">
            <img src="${logoUrl}" alt="Logo"
              style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
              onerror="this.style.display='none'">
            <div style="width:56px;height:56px;border-radius:50%;background:#fff;
                        display:flex;align-items:center;justify-content:center;
                        margin:0 auto 16px;font-size:28px;">⚠️</div>
            <div style="font-size:17px;font-weight:700;color:#000 ;margin-bottom:8px;">
              Free product not selected
            </div>
            <p style="font-size:15px;color:#555;margin:0 0 14px;line-height:1.6;">
              Please select a free product for:
            </p>
            <ul style="text-align:left;list-style:none;padding:0 0 0 8px;margin:0 0 20px;font-size:15px;color:#1f2937;">
              ${names}
            </ul>
            <button type="button" onclick="unlockUI()"
              style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
                    border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
                    font-family:'Crimson Pro',serif;width:100%;">
              OK, I'll fix it
            </button>
          </div>`;

        overlay.style.display = 'flex';
        return;
      }
    activeChoices.forEach(({ variantId }) => {
      const p = window.b2bVariantRewardChoices[variantId]?._pending;
      if (p) window.b2bVariantRewardChoices[variantId] = { confirmed: true, ...p };
    });
    closeVariantRewardModal();
    updateIncentiveBanners();
    if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
  };

  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function openPriority2Modal() {
  const modal    = getEl('variant-reward-modal');
  const list     = getEl('variant-reward-products-list');
  const titleEl  = getEl('variant-reward-modal-title');
  const subEl    = getEl('variant-reward-modal-subtitle');

  const pct      = parseFloat(window.b2bCollectionDiscount || 0);
  const isP4     = Number(window.b2bCollectionPriority || 1) === 4;
  const products = isP4 ? b2bSyncP4Products() : (window.b2bDiscountProducts || []);

  function getProductPrice(p) {
    const liquidPrice = parseFloat(p.incentive_product_price || 0);
    if (liquidPrice > 0) return liquidPrice;
    const vid2      = String(p.variant_id || '');
    const extras2   = window.b2bVariantExtrasMap?.[vid2] || {};
    const metaPrice = parseFloat(extras2.incentive_product_price || 0);
    if (metaPrice > 0) return metaPrice;
    return parseFloat(p.price || 0);
  }

  let orderTotal = 0;
  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    orderTotal += qty * parseFloat(row.dataset.unitPrice || 0);
  });

  const budget = orderTotal * (pct / 100);

  titleEl.textContent = isP4 ? 'Choose Testers & Vials to Redeem Your Credit' : 'Choose Products to Redeem Your Credit';
  subEl.innerHTML     = isP4
    ? `Use your <strong>$${budget.toFixed(2)}</strong> credit on testers and vials.`
    : `Use your <strong>$${budget.toFixed(2)}</strong> credit on selected products.`;

  // Solo usar prevSelections si está confirmado Y no fue reseteado
  // (se buscan por variant_id porque en P4 la lista cambia según lo comprado)
    const prevSelections = (window.b2bPriority2Choice?.confirmed && window.b2bPriority2Choice?.selections?.length)
      ? window.b2bPriority2Choice.selections
      : [];
    const selectedQtys = {};
    products.forEach((p, i) => {
      const prev = prevSelections.find(s => String(s.variant_id) === String(p.variant_id));
      const maxQ = p.max_qty != null ? p.max_qty : Infinity;
      selectedQtys[i] = Math.min(prev?.selectedQty || 0, maxQ);
    });

  function calcSummary() {
    let selectedSpent = 0;
    products.forEach((p, i) => {
      selectedSpent += (selectedQtys[i] || 0) * getProductPrice(p);
    });
    const available   = Math.max(0, budget - selectedSpent);
    const progressPct = budget > 0 ? Math.min(100, (selectedSpent / budget) * 100) : 0;
    return { selectedSpent, available, progressPct };
  }

  function renderSummary() {
    const { selectedSpent, available, progressPct } = calcSummary();
    const selEl   = getEl('p2-selected');
    const avaEl   = getEl('p2-available');
    const barEl   = getEl('p2-progress');
    const countEl = getEl('p2-count');

    if (selEl) selEl.textContent = `$${selectedSpent.toFixed(2)}`;
    if (avaEl) {
      avaEl.textContent = `$${available.toFixed(2)}`;
      avaEl.style.color = available < 0.01 ? '#dc2626' : '#16a34a';
    }
    if (barEl) barEl.style.width = `${progressPct}%`;
    if (countEl) {
      const totalUnitsSelected = products.reduce((sum, _, i) => sum + (selectedQtys[i] || 0), 0);
      countEl.textContent = totalUnitsSelected;
    }
  }

 // ── Filtros del modal (Collection, Product, Presentation, ML, Price) ──
  const p2Filters = { collection: new Set(), product: new Set(), pres: new Set(), ml: new Set(), price: new Set() };
  function p2RowMeta(p) {
    const vid     = String(p.variant_id || '');
    const varData = window.b2bAllVariantsMap?.[vid] || {};
    const notes   = window.b2bNotesMap?.[p.handle] || {};
    return {
      collection: varData.collection || notes.collection || '—',
      product:    p.title || '—',
      pres:       varData.pres || '—',
      ml:         varData.ml || (p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '') || '—',
      price:      getProductPrice(p).toFixed(2)
    };
  }
  function p2PassesFilters(p) {
    const m = p2RowMeta(p);
    return Object.keys(p2Filters).every(k => p2Filters[k].size === 0 || p2Filters[k].has(String(m[k])));
  }
  // Valores únicos de una columna (ordenados)
  function p2ColumnValues(k) {
    const vals = [...new Set(products.filter(p => p?.title).map(p => String(p2RowMeta(p)[k])))];
    vals.sort((x, y) => k === 'price' ? parseFloat(x) - parseFloat(y) : x.localeCompare(y, undefined, { numeric: true }));
    return vals;
  }
  // Texto del botón: "All", el valor elegido o "N selected"
  function p2UpdateFilterButtons() {
    Object.keys(p2Filters).forEach(k => {
      const btn = getEl(`p2-filter-${k}`);
      if (!btn) return;
      const set = p2Filters[k];
      let txt = 'All';
      if (set.size === 1) { const v = [...set][0]; txt = k === 'price' ? '$' + v : v; }
      else if (set.size > 1) txt = `${set.size} selected`;
      btn.querySelector('.p2-ms-text').textContent = txt;
      btn.style.borderColor = set.size ? '#b8a77d' : '#d1d5db';
      btn.style.background  = set.size ? '#f9f5ef' : '#fff';
    });
  }
  // Panel desplegable con checkboxes (position:fixed para que no lo corte el scroll de la tabla)
  function p2OpenFilterPanel(btn) {
    const k = btn.dataset.key;
    let panel = getEl('p2-ms-panel');
    if (panel && panel.dataset.key === k && panel.style.display === 'block') { panel.style.display = 'none'; return; }
    if (!panel) {
      panel = document.createElement('div');
      panel.id = 'p2-ms-panel';
      panel.style.cssText = 'position:fixed;z-index:1000000;background:#fff;border:1px solid #d1d5db;border-radius:8px;'
        + 'box-shadow:0 8px 24px rgba(0,0,0,.18);max-height:280px;overflow:auto;min-width:180px;padding:6px 0;'
        + 'font-family:Arial,sans-serif;font-size:13px;color:#374151;display:none;';
      document.body.appendChild(panel);
      // El panel se reutiliza: delega al manejador del modal abierto actualmente
      panel.addEventListener('change', e => { if (window.__p2MsOnChange) window.__p2MsOnChange(e); });
      document.addEventListener('mousedown', e => {
        const pnl = getEl('p2-ms-panel');
        if (!pnl || pnl.style.display !== 'block') return;
        if (pnl.contains(e.target) || e.target.closest('.p2-ms-btn')) return;
        pnl.style.display = 'none';
      });
    }
    window.__p2MsOnChange = e => {
        const panel = getEl('p2-ms-panel');
        const cb = e.target.closest('input[type=checkbox]');
        if (!cb) return;
        const key = panel.dataset.key;
        if (cb.dataset.all) {
          p2Filters[key].clear();
        } else if (cb.checked) {
          p2Filters[key].add(cb.value);
        } else {
          p2Filters[key].delete(cb.value);
        }
        panel.querySelector('input[data-all]').checked = p2Filters[key].size === 0;
        panel.querySelectorAll('input[data-val]').forEach(i => { i.checked = p2Filters[key].has(i.value); });
        p2UpdateFilterButtons();
        renderP2TableRows();
    };
    const vals = p2ColumnValues(k);
    const set  = p2Filters[k];
    const row  = (attrs, label, checked) =>
      `<label style="display:flex;align-items:center;gap:8px;padding:6px 12px;cursor:pointer;white-space:nowrap;"
         onmouseenter="this.style.background='#f9f5ef'" onmouseleave="this.style.background=''">
         <input type="checkbox" ${attrs} ${checked ? 'checked' : ''} style="accent-color:#b8a77d;cursor:pointer;">${label}</label>`;
    panel.innerHTML = row('data-all="1"', '<strong>All</strong>', set.size === 0)
      + `<div style="height:1px;background:#e5e7eb;margin:4px 0;"></div>`
      + vals.map(v => row(`data-val="1" value="${v.replace(/"/g, '&quot;')}"`, k === 'price' ? '$' + v : v, set.has(v))).join('');
    panel.dataset.key = k;
    const r = btn.getBoundingClientRect();
    panel.style.display = 'block';
    panel.style.minWidth = Math.max(180, r.width) + 'px';
    const left = Math.min(r.left, window.innerWidth - panel.offsetWidth - 8);
    panel.style.left = Math.max(8, left) + 'px';
    const below = window.innerHeight - r.bottom;
    panel.style.top = (below > 200 ? r.bottom + 4 : Math.max(8, r.top - panel.offsetHeight - 4)) + 'px';
  }

 function renderP2TableRows() {
    const tbody = getEl('p2-table-body');
    if (!tbody) return;
    const { available } = calcSummary();
    const p2Html = products.map((p, idx) => {
      if (!p?.title) return '';
      if (!p2PassesFilters(p)) return '';
      const imgSrc     = (p.image || '').replace(/^\/\//, 'https://');
      const price      = getProductPrice(p);
      const currentQty = selectedQtys[idx] || 0;
      const vid        = String(p.variant_id || '');
      const varData    = window.b2bAllVariantsMap?.[vid] || {};
      const extras2    = window.b2bVariantExtrasMap?.[vid] || {};
      const notes      = window.b2bNotesMap?.[p.handle] || {};
      const ml         = varData.ml || (p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '') || '—';
      const pres       = varData.pres       || '—';
      const collection = varData.collection || notes.collection || '—';
      const minQty     = extras2.quantity > 0 ? extras2.quantity : '—';
      
      const bgColor    = idx % 2 === 0 ? '#fff' : '#f9fafb';
      // P4: tope por regla de desbloqueo (aunque quede crédito disponible)
      const maxQ       = (p.max_qty != null) ? p.max_qty : Infinity;
      const capReached = currentQty >= maxQ;
      const noFunds    = price > available + 0.001 && !capReached && maxQ > 0;
      const plusDisabled = price > available + 0.001 || capReached;
      const fundsNote  = noFunds
        ? `<div style="font-size:12px;color:#dc2626;font-weight:700;margin-top:3px;white-space:normal;">Insufficient funds</div>`
        : '';
      const unlockNote = (isP4 && p.unlock_pres && p.unlock_qty > 0)
        ? `<div style="font-size:12px;color:${maxQ > 0 ? '#166534' : '#b45309'};margin-top:3px;white-space:normal;">`
          + (maxQ > 0
            //   ? `Max ${maxQ} (${p.unlock_step} per ${p.unlock_qty} ${p.unlock_pres})`
            //   : `Buy ${p.unlock_qty} ${p.unlock_pres} to unlock`)
            ? `` : ``)
          + `</div>`
        : '';
      const tdC = 'padding:9px 7px;vertical-align:middle;font-size:13px;color:#374151;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

      return `<tr style="background:${bgColor};border-bottom:1px solid #e5e7eb;">
        <!-- View -->
        <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
          <button type="button" class="b2b-p2-view-btn"
            data-handle="${p.handle || ''}"
            data-variant-id="${p.variant_id || ''}"
            style="background:transparent;border:none;cursor:pointer;">
            <svg viewBox="0 0 32 32" stroke-linecap="round" style="width:26px;height:26px;stroke:#356ce1;fill:none;">
              <path d="M4,16 C9,28 23,28 28,16" stroke-width="3"/>
              <path d="M4,16 C9,4 23,4 28,16" stroke-width="3"/>
              <circle cx="16" cy="16" r="4.5" stroke-width="5"/>
            </svg>
          </button>
        </td>
        <!-- Photo -->
        <td style="padding:9px 7px;text-align:center;vertical-align:middle;width:68px;">
          ${imgSrc
            ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;" onerror="this.style.display='none'">`
            : `<div style="width:52px;height:52px;border-radius:8px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:18px;margin:0 auto;">🏷️</div>`}
        </td>
        <!-- Collection -->
        <td style="${tdC};max-width:130px;" title="${collection}">${collection}</td>
        <!-- Product -->
        <td style="padding:9px 7px;vertical-align:middle;min-width:120px;text-align: center;">
          <div style="font-weight:700;color:#111;font-size:14px;white-space:normal;word-break:break-word;">${p.title}</div>
        </td>
        <!-- Presentation -->
        <td style="${tdC}">${pres}</td>
        <!-- Quantity (Min Qty) -->
        <td style="${tdC};font-weight:700;color:#000;">${minQty}</td>
        <!-- ML -->
        <td style="${tdC};max-width:65px;">${ml}</td>
        <!-- Price -->
        <td style="padding:9px 7px;text-align:center;vertical-align:middle;font-size:14px;font-weight:700;color:#111;white-space:nowrap;">$${price.toFixed(2)}</td>
        <!-- Qty stepper -->
        <td style="padding:9px 7px;text-align:center;vertical-align:middle;white-space:nowrap;">
          <div style="display:inline-flex;align-items:center;gap:4px;">
            <button type="button" id="p2-minus-${idx}" data-idx="${idx}"
              style="width:28px;height:28px;border:1px solid #e5e7eb;border-radius:6px;background:#f9fafb;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;flex-shrink:0;">−</button>
            <span id="p2-qty-${idx}" style="min-width:22px;text-align:center;font-weight:700;font-size:14px;">${currentQty}</span>
            <button type="button" id="p2-plus-${idx}" data-idx="${idx}"
              style="width:28px;height:28px;border:1px solid ${plusDisabled ? '#e5e7eb' : '#b8a77d'};border-radius:6px;background:${plusDisabled ? '#f3f4f6' : '#b8a77d'};color:${plusDisabled ? '#9ca3af' : '#fff'};font-size:16px;cursor:${plusDisabled ? 'not-allowed' : 'pointer'};display:flex;align-items:center;justify-content:center;flex-shrink:0;opacity:${plusDisabled ? '0.4' : '1'};">+</button>
          </div>
          ${fundsNote || unlockNote}
        </td>
      </tr>`;
    }).join('');
    tbody.innerHTML = p2Html.trim()
      ? p2Html
      : `<tr><td colspan="9" style="padding:24px;text-align:center;color:#6b7280;font-size:15px;">No products match the filters.</td></tr>`;
  }

  list.innerHTML = `
   <div style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:14px 16px;margin-bottom:16px;">
      <div style="display:flex;gap:24px;flex-wrap:nowrap;justify-content:space-around;align-items:center;">
  
  <!-- Grupo cálculo pegado -->
  <div style="display:flex;align-items:center;gap:14px;">
    <div style="text-align:center;">
      <span style="color:#6b7280;font-size:16px;display:block;">Order Total</span>
      <strong style="font-size:16px;color:#111;">$${orderTotal.toFixed(2)}</strong>
    </div>
    <span style="color:#6b7280;font-size:16px;padding-top:27px;">×</span>
    <div style="text-align:center;">
      <span style="color:#6b7280;font-size:16px;display:block;">%</span>
      <strong style="font-size:16px;color:#b8a77d;">${pct}%</strong>
    </div>
    <span style="color:#6b7280;font-size:16px;padding-top:27px;">=</span>
    <div style="text-align:center;">
      <span style="color:#6b7280;font-size:16px;display:block;">Credit Total</span>
      <strong style="font-size:16px;color:#16a34a;">$${budget.toFixed(2)}</strong>
    </div>
  </div>

  <div style="width:2px;height:50px;background:#d1d5db;flex-shrink:0;"></div>

  <div style="text-align:center;">
    <span style="color:#6b7280;font-size:16px;display:block;">Selected</span>
    <strong id="p2-selected" style="font-size:16px;color:#b8a77d;">$0.00</strong>
  </div>
  <div style="text-align:center;">
    <span style="color:#6b7280;font-size:16px;display:block;">Available</span>
    <strong id="p2-available" style="font-size:16px;color:#16a34a;">$${budget.toFixed(2)}</strong>
  </div>
  <div style="text-align:center;">
    <span style="color:#6b7280;font-size:16px;display:block;">Incentive</span>
    <strong id="p2-count" style="font-size:16px;color:#000;">0</strong>
  </div>
</div>
  <div style="margin-top:10px;background:#e5e7eb;border-radius:99px;height:6px;">
    <div id="p2-progress" style="height:6px;border-radius:99px;background:#b8a77d;width:0%;transition:width 0.3s;"></div>
  </div>
</div>
    <div id="p2-table-scroll" style="overflow:auto;-webkit-overflow-scrolling:touch;max-height:calc(100vh - 380px);min-height:220px;border:1px solid #e5e7eb;border-radius:8px;">
      <table style="width:100%;min-width:500px;border-collapse:separate;border-spacing:0;font-family:'Crimson Pro',serif;table-layout:fixed;">
        <colgroup>
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
          <col style="width:30%;">
        </colgroup>
        <thead style="position:sticky;top:0;z-index:3;">
          <tr style="background:#686a6c;color:#fff;">
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">View</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Photo</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Collection</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Product</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Presentation</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Units/Pack</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">ML</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Price</th>
            <th style="background:#686a6c;padding:9px 7px;text-align:center;font-size:18px;font-weight:600;">Qty</th>
          </tr>
          <tr id="p2-filter-row">
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"><button type="button" id="p2-filter-collection" class="p2-ms-btn" data-key="collection" style="width:100%;max-width:150px;padding:6px 8px;border:1px solid #d1d5db;border-radius:6px;background:#fff;font-size:13px;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:4px;margin:0 auto;"><span class="p2-ms-text" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">All</span><span style="font-size:10px;">▼</span></button></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"><button type="button" id="p2-filter-product" class="p2-ms-btn" data-key="product" style="width:100%;max-width:150px;padding:6px 8px;border:1px solid #d1d5db;border-radius:6px;background:#fff;font-size:13px;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:4px;margin:0 auto;"><span class="p2-ms-text" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">All</span><span style="font-size:10px;">▼</span></button></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"><button type="button" id="p2-filter-pres" class="p2-ms-btn" data-key="pres" style="width:100%;max-width:150px;padding:6px 8px;border:1px solid #d1d5db;border-radius:6px;background:#fff;font-size:13px;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:4px;margin:0 auto;"><span class="p2-ms-text" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">All</span><span style="font-size:10px;">▼</span></button></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"><button type="button" id="p2-filter-ml" class="p2-ms-btn" data-key="ml" style="width:100%;max-width:150px;padding:6px 8px;border:1px solid #d1d5db;border-radius:6px;background:#fff;font-size:13px;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:4px;margin:0 auto;"><span class="p2-ms-text" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">All</span><span style="font-size:10px;">▼</span></button></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"><button type="button" id="p2-filter-price" class="p2-ms-btn" data-key="price" style="width:100%;max-width:150px;padding:6px 8px;border:1px solid #d1d5db;border-radius:6px;background:#fff;font-size:13px;color:#374151;cursor:pointer;display:flex;align-items:center;justify-content:space-between;gap:4px;margin:0 auto;"><span class="p2-ms-text" style="overflow:hidden;text-overflow:ellipsis;white-space:nowrap;">All</span><span style="font-size:10px;">▼</span></button></th>
            <th style="padding:8px 5px;text-align:center;background:#f3f4f6;"></th>
          </tr>
        </thead>
        <tbody id="p2-table-body"></tbody>
      </table>
    </div>`;

  p2UpdateFilterButtons();
  renderP2TableRows();

  const p2FilterRow = getEl('p2-filter-row');
  if (p2FilterRow) {
    p2FilterRow.addEventListener('click', e => {
      const btn = e.target.closest('.p2-ms-btn');
      if (btn) p2OpenFilterPanel(btn);
    });
  }
  // Cerrar el panel si se hace scroll dentro de la tabla
  const p2Scroll = getEl('p2-table-scroll');
  if (p2Scroll) p2Scroll.addEventListener('scroll', () => {
    const pnl = getEl('p2-ms-panel');
    if (pnl) pnl.style.display = 'none';
  });
  { const pnl = getEl('p2-ms-panel'); if (pnl) pnl.style.display = 'none'; }

  const tbody = getEl('p2-table-body');
  tbody.addEventListener('click', e => {
    const btn = e.target.closest('button[data-idx]');
    if (!btn) return;
    const idx     = parseInt(btn.dataset.idx);
    const isMinus = btn.id.startsWith('p2-minus');
    const price   = getProductPrice(products[idx]);

    if (isMinus) {
      selectedQtys[idx] = Math.max(0, (selectedQtys[idx] || 0) - 1);
    } else {
      const { available } = calcSummary();
      if (price > available + 0.001) {
        b2bShowFundsMsg(available, price);
        return;
      }
      const maxQ = products[idx]?.max_qty != null ? products[idx].max_qty : Infinity;
      if ((selectedQtys[idx] || 0) >= maxQ) return; // P4: regla de desbloqueo
      selectedQtys[idx] = (selectedQtys[idx] || 0) + 1;
    }

    const qtyEl = getEl(`p2-qty-${idx}`);
    if (qtyEl) qtyEl.textContent = selectedQtys[idx];
    renderSummary();
    renderP2TableRows();
  });

  list.addEventListener('click', e => {
      const viewBtn = e.target.closest('.b2b-p2-view-btn');
      if (!viewBtn) return;
      const vid    = viewBtn.dataset.variantId;
      const handle = viewBtn.dataset.handle;
      if (!handle) return;

      const skuModal = getEl('sku-detail-modal');
      const extras   = window.b2bVariantExtrasMap?.[vid] || {};
      const notes    = window.b2bNotesMap?.[handle] || {};

      // ── Buscar imagen del producto de incentivo ──
      const p = products.find(p => String(p.variant_id) === String(vid));
      const imgSrc = (p?.image || '').replace(/^\/\//, 'https://');

      // ── ML y precio desde metafields de la variante ──
      const ml    = extras.size || '—';
      const pres  = extras.presentation || '—';
      const metaPrice = parseFloat(p?.incentive_product_price || extras.incentive_product_price || 0);
      const price = metaPrice > 0 ? metaPrice : parseFloat(p?.price || 0);

      getEl('sku-modal-main-img').src             = imgSrc;
      getEl('sku-modal-title').textContent        = p?.title || handle;
      
      const varData = window.b2bAllVariantsMap?.[String(vid)] || {};
      const sku     = varData.sku || extras.sku || '—';
      getEl('sku-modal-sku').textContent = sku.toUpperCase();
      getEl('sku-modal-collection').textContent   = notes.collection || '—';
      getEl('sku-modal-ml').textContent           = ml;
      getEl('sku-modal-price-single').textContent = formatMoney(price);
      getEl('sku-modal-description').textContent  = '';
      getEl('sku-modal-top').textContent          = parseNotes(notes.top)    || '-';
      getEl('sku-modal-middle').textContent       = parseNotes(notes.middle) || '-';
      getEl('sku-modal-base').textContent         = parseNotes(notes.base)   || '-';
      getEl('sku-modal-incentives').style.display = 'none';

      // ── Galería ──
      const thumbsEl = getEl('sku-modal-thumbs');
      thumbsEl.innerHTML = '';
      fetch(`/products/${handle}.js`).then(r => r.json()).then(product => {
        if (!product?.variants?.length) return;
        // Buscar la variante por id
        const variant = product.variants.find(v => String(v.id) === String(vid)) || product.variants[0];
        if (variant?.sku) {
          const skuEl = getEl('sku-modal-sku');
          if (skuEl) skuEl.textContent = variant.sku.toUpperCase();
        }
        // ── Galería ──
        if (!product?.images?.length) return;
        const mainImg = getEl('sku-modal-main-img');
        product.images.forEach((img, i) => {
          const src   = (typeof img === 'string' ? img : img.src || '').replace(/^\/\//, 'https://');
          const thumb = document.createElement('img');
          thumb.className = 'sku-modal-thumb' + (i === 0 ? ' active' : '');
          thumb.src = src; thumb.width = 56; thumb.height = 56;
          thumb.addEventListener('click', () => {
            mainImg.src = src;
            document.querySelectorAll('.sku-modal-thumb').forEach(t => t.classList.remove('active'));
            thumb.classList.add('active');
          });
          thumbsEl.appendChild(thumb);
          if (i === 0) mainImg.src = src;
        });
      }).catch(() => {});

      getEl('variant-reward-modal').style.zIndex = '99990';
      skuModal.style.zIndex = '999999';
      skuModal.style.display = 'flex';
      document.body.style.overflow = 'hidden';
   });

  const confirmBtn = getEl('variant-reward-confirm');
  confirmBtn.textContent = '✓ Confirm My Choice';
  confirmBtn.onclick = () => {
    const hasSelection = products.some((_, i) => (selectedQtys[i] || 0) > 0);
    if (!hasSelection) {
      alert('Please select at least one product.');
      return;
    }

    const selections = products.map((p, i) => {
      const qty = parseInt(selectedQtys[i] || 0);
      return { ...p, selectedQty: qty };
    });

    const { selectedSpent } = calcSummary();
    window.b2bPriority2Choice = {
      confirmed:   true,
      selections,
      totalSpent:  selectedSpent,
      discountPct: pct
    };

    closeVariantRewardModal();
    updateIncentiveBanners();
    if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
  };

  renderSummary();
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

window.openPriority2Modal = openPriority2Modal;



function openPriority3Modal() {
  const modal   = getEl('variant-reward-modal');
  const list    = getEl('variant-reward-products-list');
  const titleEl = getEl('variant-reward-modal-title');
  const subEl   = getEl('variant-reward-modal-subtitle');

  titleEl.textContent = 'Choose Your Incentive';
  list.innerHTML = '';

  const groups  = [];
  const seenIds = new Set();

  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (qty <= 0) return;
    const vid = row.dataset.variantId;
    if (seenIds.has(vid)) return;
    const extras = window.b2bVariantExtrasMap?.[vid];
    if (!variantHasIncentive(extras)) return;
    const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
    if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
    seenIds.add(vid);
    const fps        = getVariantFreeProducts(extras);
    const fqs        = getVariantFreeQtys(extras);
    const multiplier = calcVariantMultiplier(extras, qty, lineV);
    const totalFree  = (fqs[0] || 1) * multiplier;
    // groups.push({ vid, pName: row.cells[5]?.textContent?.trim() || 'Product',
    //   qty, extras, fps, fqs, multiplier, totalFree });
    const maxAchievable = computeMaxAchievableFoc(fps, totalFree);
    groups.push({ vid, pName: row.cells[5]?.textContent?.trim() || 'Product',
      qty, extras, fps, fqs, multiplier, totalFree, maxAchievable });
  });

  if (!groups.length) return;

  const prevSelections = (window.b2bPriority3Choice?.confirmed && window.b2bPriority3Choice?.selections?.length)
    ? window.b2bPriority3Choice.selections
    : [];
  const selectedQtys = groups.map((g, gi) => {
    const prev = prevSelections[gi];
    return g.fps.map((_, fi) => prev?.qtys?.[fi] || 0);
  });

  // function getTotalFreeAll() { return groups.reduce((s, g) => s + g.totalFree, 0); }
  function getTotalFreeAll() { return groups.reduce((s, g) => s + g.maxAchievable, 0); }
  function getTotalUsedAll() { return groups.reduce((s, _, gi) => s + calcGroupTotal(gi), 0); }
  function calcGroupTotal(gi) { return selectedQtys[gi].reduce((s, q) => s + q, 0); }

  function updateGlobalCounter() {
    const total     = getTotalFreeAll();
    const used      = getTotalUsedAll();
    const remaining = total - used;
    const allDone   = remaining === 0;
    const pct       = total > 0 ? Math.min(100, (used / total) * 100) : 0;

    const counterEl = getEl('p3-global-counter');
    if (!counterEl) return;

    const listId  = 'p3-instructions-list';
    const btnId   = 'p3-instructions-toggle';
    const PAGE_SIZE = 4;

    const allGuideCards = [];
    groups.forEach(g => {
      const mainImgSrc = (() => {
        const row = document.querySelector(`.b2b-variant-row[data-variant-id="${g.vid}"]`);
        return row ? (row.dataset.imgUrl || '') : '';
      })();
      const minU = g.extras?.incentive_product || g.extras?.next_incentive_product || '?';
      g.fps.forEach((fp, fi) => {
        const fpImg = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
        const vid2  = String(fp.variant_id || '');
        const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
        const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
        const ml2   = vd2.ml || '—';
        const pres2 = vd2.pres || '—';
        const pack2 = ex2.quantity > 0 ? ex2.quantity : '—';
        const qty2  = g.fqs[fi] || 1;
        allGuideCards.push(`
          <div style="display:flex;align-items:center;gap:0;border-radius:14px;overflow:hidden;border:1px solid #e5e7eb;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,0.06);flex:1;min-width:220px;max-width:300px;">
            <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:14px 10px;text-align:center;flex:1;background:#f9fafb;">
              ${mainImgSrc
                ? `<img src="${mainImgSrc}" style="width:70px;height:90px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;">`
                : `<div style="width:50px;height:50px;border-radius:8px;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-size:22px;">🛍️</div>`}
              <div style="font-size:14px;font-weight:700;color:#111;">Buy ${minU} units</div>
              <div style="font-size:13px;font-weight:600;color:#374151;">${g.pName}</div>
            </div>
            <div style="display:flex;align-items:center;justify-content:center;width:28px;flex-shrink:0;font-size:18px;font-weight:700;color:#000;background:#fff;">=</div>
            <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:14px 10px;text-align:center;flex:1;border-left:1px solid #e5e7eb;">
              ${fpImg
                ? `<img src="${fpImg}" style="width:70px;height:90px;object-fit:cover;border-radius:8px;">`
                : `<div style="width:50px;height:50px;border-radius:8px;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:22px;">🎁</div>`}
              <div style="font-size:14px;font-weight:700;color:#000;line-height:1.3;">${pack2}x ${fp.title}</div>
              <div style="font-size:13px;color:#6b7280;">${pres2} | ${ml2} | Pack: ${qty2}</div>
            </div>
          </div>`);
      });
    });

    const arrowColors = ['#22c55e','#ec4899','#f59e0b','#3b82f6'];
    const allTableRows = [];
    groups.forEach(g => {
      const mainImgSrc = (() => {
        const row = document.querySelector(`.b2b-variant-row[data-variant-id="${g.vid}"]`);
        return row ? (row.dataset.imgUrl || '') : '';
      })();
      const minU = g.extras?.incentive_product || g.extras?.next_incentive_product || '?';
      g.fps.forEach((fp, fi) => {
        const fpImg  = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
        const vid2   = String(fp.variant_id || '');
        const vd2    = window.b2bAllVariantsMap?.[vid2] || {};
        const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
        const ml2    = vd2.ml || '—';
        const pres2  = vd2.pres || '—';
        const pack2  = ex2.quantity > 0 ? ex2.quantity : '—';
        const qty2   = g.fqs[fi] || 1;
        const color  = arrowColors[fi % arrowColors.length];
        const bgC    = fi % 2 === 0 ? '#fff' : '#f9fafb';
        allTableRows.push(`
          <tr style="background:${bgC};border-bottom:1px solid #e5e7eb;">
            <td style="padding:12px 14px;vertical-align:middle;">
              <div style="display:flex;align-items:center;gap:10px;">
                ${mainImgSrc
                  ? `<img src="${mainImgSrc}" style="width:70px;height:90px;object-fit:cover;border-radius:6px;flex-shrink:0;">`
                  : `<div style="width:38px;height:38px;border-radius:6px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:16px;flex-shrink:0;">🛍️</div>`}
                <div>
                  <div style="font-size:16px;color:#111;">${minU} units of</div>
                  <div style="font-size:16px;font-weight:700;color:#111;">${g.pName}</div>
                </div>
              </div>
            </td>
            <td style="padding:12px 14px;text-align:center;vertical-align:middle;">
              <div style="display:flex;align-items:center;justify-content:center;gap:10px;">
                
                <div style="display:flex;flex-direction:column;align-items:center;gap:3px;">
                  ${fpImg
                    ? `<img src="${fpImg}" style="width:70px;height:90px;object-fit:cover;border-radius:6px;">`
                    : `<div style="width:50px;height:50px;background:#f0fdf4;display:flex;align-items:center;justify-content:center;font-size:18px;border:2px solid #bbf7d0;">🎁</div>`}
                  <div style="font-size:16px;font-weight:700;color:#111;">${pack2}x ${fp.title}</div>
                  <div style="font-size:16px;color:#111;">${pres2} | ${ml2} | Pack: ${qty2}</div>
                </div>
              </div>
            </td>
            <td style="padding:12px 14px;text-align:center;vertical-align:middle;">
              <div style="display:flex;align-items:center;justify-content:center;gap:8px;">
               
                <div style="font-size:16px;color:#374151;text-align:left;">
                  <div style="font-weight:700;">${pack2} ${pres2} ${ml2} ${fp.title} = ${minU} units ${g.pName} </div>
                  
                </div>
              </div>
            </td>
          </tr>`);
      });
    });

    function buildPaginationHTML(total, prevId, nextId, infoId) {
      if (total <= PAGE_SIZE) return '';
      return `
        <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding-top:10px;border-top:1px solid #e5e7eb;">
          <button type="button" id="${prevId}" style="padding:5px 16px;border:1px solid #e5e7eb;border-radius:6px;font-size:13px;cursor:pointer;font-family:'Crimson Pro',serif;font-weight:600;">← Prev</button>
          <span id="${infoId}" style="font-size:13px;color:#6b7280;"></span>
          <button type="button" id="${nextId}" style="padding:5px 16px;border:1px solid #e5e7eb;border-radius:6px;font-size:13px;cursor:pointer;font-family:'Crimson Pro',serif;font-weight:600;">Next →</button>
        </div>`;
    }
    const totalSelectedUnits = groups.reduce((s, g) => s + g.qty, 0);
    counterEl.innerHTML = `
      <div style="display:flex;align-items:center;justify-content:space-between;gap:12px;margin-bottom:12px;flex-wrap:wrap;">
        <div style="display:flex;flex-direction:column;gap:8px;">
          <span style="font-size:15px;color:#6b7280;">
            Distribute your free units below. Each group must use exactly its total.
          </span>
          <div style="position:relative;display:inline-block;">
            <button type="button" id="${btnId}" onclick="
              var el = document.getElementById('${listId}');
              var open = el.style.display !== 'none';
              el.style.display = open ? 'none' : 'block';
              this.querySelector('.p3-arrow').textContent = open ? '▼' : '▲';
            " style="display:inline-flex;align-items:center;gap:6px;background:none;border:1px solid #e5e7eb;border-radius:6px;cursor:pointer;font-size:14px;color:#374151;font-family:'Crimson Pro',serif;padding:5px 10px;">
              <span style="font-weight:600;font-size:15px;">📋 Conversion Equivalencies Table</span>
              <span class="p3-arrow" style="font-size:12px;color:#9ca3af;">▼</span>
            </button>
            <div id="${listId}" style="display:none;position:absolute;top:calc(100% + 6px);left:0;z-index:9999;min-width:1049px;max-width:860px;background:#fff;border:1px solid #e5e7eb;border-radius:12px;box-shadow:0 8px 24px rgba(0,0,0,0.12);">
              <div style="padding:16px 18px;">
                <div style="margin-bottom:24px;">
                  <div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
                    <span style="font-size:16px;">⭐</span>
                    <span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Examples</span>
                  </div>
                  <div id="p3-guide-cards" style="display:flex;flex-wrap:wrap;gap:12px;min-height:60px;"></div>
                  ${buildPaginationHTML(allGuideCards.length, 'p3-guide-prev', 'p3-guide-next', 'p3-guide-info')}
                </div>
                <div>
                  <div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
                    <span style="font-size:16px;">⇄</span>
                    <span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Conversion Equivalencies</span>
                  </div>
                  <div style="overflow-x:auto;">
                    <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
                      <thead>
                        <tr style="background:#686a6c;color:#fff;">
                          <th style="padding:10px 14px;text-align:left;font-size:13px;font-weight:600;border-radius:8px 0 0 0;">If You Purchase</th>
                          <th style="padding:10px 14px;text-align:center;font-size:13px;font-weight:600;">You Can Receive (FOC)</th>
                          <th style="padding:10px 14px;text-align:center;font-size:13px;font-weight:600;border-radius:0 8px 0 0;">Equivalency (Either Way)</th>
                        </tr>
                      </thead>
                      <tbody id="p3-table-rows" style="min-height:60px;"></tbody>
                    </table>
                  </div>
                  ${buildPaginationHTML(allTableRows.length, 'p3-table-prev', 'p3-table-next', 'p3-table-info')}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div style="display:flex;align-items:center;gap:10px;flex-shrink:0;">
          <div style="display:flex;gap:16px;background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:8px 16px;">
          <div style="text-align:center;">
              <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">Selected unit</div>
              <div style="font-size:20px;font-weight:700;color:#111;">${totalSelectedUnits}</div>
            </div>
            <div style="text-align:center;">
              <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">FOC</div>
              <div style="font-size:20px;font-weight:700;color:#111;">${total}</div>
            </div>
            <div style="width:1px;background:#e5e7eb;"></div>
            <div style="text-align:center;">
              <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">Selected</div>
              <div style="font-size:20px;font-weight:700;color:#b8a77d;">${used}</div>
            </div>
            <div style="width:1px;background:#e5e7eb;"></div>
            <div style="text-align:center;">
              <div style="font-size:11px;color:#6b7280;font-weight:600;text-transform:uppercase;letter-spacing:.5px;">Remaining</div>
              <div style="font-size:20px;font-weight:700;color:${allDone ? '#16a34a' : '#b45309'};">${remaining}</div>
            </div>
          </div>
          ${allDone
            ? `<span style="background:#dcfce7;color:#166534;font-size:13px;font-weight:700;padding:6px 14px;border-radius:10px;">✓ All assigned!</span>`
            : `<span></span>`}
        </div>
      </div>
      <div style="border-radius:99px;height:7px;">
        <div style="height:7px;border-radius:99px;background:${allDone ? '#16a34a' : '#b8a77d'};width:${pct}%;transition:width 0.3s;"></div>
      </div>`;

    let guideP = 0;
    function renderGuideCards() {
      const container = document.getElementById('p3-guide-cards');
      const infoEl    = document.getElementById('p3-guide-info');
      if (!container) return;
      const start = guideP * PAGE_SIZE;
      const end   = Math.min(start + PAGE_SIZE, allGuideCards.length);
      container.innerHTML = allGuideCards.slice(start, end).join('');
      if (infoEl) infoEl.textContent = allGuideCards.length > PAGE_SIZE ? `${start + 1}–${end} of ${allGuideCards.length}` : '';
      const prevBtn = document.getElementById('p3-guide-prev');
      const nextBtn = document.getElementById('p3-guide-next');
      if (prevBtn) {
        prevBtn.style.background = guideP === 0 ? '#f3f4f6' : '#b8a77d';
        prevBtn.style.color      = guideP === 0 ? '#9ca3af' : '#fff';
        prevBtn.style.border     = `1px solid ${guideP === 0 ? '#e5e7eb' : '#b8a77d'}`;
        prevBtn.style.cursor     = guideP === 0 ? 'not-allowed' : 'pointer';
        prevBtn.onclick = () => { if (guideP > 0) { guideP--; renderGuideCards(); } };
      }
      if (nextBtn) {
        const isLast = end >= allGuideCards.length;
        nextBtn.style.background = isLast ? '#f3f4f6' : '#b8a77d';
        nextBtn.style.color      = isLast ? '#9ca3af' : '#fff';
        nextBtn.style.border     = `1px solid ${isLast ? '#e5e7eb' : '#b8a77d'}`;
        nextBtn.style.cursor     = isLast ? 'not-allowed' : 'pointer';
        nextBtn.onclick = () => { if (!isLast) { guideP++; renderGuideCards(); } };
      }
    }

    let tableP = 0;
    function renderTableRows() {
      const tbody  = document.getElementById('p3-table-rows');
      const infoEl = document.getElementById('p3-table-info');
      if (!tbody) return;
      const start = tableP * PAGE_SIZE;
      const end   = Math.min(start + PAGE_SIZE, allTableRows.length);
      tbody.innerHTML = allTableRows.slice(start, end).join('');
      if (infoEl) infoEl.textContent = allTableRows.length > PAGE_SIZE ? `${start + 1}–${end} of ${allTableRows.length}` : '';
      const prevBtn = document.getElementById('p3-table-prev');
      const nextBtn = document.getElementById('p3-table-next');
      if (prevBtn) {
        prevBtn.style.background = tableP === 0 ? '#f3f4f6' : '#b8a77d';
        prevBtn.style.color      = tableP === 0 ? '#9ca3af' : '#fff';
        prevBtn.style.border     = `1px solid ${tableP === 0 ? '#e5e7eb' : '#b8a77d'}`;
        prevBtn.style.cursor     = tableP === 0 ? 'not-allowed' : 'pointer';
        prevBtn.onclick = () => { if (tableP > 0) { tableP--; renderTableRows(); } };
      }
      if (nextBtn) {
        const isLast = end >= allTableRows.length;
        nextBtn.style.background = isLast ? '#f3f4f6' : '#b8a77d';
        nextBtn.style.color      = isLast ? '#9ca3af' : '#fff';
        nextBtn.style.border     = `1px solid ${isLast ? '#e5e7eb' : '#b8a77d'}`;
        nextBtn.style.cursor     = isLast ? 'not-allowed' : 'pointer';
        nextBtn.onclick = () => { if (!isLast) { tableP++; renderTableRows(); } };
      }
    }

    setTimeout(() => {
      renderGuideCards();
      renderTableRows();
    }, 50);
  }

  subEl.innerHTML = `<div id="p3-global-counter"></div>`;

  function renderGroups() {
    list.innerHTML = '';

    // groups.forEach((g, gi) => {
    //   const used       = calcGroupTotal(gi);
    //   const remaining  = g.totalFree - used;
    //   const isComplete = remaining === 0;
    groups.forEach((g, gi) => {
      const used       = calcGroupTotal(gi);
      const target     = g.maxAchievable; // límite real (puede ser menor a totalFree si falta stock)
      const remaining  = target - used;
      const isComplete = remaining === 0;

      const groupCard = document.createElement('div');
      groupCard.style.cssText = `border:2px solid #e5e7eb;border-radius:12px;padding:16px;margin-bottom:20px;background:#fff;box-shadow:0 2px 8px rgba(0,0,0,0.06);transition:border-color 0.2s,background 0.2s;`;


      groupCard.innerHTML = `
        <div style="display:flex;align-items:center;justify-content:space-between;margin-bottom:12px;padding-bottom:10px;border-bottom:1px solid #e5e7eb;">
          <div>
            <span style="font-size:19px;font-weight:700;color:#686a6c;">${g.pName}</span>
            <div style="font-size:18px;color:#6b7280;margin-top:4px;line-height:1.5;">
              You ordered <strong style="color:#111;">${g.qty} units ${g.pName} </strong>
              you can choose up to <strong style="color:#111;">${g.totalFree} FOC</strong>
              ${g.totalFree > 1 ? `<span style="color:#9ca3af;font-size:16px;">(select ${g.totalFree} product${g.totalFree > 1 ? 's' : ''} below)</span>` : ''}
            </div>
          </div>
          <div style="display:flex;align-items:center;gap:8px;">
            <span style="font-size:18px;color:#6b7280;">
              FOC assign: <strong style="color:${isComplete ? '#16a34a' : '#b45309'};">${remaining}</strong> / ${target}
            </span>
            ${isComplete ? `<span style="background:#dcfce7;color:#166534;font-size:11px;font-weight:700;padding:3px 10px;border-radius:12px;">✓ Complete</span>` : ''}
          </div>
        </div>
        <div style="background:#e5e7eb;border-radius:99px;height:5px;margin-bottom:14px;">
          <div style="height:5px;border-radius:99px;background:${isComplete ? '#16a34a' : '#b8a77d'};width:${Math.min(100,(used/g.totalFree)*100)}%;transition:width 0.3s;"></div>
        </div>`;

      const tableWrap = document.createElement('div');
      tableWrap.style.cssText = 'overflow-x:auto;-webkit-overflow-scrolling:touch;';
      tableWrap.innerHTML = `
        <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;table-layout:fixed;">
          <colgroup>
            <col style="width:10%;"><col style="width:17%;"><col style="width:22%;">
            <col style="width:14%;"><col style="width:12%;"><col style="width:11%;"><col style="width:14%;">
          </colgroup>
          <thead>
            <tr style="background:#686a6c;color:#fff;">
              <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Photo</th>
              <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Collection</th>
              <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Product</th>
              <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Presentation</th>
              <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Units/Pack</th>
              <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">ML</th>
              <th style="padding:8px 7px;text-align:center;font-size:18px;font-weight:600;">Qty</th>
            </tr>
          </thead>
          <tbody id="p3-tbody-${gi}"></tbody>
        </table>`;

      groupCard.appendChild(tableWrap);
      list.appendChild(groupCard);

      const tbody = tableWrap.querySelector(`#p3-tbody-${gi}`);

      // g.fps.forEach((fp, fi) => {
      //   if (!fp?.title) return;
      //   const imgSrc       = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
      //   const curQty       = selectedQtys[gi][fi] || 0;
      //   const canAdd       = remaining > 0;
      //   const canSub       = curQty > 0;
      g.fps.forEach((fp, fi) => {
        if (!fp?.title) return;
        const imgSrc       = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
        const curQty       = selectedQtys[gi][fi] || 0;
        const vidFp        = String(fp.variant_id || '');

        // ── Límite adicional: no exceder stock real disponible para esta variante ──
        const remainingStockForGift = getRemainingStockForGift(vidFp);
        const stockCapReached = vidFp && curQty >= remainingStockForGift;

        const canAdd       = remaining > 0 && !stockCapReached;
        const canSub       = curQty > 0;
        const vid2         = String(fp.variant_id || '');
        const varData      = window.b2bAllVariantsMap?.[vid2] || {};
        const extras2      = window.b2bVariantExtrasMap?.[vid2] || {};
        const ml           = varData.ml || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
        const pres         = varData.pres || '—';
        const collection   = varData.collection || '—';
        const unitsPerPack = extras2.quantity > 0 ? extras2.quantity : '—';
        const bgColor      = fi % 2 === 0 ? '#fff' : '#f9fafb';
        const tdC          = 'padding:9px 7px;vertical-align:middle;font-size:17px;color:#374151;text-align:center;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

        const tr = document.createElement('tr');
        tr.style.cssText = `background:${curQty > 0 ? '' : bgColor};border-bottom:1px solid #e5e7eb;transition:background 0.2s;`;
        tr.innerHTML = `
          <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
            ${imgSrc
              ? `<img src="${imgSrc}" style="width:48px;height:48px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;">`
              : `<div style="width:48px;height:48px;border-radius:8px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:18px;">🎁</div>`}
          </td>
          <td style="${tdC}">${collection}</td>
          <td style="padding:9px 7px;text-align:center;vertical-align:middle;">
            <div style="font-weight:700;color:#111;font-size:17px;white-space:normal;word-break:break-word;">${fp.title}</div>
          </td>
          <td style="${tdC}">${pres}</td>
          <td style="${tdC};font-weight:700;color:#000;">${unitsPerPack}</td>
          <td style="${tdC}">${ml}</td>
          <td style="padding:9px 7px;text-align:center;vertical-align:middle;white-space:nowrap;">
            <div style="display:inline-flex;align-items:center;gap:5px;">
              <button type="button" data-gi="${gi}" data-fi="${fi}" data-action="minus"
                style="width:28px;height:28px;border:1px solid #e5e7eb;border-radius:6px;background:${canSub ? '#f9fafb' : '#f3f4f6'};font-size:16px;cursor:${canSub ? 'pointer' : 'not-allowed'};display:flex;align-items:center;justify-content:center;opacity:${canSub ? '1' : '0.4'};">−</button>
              <span style="min-width:22px;text-align:center;font-weight:700;font-size:19px;color:#374151;">${curQty}</span>
              <button type="button" data-gi="${gi}" data-fi="${fi}" data-action="plus"
                style="width:28px;height:28px;border:1px solid ${canAdd ? '#b8a77d' : '#e5e7eb'};border-radius:6px;background:${canAdd ? '#b8a77d' : '#f3f4f6'};color:${canAdd ? '#fff' : '#9ca3af'};font-size:16px;cursor:${canAdd ? 'pointer' : 'not-allowed'};display:flex;align-items:center;justify-content:center;opacity:${canAdd ? '1' : '0.4'};">+</button>
            </div>
          </td>`;
        tbody.appendChild(tr);
      });
    });

    updateGlobalCounter();
  }

  renderGroups();

  list.addEventListener('click', e => {
    const btn = e.target.closest('button[data-action]');
    if (!btn) return;
    const gi        = parseInt(btn.dataset.gi);
    const fi        = parseInt(btn.dataset.fi);
    const action    = btn.dataset.action;
    const remaining = groups[gi].totalFree - calcGroupTotal(gi);

    // if (action === 'plus') {
    //   if (remaining <= 0) return;
    //   selectedQtys[gi][fi] = (selectedQtys[gi][fi] || 0) + 1;
    if (action === 'plus') {
      if (remaining <= 0) return;
      const fpCheck = groups[gi].fps[fi];
      const vidCheck = String(fpCheck?.variant_id || '');
      const remStock = getRemainingStockForGift(vidCheck);
      if (vidCheck && (selectedQtys[gi][fi] || 0) >= remStock) return; // no superar stock disponible
      selectedQtys[gi][fi] = (selectedQtys[gi][fi] || 0) + 1;
    } else {
      if ((selectedQtys[gi][fi] || 0) <= 0) return;
      selectedQtys[gi][fi]--;
    }
    renderGroups();
  });

  const confirmBtn = getEl('variant-reward-confirm');
  confirmBtn.textContent = '✓ Confirm My Choice';
  // confirmBtn.onclick = () => {
  //   const incomplete = groups.filter((g, gi) => calcGroupTotal(gi) !== g.totalFree);
  confirmBtn.onclick = () => {
    const incomplete = groups.filter((g, gi) => calcGroupTotal(gi) !== g.maxAchievable);
   if (incomplete.length > 0) {
      const overlay = getEl('b2b-processing-overlay') || (() => {
        const el = document.createElement('div');
        el.id = 'b2b-processing-overlay';
        el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
        document.body.appendChild(el);
        return el;
      })();

      const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
      const names   = incomplete.map(g => `<li style="margin:4px 0;">${g.pName}</li>`).join('');

      overlay.innerHTML = `
        <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
                    box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
                    max-width:440px;width:90%;">
          <img src="${logoUrl}" alt="Logo"
            style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
            onerror="this.style.display='none'">
          <div style="width:56px;height:56px;border-radius:50%;background:#fff;
                      display:flex;align-items:center;justify-content:center;
                      margin:0 auto 16px;font-size:28px;">⚠️</div>
          <div style="font-size:17px;font-weight:700;color:#555;margin-bottom:8px;">
            Pending free units
          </div>
          <p style="font-size:15px;color:#555;margin:0 0 14px;line-height:1.6;">
            Please assign all free units for:
          </p>
          <ul style="text-align:center;list-style:none;padding:0 0 0 8px;margin:0 0 20px;font-size:15px;color:#1f2937;">
            ${names}
          </ul>
          <button type="button" onclick="unlockUI()"
            style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
                  border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
                  font-family:'Crimson Pro',serif;width:100%;">
            OK, I'll fix it
          </button>
        </div>`;

      overlay.style.display = 'flex';
      return;
    }
    const selections = groups.map((g, gi) => ({
      variantId: g.vid,
      pName:     g.pName,
      totalFree: g.totalFree,
      qtys:      [...selectedQtys[gi]],
      choices:   g.fps.map((fp, fi) => ({
        ...fp,
        chosenQty:       selectedQtys[gi][fi],
        chosenVariantId: fp.variant_id && fp.variant_id !== '0' ? String(fp.variant_id) : null
      })).filter(c => c.chosenQty > 0)
    }));
    window.b2bPriority3Choice = { confirmed: true, selections };
    closeVariantRewardModal();
    updateIncentiveBanners();
    if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
  };

  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

 window.openPriority3Modal = openPriority3Modal;




function closeVariantRewardModal() {
  getEl('variant-reward-modal').style.display = 'none';
  document.body.style.overflow = '';
  _variantRewardCurrentId = null;
}

/* ============================================================
   MODAL — COLLECTION REWARD CHOICE
   ============================================================ */

async function openRewardChoiceModal() {
  const rule = rewardChoice.active;
  if (!rule) return;

  const modal     = getEl('reward-choice-modal');
  const prodsEl   = getEl('reward-products-section');
  const prodsList = getEl('reward-products-list');
  prodsEl.style.display = 'none';

  const disc    = Number(rule.discount || 0);
  const options = [];

  if (Array.isArray(rule.free_testers) && rule.free_testers.length) {
    rule.free_testers.forEach((tp, i) => {
      if (!tp?.title) return;
      options.push({ type: 'tester', label: `${getTesterQty(rule, i)}x tester: ${tp.title}`,
        handle: tp.handle || null, variant_id: tp.variant_id || null,
        variant_title: tp.variant_title || '', id: tp.id || null,
        image: tp.image || null, title: tp.title, qty: getTesterQty(rule, i) });
    });
  } else {
    const total = normalizeQtyArray(rule.testers_qty).reduce((s, q) => s + q, 0);
    if (total > 0) options.push({ type: 'tester', label: `${total} tester${total > 1 ? 's' : ''}`, handle: null, image: null, qty: total });
  }

  (rule.free_products || []).forEach((fp, i) => {
    const qty = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
    if (fp?.title) options.push({
      type: 'product', label: `${qty}x free: ${fp.title}`, handle: fp.handle,
      image: fp.image, title: fp.title, variant_id: fp.variant_id || null,
      variant_title: fp.variant_title || '', qty
    });
  });

  if (disc > 0) options.push({ type: 'discount', label: `🏷️ ${disc}% discount on your order`, handle: null, image: null, qty: 0 });
  if (!options.length) return;

  const variantMap = {};
  await Promise.all(options.filter(o => (o.type === 'product' || o.type === 'tester') && o.handle).map(async o => {
    try {
      const res = await fetch(`/products/${o.handle}.js`);
      if (!res.ok) return;
      const all = (await res.json()).variants || [];
      if (o.type === 'tester') { variantMap[o.handle] = all; return; }
      const FREE_KW = ['free', 'gift', 'sample'];
      const free = all.filter(v =>
        parseFloat(v.price) === 0 ||
        FREE_KW.some(k => (v.sku || '').toLowerCase().includes(k) || ['option1','option2','option3'].some(f => (v[f]||'').toLowerCase().includes(k)))
      );
      variantMap[o.handle] = free.length ? free : all;
    } catch {}
  }));

  prodsEl.style.display = 'block';
  prodsList.innerHTML   = '<p style="color:#6b7280;font-size:13px;margin:0 0 14px;">Select ONE reward:</p>';

  options.forEach(opt => {
    const isSelected = rewardChoice.chosenType === opt.type && (
      opt.type === 'discount'
        ? true
        : rewardChoice.chosenProductHandle === opt.handle &&
          rewardChoice.chosenVariantId === (opt._autoVariantId || (opt.variant_id && opt.variant_id !== '0' ? String(opt.variant_id) : null))
    );
    const imgSrc     = opt.image ? opt.image.replace(/^\/\//, 'https://') : '';
    let variantHTML  = '';

    if ((opt.type === 'product' || opt.type === 'tester') && opt.variant_id && opt.variant_id !== '0') {
      opt._autoVariantId = String(opt.variant_id);
      const vLabel = opt.variant_title && opt.variant_title.toLowerCase() !== 'default title' ? opt.variant_title : '';
      if (vLabel) variantHTML = `<div style="margin-top:5px;font-size:12px;color:#6b7280;">Variant: <strong>${vLabel}</strong></div>`;
    } else if (variantMap[opt.handle]?.length) {
      const vms = variantMap[opt.handle];
      if (vms.length === 1) {
        opt._autoVariantId = String(vms[0].id);
        const lbl = vms[0].option1 + (vms[0].option2 && vms[0].option2.toLowerCase() !== 'default title' ? ' / ' + vms[0].option2 : '');
        if (lbl && lbl.toLowerCase() !== 'default title') variantHTML = `<div style="margin-top:5px;font-size:12px;color:#6b7280;">Variant: <strong>${lbl}</strong></div>`;
      } else if (opt.type === 'product') {
        const curVid = rewardChoice.chosenProductHandle === opt.handle ? rewardChoice.chosenVariantId : '';
        const opts = vms.map(v => {
          const lbl = v.option1 + (v.option2 && v.option2.toLowerCase() !== 'default title' ? ' / ' + v.option2 : '');
          return `<option value="${v.id}" ${String(v.id) === String(curVid) ? 'selected' : ''}>${lbl}</option>`;
        }).join('');
        variantHTML = `<div class="reward-variant-wrap" style="margin-top:10px;display:${isSelected?'block':'none'};">
          <label style="font-size:12px;color:#555;display:block;margin-bottom:4px;">Select variant:</label>
          <select class="reward-variant-sel" data-handle="${opt.handle}" style="width:100%;padding:8px 10px;border:1px solid #d1d5db;border-radius:6px;font-size:13px;background:#fff;">
            <option value="">— Select variant —</option>${opts}
          </select></div>`;
      } else {
        const autoV = vms.find(v => v.available) || vms[0];
        opt._autoVariantId = String(autoV.id);
      }
    }

    const card = document.createElement('div');
    card.className = 'b2b-reward-card';
    card.style.cssText = `display:flex;align-items:flex-start;gap:12px;padding:14px;border:2px solid ${isSelected?'#16a34a':'#e5e7eb'};border-radius:10px;margin-bottom:10px;cursor:pointer;background:${isSelected?'#f0fdf4':'#fff'};transition:all .15s;`;
    card.innerHTML = `
      <div class="b2b-reward-radio" style="width:22px;height:22px;border-radius:50%;border:2px solid ${isSelected?'#16a34a':'#9ca3af'};background:${isSelected?'#16a34a':'#fff'};display:flex;align-items:center;justify-content:center;flex-shrink:0;margin-top:2px;">
        ${isSelected ? '<svg width="12" height="12" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>' : ''}
      </div>
      ${imgSrc ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:8px;flex-shrink:0;">` : ''}
      <div style="flex:1;"><div style="font-weight:700;color:#111;font-size:14px;">${opt.label}</div>${variantHTML}</div>`;

    if (isSelected && opt._autoVariantId && !rewardChoice.chosenVariantId) rewardChoice.chosenVariantId = opt._autoVariantId;

    card.addEventListener('click', e => {
      if (e.target.tagName === 'SELECT' || e.target.tagName === 'OPTION') return;
      prodsList.querySelectorAll('.b2b-reward-card').forEach(c => {
        c.style.border = '2px solid #e5e7eb'; c.style.background = '#fff';
        const r = c.querySelector('.b2b-reward-radio'); if (r) { r.style.border = '2px solid #9ca3af'; r.style.background = '#fff'; r.innerHTML = ''; }
        const vw = c.querySelector('.reward-variant-wrap'); if (vw) vw.style.display = 'none';
      });
      card.style.border = '2px solid #16a34a'; card.style.background = '#f0fdf4';
      const radio = card.querySelector('.b2b-reward-radio');
      if (radio) { radio.style.border = '2px solid #16a34a'; radio.style.background = '#16a34a'; radio.innerHTML = '<svg width="12" height="12" viewBox="0 0 12 12"><polyline points="2,6 5,9 10,3" stroke="#fff" stroke-width="2" fill="none" stroke-linecap="round"/></svg>'; }
      const vw = card.querySelector('.reward-variant-wrap'); if (vw) vw.style.display = 'block';
      rewardChoice.chosenType          = opt.type;
      rewardChoice.chosenProductHandle = opt.type !== 'discount' ? opt.handle : null;
      rewardChoice.chosenProductTitle  = opt.type !== 'discount' ? opt.title  : null;
      rewardChoice.chosenProductImage  = opt.type !== 'discount' ? opt.image  : null;
      rewardChoice.chosenQty           = opt.qty || 1;
      rewardChoice.chosenVariantId     = opt._autoVariantId || (opt.variant_id && opt.variant_id !== '0' ? String(opt.variant_id) : null);
      rewardChoice.discountPct         = opt.type === 'discount' ? disc : 0;
    });

    const sel = card.querySelector('.reward-variant-sel');
    if (sel) {
      sel.addEventListener('change', () => { rewardChoice.chosenVariantId = sel.value; });
      if (isSelected && rewardChoice.chosenVariantId) sel.value = rewardChoice.chosenVariantId;
    }

    prodsList.appendChild(card);
  });

  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closeRewardChoiceModal() {
  getEl('reward-choice-modal').style.display = 'none';
  document.body.style.overflow = '';
}

/* ============================================================
   RENDER PURCHASE DETAILS
   ============================================================ */
  // function renderPurchaseDetails() {
  //   ensureSkuPopup();
  //   const content = getEl('b2b-details-content');
  //   const noMsg   = getEl('b2b-no-items-msg');
  //   if (!content) return;
  //   content.innerHTML = '';
  //   if (noMsg) noMsg.style.display = 'none';

  //   const uniqueProducts = new Set(), uniqueCollections = new Set();
  //   let totalItems = 0, grandTotal = 0;

  //   function getSelectionPrice(sel) {
  //     const metaP = parseFloat(sel.incentive_product_price || 0);
  //     if (metaP > 0) return metaP;
  //     const vid2    = String(sel.variant_id || '');
  //     const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
  //     const metaP2  = parseFloat(extras2.incentive_product_price || 0);
  //     if (metaP2 > 0) return metaP2;
  //     return parseFloat(sel.price || 0);
  //   }

  //   // ── Filas principales ──
  //   const mainRows = [];
  //   variantRows().forEach(row => {
  //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
  //     if (!qty) return;
  //     const sku        = (row.dataset.sku || '-').toUpperCase();
  //     const vendor     = new URLSearchParams(window.location.search).get('vendor') || '';
  //     const product    = row.cells[5]?.textContent?.trim() || 'Product';
  //     const ml         = row.cells[7]?.textContent?.trim() || 'N/A';
  //     const pres       = row.cells[8]?.textContent?.trim() || 'N/A';
  //     const collection = row.cells[4]?.textContent?.trim() || 'N/A';
  //     const unitPrice  = parseFloat(row.dataset.unitPrice || 0);
  //     const subtotal   = qty * unitPrice;
  //     const imgUrl     = row.dataset.imgUrl || '';
  //     const coeff      = row.cells[10]?.textContent?.trim() || 'N/A';

  //       mainRows.push(`
  //       <tr style="border-bottom:1px solid #e5e7eb;">
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
  //           ${imgUrl
  //             ? `<img src="${imgUrl}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;cursor:pointer;"
  //                 class="detail-img-hover"
  //                 data-description="${row.dataset.description||''}"
  //                 data-top-notes="${row.dataset.topNotes||''}"
  //                 data-middle-notes="${row.dataset.middleNotes||''}"
  //                 data-base-notes="${row.dataset.baseNotes||''}"
  //                 onerror="this.style.display='none'">`
  //             : '<div style="width:52px;height:52px;border-radius:6px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">📦</div>'}
  //         </td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">${product}</td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${sku}</td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${ml}</td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${pres}</td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${collection}</td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${coeff}</td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
  //         <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">$${subtotal.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
  //       </tr>`);

  //     totalItems += qty; grandTotal += subtotal;
  //     uniqueProducts.add(product); uniqueCollections.add(collection);
  //   });

  //   // ── Filas de incentivos ──
  //   const freeRows = [];
  //   const freeRowsData = [];
  //   const withOwnRule = new Set();
  //   const colH     = getColHandle();
  //   const rulesRPD = window.b2bCollectionIncentivesMap?.[colH] || [];

  //   function getFreeVariantInfo(variantId) {
  //     if (!variantId) return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack:'—' };
  //     const vid = String(variantId);
  //     const freeRow = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
  //     const extras2 = window.b2bVariantExtrasMap?.[vid] || {};
  //     const unitsPerPack = extras2.quantity > 0 ? extras2.quantity : '—';
  //     if (freeRow) {
  //       return {
  //         sku:         (freeRow.dataset.sku || '').toUpperCase() || '—',
  //         ml:          freeRow.cells[7]?.textContent?.trim()  || '—',
  //         pres:        freeRow.cells[8]?.textContent?.trim()  || '—',
  //         collection:  freeRow.cells[4]?.textContent?.trim()  || '—',
  //         coefficient: freeRow.cells[10]?.textContent?.trim() || '—',
  //         unitsPerPack
  //       };
  //     }
  //     const v = window.b2bAllVariantsMap?.[vid];
  //     if (v) return {
  //       sku:         v.sku         || '—',
  //       ml:          v.ml          || '—',
  //       pres:        v.pres        || '—',
  //       collection:  v.collection  || '—',
  //       coefficient: v.coefficient || '—',
  //       unitsPerPack
  //     };
  //     return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack:'—' };
  //   }

  //     function addFreeRow(imgSrc, title, badge, badgeBg, subtitle, variantId, qty, extraCol = '—') {
  //         const info = getFreeVariantInfo(variantId);
  //          const pack = parseInt(info.unitsPerPack) || 1;
  //         // Solo multiplicar por Units/Pack si la presentación es Vails
  //         const isVails = (info.pres || '').toLowerCase().includes('vail');
  //         const totalUnits = isVails ? (parseInt(qty) || 0) * pack : (parseInt(qty) || 0);
  //         freeRowsData.push({ pres: info.pres, qty: totalUnits });
  //         // freeRowsData.push({ pres: info.pres, qty: parseInt(qty) || 0 });
  //         freeRows.push(`
  //           <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
  //               ${imgSrc
  //                 ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
  //                 : '<div style="width:52px;height:52px;border-radius:6px;background:#dcfce7;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>'}
  //             </td>
  //             <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;text-align: center;">
  //               ${title}
                
  //             </td>
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
             
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${extraCol}</td>
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
  //             <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">$0.00</td>
  //           </tr>`);
  //      }

  //   // P1 variant incentives
  //   variantRows().forEach(row => {
  //     const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
  //     if (qty <= 0) return;
  //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
  //     if (!variantHasIncentive(extras)) return;
  //     const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
  //     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

  //     withOwnRule.add(row.dataset.variantId);
  //     const pName      = row.cells[5]?.textContent?.trim() || 'Product';
  //     const multiplier = calcVariantMultiplier(extras, qty, lineV);
  //     const fps        = getVariantFreeProducts(extras);
  //     const fqs        = getVariantFreeQtys(extras);
  //     const choice     = window.b2bVariantRewardChoices[row.dataset.variantId];

  //     if (fps.length > 1 && choice?.confirmed) {
  //       const img  = (choice.chosenImage || '').replace(/^\/\//, 'https://');
  //       const vid2 = choice.chosenVariantId;
  //       const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
  //       const up   = ex2.quantity > 0 ? ex2.quantity : '—';
  //       addFreeRow(img, choice.chosenTitle, 'FREE', '#16a34a', `${pName} Incentive — Your Choice`, vid2, choice.chosenQty, up);
  //     } else if (fps.length > 1 && !choice?.confirmed) {
  //       if (Number(window.b2bCollectionPriority || 1) !== 2 && Number(window.b2bCollectionPriority || 1) !== 3) {
  //         freeRows.push(`
  //           <tr style="border-bottom:1px solid #fde68a;background:#fffbeb;">
  //             <td colspan="7" style="padding:12px 16px;">
  //               <div style="display:flex;align-items:center;gap:10px;">
  //                 <span style="font-size:20px;">⚠️</span>
  //                 <div>
  //                   <strong style="color:#92400e;">Free Gift Pending Selection</strong>
  //                   <span style="font-size:12px;color:#92400e;margin-left:8px;">${pName} — click Choose Gift to select</span>
  //                 </div>
  //               </div>
  //             </td>
  //           </tr>`);
  //       }
  //     } else {
  //       fps.forEach((fp, i) => {
  //         if (!fp?.title) return;
  //         const giftQty = (fqs[i] || 1) * multiplier;
  //         const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
  //         const vid2    = String(fp.variant_id || '');
  //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
  //         const up      = ex2.quantity > 0 ? ex2.quantity : '—';
  //         addFreeRow(img, fp.title, 'FREE', '#16a34a', `${pName} Incentive`, vid2, giftQty, up);
  //       });
  //     }
  //   });

  //   // P2
  //   const p2choice = window.b2bPriority2Choice || {};
  //   if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
  //     p2choice.selections.filter(sel => (sel.selectedQty || 0) > 0).forEach(sel => {
  //       const imgSrc   = (sel.image || '').replace(/^\/\//, 'https://');
  //       const vid      = String(sel.variant_id || '');
  //       const ex2      = window.b2bVariantExtrasMap?.[vid] || {};
  //       const up       = ex2.quantity > 0 ? ex2.quantity : '—';
  //       const price    = getSelectionPrice(sel);
  //       const discPct2 = parseFloat(p2choice.discountPct || 0);
  //       const final    = price * (1 - discPct2 / 100);
  //       const subtotal = final * sel.selectedQty;
  //       const info     = getFreeVariantInfo(vid);
  //       freeRowsData.push({ pres: info.pres, qty: sel.selectedQty });
  //      freeRows.push(`
  //         <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;">
  //             ${imgSrc
  //               ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
  //               : '<div style="width:52px;height:52px;border-radius:6px;background:#dbeafe;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🏷️</div>'}
  //           </td>
  //           <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">
  //             ${sel.title}
              
  //           </td>
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
            
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${up}</td>
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${sel.selectedQty}</td>
  //           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">$${subtotal.toFixed(2)}</td>
  //         </tr>`);
  //     });
  //   }

  //   // P3
  //   const p3choice = window.b2bPriority3Choice || {};
  //   if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
  //     p3choice.selections.forEach(sel => {
  //       (sel.choices || []).forEach(choice => {
  //         if (!choice.chosenQty || choice.chosenQty <= 0) return;
  //         const imgSrc = (choice.image || '').replace(/^\/\//, 'https://');
  //         const vid2   = String(choice.chosenVariantId || '');
  //         const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
  //         const up     = ex2.quantity > 0 ? ex2.quantity : '—';
  //         addFreeRow(imgSrc, choice.title, 'FREE', '#16a34a', `${sel.pName} — Your choice (P3)`, vid2, choice.chosenQty, up);
  //       });
  //     });
  //   }

  //   // Collection rules
  //   let unitsCol = 0, valueCol = 0;
  //   variantRows().forEach(row => {
  //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
  //     if (qty <= 0 || withOwnRule.has(row.dataset.variantId)) return;
  //     unitsCol += qty;
  //     valueCol += qty * parseFloat(row.dataset.unitPrice || 0);
  //   });

  //   const activeRPD = rulesRPD.length ? calcActiveIncentive(rulesRPD, unitsCol, valueCol) : null;
  //   if (activeRPD) {
  //     if (isAutoApply(activeRPD)) {
  //       (activeRPD.free_products || []).forEach((fp, i) => {
  //         if (!fp?.title) return;
  //         const giftQty = normalizeQtyArray(activeRPD.free_product_quantities)[i] || 1;
  //         const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
  //         const vid2    = String(fp.variant_id || '');
  //         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
  //         const up      = ex2.quantity > 0 ? ex2.quantity : '—';
  //         addFreeRow(img, fp.title, 'FREE', '#16a34a', 'Collection Incentive', vid2, giftQty, up);
  //       });
  //       (activeRPD.free_testers || []).forEach((tp, i) => {
  //         if (!tp?.title) return;
  //         const q   = getTesterQty(activeRPD, i);
  //         const img = tp.image ? tp.image.replace(/^\/\//, 'https://') : '';
  //         const vid2 = String(tp.variant_id || '');
  //         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
  //         const up   = ex2.quantity > 0 ? ex2.quantity : '—';
  //         addFreeRow(img, tp.title, 'TESTER', '#2563eb', 'Collection Incentive', vid2, q, up);
  //       });
  //     } else if (rewardChoice.confirmed) {
  //       const ct  = rewardChoice.chosenType;
  //       const img = (rewardChoice.chosenProductImage || '').replace(/^\/\//, 'https://');
  //       if (ct === 'tester' || ct === 'product') {
  //         const vid2 = rewardChoice.chosenVariantId;
  //         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
  //         const up   = ex2.quantity > 0 ? ex2.quantity : '—';
  //         addFreeRow(img, rewardChoice.chosenProductTitle || ct, ct === 'tester' ? 'TESTER' : 'FREE', '#16a34a', 'Your chosen reward', vid2, rewardChoice.chosenQty || 1, up);
  //       }
  //     }
  //   }

  //   // ── Contar incentivos ──
  //   let totalIncentives = 0;
  //   variantRows().forEach(row => {
  //     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
  //     if (qty <= 0) return;
  //     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
  //     if (!variantHasIncentive(extras)) return;
  //     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
  //     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
  //     const fps    = getVariantFreeProducts(extras);
  //     const fqs    = getVariantFreeQtys(extras);
  //     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
  //     if (fps.length > 1 && choice?.confirmed) {
  //       totalIncentives += choice.chosenQty || 0;
  //     } else if (fps.length <= 1) {
  //       fps.forEach((fp, i) => { totalIncentives += fqs[i] || 1; });
  //     }
  //   });
  //   const p2i = window.b2bPriority2Choice || {};
  //   if (p2i.confirmed && Array.isArray(p2i.selections)) {
  //     p2i.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => { totalIncentives += s.selectedQty; });
  //   }
  //   const p3i = window.b2bPriority3Choice || {};
  //   if (p3i.confirmed && Array.isArray(p3i.selections)) {
  //     p3i.selections.forEach(sel => {
  //       (sel.choices || []).forEach(c => { totalIncentives += c.chosenQty || 0; });
  //     });
  //   }

  //   // ── Totales ──
  //   const p2 = window.b2bPriority2Choice || {};
  //   let p2Subtotal = 0;
  //   if (p2.confirmed && Array.isArray(p2.selections)) {
  //     p2.selections.filter(s => s.selectedQty > 0).forEach(s => {
  //       const price    = getSelectionPrice(s);
  //       const discPct2 = parseFloat(p2.discountPct || 0);
  //       p2Subtotal += price * (1 - discPct2 / 100) * s.selectedQty;
  //     });
  //   }
  //   const discPct    = rewardChoice?.discountPct || 0;
  //   const discAmount = discPct > 0 ? grandTotal * discPct / 100 : 0;
  //   const finalTotal = grandTotal - discAmount;
  //   const fmt = n => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  //   // ── Construir HTML final ──
  //   const tableStyle = 'width:100%;border-collapse:collapse;font-family:"Crimson Pro",serif;';
  //   const thStyle    = 'padding:9px 8px;text-align:center;font-size:17px;font-weight:600;color:#fff;';

  //   let html = '';

  //   if (mainRows.length) {
  //  html += `
  //     <div style="overflow-x:auto;margin-bottom:0;">
  //       <table style="${tableStyle}">
  //         <thead>
  //           <tr style="background:#686a6c;">
  //             <th style="${thStyle}">Photo</th>
  //             <th style="${thStyle}">Product</th>
  //             <th style="${thStyle}">SKU</th>
  //             <th style="${thStyle}">ML</th>
  //             <th style="${thStyle}">Presentation</th>
  //             <th style="${thStyle}">Collection</th>
  //             <th style="${thStyle}">Coefficient</th>
  //             <th style="${thStyle}">Qty</th>
  //             <th style="${thStyle}">Total</th>
  //           </tr>
  //         </thead>
  //         <tbody>
  //           ${mainRows.join('')}
  //         </tbody>
  //       </table>
  //     </div>`;
  //   }

  //   if (freeRows.length) {
  //     html += `
  //       <div style="margin-top:16px;overflow-x:auto;">
  //         <div class="b2b-free-gifts-header">Incentives Included</div>
  //         <table style="${tableStyle}">
  //           <thead>
  //             <tr style="background:#686a6c;">
  //               <th style="${thStyle}">Photo</th>
  //               <th style="${thStyle}">Product</th>
  //               <th style="${thStyle}">SKU</th>
  //               <th style="${thStyle}">ML</th>
  //               <th style="${thStyle}">Presentation</th>
  //               <th style="${thStyle}">Collection</th>
                
  //               <th style="${thStyle}">Units/Pack</th>
  //               <th style="${thStyle}">Qty</th>
  //               <th style="${thStyle}">Total</th>
  //             </tr>
  //           </thead>
  //           <tbody>
  //             ${freeRows.join('')}
  //           </tbody>
  //         </table>
  //       </div>`;
  //   }


  //   const incentiveByPres = {};
  //     freeRowsData.forEach(item => {
  //       const key = item.pres && item.pres !== '—' ? item.pres : 'Other';
  //       incentiveByPres[key] = (incentiveByPres[key] || 0) + item.qty;
  //     });
  //     const totalIncentiveQty = totalIncentives;

  //     const presBreakdownHTML = Object.entries(incentiveByPres).map(([pres, qty]) => `
  //       <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
  //         <span style="font-weight:400;text-align:right;padding-right:16px;color:#000;font-size:16px;">GWP ${pres}</span>
  //         <span style="text-align:right;font-size:16px; color:#000;">${qty}</span>
  //       </div>`).join('');

  //   // Totales
  //   html += `
  //       <div style="display:flex;flex-direction:column;align-items:flex-end;gap:6px;font-size:15px;margin-top:16px;padding-top:12px;padding-bottom:40px;border-top:1px solid #e5e7eb;">

  //         ${totalIncentiveQty > 0 ? `
  //         <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
  //           <span style="font-weight:700;text-align:right;padding-right:16px; color:#000">GWP Qty</span>
  //           <span style="font-weight:700;text-align:right;color:#000">${totalIncentiveQty}</span>
  //         </div>
  //         ${presBreakdownHTML}
  //         <div style="width:300px;border-top:1px dashed #d1d5db;margin:4px 0;"></div>
  //         ` : ''}

  //         <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
  //           <span style="font-weight:600;text-align:right;padding-right:16px;">Total Qty</span>
  //           <span style="font-weight:700;text-align:right;">${totalItems.toLocaleString('en-US')}</span>
  //         </div>
  //         <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;">
  //           <span style="font-weight:600;text-align:right;padding-right:16px;">Subtotal</span>
  //           <span style="text-align:right;">$${fmt(grandTotal)}</span>
  //         </div>
  //         ${p2Subtotal > 0
  //           ? `<div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;color:#2563eb;">
  //               <span style="font-weight:600;text-align:right;padding-right:16px;">Reward Credit (${p2.discountPct}%)</span>
  //               <span style="font-weight:700;text-align:right;">$${fmt(p2Subtotal)}</span>
  //             </div>` : ''}
  //         ${discPct > 0
  //           ? `<div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;color:#b45309;">
  //               <span style="font-weight:600;text-align:right;padding-right:16px;">Discount (${discPct}%)</span>
  //               <span style="font-weight:700;text-align:right;">-$${fmt(discAmount)}</span>
  //             </div>
  //             <div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;font-size:17px;color:#166534;">
  //               <span style="font-weight:700;text-align:right;padding-right:16px;">Estimated Total</span>
  //               <span style="font-weight:800;text-align:right;">$${fmt(finalTotal)}</span>
  //             </div>`
  //           : `<div style="display:grid;grid-template-columns:minmax(160px,1fr) 100px;width:300px;font-size:17px;">
  //               <span style="font-weight:700;text-align:right;padding-right:16px;">Estimated Total</span>
  //               <span style="font-weight:800;text-align:right;">$${fmt(finalTotal)}</span>
  //             </div>`}
  //       </div>`;

  //   if (!mainRows.length) {
  //     if (noMsg) noMsg.style.display = 'block';
  //   } else {
  //     content.innerHTML = html;
  //     content.querySelectorAll('.detail-img-hover').forEach(img => {
  //       img.addEventListener('mouseenter', e => {
  //         skuPopup.querySelector('.sku-popup-img').src = img.src || '';
  //         skuPopup.querySelector('.popup-description').textContent  = img.dataset.description || '';
  //         skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(img.dataset.topNotes);
  //         skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(img.dataset.middleNotes);
  //         skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(img.dataset.baseNotes);
  //         positionPopup(e); skuPopup.classList.add('visible');
  //       });
  //       img.addEventListener('mousemove', positionPopup);
  //       img.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
  //     });
  //   }

  //   getEl('dash-count-product').textContent    = uniqueProducts.size;
  //   getEl('dash-unique-types').textContent     = uniqueCollections.size;
  //   getEl('dash-total-items').textContent      = totalItems;
  //   getEl('dash-total-incentives').textContent = totalIncentives;
  //   getEl('dash-total-purchase').textContent   = '$' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
  //   getEl('b2b-incentive-summary-panel').style.display = 'none';
  // }

//  function renderPurchaseDetails() {
//     ensureSkuPopup();
//     const content = getEl('b2b-details-content');
//     const noMsg   = getEl('b2b-no-items-msg');
//     if (!content) return;
//     content.innerHTML = '';
//     if (noMsg) noMsg.style.display = 'none';

//     const uniqueProducts = new Set(), uniqueCollections = new Set();
//     let totalItems = 0, grandTotal = 0;

//     const tableStyle = 'width:100%;border-collapse:collapse;font-family:"Crimson Pro",serif;';
//     const thStyle    = 'padding:9px 8px;text-align:center;font-size:17px;font-weight:600;color:#fff;';

//     function getSelectionPrice(sel) {
//       const metaP = parseFloat(sel.incentive_product_price || 0);
//       if (metaP > 0) return metaP;
//       const vid2    = String(sel.variant_id || '');
//       const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
//       const metaP2  = parseFloat(extras2.incentive_product_price || 0);
//       if (metaP2 > 0) return metaP2;
//       return parseFloat(sel.price || 0);
//     }

//     // ── Agrupar filas principales por presentación ──
//     const groupedRows = {};
//     const groupOrder  = [];

//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (!qty) return;

//       const sku        = (row.dataset.sku || '-').toUpperCase();
//       const product    = row.cells[5]?.textContent?.trim() || 'Product';
//       const ml         = row.cells[7]?.textContent?.trim() || 'N/A';
//       const presDisp   = row.cells[8]?.textContent?.trim() || 'N/A';
//       const presLower  = presDisp.toLowerCase();
//       const collection = row.cells[4]?.textContent?.trim() || 'N/A';
//       const unitPrice  = parseFloat(row.dataset.unitPrice || 0);
//       const subtotal   = qty * unitPrice;
//       const imgUrl     = row.dataset.imgUrl || '';
//       const coeff      = row.cells[10]?.textContent?.trim() || 'N/A';

//       let groupKey = 'Others';
//       if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
//       // else if (presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
//       else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester') || presLower.includes('sample')) groupKey = 'Vials & Testers';
//       else if (presLower.includes('retail'))                               groupKey = 'Retail';
//       else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;

//       if (!groupedRows[groupKey]) {
//         groupedRows[groupKey] = { rows: [], subtotal: 0, qty: 0 };
//         groupOrder.push(groupKey);
//       }

//       groupedRows[groupKey].subtotal += subtotal;
//       groupedRows[groupKey].qty      += qty;
//       groupedRows[groupKey].rows.push(`
//         <tr style="border-bottom:1px solid #e5e7eb;">
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
//             ${imgUrl
//               ? `<img src="${imgUrl}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;cursor:pointer;"
//                   class="detail-img-hover"
//                   data-description="${row.dataset.description||''}"
//                   data-top-notes="${row.dataset.topNotes||''}"
//                   data-middle-notes="${row.dataset.middleNotes||''}"
//                   data-base-notes="${row.dataset.baseNotes||''}"
//                   onerror="this.style.display='none'">`
//               : '<div style="width:52px;height:52px;border-radius:6px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">📦</div>'}
//           </td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">${product}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${sku}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${ml}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${presDisp}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${collection}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${coeff}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">$${subtotal.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
//         </tr>`);

//       totalItems += qty;
//       grandTotal += subtotal;
//       uniqueProducts.add(product);
//       uniqueCollections.add(collection);
//     });

//     // ── Filas de incentivos ──
//     const freeRows     = [];
//     const freeRowsData = [];
//     const withOwnRule  = new Set();
//     const colH         = getColHandle();
//     const rulesRPD     = window.b2bCollectionIncentivesMap?.[colH] || [];

//     function getFreeVariantInfo(variantId) {
//       if (!variantId) return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
//       const vid      = String(variantId);
//       const freeRow  = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
//       const extras2  = window.b2bVariantExtrasMap?.[vid] || {};
//       const unitsPerPack = parseInt(extras2.quantity) || 0;
//       if (freeRow) {
//         return {
//           sku:         (freeRow.dataset.sku || '').toUpperCase() || '—',
//           ml:          freeRow.cells[7]?.textContent?.trim()  || '—',
//           pres:        freeRow.cells[8]?.textContent?.trim()  || '—',
//           collection:  freeRow.cells[4]?.textContent?.trim()  || '—',
//           coefficient: freeRow.cells[10]?.textContent?.trim() || '—',
//           unitsPerPack
//         };
//       }
//       const v = window.b2bAllVariantsMap?.[vid];
//       if (v) return {
//         sku:         v.sku         || '—',
//         ml:          v.ml          || '—',
//         pres:        v.pres        || '—',
//         collection:  v.collection  || '—',
//         coefficient: v.coefficient || '—',
//         unitsPerPack
//       };
//       return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
//     }

//     function addFreeRow(imgSrc, title, badge, badgeBg, subtitle, variantId, qty, extraCol = '—', overridePrice = null) {
//       const info = getFreeVariantInfo(variantId);

//       // ── Resolver pack desde múltiples fuentes ──
//       const extras3     = window.b2bVariantExtrasMap?.[String(variantId)] || {};
//       const packFromExt = parseInt(extras3.quantity) || 0;
//       const packFromCol = extraCol !== '—' ? parseInt(extraCol) || 0 : 0;
//       const packFromInf = parseInt(info.unitsPerPack) || 0;
//       const pack        = packFromExt > 0 ? packFromExt
//                         : packFromCol > 0 ? packFromCol
//                         : packFromInf > 0 ? packFromInf : 1;

//       // const isVails = (info.pres || '').toLowerCase().includes('vail');
//       const isVails = (info.pres || '').toLowerCase().includes('vial') || 
//                 (info.pres || '').toLowerCase().includes('vail');
//       // const realQty = isVails ? (parseInt(qty) || 0) * pack : (parseInt(qty) || 0);
//       const packVal = pack > 1 ? pack : 1;
//             const realQty = isVails ? (parseInt(qty) || 0) * packVal : (parseInt(qty) || 0);

//       // freeRowsData.push({ pres: info.pres, qty: realQty, pack, rawQty: parseInt(qty) || 0 });
//       freeRowsData.push({ pres: info.pres, qty: realQty, pack: packVal, rawQty: parseInt(qty) || 0 });

//       const packDisplay  = pack > 1 ? pack : (extraCol !== '—' ? extraCol : '—');
//       const priceDisplay = overridePrice !== null ? `$${overridePrice}` : '$0.00';

//       freeRows.push(`
//         <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
//             ${imgSrc
//               ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
//               : '<div style="width:52px;height:52px;border-radius:6px;background:#dcfce7;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>'}
//           </td>
//           <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;text-align:center;">${title}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${packDisplay}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
//           <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">${priceDisplay}</td>
//         </tr>`);
//     }

//     // ── P1 variant incentives ──
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       if (!variantHasIncentive(extras)) return;
//       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

//       withOwnRule.add(row.dataset.variantId);
//       const pName      = row.cells[5]?.textContent?.trim() || 'Product';
//       const multiplier = calcVariantMultiplier(extras, qty, lineV);
//       const fps        = getVariantFreeProducts(extras);
//       const fqs        = getVariantFreeQtys(extras);
//       const choice     = window.b2bVariantRewardChoices[row.dataset.variantId];

//       if (fps.length > 1 && choice?.confirmed) {
//         const img  = (choice.chosenImage || '').replace(/^\/\//, 'https://');
//         const vid2 = choice.chosenVariantId;
//         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//         const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//         addFreeRow(img, choice.chosenTitle, 'FREE', '#16a34a', `${pName} Incentive — Your Choice`, vid2, choice.chosenQty, up);
//       } else if (fps.length > 1 && !choice?.confirmed) {
//         if (Number(window.b2bCollectionPriority || 1) !== 2 && Number(window.b2bCollectionPriority || 1) !== 3) {
//           freeRows.push(`
//             <tr style="border-bottom:1px solid #fde68a;background:#fffbeb;">
//               <td colspan="9" style="padding:12px 16px;">
//                 <div style="display:flex;align-items:center;gap:10px;">
//                   <span style="font-size:20px;">⚠️</span>
//                   <div>
//                     <strong style="color:#92400e;">Free Gift Pending Selection</strong>
//                     <span style="font-size:12px;color:#92400e;margin-left:8px;">${pName} — click Choose Gift to select</span>
//                   </div>
//                 </div>
//               </td>
//             </tr>`);
//         }
//       } else {
//         fps.forEach((fp, i) => {
//           if (!fp?.title) return;
//           const giftQty = (fqs[i] || 1) * multiplier;
//           const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//           const vid2    = String(fp.variant_id || '');
//           const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up      = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(img, fp.title, 'FREE', '#16a34a', `${pName} Incentive`, vid2, giftQty, up);
//         });
//       }
//     });

//     // ── P2 ──
//     const p2choice = window.b2bPriority2Choice || {};
//     if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
//       p2choice.selections.filter(sel => (sel.selectedQty || 0) > 0).forEach(sel => {
//         const imgSrc   = (sel.image || '').replace(/^\/\//, 'https://');
//         const vid      = String(sel.variant_id || '');
//         const ex2      = window.b2bVariantExtrasMap?.[vid] || {};
//         const up       = ex2.quantity > 0 ? ex2.quantity : '—';
//         const price    = getSelectionPrice(sel);
//         const discPct2 = parseFloat(p2choice.discountPct || 0);
//         const final    = price * (1 - discPct2 / 100);
//         const subtotal = parseFloat((final * sel.selectedQty).toFixed(2));
//         addFreeRow(imgSrc, sel.title, `${discPct2}%`, '#2563eb', 'Reward Credit', vid, sel.selectedQty, up, subtotal);
//       });
//     }

//     // ── P3 ──
//     const p3choice = window.b2bPriority3Choice || {};
//     if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
//       p3choice.selections.forEach(sel => {
//         (sel.choices || []).forEach(choice => {
//           if (!choice.chosenQty || choice.chosenQty <= 0) return;
//           const imgSrc = (choice.image || '').replace(/^\/\//, 'https://');
//           const vid2   = String(choice.chosenVariantId || '');
//           const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up     = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(imgSrc, choice.title, 'FREE', '#16a34a', `${sel.pName} — Your choice (P3)`, vid2, choice.chosenQty, up);
//         });
//       });
//     }

//     // ── Collection rules ──
//     let unitsCol = 0, valueCol = 0;
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0 || withOwnRule.has(row.dataset.variantId)) return;
//       unitsCol += qty;
//       valueCol += qty * parseFloat(row.dataset.unitPrice || 0);
//     });

//     const activeRPD = rulesRPD.length ? calcActiveIncentive(rulesRPD, unitsCol, valueCol) : null;
//     if (activeRPD) {
//       if (isAutoApply(activeRPD)) {
//         (activeRPD.free_products || []).forEach((fp, i) => {
//           if (!fp?.title) return;
//           const giftQty = normalizeQtyArray(activeRPD.free_product_quantities)[i] || 1;
//           const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
//           const vid2    = String(fp.variant_id || '');
//           const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up      = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(img, fp.title, 'FREE', '#16a34a', 'Collection Incentive', vid2, giftQty, up);
//         });
//         (activeRPD.free_testers || []).forEach((tp, i) => {
//           if (!tp?.title) return;
//           const q    = getTesterQty(activeRPD, i);
//           const img  = tp.image ? tp.image.replace(/^\/\//, 'https://') : '';
//           const vid2 = String(tp.variant_id || '');
//           const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(img, tp.title, 'TESTER', '#2563eb', 'Collection Incentive', vid2, q, up);
//         });
//       } else if (rewardChoice.confirmed) {
//         const ct  = rewardChoice.chosenType;
//         const img = (rewardChoice.chosenProductImage || '').replace(/^\/\//, 'https://');
//         if (ct === 'tester' || ct === 'product') {
//           const vid2 = rewardChoice.chosenVariantId;
//           const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//           const up   = ex2.quantity > 0 ? ex2.quantity : '—';
//           addFreeRow(img, rewardChoice.chosenProductTitle || ct, ct === 'tester' ? 'TESTER' : 'FREE', '#16a34a', 'Your chosen reward', vid2, rewardChoice.chosenQty || 1, up);
//         }
//       }
//     }

//     // ── Contar incentivos ──
//     let totalIncentives = 0;
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       if (!variantHasIncentive(extras)) return;
//       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//       const fps    = getVariantFreeProducts(extras);
//       const fqs    = getVariantFreeQtys(extras);
//       const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//       if (fps.length > 1 && choice?.confirmed) {
//         totalIncentives += choice.chosenQty || 0;
//       } else if (fps.length <= 1) {
//         fps.forEach((fp, i) => { totalIncentives += fqs[i] || 1; });
//       }
//     });
//     const p2i = window.b2bPriority2Choice || {};
//     if (p2i.confirmed && Array.isArray(p2i.selections)) {
//       p2i.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => { totalIncentives += s.selectedQty; });
//     }
//     const p3i = window.b2bPriority3Choice || {};
//     if (p3i.confirmed && Array.isArray(p3i.selections)) {
//       p3i.selections.forEach(sel => {
//         (sel.choices || []).forEach(c => { totalIncentives += c.chosenQty || 0; });
//       });
//     }

//     // ── Totales ──
//     const p2       = window.b2bPriority2Choice || {};
//     let p2Subtotal = 0;
//     if (p2.confirmed && Array.isArray(p2.selections)) {
//       p2.selections.filter(s => s.selectedQty > 0).forEach(s => {
//         const price    = getSelectionPrice(s);
//         const discPct2 = parseFloat(p2.discountPct || 0);
//         p2Subtotal += price * (1 - discPct2 / 100) * s.selectedQty;
//       });
//     }
//     const discPct    = rewardChoice?.discountPct || 0;
//     const discAmount = discPct > 0 ? grandTotal * discPct / 100 : 0;
//     const finalTotal = grandTotal - discAmount;
//     const fmt = n => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//     // ── Construir HTML final ──
//     let html = '';

//     const tableHeader = `
//       <thead>
//         <tr style="background:#686a6c;">
//           <th style="${thStyle}">Photo</th>
//           <th style="${thStyle}">Product</th>
//           <th style="${thStyle}">SKU</th>
//           <th style="${thStyle}">ML</th>
//           <th style="${thStyle}">Presentation</th>
//           <th style="${thStyle}">Collection</th>
//           <th style="${thStyle}">Coefficient</th>
//           <th style="${thStyle}">Qty</th>
//           <th style="${thStyle}">Total</th>
//         </tr>
//       </thead>`;

//     const preferredOrder = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
//     const sortedGroups   = [
//       ...preferredOrder.filter(g => groupedRows[g]),
//       ...groupOrder.filter(g => !preferredOrder.includes(g))
//     ];

//     const groupIcons = {
//       'Perfumes':        '',
//       'Vials & Testers': '',
//       'Retail':          '',
//       'Others':          ''
//     };

//     sortedGroups.forEach(groupKey => {
//       const group = groupedRows[groupKey];
//       if (!group?.rows?.length) return;
//       const icon = groupIcons[groupKey] || '';

//       html += `
//         <div style="margin-bottom:28px;">
//           <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">
//             <div style="width:4px;height:28px;background:#b8a77d;border-radius:2px;"></div>
//             <span style="font-size:20px;">${icon}</span>
//             <h3 style="margin:0;font-size:19px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;">${groupKey}</h3>
//             <span style="background:#f3f4f6;color:#6b7280;font-size:13px;font-weight:600;padding:2px 10px;border-radius:99px;">
//               ${group.rows.length} item${group.rows.length > 1 ? 's' : ''}
//             </span>
//           </div>
//           <div style="overflow-x:auto;border-radius:8px;border:1px solid #e5e7eb;overflow:hidden;">
//             <table style="${tableStyle}">
//               ${tableHeader}
//               <tbody>${group.rows.join('')}</tbody>
//               <tfoot>
//                 <tr style="border-top:2px solid #b8a77d;">
//                   <td colspan="7" style="padding:10px 8px;"></td>
//                   <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">${group.qty}</td>
//                   <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">$${fmt(group.subtotal)}</td>
//                 </tr>
//               </tfoot>
//             </table>
//           </div>
//         </div>`;
//     });

//     // ── Sección Incentives Included ──
//     if (freeRows.length) {
//       html += `
//         <div style="margin-top:16px;overflow-x:auto;">
//           <div class="b2b-free-gifts-header">Incentives Included</div>
//           <table style="${tableStyle}">
//             <thead>
//               <tr style="background:#686a6c;">
//                 <th style="${thStyle}">Photo</th>
//                 <th style="${thStyle}">Product</th>
//                 <th style="${thStyle}">SKU</th>
//                 <th style="${thStyle}">ML</th>
//                 <th style="${thStyle}">Presentation</th>
//                 <th style="${thStyle}">Collection</th>
//                 <th style="${thStyle}">Units/Pack</th>
//                 <th style="${thStyle}">Qty</th>
//                 <th style="${thStyle}">Total</th>
//               </tr>
//             </thead>
//             <tbody>${freeRows.join('')}</tbody>
//           </table>
//         </div>`;
//     }

//     // ── Breakdown GWP por presentación ──
//     const incentiveByPres = {};
//     const packByPres      = {};
//     freeRowsData.forEach(item => {
//       const key  = item.pres && item.pres !== '—' ? item.pres : 'Other';
//       const pack = parseInt(item.pack) || 1;
//       incentiveByPres[key] = (incentiveByPres[key] || 0) + item.qty;
//       if (!packByPres[key]) packByPres[key] = pack;
//     });

//     const totalIncentiveQty = totalIncentives;

//     // ── Order Summary ──
//     const summaryRows = [];

//     // GWP por presentación
//     if (totalIncentiveQty > 0) {
//       Object.entries(incentiveByPres).forEach(([pres, qty]) => {
//         const packVal = (packByPres[pres] && packByPres[pres] > 1) ? packByPres[pres] : '—';
//         summaryRows.push(`
//           <tr style="border-bottom:1px solid #f3f4f6;">
//             <td style="padding:10px 16px;font-size:15px;color:#374151;">FOC ${pres}</td>
//             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${packVal}</td>
//             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${qty}</td>
//             <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
//           </tr>`);
//       });
//       summaryRows.push(`
//         <tr style="border-bottom:2px solid #e5e7eb;background:#f9fafb;">
//           <td style="padding:10px 16px;font-size:15px;font-weight:700;color:#111;">Total FOC</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">${totalIncentiveQty}</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">$0.00</td>
//         </tr>`);
//     }

//     // Grupos por presentación
//     const preferredSummary = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
//     const allSummaryGroups = [
//       ...preferredSummary.filter(g => groupedRows[g]),
//       ...groupOrder.filter(g => !preferredSummary.includes(g) && groupedRows[g])
//     ];

//     allSummaryGroups.forEach(groupKey => {
//       const group = groupedRows[groupKey];
//       if (!group?.qty) return;
//       const icon = groupIcons[groupKey] || '';
//       summaryRows.push(`
//         <tr style="border-bottom:1px solid #f3f4f6;">
//           <td style="padding:10px 16px;font-size:15px;color:#374151;">${icon} ${groupKey}</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${group.qty}</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">$${fmt(group.subtotal)}</td>
//         </tr>`);
//     });

//     // Reward Credit P2
//     // if (p2Subtotal > 0) {
//     //   summaryRows.push(`
//     //     <tr style="border-bottom:1px solid #e5e7eb;">
//     //       <td style="padding:10px 16px;font-size:15px;color:#2563eb;">Reward Credit (${p2.discountPct}%)</td>
//     //       <td style="padding:10px 16px;text-align:right;font-size:15px;color:#2563eb;">—</td>
//     //       <td style="padding:10px 16px;text-align:right;font-size:15px;color:#2563eb;">—</td>
//     //       <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#2563eb;">$${fmt(p2Subtotal)}</td>
//     //     </tr>`);
//     // }

//     // Total Qty
//     // summaryRows.push(`
//     //   <tr style="border-bottom:1px solid #e5e7eb;background:#f9fafb;">
//     //     <td style="padding:10px 16px;font-size:15px;font-weight:700;color:#111;">Total Qty</td>
//     //     <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">—</td>
//     //     <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">${totalItems.toLocaleString('en-US')}</td>
//     //     <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">$${fmt(grandTotal)}</td>
//     //   </tr>`);

//     // Descuento
//     if (discPct > 0) {
//       summaryRows.push(`
//         <tr style="border-bottom:1px solid #e5e7eb;">
//           <td style="padding:10px 16px;font-size:15px;color:#b45309;">Discount (${discPct}%)</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
//           <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#b45309;">-$${fmt(discAmount)}</td>
//         </tr>`);
//     }

//     // Estimated Total
//     summaryRows.push(`
//       <tr style="background:#686a6c;">
//         <td style="padding:0px 7px;font-size:17px;font-weight:700;color:#fff;">Estimated Total</td>
//         <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
//         <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
//         <td style="padding:14px 16px;text-align:right;font-size:18px;font-weight:800;color:#fff;">$${fmt(finalTotal)}</td>
//       </tr>`);

//     html += `
//       <div style="margin-top:24px;padding-top:16px;border-top:2px solid #e5e7eb;padding-bottom:40px;">
//         <div style="display:flex;align-items:center;gap:10px;margin-bottom:12px;">
//           <div style="width:4px;height:24px;background:#b8a77d;border-radius:2px;"></div>
//           <h3 style="margin:0;font-size:18px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;"></h3>
//         </div>
//         <div style="overflow-x:auto;border-radius:10px;border:1px solid #e5e7eb;overflow:hidden;max-width:550px;margin-left:auto;">
//           <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
//             <thead>
//               <tr style="background:#686a6c;">
//                 <th style="padding:10px 16px;text-align:left;font-size:16px;font-weight:600;color:#fff;">Category</th>
//                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Units/Pack</th>
//                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Qty</th>
//                 <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Amount</th>
//               </tr>
//             </thead>
//             <tbody>${summaryRows.join('')}</tbody>
//           </table>
//         </div>
//       </div>`;

//     if (!Object.keys(groupedRows).length) {
//       if (noMsg) noMsg.style.display = 'block';
//     } else {
//       content.innerHTML = html;
//       content.querySelectorAll('.detail-img-hover').forEach(img => {
//         img.addEventListener('mouseenter', e => {
//           skuPopup.querySelector('.sku-popup-img').src = img.src || '';
//           skuPopup.querySelector('.popup-description').textContent  = img.dataset.description || '';
//           skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(img.dataset.topNotes);
//           skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(img.dataset.middleNotes);
//           skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(img.dataset.baseNotes);
//           positionPopup(e); skuPopup.classList.add('visible');
//         });
//         img.addEventListener('mousemove', positionPopup);
//         img.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
//       });
//     }

//     getEl('dash-count-product').textContent    = uniqueProducts.size;
//     getEl('dash-unique-types').textContent     = uniqueCollections.size;
//     getEl('dash-total-items').textContent      = totalItems;
//     getEl('dash-total-incentives').textContent = totalIncentives;
//     getEl('dash-total-purchase').textContent   = '$' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
//     getEl('b2b-incentive-summary-panel').style.display = 'none';
//   }




function renderPurchaseDetails() {
    ensureSkuPopup();
    const content = getEl('b2b-details-content');
    const noMsg   = getEl('b2b-no-items-msg');
    if (!content) return;
    content.innerHTML = '';
    if (noMsg) noMsg.style.display = 'none';

    const uniqueProducts = new Set(), uniqueCollections = new Set();
    let totalItems = 0, grandTotal = 0;

    const tableStyle = 'width:100%;border-collapse:collapse;font-family:"Crimson Pro",serif;';
    const thStyle    = 'padding:9px 8px;text-align:center;font-size:17px;font-weight:600;color:#fff;';

    function getSelectionPrice(sel) {
      const metaP = parseFloat(sel.incentive_product_price || 0);
      if (metaP > 0) return metaP;
      const vid2    = String(sel.variant_id || '');
      const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
      const metaP2  = parseFloat(extras2.incentive_product_price || 0);
      if (metaP2 > 0) return metaP2;
      return parseFloat(sel.price || 0);
    }

    // ── Agrupar filas principales por presentación ──
    const groupedRows = {};
    const groupOrder  = [];

    variantRows().forEach(row => {
      const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (!qty) return;

      const sku        = (row.dataset.sku || '-').toUpperCase();
      const product    = row.cells[5]?.textContent?.trim() || 'Product';
      const ml         = row.cells[7]?.textContent?.trim() || 'N/A';
      const presDisp   = row.cells[8]?.textContent?.trim() || 'N/A';
      const presLower  = presDisp.toLowerCase();
      const collection = row.cells[4]?.textContent?.trim() || 'N/A';
      const unitPrice  = parseFloat(row.dataset.unitPrice || 0);
      const subtotal   = qty * unitPrice;
      const imgUrl     = row.dataset.imgUrl || '';
      const coeff      = row.cells[10]?.textContent?.trim() || 'N/A';

      let groupKey = 'Others';
      if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
      else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester') || presLower.includes('sample')) groupKey = 'Vials & Testers';
      else if (presLower.includes('retail'))                               groupKey = 'Retail';
      else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;

      if (!groupedRows[groupKey]) {
        groupedRows[groupKey] = { rows: [], subtotal: 0, qty: 0 };
        groupOrder.push(groupKey);
      }

      groupedRows[groupKey].subtotal += subtotal;
      groupedRows[groupKey].qty      += qty;
      groupedRows[groupKey].rows.push(`
        <tr style="border-bottom:1px solid #e5e7eb;">
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
            ${imgUrl
              ? `<img src="${imgUrl}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;cursor:pointer;"
                  class="detail-img-hover"
                  data-description="${row.dataset.description||''}"
                  data-top-notes="${row.dataset.topNotes||''}"
                  data-middle-notes="${row.dataset.middleNotes||''}"
                  data-base-notes="${row.dataset.baseNotes||''}"
                  onerror="this.style.display='none'">`
              : '<div style="width:52px;height:52px;border-radius:6px;background:#f3f4f6;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">📦</div>'}
          </td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:17px;font-weight:700;color:#111;">${product}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${sku}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${ml}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${presDisp}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${collection}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${coeff}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">$${subtotal.toLocaleString('en-US',{minimumFractionDigits:2,maximumFractionDigits:2})}</td>
        </tr>`);

      totalItems += qty;
      grandTotal += subtotal;
      uniqueProducts.add(product);
      uniqueCollections.add(collection);
    });

    // ── Filas de incentivos ──
    const freeRows     = [];
    const freeRowsData = [];
    const withOwnRule  = new Set();
    const colH         = getColHandle();
    const rulesRPD     = window.b2bCollectionIncentivesMap?.[colH] || [];

    function getFreeVariantInfo(variantId) {
      if (!variantId) return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
      const vid      = String(variantId);
      const freeRow  = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
      const extras2  = window.b2bVariantExtrasMap?.[vid] || {};
      const unitsPerPack = parseInt(extras2.quantity) || 0;
      if (freeRow) {
        return {
          sku:         (freeRow.dataset.sku || '').toUpperCase() || '—',
          ml:          freeRow.cells[7]?.textContent?.trim()  || '—',
          pres:        freeRow.cells[8]?.textContent?.trim()  || '—',
          collection:  freeRow.cells[4]?.textContent?.trim()  || '—',
          coefficient: freeRow.cells[10]?.textContent?.trim() || '—',
          unitsPerPack
        };
      }
      const v = window.b2bAllVariantsMap?.[vid];
      if (v) return {
        sku:         v.sku         || '—',
        ml:          v.ml          || '—',
        pres:        v.pres        || '—',
        collection:  v.collection  || '—',
        coefficient: v.coefficient || '—',
        unitsPerPack
      };
      return { sku:'—', ml:'—', pres:'—', collection:'—', coefficient:'—', unitsPerPack: 0 };
    }

    function addFreeRow(imgSrc, title, badge, badgeBg, subtitle, variantId, qty, extraCol = '—', overridePrice = null) {
      const info = getFreeVariantInfo(variantId);

      // ── Resolver pack desde múltiples fuentes ──
      const extras3     = window.b2bVariantExtrasMap?.[String(variantId)] || {};
      const packFromExt = parseInt(extras3.quantity) || 0;
      const packFromCol = extraCol !== '—' ? parseInt(extraCol) || 0 : 0;
      const packFromInf = parseInt(info.unitsPerPack) || 0;
      const pack        = packFromExt > 0 ? packFromExt
                        : packFromCol > 0 ? packFromCol
                        : packFromInf > 0 ? packFromInf : 1;

      const isVails = (info.pres || '').toLowerCase().includes('vial') || 
                (info.pres || '').toLowerCase().includes('vail');
      const packVal = pack > 1 ? pack : 1;
      const realQty = isVails ? (parseInt(qty) || 0) * packVal : (parseInt(qty) || 0);

      freeRowsData.push({ pres: info.pres, qty: realQty, pack: packVal, rawQty: parseInt(qty) || 0 });

      const packDisplay  = pack > 1 ? pack : (extraCol !== '—' ? extraCol : '—');
      const priceDisplay = overridePrice !== null ? `$${overridePrice}` : '$0.00';

      // ── Determinar grupo FOC: Vials, Testers u Others ──
      const presLowerFoc = (info.pres || '').toLowerCase();
      let focGroupKey = 'Others';
      if (presLowerFoc.includes('tester')) focGroupKey = 'Testers';
      else if (presLowerFoc.includes('vial') || presLowerFoc.includes('vail')) focGroupKey = 'Vials';

      freeRows.push({ groupKey: focGroupKey, qty: parseInt(qty) || 0, html: `
        <tr style="border-bottom:1px solid #e5e7eb;background:#fff;">
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;width:60px;">
            ${imgSrc
              ? `<img src="${imgSrc}" style="width:52px;height:52px;object-fit:cover;border-radius:6px;">`
              : '<div style="width:52px;height:52px;border-radius:6px;background:#dcfce7;display:inline-flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>'}
          </td>
          <td style="padding:10px 8px;vertical-align:middle;font-size:17px;font-weight:700;color:#111;text-align:center;">${title}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.sku}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.ml}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.pres}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;color:#374151;">${info.collection}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#374151;">${packDisplay}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;">${qty}</td>
          <td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#000;">${priceDisplay}</td>
        </tr>`});
    }

    // ── P1 variant incentives ──
    variantRows().forEach(row => {
      const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0) return;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      if (!variantHasIncentive(extras)) return;
      const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
      if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

      withOwnRule.add(row.dataset.variantId);
      const pName      = row.cells[5]?.textContent?.trim() || 'Product';
      const multiplier = calcVariantMultiplier(extras, qty, lineV);
      const fps        = getVariantFreeProducts(extras);
      const fqs        = getVariantFreeQtys(extras);
      const choice     = window.b2bVariantRewardChoices[row.dataset.variantId];
      const priorityNow = Number(window.b2bCollectionPriority || 1);

      if (fps.length > 1 && choice?.confirmed) {
        const img  = (choice.chosenImage || '').replace(/^\/\//, 'https://');
        const vid2 = choice.chosenVariantId;
        const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
        const up   = ex2.quantity > 0 ? ex2.quantity : '—';
        addFreeRow(img, choice.chosenTitle, 'FREE', '#16a34a', `${pName} Incentive — Your Choice`, vid2, choice.chosenQty, up);
   } else if (fps.length > 1 && !choice?.confirmed) {
        if (priorityNow !== 2 && priorityNow !== 4 && priorityNow !== 3) {
          freeRows.push({ groupKey: 'Pending', qty: 0, html: `
            <tr style="border-bottom:1px solid #fde68a;background:#fffbeb;">
              <td colspan="9" style="padding:12px 16px;">
                <div style="display:flex;align-items:center;gap:10px;">
                  <span style="font-size:20px;">⚠️</span>
                  <div>
                    <strong style="color:#92400e;">Free Gift Pending Selection</strong>
                    <span style="font-size:12px;color:#92400e;margin-left:8px;">${pName} — click Choose Gift to select</span>
                  </div>
                </div>
              </td>
            </tr>` });
        }
      } else {
        // ⚠️ FIX: en priority 2 y 3, este regalo ya se muestra vía p2choice/p3choice más abajo.
        // Si no bloqueamos acá, se duplica cuando fps.length === 1.
        if (priorityNow !== 2 && priorityNow !== 4 && priorityNow !== 3) {
          fps.forEach((fp, i) => {
            if (!fp?.title) return;
            const giftQty = (fqs[i] || 1) * multiplier;
            const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
            const vid2    = String(fp.variant_id || '');
            const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
            const up      = ex2.quantity > 0 ? ex2.quantity : '—';
            addFreeRow(img, fp.title, 'FREE', '#16a34a', `${pName} Incentive`, vid2, giftQty, up);
          });
        }
      }
    });

    // ── P2 ──
    const p2choice = window.b2bPriority2Choice || {};
    if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
      p2choice.selections.filter(sel => (sel.selectedQty || 0) > 0).forEach(sel => {
        const imgSrc   = (sel.image || '').replace(/^\/\//, 'https://');
        const vid      = String(sel.variant_id || '');
        const ex2      = window.b2bVariantExtrasMap?.[vid] || {};
        const up       = ex2.quantity > 0 ? ex2.quantity : '—';
        const price    = getSelectionPrice(sel);
        const discPct2 = parseFloat(p2choice.discountPct || 0);
        const final    = price * (1 - discPct2 / 100);
        const subtotal = parseFloat((final * sel.selectedQty).toFixed(2));
        addFreeRow(imgSrc, sel.title, `${discPct2}%`, '#2563eb', 'Reward Credit', vid, sel.selectedQty, up, subtotal);
      });
    }

    // ── P3 ──
    const p3choice = window.b2bPriority3Choice || {};
    if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
      p3choice.selections.forEach(sel => {
        (sel.choices || []).forEach(choice => {
          if (!choice.chosenQty || choice.chosenQty <= 0) return;
          const imgSrc = (choice.image || '').replace(/^\/\//, 'https://');
          const vid2   = String(choice.chosenVariantId || '');
          const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
          const up     = ex2.quantity > 0 ? ex2.quantity : '—';
          addFreeRow(imgSrc, choice.title, 'FREE', '#16a34a', `${sel.pName} — Your choice (P3)`, vid2, choice.chosenQty, up);
        });
      });
    }


        // ── Master FOC (manual, sin restricciones) ──
    if (window.b2bIsMasterUser) {
      Object.entries(window.b2bMasterFreeItems || {}).forEach(([vid2, qty]) => {
        qty = parseInt(qty) || 0;
        if (qty <= 0) return;
        const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
        const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
        const row2  = document.querySelector(`.b2b-variant-row[data-variant-id="${vid2}"]`);
        const img2  = row2 ? (row2.dataset.imgUrl || '') : '';
        const title2 = vd2.title || (row2 ? row2.cells[5]?.textContent?.trim() : '') || 'Product';
        const up2   = ex2.quantity > 0 ? ex2.quantity : '—';
        addFreeRow(img2, title2, 'FREE', '#7c3aed', 'Master FOC', vid2, qty, up2);
      });
    }

    // ── Collection rules ──
    let unitsCol = 0, valueCol = 0;
    variantRows().forEach(row => {
      const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0 || withOwnRule.has(row.dataset.variantId)) return;
      unitsCol += qty;
      valueCol += qty * parseFloat(row.dataset.unitPrice || 0);
    });

    const activeRPD = rulesRPD.length ? calcActiveIncentive(rulesRPD, unitsCol, valueCol) : null;
    if (activeRPD) {
      if (isAutoApply(activeRPD)) {
        (activeRPD.free_products || []).forEach((fp, i) => {
          if (!fp?.title) return;
          const giftQty = normalizeQtyArray(activeRPD.free_product_quantities)[i] || 1;
          const img     = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
          const vid2    = String(fp.variant_id || '');
          const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
          const up      = ex2.quantity > 0 ? ex2.quantity : '—';
          addFreeRow(img, fp.title, 'FREE', '#16a34a', 'Collection Incentive', vid2, giftQty, up);
        });
        (activeRPD.free_testers || []).forEach((tp, i) => {
          if (!tp?.title) return;
          const q    = getTesterQty(activeRPD, i);
          const img  = tp.image ? tp.image.replace(/^\/\//, 'https://') : '';
          const vid2 = String(tp.variant_id || '');
          const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
          const up   = ex2.quantity > 0 ? ex2.quantity : '—';
          addFreeRow(img, tp.title, 'TESTER', '#2563eb', 'Collection Incentive', vid2, q, up);
        });
      } else if (rewardChoice.confirmed) {
        const ct  = rewardChoice.chosenType;
        const img = (rewardChoice.chosenProductImage || '').replace(/^\/\//, 'https://');
        if (ct === 'tester' || ct === 'product') {
          const vid2 = rewardChoice.chosenVariantId;
          const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
          const up   = ex2.quantity > 0 ? ex2.quantity : '—';
          addFreeRow(img, rewardChoice.chosenProductTitle || ct, ct === 'tester' ? 'TESTER' : 'FREE', '#16a34a', 'Your chosen reward', vid2, rewardChoice.chosenQty || 1, up);
        }
      }
    }

    // ── Contar incentivos ──
    let totalIncentives = 0;
    variantRows().forEach(row => {
      const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0) return;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      if (!variantHasIncentive(extras)) return;
      const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
      if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
      const fps    = getVariantFreeProducts(extras);
      const fqs    = getVariantFreeQtys(extras);
      const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
      const priorityNow2 = Number(window.b2bCollectionPriority || 1);

      if (fps.length > 1 && choice?.confirmed) {
        totalIncentives += choice.chosenQty || 0;
      } else if (fps.length <= 1 && priorityNow2 !== 2 && priorityNow2 !== 4 && priorityNow2 !== 3) {
        // ⚠️ FIX: mismo criterio — no contar acá si priority 2/3 ya lo cuenta vía p2i/p3i más abajo
        fps.forEach((fp, i) => { totalIncentives += fqs[i] || 1; });
      }
    });
    const p2i = window.b2bPriority2Choice || {};
    if (p2i.confirmed && Array.isArray(p2i.selections)) {
      p2i.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => { totalIncentives += s.selectedQty; });
    }
    const p3i = window.b2bPriority3Choice || {};
    if (p3i.confirmed && Array.isArray(p3i.selections)) {
      p3i.selections.forEach(sel => {
        (sel.choices || []).forEach(c => { totalIncentives += c.chosenQty || 0; });
      });
    }

     // ── Master FOC ──
    if (window.b2bIsMasterUser) {
      Object.values(window.b2bMasterFreeItems || {}).forEach(q => {
        totalIncentives += parseInt(q) || 0;
      });
    }

    // ── Totales ──
    const p2       = window.b2bPriority2Choice || {};
    let p2Subtotal = 0;
    if (p2.confirmed && Array.isArray(p2.selections)) {
      p2.selections.filter(s => s.selectedQty > 0).forEach(s => {
        const price    = getSelectionPrice(s);
        const discPct2 = parseFloat(p2.discountPct || 0);
        p2Subtotal += price * (1 - discPct2 / 100) * s.selectedQty;
      });
    }
    const discPct    = rewardChoice?.discountPct || 0;
    const discAmount = discPct > 0 ? grandTotal * discPct / 100 : 0;
    const finalTotal = grandTotal - discAmount;
    const fmt = n => n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    // ── Construir HTML final ──
    let html = '';

    const tableHeader = `
      <thead>
        <tr style="background:#686a6c;">
          <th style="${thStyle}">Photo</th>
          <th style="${thStyle}">Product</th>
          <th style="${thStyle}">SKU</th>
          <th style="${thStyle}">ML</th>
          <th style="${thStyle}">Presentation</th>
          <th style="${thStyle}">Collection</th>
          <th style="${thStyle}">Coefficient</th>
          <th style="${thStyle}">Qty</th>
          <th style="${thStyle}">Total</th>
        </tr>
      </thead>`;

    const preferredOrder = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
    const sortedGroups   = [
      ...preferredOrder.filter(g => groupedRows[g]),
      ...groupOrder.filter(g => !preferredOrder.includes(g))
    ];

    const groupIcons = {
      'Perfumes':        '',
      'Vials & Testers': '',
      'Retail':          '',
      'Others':          ''
    };

    sortedGroups.forEach(groupKey => {
      const group = groupedRows[groupKey];
      if (!group?.rows?.length) return;
      const icon = groupIcons[groupKey] || '';

      html += `
        <div style="margin-bottom:28px;">
          <div style="display:flex;align-items:center;gap:10px;margin-bottom:10px;">
            <div style="width:4px;height:28px;background:#b8a77d;border-radius:2px;"></div>
            <span style="font-size:20px;">${icon}</span>
            <h3 style="margin:0;font-size:19px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;">${groupKey}</h3>
            <span style="background:#f3f4f6;color:#6b7280;font-size:13px;font-weight:600;padding:2px 10px;border-radius:99px;">
              ${group.rows.length} item${group.rows.length > 1 ? 's' : ''}
            </span>
          </div>
          <div style="overflow-x:auto;border-radius:8px;border:1px solid #e5e7eb;overflow:hidden;">
            <table style="${tableStyle}">
              ${tableHeader}
              <tbody>${group.rows.join('')}</tbody>
              <tfoot>
                <tr style="border-top:2px solid #b8a77d;">
                  <td colspan="7" style="padding:10px 8px;"></td>
                  <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">${group.qty}</td>
                  <td style="padding:10px 8px;text-align:center;font-size:15px;font-weight:700;color:#1f2937;">$${fmt(group.subtotal)}</td>
                </tr>
              </tfoot>
            </table>
          </div>
        </div>`;
    });

    // ── Sección Incentives Included ──
    // if (freeRows.length) {
    //   html += `
    //     <div style="margin-top:16px;overflow-x:auto;">
    //       <div class="b2b-free-gifts-header">Foc</div>
    //       <table style="${tableStyle}">
    //         <thead>
    //           <tr style="background:#686a6c;">
    //             <th style="${thStyle}">Photo</th>
    //             <th style="${thStyle}">Product</th>
    //             <th style="${thStyle}">SKU</th>
    //             <th style="${thStyle}">ML</th>
    //             <th style="${thStyle}">Presentation</th>
    //             <th style="${thStyle}">Collection</th>
    //             <th style="${thStyle}">Units/Pack</th>
    //             <th style="${thStyle}">Qty</th>
    //             <th style="${thStyle}">Total</th>
    //           </tr>
    //         </thead>
    //         <tbody>${freeRows.join('')}</tbody>
    //       </table>
    //     </div>`;
    // }

    // ── Sección Incentives Included (separado por Vials / Testers / Others) ──
    if (freeRows.length) {
      const focGroups     = {};
      const focGroupOrder = [];

      freeRows.forEach(item => {
        if (!focGroups[item.groupKey]) {
          focGroups[item.groupKey] = { rows: [], qty: 0 };
          focGroupOrder.push(item.groupKey);
        }
        focGroups[item.groupKey].rows.push(item.html);
        focGroups[item.groupKey].qty += item.qty;
      });

      const focLabels = { Vials: 'FOC — Vials', Testers: 'FOC — Testers', Others: 'FOC — Others', Pending: 'FOC — Pending Selection' };
      const focPreferredOrder = ['Vials', 'Testers', 'Others', 'Pending'];
      const focSortedGroups = [
        ...focPreferredOrder.filter(g => focGroups[g]),
        ...focGroupOrder.filter(g => !focPreferredOrder.includes(g))
      ];

      focSortedGroups.forEach(groupKey => {
        const group = focGroups[groupKey];
        if (!group?.rows?.length) return;

        html += `
          <div style="margin-top:16px;overflow-x:auto;">
            <div class="b2b-free-gifts-header">${focLabels[groupKey] || `FOC — ${groupKey}`}</div>
            <table style="${tableStyle}">
              <thead>
                <tr style="background:#686a6c;">
                  <th style="${thStyle}">Photo</th>
                  <th style="${thStyle}">Product</th>
                  <th style="${thStyle}">SKU</th>
                  <th style="${thStyle}">ML</th>
                  <th style="${thStyle}">Presentation</th>
                  <th style="${thStyle}">Collection</th>
                  <th style="${thStyle}">Units/Pack</th>
                  <th style="${thStyle}">Qty</th>
                  <th style="${thStyle}">Total</th>
                </tr>
              </thead>
              <tbody>${group.rows.join('')}</tbody>
            </table>
          </div>`;
      });
    }

    // ── Breakdown GWP por presentación ──
    const incentiveByPres = {};
    const packByPres      = {};
    freeRowsData.forEach(item => {
      const key  = item.pres && item.pres !== '—' ? item.pres : 'Other';
      const pack = parseInt(item.pack) || 1;
      incentiveByPres[key] = (incentiveByPres[key] || 0) + item.qty;
      if (!packByPres[key]) packByPres[key] = pack;
    });

    const totalIncentiveQty = totalIncentives;

    // ── Order Summary ──
    const summaryRows = [];

    if (totalIncentiveQty > 0) {
      Object.entries(incentiveByPres).forEach(([pres, qty]) => {
        const packVal = (packByPres[pres] && packByPres[pres] > 1) ? packByPres[pres] : '—';
        summaryRows.push(`
          <tr style="border-bottom:1px solid #f3f4f6;">
            <td style="padding:10px 16px;font-size:15px;color:#374151;">FOC ${pres}</td>
            <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${packVal}</td>
            <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${qty}</td>
            <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
          </tr>`);
      });
      summaryRows.push(`
        <tr style="border-bottom:2px solid #e5e7eb;background:#f9fafb;">
          <td style="padding:10px 16px;font-size:15px;font-weight:700;color:#111;">Total FOC</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">—</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">${totalIncentiveQty}</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#111;">$0.00</td>
        </tr>`);
    }

    const preferredSummary = ['Perfumes', 'Vials & Testers', 'Retail', 'Others'];
    const allSummaryGroups = [
      ...preferredSummary.filter(g => groupedRows[g]),
      ...groupOrder.filter(g => !preferredSummary.includes(g) && groupedRows[g])
    ];

    allSummaryGroups.forEach(groupKey => {
      const group = groupedRows[groupKey];
      if (!group?.qty) return;
      const icon = groupIcons[groupKey] || '';
      summaryRows.push(`
        <tr style="border-bottom:1px solid #f3f4f6;">
          <td style="padding:10px 16px;font-size:15px;color:#374151;">${icon} ${groupKey}</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">—</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">${group.qty}</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;color:#374151;">$${fmt(group.subtotal)}</td>
        </tr>`);
    });

    if (discPct > 0) {
      summaryRows.push(`
        <tr style="border-bottom:1px solid #e5e7eb;">
          <td style="padding:10px 16px;font-size:15px;color:#b45309;">Discount (${discPct}%)</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;color:#b45309;">—</td>
          <td style="padding:10px 16px;text-align:right;font-size:15px;font-weight:700;color:#b45309;">-$${fmt(discAmount)}</td>
        </tr>`);
    }

    summaryRows.push(`
      <tr style="background:#686a6c;">
        <td style="padding:0px 7px;font-size:17px;font-weight:700;color:#fff;">Estimated Total</td>
        <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
        <td style="padding:14px 16px;text-align:right;font-size:17px;color:#fff;"></td>
        <td style="padding:14px 16px;text-align:right;font-size:18px;font-weight:800;color:#fff;">$${fmt(finalTotal)}</td>
      </tr>`);

    html += `
      <div style="margin-top:24px;padding-top:16px;border-top:2px solid #e5e7eb;padding-bottom:40px;">
        <div style="display:flex;align-items:center;gap:10px;margin-bottom:12px;">
          <div style="width:4px;height:24px;background:#b8a77d;border-radius:2px;"></div>
          <h3 style="margin:0;font-size:18px;font-weight:700;color:#1f2937;font-family:'Crimson Pro',serif;"></h3>
        </div>
        <div style="overflow-x:auto;border-radius:10px;border:1px solid #e5e7eb;overflow:hidden;max-width:550px;margin-left:auto;">
          <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
            <thead>
              <tr style="background:#686a6c;">
                <th style="padding:10px 16px;text-align:left;font-size:16px;font-weight:600;color:#fff;">Category</th>
                <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Units/Pack</th>
                <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Qty</th>
                <th style="padding:10px 16px;text-align:right;font-size:16px;font-weight:600;color:#fff;">Amount</th>
              </tr>
            </thead>
            <tbody>${summaryRows.join('')}</tbody>
          </table>
        </div>
      </div>`;

    if (!Object.keys(groupedRows).length) {
      if (noMsg) noMsg.style.display = 'block';
    } else {
      content.innerHTML = html;
      content.querySelectorAll('.detail-img-hover').forEach(img => {
        img.addEventListener('mouseenter', e => {
          skuPopup.querySelector('.sku-popup-img').src = img.src || '';
          skuPopup.querySelector('.popup-description').textContent  = img.dataset.description || '';
          skuPopup.querySelector('.top-notes-val').textContent    = parseNotes(img.dataset.topNotes);
          skuPopup.querySelector('.middle-notes-val').textContent = parseNotes(img.dataset.middleNotes);
          skuPopup.querySelector('.base-notes-val').textContent   = parseNotes(img.dataset.baseNotes);
          positionPopup(e); skuPopup.classList.add('visible');
        });
        img.addEventListener('mousemove', positionPopup);
        img.addEventListener('mouseleave', () => skuPopup.classList.remove('visible'));
      });
    }

    getEl('dash-count-product').textContent    = uniqueProducts.size;
    getEl('dash-unique-types').textContent     = uniqueCollections.size;
    getEl('dash-total-items').textContent      = totalItems;
    getEl('dash-total-incentives').textContent = totalIncentives;
    getEl('dash-total-purchase').textContent   = '$' + grandTotal.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    getEl('b2b-incentive-summary-panel').style.display = 'none';
  }

/* ============================================================
   MODALES DE VALIDACIÓN
   ============================================================ */

function showMinQtyModal() {
  const violations = [];
  variantRows().forEach(row => {
    if (row.style.display === 'none') return;
    const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (qty <= 0) return;
    const minQty = parseInt(row.dataset.minQty || 1);
    if (qty >= minQty) return;
    violations.push({
      productName: row.cells[5]?.textContent.trim() || 'Product',
      sku: (row.dataset.sku || '-').toUpperCase(),
      ml: row.cells[7]?.textContent.trim() || '',
      qty, minQty
    });
  });
  if (!violations.length) return false;
  getEl('min-qty-modal-list').innerHTML = violations.map(v =>
    `<div style="background:#fef2f2;border:1px solid #fecaca;border-radius:8px;padding:12px 16px;">
      <div style="font-weight:700;color:#111;margin-bottom:4px;">${v.productName}</div>
      <div style="font-size:14px;color:#555;">SKU: ${v.sku}${v.ml ? ' | ' + v.ml : ''}</div>
      <div style="margin-top:6px;font-size:16px;display:flex;gap:16px;flex-wrap:wrap;">
        <span style="color:#000;font-weight:600;">You have: ${v.qty}</span>
        <span style="color:#16a34a;font-weight:600;">Minimum: ${v.minQty}</span>
        <span style="color:#2563eb;font-weight:600;">Need ${v.minQty - v.qty} more</span>
      </div>
    </div>`
  ).join('');
  getEl('min-qty-modal').style.display = 'flex';
  return true;
}

function showSellLimitModal(limit, productName) {
  const modal = getEl('sell-limit-modal');
  const text  = getEl('sell-limit-modal-text');
  if (!modal || !text) return;
  text.innerHTML = `You are only allowed to purchase up to <strong>${limit}</strong> unit${limit > 1 ? 's' : ''}` +
    (productName ? ` of <strong>${productName}</strong>` : '') + `.`;
  modal.style.display = 'flex';
}

function showMasterOrderCreatedModal(data) {
  const overlay = getEl('b2b-processing-overlay') || (() => {
    const el = document.createElement('div');
    el.id = 'b2b-processing-overlay';
    el.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;';
    document.body.appendChild(el);
    return el;
  })();

  const ctx     = window.b2bMasterOrderContext || {};
  const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
  const total   = data.totalAmount
    ? parseFloat(data.totalAmount).toLocaleString('en-US', { style: 'currency', currency: data.currency || 'USD' })
    : '';

  overlay.innerHTML = `
    <div style="background:white;border-radius:16px;padding:32px 40px;text-align:center;
                box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;
                max-width:460px;width:90%;">
      <img src="${logoUrl}" alt="Logo"
        style="width:120px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
        onerror="this.style.display='none'">
      <div style="width:64px;height:64px;border-radius:50%;background:#f5f3ee;
                  display:flex;align-items:center;justify-content:center;
                  margin:0 auto 16px;font-size:32px;color:#b8a77d;">✓</div>
      <div style="font-size:1.4rem;font-weight:700;color:#b8a77d;margin-bottom:6px;">
        Order created in Drafts
      </div>
      <div style="font-size:1.6rem;font-weight:800;color:#1f2937;margin-bottom:14px;">
        ${data.draftOrderName || ''}
      </div>
      <div style="font-size:15px;color:#6b7280;line-height:1.7;margin-bottom:20px;text-align:left;background:#f9fafb;border-radius:10px;padding:14px 16px;">
        <div><strong>Company:</strong> ${ctx.companyName || '—'}</div>
        <div><strong>Customer:</strong> ${ctx.customerName || '—'}</div>
        ${total ? `<div><strong>Total:</strong> ${total}</div>` : ''}
      </div>
      <button type="button" id="master-order-created-ok"
        style="padding:11px 32px;background:#1f2937;color:#fff;border:none;
              border-radius:8px;font-size:15px;font-weight:600;cursor:pointer;
              font-family:'Crimson Pro',serif;width:100%;">
        OK
      </button>
    </div>`;

  overlay.style.display = 'flex';

  getEl('master-order-created-ok').addEventListener('click', () => {
    overlay.style.display = 'none';
    resetMasterOrderAfterSuccess();
  });
}

function resetMasterOrderAfterSuccess() {
  // Reset de cantidades y filtros: reutiliza el handler del botón Clear
  getEl('reset-btn')?.click();

  // Limpiar FOC manuales
  window.b2bMasterFreeItems = {};

  // Limpiar selección de company/customer
  window.b2bMasterOrderContext = {
    companyId: null, companyName: null, companyContactId: null,
    companyLocationId: null, customerId: null, customerName: null, customerEmail: null
  };
  const companySel  = getEl('master-company-select');
  const customerSel = getEl('master-customer-select');
  if (companySel)  companySel.value = '';
  if (customerSel) { customerSel.innerHTML = '<option value="">Select a company first</option>'; customerSel.disabled = true; }

  updateMasterOrderBadge();
  updateMasterOrderLock();
  applyFreeProductStockDeductions();
  updateTotals();
  unlockUI();
}

function showBrandMinQtyModal() {
  const brandMin = parseInt(window.b2bBrandMinQty || 0);
  if (brandMin <= 0) return false;
  let totalUnits = 0;
  variantRows().forEach(row => {
    if (row.style.display === 'none') return;
    totalUnits += parseInt(row.querySelector('.hidden-qty')?.value) || 0;
  });
  if (totalUnits >= brandMin) return false;
  getEl('brand-min-qty-modal-body').innerHTML = `
    <div style="font-size:16px;color:#111;margin-bottom:8px;"><strong>This brand requires a minimum of ${brandMin} units</strong></div>
    <div style="font-size:16px;display:flex;gap:20px;flex-wrap:wrap;margin-top:8px;">
      <span style="color:#000;font-weight:600;">You have: ${totalUnits}</span>
      <span style="color:#2563eb;font-weight:600;">Need ${brandMin - totalUnits} more</span>
    </div>`;
  getEl('brand-min-qty-modal').style.display = 'flex';
  return true;
}

function showBrandMinValueModal() {
  const minValue = parseFloat(window.b2bBrandMinValue || 0);
  if (minValue <= 0) return false;
  let totalValue = 0;
  variantRows().forEach(row => {
    if (row.style.display === 'none') return;
    totalValue += (parseInt(row.querySelector('.hidden-qty')?.value) || 0) * parseFloat(row.dataset.unitPrice || 0);
  });
  if (totalValue >= minValue) return false;
  getEl('brand-min-value-modal-body').innerHTML = `
    <div style="font-size:16px;color:#111;margin-bottom:8px;"><strong>Minimum order value: $${minValue.toFixed(2)}</strong></div>
    <div style="font-size:16px;display:flex;gap:20px;flex-wrap:wrap;margin-top:8px;">
      <span style="color:#000;font-weight:600;">Your total: $${totalValue.toFixed(2)}</span>
      <span style="color:#2563eb;font-weight:600;">Need $${(minValue - totalValue).toFixed(2)} more</span>
    </div>`;
  getEl('brand-min-value-modal').style.display = 'flex';
  return true;
}

/* ============================================================
   COMBOBOX MULTISELECT
   ============================================================ */

class B2BCombo {
  constructor(root) {
    this.root   = root;
    this.select = root.querySelector('select[multiple]');
    this.btn    = root.querySelector('.b2b-toggle');
    this.label  = root.querySelector('.b2b-label');
    this.panel  = root.querySelector('.b2b-panel');
    this.search = root.querySelector('.b2b-search');
    this.list   = root.querySelector('.b2b-options');
    this.btnApply = root.querySelector('.apply');
    this.btnClear = root.querySelector('.clear');
    this.btnAll   = root.querySelector('.select-all');
    this._bind(); this._render(''); this._updateLabel();
  }

  _bind() {
    this.btn.addEventListener('click', () => {
      const open = this.root.getAttribute('aria-expanded') === 'true';
      document.querySelectorAll('.b2b-combo[aria-expanded="true"]').forEach(el => {
        if (el !== this.root) el.setAttribute('aria-expanded', 'false');
      });
      this.root.setAttribute('aria-expanded', open ? 'false' : 'true');
      if (!open) {
        setTimeout(() => {
          const rect = this.btn.getBoundingClientRect();
          this.panel.style.position = 'fixed';
          this.panel.style.top  = (rect.bottom + 4) + 'px';
          this.panel.style.left = rect.left + 'px';
          this.panel.style.width = Math.max(rect.width, 300) + 'px';
          this.panel.style.zIndex = '99999';
          this.search.focus();
        }, 0);
      }
    });
    document.addEventListener('click', e => { if (!this.root.contains(e.target)) this.root.setAttribute('aria-expanded', 'false'); });
    this.root.addEventListener('keydown', e => { if (e.key === 'Escape') this.root.setAttribute('aria-expanded', 'false'); });
    this.search.addEventListener('input', e => this._render(e.target.value.trim().toLowerCase()));
    this.btnClear.addEventListener('click', () => { Array.from(this.select.options).forEach(o => o.selected = false); this._render(this.search.value.trim().toLowerCase()); this._updateLabel(); });
    this.btnAll.addEventListener('click', () => { Array.from(this.select.options).forEach(o => o.selected = true); this._render(this.search.value.trim().toLowerCase()); this._updateLabel(); });
    this.btnApply.addEventListener('click', () => { this._updateLabel(); this.root.setAttribute('aria-expanded', 'false'); b2bApplyFilters(); });
    this.select.addEventListener('change', () => { this._render(this.search.value.trim().toLowerCase()); this._updateLabel(); });
  }

  _render(query) {
    this.list.innerHTML = '';
    let count = 0;
    Array.from(this.select.options).forEach(opt => {
      const label = opt.text || opt.value;
      if (query && !label.toLowerCase().includes(query)) return;
      const row = document.createElement('label'); row.className = 'b2b-opt';
      const chk = document.createElement('input'); chk.type = 'checkbox'; chk.checked = opt.selected;
      chk.addEventListener('change', () => { opt.selected = chk.checked; });
      const span = document.createElement('span'); span.textContent = label;
      row.appendChild(chk); row.appendChild(span); this.list.appendChild(row); count++;
    });
    this.list.classList.toggle('empty', count === 0);
  }

  _updateLabel() {
    const selected = Array.from(this.select.selectedOptions || []);
    if (!selected.length) { this.label.textContent = 'All'; return; }
    const labels  = selected.map(o => o.text);
    const preview = labels.slice(0, 2).join(', ');
    this.label.textContent = labels.length > 2 ? `${preview} +${labels.length - 2}` : preview;
  }
}

let B2B_COMBOS = [];

/* ============================================================
   BUILD FILTER OPTIONS
   ── type, coefficient y msrp se leen desde extras (variante)
      con fallback a notes (producto)
   ============================================================ */

function b2bBuildFilterOptions() {
  // P4: las filas Tester/Vial ocultas no aparecen en las opciones de los filtros
  const rows = variantRows().filter(r => !r.classList.contains('b2b-row-hidden-tv'));
  const S = {
    stock: new Map(), collection: new Map(), perfume: new Map(),
    type: new Map(), ml: new Map(), presentation: new Map(),
    msrp: new Map(), wholesale: new Map(),
    coefficient: new Map(), references: new Map()
  };

  rows.forEach(r => {
    const handle = r.dataset.handle || '';
    const notes  = window.b2bNotesMap?.[handle] || {};
    const extras = window.b2bVariantExtrasMap?.[r.dataset.variantId] || {};

    // ── Campos resueltos desde variante con fallback a producto ──
    const typeVal        = getTypeVal(extras, notes);
    // const coefficientVal = getCoefficientVal(extras, notes);
    const coefficientVal = r.cells[10]?.textContent?.trim() || 'N/A';
    // const msrpVal        = getMsrpVal(extras, notes);
    const msrpVal        = r.dataset.msrp || '0';

    const vStock = r.dataset.stock || '0';
    if (vStock) S.stock.set(vStock, r.cells[3]?.textContent?.trim() || '0');

    const vColl = normalize(r.dataset.collection || r.cells[4]?.textContent);
    const vPerf = normalize(r.dataset.perfume    || r.cells[5]?.textContent);
    const vType = normalize(typeVal);
    const vML   = normalize(r.dataset.ml         || r.cells[7]?.textContent);
    const vPres = normalize(r.dataset.presentation || r.cells[8]?.textContent);

    if (vColl) S.collection.set(vColl, r.cells[4]?.textContent?.trim() || '');
    if (vPerf) S.perfume.set(vPerf,    r.cells[5]?.textContent?.trim() || '');
    if (vType && vType !== 'n/a') S.type.set(vType, typeVal || '');
    if (vML   && vML   !== 'n/a') S.ml.set(vML,    r.cells[7]?.textContent?.trim() || '');
    if (vPres && vPres !== 'n/a') S.presentation.set(vPres, r.cells[8]?.textContent?.trim() || '');

    const mC = toCents(msrpVal);
    const wC = toCents(r.dataset.wholesale || '0');
    if (mC > 0) S.msrp.set(String(mC),     r.cells[11]?.textContent?.trim() || '');
    if (wC > 0) S.wholesale.set(String(wC), r.cells[12]?.textContent?.trim() || '');

    if (coefficientVal && coefficientVal !== 'N/A') S.coefficient.set(String(coefficientVal), String(coefficientVal));
    if (notes.references) S.references.set(String(notes.references), String(notes.references));
  });

  const toOptions = (map, numeric = false) => {
    const arr = Array.from(map, ([value, label]) => ({ value, label }));
    return numeric
      ? arr.sort((a, b) => parseInt(a.value, 10) - parseInt(b.value, 10))
      : arr.sort((a, b) => a.label.localeCompare(b.label, undefined, { numeric: true, sensitivity: 'base' }));
  };

  const fill = (id, options) => {
    const sel = getEl('b2b-filter-' + id);
    if (sel) sel.innerHTML = options.map(o => `<option value="${o.value}">${o.label}</option>`).join('');
  };

  fill('stock',        toOptions(S.stock, true));
  fill('collection',   toOptions(S.collection));
  fill('perfume',      toOptions(S.perfume));
  fill('type',         toOptions(S.type));
  fill('ml',           toOptions(S.ml, true));
  fill('presentation', toOptions(S.presentation));
  fill('msrp',         toOptions(S.msrp, true));
  fill('wholesale',    toOptions(S.wholesale, true));
  fill('coefficient',  toOptions(S.coefficient, true));
  fill('references',   toOptions(S.references, true));
}

function b2bInitCombos() {
  B2B_COMBOS = qsa('.b2b-combo').map(c => new B2BCombo(c));
}

function getSelected(id) {
  const sel = getEl('b2b-filter-' + id);
  return sel ? Array.from(sel.selectedOptions).map(o => o.value) : [];
}

/* ============================================================
   APPLY FILTERS
   ── type, coefficient y msrp comparan contra extras/variante
   ============================================================ */

function b2bApplyFilters() {
  const sel = {
    stock: getSelected('stock'), collection: getSelected('collection'),
    perfume: getSelected('perfume'), type: getSelected('type'),
    ml: getSelected('ml'), presentation: getSelected('presentation'),
    msrp: getSelected('msrp'), wholesale: getSelected('wholesale'),
    coefficient: getSelected('coefficient'),
    references: getSelected('references')
  };

  variantRows().forEach(r => {
    const handle = r.dataset.handle || '';
    const notes  = window.b2bNotesMap?.[handle] || {};
    const extras = window.b2bVariantExtrasMap?.[r.dataset.variantId] || {};

    // ── Resolver valores reales para filtrar ──
    const typeVal        = getTypeVal(extras, notes);
    // const coefficientVal = getCoefficientVal(extras, notes);
    // const msrpVal        = getMsrpVal(extras, notes);
    const coefficientVal = r.cells[10]?.textContent?.trim() || 'N/A';
    const msrpVal        = r.dataset.msrp || '0';

    const mC = String(toCents(msrpVal));
    const wC = String(toCents(r.dataset.wholesale || '0'));

    const visible =
      (!sel.stock.length        || sel.stock.includes(r.dataset.stock)) &&
      (!sel.collection.length   || sel.collection.includes(normalize(r.dataset.collection || r.cells[4]?.textContent))) &&
      (!sel.perfume.length      || sel.perfume.includes(normalize(r.dataset.perfume || r.cells[5]?.textContent))) &&
      (!sel.type.length         || sel.type.includes(normalize(typeVal))) &&
      (!sel.ml.length           || sel.ml.includes(normalize(r.dataset.ml || r.cells[7]?.textContent))) &&
      (!sel.presentation.length || sel.presentation.includes(normalize(r.dataset.presentation || r.cells[8]?.textContent))) &&
      (!sel.msrp.length         || sel.msrp.includes(mC)) &&
      (!sel.wholesale.length    || sel.wholesale.includes(wC)) &&
      (!sel.coefficient.length  || sel.coefficient.includes(String(coefficientVal))) &&
      (!sel.references.length   || sel.references.includes(String(notes.references || '')));

    r.style.display = visible ? '' : 'none';
    r.dataset.filteredOut = visible ? 'false' : 'true';
  });
}

/* ============================================================
   SEARCH
   ============================================================ */

function initSearch() {
  const searchInput = getEl('b2b-search-input');
  const clearBtn    = getEl('b2b-search-clear');

  function applySearch() {
    const query = searchInput.value.trim().toLowerCase();
    clearBtn.style.display = query ? 'block' : 'none';
    variantRows().forEach(row => {
      if (!query) { row.style.display = ''; return; }
      const texts = [row.dataset.sku, row.dataset.perfume, row.dataset.type, row.dataset.ml, row.dataset.collection].join(' ');
      row.style.display = texts.includes(query) ? '' : 'none';
    });
    updateTotals();
  }

  searchInput.addEventListener('input', applySearch);
  clearBtn.addEventListener('click', () => { searchInput.value = ''; applySearch(); searchInput.focus(); });
}

/* ============================================================
   SORT
   ============================================================ */

function initSort() {
  document.querySelectorAll('.sortable').forEach(th => {
    th.addEventListener('click', () => {
      const tbody = th.closest('table').querySelector('tbody');
      const rows  = Array.from(tbody.querySelectorAll('tr.b2b-variant-row'));
      const index = Array.from(th.parentElement.children).indexOf(th);
      const dir   = th.classList.contains('asc') ? 'desc' : 'asc';
      document.querySelectorAll('.sortable').forEach(h => h.classList.remove('asc', 'desc'));
      th.classList.add(dir);
      rows.sort((a, b) => {
        let aV = a.children[index]?.textContent.trim().toLowerCase() || '';
        let bV = b.children[index]?.textContent.trim().toLowerCase() || '';
        if (['stock', 'msrp', 'wholesale', 'ranking', 'coefficient'].includes(th.dataset.column)) {
          aV = parseFloat(aV) || 0; bV = parseFloat(bV) || 0;
        }
        return dir === 'asc' ? (aV > bV ? 1 : -1) : (aV < bV ? 1 : -1);
      });
      rows.forEach(row => tbody.appendChild(row));
    });
  });
}

/* ============================================================
   PRESENTATION FILTER
   ============================================================ */

function initPresentationFilter() {
  const filterBtn = getEl('presentation-btn');
  const dropdown  = getEl('presentation-dropdown');
  if (!filterBtn || !dropdown) return;

  const options = dropdown.querySelectorAll('.b2b-filter-option');
  let currentFilter = 'all';

  function applyPresentationFilter() {
    variantRows().forEach(row => {
      const visible = currentFilter === 'all' || row.dataset.presentation.includes(currentFilter);
      row.style.display = visible ? '' : 'none';
      row.dataset.filteredOut = visible ? 'false' : 'true';
    });
    const searchInput = getEl('b2b-search-input');
    if (searchInput?.value.trim()) {
      const query = searchInput.value.trim().toLowerCase();
      variantRows().forEach(row => {
        if (row.style.display === 'none') return;
        const texts = [row.dataset.sku, row.dataset.perfume, row.dataset.type, row.dataset.ml, row.dataset.collection].join(' ');
        if (!texts.includes(query)) row.style.display = 'none';
      });
    }
    updateTotals();
  }

  filterBtn.addEventListener('click', () => dropdown.classList.toggle('show'));
  options.forEach(opt => {
    opt.addEventListener('click', () => {
      options.forEach(o => o.classList.remove('selected'));
      opt.classList.add('selected');
      currentFilter = opt.dataset.value;
      filterBtn.firstChild.textContent = opt.textContent.trim() + ' ';
      dropdown.classList.remove('show');
      applyPresentationFilter();
    });
  });
  document.addEventListener('click', e => {
    if (!filterBtn.contains(e.target) && !dropdown.contains(e.target)) dropdown.classList.remove('show');
  });

  window._applyPresentationFilter = applyPresentationFilter;
  applyPresentationFilter();
}

/* ============================================================
   VIEW / HIDE DETAILS PANEL
   ============================================================ */

function initDetailsPanel() {
  const viewBtn = getEl('b2b-view-details-btn');
  const hideBtn = getEl('b2b-hide-details-btn');
  const panel   = getEl('b2b-details-panel');
  if (!viewBtn || !hideBtn || !panel) return;

  // ── Elementos del footer a ocultar (excepto el panel) ──
  function setFooterItemsVisibility(visible) {
    const display = visible ? '' : 'none';
    const ids = ['b2b-buy-btn', 'b2b-view-details-btn', 'b2b-choose-reward-btn',
                 'b2b-incentive-banner', 'b2b-variant-incentive-banner', 'b2b-incentive-next'];
    ids.forEach(id => {
      const el = getEl(id);
      if (el) el.style.display = display;
    });
    // Ocultar summary info y boton container
    document.querySelectorAll('.b2b-summary-main').forEach(el => {
      el.style.display = visible ? '' : 'none';
    });
  }

  viewBtn.addEventListener('click', () => {
    if (showMinQtyModal() || showBrandMinQtyModal() || showBrandMinValueModal()) return;
    panel.classList.add('expanded');
    setFooterItemsVisibility(false);
    renderPurchaseDetails();
  });

  hideBtn.addEventListener('click', () => {
    panel.classList.remove('expanded');
    setFooterItemsVisibility(true);
    updateIncentiveBanners();
  });

  // ── Hide Order bottom ──
  getEl('b2b-hide-details-btn-bottom')?.addEventListener('click', () => {
    panel.classList.remove('expanded');
    setFooterItemsVisibility(true);
    updateIncentiveBanners();
  });
}

/* ============================================================
   EXPORT EXCEL — PRE ORDERS
   ============================================================ */

function initExcelExport() {
  const btn = getEl('export-excel-btn');
  if (!btn || btn.dataset.listenerAttached) return;

  btn.onclick = () => {
    const vendor  = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const headers = ['SKU','Product','Collection','Type','ML','Presentation','MSRP','Wholesale Price','Qty','Subtotal'];
    const data    = [headers];

    // ── Items principales ──
    variantRows().forEach(row => {
      const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (!qty) return;
      const unitPrice = parseFloat(row.dataset.unitPrice || 0);
      data.push([
        (row.dataset.sku || '-').toUpperCase(),
        row.cells[5]?.textContent?.trim() || '',
        row.cells[4]?.textContent?.trim() || '',
        row.cells[6]?.textContent?.trim() || '',
        row.cells[7]?.textContent?.trim() || '',
        row.cells[8]?.textContent?.trim() || '',
        row.cells[11]?.textContent?.trim() || '',
        unitPrice, qty,
        qty * unitPrice
      ]);
    });

    let grandTotal = 0;
    variantRows().forEach(row => {
      const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      grandTotal += qty * parseFloat(row.dataset.unitPrice || 0);
    });

    // ── Free gifts prioridad 1: collection rules ──
    const colHandle = getColHandle();
    const rules     = window.b2bCollectionIncentivesMap?.[colHandle] || [];
    let totalUnits  = 0;
    variantRows().forEach(row => {
      totalUnits += parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    });
    const active = rules.length ? calcActiveIncentive(rules, totalUnits, grandTotal) : null;
    if (active) {
      (active.free_products || []).forEach((fp, i) => {
        if (!fp?.title) return;
        const qty = normalizeQtyArray(active.free_product_quantities)[i] || 1;
        data.push(['-', fp.title + (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ' — ' + fp.variant_title : ''), '', '', '', '', '', 0, qty, 0]);
      });
      (active.free_testers || []).forEach((tp, i) => {
        if (!tp?.title) return;
        const qty = getTesterQty(active, i);
        data.push(['-', tp.title + ' (Tester)', '', '', '', '', '', 0, qty, 0]);
      });
    }

    // ── Free gifts prioridad 1: por variante ──
    variantRows().forEach(row => {
      const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0) return;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      if (!variantHasIncentive(extras)) return;
      const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
      if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

      const fps  = getVariantFreeProducts(extras);
      const fqs  = getVariantFreeQtys(extras);
      const mult = calcVariantMultiplier(extras, qty, lineV);
      const pName = row.cells[5]?.textContent?.trim() || '';

      const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
      if (fps.length > 1 && choice?.confirmed) {
        data.push(['-', choice.chosenTitle + ' (Free — ' + pName + ' incentive)', '', '', '', '', '', 0, choice.chosenQty, 0]);
      } else if (fps.length === 1) {
        fps.forEach((fp, i) => {
          if (!fp?.title) return;
          const giftQty = (fqs[i] || 1) * mult;
          const fpVar   = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ' — ' + fp.variant_title : '';
          data.push(['-', fp.title + fpVar + ' (Free — ' + pName + ' incentive)', '', '', '', '', '', 0, giftQty, 0]);
        });
      }
    });

    // ── Free gifts prioridad 2 ──
    const p2 = window.b2bPriority2Choice || {};
    if (p2.confirmed && Array.isArray(p2.selections)) {
      p2.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => {
        const vid    = String(s.variant_id || '');
        const vd     = window.b2bAllVariantsMap?.[vid] || {};
        const metaP  = parseFloat(s.incentive_product_price || vd.incentive_product_price || 0);
        const price  = metaP > 0 ? metaP : parseFloat(s.price || 0);
        const disc   = parseFloat(p2.discountPct || 0);
        const final  = price * (1 - disc / 100);
        const fpVar  = s.variant_title && s.variant_title.toLowerCase() !== 'default title' ? ' — ' + s.variant_title : '';
        data.push([
          vd.sku || '-',
          s.title + fpVar + ` (${disc}% Credit)`,
          vd.collection || '-',
          '-',
          vd.ml || '-',
          vd.pres || '-',
          '-',
          final,
          s.selectedQty,
          final * s.selectedQty
        ]);
      });
    }

    data.push([]);
    data.push(['', '', '', '', '', '', '', '', 'TOTAL', grandTotal]);

    const ws = XLSX.utils.aoa_to_sheet(data);
    ws['!cols'] = [{wch:18},{wch:30},{wch:20},{wch:18},{wch:10},{wch:14},{wch:12},{wch:16},{wch:8},{wch:14}];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Pre-Order');
    XLSX.writeFile(wb, 'pre-order-' + vendor.toLowerCase().replace(/\s+/g, '-') + '.xlsx');
  };

  btn.dataset.listenerAttached = 'true';
}

/* ============================================================
   EXPORT EXCEL — CATÁLOGO COMPLETO
   ============================================================ */

function initCatalogExport() {
  const btn = getEl('export-all-products-btn');
  if (!btn || btn.dataset.listenerAttached) return;

  btn.onclick = () => {
    // Limpiar botones anteriores
    getEl('catalog-download-btns')?.remove();
    getEl('incentives-download-btns')?.remove();
    getEl('preorder-download-btns')?.remove();
    document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

    const modeEl        = getEl('send-modal-mode');
    const titleEl       = getEl('send-modal-title');
    const formatSection = getEl('send-format-section');

    if (modeEl)         modeEl.value        = 'catalog';
    if (titleEl)        titleEl.textContent  = 'Product List';
    if (formatSection)  formatSection.style.display = '';

    const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
    if (excelRadio) excelRadio.checked = true;

    // ── Bloque descarga + separador OR + email ──
    const downloadBtns = document.createElement('div');
    downloadBtns.id = 'catalog-download-btns';
    downloadBtns.innerHTML = `
      <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">
        <div style="width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
            <polyline points="7 10 12 15 17 10"/>
            <line x1="12" y1="15" x2="12" y2="3"/>
          </svg>
        </div>
        <div>
          <div style="    font-family: 'Crimson Pro';font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Product List</div>
          <div style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
        </div>
      </div>

      <div style="display:flex;gap:12px;margin-bottom:12px;">
        <button type="button" id="catalog-dl-excel"
          style="      font-family: 'Crimson Pro';  border: none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
          border-radius:10px;cursor:pointer;
          font-family:'Crimson Pro',serif;transition:all 0.2s;">
          <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
          <div style="text-align:left;">
            <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
            <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
          </div>
        </button>
        <button type="button" id="catalog-dl-pdf"
          style="    font-family: 'Crimson Pro';border: none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
          border-radius:10px;cursor:pointer;
          font-family:'Crimson Pro',serif;transition:all 0.2s;">
          <img src="${window._b2bPdfIconUrl}" width="40" height="30" alt="PDF">
          <div style="text-align:left;">
            <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
            <div style="font-size:12px;color:#6b7280;">.pdf format</div>
          </div>
        </button>
      </div>

      <div style="text-align:center;margin-bottom:16px;">
        <span style="font-family: 'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:14px;color:#b8a77d;font-weight:600;">
           Instant download – No email required
        </span>
      </div>

     <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
      <span style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
    </div>

      <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">
        <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
            <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
            <polyline points="22,6 12,13 2,6"/>
          </svg>
        </div>
        <div>
          <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Product List by Email</div>
          <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
        </div>
      </div>`;

    const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
    const firstLabel     = sendModalInner?.querySelector('label');
    if (firstLabel) {
      firstLabel.parentNode.insertBefore(downloadBtns, firstLabel);
    }

    // Listeners descarga directa
    getEl('catalog-dl-excel')?.addEventListener('click', async () => {
      const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
      const base64 = await generateCatalogBase64();
      if (!base64) return;
      const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
      a.click(); URL.revokeObjectURL(url);
    });

    getEl('catalog-dl-pdf')?.addEventListener('click', async () => {
      const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
      const base64 = await generateCatalogPdfBase64();
      if (!base64) return;
      const blob = base64toBlob(base64, 'application/pdf');
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
      a.click(); URL.revokeObjectURL(url);
    });

    // Nota al pie
    const footer = document.createElement('div');
    footer.className = 'send-modal-separator';
    footer.innerHTML = `
      `;
    const cancelBtn = sendModalInner?.querySelector('#send-modal-cancel');
    if (cancelBtn) cancelBtn.parentNode.parentNode.appendChild(footer);

    const modal = getEl('send-modal');
    if (modal) modal.style.display = 'flex';
    document.body.style.overflow = 'hidden';
  };

  btn.dataset.listenerAttached = 'true';
}

// ── Helper base64 a Blob ──
function base64toBlob(base64, mimeType) {
  const bytes  = atob(base64);
  const buffer = new ArrayBuffer(bytes.length);
  const view   = new Uint8Array(buffer);
  for (let i = 0; i < bytes.length; i++) view[i] = bytes.charCodeAt(i);
  return new Blob([buffer], { type: mimeType });
}


/* ============================================================
   EXPORT PDF
   ============================================================ */

function initPdfExport() {
  const btn = getEl('export-pdf-btn');
  if (!btn || btn.dataset.listenerAttached) return;

  let _logoDataUrl = null;
  const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
  if (logoUrl) {
    const li = new Image();
    li.crossOrigin = 'anonymous';
    li.onload = () => {
      try {
        const c = document.createElement('canvas');
        c.width = li.width; c.height = li.height;
        c.getContext('2d').drawImage(li, 0, 0);
        _logoDataUrl = c.toDataURL('image/png');
      } catch {}
    };
    li.src = logoUrl;
  }

  btn.onclick = () => {
    const { jsPDF } = window.jspdf;
    const doc = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageW = doc.internal.pageSize.getWidth();
    const pageH = doc.internal.pageSize.getHeight();
    const margin = 14, colW = pageW - margin * 2;
    let y = margin;

    const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
    const drawLine = () => { doc.setDrawColor(220,220,220); doc.line(margin, y, pageW - margin, y); y += 3; };

    if (_logoDataUrl) {
      try {
        const li = new Image(); li.src = _logoDataUrl;
        const lw = 40, lh = li.height > 0 ? (li.height * lw) / li.width : 20;
        doc.addImage(_logoDataUrl, 'PNG', (pageW - lw) / 2, y, lw, Math.min(lh, 30));
        y += Math.min(lh, 30) + 6;
      } catch {}
    }

    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    doc.setFontSize(16); doc.setFont('helvetica', 'bold');
    doc.text(vendor, pageW / 2, y, { align: 'center' }); y += 7;
    doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120,120,120);
    doc.text(new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }), pageW / 2, y, { align: 'center' });
    doc.setTextColor(0,0,0); y += 8; drawLine();

    const dashData = [
      { label: 'Products',    value: getEl('dash-count-product')?.textContent || '0' },
      { label: 'Collections', value: getEl('dash-unique-types')?.textContent  || '0' },
      { label: 'Items',       value: getEl('dash-total-items')?.textContent   || '0' },
      { label: 'Est. Total',  value: getEl('dash-total-purchase')?.textContent || '$0' }
    ];
    const cardW = colW / 4 - 2;
    dashData.forEach((d, i) => {
      const cx = margin + i * (cardW + 2.5);
      doc.setFillColor(248,248,248); doc.setDrawColor(220,220,220);
      doc.roundedRect(cx, y, cardW, 18, 2, 2, 'FD');
      doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(100,100,100);
      doc.text(d.label, cx + cardW / 2, y + 6, { align: 'center' });
      doc.setFontSize(12); doc.setFont('helvetica','bold'); doc.setTextColor(30,30,30);
      doc.text(d.value, cx + cardW / 2, y + 14, { align: 'center' });
    });
    doc.setTextColor(0,0,0); y += 24; drawLine();

    const cols = { sku: 32, product: 48, type: 26, ml: 14, qty: 12, price: 24, total: 26 };
    const colWidths = [cols.sku, cols.product, cols.type, cols.ml, cols.qty, cols.price, cols.total];
    doc.setFillColor(30,30,30); doc.rect(margin, y, colW, 7, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    let cx = margin + 2;
    ['SKU','Product','Type','ML','Qty','Unit Price','Subtotal'].forEach((lbl, i) => {
      doc.text(lbl, cx, y + 5); cx += colWidths[i];
    });
    doc.setTextColor(0,0,0); y += 9;

    let rowCount = 0, totalItemsPDF = 0, grandTotalPDF = 0;
    variantRows().forEach(row => {
      const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (!qty) return;
      const unitPrice = parseFloat(row.dataset.unitPrice || 0), subtotal = qty * unitPrice;
      checkPage(8);
      doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
      doc.rect(margin, y - 1, colW, 7, 'F');
      doc.setFontSize(8); doc.setFont('helvetica','normal');
      let cx2 = margin + 2;
      [
        (row.dataset.sku || '-').toUpperCase().substring(0, 12),
        (row.cells[5]?.textContent?.trim() || '-').substring(0, 30),
        (row.cells[6]?.textContent?.trim() || '-').substring(0, 14),
        (row.cells[7]?.textContent?.trim() || '-').substring(0, 8),
        String(qty), '$' + unitPrice.toFixed(2), '$' + subtotal.toFixed(2)
      ].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += colWidths[i]; });
      y += 7; rowCount++; totalItemsPDF += qty; grandTotalPDF += subtotal;
    });

  const colH2    = getColHandle();
    const rulesPDF = window.b2bCollectionIncentivesMap?.[colH2] || [];
    const activePDF = rulesPDF.length ? calcActiveIncentive(rulesPDF, totalItemsPDF, grandTotalPDF) : null;

    // ── Sección FREE GIFTS ──
    const freeRowsPDF = [];

    // Collection rules auto-apply
    if (activePDF && isAutoApply(activePDF)) {
      (activePDF.free_products || []).forEach((fp, i) => {
        if (!fp?.title) return;
        const qty   = normalizeQtyArray(activePDF.free_product_quantities)[i] || 1;
        const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
        freeRowsPDF.push({ label: fp.title + fpVar, qty, badge: 'FREE', color: [22,101,52], bg: [220,252,231] });
      });
      (activePDF.free_testers || []).forEach((tp, i) => {
        if (!tp?.title) return;
        freeRowsPDF.push({ label: tp.title + ' (Tester)', qty: getTesterQty(activePDF, i), badge: 'TESTER', color: [29,78,216], bg: [219,234,254] });
      });
    }

    // Variant incentives
    variantRows().forEach(row => {
      const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0) return;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      if (!variantHasIncentive(extras)) return;
      const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
      if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

      const fps    = getVariantFreeProducts(extras);
      const fqs    = getVariantFreeQtys(extras);
      const mult   = calcVariantMultiplier(extras, qty, lineV);
      const pName  = row.cells[5]?.textContent?.trim() || '';
      const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

      if (fps.length > 1 && choice?.confirmed) {
        freeRowsPDF.push({ label: `${choice.chosenTitle} (${pName} incentive)`, qty: choice.chosenQty, badge: 'FREE', color: [22,101,52], bg: [220,252,231] });
      } else {
        fps.forEach((fp, i) => {
          if (!fp?.title) return;
          const giftQty = (fqs[i] || 1) * mult;
          const fpVar   = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
          freeRowsPDF.push({ label: `${fp.title}${fpVar} (${pName} incentive)`, qty: giftQty, badge: 'FREE', color: [22,101,52], bg: [220,252,231] });
        });
      }
    });

    // Prioridad 2
    const p2PDF = window.b2bPriority2Choice || {};
    if (p2PDF.confirmed && Array.isArray(p2PDF.selections)) {
      p2PDF.selections.filter(s => (s.selectedQty || 0) > 0).forEach(s => {
        const vid   = String(s.variant_id || '');
        const vd    = window.b2bAllVariantsMap?.[vid] || {};
        const metaP = parseFloat(s.incentive_product_price || vd.incentive_product_price || 0);
        const price = metaP > 0 ? metaP : parseFloat(s.price || 0);
        const disc  = parseFloat(p2PDF.discountPct || 0);
        const fpVar = s.variant_title && s.variant_title.toLowerCase() !== 'default title' ? ` — ${s.variant_title}` : '';
        freeRowsPDF.push({ label: `${s.title}${fpVar} (${disc}% credit)`, qty: s.selectedQty, badge: `${disc}%`, color: [29,78,216], bg: [219,234,254] });
      });
    }

    // ── Renderizar sección free gifts ──
    if (freeRowsPDF.length) {
      checkPage(12);
      doc.setFillColor(30,30,30); doc.rect(margin, y, colW, 7, 'F');
      doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
      doc.text('FREE GIFTS INCLUDED', margin + 2, y + 4.5);
      doc.setTextColor(0,0,0); y += 10;

      freeRowsPDF.forEach(item => {
        checkPage(8);
        doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, 7, 'F');
        doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(...item.color);
        doc.text(item.badge, margin + 2, y + 4);
        doc.setFont('helvetica','normal');
        doc.text(item.label.substring(0, 50), margin + 16, y + 4);
        doc.text(`Qty: ${item.qty}`, pageW - margin - 2, y + 4, { align: 'right' });
        doc.setTextColor(0,0,0); y += 7;
      });
    }

    const discPctPDF    = rewardChoice?.discountPct || 0;
    const discAmountPDF = discPctPDF > 0 ? grandTotalPDF * discPctPDF / 100 : 0;
    const finalTotalPDF = grandTotalPDF - discAmountPDF;

    checkPage(20); y += 3; drawLine();
    doc.setFontSize(11); doc.setFont('helvetica','bold');
    doc.text('Total Items: ' + totalItemsPDF, margin, y + 6);
    if (discPctPDF > 0) {
      doc.setFontSize(9); doc.setFont('helvetica','normal'); doc.setTextColor(150,80,0);
      doc.text(`Discount (${discPctPDF}%): -$${discAmountPDF.toFixed(2)}`, pageW - margin, y + 6, { align: 'right' });
      y += 7; doc.setFontSize(11); doc.setFont('helvetica','bold'); doc.setTextColor(0,0,0);
    }
    doc.text('Estimated Total: $' + finalTotalPDF.toFixed(2), pageW - margin, y + 6, { align: 'right' });
    doc.save('pre-order-' + vendor.toLowerCase().replace(/\s+/g, '-') + '.pdf');
  };

  btn.dataset.listenerAttached = 'true';
}



async function cartAddWithRetry(payload, retries = 5, delay = 1500) {
  const root = window.Shopify?.routes?.root || '/';
  for (let i = 0; i < retries; i++) {
    const res = await fetch(`${root}cart/add.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(payload)
    });

    console.log(`[b2b] Intento ${i + 1}/${retries} - Status: ${res.status}`);

    if (res.status === 403 && i < retries - 1) {
      await new Promise(r => setTimeout(r, delay));
      continue;
    }

    return res;
  }
}



/* ============================================================
   BUY NOW
   ============================================================ */

// async function handleBuyNow() {
//   const buyBtns = [getEl('b2b-buy-btn'), getEl('b2b-buy-now-bottom')];
//   if (buyBtns[0]?.dataset.processing === 'true') return;

//   buyBtns.forEach(btn => {
//     if (btn) { btn.dataset.processing = 'true'; btn.disabled = true; btn.textContent = 'Processing...'; }
//   });

//   function resetBuyBtns() {
//     buyBtns.forEach(btn => {
//       if (btn) { btn.dataset.processing = 'false'; btn.disabled = false; btn.textContent = 'Buy Now'; }
//     });
//   }

//   if (showMinQtyModal() || showBrandMinQtyModal() || showBrandMinValueModal()) {
//     resetBuyBtns(); return;
//   }

//   let anyVariantActive = false;
//   variantRows().forEach(row => {
//     const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (qty <= 0) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) anyVariantActive = true;
//   });

//   if (!anyVariantActive && rewardChoice.active && !isAutoApply(rewardChoice.active) && !rewardChoice.confirmed) {
//     alert('Please choose your collection reward first by clicking Choose Your Reward.');
//     resetBuyBtns(); return;
//   }

//   let pendingVariantChoice = false;
//   if (Number(window.b2bCollectionPriority || 1) !== 2  && Number(window.b2bCollectionPriority || 1) !== 3) {
//     variantRows().forEach(row => {
//       const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       if (qty <= 0) return;
//       const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//       if (!variantHasIncentive(extras)) return;
//       const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//       if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//       if (getVariantFreeProducts(extras).length > 1) {
//         const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//         if (!choice?.confirmed) pendingVariantChoice = true;
//       }
//     });
//     if (pendingVariantChoice) {
//       alert('Please choose your free product gift before continuing.');
//       resetBuyBtns(); return;
//     }
//   }

//   const items = [];
//   document.querySelectorAll('.hidden-qty').forEach(input => {
//     const qty = parseInt(input.value) || 0;
//     if (qty > 0) {
//       const vid = input.nextElementSibling?.value;
//       if (vid) items.push({ id: Number(vid), quantity: qty });
//     }
//   });
//   if (!items.length) { resetBuyBtns(); return; }

//   lockUI();

//   const colHandle = getColHandle();
//   const rules     = window.b2bCollectionIncentivesMap?.[colHandle] || [];
//   let freeItems   = [];

//   if (rules.length) {
//     let unitsCol = 0, valueCol = 0;
//     items.forEach(item => {
//       const extras = window.b2bVariantExtrasMap?.[String(item.id)];
//       const row    = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
//       const lineV  = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
//       if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, item.quantity, lineV)) return;
//       unitsCol += item.quantity;
//       valueCol += lineV;
//     });

//     const active = calcActiveIncentive(rules, unitsCol, valueCol);
//     if (active && (isAutoApply(active) || rewardChoice.confirmed)) {
//       if (isAutoApply(active)) {
//         await Promise.all((active.free_products || []).map(async (fp, i) => {
//           const giftQty = normalizeQtyArray(active.free_product_quantities)[i] || 1;
//           if (fp?.variant_id && fp.variant_id !== '0') {
//             freeItems.push({ id: Number(fp.variant_id), quantity: giftQty, properties: { 'Free Gift': 'Volume Incentive Reward' } });
//             return;
//           }
//           if (!fp?.handle) return;
//           const v = await fetchFreeGiftVariant(fp.handle);
//           if (v) freeItems.push({ id: Number(v.id), quantity: giftQty, properties: { 'Free Gift': 'Volume Incentive Reward' } });
//         }));
//         const testers = active.free_testers || [];
//         if (testers.length) {
//           await Promise.all(testers.map(async (tp, i) => {
//             const q = getTesterQty(active, i);
//             if (tp.variant_id && tp.variant_id !== '0') {
//               freeItems.push({ id: Number(tp.variant_id), quantity: q, properties: { '🧴 Tester': 'Volume Incentive Reward' } });
//               return;
//             }
//             if (!tp?.handle) return;
//             const v = await fetchFreeGiftVariant(tp.handle, 'tester');
//             if (v) freeItems.push({ id: Number(v.id), quantity: q, properties: { '🧴 Tester': 'Volume Incentive Reward' } });
//           }));
//         } else {
//           const tTotal = normalizeQtyArray(active.testers_qty).reduce((s, q) => s + q, 0);
//           if (tTotal > 0) window._pendingTesters = tTotal;
//         }
//       } else {
//         const ct = rewardChoice.chosenType, chosenQty = rewardChoice.chosenQty || 1;
//         if (ct === 'product' || ct === 'tester') {
//           let chosenVid = rewardChoice.chosenVariantId;
//           if (!chosenVid && rewardChoice.chosenProductHandle) {
//             const v = await fetchFreeGiftVariant(rewardChoice.chosenProductHandle, ct);
//             if (v) { chosenVid = String(v.id); rewardChoice.chosenVariantId = chosenVid; }
//           }
//           if (chosenVid) {
//             const prop = ct === 'tester' ? '🧴 Tester' : 'Free Gift';
//             freeItems.push({ id: Number(chosenVid), quantity: chosenQty, properties: { [prop]: 'Volume Incentive — User Choice' } });
//           }
//         }
//       }
//       rewardChoice.discountPct = Number(active.discount || 0);
//     }
//   }

//   const alreadyAdded = new Set(freeItems.map(fi => String(fi.id)));
//   await Promise.all(items.map(async item => {
//     const extras = window.b2bVariantExtrasMap?.[String(item.id)];
//     if (!variantHasIncentive(extras)) return;
//     const row   = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
//     const lineV = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, item.quantity, lineV)) return;

//     const fps  = getVariantFreeProducts(extras);
//     const fqs  = getVariantFreeQtys(extras);
//     const mult = calcVariantMultiplier(extras, item.quantity, lineV);

//     if (fps.length > 1) {
//       const choice = window.b2bVariantRewardChoices?.[String(item.id)];
//       if (choice?.confirmed && choice.chosenVariantId && !alreadyAdded.has(choice.chosenVariantId)) {
//         alreadyAdded.add(choice.chosenVariantId);
//         freeItems.push({ id: Number(choice.chosenVariantId), quantity: choice.chosenQty, properties: { 'Free Gift': 'Variant Incentive — User Choice' } });
//       }
//     } else {
//       await Promise.all(fps.map(async (fp, i) => {
//         const giftQty = (fqs[i] || 1) * mult;
//         if (fp?.variant_id && fp.variant_id !== '0') {
//           if (!alreadyAdded.has(String(fp.variant_id))) {
//             alreadyAdded.add(String(fp.variant_id));
//             freeItems.push({ id: Number(fp.variant_id), quantity: giftQty, properties: { 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` } });
//           }
//           return;
//         }
//         if (!fp?.handle) return;
//         const variant = await fetchFreeGiftVariant(fp.handle);
//         if (variant && !alreadyAdded.has(String(variant.id))) {
//           alreadyAdded.add(String(variant.id));
//           freeItems.push({ id: Number(variant.id), quantity: giftQty, properties: { 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` } });
//         }
//       }));
//     }
//   }));

// try {
//     const root = window.Shopify?.routes?.root || '/';

//     // ✅ Warm-up: despertar la sesión
//     await fetch(`${root}cart.js`, {
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json' }
//     });
//     await new Promise(r => setTimeout(r, 400));

//     // ✅ Limpiar carrito vía update.js en lugar de clear.js
//     const currentCartRes = await fetch(`${root}cart.js`, {
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json' }
//     });
//     const currentCart = await currentCartRes.json();
//     if (currentCart.items?.length) {
//       const updates = {};
//       currentCart.items.forEach(item => { updates[item.key] = 0; });
//       await fetch(`${root}cart/update.js`, {
//         method: 'POST',
//         credentials: 'same-origin',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({ updates })
//       });
//       await new Promise(r => setTimeout(r, 400));
//     }

//     // ── Agregar items principales ──
//     const mainRes = await cartAddWithRetry({ items });

//     if (mainRes.status === 403 || mainRes.status === 401) {
//       resetBuyBtns();
//       window.location.href = `${root}account/login?return_url=` + encodeURIComponent(window.location.pathname + window.location.search);
//       return;
//     }

//     if (!mainRes.ok) {
//       const errText = await getSafeError(mainRes);
//       throw new Error(`Cart add failed. Status ${mainRes.status}: ${errText}`);
//     }

//     // ── Prioridad 1: free gifts principales ──
//     if (freeItems.length) {
//       const freeRes = await cartAddWithRetry({ items: freeItems });
//       if (!freeRes.ok) {
//         const freeErr = await getSafeError(freeRes);
//         console.warn('[b2b] Free items add failed:', freeErr);
//       }
//     }

//     // ── Prioridad 2: productos con descuento ──
//     const p2choice = window.b2bPriority2Choice || {};
//     if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
//       const p2Items = [];
//       for (const sel of p2choice.selections) {
//         const qty = parseInt(sel.selectedQty || 0);
//         if (qty <= 0) continue;
//         const vid = sel.variant_id && String(sel.variant_id) !== '0'
//           ? String(sel.variant_id)
//           : null;
//         if (!vid) continue;
//         p2Items.push({
//           id:       Number(vid),
//           quantity: qty,
//           properties: { 'Discount Gift': `${p2choice.discountPct}% credit applied` }
//         });
//       }

//       if (p2Items.length) {
//         try {
//           const p2Res = await cartAddWithRetry({ items: p2Items });
//           if (!p2Res.ok) {
//             const p2Err = await getSafeError(p2Res);
//             console.warn('[P2] No se pudieron agregar productos gift:', p2Err);
//           }
//         } catch (p2Err) {
//           console.warn('[P2] Error al agregar productos gift:', p2Err);
//         }
//       }
//     }

//     // ── Prioridad 3: free gifts distribuidos ──
//     const p3choice = window.b2bPriority3Choice || {};
//     if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
//       const p3Items = [];
//       for (const sel of p3choice.selections) {
//         for (const choice of (sel.choices || [])) {
//           if (!choice.chosenQty || choice.chosenQty <= 0) continue;
//           let vid3 = choice.chosenVariantId;
//           if (!vid3 && choice.handle) {
//             const v = await fetchFreeGiftVariant(choice.handle);
//             if (v) vid3 = String(v.id);
//           }
//           if (!vid3) continue;
//           p3Items.push({
//             id:       Number(vid3),
//             quantity: choice.chosenQty,
//             properties: { 'Free Gift': `Priority 3 — ${sel.pName}` }
//           });
//         }
//       }
//       if (p3Items.length) {
//         try {
//           const p3Res = await cartAddWithRetry({ items: p3Items });
//           if (!p3Res.ok) {
//             const p3Err = await getSafeError(p3Res);
//             console.warn('[P3] Error adding gifts:', p3Err);
//           }
//         } catch (e) {
//           console.warn('[P3] Error adding gifts:', e);
//         }
//       }
//     }

//     // ── Cart attributes ──
//     const discPct = rewardChoice?.discountPct || 0;
//     const attribs = {};
//     if (freeItems.length)           { attribs['Free Gifts'] = freeItems.map(fi => `${fi.quantity}x variant ${fi.id}`).join(', '); attribs['Incentive Applied'] = 'Yes'; }
//     if (discPct > 0)                { attribs['Discount Applied'] = `${discPct}% Volume Incentive`; attribs['Incentive Discount'] = String(discPct); }
//     if (window._pendingTesters > 0) { attribs['Testers Requested'] = String(window._pendingTesters); window._pendingTesters = 0; }
//     if (Object.keys(attribs).length) {
//       await fetch(`${root}cart/update.js`, {
//         method: 'POST',
//         credentials: 'same-origin',
//         headers: {
//           'Content-Type': 'application/json',
//           'Accept': 'application/json',
//           'X-Requested-With': 'XMLHttpRequest'
//         },
//         body: JSON.stringify({ attributes: attribs })
//       });
//     }

//     // ── Verificar items principales ──
//     const cartRes = await fetch(`${root}cart.js`, {
//       credentials: 'same-origin',
//       headers: { 'Accept': 'application/json' }
//     });
//     const cart = await cartRes.json();
//     const addedVariantIds = new Set(items.map(i => i.id));
//     const cartVariantIds  = new Set(cart.items.map(i => i.variant_id));
//     const missing = [...addedVariantIds].filter(id => !cartVariantIds.has(id));
//     if (missing.length) throw new Error(`Some items could not be added to the cart (variant IDs: ${missing.join(', ')})`);

//     // ✅ Pausa final y checkout locale-aware
//     await new Promise(resolve => setTimeout(resolve, 300));
//     window.location.assign(`${root}checkout`);

//   } catch (err) {
//     console.error('[b2b] Buy Now error:', err);
//     alert('There was an error processing your purchase. Please try again.\n\n' + err.message);
//     resetBuyBtns();
//   }
// }


async function handleBuyNow() {
  const buyBtns = [getEl('b2b-buy-btn'), getEl('b2b-buy-now-bottom')];
  if (buyBtns[0]?.dataset.processing === 'true') return;

  buyBtns.forEach(btn => {
    if (btn) { btn.dataset.processing = 'true'; btn.disabled = true; btn.textContent = 'Processing...'; }
  });

  function resetBuyBtns() {
    buyBtns.forEach(btn => {
      if (btn) { btn.dataset.processing = 'false'; btn.disabled = false; btn.textContent = 'Buy Now'; }
    });
  }

  if (showMinQtyModal() || showBrandMinQtyModal() || showBrandMinValueModal()) {
    resetBuyBtns(); return;
  }

  // ── Estas validaciones no aplican a master ──
  if (!window.b2bIsMasterUser) {
    let anyVariantActive = false;
    variantRows().forEach(row => {
      const qty    = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      if (qty <= 0) return;
      const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
      const lineV  = qty * parseFloat(row.dataset.unitPrice || 0);
      if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, qty, lineV)) anyVariantActive = true;
    });

    if (!anyVariantActive && rewardChoice.active && !isAutoApply(rewardChoice.active) && !rewardChoice.confirmed) {
      alert('Please choose your collection reward first by clicking Choose Your Reward.');
      resetBuyBtns(); return;
    }

    let pendingVariantChoice = false;
    if (!b2bIsCreditPriority() && Number(window.b2bCollectionPriority || 1) !== 3) {
      variantRows().forEach(row => {
        const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
        if (qty <= 0) return;
        const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
        if (!variantHasIncentive(extras)) return;
        const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
        if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
        if (getVariantFreeProducts(extras).length > 1) {
          const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
          if (!choice?.confirmed) pendingVariantChoice = true;
        }
      });
      if (pendingVariantChoice) {
        alert('Please choose your free product gift before continuing.');
        resetBuyBtns(); return;
      }
    }
  }

  const items = [];
  document.querySelectorAll('.hidden-qty').forEach(input => {
    const qty = parseInt(input.value) || 0;
    if (qty > 0) {
      const vid = input.nextElementSibling?.value;
      if (vid) items.push({ id: Number(vid), quantity: qty });
    }
  });
  if (!items.length) { resetBuyBtns(); return; }

  if (window.b2bIsMasterUser) {
    const ctx = window.b2bMasterOrderContext;
    if (!ctx.companyId || !ctx.customerId) {
      alert('Please select a Company and a Customer before placing this order.');
      resetBuyBtns(); return;
    }
  }

  lockUI();

  const colHandle = getColHandle();
  const rules     = window.b2bCollectionIncentivesMap?.[colHandle] || [];
  let freeItems   = [];

  // ══════════════════════════════════════════════
  // MASTER: FOC manual, sin reglas de incentivo
  // NO MASTER: reglas de colección auto-apply / reward choice
  // ══════════════════════════════════════════════
  if (window.b2bIsMasterUser) {
    Object.entries(window.b2bMasterFreeItems || {}).forEach(([vid, qty]) => {
      qty = parseInt(qty) || 0;
      if (qty <= 0) return;
      freeItems.push({
        id: Number(vid),
        quantity: qty,
        properties: { '_gift_type': 'free_sample', 'Free Gift': 'Master Manual FOC' }
      });
    });
  } else if (rules.length) {
    let unitsCol = 0, valueCol = 0;
    items.forEach(item => {
      const extras = window.b2bVariantExtrasMap?.[String(item.id)];
      const row    = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
      const lineV  = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
      if (variantHasIncentive(extras) && checkVariantIncentiveMet(extras, item.quantity, lineV)) return;
      unitsCol += item.quantity;
      valueCol += lineV;
    });

    const active = calcActiveIncentive(rules, unitsCol, valueCol);
    if (active && (isAutoApply(active) || rewardChoice.confirmed)) {
      if (isAutoApply(active)) {
        await Promise.all((active.free_products || []).map(async (fp, i) => {
          const giftQty = normalizeQtyArray(active.free_product_quantities)[i] || 1;
          if (fp?.variant_id && fp.variant_id !== '0') {
            freeItems.push({ id: Number(fp.variant_id), quantity: giftQty, properties: { '_gift_type': 'free_sample', 'Free Gift': 'Volume Incentive Reward' } });
            return;
          }
          if (!fp?.handle) return;
          const v = await fetchFreeGiftVariant(fp.handle);
          if (v) freeItems.push({ id: Number(v.id), quantity: giftQty, properties: { '_gift_type': 'free_sample', 'Free Gift': 'Volume Incentive Reward' } });
        }));
        const testers = active.free_testers || [];
        if (testers.length) {
          await Promise.all(testers.map(async (tp, i) => {
            const q = getTesterQty(active, i);
            if (tp.variant_id && tp.variant_id !== '0') {
              freeItems.push({ id: Number(tp.variant_id), quantity: q, properties: { '_gift_type': 'free_sample', '🧴 Tester': 'Volume Incentive Reward' } });
              return;
            }
            if (!tp?.handle) return;
            const v = await fetchFreeGiftVariant(tp.handle, 'tester');
            if (v) freeItems.push({ id: Number(v.id), quantity: q, properties: { '_gift_type': 'free_sample', '🧴 Tester': 'Volume Incentive Reward' } });
          }));
        } else {
          const tTotal = normalizeQtyArray(active.testers_qty).reduce((s, q) => s + q, 0);
          if (tTotal > 0) window._pendingTesters = tTotal;
        }
      } else {
        const ct = rewardChoice.chosenType, chosenQty = rewardChoice.chosenQty || 1;
        if (ct === 'product' || ct === 'tester') {
          let chosenVid = rewardChoice.chosenVariantId;
          if (!chosenVid && rewardChoice.chosenProductHandle) {
            const v = await fetchFreeGiftVariant(rewardChoice.chosenProductHandle, ct);
            if (v) { chosenVid = String(v.id); rewardChoice.chosenVariantId = chosenVid; }
          }
          if (chosenVid) {
            const prop = ct === 'tester' ? '🧴 Tester' : 'Free Gift';
            freeItems.push({ id: Number(chosenVid), quantity: chosenQty, properties: { '_gift_type': 'free_sample', [prop]: 'Volume Incentive — User Choice' } });
          }
        }
      }
      rewardChoice.discountPct = Number(active.discount || 0);
    }
  }

  const alreadyAdded = new Set(freeItems.map(fi => String(fi.id)));
  const priorityForBuy = Number(window.b2bCollectionPriority || 1);

  // ── El auto-detect de free gifts por variante (P1) tampoco aplica a master ──
  if (!window.b2bIsMasterUser) {
    await Promise.all(items.map(async item => {
      const extras = window.b2bVariantExtrasMap?.[String(item.id)];
      if (!variantHasIncentive(extras)) return;
      const row   = document.querySelector(`.b2b-variant-row[data-variant-id="${item.id}"]`);
      const lineV = item.quantity * parseFloat(row?.dataset.unitPrice || 0);
      if (!checkVariantIncentiveMet(extras, item.quantity, lineV)) return;

      const fps  = getVariantFreeProducts(extras);
      const fqs  = getVariantFreeQtys(extras);
      const mult = calcVariantMultiplier(extras, item.quantity, lineV);

      if (fps.length > 1) {
        const choice = window.b2bVariantRewardChoices?.[String(item.id)];
        if (choice?.confirmed && choice.chosenVariantId && !alreadyAdded.has(choice.chosenVariantId)) {
          alreadyAdded.add(choice.chosenVariantId);
          freeItems.push({
            id: Number(choice.chosenVariantId),
            quantity: computeCartGiftQty(choice.chosenVariantId, choice.chosenQty),
            properties: { '_gift_type': 'free_sample', 'Free Gift': 'Variant Incentive — User Choice' }
          });
        }
      } else if (priorityForBuy !== 2 && priorityForBuy !== 4 && priorityForBuy !== 3) {
        await Promise.all(fps.map(async (fp, i) => {
          const giftQty = (fqs[i] || 1) * mult;
          if (fp?.variant_id && fp.variant_id !== '0') {
            if (!alreadyAdded.has(String(fp.variant_id))) {
              alreadyAdded.add(String(fp.variant_id));
              freeItems.push({
                id: Number(fp.variant_id),
                quantity: computeCartGiftQty(fp.variant_id, giftQty),
                properties: { '_gift_type': 'free_sample', 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` }
              });
            }
            return;
          }
          if (!fp?.handle) return;
          const variant = await fetchFreeGiftVariant(fp.handle);
          if (variant && !alreadyAdded.has(String(variant.id))) {
            alreadyAdded.add(String(variant.id));
            freeItems.push({
              id: Number(variant.id),
              quantity: computeCartGiftQty(variant.id, giftQty),
              properties: { '_gift_type': 'free_sample', 'Free Gift': `Variant Incentive (${item.quantity} units = ${giftQty}x free)` }
            });
          }
        }));
      }
    }));
  }

  // ══════════════════════════════════════════════
  // MASTER: crear Draft Order vía backend, atribuido
  // al customer/company seleccionado. NO usa cart/add.js.
  // Corta la ejecución aquí (return) y no toca el checkout normal.
  // ══════════════════════════════════════════════
  if (window.b2bIsMasterUser) {
    const ctx = window.b2bMasterOrderContext;

    const orderItems = items.map(it => ({
      variantId: String(it.id),
      quantity: it.quantity
    }));

    const orderFreeItems = freeItems.map(fi => ({
      variantId: String(fi.id),
      quantity: fi.quantity
    }));

    try {
      const res = await fetch('https://shopifyadminapi.8motiv.com/api/Master/CreateOrder', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          customerId: ctx.customerId,
          companyId: ctx.companyId,
          companyContactId: ctx.companyContactId,
          companyLocationId: ctx.companyLocationId,
          items: orderItems,
          freeItems: orderFreeItems,
          note: `Master order — ${ctx.customerName} / ${ctx.companyName}`
        })
      });

      const data = await res.json();
      console.log('[Master CreateOrder] Full response:', data);
      if (!data.success) {
         console.error('[Master CreateOrder] Error detail:', JSON.stringify(data, null, 2));
        throw new Error(data.message || (data.errors ? JSON.stringify(data.errors) : 'Unknown error'));
      }

      resetBuyBtns();
      showMasterOrderCreatedModal(data);
      return;

    } catch (err) {
      console.error('[Master] CreateOrder error:', err);
      alert('There was an error creating the order. Please try again.\n\n' + err.message);
      resetBuyBtns();
      return;
    }
  }

  // ══════════════════════════════════════════════
  // A partir de aquí: flujo normal de carrito/checkout, SOLO no-master
  // ══════════════════════════════════════════════
  try {
    const root = window.Shopify?.routes?.root || '/';

    // ✅ Warm-up: despertar la sesión
    await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    await new Promise(r => setTimeout(r, 400));

    // ✅ Limpiar carrito vía update.js en lugar de clear.js
    const currentCartRes = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    const currentCart = await currentCartRes.json();
    if (currentCart.items?.length) {
      const updates = {};
      currentCart.items.forEach(item => { updates[item.key] = 0; });
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ updates })
      });
      await new Promise(r => setTimeout(r, 400));
    }

    // ── Agregar items principales ──
    const mainRes = await cartAddWithRetry({ items });

    if (mainRes.status === 403 || mainRes.status === 401) {
      resetBuyBtns();
      window.location.href = `${root}account/login?return_url=` + encodeURIComponent(window.location.pathname + window.location.search);
      return;
    }

    if (!mainRes.ok) {
      const errText = await getSafeError(mainRes);
      throw new Error(`Cart add failed. Status ${mainRes.status}: ${errText}`);
    }

    // ── Free gifts (P1) ──
    if (freeItems.length) {
      const freeRes = await cartAddWithRetry({ items: freeItems });
      if (!freeRes.ok) {
        const freeErr = await getSafeError(freeRes);
        console.warn('[b2b] Free items add failed:', freeErr);
      }
    }

    // ── Prioridad 2: productos con descuento ──
    const p2choice = window.b2bPriority2Choice || {};
    if (p2choice.confirmed && Array.isArray(p2choice.selections)) {
      const p2Items = [];
      for (const sel of p2choice.selections) {
        const qty = parseInt(sel.selectedQty || 0);
        if (qty <= 0) continue;
        const vid = sel.variant_id && String(sel.variant_id) !== '0'
          ? String(sel.variant_id)
          : null;
        if (!vid) continue;
        p2Items.push({
          id: Number(vid),
          quantity: computeCartGiftQty(vid, qty),
          properties: { '_gift_type': 'free_sample', 'Discount Gift': `${p2choice.discountPct}% credit applied` }
        });
      }

      if (p2Items.length) {
        try {
          const p2Res = await cartAddWithRetry({ items: p2Items });
          if (!p2Res.ok) {
            const p2Err = await getSafeError(p2Res);
            console.warn('[P2] No se pudieron agregar productos gift:', p2Err);
          }
        } catch (p2Err) {
          console.warn('[P2] Error al agregar productos gift:', p2Err);
        }
      }
    }

    // ── Prioridad 3: free gifts distribuidos ──
    const p3choice = window.b2bPriority3Choice || {};
    if (p3choice.confirmed && Array.isArray(p3choice.selections)) {
      const p3Items = [];
      for (const sel of p3choice.selections) {
        for (const choice of (sel.choices || [])) {
          if (!choice.chosenQty || choice.chosenQty <= 0) continue;
          let vid3 = choice.chosenVariantId;
          if (!vid3 && choice.handle) {
            const v = await fetchFreeGiftVariant(choice.handle);
            if (v) vid3 = String(v.id);
          }
          if (!vid3) continue;
          p3Items.push({
            id: Number(vid3),
            quantity: computeCartGiftQty(vid3, choice.chosenQty),
            properties: { '_gift_type': 'free_sample', 'Free Gift': `${sel.pName}` }
          });
        }
      }
      if (p3Items.length) {
        try {
          const p3Res = await cartAddWithRetry({ items: p3Items });
          if (!p3Res.ok) {
            const p3Err = await getSafeError(p3Res);
            console.warn('[P3] Error adding gifts:', p3Err);
          }
        } catch (e) {
          console.warn('[P3] Error adding gifts:', e);
        }
      }
    }

    // ── Cart attributes ──
    const discPct = rewardChoice?.discountPct || 0;
    const attribs = {};
    if (freeItems.length)           { attribs['Free Gifts'] = freeItems.map(fi => `${fi.quantity}x variant ${fi.id}`).join(', '); attribs['Incentive Applied'] = 'Yes'; }
    if (discPct > 0)                { attribs['Discount Applied'] = `${discPct}% Volume Incentive`; attribs['Incentive Discount'] = String(discPct); }
    if (window._pendingTesters > 0) { attribs['Testers Requested'] = String(window._pendingTesters); window._pendingTesters = 0; }
    if (Object.keys(attribs).length) {
      await fetch(`${root}cart/update.js`, {
        method: 'POST',
        credentials: 'same-origin',
        headers: {
          'Content-Type': 'application/json',
          'Accept': 'application/json',
          'X-Requested-With': 'XMLHttpRequest'
        },
        body: JSON.stringify({ attributes: attribs })
      });
    }

    // ── Verificar items principales ──
    const cartRes = await fetch(`${root}cart.js`, {
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    });
    const cart = await cartRes.json();
    const addedVariantIds = new Set(items.map(i => i.id));
    const cartVariantIds  = new Set(cart.items.map(i => i.variant_id));
    const missing = [...addedVariantIds].filter(id => !cartVariantIds.has(id));
    if (missing.length) throw new Error(`Some items could not be added to the cart (variant IDs: ${missing.join(', ')})`);

    // ✅ Pausa final y checkout locale-aware
    // await new Promise(resolve => setTimeout(resolve, 300));
    // window.location.assign(`${root}checkout`);

        // ── Aplicar el código del metaobject al carrito y al checkout ──
    const pdCode = (window.b2bProductDiscount?.code || '').trim();
    console.log('[ProductDiscount] Buy Now →', {
      source: window.b2bProductDiscount?.source || 'none',
      code: pdCode || '(sin código)',
      coefficient: window.b2bProductDiscount?.coefficient
    });
    const cartPost = (body) => fetch(`${root}cart/update.js`, {
      method: 'POST',
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json',
        'X-Requested-With': 'XMLHttpRequest'
      },
      body: JSON.stringify(body)
    });
    try {
      // 1) Quitar cualquier código viejo que haya quedado en el carrito
      //    (ej. el de la marca de una prueba anterior)
      await cartPost({ discount: '' });

      // 2) Aplicar el código correcto (compañía o marca)
      if (pdCode) {
        await cartPost({ discount: pdCode });
        const chk = await (await fetch(`${root}cart.js`, {
          credentials: 'same-origin',
          headers: { 'Accept': 'application/json' }
        })).json();
        const applied = (chk.discount_codes || []).find(d => String(d.code).toLowerCase() === pdCode.toLowerCase());
        console.log('[ProductDiscount] discount_codes:', chk.discount_codes,
                    '| total_discount:', chk.total_discount / 100);
        if (!applied || applied.applicable === false) {
          console.warn(`[ProductDiscount] Shopify NO aceptó el código "${pdCode}". Revisa en Discounts: que exista con ese nombre exacto, que esté activo, la Eligibility (este cliente/compañía), Applies to (esta marca) y Combinations.`);
        }
      }
    } catch (e) {
      console.warn('[ProductDiscount] No se pudo aplicar el código al carrito:', e);
    }

    // ✅ Pausa final y checkout con el código
    await new Promise(resolve => setTimeout(resolve, 300));
    window.location.assign(`${root}checkout${pdCode ? '?discount=' + encodeURIComponent(pdCode) : ''}`);

  } catch (err) {
    console.error('[b2b] Buy Now error:', err);
    alert('There was an error processing your purchase. Please try again.\n\n' + err.message);
    resetBuyBtns();
  }
}





/* ============================================================
   GUIDELINES MODAL
   ============================================================ */

  function initGuidelinesModal() {
    getEl('conditions-btn')?.addEventListener('click', async () => {
      const colHandle = getColHandle();
      getEl('cond-first-units').textContent = window.b2bBrandMinQtyMap?.[colHandle]        ? window.b2bBrandMinQtyMap[colHandle] + ' Units' : '—';
      getEl('cond-first-value').textContent = window.b2bBrandMinValueMap?.[colHandle]       ? '$' + parseFloat(window.b2bBrandMinValueMap[colHandle]).toFixed(2) : '—';
      getEl('cond-next-units').textContent  = window.b2bBrandNextOrderMap?.[colHandle]      ? window.b2bBrandNextOrderMap[colHandle] + ' Units' : '—';
      getEl('cond-next-value').textContent  = window.b2bBrandNextOrderValueMap?.[colHandle] ? '$' + parseFloat(window.b2bBrandNextOrderValueMap[colHandle]).toFixed(2) : '—';

      const rules            = window.b2bCollectionIncentivesMap?.[colHandle] || [];
      const incentivesSection = getEl('cond-incentives-section');
      const incentivesList    = getEl('cond-incentives-list');

      const priority     = Number(window.b2bCollectionPriority || 1);
      const discPct      = parseFloat(window.b2bCollectionDiscount || 0);
      const minAmount    = parseFloat(window.b2bDiscountMinAmount  || 0);
      const discProducts = (Number(window.b2bCollectionPriority || 1) === 4 ? b2bBuildP4Products({ all: true }) : (window.b2bDiscountProducts || []));

      if (b2bIsCreditPriority(priority) && discPct > 0 && discProducts.length > 0) {
        // ════════════════════════════════════
        //  PRIORIDAD 2
        // ════════════════════════════════════
        incentivesSection.style.display = 'block';

        function getProductPrice(p) {
          const metaP = parseFloat(p.incentive_product_price || 0);
          if (metaP > 0) return metaP;
          const vid2    = String(p.variant_id || '');
          const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
          const metaP2  = parseFloat(extras2.incentive_product_price || 0);
          if (metaP2 > 0) return metaP2;
          return parseFloat(p.price || 0);
        }

        // ── Construir cards ──
        const p2Cards = discProducts.map(p => {
          if (!p?.title) return '';
          const imgSrc    = (p.image || '').replace(/^\/\//, 'https://');
          const realPrice = getProductPrice(p);
          const varTitle  = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
          const vid       = String(p.variant_id || '');
          const varData   = window.b2bAllVariantsMap?.[vid] || {};
          const notes     = window.b2bNotesMap?.[p.handle] || {};
          const sku        = varData.sku || '—';
          const ml         = varData.ml || varTitle || '—';
          const pres       = varData.pres || '—';
          const collection = varData.collection || notes.collection || '—';
          const coeff      = varData.coefficient || notes.coefficient || '—';
          return `
            <div style="display:flex;align-items:center;gap:12px;padding:12px;background:#fff;border:1px solid #e5e7eb;border-radius:8px;">
              ${imgSrc
                ? `<img src="${imgSrc}" style="width:60px;height:60px;object-fit:cover;border-radius:8px;flex-shrink:0;">`
                : '<div style="width:60px;height:60px;border-radius:8px;background:#dbeafe;display:flex;align-items:center;justify-content:center;font-size:24px;">🏷️</div>'}
              <div style="flex:1;min-width:0;">
                <div style="font-weight:700;color:#111;font-size:14px;margin-bottom:2px;">
                  ${p.title}${varTitle ? ` <span style="font-size:12px;color:#6b7280;font-weight:400;">— ${varTitle}</span>` : ''}
                </div>
                <div style="font-size:12px;color:#6b7280;margin-bottom:3px;">SKU: ${sku} | ${ml} | ${pres}</div>
                <div style="font-size:11px;color:#9ca3af;">Collection: ${collection} | Coefficient: ${coeff}</div>
              </div>
              <div style="text-align:right;flex-shrink:0;">
                <div style="font-size:16px;font-weight:700;color:#16a34a;">$${realPrice.toFixed(2)}</div>
              </div>
            </div>`;
        });

        // ── Paginación P2 ──
        const P2_PAGE_SIZE = 5;
        let p2CurrentPage  = 0;
        const p2TotalPages = Math.ceil(p2Cards.length / P2_PAGE_SIZE);

        function renderP2Page() {
          const start     = p2CurrentPage * P2_PAGE_SIZE;
          const end       = start + P2_PAGE_SIZE;
          const pageItems = p2Cards.slice(start, end);
          const total     = p2Cards.length;

          const paginationHTML = total > P2_PAGE_SIZE ? `
            <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding:10px 0;border-top:1px solid #e5e7eb;">
              <button type="button" onclick="window._p2Prev()"
                style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
                  background:${p2CurrentPage === 0 ? '#f3f4f6' : '#b8a77d'};
                  color:${p2CurrentPage === 0 ? '#9ca3af' : '#fff'};
                  font-size:14px;cursor:${p2CurrentPage === 0 ? 'not-allowed' : 'pointer'};
                  font-family:'Crimson Pro',serif;font-weight:600;">
                ← Prev
              </button>
              <span style="font-size:13px;color:#6b7280;">
                ${start + 1}–${Math.min(end, total)} of ${total} products
              </span>
              <button type="button" onclick="window._p2Next()"
                style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
                  background:${p2CurrentPage >= p2TotalPages - 1 ? '#f3f4f6' : '#b8a77d'};
                  color:${p2CurrentPage >= p2TotalPages - 1 ? '#9ca3af' : '#fff'};
                  font-size:14px;cursor:${p2CurrentPage >= p2TotalPages - 1 ? 'not-allowed' : 'pointer'};
                  font-family:'Crimson Pro',serif;font-weight:600;">
                Next →
              </button>
            </div>` : '';

          const container = document.getElementById('p2-products-container');
          if (container) container.innerHTML = pageItems.join('') + paginationHTML;
        }

        window._p2Prev = () => {
          if (p2CurrentPage > 0) { p2CurrentPage--; renderP2Page(); }
        };
        window._p2Next = () => {
          if (p2CurrentPage < p2TotalPages - 1) { p2CurrentPage++; renderP2Page(); }
        };

        incentivesList.innerHTML = `
          <div style="background:#fff;border-radius:12px;padding:16px;margin-bottom:12px;">
            <p style="margin:0 0 8px;font-size:18px;color:#1f2937;line-height:1.6;">
              Spend <strong style="color:#000;">$${minAmount.toLocaleString('en-US', { minimumFractionDigits: 2 })}</strong> or more and receive a credit worth
               <strong style="color:#000;font-size:18px;">${discPct}%</strong>
                of your purchase, redeemable on the selected products below.
            </p>
            <div style="background:#fff;border-left:4px solid #f59e0b;padding:10px 12px;margin-top:10px;border-radius:6px;">
              <p style="margin:0;font-size:16px;color:#78350f;font-weight:600;">
                ⚠ Credits must be used on the same day of purchase and cannot be transferred or accumulated for future orders.
              </p>
            </div>
          </div>
          <div style="background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:14px;">
            <h4 style="margin:0 0 12px;font-size:15px;font-weight:700;color:#111;">
             
            </h4>
            <div id="p2-products-container" style="display:flex;flex-direction:column;gap:10px;"></div>
          </div>`;

        renderP2Page();

      } else {
        // ════════════════════════════════════
        //  PRIORIDAD 1
        // ════════════════════════════════════
        const hasVariantIncentives = variantRows().some(row => {
          const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId] || {};
          return variantHasIncentive(extras);
        });

        if (!hasVariantIncentives && !rules.length) {
          incentivesSection.style.display = 'none';
        } else {
          incentivesSection.style.display = 'block';
          incentivesList.innerHTML = '<p style="text-align:center;color:#6b7280;padding:12px;">Loading...</p>';

          const allFPs = {};
          rules.forEach((rule, ri) => {
            rule._cacheKey = 'rule_' + ri;
            (rule.free_products || []).forEach(fp => { if (fp?.handle) allFPs[fp.handle] = fp; });
            (rule.free_testers  || []).forEach(tp => { if (tp?.handle) allFPs[tp.handle] = tp; });
          });

          const productDataMap = {};
          await Promise.all(Object.keys(allFPs).map(async handle => {
            if (productDataMap[handle]) return;
            try { const res = await fetch(`/products/${handle}.js`); if (res.ok) productDataMap[handle] = await res.json(); } catch {}
          }));

          const cache = {};
          rules.forEach(rule => {
            const mapItem = fp => {
              const pd    = productDataMap[fp.handle];
              const image = fp.image || (pd?.featured_image ? pd.featured_image.replace(/^\/\//, 'https://') : '');
              return { title: fp.title, variant_title: fp.variant_title || '', image };
            };
            cache[rule._cacheKey] = {
              products: (rule.free_products || []).map(mapItem),
              testers:  (rule.free_testers  || []).map(mapItem)
            };
          });

          // ── Collection rules HTML ──
          const collectionRulesHTML = rules.map((rule, idx) => {
            const minQ = Number(rule.min_qty || 0), minV = Number(rule.min_order_value || 0), disc = Number(rule.discount || 0);
            const auto = isAutoApply(rule);
            const condParts = [];
            if (minQ > 0) condParts.push(`<strong>${minQ} units</strong>`);
            if (minV > 0) condParts.push(`<strong>$${minV.toLocaleString()}</strong>`);
            const condSentence  = condParts.length ? 'When ordering at least ' + condParts.join(' and ') : '';
            const rewardParts   = [];
            if (Array.isArray(rule.free_testers) && rule.free_testers.length) {
              rule.free_testers.forEach((tp, i) => { if (tp?.title) rewardParts.push(`<strong>${getTesterQty(rule, i)}x tester:</strong> ${tp.title}`); });
            } else {
              const tot = normalizeQtyArray(rule.testers_qty).reduce((s, q) => s + q, 0);
              if (tot > 0) rewardParts.push(`<strong>${tot} tester${tot > 1 ? 's' : ''}</strong>`);
            }
            if (disc > 0) rewardParts.push(`<strong>${disc}% discount</strong>`);
            (rule.free_products || []).forEach((fp, i) => {
              if (!fp?.title) return;
              const dName = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? `${fp.title} — ${fp.variant_title}` : fp.title;
              rewardParts.push(`<strong>${normalizeQtyArray(rule.free_product_quantities)[i] || 1}x free:</strong> ${dName}`);
            });
            const sep            = auto ? ' + ' : ' <em>or</em> ';
            const rewardSentence = rewardParts.length ? ', ' + (auto ? 'you receive: ' : 'choose one: ') + rewardParts.join(sep) : '';
            const applyBadge     = auto
              ? '<span style="display:inline-block;background:#dcfce7;color:#166534;font-size:11px;font-weight:700;padding:2px 8px;border-radius:12px;margin-left:8px;">Auto</span>'
              : '<span style="display:inline-block;background:#fef9c3;color:#92400e;font-size:11px;font-weight:700;padding:2px 8px;border-radius:12px;margin-left:8px;">Choose reward</span>';
            let freeImgsRow = '';
            const cd = cache[rule._cacheKey];
            if (cd) {
              const makeCard = (item, qty, badge) => {
                const imgTag  = item.image ? `<img src="${item.image}" style="width:72px;height:72px;object-fit:cover;border-radius:10px;border:1px solid #e5e7eb;" onerror="this.style.display='none'">` : '<div style="width:72px;height:72px;border-radius:10px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:28px;"></div>';
                const badgeEl = `<span style="display:inline-block;background:#dcfce7;color:#166534;font-size:11px;font-weight:700;padding:1px 7px;border-radius:10px;margin-bottom:2px;">${qty}x ${badge}</span>`;
                const dName   = item.variant_title && item.variant_title.toLowerCase() !== 'default title' ? `${item.title}<br><span style="font-size:10px;color:#6b7280;font-weight:400;">${item.variant_title}</span>` : item.title;
                return `<div style="display:flex;flex-direction:column;align-items:center;gap:4px;text-align:center;max-width:90px;">${imgTag}${badgeEl}<span style="font-size:12px;color:#111;font-weight:600;line-height:1.3;">${dName}</span></div>`;
              };
              const allCards = [
                ...(cd.testers  || []).map((t, i) => makeCard(t, getTesterQty(rule, i), 'tester')),
                ...(cd.products || []).map((p, i) => makeCard(p, normalizeQtyArray(rule.free_product_quantities)[i] || 1, 'free'))
              ];
              if (allCards.length) freeImgsRow = `<div style="display:flex;flex-wrap:wrap;gap:16px;margin-top:12px;">${allCards.join('')}</div>`;
            }
            return `<div style="background:#fff;border:1px solid #e5e7eb;border-radius:12px;padding:14px 16px;${idx < rules.length - 1 ? 'margin-bottom:10px;' : ''}">
              <p style="margin:0;font-size:15px;color:#111;line-height:1.7;">${condSentence}${rewardSentence}${applyBadge}</p>
              ${freeImgsRow}
            </div>`;
          }).join('');

          // ── Acordeón por variante ──
          // ── Acordeón por variante ──
            const variantAccordions = [];
            variantRows().forEach(row => {
              const vid    = row.dataset.variantId;
              const extras = window.b2bVariantExtrasMap?.[vid] || {};
              if (!variantHasIncentive(extras)) return;

              const pName  = row.cells[5]?.textContent?.trim() || '';
              const ml     = row.cells[7]?.textContent?.trim() || '';
              const imgUrl = row.dataset.imgUrl || '';
              const fps    = getVariantFreeProducts(extras);
              const fqs    = getVariantFreeQtys(extras);
              const { minU, minV } = getVariantThresholds(extras);

              const condParts = [];
              if (minU > 0) condParts.push(`<strong>${minU} units</strong>`);
              if (minV > 0) condParts.push(`<strong>$${Number(minV).toLocaleString()}</strong>`);
              const condText = condParts.length ? 'Buy ' + condParts.join(' and ') : '';

              // ── Construir purchaseToGwp para este variante ──
              const purchaseToGwpAcc = fps.map((fp, fi) => {
                const fpImg2 = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
                const vid2   = String(fp.variant_id || '');
                const vd2    = window.b2bAllVariantsMap?.[vid2] || {};
                const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
                const ml2    = vd2.ml || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
                const pres2  = ex2.presentation || vd2.pres || '—';
                const pack2  = ex2.quantity > 0 ? ex2.quantity : '—';
                const qty2   = fqs[fi] || 1;
                return { fpImg: fpImg2, title: fp.title, ml: ml2, pres: pres2, pack: pack2, qty: qty2 };
              });

              const minUVal    = minU || '?';
              const arrowColors = ['#22c55e','#ec4899','#f59e0b','#3b82f6'];

              // ── EXAMPLES ──
              const examplesAccHTML = `
                <div style="margin-bottom:20px;">
                  <div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
                    <span style="font-size:16px;">⭐</span>
                    <span style="font-size:16px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Examples</span>
                  </div>
                  <div style="display:flex;flex-wrap:wrap;gap:10px;">
                    ${purchaseToGwpAcc.map(item => `
                      <div style="display:flex;align-items:center;gap:0;border-radius:14px;overflow:hidden;border:1px solid #e5e7eb;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,0.06);flex:1;min-width:200px;max-width:360px;">
                        <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:12px 8px;text-align:center;flex:1;">
                          ${imgUrl
                            ? `<img src="${imgUrl}" style="width:80px;height:110px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;">`
                            : `<div style="width:44px;height:44px;border-radius:8px;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-size:20px;">🛍️</div>`}
                          <div style="font-size:16px;font-weight:700;color:#111;">Buy ${minUVal} units</div>
                          <div style="font-size:14px;font-weight:600;color:#374151;">${pName}</div>
                        </div>
                        <div style="display:flex;align-items:center;justify-content:center;width:26px;flex-shrink:0;font-size:16px;font-weight:700;color:#276e31;background:#fff;">=</div>
                        <div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:4px;padding:12px 8px;text-align:center;flex:1;">
                          ${item.fpImg
                            ? `<img src="${item.fpImg}" style="width:80px;height:110px;object-fit:cover;border-radius:8px;">`
                            : `<div style="width:44px;height:44px;border-radius:8px;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:20px;">🎁</div>`}
                          <div style="font-size:12px;font-weight:700;color:#111;"></div>
                          <div style="font-size:16px;font-weight:700;color:#111;line-height:1.3;">${item.pack} x ${item.title}</div>
                          <div style="font-size:14px;color:#111;font-family: Crimson pro;">${item.pres} | ${item.ml} | Pack: ${item.qty}</div>
                         
                        </div>
                      </div>`).join('')}
                  </div>
                </div>`;

              // ── CONVERSION EQUIVALENCIES ──
              const equivAccHTML = `
                <div>
                  <div style="display:flex;align-items:center;gap:8px;margin-bottom:10px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">
                    <span style="font-size:16px;">⇄</span>
                    <span style="font-size:16px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Conversion Equivalencies</span>
                  </div>
                  <div style="overflow-x:auto;">
                    <table style="width:100%;border-collapse:collapse;font-family:'Crimson Pro',serif;">
                      <thead>
                        <tr style="background:#686a6c;color:#fff;">
                          <th style="padding:8px 12px;text-align:left;font-size:16px;font-weight:600;border-radius:6px 0 0 0;">If You Purchase</th>
                          <th style="padding:8px 12px;text-align:center;font-size:16px;font-weight:600;">You Can Receive (FOC)</th>
                          <th style="padding:8px 12px;text-align:center;font-size:16px;font-weight:600;border-radius:0 6px 0 0;">Equivalency (Either Way)</th>
                        </tr>
                      </thead>
                      <tbody>
                        ${purchaseToGwpAcc.map((item, idx) => `
                          <tr style="background:${idx % 2 === 0 ? '#fff' : '#f9fafb'};border-bottom:1px solid #e5e7eb;">
                            <td style="padding:10px 12px;vertical-align:middle;">
                              <div style="display:flex;align-items:center;gap:8px;">
                                ${imgUrl
                                  ? `<img src="${imgUrl}" style="width:80px;height:110px;object-fit:cover;border-radius:6px;border:1px solid #e5e7eb;flex-shrink:0;">`
                                  : `<div style="width:34px;height:34px;border-radius:6px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:14px;flex-shrink:0;">🛍️</div>`}
                                <div>
                                  <div style="font-size:16px;color:#111;">${minUVal} units of</div>
                                  <div style="font-size:16px;font-weight:700;color:#111;">${pName}</div>
                                </div>
                              </div>
                            </td>
                            <td style="padding:10px 12px;text-align:center;vertical-align:middle;">
                              <div style="display:flex;align-items:center;justify-content:center;gap:8px;">
                                
                                <div style="display:flex;flex-direction:column;align-items:center;gap:2px;">
                                  ${item.fpImg
                                    ? `<div style="width:80px;height:110px;overflow:hidden;background:#f0fdf4;">
                                        <img src="${item.fpImg}" style="width:100%;height:100%;object-fit:cover;">
                                      </div>`
                                    : `<div style="width:36px;height:36px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;font-size:16px;border:2px solid #bbf7d0;">🎁</div>`}
                                  <div style="font-size:16px;font-weight:700;color:#111;">${item.pack} x ${item.title}</div>
                                  <div style="font-size:16px;color:#111;">${item.pres} | ${item.ml} | Pack: ${item.qty}</div>
                                </div>
                              </div>
                            </td>
                            <td style="padding:10px 12px;text-align:center;vertical-align:middle;">
                              <div style="display:flex;align-items:center;justify-content:center;gap:6px;">
                                
                                <div style="font-size:14px;color:#111;text-align:left;">
                                  <div style="font-size:16px;font-weight:700;">${item.pack} ${item.pres} ${item.ml} = ${minU} units ${item.title} </div>
                                  
                                </div>
                              </div>
                            </td>
                          </tr>`).join('')}
                      </tbody>
                    </table>
                  </div>
                </div>`;

              const aId = `vacc-${vid}`;
              variantAccordions.push(`
                <div style="border:1px solid #e5e7eb;border-radius:10px;margin-bottom:8px;overflow:hidden;background:#fff;">
                  <button type="button" onclick="
                    var p=document.getElementById('${aId}');
                    var a=document.getElementById('aarr-${aId}');
                    var o=p.style.display!=='none';
                    p.style.display=o?'none':'block';
                    a.style.transform=o?'rotate(0deg)':'rotate(180deg)';
                  " style="width:100%;display:flex;align-items:center;gap:12px;padding:12px 14px;background:#fff;border:none;cursor:pointer;text-align:left;">
                    ${imgUrl
                      ? `<img src="${imgUrl}" style="width:46px;height:46px;object-fit:cover;border-radius:8px;flex-shrink:0;">`
                      : '<div style="width:46px;height:46px;border-radius:8px;background:#f3f4f6;flex-shrink:0;"></div>'}
                    <div style="flex:1;min-width:0;">
                      <div style="font-size:15px;font-weight:700;color:#111;">
                        ${pName} <span style="font-size:13px;color:#6b7280;font-weight:400;">— ${ml}</span>
                      </div>
                      <div style="font-size:14px;color:#111;margin-top:2px;font-family:'Crimson Pro',serif;">
                        ${condText} — choose 1 of ${fps.length} product${fps.length > 1 ? 's' : ''} for free
                      </div>
                    </div>
                    <svg id="aarr-${aId}" width="18" height="18" viewBox="0 0 16 16"
                      style="flex-shrink:0;transition:transform 0.25s;color:#9ca3af;">
                      <polyline points="4,6 8,10 12,6" stroke="currentColor" stroke-width="2"
                        fill="none" stroke-linecap="round" stroke-linejoin="round"/>
                    </svg>
                  </button>
                  <div id="${aId}" style="display:none;padding:14px;background:#fafafa;">
                    ${examplesAccHTML}
                    ${equivAccHTML}
                  </div>
                </div>`);
            });

          // ── Texto introductorio ──
          const introHTML = `
            <div style="margin-bottom:5px;margin:0px font-family:'Crimson Pro',serif;background:#f9fafb;border:1px solid #e5e7eb;border-radius:10px;padding:15px 16px;font-size:17px;color:#374151;line-height:1.6;">
              <p style="margin:0px">For this brand, rewards are based on purchase volume.</p>
              <p style="margin:0px">By purchasing the eligible quantities, you can receive one of the selected products for free as part of the promotion.</p>
              <p style="margin:0px">Below you will find the list of available reward options.</p>
              </div>`;
              
              // <p style="margin:0;font-size:15px;color:#6b7280;">Note: Promotions may apply individually to each product.</p>
          // ── Paginación P1 ──
          const PAGE_SIZE  = 5;
          let currentPage  = 0;
          const totalPages = Math.ceil(variantAccordions.length / PAGE_SIZE);

          function renderAccordionPage() {
            const start     = currentPage * PAGE_SIZE;
            const end       = start + PAGE_SIZE;
            const pageItems = variantAccordions.slice(start, end);
            const total     = variantAccordions.length;

            const paginationHTML = total > PAGE_SIZE ? `
              <div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding:10px 0;border-top:1px solid #e5e7eb;">
                <button type="button" onclick="window._accPrev()"
                  style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
                    background:${currentPage === 0 ? '#f3f4f6' : '#b8a77d'};
                    color:${currentPage === 0 ? '#9ca3af' : '#fff'};
                    font-size:14px;cursor:${currentPage === 0 ? 'not-allowed' : 'pointer'};
                    font-family:'Crimson Pro',serif;font-weight:600;">
                  ← Prev
                </button>
                <span style="font-size:13px;color:#6b7280;">
                  ${start + 1}–${Math.min(end, total)} of ${total} products
                </span>
                <button type="button" onclick="window._accNext()"
                  style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;
                    background:${currentPage >= totalPages - 1 ? '#f3f4f6' : '#b8a77d'};
                    color:${currentPage >= totalPages - 1 ? '#9ca3af' : '#fff'};
                    font-size:14px;cursor:${currentPage >= totalPages - 1 ? 'not-allowed' : 'pointer'};
                    font-family:'Crimson Pro',serif;font-weight:600;">
                  Next →
                </button>
              </div>` : '';

            const container = document.getElementById('acc-page-container');
            if (container) container.innerHTML = pageItems.join('') + paginationHTML;
          }

          window._accPrev = () => {
            if (currentPage > 0) { currentPage--; renderAccordionPage(); }
          };
          window._accNext = () => {
            if (currentPage < totalPages - 1) { currentPage++; renderAccordionPage(); }
          };

          // ── Combinar todo ──
          incentivesList.innerHTML =
            introHTML +
            (variantAccordions.length
              ? `<div style="margin-bottom:${collectionRulesHTML ? '16px' : '0'};">
                  <div id="acc-page-container"></div>
                </div>`
              : '') +
            (collectionRulesHTML
              ? (variantAccordions.length
                  ? `<div style="border-top:1px solid #e5e7eb;padding-top:16px;">${collectionRulesHTML}</div>`
                  : collectionRulesHTML)
              : '');

          if (variantAccordions.length) renderAccordionPage();
        }
      }

      // ── Botones exportación ──
      const expExcel = getEl('guidelines-export-excel-btn');
      const expPdf   = getEl('guidelines-export-pdf-btn');
      if (expExcel) {
        expExcel.onclick = () => exportGuidelines('excel');
        expExcel.style.display = (typeof XLSX !== 'undefined') ? '' : 'none';
      }
      if (expPdf) {
        expPdf.onclick = () => exportGuidelines('pdf');
        expPdf.style.display = (window.jspdf) ? '' : 'none';
      }
       const expSend = getEl('guidelines-export-send-btn');
      if (expSend) expSend.style.display = '';
      getEl('conditions-modal').style.display = 'flex';
    });
  }
/* ============================================================
   LISTENERS GLOBALES
   ============================================================ */

function initGlobalListeners() {
  const modalPairs = [
    ['brand-min-qty-modal-close', 'brand-min-qty-modal'],
    ['brand-min-qty-overlay',     'brand-min-qty-modal'],
    ['brand-min-value-modal-close','brand-min-value-modal'],
    ['brand-min-value-overlay',   'brand-min-value-modal'],
    ['min-qty-modal-close',       'min-qty-modal'],
    ['min-qty-overlay',           'min-qty-modal'],
    ['conditions-modal-close',    'conditions-modal'],
    ['conditions-modal-ok',       'conditions-modal'],
    ['conditions-overlay',        'conditions-modal'],
    ['reward-choice-close',       'reward-choice-modal'],
    ['reward-choice-overlay',     'reward-choice-modal'],
    ['sell-limit-modal-close',    'sell-limit-modal'],   
    ['sell-limit-overlay',        'sell-limit-modal'], 
  ];
  modalPairs.forEach(([triggerId, modalId]) => {
    getEl(triggerId)?.addEventListener('click', () => {
      const el = getEl(modalId);
      if (el) el.style.display = 'none';
      document.body.style.overflow = '';
    });
  });

  getEl('reward-choice-confirm')?.addEventListener('click', async () => {
    const rule = rewardChoice.active;
    if (!rule) return;
    const chosen = rewardChoice.chosenType;
    if (!chosen) { alert('Please select one reward option.'); return; }

    if (chosen === 'product' || chosen === 'tester') {
      if (!rewardChoice.chosenVariantId) {
        const handle = rewardChoice.chosenProductHandle;
        if (handle) {
          const v = await fetchFreeGiftVariant(handle, chosen);
          if (v) rewardChoice.chosenVariantId = String(v.id);
        }
        if (!rewardChoice.chosenVariantId && rewardChoice.chosenProductTitle) {
          try {
            const res = await fetch('/collections/' + getColHandle() + '/products.json?limit=250');
            if (res.ok) {
              const data  = await res.json();
              const match = (data.products || []).find(p => p.title.trim().toLowerCase() === rewardChoice.chosenProductTitle.trim().toLowerCase());
              if (match) {
                const v = chosen === 'tester' ? (match.variants.find(v => v.available) || match.variants[0]) : (match.variants.find(v => parseFloat(v.price) === 0) || match.variants[0]);
                if (v) { rewardChoice.chosenProductHandle = match.handle; rewardChoice.chosenVariantId = String(v.id); }
              }
            }
          } catch {}
        }
      }
      if (!rewardChoice.chosenVariantId) {
        alert('Could not find variant for: ' + (rewardChoice.chosenProductTitle || 'the selected product') + '. Please contact support.');
        return;
      }
    }

    rewardChoice.discountPct = chosen === 'discount' ? Number(rule.discount || 0) : 0;
    rewardChoice.confirmed   = true;
    closeRewardChoiceModal();
    updateIncentiveBanners();
    if (getEl('b2b-details-panel').classList.contains('expanded')) renderPurchaseDetails();
  });

  getEl('variant-reward-close')?.addEventListener('click', closeVariantRewardModal);
  getEl('variant-reward-overlay')?.addEventListener('click', closeVariantRewardModal);
  getEl('b2b-choose-reward-btn')?.addEventListener('click', openRewardChoiceModal);
  getEl('b2b-buy-btn')?.addEventListener('click', handleBuyNow);
  getEl('b2b-buy-now-bottom')?.addEventListener('click', handleBuyNow);

  initDetailsPanel();


  // ── Pre Order Share btn ──
 getEl('preorder-share-btn-panel')?.addEventListener('click', () => {
  getEl('catalog-download-btns')?.remove();
  getEl('incentives-download-btns')?.remove();
  getEl('preorder-download-btns')?.remove();
  document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

  const modeEl        = getEl('send-modal-mode');
  const titleEl       = getEl('send-modal-title');
  const formatSection = getEl('send-format-section');

  if (modeEl)        modeEl.value       = 'preorder';
  if (titleEl)       titleEl.textContent = 'Share Pre Order';
  if (formatSection) formatSection.style.display = '';

  const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
  if (excelRadio) excelRadio.checked = true;

  const dlBtns = document.createElement('div');
  dlBtns.id = 'preorder-download-btns';
  dlBtns.innerHTML = `
    <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
      <div style="width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
      </div>
      <div>
        <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Pre Order</div>
        <div style="font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
      </div>
    </div>
    <div style="display:flex;gap:12px;margin-bottom:12px;">
      <button type="button" id="preorder-dl-excel"
        style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
        <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
        <div style="text-align:left;">
          <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
          <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
        </div>
      </button>
      <button type="button" id="preorder-dl-pdf"
        style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
        <img src="${window._b2bPdfIconUrl}" width="32" height="28" alt="PDF">
        <div style="text-align:left;">
          <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
          <div style="font-size:12px;color:#6b7280;">.pdf format</div>
        </div>
      </button>
    </div>
    <div style="text-align:center;margin-bottom:16px;">
      <span style="font-family:'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:14px;color:#b8a77d;font-weight:600;">
        Instant download – No email required
      </span>
    </div>
    <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
      <span style="font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
    </div>
    <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
      <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>
      <div>
        <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Pre Order by Email</div>
        <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
      </div>
    </div>`;

  const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
  const firstLabel     = sendModalInner?.querySelector('label');
  if (firstLabel) firstLabel.parentNode.insertBefore(dlBtns, firstLabel);

  getEl('preorder-dl-excel')?.addEventListener('click', async () => {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generatePreOrderExcelBase64();
    if (!base64) return;
    const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `pre-order-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
    a.click(); URL.revokeObjectURL(url);
  });

  getEl('preorder-dl-pdf')?.addEventListener('click', async () => {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generatePreOrderPdfBase64();
    if (!base64) return;
    const blob = base64toBlob(base64, 'application/pdf');
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `pre-order-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
    a.click(); URL.revokeObjectURL(url);
  });

  const modal = getEl('send-modal');
  if (modal) modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
});

getEl('catalog-share-btn')?.addEventListener('click', () => {
  // Limpiar botones anteriores
  getEl('catalog-download-btns')?.remove();
  getEl('incentives-download-btns')?.remove();
  getEl('preorder-download-btns')?.remove();
  document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

  const modeEl        = getEl('send-modal-mode');
  const titleEl       = getEl('send-modal-title');
  const formatSection = getEl('send-format-section');

  if (modeEl)        modeEl.value       = 'catalog';
  if (titleEl)       titleEl.textContent = 'Product List';
  if (formatSection) formatSection.style.display = '';

  const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
  if (excelRadio) excelRadio.checked = true;

  const downloadBtns = document.createElement('div');
  downloadBtns.id = 'catalog-download-btns';
  downloadBtns.innerHTML = `
    <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
      <div style="width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
      </div>
      <div>
        <div style="font-family:'Crimson Pro';font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Product List</div>
        <div style="font-family:'Crimson Pro';font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
      </div>
    </div>
    <div style="display:flex;gap:12px;margin-bottom:12px;">
      <button type="button" id="catalog-dl-excel"
        style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
        <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
        <div style="text-align:left;">
          <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
          <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
        </div>
      </button>
      <button type="button" id="catalog-dl-pdf"
        style="font-family:'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;border-radius:10px;cursor:pointer;">
        <img src="${window._b2bPdfIconUrl}" width="40" height="30" alt="PDF">
        <div style="text-align:left;">
          <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
          <div style="font-size:12px;color:#6b7280;">.pdf format</div>
        </div>
      </button>
    </div>
    <div style="text-align:center;margin-bottom:16px;">
      <span style="font-family:'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:14px;color:#b8a77d;font-weight:600;">
        Instant download – No email required
      </span>
    </div>
    <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
      <span style="font-family:'Crimson Pro';font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
    </div>
    <div style="font-family:'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;">
      <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>
      <div>
        <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Product List by Email</div>
        <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
      </div>
    </div>`;

  const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
  const firstLabel     = sendModalInner?.querySelector('label');
  if (firstLabel) firstLabel.parentNode.insertBefore(downloadBtns, firstLabel);

  getEl('catalog-dl-excel')?.addEventListener('click', async () => {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generateCatalogBase64();
    if (!base64) return;
    const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
    a.click(); URL.revokeObjectURL(url);
  });

  getEl('catalog-dl-pdf')?.addEventListener('click', async () => {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generateCatalogPdfBase64();
    if (!base64) return;
    const blob = base64toBlob(base64, 'application/pdf');
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
    a.click(); URL.revokeObjectURL(url);
  });

  const modal = getEl('send-modal');
  if (modal) modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
});


// getEl('header-dl-excel')?.addEventListener('click', async () => {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//   const base64 = await generateCatalogBase64();
//   if (!base64) return;
//   const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
//   const url  = URL.createObjectURL(blob);
//   const a    = document.createElement('a');
//   a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
//   a.click(); URL.revokeObjectURL(url);
// });

// getEl('header-dl-pdf')?.addEventListener('click', async () => {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//   const base64 = await generateCatalogPdfBase64();
//   if (!base64) return;
//   const blob = base64toBlob(base64, 'application/pdf');
//   const url  = URL.createObjectURL(blob);
//   const a    = document.createElement('a');
//   a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
//   a.click(); URL.revokeObjectURL(url);
// });

function setIconBtnLoading(btn, loading) {
  if (!btn) return;
  const img     = btn.querySelector('.b2b-icon-btn-img');
  const spinner = btn.querySelector('.b2b-icon-btn-spinner');
  btn.classList.toggle('is-loading', loading);
  if (img)     img.style.display     = loading ? 'none'  : '';
  if (spinner) spinner.style.display = loading ? 'block' : 'none';
}

getEl('header-dl-excel')?.addEventListener('click', async function() {
  const btn = this;
  if (btn.classList.contains('is-loading')) return;
  setIconBtnLoading(btn, true);
  try {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generateCatalogBase64();
    if (base64) {
      const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
      a.click(); URL.revokeObjectURL(url);
    }
  } catch (err) {
    console.error('Error generating Excel:', err);
  } finally {
    setIconBtnLoading(btn, false);
  }
});

getEl('header-dl-pdf')?.addEventListener('click', async function() {
  const btn = this;
  if (btn.classList.contains('is-loading')) return;
  setIconBtnLoading(btn, true);
  try {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generateCatalogPdfBase64();
    if (base64) {
      const blob = base64toBlob(base64, 'application/pdf');
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url; a.download = `product-list-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
      a.click(); URL.revokeObjectURL(url);
    }
  } catch (err) {
    console.error('Error generating PDF:', err);
  } finally {
    setIconBtnLoading(btn, false);
  }
});

  document.addEventListener('click', e => {
    if (e.target.matches('.quickview-trigger')) {
      e.preventDefault();
      const handle = e.target.dataset.handle;
      if (!handle) return;
      const modal = getEl('quickview-modal'), body = getEl('quickview-body');
      body.innerHTML = '<p style="text-align:center;padding:60px 0;">Loading product...</p>';
      modal.style.display = 'flex';
      fetch(`/products/${handle}.js`)
        .then(r => { if (!r.ok) throw new Error('Not found'); return r.json(); })
        .then(product => {
          const price = new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(product.price / 100);
          body.innerHTML = `<div class="quickview-header"><h2>${product.title}</h2></div><div class="quickview-info"><div class="price">${price}</div><div>${product.description || ''}</div></div>`;
        })
        .catch(err => { body.innerHTML = `<p style="color:#c53030;text-align:center;padding:60px 0;">${err.message}</p>`; });
    }
    if (e.target.matches('.quickview-close') || e.target.matches('.quickview-overlay')) {
      getEl('quickview-modal').style.display = 'none';
    }
  });

  document.addEventListener('keydown', e => {
    if (e.key !== 'Escape') return;
    ['sku-detail-modal','min-qty-modal','brand-min-qty-modal','brand-min-value-modal',
     'conditions-modal','reward-choice-modal','variant-reward-modal'].forEach(id => {
      const el = getEl(id);
      if (el) el.style.display = 'none';
    });
    document.body.style.overflow = '';
  });

  const excelBtn = getEl('export-excel-btn');
  const excelTip = getEl('excel-tooltip');
  const MODAL_IDS = ['sku-detail-modal','conditions-modal','reward-choice-modal',
    'variant-reward-modal','min-qty-modal','brand-min-qty-modal','brand-min-value-modal'];
  if (excelBtn && excelTip) {
    excelBtn.addEventListener('mouseenter', () => {
      const anyOpen = MODAL_IDS.some(id => getEl(id)?.style.display === 'flex');
      if (!anyOpen) excelTip.style.display = 'block';
    });
    excelBtn.addEventListener('mouseleave', () => { excelTip.style.display = 'none'; });
  }

  const pdfBtn = getEl('export-pdf-btn');
  const pdfTip = getEl('pdf-tooltip');
  if (pdfBtn && pdfTip) {
    pdfBtn.addEventListener('mouseenter', () => {
      const anyOpen = MODAL_IDS.some(id => getEl(id)?.style.display === 'flex');
      if (!anyOpen) pdfTip.style.display = 'block';
    });
    pdfBtn.addEventListener('mouseleave', () => { pdfTip.style.display = 'none'; });
  }

    // Al final de initGlobalListeners(), antes del cierre
    getEl('reset-btn')?.addEventListener('click', () => {
      // Limpiar cantidades visuales
      variantRows().forEach(row => {
        const stepVal = row.querySelector('.step-value');
        const hidQty  = row.querySelector('.hidden-qty');
        const total   = row.querySelector('.b2b-row-total');
        const badge   = row.querySelector('.qty-badge');
        const plus    = row.querySelector('.step-plus');
        const minus   = row.querySelector('.step-minus');
        const stock   = parseInt(row.dataset.stock || 0);

        if (stepVal) stepVal.textContent = '0';
        if (hidQty)  hidQty.value = '0';
        if (total)   total.textContent = '0.00';
        if (badge)   { badge.textContent = '0'; badge.style.display = 'none'; }
        if (plus)    plus.disabled  = stock <= 0;
        if (minus)   minus.disabled = true;
        row.style.display = '';
      });

      // Limpiar combos multiselect
      B2B_COMBOS.forEach(combo => {
        Array.from(combo.select.options).forEach(o => o.selected = false);
        combo._updateLabel();
      });

      // Limpiar search
      const searchInput = getEl('b2b-search-input');
      const clearBtn    = getEl('b2b-search-clear');
      if (searchInput) searchInput.value = '';
      if (clearBtn)    clearBtn.style.display = 'none';

      // ── Resetear TODOS los estados de incentivos ──
      window.b2bVariantRewardChoices = {};
      window.b2bPriority2Choice = { confirmed: false, selections: [], totalSpent: 0, discountPct: 0 };
      window.b2bPriority3Choice = { confirmed: false, selections: [] };
      window.b2bVariantRewardChoices = {};
      window.b2bRewardChoice = {
        active: null, confirmed: false, chosenType: null,
        chosenVariantId: null, chosenProductHandle: null,
        chosenProductTitle: null, chosenProductImage: null,
        chosenQty: 1, discountPct: 0
      };

      b2bApplyFilters();
      updateTotals();
    });
}

/* ============================================================
   VIEW TOGGLE (View1 / View2)
   ============================================================ */

function initViewToggle() {
  const btn1 = getEl('view1-btn');
  const btn2 = getEl('view2-btn');
  if (!btn1 || !btn2) return;

  const colsToHide  = [3, 7, 8, 9, 10, 12];
  const filtersRow  = document.querySelector('.b2b-filters-row');
  let view2Inserted = false;

  function applyVisibility(show, table) {
  const headThs   = Array.from(table.querySelectorAll('thead tr:first-child th'));
  const filterThs = filtersRow ? Array.from(filtersRow.querySelectorAll('th')) : [];
  const bodyRows  = Array.from(table.querySelectorAll('tbody tr.b2b-variant-row'));

  colsToHide.forEach(i => {
    const disp = show ? '' : 'none';
    if (headThs[i])   headThs[i].style.display   = disp;
    if (filterThs[i]) filterThs[i].style.display = disp;
    bodyRows.forEach(row => {
      if (row.cells[i]) row.cells[i].style.display = disp;
    });
  });

  // ── INCENTIVES (col 13): visible en Price View, oculta en Score View ──
  const incentivesDisp = show ? '' : 'none';  // show=true es Price View
  if (headThs[13])   headThs[13].style.display   = incentivesDisp;
  if (filterThs[13]) filterThs[13].style.display = incentivesDisp;
  bodyRows.forEach(row => {
    if (row.cells[13]) row.cells[13].style.display = incentivesDisp;
  });
}

  function setView(view) {
    const table    = document.getElementById('ordenesTable');
    const bodyRows = Array.from(table.querySelectorAll('tbody tr.b2b-variant-row'));

    if (view === 'view1') {
       applyVisibility(true, table);
        table.querySelectorAll('.view2-th').forEach(el => el.remove());
        if (filtersRow) filtersRow.querySelectorAll('.view2-filter-th').forEach(el => el.remove());
        bodyRows.forEach(row => row.querySelectorAll('.view2-col').forEach(el => el.remove()));
        if (filtersRow) filtersRow.style.display = '';
        view2Inserted = false;

        // ── Restaurar columna INCENTIVES explícitamente ──
        const headThs2  = Array.from(table.querySelectorAll('thead tr:first-child th'));
        const filterThs2 = filtersRow ? Array.from(filtersRow.querySelectorAll('th')) : [];
        if (headThs2[13])  headThs2[13].style.display  = '';
        if (filterThs2[13]) filterThs2[13].style.display = '';
        variantRows().forEach(row => {
          if (row.cells[13]) row.cells[13].style.display = '';
        });

        btn1.style.background = '#b8a77d'; btn1.style.color = '#fff';
        btn2.style.background = '#afb0b0'; btn2.style.color = '#fff';

    } else {
      applyVisibility(false, table);

      if (!view2Inserted) {
        const headerRow = table.querySelector('thead tr:first-child');
        const qtyTh     = headerRow.querySelector('th:nth-last-child(2)');

        [
          { html: 'AI Artistic <br> Score',    col: 'combined_score' },
          { html: 'AI Commercial <br> Score',  col: 'brand_ranking'  },
          { html: 'AI Combined <br> Score',    col: 'total_score'    }
        ].forEach(({ html, col }) => {
          const th = document.createElement('th');
          th.className = 'b2b-th sortable view2-th';
          th.dataset.column = col;
          th.innerHTML = html;
          th.addEventListener('click', () => {
            const tbody = document.getElementById('ordenesTable').querySelector('tbody');
            const rows  = Array.from(tbody.querySelectorAll('tr.b2b-variant-row'));
            const dir   = th.classList.contains('asc') ? 'desc' : 'asc';
            document.querySelectorAll('.sortable').forEach(h => h.classList.remove('asc', 'desc'));
            th.classList.add(dir);
            rows.sort((a, b) => {
              const getCellVal = row => {
                const c = Array.from(row.querySelectorAll('td.view2-col'));
                const idx = col === 'combined_score' ? 0 : col === 'brand_ranking' ? 1 : 2;
                return parseFloat(c[idx]?.textContent) || 0;
              };
              const aV = getCellVal(a), bV = getCellVal(b);
              return dir === 'asc' ? aV - bV : bV - aV;
            });
            rows.forEach(row => tbody.appendChild(row));
          });
          headerRow.insertBefore(th, qtyTh);
        });

        if (filtersRow) {
          const filterQtyTh = filtersRow.querySelector('th:nth-last-child(2)');
          ['combined_score', 'brand_ranking'].forEach(col => {
            const th = document.createElement('th');
            th.className = 'b2b-th view2-filter-th';
            const uniqueVals = [];
            Array.from(document.getElementById('ordenesTable').querySelectorAll('tbody tr.b2b-variant-row')).forEach(row => {
              const handle = row.dataset.handle || '';
              const notes  = window.b2bNotesMap?.[handle] || {};
              const val = col === 'combined_score' ? notes.artistic_score : notes.brand_ranking;
              if (val && !uniqueVals.includes(String(val))) uniqueVals.push(String(val));
            });
            uniqueVals.sort((a, b) => parseFloat(a) - parseFloat(b));
            const label   = col === 'combined_score' ? 'Combined Score' : 'Brand Ranking';
            const selectId = `b2b-filter-${col}`;
            th.innerHTML = `
              <div class="b2b-combo" data-col="${col}" aria-expanded="false">
                <select id="${selectId}" multiple>
                  ${uniqueVals.map(v => `<option value="${v}">${v}</option>`).join('')}
                </select>
                <button type="button" class="b2b-toggle">
                  <span class="b2b-label">All</span><span class="b2b-caret">▼</span>
                </button>
                <div class="b2b-panel">
                  <input type="text" class="b2b-search" placeholder="Search ${label}...">
                  <div class="b2b-options"></div>
                  <div class="b2b-actions">
                    <button type="button" class="b2b-btn select-all">Select all</button>
                    <button type="button" class="b2b-btn clear">Clear</button>
                    <button type="button" class="b2b-btn apply">Apply</button>
                  </div>
                </div>
              </div>`;
            const comboRoot = th.querySelector('.b2b-combo');
            new B2BCombo(comboRoot);
            comboRoot.querySelector('.apply').addEventListener('click', applyView2Filters);
            filtersRow.insertBefore(th, filterQtyTh);
          });

          const totalScoreTh = document.createElement('th');
          totalScoreTh.className = 'b2b-th view2-filter-th';
          const totalScoreVals = [];
          Array.from(document.getElementById('ordenesTable').querySelectorAll('tbody tr.b2b-variant-row')).forEach(row => {
            const handle = row.dataset.handle || '';
            const notes  = window.b2bNotesMap?.[handle] || {};
            const val = String(notes.combined_score || '');
            if (val && !totalScoreVals.includes(val)) totalScoreVals.push(val);
          });
          totalScoreVals.sort((a, b) => parseFloat(a) - parseFloat(b));
          totalScoreTh.innerHTML = `
            <div class="b2b-combo" data-col="total_score" aria-expanded="false">
              <select id="b2b-filter-total_score" multiple>
                ${totalScoreVals.map(v => `<option value="${v}">${v}</option>`).join('')}
              </select>
              <button type="button" class="b2b-toggle">
                <span class="b2b-label">All</span><span class="b2b-caret">▼</span>
              </button>
              <div class="b2b-panel">
                <input type="text" class="b2b-search" placeholder="Search Total Score...">
                <div class="b2b-options"></div>
                <div class="b2b-actions">
                  <button type="button" class="b2b-btn select-all">Select all</button>
                  <button type="button" class="b2b-btn clear">Clear</button>
                  <button type="button" class="b2b-btn apply">Apply</button>
                </div>
              </div>
            </div>`;
          const totalScoreComboRoot = totalScoreTh.querySelector('.b2b-combo');
          new B2BCombo(totalScoreComboRoot);
          totalScoreComboRoot.querySelector('.apply').addEventListener('click', applyView2Filters);
          filtersRow.insertBefore(totalScoreTh, filterQtyTh);
        }

        bodyRows.forEach(row => {
          const qtyTd  = row.cells[13];
          const handle = row.dataset.handle || '';
          const notes  = window.b2bNotesMap?.[handle] || {};
          [
            notes.artistic_score || '—',
            notes.brand_ranking  || '—',
            notes.combined_score || '—'
          ].forEach(val => {
            const td = document.createElement('td');
            td.className = 'b2b-td view2-col';
            td.textContent = val;
            row.insertBefore(td, qtyTd);
          });
        });

        view2Inserted = true;
      }

      if (filtersRow) filtersRow.style.display = '';
      btn2.style.background = '#b8a77d'; btn2.style.color = '#fff';
      btn1.style.background = '#afb0b0'; btn1.style.color = '#fff';
    }
  }

  btn1.addEventListener('click', () => setView('view1'));
  btn2.addEventListener('click', () => setView('view2'));
}

function applyView2Filters() {
  const getSelectedVals = id => {
    const sel = document.getElementById(id);
    if (!sel) return [];
    return Array.from(sel.selectedOptions).map(o => o.value);
  };
  const csVals  = getSelectedVals('b2b-filter-combined_score');
  const brVals  = getSelectedVals('b2b-filter-brand_ranking');
  const refVals = getSelectedVals('b2b-filter-references');
  const tsVals  = getSelectedVals('b2b-filter-total_score');

  document.querySelectorAll('tbody tr.b2b-variant-row').forEach(row => {
    const cols = Array.from(row.querySelectorAll('td.view2-col'));
    if (!cols.length) return;
    const cs  = cols[0]?.textContent?.trim();
    const br  = cols[1]?.textContent?.trim();
    const ts  = cols[2]?.textContent?.trim();
    const handle = row.dataset.handle || '';
    const notes  = window.b2bNotesMap?.[handle] || {};
    const ref    = String(notes.references || '');

    const match =
      (!csVals.length  || csVals.includes(cs))   &&
      (!brVals.length  || brVals.includes(br))   &&
      (!refVals.length || refVals.includes(ref)) &&
      (!tsVals.length  || tsVals.includes(ts));

    row.style.display = match ? '' : 'none';
  });
}

/* ============================================================
   FOOTER PADDING DINÁMICO
   ============================================================ */

function initFooterPadding() {
  const footer  = getEl('b2b-footer');
  const wrapper = document.querySelector('.b2b-wrapper');
  if (!footer || !wrapper) return;
  function applyPadding() { wrapper.style.paddingBottom = footer.offsetHeight + 'px'; }
  applyPadding();
  if (window.ResizeObserver) {
    new ResizeObserver(applyPadding).observe(footer);
  } else {
    window.addEventListener('resize', applyPadding);
  }
}

/* ============================================================
   LOCK / UNLOCK UI
   ============================================================ */

function lockUI(mode = 'order') {
  document.querySelectorAll('.step-btn').forEach(btn => {
    btn.disabled = true; btn.style.pointerEvents = 'none';
  });
  const inputsToDisable = [
    getEl('b2b-search-input'), getEl('presentation-btn'), getEl('reset-btn'),
    getEl('conditions-btn'), getEl('export-all-products-btn'), getEl('export-excel-btn'),
    getEl('export-pdf-btn'), getEl('b2b-view-details-btn'), getEl('b2b-choose-reward-btn'),
    getEl('view1-btn'), getEl('view2-btn'),
  ];
  inputsToDisable.forEach(el => {
    if (el) { el.disabled = true; el.style.pointerEvents = 'none'; el.style.opacity = '0.5'; }
  });
  document.querySelectorAll('.b2b-toggle').forEach(btn => {
    btn.disabled = true; btn.style.pointerEvents = 'none'; btn.style.opacity = '0.5';
  });

  let overlay = getEl('b2b-processing-overlay');
  if (!overlay) {
    overlay = document.createElement('div');
    overlay.id = 'b2b-processing-overlay';
    overlay.style.cssText = 'position:fixed;inset:0;background:rgba(0,0,0,0.25);z-index:99998;display:flex;align-items:center;justify-content:center;cursor:not-allowed;';
    document.body.appendChild(overlay);
  }

  // ── Siempre actualizar el contenido según el modo ──
  const title    = mode === 'email' ? 'Sending email...'                    : 'Processing your order...';
  const subtitle = mode === 'email' ? 'Please wait, do not close this page.' : 'Please wait, do not close this page.';

  overlay.innerHTML = `
    <div style="background:white;border-radius:16px;padding:32px 48px;text-align:center;box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;">
      <img src="${(window._b2bLogoUrl || '').replace(/^\/\//, 'https://')}" alt="Logo"
        style="width:140px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
        onerror="this.style.display='none'">
      <div style="font-size:1.6rem;font-weight:700;color:#1f2937;margin-bottom:6px;">${title}</div>
      <div style="font-size:1.2rem;color:#6b7280;">${subtitle}</div>
    </div>`;

  overlay.style.display = 'flex';
  
}

function unlockUI() {
  document.querySelectorAll('.step-btn').forEach(btn => {
    const row = btn.closest('tr');
    const stock = parseInt(row?.dataset.stock || 0);
    if (stock > 0) { btn.disabled = false; btn.style.pointerEvents = ''; }
  });
  const inputsToEnable = [
    getEl('b2b-search-input'), getEl('presentation-btn'), getEl('reset-btn'),
    getEl('conditions-btn'), getEl('export-all-products-btn'), getEl('export-excel-btn'),
    getEl('export-pdf-btn'), getEl('b2b-view-details-btn'), getEl('b2b-choose-reward-btn'),
    getEl('view1-btn'), getEl('view2-btn'),
  ];
  inputsToEnable.forEach(el => {
    if (el) { el.disabled = false; el.style.pointerEvents = ''; el.style.opacity = ''; }
  });
  document.querySelectorAll('.b2b-toggle').forEach(btn => {
    btn.disabled = false; btn.style.pointerEvents = ''; btn.style.opacity = '';
  });
  const overlay = getEl('b2b-processing-overlay');
  if (overlay) overlay.style.display = 'none';
}



function openOrderRulesModal(btn) {
  var vid    = btn.dataset.variantId;
  var handle = btn.dataset.handle;
  var row    = document.querySelector('.b2b-variant-row[data-variant-id="' + vid + '"]');
  var notes  = window.b2bNotesMap?.[handle] || {};
  var extras = window.b2bVariantExtrasMap?.[vid] || {};

  // Nombre producto
  var productName = row ? (row.cells[5]?.textContent?.trim() || handle) : handle;
  document.getElementById('orm-product-name').textContent = productName;

  // SKU / Collection / ML
  var sku  = (row?.dataset?.sku || '').toUpperCase();
  var coll = row ? (row.cells[4]?.textContent?.trim() || '') : (notes.collection || '');
  var ml   = row ? (row.cells[7]?.textContent?.trim() || '') : '';
  document.getElementById('orm-sku').textContent        = sku  ? sku  : '';
  document.getElementById('orm-collection').textContent = coll ? coll : '';
  document.getElementById('orm-ml').textContent         = ml   ? ml   : '';
  document.getElementById('orm-collection-sep').style.display = (sku && coll) ? '' : 'none';
  document.getElementById('orm-ml-sep').style.display         = (coll && ml)  ? '' : 'none';

  // Precio wholesale
  var wholesale = row ? parseFloat(row.dataset.unitPrice || 0) : 0;
  document.getElementById('orm-wholesale').textContent = wholesale > 0
    ? '$' + wholesale.toLocaleString('en-US', {minimumFractionDigits:2, maximumFractionDigits:2})
    : '—';

  // Descripción
  var desc = row ? (row.dataset.description || 'No description available.') : 'No description available.';
  document.getElementById('orm-description').textContent = desc;

  // Notas olfativas
  var topN    = row ? parseNotes(row.dataset.topNotes)    : (parseNotes(notes.top)    || '—');
  var middleN = row ? parseNotes(row.dataset.middleNotes) : (parseNotes(notes.middle) || '—');
  var baseN   = row ? parseNotes(row.dataset.baseNotes)   : (parseNotes(notes.base)   || '—');
  document.getElementById('orm-top').textContent    = topN    || '—';
  document.getElementById('orm-middle').textContent = middleN || '—';
  document.getElementById('orm-base').textContent   = baseN   || '—';

  // MSRP / Coeff
  var msrp  = row ? (row.cells[11]?.textContent?.trim() || '—') : '—';
  var coeff = row ? (row.cells[10]?.textContent?.trim() || '—') : '—';
  document.getElementById('orm-msrp').textContent  = msrp;
  document.getElementById('orm-coeff').textContent = coeff;

  // Incentivos
  var incSection = document.getElementById('orm-incentives-section');
  var incBody    = document.getElementById('orm-incentive-body');
  var incProds   = document.getElementById('orm-incentive-products');
  var priority   = Number(window.b2bCollectionPriority || 1);

  if (b2bIsCreditPriority(priority)) {
    var discPct      = parseFloat(window.b2bCollectionDiscount || 0);
    var minAmount    = parseFloat(window.b2bDiscountMinAmount  || 0);
    var discProducts = (Number(window.b2bCollectionPriority || 1) === 4 ? b2bBuildP4Products({ productId: row?.dataset?.productId }) : (window.b2bDiscountProducts || []));

    if (discPct > 0 && discProducts.length > 0) {
      incSection.style.display = 'block';

      incBody.innerHTML =
        '<div style="margin-bottom:14px;">'
        + '<p style="font-size:17px;color:#1f2937;line-height:1.7;margin:0 0 12px 0;">'
          + 'For purchases of <strong style="color:#000;">$' + minAmount.toLocaleString('en-US', { minimumFractionDigits: 2 }) + '</strong> '
          + 'or more, you will receive a <strong style="color:#000;">' + discPct + '%</strong> '
          + 'credit that can be used on selected products.'
        + '</p>'
        + '<div style="border-left:5px solid #d97706;padding:12px 15px;border-radius:8px;margin-top:10px;">'
          + '<p style="margin:0 0 6px 0;font-size:15px;font-weight:700;color:#92400e;">⚠ Important Notice</p>'
          + '<p style="margin:0;font-size:15px;line-height:1.6;color:#78350f;font-weight:700;">'
            + 'Credits must be used during the current purchase and cannot be carried over or accumulated for future orders.'
          + '</p>'
        + '</div>'
        + '</div>';

      // ── Construir filas de tabla ──
     // ── Construir filas de tabla ──
      var ormRows = discProducts.map(function(p, ri) {
        if (!p?.title) return '';
        var imgSrc    = (p.image || '').replace(/^\/\//, 'https://');
        var varTitle  = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
        var vid2      = String(p.variant_id || '');
        var extras2   = window.b2bVariantExtrasMap?.[vid2] || {};
        var notes2    = window.b2bNotesMap?.[p.handle]     || {};
        var varData2  = window.b2bAllVariantsMap?.[vid2]   || {};
        var tableRow2 = document.querySelector('.b2b-variant-row[data-variant-id="' + vid2 + '"]');
        var metaPrice = parseFloat(p.incentive_product_price || extras2.incentive_product_price || 0);
        var realPrice = metaPrice > 0 ? metaPrice : tableRow2 ? parseFloat(tableRow2.dataset.unitPrice || p.price || 0) : parseFloat(p.price || 0);
        var sku2       = varData2.sku        || (tableRow2 ? (tableRow2.dataset.sku || '').toUpperCase() : '—');
        var ml2        = varData2.ml         || (tableRow2 ? tableRow2.cells[7]?.textContent?.trim() : '') || varTitle || '—';
        var pres2      = varData2.pres       || (tableRow2 ? tableRow2.cells[8]?.textContent?.trim() : '') || '—';
        var collection2= varData2.collection || notes2.collection || (tableRow2 ? tableRow2.cells[4]?.textContent?.trim() : '') || '—';
        // var coeff2     = varData2.coefficient || notes2.coefficient || (tableRow2 ? tableRow2.cells[10]?.textContent?.trim() : '') || '—';
        var bgColor    = ri % 2 === 0 ? '#fff' : '#f9fafb';

        var tdStyle   = 'padding:10px 8px;vertical-align:middle;font-size:13px;color:#374151;text-align:center;max-width:120px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';
        var tdStyleSm = 'padding:10px 8px;vertical-align:middle;font-size:13px;color:#374151;text-align:center;max-width:70px;overflow:hidden;text-overflow:ellipsis;white-space:nowrap;';

        return ''
          + '<tr style="background:' + bgColor + ';border-bottom:1px solid #e5e7eb;">'

          // Photo
          + '<td style="padding:10px 8px;text-align:center;vertical-align:middle;width:72px;">'
          + (imgSrc
            ? '<img src="' + imgSrc + '" style="width:56px;height:56px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;display:block;margin:0 auto;" onerror="this.style.display=\'none\'">'
            : '<div style="width:56px;height:56px;border-radius:8px;background:#dbeafe;display:inline-flex;align-items:center;justify-content:center;font-size:20px;margin:0 auto;">🏷️</div>')
          + '</td>'

          // Product
          + '<td style="padding:10px 8px;vertical-align:center;min-width:100px;max-width:150px;">'
          + '<div style="font-weight:700;color:#111;font-size:16px;white-space:normal;word-break:break-word;">' + p.title + '</div>'
          
          + '</td>'

          // SKU
          + '<td style="' + tdStyle + '" title="' + sku2 + '">' + sku2 + '</td>'

          // ML
          + '<td style="' + tdStyleSm + '">' + ml2 + '</td>'

          // Presentation
          + '<td style="' + tdStyle + '">' + pres2 + '</td>'

          // Collection
          + '<td style="' + tdStyle + ';max-width:130px;" title="' + collection2 + '">' + collection2 + '</td>'

          // Coefficient
          // + '<td style="' + tdStyleSm + '">' + coeff2 + '</td>'

          // Price
          + '<td style="padding:10px 8px;text-align:center;vertical-align:middle;font-size:15px;font-weight:700;color:#111;white-space:nowrap;min-width:70px;">$' + realPrice.toFixed(2) + '</td>'

          + '</tr>';
      });

      // ── Paginación ──
      var ORM_PAGE_SIZE  = 10;
      var ormPage        = 0;
      var ormTotalPages  = Math.ceil(ormRows.length / ORM_PAGE_SIZE);

      function renderOrmPage() {
        var start     = ormPage * ORM_PAGE_SIZE;
        var end       = start + ORM_PAGE_SIZE;
        var total     = ormRows.length;
        var pageItems = ormRows.slice(start, end);

        var tbody = document.getElementById('orm-table-body');
        if (tbody) tbody.innerHTML = pageItems.join('');

        var paginationEl = document.getElementById('orm-pagination');
        if (paginationEl) {
          paginationEl.innerHTML = total > ORM_PAGE_SIZE
            ? '<div style="display:flex;align-items:center;justify-content:space-between;margin-top:10px;padding:10px 0;border-top:1px solid #e5e7eb;">'
                + '<button type="button" onclick="window._ormPrev()" style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;background:' + (ormPage === 0 ? '#f3f4f6' : '#b8a77d') + ';color:' + (ormPage === 0 ? '#9ca3af' : '#fff') + ';font-size:14px;cursor:' + (ormPage === 0 ? 'not-allowed' : 'pointer') + ';font-family:\'Crimson Pro\',serif;font-weight:600;">← Prev</button>'
                + '<span style="font-size:13px;color:#6b7280;">' + (start + 1) + '–' + Math.min(end, total) + ' of ' + total + ' products</span>'
                + '<button type="button" onclick="window._ormNext()" style="padding:6px 18px;border:1px solid #e5e7eb;border-radius:8px;background:' + (ormPage >= ormTotalPages - 1 ? '#f3f4f6' : '#b8a77d') + ';color:' + (ormPage >= ormTotalPages - 1 ? '#9ca3af' : '#fff') + ';font-size:14px;cursor:' + (ormPage >= ormTotalPages - 1 ? 'not-allowed' : 'pointer') + ';font-family:\'Crimson Pro\',serif;font-weight:600;">Next →</button>'
              + '</div>'
            : '';
        }
      }

      window._ormPrev = function() { if (ormPage > 0) { ormPage--; renderOrmPage(); } };
      window._ormNext = function() { if (ormPage < ormTotalPages - 1) { ormPage++; renderOrmPage(); } };

      incProds.innerHTML =
        '<div style="overflow-x:auto;margin-top:8px;-webkit-overflow-scrolling:touch;">'
        + '<table style="width:100%;min-width:600px;border-collapse:collapse;font-family:\'Crimson Pro\',serif;table-layout:fixed;">'
        + '<colgroup>'
        + '<col style="width:72px;">'
        + '<col style="width:150px;">'
        + '<col style="width:130px;">'
        + '<col style="width:70px;">'
        + '<col style="width:90px;">'
        + '<col style="width:130px;">'
     
        + '<col style="width:80px;">'
        + '</colgroup>'
        + '<thead>'
        + '<tr style="background:#686a6c;color:#fff;">'
        + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Photo</th>'
        + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Product</th>'
        + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">SKU</th>'
        + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">ML</th>'
        + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Presentation</th>'
        + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Collection</th>'
        
        + '<th style="padding:10px 8px;text-align:center;font-weight:600;font-size:18px;">Price</th>'
        + '</tr>'
        + '</thead>'
        + '<tbody id="orm-table-body"></tbody>'
        + '</table>'
        + '</div>'
        + '<div id="orm-pagination"></div>';

      renderOrmPage();

    } else {
      incSection.style.display = 'none';
      incBody.innerHTML  = '';
      incProds.innerHTML = '';
    }

  } else {
   var isFirst = (window._b2bOrdersCount || 0) === 0;

      
      var listFirst = (extras.free_product_first_order && extras.free_product_first_order.length)
        ? extras.free_product_first_order : (extras.free_products || []);
      var listNext  = (extras.free_product_next_order && extras.free_product_next_order.length)
        ? extras.free_product_next_order : (extras.free_products || []);
      var fps = isFirst ? (listFirst.length ? listFirst : listNext)
                        : (listNext.length  ? listNext  : listFirst);

      var qtyFirst = (extras.free_product_first_qty && extras.free_product_first_qty.length)
        ? extras.free_product_first_qty : (extras.free_product_quantities || []);
      var qtyNext  = (extras.free_product_next_qty && extras.free_product_next_qty.length)
        ? extras.free_product_next_qty : (extras.free_product_quantities || []);
      var fqs = isFirst ? (qtyFirst.length ? qtyFirst : qtyNext)
                        : (qtyNext.length  ? qtyNext  : qtyFirst);

      var uFirst = Number(extras.incentive_product || 0), uNext = Number(extras.next_incentive_product || 0);
      var vFirst = Number(extras.incentive_value   || 0), vNext = Number(extras.next_incentive_value   || 0);
      var minU = isFirst ? (uFirst > 0 ? uFirst : uNext) : (uNext > 0 ? uNext : uFirst);
      var minV = isFirst ? (vFirst > 0 ? vFirst : vNext) : (vNext > 0 ? vNext : vFirst);

      console.log('[FOC modal]', { vid, priority, isFirst, minU, minV, fps, fqs, extras });
    if (fps.length > 0 && (minU > 0 || minV > 0)) {
      incSection.style.display = 'block';
      var condParts = [];
      if (minU > 0) condParts.push('<strong>' + minU + ' units</strong>');
      if (minV > 0) condParts.push('order value of <strong>$' + Number(minV).toLocaleString() + '</strong>');
      var getText = fps.map(function(fp, i) {
        var qty  = fqs[i] || 1;
        var name = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
          ? fp.title + ' ' + fp.variant_title : fp.title;
        return '<br><strong>' + qty + 'x</strong> ' + name;
      }).join(' or ');
      incBody.innerHTML = (condParts.length ? 'For every ' + condParts.join(' and ') + '. ' : '')
        + (getText ? 'purchased, receive FOC ' : '');
          // ── Construir datos agrupados ──
          var purchaseToGwp = fps.map(function(fp, i) {
            var qty2         = fqs[i] || 1;
            var vid2         = String(fp.variant_id || '');
            var varData2     = window.b2bAllVariantsMap?.[vid2] || {};
            var extras2      = window.b2bVariantExtrasMap?.[vid2] || {};
            var imgSrc       = fp.image ? fp.image.replace(/^\/\//, 'https://') : '';
            var ml2          = varData2.ml || (fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '') || '—';
            var pres2 = extras2.presentation || varData2.pres || '—';
            var unitsPerPack = extras2.quantity > 0 ? extras2.quantity : '—';
            var name         = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title'
              ? fp.title  : fp.title;
            return { imgSrc, name, ml2, pres2, unitsPerPack, qty: qty2 };
          });

          var condText = condParts.length ? condParts.join(' and ') : '';

          // ── Imagen y nombre del producto principal ──
          var mainImgSrc      = row ? (row.dataset.imgUrl || '') : '';
          var mainProductName = row ? (row.cells[5]?.textContent?.trim() || '') : '';

          // ── EXAMPLES ──
          var examplesHTML = '<div style="margin-bottom:24px;">'
            + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:14px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">'
            + '<span style="font-size:18px;">⭐</span>'
            + '<span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Examples</span>'
            + '</div>'
            + '<div style="display:flex;flex-wrap:wrap;gap:14px;justify-content:flex-start;">'
            + purchaseToGwp.map(function(item) {
                var gwpBg = '#f0fdf4';
                var gwpBorder = '#bbf7d0';
                return '<div style="display:flex;align-items:center;gap:0;border-radius:14px;overflow:hidden;border:1px solid #e5e7eb;background:#fff;box-shadow:0 1px 4px rgba(0,0,0,0.06);flex:1;min-width:220px;max-width:409px;">'

                  // Lado izquierdo: producto comprado
                  + '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:16px 12px;text-align:center;flex:1;">'
                  + (mainImgSrc
                    ? '<img src="' + mainImgSrc + '" style="width:80px;height:110px;object-fit:cover;border-radius:8px;border:1px solid #e5e7eb;">'
                    : '<div style="width:54px;height:54px;border-radius:8px;background:#e5e7eb;display:flex;align-items:center;justify-content:center;font-size:24px;">🛍️</div>')
                  + '<div style="font-size:16px;font-weight:700;color:#111;">Buy ' + condText + ' units</div>'
                  + '<div style="font-size:16px;font-weight:600;color:#374151;">' + mainProductName + '</div>'
                  + '<div style="font-size:13px;color:#9ca3af;"></div>'
                  + '</div>'

                  // Signo = centrado entre los dos lados
                  + '<div style="display:flex;align-items:center;justify-content:center;width:32px;flex-shrink:0;font-size:20px;font-weight:700;color:#276e31;background:#fff;">=</div>'

                  // Lado derecho: GWP
                  + '<div style="display:flex;flex-direction:column;align-items:center;justify-content:center;gap:2px;padding:16px 12px;text-align:center;flex:1;">'
                  + (item.imgSrc
                    ? '<img src="' + item.imgSrc + '" style="width:80px;height:110px;object-fit:cover;border-radius:8px;">'
                    : '<div style="width:54px;height:54px;border-radius:8px;background:#dcfce7;display:flex;align-items:center;justify-content:center;font-size:24px;"></div>')
                  
                  + '<div style="font-size:16px;font-weight:700;color:#000;line-height:1.3;"> ' + item.unitsPerPack  + ' x ' + item.name + '</div>'
                  + '<div style="font-size:16px;color:#111;font-family:Crimson pro;">' + item.pres2 + ' | ' + item.ml2 + ' | Pack: ' + item.qty + '</div>'
                  // + '<div style="font-size:13px;font-weight:700;color:#000;margin-top:2px;">as GWP</div>'
                  + '</div>'

                  + '</div>';
              }).join('')
            + '</div>'
            + '</div>';

          // ── CONVERSION EQUIVALENCIES ──
          var tableHTML = '<div>'
            + '<div style="display:flex;align-items:center;gap:8px;margin-bottom:12px;padding-bottom:8px;border-bottom:2px solid #e9d97a;">'
            + '<span style="font-size:18px;">⇄</span>'
            + '<span style="font-size:13px;font-weight:700;color:#374151;text-transform:uppercase;letter-spacing:1px;">Conversion Equivalencies</span>'
            + '</div>'
            + '<div style="overflow-x:auto;">'
            + '<table style="width:100%;border-collapse:collapse;font-family:\'Crimson Pro\',serif;">'
            + '<thead>'
            + '<tr style="background:#686a6c;color:#fff;">'
            + '<th style="padding:10px 14px;text-align:left;font-size:16px;font-weight:600;border-radius:8px 0 0 0;">If You Purchase</th>'
            + '<th style="padding:10px 14px;text-align:center;font-size:16px;font-weight:600;">You Can Receive (FOC)</th>'
            + '<th style="padding:10px 14px;text-align:center;font-size:16px;font-weight:600;border-radius:0 8px 0 0;">Equivalency (Either Way)</th>'
            + '</tr>'
            + '</thead>'
            + '<tbody>'
            + purchaseToGwp.map(function(item, idx) {
                var arrowColors = ['#22c55e','#ec4899','#f59e0b','#3b82f6'];
                var arrowColor  = arrowColors[idx % arrowColors.length];
                var bgColor     = idx % 2 === 0 ? '#fff' : '#f9fafb';
                return '<tr style="background:' + bgColor + ';border-bottom:1px solid #e5e7eb;">'

                  // Col 1
                  + '<td style="padding:12px 14px;vertical-align:middle;">'
                  + '<div style="display:flex;align-items:center;gap:10px;">'
                  + (mainImgSrc
                    ? '<img src="' + mainImgSrc + '" style="width:80px;height:110px;object-fit:cover;border-radius:6px;border:1px solid #e5e7eb;flex-shrink:0;">'
                    : '<div style="width:38px;height:38px;border-radius:6px;background:#f3f4f6;display:flex;align-items:center;justify-content:center;font-size:18px;flex-shrink:0;">🛍️</div>')
                  + '<div>'
                  + '<div style="font-size:16px;color:#111;">' + condText + ' units of</div>'
                  + '<div style="font-size:16px;font-weight:700;color:#111;">' + mainProductName + '</div>'
                  + '</div>'
                  + '</div>'
                  + '</td>'

                  // Col 2
                  + '<td style="padding:12px 14px;text-align:center;vertical-align:middle;">'
                  + '<div style="display:flex;align-items:center;justify-content:center;gap:10px;">'
                  // + '<span style="font-size:18px;color:' + arrowColor + ';">→</span>'
                  + '<div style="display:flex;flex-direction:column;align-items:center;gap:3px;">'
                  + (item.imgSrc
                    ? '<div style="width:80px;height:110px;;overflow:hidden;display:flex;align-items:center;justify-content:center;">'
                      + '<img src="' + item.imgSrc + '" style="width:80px;height:110px;object-fit:cover;">'
                      + '</div>'
                    : '<div style="width:40px;height:40px;background:#f0fdf4;display:flex;align-items:center;justify-content:center;font-size:18px;border:2px solid #bbf7d0;">🎁</div>')
                  + '<div style="font-size:16px;font-weight:700;color:#111;">' + item.unitsPerPack + 'x ' + item.name + '</div>'
                  + '<div style="font-size:16px;color:#111;">'+ item.pres2 + ' | ' + item.ml2 + ' | Pack: ' + item.qty  + '</div>'
                  + '</div>'
                  + '</div>'
                  + '</td>'

                  // Col 3
                  + '<td style="padding:12px 14px;text-align:center;vertical-align:middle;">'
                  + '<div style="display:flex;align-items:center;justify-content:center;gap:8px;">'
                  // + '<span style="font-size:16px;color:#f59e0b;">⇄</span>'
                  + '<div style="font-size:16px;color:#111;font-family: Crimson pro;text-align:left;">'
                  + '<div style="font-weight:700;">' + item.unitsPerPack + ' '+ item.pres2 + ' '+ item.ml2 +' = '+ condText + '  ' + item.name + '</div>'
                  // + '<div style="color:#6b7280;">= ' + condText + ' units</div>'
                  + '</div>'
                  + '</div>'
                  + '</td>'
                  + '</tr>';
              }).join('')
            + '</tbody></table></div></div>';

          incProds.innerHTML = examplesHTML + tableHTML;


    } else {
      incSection.style.display = 'none';
      incBody.innerHTML  = '';
      incProds.innerHTML = '';
    }
  }

  // Galería de imágenes (fetch producto)
  var mainImg  = document.getElementById('orm-main-img');
  var thumbsEl = document.getElementById('orm-thumbs');
  mainImg.src  = row ? (row.dataset.imgUrl || '') : '';
  thumbsEl.innerHTML = '';

  if (handle) {
    fetch('/products/' + handle + '.js').then(function(r){ return r.json(); }).then(function(product) {
      if (!product?.images?.length) return;
      product.images.forEach(function(img, i) {
        var src = (typeof img === 'string' ? img : img.src || '').replace(/^\/\//, 'https://');
        var thumb = document.createElement('img');
        thumb.className = 'sku-modal-thumb' + (i === 0 ? ' active' : '');
        thumb.src = src; thumb.width = 56; thumb.height = 56;
        thumb.addEventListener('click', function() {
          mainImg.src = src;
          document.querySelectorAll('#orm-thumbs .sku-modal-thumb').forEach(function(t){ t.classList.remove('active'); });
          thumb.classList.add('active');
        });
        thumbsEl.appendChild(thumb);
        if (i === 0) mainImg.src = src;
      });
    }).catch(function(){});
  }

  document.getElementById('order-rules-modal').style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closeOrderRulesModal() {
  document.getElementById('order-rules-modal').style.display = 'none';
  document.body.style.overflow = '';
}

document.getElementById('order-rules-overlay')?.addEventListener('click', closeOrderRulesModal);



/* ============================================================
EXPORT GUIDELINES — PDF y Excel
============================================================ */
function exportGuidelines(format) {
  const vendor    = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
  const colHandle = getColHandle();
  const priority  = Number(window.b2bCollectionPriority || 1);

  // const firstUnits = window.b2bBrandMinQtyMap?.[colHandle] || '—';
  // const firstValue = window.b2bBrandMinValueMap?.[colHandle]
  //   ? '$' + parseFloat(window.b2bBrandMinValueMap[colHandle]).toFixed(2) : '—';
  const nextUnits  = window.b2bBrandNextOrderMap?.[colHandle] || '—';
  const nextValue  = window.b2bBrandNextOrderValueMap?.[colHandle]
    ? '$' + parseFloat(window.b2bBrandNextOrderValueMap[colHandle]).toFixed(2) : '—';

  // ── Helper precio ──
  function getIncentivePrice(p) {
    const metaP = parseFloat(p.incentive_product_price || 0);
    if (metaP > 0) return metaP;
    const vid2    = String(p.variant_id || '');
    const extras2 = window.b2bVariantExtrasMap?.[vid2] || {};
    const metaP2  = parseFloat(extras2.incentive_product_price || 0);
    if (metaP2 > 0) return metaP2;
    return parseFloat(p.price || 0);
  }

  if (format === 'excel') {
    const data = [];

    // ── Cabecera ──
    data.push([`Brand Incentive — ${vendor}`]);
    data.push([]);
    // data.push(['First Order — Min Units:', firstUnits, 'Min Value:', firstValue]);
    // data.push(['Next Order  — Min Units:', nextUnits,  'Min Value:', nextValue]);
    data.push([]);

    if (b2bIsCreditPriority(priority)) {
      // ── P2 ──
      const discPct    = parseFloat(window.b2bCollectionDiscount || 0);
      const minAmount  = parseFloat(window.b2bDiscountMinAmount  || 0);
      const discProds  = (Number(window.b2bCollectionPriority || 1) === 4 ? b2bBuildP4Products({ all: true }) : (window.b2bDiscountProducts || []));

      data.push([`Volume Incentives — ${discPct}% Credit`]);
      data.push([`Minimum purchase: $${minAmount.toFixed(2)}`]);
      data.push(['⚠ Credits must be used during the current purchase.']);
      data.push([]);
      data.push(['Product', 'Variant', 'SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'Price']);

      discProds.forEach(p => {
        if (!p?.title) return;
        const vid    = String(p.variant_id || '');
        const vd     = window.b2bAllVariantsMap?.[vid] || {};
        const notes  = window.b2bNotesMap?.[p.handle] || {};
        const price  = getIncentivePrice(p);
        const vTitle = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
        data.push([
          p.title,
          vTitle,
          vd.sku || '—',
          vd.ml  || vTitle || '—',
          vd.pres || '—',
          vd.collection || notes.collection || '—',
          vd.coefficient || notes.coefficient || '—',
         
          `$${price.toFixed(2)}`
        ]);
      });

    } else {
      // ── P1: variantes ──
      data.push(['Volume Incentives — By Product']);
      data.push([]);

      variantRows().forEach(row => {
        const vid    = row.dataset.variantId;
        const extras = window.b2bVariantExtrasMap?.[vid] || {};
        if (!variantHasIncentive(extras)) return;

        const pName  = row.cells[5]?.textContent?.trim() || '';
        const ml     = row.cells[7]?.textContent?.trim() || '';
        const pres   = row.cells[8]?.textContent?.trim() || '';
        const coll   = row.cells[4]?.textContent?.trim() || '';
        const coeff  = row.cells[10]?.textContent?.trim() || '';
        const msrp   = row.cells[11]?.textContent?.trim() || '';
        const price  = parseFloat(row.dataset.unitPrice || 0);
        const sku    = (row.dataset.sku || '').toUpperCase();

        const { minU, minV } = getVariantThresholds(extras);
        const fps = getVariantFreeProducts(extras);
        const fqs = getVariantFreeQtys(extras);

        const condParts = [];
        if (minU > 0) condParts.push(`${minU} units`);
        if (minV > 0) condParts.push(`$${Number(minV).toLocaleString()}`);
        const condition = condParts.length ? 'Buy ' + condParts.join(' and ') : '';

        data.push([`${pName} — ${ml}`]);
        data.push(['SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'MSRP', 'Price', 'Condition']);
        data.push([sku, ml, pres, coll, coeff, msrp, `$${price.toFixed(2)}`, condition]);
        data.push(['']);
        data.push(['Free Gifts:']);
        data.push(['Gift Product', 'Variant', 'Qty']);
        fps.forEach((fp, i) => {
          const qty   = fqs[i] || 1;
          const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '';
          data.push([fp.title, fpVar, qty]);
        });
        data.push([]);
      });

      // ── Collection rules ──
      const rules = window.b2bCollectionIncentivesMap?.[colHandle] || [];
      if (rules.length) {
        data.push(['Collection Volume Rules']);
        data.push([]);
        rules.forEach((rule, idx) => {
          const minQ = Number(rule.min_qty || 0);
          const minV = Number(rule.min_order_value || 0);
          const disc = Number(rule.discount || 0);
          const condParts = [];
          if (minQ > 0) condParts.push(`${minQ} units`);
          if (minV > 0) condParts.push(`$${minV.toLocaleString()}`);
          data.push([`Rule ${idx + 1}: ${condParts.join(' + ')}`]);
          if (disc > 0) data.push(['Discount:', `${disc}%`]);
          (rule.free_products || []).forEach((fp, i) => {
            if (!fp?.title) return;
            const qty   = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
            const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? fp.variant_title : '';
            data.push(['Free:', `${qty}x ${fp.title}${fpVar ? ' — ' + fpVar : ''}`]);
          });
          (rule.free_testers || []).forEach((tp, i) => {
            if (!tp?.title) return;
            data.push(['Tester:', `${getTesterQty(rule, i)}x ${tp.title}`]);
          });
          data.push([]);
        });
      }
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    ws['!cols'] = [{wch:30},{wch:20},{wch:18},{wch:12},{wch:14},{wch:20},{wch:14},{wch:12},{wch:12}];
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Guidelines');
    XLSX.writeFile(wb, `guidelines-${vendor.toLowerCase().replace(/\s+/g, '-')}.xlsx`);

  } else if (format === 'pdf') {
    const { jsPDF } = window.jspdf;
    const doc    = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
    const pageW  = doc.internal.pageSize.getWidth();
    const pageH  = doc.internal.pageSize.getHeight();
    const margin = 14, colW = pageW - margin * 2;
    let y = margin;

    const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
    const drawLine  = () => { doc.setDrawColor(220,220,220); doc.line(margin, y, pageW - margin, y); y += 4; };

    // ── Logo ──
    const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
    if (logoUrl) {
      try {
        const li = new Image(); li.src = logoUrl; li.crossOrigin = 'anonymous';
        const lw = 40, lh = li.height > 0 ? (li.height * lw) / li.width : 20;
        doc.addImage(logoUrl, 'PNG', (pageW - lw) / 2, y, lw, Math.min(lh, 28));
        y += Math.min(lh, 28) + 6;
      } catch {}
    }

    // ── Título ──
    doc.setFontSize(18); doc.setFont('helvetica', 'bold');
    doc.text('Brand Incentives', pageW / 2, y, { align: 'center' }); y += 7;
    doc.setFontSize(11); doc.setFont('helvetica', 'normal'); doc.setTextColor(100,100,100);
    doc.text(vendor, pageW / 2, y, { align: 'center' });
    doc.setTextColor(0,0,0); y += 8; drawLine();

    // ── Mínimos ──
    // doc.setFillColor(184,167,125); doc.roundedRect(margin, y, colW / 2 - 4, 18, 2, 2, 'F');
    // doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    // doc.text('First Order', margin + 4, y + 6);
    // doc.setFont('helvetica','normal'); doc.setFontSize(8);
    // // doc.text(`Units: ${firstUnits}  |  Value: ${firstValue}`, margin + 4, y + 13);
    // doc.setFillColor(156,163,175); doc.roundedRect(pageW / 2 + 2, y, colW / 2 - 4, 18, 2, 2, 'F');
    // doc.setFontSize(9); doc.setFont('helvetica','bold');
    // doc.text('Next Order', pageW / 2 + 6, y + 6);
    // doc.setFont('helvetica','normal'); doc.setFontSize(8);
    // doc.text(`Units: ${nextUnits}  |  Value: ${nextValue}`, pageW / 2 + 6, y + 13);
    // doc.setTextColor(0,0,0); y += 24; drawLine();

    // ── Incentivos ──
    doc.setFillColor(30,30,30); doc.roundedRect(margin, y, colW, 8, 2, 2, 'F');
    doc.setFontSize(11); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    doc.text('Volume Incentives', margin + 4, y + 5.5);
    doc.setTextColor(0,0,0); y += 13;

    if (b2bIsCreditPriority(priority)) {
      const discPct   = parseFloat(window.b2bCollectionDiscount || 0);
      const minAmount = parseFloat(window.b2bDiscountMinAmount  || 0);
      const discProds = (Number(window.b2bCollectionPriority || 1) === 4 ? b2bBuildP4Products({ all: true }) : (window.b2bDiscountProducts || []));

      checkPage(20);
      doc.setFontSize(10); doc.setFont('helvetica','bold');
      doc.text(`${discPct}% Credit — Minimum purchase: $${minAmount.toFixed(2)}`, margin, y); y += 6;
      doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(120,80,0);
      doc.text('Credits must be used during the current purchase.', margin, y);
      doc.setTextColor(0,0,0); y += 8;

      // Cabecera tabla
      const cols2 = [40, 16, 14, 14, 20, 14, 14];
      doc.setFillColor(240,240,240); doc.rect(margin, y - 2, colW, 7, 'F');
      doc.setFontSize(7); doc.setFont('helvetica','bold');
      let cx = margin + 1;
      ['Product','SKU','ML','Pres.','Collection','Coeff.','Price'].forEach((h, i) => {
        doc.text(h, cx, y + 3); cx += cols2[i];
      });
      y += 7;

      discProds.forEach((p, ri) => {
        if (!p?.title) return;
        checkPage(8);
        const vid   = String(p.variant_id || '');
        const vd    = window.b2bAllVariantsMap?.[vid] || {};
        const notes = window.b2bNotesMap?.[p.handle] || {};
        const price = getIncentivePrice(p);
        const vTitle = p.variant_title && p.variant_title.toLowerCase() !== 'default title' ? p.variant_title : '';
        doc.setFillColor(...(ri % 2 === 0 ? [255,255,255] : [248,249,250]));
        doc.rect(margin, y - 1, colW, 7, 'F');
        doc.setFontSize(7); doc.setFont('helvetica','normal');
        let cx2 = margin + 1;
        [
          `${p.title}${vTitle ? ' — ' + vTitle : ''}`.substring(0, 22),
          (vd.sku || '—').substring(0, 10),
          (vd.ml || vTitle || '—').substring(0, 8),
          (vd.pres || '—').substring(0, 8),
          (vd.collection || notes.collection || '—').substring(0, 14),
          String(vd.coefficient || notes.coefficient || '—').substring(0, 6),
          `$${price.toFixed(2)}`
        ].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += cols2[i]; });
        y += 7;
      });

    } else {
      // ── P1: por variante ──
      variantRows().forEach(row => {
        const vid    = row.dataset.variantId;
        const extras = window.b2bVariantExtrasMap?.[vid] || {};
        if (!variantHasIncentive(extras)) return;

        const pName = row.cells[5]?.textContent?.trim() || '';
        const ml    = row.cells[7]?.textContent?.trim() || '';
        const pres  = row.cells[8]?.textContent?.trim() || '';
        const coll  = row.cells[4]?.textContent?.trim() || '';
        const coeff = row.cells[10]?.textContent?.trim() || '';
        const msrp  = row.cells[11]?.textContent?.trim() || '';
        const price = parseFloat(row.dataset.unitPrice || 0);
        const sku   = (row.dataset.sku || '').toUpperCase();
        const imgUrl = row.dataset.imgUrl || '';

        const { minU, minV } = getVariantThresholds(extras);
        const fps = getVariantFreeProducts(extras);
        const fqs = getVariantFreeQtys(extras);

        const condParts = [];
        if (minU > 0) condParts.push(`${minU} units`);
        if (minV > 0) condParts.push(`$${Number(minV).toLocaleString()}`);
        const condition = condParts.length ? 'Buy ' + condParts.join(' and ') + ' → get free gift' : '';

        checkPage(40);

        // Header producto
        doc.setFillColor(245,245,245); doc.roundedRect(margin, y, colW, 10, 2, 2, 'F');
        doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(30,30,30);
        doc.text(`${pName} — ${ml}`, margin + 4, y + 7);
        doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(80,80,80);
        // doc.text(condition, pageW - margin - 2, y + 7, { align: 'right' });
        doc.setTextColor(0,0,0); y += 13;

        // Info variante
        doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(100,100,100);
        doc.text(`SKU: ${sku}  |  ML: ${ml}  |  Pres: ${pres}  |  Collection: ${coll}  |  Coeff: ${coeff}  |  MSRP: ${msrp}  |  Price: $${price.toFixed(2)}`, margin, y);
        doc.setTextColor(0,0,0); y += 6;

        // Gifts
        if (fps.length) {
          doc.setFontSize(8); doc.setFont('helvetica','bold');
          doc.text('Free Gifts:', margin, y); y += 5;
          fps.forEach((fp, i) => {
            checkPage(7);
            const qty   = fqs[i] || 1;
            const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
            doc.setFillColor(220,252,231); doc.roundedRect(margin, y - 1, colW, 6, 1, 1, 'F');
            doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(22,101,52);
            doc.text(`${qty}x FREE  ${fp.title}${fpVar}`, margin + 3, y + 3);
            doc.setTextColor(0,0,0); y += 7;
          });
        }
        y += 4; drawLine();
      });

      // ── Collection rules ──
      const rules = window.b2bCollectionIncentivesMap?.[colHandle] || [];
      if (rules.length) {
        checkPage(12);
        doc.setFillColor(50,50,50); doc.roundedRect(margin, y, colW, 8, 2, 2, 'F');
        doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
        doc.text('Collection Volume Rules', margin + 4, y + 5.5);
        doc.setTextColor(0,0,0); y += 12;

        rules.forEach((rule, idx) => {
          checkPage(24);
          const minQ = Number(rule.min_qty || 0);
          const minV = Number(rule.min_order_value || 0);
          const disc = Number(rule.discount || 0);
          const condParts = [];
          if (minQ > 0) condParts.push(`${minQ} units`);
          if (minV > 0) condParts.push(`$${minV.toLocaleString()}`);

          doc.setFillColor(248,249,250); doc.roundedRect(margin, y, colW, 8, 2, 2, 'F');
          doc.setFontSize(9); doc.setFont('helvetica','bold');
          doc.text(`Rule ${idx + 1}: ${condParts.join(' + ')}${disc > 0 ? `  —  ${disc}% discount` : ''}`, margin + 3, y + 5.5);
          y += 11;

          (rule.free_products || []).forEach((fp, i) => {
            if (!fp?.title) return;
            checkPage(7);
            const qty   = normalizeQtyArray(rule.free_product_quantities)[i] || 1;
            const fpVar = fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ` — ${fp.variant_title}` : '';
            doc.setFillColor(220,252,231); doc.roundedRect(margin, y - 1, colW, 6, 1, 1, 'F');
            doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(22,101,52);
            doc.text(`${qty}x FREE  ${fp.title}${fpVar}`, margin + 3, y + 3);
            doc.setTextColor(0,0,0); y += 7;
          });

          (rule.free_testers || []).forEach((tp, i) => {
            if (!tp?.title) return;
            checkPage(7);
            doc.setFillColor(219,234,254); doc.roundedRect(margin, y - 1, colW, 6, 1, 1, 'F');
            doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(29,78,216);
            doc.text(`${getTesterQty(rule, i)}x TESTER  ${tp.title}`, margin + 3, y + 3);
            doc.setTextColor(0,0,0); y += 7;
          });
          y += 4;
        });
      }
    }

    doc.save(`Incentives-${vendor.toLowerCase().replace(/\s+/g, '-')}.pdf`);
  }
}



async function generateGuidelinesBase64(format) {
  const vendor    = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
  const colHandle = getColHandle();
  const priority  = Number(window.b2bCollectionPriority || 1);

  if (format === 'excel') {
    const data = [];
    data.push([`Brand Incentive — ${vendor}`]);
    data.push([]);

    if (b2bIsCreditPriority(priority)) {
      const discPct   = parseFloat(window.b2bCollectionDiscount || 0);
      const minAmount = parseFloat(window.b2bDiscountMinAmount  || 0);
      const discProds = (Number(window.b2bCollectionPriority || 1) === 4 ? b2bBuildP4Products({ all: true }) : (window.b2bDiscountProducts || []));
      data.push([`Volume Incentives — ${discPct}% Credit`]);
      data.push([`Minimum purchase: $${minAmount.toFixed(2)}`]);
      data.push([]);
      data.push(['Product', 'Variant', 'SKU', 'ML', 'Presentation', 'Collection', 'Price']);
      discProds.forEach(p => {
        if (!p?.title) return;
        const vid   = String(p.variant_id || '');
        const vd    = window.b2bAllVariantsMap?.[vid] || {};
        const note  = window.b2bNotesMap?.[p.handle] || {};
        const metaP = parseFloat(p.incentive_product_price || 0);
        const price = metaP > 0 ? metaP : parseFloat(p.price || 0);
        data.push([p.title, p.variant_title || '', vd.sku || '—', vd.ml || '—', vd.pres || '—', vd.collection || note.collection || '—', `$${price.toFixed(2)}`]);
      });
    } else {
      data.push(['Volume Incentives — By Product']);
      data.push([]);
      variantRows().forEach(row => {
        const vid    = row.dataset.variantId;
        const extras = window.b2bVariantExtrasMap?.[vid] || {};
        if (!variantHasIncentive(extras)) return;
        const fps = getVariantFreeProducts(extras);
        const fqs = getVariantFreeQtys(extras);
        const { minU, minV } = getVariantThresholds(extras);
        const condParts = [];
        if (minU > 0) condParts.push(`${minU} units`);
        if (minV > 0) condParts.push(`$${Number(minV).toLocaleString()}`);
        data.push([`${row.cells[5]?.textContent?.trim()} — ${row.cells[7]?.textContent?.trim()}`]);
        data.push(['Condition', condParts.join(' and ')]);
        fps.forEach((fp, i) => {
          data.push(['Free:', `${fqs[i] || 1}x ${fp.title}${fp.variant_title && fp.variant_title.toLowerCase() !== 'default title' ? ' — ' + fp.variant_title : ''}`]);
        });
        data.push([]);
      });
    }

    const ws = XLSX.utils.aoa_to_sheet(data);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, 'Incentives');
    return XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });

  } else if (format === 'pdf') {
    try {
      const { jsPDF } = window.jspdf;
      if (!jsPDF) { console.error('jsPDF not loaded'); return null; }

      const doc    = new jsPDF({ orientation: 'portrait', unit: 'mm', format: 'a4' });
      const pageW  = doc.internal.pageSize.getWidth();
      const pageH  = doc.internal.pageSize.getHeight();
      const margin = 14;
      const colW   = pageW - margin * 2;
      let y = margin;

      const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };

      // ── Título ──
      doc.setFontSize(16); doc.setFont('helvetica', 'bold');
      doc.text(`${vendor} — Brand Incentives`, pageW / 2, y, { align: 'center' }); y += 10;
      doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
      doc.text(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pageW / 2, y, { align: 'center' });
      doc.setTextColor(0, 0, 0); y += 12;

      if (b2bIsCreditPriority(priority)) {
        const discPct   = parseFloat(window.b2bCollectionDiscount || 0);
        const minAmount = parseFloat(window.b2bDiscountMinAmount  || 0);
        doc.setFontSize(10); doc.setFont('helvetica', 'bold');
        doc.text(`${discPct}% Credit — Min purchase: $${minAmount.toFixed(2)}`, margin, y); y += 8;
        doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 80, 0);
        doc.text('Credits must be used during the current purchase.', margin, y);
        doc.setTextColor(0, 0, 0); y += 10;

        (Number(window.b2bCollectionPriority || 1) === 4 ? b2bBuildP4Products({ all: true }) : (window.b2bDiscountProducts || [])).forEach((p, ri) => {
          if (!p?.title) return;
          checkPage(8);
          const vid   = String(p.variant_id || '');
          const vd    = window.b2bAllVariantsMap?.[vid] || {};
          const metaP = parseFloat(p.incentive_product_price || 0);
          const price = metaP > 0 ? metaP : parseFloat(p.price || 0);
          doc.setFillColor(...(ri % 2 === 0 ? [255,255,255] : [248,249,250]));
          doc.rect(margin, y - 1, colW, 7, 'F');
          doc.setFontSize(8); doc.setFont('helvetica', 'normal');
          doc.text(`${p.title} | ${vd.ml || '—'} | ${vd.pres || '—'} | $${price.toFixed(2)}`, margin + 2, y + 4);
          y += 7;
        });

      } else {
        variantRows().forEach(row => {
          const vid    = row.dataset.variantId;
          const extras = window.b2bVariantExtrasMap?.[vid] || {};
          if (!variantHasIncentive(extras)) return;
          const fps    = getVariantFreeProducts(extras);
          const fqs    = getVariantFreeQtys(extras);
          const { minU } = getVariantThresholds(extras);

          checkPage(20);
          doc.setFontSize(9); doc.setFont('helvetica', 'bold');
          doc.text(`${row.cells[5]?.textContent?.trim()} — Buy ${minU} units`, margin, y); y += 6;

          fps.forEach((fp, i) => {
            checkPage(6);
            doc.setFont('helvetica', 'normal'); doc.setFontSize(8);
            doc.setFillColor(220, 252, 231);
            doc.rect(margin, y - 1, colW, 6, 'F');
            doc.setTextColor(22, 101, 52);
            doc.text(`  ${fqs[i] || 1}x FREE: ${fp.title}`, margin + 2, y + 3);
            doc.setTextColor(0, 0, 0);
            y += 6;
          });
          y += 4;
        });
      }

      // ── Retornar base64 ──
      const pdfBase64 = doc.output('datauristring').split(',')[1];
      if (!pdfBase64) { console.error('PDF base64 is empty'); return null; }
      return pdfBase64;

    } catch (err) {
      console.error('Error generating PDF base64:', err);
      return null;
    }
  }

  return null;
}

/* ══════════════════════════════════════════════════════════════
   PATCH — Agrupación por categoría + orden por ML para el
   "Product List" completo (generateCatalogBase64 / generateCatalogPdfBase64)

   INSTRUCCIONES:
   1) Pega el bloque "HELPERS NUEVOS" en cualquier parte del archivo
      b2b-marca-tabla.js ANTES de generateCatalogBase64 (por ejemplo,
      justo debajo de la función getColHandle()).
   2) Reemplaza tu función `async function generateCatalogBase64() {...}`
      completa por la nueva versión de este archivo.
   3) Reemplaza tu función `async function generateCatalogPdfBase64() {...}`
      completa por la nueva versión de este archivo.
   4) NO toques generatePreOrderExcelBase64 / generatePreOrderPdfBase64 /
      initExcelExport / initPdfExport — esos exports (Pre-Order) quedan igual.
   ══════════════════════════════════════════════════════════════ */


/* ══════════════════════════════════════════════
   HELPERS NUEVOS — pegar antes de generateCatalogBase64
   ══════════════════════════════════════════════ */

// Valores de presentation (ya normalizados) que pertenecen a Bath & Body Care.
const CATALOG_BATH_BODY_PRESENTATIONS = new Set([
  'body butter', 'body lotion', 'body scrub', 'body wash', 'soap', 'shampoo & conditioner'
]);

const CATALOG_CATEGORY_ORDER = ['perfume', 'tester', 'bathbody', 'others'];

const CATALOG_CATEGORY_TITLES = {
  perfume:  'Perfume',
  tester:   'Perfume Tester and Vials',
  bathbody: 'Bath & Body Care',
  others:   'Others',
};

// Limpia espacios normales e invisibles (NBSP, etc.) y normaliza a minúsculas,
// para que la comparación no falle por diferencias invisibles en el dato guardado.
function catalogNormalizePresentation(presentation) {
  return (presentation || '')
    .replace(/[\u00A0\u200B\u2028\u2029]/g, ' ')
    .trim()
    .toLowerCase();
}

// Decide la categoría de una fila (variante) según su presentation:
//  - Body Butter / Body Lotion / Body Scrub / Body Wash / Soap / Shampoo & Conditioner -> bathbody
//  - Tester / Vial -> tester
//  - Perfume (exacto) -> perfume
//  - cualquier otro valor (Retail, Sample, Travel Set, Discovery Set, Other, etc.) -> others
function getCatalogRowCategory(presentation) {
  const norm = catalogNormalizePresentation(presentation);
  if (norm && CATALOG_BATH_BODY_PRESENTATIONS.has(norm)) return 'bathbody';
  if (norm === 'tester' || norm === 'vial') return 'tester';
  if (norm === 'perfume') return 'perfume';
  return 'others';
}

// Extrae el número de ML de un string tipo "100 ml" -> 100. Sin número (Sample,
// Tester suelto, etc.) devuelve -1 para que quede al final al ordenar desc.
function getCatalogMlSortValue(mlStr) {
  const match = (mlStr || '').match(/(\d+(\.\d+)?)/);
  return match ? parseFloat(match[1]) : -1;
}

// Agrupa las filas del catálogo (variantRows()) en las 4 categorías y ordena
// cada grupo por ML de mayor a menor. row.dataset.presentation y row.dataset.ml
// ya vienen en minúsculas desde el render (ver script inline del .liquid).
function groupAndSortCatalogRows(rows) {
  const groups = { perfume: [], tester: [], bathbody: [], others: [] };
  rows.forEach(row => {
    const category = getCatalogRowCategory(row.dataset.presentation);
    groups[category].push(row);
  });
  CATALOG_CATEGORY_ORDER.forEach(key => {
    groups[key].sort((a, b) => getCatalogMlSortValue(b.dataset.ml) - getCatalogMlSortValue(a.dataset.ml));
  });
  return groups;
}

// Construye una hoja de Excel para una categoría del catálogo completo:
// fila de resumen + encabezados + filas (ya ordenadas por ML) + fotos.
function buildCatalogSheet(workbook, categoryKey, categoryRows, imageCache) {
  const sheet = workbook.addWorksheet(CATALOG_CATEGORY_TITLES[categoryKey].substring(0, 31)); // Excel limita a 31 chars

  const columnDefs = [
    { key: 'sku',           width: 30 },
    { key: 'photo',         width: 12 },
    { key: 'product',       width: 30 },
    { key: 'collection',    width: 20 },
    { key: 'concentration', width: 18 },
    { key: 'ml',            width: 10 },
    { key: 'presentation',  width: 14 },
    { key: 'msrp',          width: 14 },
    { key: 'wholesale',     width: 16 },
  ];
  sheet.columns = columnDefs;

  // Fila 1: resumen
  const uniqueProducts = new Set(categoryRows.map(r => r.dataset.handle));
  const summaryText = `Products: ${uniqueProducts.size}   |   Unique References: ${categoryRows.length}`;
  const summaryRow = sheet.addRow([summaryText]);
  sheet.mergeCells(1, 1, 1, columnDefs.length);
  summaryRow.font = { bold: true, color: { argb: 'FFB7AC7E' } };
  summaryRow.alignment = { vertical: 'middle', horizontal: 'left' };
  summaryRow.height = 20;

  // Fila 2: encabezados
  const headerLabels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Brand MSRP', 'Wholesale Price'];
  const headerRow = sheet.addRow(headerLabels);
  headerRow.eachCell((cell) => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
  });
  headerRow.height = 18;

  // Filas 3+: datos (ya ordenados por ML desc)
  categoryRows.forEach((row, index) => {
    const excelRow = sheet.addRow({
      sku:           (row.dataset.sku || '-').toUpperCase(),
      photo:         '',
      product:       row.cells[5]?.textContent?.trim() || '',
      collection:    row.cells[4]?.textContent?.trim() || '',
      concentration: row.cells[6]?.textContent?.trim() || '',
      ml:            row.cells[7]?.textContent?.trim() || '',
      presentation:  row.cells[8]?.textContent?.trim() || '',
      msrp:          row.cells[11]?.textContent?.trim() || '',
      wholesale:     parseFloat(row.dataset.unitPrice || 0),
    });
    excelRow.height = 50;
    excelRow.alignment = { vertical: 'middle' };

    const url = row.dataset.imgUrl;
    if (url && imageCache[url]) {
      const rowNumber = index + 3; // +1 resumen, +1 encabezado, +1 porque ExcelJS es 1-based
      const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
      sheet.addImage(imageId, {
        tl: { col: 1.25, row: rowNumber - 1 + 0.28 },
        ext: { width: 50, height: 50 },
      });
    }
  });
}


/* ══════════════════════════════════════════════
   NUEVA VERSIÓN — reemplaza tu generateCatalogBase64() actual
   ══════════════════════════════════════════════ */

async function generateCatalogBase64() {
  const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

  const workbook = new ExcelJS.Workbook();
  workbook.creator = vendor;
  workbook.created = new Date();

  const rows = variantRows();

  // Pre-cargar imágenes únicas EN PARALELO (una sola vez para todas las categorías)
  const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
  const imageCache = {};
  await Promise.all(uniqueUrls.map(async url => {
    try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
    catch (e) { imageCache[url] = null; }
  }));

  // Agrupar por categoría (Perfume / Perfume Tester and Vials / Bath & Body Care / Others)
  // y ordenar cada grupo por ML de mayor a menor.
  const groups = groupAndSortCatalogRows(rows);

  // Una hoja por cada categoría con filas (las vacías se omiten)
  CATALOG_CATEGORY_ORDER.forEach(categoryKey => {
    const categoryRows = groups[categoryKey];
    if (categoryRows.length > 0) {
      buildCatalogSheet(workbook, categoryKey, categoryRows, imageCache);
    }
  });

  const buffer = await workbook.xlsx.writeBuffer();
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}


/* ══════════════════════════════════════════════
   NUEVA VERSIÓN — reemplaza tu generateCatalogPdfBase64() actual
   ══════════════════════════════════════════════ */

async function generateCatalogPdfBase64() {
  try {
    const { jsPDF } = window.jspdf;
    if (!jsPDF) { console.error('jsPDF not loaded'); return null; }

    const vendor  = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const doc     = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
    const pageW   = doc.internal.pageSize.getWidth();
    const pageH   = doc.internal.pageSize.getHeight();
    const margin  = 10;
    const colW    = pageW - margin * 2;

    // Ahora recibe/devuelve y explícitamente (antes vivía en el scope de la función,
    // pero ahora cada categoría empieza una página nueva con su propio y).
    const checkPage = (y, n) => { if (y + n > pageH - margin) { doc.addPage(); return margin; } return y; };

    const rows = variantRows();

    // Pre-cargar imágenes únicas EN PARALELO (fotos chicas, una sola vez para todo)
    const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
    const imageCache = {};
    await Promise.all(uniqueUrls.map(async url => {
      try { imageCache[url] = await loadImgAsBase64ForExport(url, 100); }
      catch (e) { imageCache[url] = null; }
    }));

    // Agrupar por categoría y ordenar por ML de mayor a menor
    const groups = groupAndSortCatalogRows(rows);
    const nonEmptyCategories = CATALOG_CATEGORY_ORDER.filter(key => groups[key].length > 0);

    // Cabecera tabla — misma estructura que antes
    const cols   = [24, 18, 44, 26, 24, 14, 20, 20, 22];
    const labels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Brand MSRP', 'Wholesale'];
    const IMG_SIZE = 12;

    nonEmptyCategories.forEach((categoryKey, catIndex) => {
      const categoryRows = groups[categoryKey];
      let y = margin;

      if (catIndex > 0) {
        doc.addPage();
      }

      // Título / fecha (se repite en cada página de categoría)
      doc.setFontSize(14); doc.setFont('helvetica', 'bold');
      doc.text(`${vendor} — Product List`, pageW / 2, y, { align: 'center' }); y += 7;
      doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
      doc.text(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pageW / 2, y, { align: 'center' });
      doc.setTextColor(0, 0, 0); y += 8;

      // Título de la categoría
      doc.setFontSize(11); doc.setFont('helvetica', 'bold'); doc.setTextColor(183, 172, 126);
      doc.text(CATALOG_CATEGORY_TITLES[categoryKey], margin, y);
      doc.setTextColor(0, 0, 0); y += 6;

      // Cabecera tabla
      doc.setFillColor(30, 30, 30);
      doc.rect(margin, y, colW, 7, 'F');
      doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
      let cx = margin + 1;
      labels.forEach((lbl, i) => { doc.text(lbl, cx, y + 4.5); cx += cols[i]; });
      doc.setTextColor(0, 0, 0); y += 8;

      // Filas (ya ordenadas por ML desc)
      let rowCount = 0;
      categoryRows.forEach(row => {
        y = checkPage(y, IMG_SIZE + 2);
        doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
        doc.rect(margin, y - 1, colW, IMG_SIZE + 2, 'F');
        doc.setFontSize(6.5); doc.setFont('helvetica', 'normal');

        let cx2 = margin + 1;

        // SKU
        doc.text((row.dataset.sku || '-').toUpperCase().substring(0, 12), cx2, y + (IMG_SIZE / 2) + 1);
        cx2 += cols[0];

        // Photo
        const url = row.dataset.imgUrl;
        const imgData = url ? imageCache[url] : null;
        if (imgData) {
          doc.addImage(imgData, 'JPEG', cx2 + 1, y, IMG_SIZE, IMG_SIZE);
        }
        cx2 += cols[1];

        // Product, Collection, Concentration, ML, Presentation, Brand MSRP, Wholesale
        const values = [
          (row.cells[5]?.textContent?.trim() || '').substring(0, 24),
          (row.cells[4]?.textContent?.trim() || '').substring(0, 16),
          (row.cells[6]?.textContent?.trim() || '').substring(0, 14),
          (row.cells[7]?.textContent?.trim() || '').substring(0, 8),
          (row.cells[8]?.textContent?.trim() || '').substring(0, 12),
          (row.cells[11]?.textContent?.trim() || '').substring(0, 10),
          '$' + parseFloat(row.dataset.unitPrice || 0).toFixed(2),
        ];
        values.forEach((v, i) => { doc.text(v, cx2, y + (IMG_SIZE / 2) + 1); cx2 += cols[i + 2]; });

        y += IMG_SIZE + 2;
        rowCount++;
      });
    });

    const pdfBase64 = doc.output('datauristring').split(',')[1];
    if (!pdfBase64) { console.error('Catalog PDF base64 is empty'); return null; }
    return pdfBase64;

  } catch (err) {
    console.error('Error generating catalog PDF base64:', err);
    return null;
  }
}


function getPresentationCategory(presentationText) {
  const p = (presentationText || '').toLowerCase();

  if (p.includes('perfume')) return 'Perfume';
  if (p.includes('tester'))  return 'Tester';
  if (p.includes('vial'))    return 'Vial';

  const bathBodyKeywords = [
    'body butter',
    'body lotion',
    'body scrub',
    'body wash',
    'soap',
    'shampoo',
    'conditioner',
  ];
  if (bathBodyKeywords.some(k => p.includes(k))) return 'Bath & Body Care';

  return 'Other';
}


// async function generateOfflineOrderTemplateBase64() {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

//   const workbook = new ExcelJS.Workbook();
//   workbook.creator = vendor;
//   workbook.created = new Date();

//   const sheet = workbook.addWorksheet('Offline Order');

//   // Columnas SIN "header" (evita el patrón frágil de mezclar
//   // sheet.columns-con-header + insertRow que ya nos dio problemas antes).
//   const columnDefs = [
//     { key: 'sku',           width: 24 },
//     { key: 'photo',         width: 12 },
//     { key: 'product',       width: 30 },
//     { key: 'collection',    width: 20 },
//     { key: 'concentration', width: 18 },
//     { key: 'ml',            width: 10 },
//     { key: 'presentation',  width: 16 },
//     { key: 'wholesale',     width: 16 },
//     { key: 'qty',           width: 16 },
//     { key: 'total',         width: 16 },
//   ];
//   sheet.columns = columnDefs;

//   // ── Fila 1: título ──
//   const titleRow = sheet.addRow([`${vendor} — Offline Order`]);
//   sheet.mergeCells(1, 1, 1, columnDefs.length);
//   titleRow.font = { bold: true, size: 14, color: { argb: 'FFB7AC7E' } };
//   titleRow.height = 22;

//   // ── Fila 2: instrucciones ──
//   const noteRow = sheet.addRow([
//     'Enter the quantity you want in the "Order Quantity" column (highlighted). The Line Total and the grand total at the bottom update automatically.'
//   ]);
//   sheet.mergeCells(2, 1, 2, columnDefs.length);
//   noteRow.font = { italic: true, color: { argb: 'FF6B7280' } };
//   noteRow.height = 18;

//   // ── Fila 3: encabezados ──
//   const headerLabels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Wholesale Price', 'Order Quantity', 'Line Total'];
//   const headerRow = sheet.addRow(headerLabels);
//   headerRow.eachCell(cell => {
//     cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
//     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
//     cell.alignment = { vertical: 'middle', horizontal: 'center' };
//   });
//   headerRow.height = 20;

//   // Obtenemos las filas y las convertimos a Array para poder usar .sort() de forma segura
//   const rows = Array.from(variantRows());

//   // ══════════════════════════════════════════════════════════════
//   // NUEVO: Lógica de ordenamiento (Perfume > Tester > Demás, y por ML descendente)
//   // ══════════════════════════════════════════════════════════════
//   const getMlValue = (row) => {
//     const mlText = (row.cells[7]?.textContent || '').trim();
//     const match = mlText.match(/(\d+(?:\.\d+)?)/); // Extrae el número (ej: "100ml" -> 100)
//     return match ? parseFloat(match[1]) : 0;
//   };

//   const getSortPriority = (row) => {
//     const presentation = (row.cells[8]?.textContent || '').toLowerCase();
//     if (presentation.includes('perfume')) return 1;
//     if (presentation.includes('tester')) return 2;
//     return 3; // "demás"
//   };

//   rows.sort((a, b) => {
//     const prioA = getSortPriority(a);
//     const prioB = getSortPriority(b);

//     // 1. Ordenar por prioridad de presentación
//     if (prioA !== prioB) {
//       return prioA - prioB;
//     }

//     // 2. Si la prioridad es igual, ordenar por ML de mayor a menor (descendente)
//     const mlA = getMlValue(a);
//     const mlB = getMlValue(b);
//     return mlB - mlA;
//   });
//   // ══════════════════════════════════════════════════════════════

//   const firstDataRow = 4; // 1=título, 2=nota, 3=encabezado -> datos desde la fila 4

//   // Pre-cargar imágenes únicas EN PARALELO (misma técnica que en el catálogo completo)
//   const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
//   const imageCache = {};
//   await Promise.all(uniqueUrls.map(async url => {
//     try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
//     catch (e) { imageCache[url] = null; }
//   }));

//   // ── Filas de datos, una por variante en pantalla, con Qty vacío y
//   //    Line Total como fórmula = Wholesale (H) * Order Quantity (I) ──
//   rows.forEach((row, idx) => {
//     const excelRowNumber = firstDataRow + idx;
//     const wholesale = parseFloat(row.dataset.unitPrice || 0);

//     const excelRow = sheet.addRow({
//       sku:           (row.dataset.sku || '-').toUpperCase(),
//       photo:         '',
//       product:       row.cells[5]?.textContent?.trim() || '',
//       collection:    row.cells[4]?.textContent?.trim() || '',
//       concentration: row.cells[6]?.textContent?.trim() || '',
//       ml:            row.cells[7]?.textContent?.trim() || '',
//       presentation:  row.cells[8]?.textContent?.trim() || '',
//       wholesale:     wholesale,
//       qty:           null, // el cliente lo llena
//       total:         { formula: `H${excelRowNumber}*I${excelRowNumber}` },
//     });
//     excelRow.height = 50;
//     excelRow.alignment = { vertical: 'middle' };

//     excelRow.getCell('wholesale').numFmt = '$#,##0.00';
//     excelRow.getCell('total').numFmt = '$#,##0.00';

//     // Resaltar la celda de cantidad como "editable"
//     const qtyCell = excelRow.getCell('qty');
//     qtyCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF7D6' } };
//     qtyCell.border = {
//       top:    { style: 'thin', color: { argb: 'FFB8A77D' } },
//       left:   { style: 'thin', color: { argb: 'FFB8A77D' } },
//       bottom: { style: 'thin', color: { argb: 'FFB8A77D' } },
//       right:  { style: 'thin', color: { argb: 'FFB8A77D' } },
//     };

//     // Insertar la foto del producto (columna B) si se pudo cargar
//     const url = row.dataset.imgUrl;
//     if (url && imageCache[url]) {
//       const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
//       sheet.addImage(imageId, {
//         tl: { col: 1.1, row: excelRowNumber - 1 + 0.1 },
//         ext: { width: 45, height: 45 },
//       });
//     }
//   });

//   // ── Fila de totales al final (SUM sobre Order Quantity y Line Total) ──
//   const lastDataRow    = firstDataRow + rows.length - 1;
//   const totalRowNumber = lastDataRow + 2; // deja una fila en blanco de separación

//   const totalRow = sheet.getRow(totalRowNumber);
//   totalRow.getCell(1).value = 'Estimated Total';
//   totalRow.getCell(1).font  = { bold: true, size: 12 };
//   sheet.mergeCells(totalRowNumber, 1, totalRowNumber, 7);

//   const totalQtyCell = totalRow.getCell('qty');
//   totalQtyCell.value = { formula: `SUM(I${firstDataRow}:I${lastDataRow})` };
//   totalQtyCell.font  = { bold: true };

//   const totalAmountCell = totalRow.getCell('total');
//   totalAmountCell.value  = { formula: `SUM(J${firstDataRow}:J${lastDataRow})` };
//   totalAmountCell.font   = { bold: true, size: 12 };
//   totalAmountCell.numFmt = '$#,##0.00';

//   totalRow.eachCell(cell => {
//     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEDE9E4' } };
//   });
//   totalRow.height = 22;

//   // Congela título + nota + encabezado al hacer scroll
//   sheet.views = [{ state: 'frozen', ySplit: 3 }];

//   const buffer = await workbook.xlsx.writeBuffer();
//   let binary = '';
//   const bytes = new Uint8Array(buffer);
//   for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
//   return btoa(binary);
// }

async function generateOfflineOrderTemplateBase64() {
  const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

  const workbook = new ExcelJS.Workbook();
  workbook.creator = vendor;
  workbook.created = new Date();

  const sheet = workbook.addWorksheet('Offline Order');

  // Columnas SIN "header" (evita el patrón frágil de mezclar
  // sheet.columns-con-header + insertRow que ya nos dio problemas antes).
  const columnDefs = [
    { key: 'sku',           width: 24 },
    { key: 'photo',         width: 12 },
    { key: 'product',       width: 30 },
    { key: 'collection',    width: 20 },
    { key: 'concentration', width: 18 },
    { key: 'ml',            width: 10 },
    { key: 'presentation',  width: 16 },
    { key: 'wholesale',     width: 16 },
    { key: 'qty',           width: 16 },
    { key: 'total',         width: 16 },
  ];
  sheet.columns = columnDefs;

  // ── Fila 1: título ──
  const titleRow = sheet.addRow([`${vendor} — Offline Order`]);
  sheet.mergeCells(1, 1, 1, columnDefs.length);
  titleRow.font = { bold: true, size: 14, color: { argb: 'FFB7AC7E' } };
  titleRow.height = 22;

  // ── Fila 2: instrucciones ──
  const noteRow = sheet.addRow([
    'Enter the quantity you want in the "Order Quantity" column (highlighted). The Line Total and the grand total at the bottom update automatically. Use the filter arrows on the header row to filter by Presentation (Perfume, Tester, Vial, etc.).'
  ]);
  sheet.mergeCells(2, 1, 2, columnDefs.length);
  noteRow.font = { italic: true, color: { argb: 'FF6B7280' } };
  noteRow.height = 18;

  // ── Fila 3: encabezados ──
  const headerLabels = ['SKU', 'Photo', 'Product', 'Collection', 'Concentration', 'ML', 'Presentation', 'Wholesale Price', 'Order Quantity', 'Line Total'];
  const headerRow = sheet.addRow(headerLabels);
  headerRow.eachCell(cell => {
    cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
    cell.alignment = { vertical: 'middle', horizontal: 'center' };
  });
  headerRow.height = 20;

  // Obtenemos las filas y las convertimos a Array para poder usar .sort() de forma segura
  const rows = Array.from(variantRows());

  // ══════════════════════════════════════════════════════════════
  // Lógica de ordenamiento (Perfume > Tester > Demás, y por ML descendente)
  // ══════════════════════════════════════════════════════════════
  const getMlValue = (row) => {
    const mlText = (row.cells[7]?.textContent || '').trim();
    const match = mlText.match(/(\d+(?:\.\d+)?)/); // Extrae el número (ej: "100ml" -> 100)
    return match ? parseFloat(match[1]) : 0;
  };

  const getSortPriority = (row) => {
    const presentation = (row.cells[8]?.textContent || '').toLowerCase();
    if (presentation.includes('perfume')) return 1;
    if (presentation.includes('tester')) return 2;
    return 3; // "demás"
  };

  rows.sort((a, b) => {
    const prioA = getSortPriority(a);
    const prioB = getSortPriority(b);

    if (prioA !== prioB) {
      return prioA - prioB;
    }

    const mlA = getMlValue(a);
    const mlB = getMlValue(b);
    return mlB - mlA;
  });
  // ══════════════════════════════════════════════════════════════

  const firstDataRow = 4; // 1=título, 2=nota, 3=encabezado -> datos desde la fila 4

  // Pre-cargar imágenes únicas EN PARALELO (misma técnica que en el catálogo completo)
  const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
  const imageCache = {};
  await Promise.all(uniqueUrls.map(async url => {
    try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
    catch (e) { imageCache[url] = null; }
  }));

  // ── Filas de datos, una por variante en pantalla, con Qty vacío y
  //    Line Total como fórmula = Wholesale (H) * Order Quantity (I) ──
  rows.forEach((row, idx) => {
    const excelRowNumber = firstDataRow + idx;
    const wholesale = parseFloat(row.dataset.unitPrice || 0);

    const excelRow = sheet.addRow({
      sku:           (row.dataset.sku || '-').toUpperCase(),
      photo:         '',
      product:       row.cells[5]?.textContent?.trim() || '',
      collection:    row.cells[4]?.textContent?.trim() || '',
      concentration: row.cells[6]?.textContent?.trim() || '',
      ml:            row.cells[7]?.textContent?.trim() || '',
      presentation:  row.cells[8]?.textContent?.trim() || '',
      wholesale:     wholesale,
      qty:           null, // el cliente lo llena
      total:         { formula: `H${excelRowNumber}*I${excelRowNumber}` },
    });
    excelRow.height = 50;
    excelRow.alignment = { vertical: 'middle' };

    excelRow.getCell('wholesale').numFmt = '$#,##0.00';
    excelRow.getCell('total').numFmt = '$#,##0.00';

    // Resaltar la celda de cantidad como "editable"
    const qtyCell = excelRow.getCell('qty');
    qtyCell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFFFF7D6' } };
    qtyCell.border = {
      top:    { style: 'thin', color: { argb: 'FFB8A77D' } },
      left:   { style: 'thin', color: { argb: 'FFB8A77D' } },
      bottom: { style: 'thin', color: { argb: 'FFB8A77D' } },
      right:  { style: 'thin', color: { argb: 'FFB8A77D' } },
    };

    // Insertar la foto del producto (columna B) si se pudo cargar
    const url = row.dataset.imgUrl;
    if (url && imageCache[url]) {
      const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
      sheet.addImage(imageId, {
        tl: { col: 1.1, row: excelRowNumber - 1 + 0.1 },
        ext: { width: 45, height: 45 },
      });
    }
  });

  // ── Fila de totales al final (SUM sobre Order Quantity y Line Total) ──
  const lastDataRow    = firstDataRow + rows.length - 1;
  const totalRowNumber = lastDataRow + 2; // deja una fila en blanco de separación

  const totalRow = sheet.getRow(totalRowNumber);
  totalRow.getCell(1).value = 'Estimated Total';
  totalRow.getCell(1).font  = { bold: true, size: 12 };
  sheet.mergeCells(totalRowNumber, 1, totalRowNumber, 7);

  const totalQtyCell = totalRow.getCell('qty');
  totalQtyCell.value = { formula: `SUM(I${firstDataRow}:I${lastDataRow})` };
  totalQtyCell.font  = { bold: true };

  const totalAmountCell = totalRow.getCell('total');
  totalAmountCell.value  = { formula: `SUM(J${firstDataRow}:J${lastDataRow})` };
  totalAmountCell.font   = { bold: true, size: 12 };
  totalAmountCell.numFmt = '$#,##0.00';

  totalRow.eachCell(cell => {
    cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FFEDE9E4' } };
  });
  totalRow.height = 22;

  // ── AutoFilter en la fila de encabezados (fila 3) ──
  sheet.autoFilter = {
    from: { row: 3, column: 1 },
    to:   { row: lastDataRow, column: columnDefs.length },
  };

  // Congela título + nota + encabezado al hacer scroll
  sheet.views = [{ state: 'frozen', ySplit: 3 }];

  const buffer = await workbook.xlsx.writeBuffer();
  let binary = '';
  const bytes = new Uint8Array(buffer);
  for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
  return btoa(binary);
}



// async function generateCatalogPdfBase64() {
//   try {
//     const { jsPDF } = window.jspdf;
//     if (!jsPDF) { console.error('jsPDF not loaded'); return null; }

//     const vendor  = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//     const doc     = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
//     const pageW   = doc.internal.pageSize.getWidth();
//     const pageH   = doc.internal.pageSize.getHeight();
//     const margin  = 10;
//     const colW    = pageW - margin * 2;
//     let y = margin;

//     const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };

//     // ── Título ──
//     doc.setFontSize(14); doc.setFont('helvetica', 'bold');
//     doc.text(`${vendor} — Product List`, pageW / 2, y, { align: 'center' }); y += 7;
//     doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(120, 120, 120);
//     doc.text(new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }), pageW / 2, y, { align: 'center' });
//     doc.setTextColor(0, 0, 0); y += 8;

//     // ── Cabecera tabla ──
//     const cols   = [28, 50, 30, 24, 16, 20, 20, 22, 16, 22, 22];
//     const labels = ['SKU', 'Product', 'Collection', 'Type', 'ML', 'Presentation', 'Brand MSRP', 'Wholesale', 'Stock', 'First Min Qty', 'Next Min Qty'];

//     doc.setFillColor(30, 30, 30);
//     doc.rect(margin, y, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255);
//     let cx = margin + 1;
//     labels.forEach((lbl, i) => { doc.text(lbl, cx, y + 4.5); cx += cols[i]; });
//     doc.setTextColor(0, 0, 0); y += 8;

//     // ── Filas ──
//     let rowCount = 0;
//     variantRows().forEach(row => {
//       checkPage(7);
//       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
//       doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(6.5); doc.setFont('helvetica', 'normal');

//       const values = [
//         (row.dataset.sku || '-').toUpperCase().substring(0, 14),
//         (row.cells[5]?.textContent?.trim() || '').substring(0, 28),
//         (row.cells[4]?.textContent?.trim() || '').substring(0, 18),
//         (row.cells[6]?.textContent?.trim() || '').substring(0, 14),
//         (row.cells[7]?.textContent?.trim() || '').substring(0, 8),
//         (row.cells[8]?.textContent?.trim() || '').substring(0, 12),
//         (row.cells[11]?.textContent?.trim() || '').substring(0, 10),
//         '$' + parseFloat(row.dataset.unitPrice || 0).toFixed(2),
//         String(parseInt(row.dataset.stock || 0)),
//         row.dataset.firstMinQty || '1',
//         row.dataset.nextMinQty  || '—'
//       ];

//       let cx2 = margin + 1;
//       values.forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += cols[i]; });
//       y += 7; rowCount++;
//     });

//     const pdfBase64 = doc.output('datauristring').split(',')[1];
//     if (!pdfBase64) { console.error('Catalog PDF base64 is empty'); return null; }
//     return pdfBase64;

//   } catch (err) {
//     console.error('Error generating catalog PDF base64:', err);
//     return null;
//   }
// }


// async function generateCatalogBase64() {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
 
//   const workbook = new ExcelJS.Workbook();
//   workbook.creator = vendor;
//   workbook.created = new Date();
 
//   const sheet = workbook.addWorksheet('Catalog');
 
//   sheet.columns = [
//     { header: 'SKU',             key: 'sku',           width: 20 },
//     { header: 'Photo',           key: 'photo',         width: 14 },
//     { header: 'Product',         key: 'product',       width: 30 },
//     { header: 'Collection',      key: 'collection',    width: 20 },
//     { header: 'Concentration',   key: 'concentration', width: 18 },
//     { header: 'ML',              key: 'ml',             width: 10 },
//     { header: 'Presentation',    key: 'presentation',  width: 14 },
//     { header: 'Brand MSRP',      key: 'msrp',          width: 14 },
//     { header: 'Wholesale Price', key: 'wholesale',     width: 16 },
//     { header: 'Stock',           key: 'stock',         width: 10 },
//   ];
 
//   const headerRow = sheet.getRow(1);
//   headerRow.eachCell((cell) => {
//     cell.font = { bold: true, color: { argb: 'FFFFFFFF' } };
//     cell.fill = { type: 'pattern', pattern: 'solid', fgColor: { argb: 'FF28261F' } };
//     cell.alignment = { vertical: 'middle', horizontal: 'center' };
//   });
//   headerRow.height = 20;
 
//   const rows = variantRows();
 
//   // ── Pre-cargar imágenes únicas EN PARALELO (fotos chicas, no las originales) ──
//   const uniqueUrls = [...new Set(rows.map(r => r.dataset.imgUrl).filter(Boolean))];
//   const imageCache = {};
//   await Promise.all(uniqueUrls.map(async url => {
//     try { imageCache[url] = await loadImgAsBase64ForExport(url, 120); }
//     catch (e) { imageCache[url] = null; }
//   }));
 
//   rows.forEach((row, index) => {
//     const excelRow = sheet.addRow({
//       sku:           (row.dataset.sku || '-').toUpperCase(),
//       photo:         '',
//       product:       row.cells[5]?.textContent?.trim() || '',
//       collection:    row.cells[4]?.textContent?.trim() || '',
//       concentration: row.cells[6]?.textContent?.trim() || '',
//       ml:            row.cells[7]?.textContent?.trim() || '',
//       presentation:  row.cells[8]?.textContent?.trim() || '',
//       msrp:          row.cells[11]?.textContent?.trim() || '',
//       wholesale:     parseFloat(row.dataset.unitPrice || 0),
//       stock:         parseInt(row.dataset.stock || 0),
//     });
//     excelRow.height = 60;
//     excelRow.alignment = { vertical: 'middle' };
 
//     const url = row.dataset.imgUrl;
//     if (url && imageCache[url]) {
//       const rowNumber = index + 2; // +1 header, +1 base 1
//       const imageId = workbook.addImage({ base64: imageCache[url], extension: 'jpeg' });
//       sheet.addImage(imageId, {
//         tl: { col: 1.05, row: rowNumber - 1 + 0.05 },
//         ext: { width: 55, height: 55 },
//       });
//     }
//   });
 
//   const buffer = await workbook.xlsx.writeBuffer();
//   let binary = '';
//   const bytes = new Uint8Array(buffer);
//   for (let i = 0; i < bytes.byteLength; i++) binary += String.fromCharCode(bytes[i]);
//   return btoa(binary);
// }


  function resetSendModal() {
      getEl('send-modal').style.display = 'none';
      document.body.style.overflow = '';
      // ── Restaurar siempre a modo incentives ──
      const modeEl      = getEl('send-modal-mode');
      const titleEl     = getEl('send-modal-title');
      const formatSection = getEl('send-format-section');
      if (modeEl)       modeEl.value        = 'incentives';
      if (titleEl)      titleEl.textContent  = 'Send Incentives';
      if (formatSection) formatSection.style.display = '';
      // ── Limpiar campos ──
      const nameEl  = getEl('send-name');
      const emailEl = getEl('send-to-email');
      const msgEl   = getEl('send-message');
      if (nameEl)  nameEl.value  = '';
      if (emailEl) emailEl.value = '';
      if (msgEl)   msgEl.value   = '';
      // ── Restaurar radio a Excel ──
      const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
      if (excelRadio) excelRadio.checked = true;
  }





function initSendModal() {
  const sendBtn = getEl('guidelines-export-send-btn');
  if (!sendBtn || sendBtn.dataset.listenerAttached) return;

 sendBtn.addEventListener('click', () => {
  // Limpiar botones anteriores
  getEl('catalog-download-btns')?.remove();
  getEl('incentives-download-btns')?.remove();
  getEl('preorder-download-btns')?.remove();
  document.querySelectorAll('.send-modal-separator').forEach(el => el.remove());

  const modeEl        = getEl('send-modal-mode');
  const titleEl       = getEl('send-modal-title');
  const formatSection = getEl('send-format-section');

  if (modeEl)         modeEl.value        = 'incentives';
  if (titleEl)        titleEl.textContent  = 'Share Incentives';
  if (formatSection)  formatSection.style.display = '';

  const excelRadio = document.querySelector('input[name="send-format"][value="excel"]');
  if (excelRadio) excelRadio.checked = true;

  // ── Botones descarga directa ──
  const dlBtns = document.createElement('div');
  dlBtns.id = 'incentives-download-btns';
  dlBtns.innerHTML = `
    <div style="    font-family: 'Crimson Pro';display:flex;align-items:center;gap:16px;margin-bottom:20px;padding-bottom:16px;border-bottom:1px solid #e5e7eb;">
      <div style="    font-family: 'Crimson Pro';width:52px;height:52px;border-radius:50%;background:#f0fdf4;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#16a34a" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"/>
          <polyline points="7 10 12 15 17 10"/>
          <line x1="12" y1="15" x2="12" y2="3"/>
        </svg>
      </div>
      <div>
        <div style="    font-family: 'Crimson Pro';font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">1. Download Incentives</div>
        <div style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;margin-top:2px;">Choose a format to download instantly.</div>
      </div>
    </div>

    <div style="display:flex;gap:12px;margin-bottom:12px;">
      <button type="button" id="incentives-dl-excel"
        style="    font-family: 'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
        border-radius:10px;cursor:pointer;font-family:'Crimson Pro',serif;">
        <img src="${window._b2bExcelIconUrl}" width="32" height="28" alt="Excel">
        <div style="text-align:left;">
          <div style="font-size:15px;font-weight:700;color:#111;">Download Excel</div>
          <div style="font-size:12px;color:#6b7280;">.xlsx format</div>
        </div>
      </button>
      <button type="button" id="incentives-dl-pdf"
        style="    font-family: 'Crimson Pro';border:none;flex:1;display:flex;align-items:center;gap:12px;padding:14px 16px;
        border-radius:10px;cursor:pointer;font-family:'Crimson Pro',serif;">
        <img src="${window._b2bPdfIconUrl}" width="32" height="28" alt="PDF">
        <div style="text-align:left;">
          <div style="font-size:15px;font-weight:700;color:#111;">Download PDF</div>
          <div style="font-size:12px;color:#6b7280;">.pdf format</div>
        </div>
      </button>
    </div>

    <div style="text-align:center;margin-bottom:16px;">
      <span style="    font-family: 'Crimson Pro';display:inline-flex;align-items:center;gap:6px;background:#fff;border-radius:99px;padding:4px 14px;font-size:13px;color:#b8a77d;font-weight:600;">
         Instant download – No email required
      </span>
    </div>

    <div style="display:flex;align-items:center;gap:10px;margin-bottom:20px;margin-top:8px;">
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
      <span style="    font-family: 'Crimson Pro';font-size:13px;color:#6b7280;border:1px solid #d1d5db;border-radius:99px;padding:4px 14px;white-space:nowrap;background:#fff;">OR</span>
      <hr style="flex:1;border:none;border-top:1px solid #d1d5db;margin:0;">
    </div>

    <div style="display:flex;align-items:center;gap:16px;margin-bottom:20px;">
      <div style="width:52px;height:52px;border-radius:50%;background:#eff6ff;display:flex;align-items:center;justify-content:center;flex-shrink:0;">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="#2563eb" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
          <path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z"/>
          <polyline points="22,6 12,13 2,6"/>
        </svg>
      </div>
      <div>
        <div style="font-size:14px;font-weight:700;color:#111;text-transform:uppercase;letter-spacing:.5px;">2. Send Incentives by Email</div>
        <div style="font-size:13px;color:#6b7280;margin-top:2px;">Send the file to yourself or another recipient.</div>
      </div>
    </div>`;

  const sendModalInner = getEl('send-modal').querySelector('div[style*="position:relative"]');
  const firstLabel     = sendModalInner?.querySelector('label');
  if (firstLabel) {
    firstLabel.parentNode.insertBefore(dlBtns, firstLabel);
  }

  getEl('incentives-dl-excel')?.addEventListener('click', async () => {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generateGuidelinesBase64('excel');
    if (!base64) return;
    const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `incentives-${vendor.toLowerCase().replace(/\s+/g,'-')}.xlsx`;
    a.click(); URL.revokeObjectURL(url);
  });

  getEl('incentives-dl-pdf')?.addEventListener('click', async () => {
    const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const base64 = await generateGuidelinesBase64('pdf');
    if (!base64) return;
    const blob = base64toBlob(base64, 'application/pdf');
    const url  = URL.createObjectURL(blob);
    const a    = document.createElement('a');
    a.href = url; a.download = `incentives-${vendor.toLowerCase().replace(/\s+/g,'-')}.pdf`;
    a.click(); URL.revokeObjectURL(url);
  });

  const modal = getEl('send-modal');
  if (modal) modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
});

  sendBtn.dataset.listenerAttached = 'true';

  // Mostrar/ocultar campo "otro correo"
  getEl('send-email-select')?.addEventListener('change', function() {
    const wrap = getEl('send-other-email-wrap');
    if (wrap) wrap.style.display = this.value === 'other' ? 'block' : 'none';
  });

  // Cerrar
  getEl('send-modal-cancel')?.addEventListener('click', resetSendModal);
  getEl('send-overlay')?.addEventListener('click', resetSendModal);

  // Confirmar envío
  getEl('send-modal-confirm')?.addEventListener('click', async () => {
    const name          = (getEl('send-name')?.value || '').trim();
    const extraEmail    = (getEl('send-to-email')?.value || '').trim();
    const message       = (getEl('send-message')?.value || '').trim();
    const format        = document.querySelector('input[name="send-format"]:checked')?.value || 'excel';
    const vendor        = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
    const customerEmail = window._b2bCustomerEmail || '';
    const mode          = getEl('send-modal-mode')?.value || 'incentives';

    if (!customerEmail && !extraEmail) {
      alert('No valid email address available.'); return;
    }

    const confirmBtn = getEl('send-modal-confirm');
    confirmBtn.disabled    = true;
    confirmBtn.textContent = 'Sending...';

    getEl('send-modal').style.display = 'none';
    document.body.style.overflow = '';
    lockUI('email');

    try {
      let excelBase64 = null;
      let pdfBase64   = null;

     if (mode === 'catalog') {
        if (format === 'excel' || format === 'both') excelBase64 = await generateCatalogBase64();
        if (format === 'pdf'   || format === 'both') pdfBase64   = await generateCatalogPdfBase64();
      } else if (mode === 'preorder') {
        // reusar las mismas funciones del export excel/pdf de pre-order
        if (format === 'excel' || format === 'both') excelBase64 = await generatePreOrderExcelBase64();
        if (format === 'pdf'   || format === 'both') pdfBase64   = await generatePreOrderPdfBase64();
      } else {
        if (format === 'excel' || format === 'both') excelBase64 = await generateGuidelinesBase64('excel');
        if (format === 'pdf'   || format === 'both') pdfBase64   = await generateGuidelinesBase64('pdf');
}

      const res = await fetch('https://shopifyadminapi.8motiv.com/api/SendEmailNiche', {
        method:  'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          toEmail:       customerEmail || null,
          extraEmail:    extraEmail    || null,
          recipientName: name,
          vendorName:    vendor,
          message:       message,
          format:        format,
          mode:          mode,
          excelBase64:   excelBase64,
          pdfBase64:     pdfBase64
        })
      });

      const data = await res.json();
      if (data.success) {
        const recipients = [customerEmail, extraEmail].filter(Boolean).join(' and ');
        showOverlayResult(true, `Sent to ${recipients}`);
        resetSendModal();
      } else {
        showOverlayResult(false, data.message || 'Please try again.');
      }
    } catch (err) {
      showOverlayResult(false, 'We are currently unable to send emails. Please try again later or contact support.');
      console.log(false, 'Connection error: ' + err.message);
    } finally {
      confirmBtn.disabled  = false;
      confirmBtn.innerHTML = '✉ Send';
    }
  });
}

// ── Helper base64 a Blob ──
function base64toBlob(base64, mimeType) {
  const bytes  = atob(base64);
  const buffer = new ArrayBuffer(bytes.length);
  const view   = new Uint8Array(buffer);
  for (let i = 0; i < bytes.length; i++) view[i] = bytes.charCodeAt(i);
  return new Blob([buffer], { type: mimeType });
}

// async function generatePreOrderExcelBase64() {
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';

//   const wb = XLSX.utils.book_new();

//   // ── Agrupar filas principales por presentación ──
//   const groupedRows = {};
//   const groupOrder  = [];

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
//     const presLower = presDisp.toLowerCase();
//     let groupKey = 'Others';
//     if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
//     else if (presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
//     else if (presLower.includes('retail'))                               groupKey = 'Retail';
//     else if (presLower.includes('travel'))                               groupKey = 'Travel Set';
//     else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;

//     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
//     groupedRows[groupKey].push(row);
//   });

//   // ── Hoja principal con grupos ──
//   const mainData = [];
//   mainData.push([`${vendor} — Pre Order`]);
//   mainData.push([new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' })]);
//   mainData.push([]);

//   let grandTotal = 0, totalItems = 0;
//   const groupSummary = [];

//   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
//   const sortedGroups = [
//     ...preferredOrder.filter(g => groupedRows[g]),
//     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
//   ];

//   sortedGroups.forEach(groupKey => {
//     const rows = groupedRows[groupKey];
//     if (!rows?.length) return;

//     mainData.push([groupKey.toUpperCase()]);
//     mainData.push(['Photo', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'Qty', 'Unit Price', 'Total']);

//     let groupTotal = 0, groupQty = 0;

//     rows.forEach(row => {
//       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
//       const subtotal  = qty * unitPrice;
//       groupTotal += subtotal;
//       groupQty   += qty;
//       grandTotal += subtotal;
//       totalItems += qty;

//       mainData.push([
//         '',
//         row.cells[5]?.textContent?.trim() || '',
//         (row.dataset.sku || '-').toUpperCase(),
//         row.cells[7]?.textContent?.trim() || '',
//         row.cells[8]?.textContent?.trim() || '',
//         row.cells[4]?.textContent?.trim() || '',
//         row.cells[10]?.textContent?.trim() || '',
//         qty,
//         unitPrice,
//         subtotal
//       ]);
//     });

//     mainData.push(['', '', '', '', '', '', '', groupQty, '', groupTotal]);
//     mainData.push([]);
//     groupSummary.push({ key: groupKey, qty: groupQty, total: groupTotal });
//   });

//   // ── Incentivos ──
//   const freeRowsExcel = [];
//   const incentiveByPres = {};

//   const addIncentivePres = (pres, qty, pack) => {
//     const isVails = (pres || '').toLowerCase().includes('vail');
//     const total   = isVails ? qty * (parseInt(pack) || 1) : qty;
//     incentiveByPres[pres || '—'] = (incentiveByPres[pres || '—'] || 0) + total;
//   };

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     const fps    = getVariantFreeProducts(extras);
//     const fqs    = getVariantFreeQtys(extras);
//     const mult   = calcVariantMultiplier(extras, qty, lineV);
//     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

//     if (fps.length > 1) {
//       if (!choice?.confirmed) return;
//       const vid2 = String(choice.chosenVariantId || '');
//       const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
//       const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//       freeRowsExcel.push(['FREE', choice.chosenTitle, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', choice.chosenQty, 0, 0]);
//       addIncentivePres(vd2.pres, choice.chosenQty, ex2.quantity);
//     } else {
//       fps.forEach((fp, i) => {
//         if (!fp?.title) return;
//         const giftQty = (fqs[i] || 1) * mult;
//         const vid2    = String(fp.variant_id || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         freeRowsExcel.push(['FREE', fp.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', giftQty, 0, 0]);
//         addIncentivePres(vd2.pres, giftQty, ex2.quantity);
//       });
//     }
//   });

//   const p2 = window.b2bPriority2Choice || {};
//   let p2Subtotal = 0;
//   if (p2.confirmed) {
//     (p2.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
//       const vid2  = String(s.variant_id || '');
//       const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
//       const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
//       const price = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
//       const disc  = parseFloat(p2.discountPct || 0);
//       const final = price * (1 - disc / 100) * s.selectedQty;
//       p2Subtotal += final;
//       freeRowsExcel.push([`${disc}% Credit`, `${s.title}`, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', s.selectedQty, price*(1-disc/100), final]);
//       addIncentivePres(vd2.pres, s.selectedQty, ex2.quantity);
//     });
//   }

//   const p3 = window.b2bPriority3Choice || {};
//   if (p3.confirmed) {
//     (p3.selections || []).forEach(sel => {
//       (sel.choices || []).forEach(choice => {
//         if (!choice.chosenQty || choice.chosenQty <= 0) return;
//         const vid2 = String(choice.chosenVariantId || '');
//         const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//         freeRowsExcel.push(['FREE', choice.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', ex2.quantity>0?ex2.quantity:'—', choice.chosenQty, 0, 0]);
//         addIncentivePres(vd2.pres, choice.chosenQty, ex2.quantity);
//       });
//     });
//   }

//   if (freeRowsExcel.length) {
//     mainData.push(['INCENTIVES INCLUDED']);
//     mainData.push(['Type', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Units/Pack', 'Qty', 'Unit Price', 'Total']);
//     freeRowsExcel.forEach(r => mainData.push(r));
//     mainData.push([]);
//   }

//   // ── Order Summary ──
//   mainData.push(['ORDER SUMMARY']);
//   mainData.push(['Category', 'Units/Pack', 'Qty', 'Amount']);

//   const totalIncentiveQty = parseInt(getEl('dash-total-incentives')?.textContent || '0');
//   if (totalIncentiveQty > 0) {
//     Object.entries(incentiveByPres).forEach(([pres, qty]) => {
//       mainData.push([`GWP ${pres}`, '—', qty, '$0.00']);
//     });
//     mainData.push(['Total GWP', '—', totalIncentiveQty, '$0.00']);
//   }

//   groupSummary.forEach(g => {
//     mainData.push([g.key, '—', g.qty, g.total]);
//   });

//   if (p2Subtotal > 0) {
//     mainData.push([`Reward Credit (${p2.discountPct}%)`, '—', '—', p2Subtotal]);
//   }

//   mainData.push(['Estimated Total', '—', totalItems, grandTotal]);

//   const ws = XLSX.utils.aoa_to_sheet(mainData);
//   ws['!cols'] = [{wch:12},{wch:32},{wch:20},{wch:10},{wch:14},{wch:20},{wch:12},{wch:8},{wch:14},{wch:14}];
//   XLSX.utils.book_append_sheet(wb, ws, 'Pre-Order');

//   return XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });
// }

// async function generatePreOrderPdfBase64() {
//   const { jsPDF } = window.jspdf;
//   if (!jsPDF) return null;

//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//   const doc    = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
//   const pageW  = doc.internal.pageSize.getWidth();
//   const pageH  = doc.internal.pageSize.getHeight();
//   const margin = 10, colW = pageW - margin * 2;
//   let y = margin;

//   const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
//   const fmt2 = n => parseFloat(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

//   // ── Título ──
//   doc.setFontSize(16); doc.setFont('helvetica', 'bold');
//   doc.text(`${vendor} — Pre Order`, pageW / 2, y + 6, { align: 'center' }); y += 10;
//   doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120,120,120);
//   doc.text(new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }), pageW / 2, y, { align: 'center' });
//   doc.setTextColor(0,0,0); y += 8;

//   // ── Columnas tabla principal ──
//   const cols  = [52, 20, 14, 22, 30, 14, 12, 22, 22];
//   const hdrs  = ['Product','SKU','ML','Presentation','Collection','Coefficient','Qty','Unit Price','Total'];

//   function drawTableHeader(bgR, bgG, bgB) {
//     doc.setFillColor(bgR||50, bgG||50, bgB||50);
//     doc.rect(margin, y, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     let cx = margin + 2;
//     hdrs.forEach((h, i) => { doc.text(h, cx, y + 4.5); cx += cols[i]; });
//     doc.setTextColor(0,0,0); y += 8;
//   }

//   function drawGroupFooter(groupQty, groupTotal) {
//     checkPage(8);
//     doc.setFillColor(230,230,230);
//     doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold');
//     let cx2 = margin + 2;
//     cols.slice(0,-2).forEach(w => { cx2 += w; });
//     doc.text('Subtotal', cx2 - 20, y + 4);
//     cx2 = margin + 2; cols.slice(0,6).forEach(w => cx2 += w);
//     doc.text(String(groupQty), cx2, y + 4);
//     cx2 += cols[6] + cols[7];
//     doc.text('$' + fmt2(groupTotal), cx2, y + 4);
//     doc.setFont('helvetica','normal');
//     y += 9;
//   }

//   // ── Agrupar por presentación ──
//   const groupedRows = {};
//   const groupOrder  = [];

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
//     const presLower = presDisp.toLowerCase();
//     let groupKey = 'Others';
//     if (presLower.includes('perfume'))                                   groupKey = 'Perfumes';
//     else if (presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
//     else if (presLower.includes('retail'))                               groupKey = 'Retail';
//     else if (presLower.includes('travel'))                               groupKey = 'Travel Set';
//     else if (presDisp && presDisp !== 'N/A')                            groupKey = presDisp;
//     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
//     groupedRows[groupKey].push(row);
//   });

//   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
//   const sortedGroups   = [
//     ...preferredOrder.filter(g => groupedRows[g]),
//     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
//   ];

//   let grandTotal = 0, totalItems = 0, rowCount = 0;
//   const groupSummaryPdf = [];

//   sortedGroups.forEach(groupKey => {
//     const rows = groupedRows[groupKey];
//     if (!rows?.length) return;

//     checkPage(20);
//     // ── Header grupo ──
//     doc.setFillColor(184,167,125);
//     doc.rect(margin, y, colW, 8, 'F');
//     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     doc.text(`${groupKey}  (${rows.length} item${rows.length > 1 ? 's' : ''})`, margin + 3, y + 5.5);
//     doc.setTextColor(0,0,0); y += 10;

//     drawTableHeader();

//     let groupTotal = 0, groupQty = 0;

//     rows.forEach(row => {
//       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
//       const subtotal  = qty * unitPrice;
//       checkPage(8);
//       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
//       doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(7); doc.setFont('helvetica','normal');
//       let cx = margin + 2;
//       [
//         (row.cells[5]?.textContent?.trim() || '').substring(0,30),
//         (row.dataset.sku || '-').toUpperCase().substring(0,12),
//         (row.cells[7]?.textContent?.trim() || '').substring(0,8),
//         (row.cells[8]?.textContent?.trim() || '').substring(0,14),
//         (row.cells[4]?.textContent?.trim() || '').substring(0,18),
//         (row.cells[10]?.textContent?.trim() || '').substring(0,8),
//         String(qty),
//         '$' + unitPrice.toFixed(2),
//         '$' + subtotal.toFixed(2)
//       ].forEach((v, i) => { doc.text(v, cx, y + 4); cx += cols[i]; });
//       y += 7; rowCount++;
//       groupTotal += subtotal; groupQty += qty;
//       grandTotal += subtotal; totalItems += qty;
//     });

//     drawGroupFooter(groupQty, groupTotal);
//     groupSummaryPdf.push({ key: groupKey, qty: groupQty, total: groupTotal });
//   });

//   // ── Incentivos ──
//   const freeRowsPDF = [];
//   const incentiveByPresPDF = {};

//   const addPresPDF = (pres, qty, pack) => {
//     // const isVails = (pres || '').toLowerCase().includes('vail');
//     const isVails = (pres || '').toLowerCase().includes('vial') || 
//                 (pres || '').toLowerCase().includes('vail');
//     const total   = isVails ? qty * (parseInt(pack) || 1) : qty;
//     incentiveByPresPDF[pres || '—'] = (incentiveByPresPDF[pres || '—'] || 0) + total;
//   };

//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     const fps    = getVariantFreeProducts(extras);
//     const fqs    = getVariantFreeQtys(extras);
//     const mult   = calcVariantMultiplier(extras, qty, lineV);
//     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
//     if (fps.length > 1) {
//       if (!choice?.confirmed) return;
//       const vid2 = String(choice.chosenVariantId || '');
//       const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
//       const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//       freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.chosenTitle, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:choice.chosenQty, price:'$0.00', color:[50,50,50], bg:[248,249,250]});
//       addPresPDF(vd2.pres, choice.chosenQty, ex2.quantity);
//     } else {
//       fps.forEach((fp, i) => {
//         if (!fp?.title) return;
//         const giftQty = (fqs[i] || 1) * mult;
//         const vid2    = String(fp.variant_id || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:fp.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:giftQty, price:'$0.00', color:[50,50,50], bg:[248,249,250]});
//         addPresPDF(vd2.pres, giftQty, ex2.quantity);
//       });
//     }
//   });

//   const p2pdf = window.b2bPriority2Choice || {};
//   let p2SubtotalPDF = 0;
//   if (p2pdf.confirmed) {
//     (p2pdf.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
//       const vid2  = String(s.variant_id || '');
//       const ex2   = window.b2bVariantExtrasMap?.[vid2] || {};
//       const vd2   = window.b2bAllVariantsMap?.[vid2] || {};
//       const price = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
//       const disc  = parseFloat(p2pdf.discountPct || 0);
//       const final = price * (1 - disc / 100) * s.selectedQty;
//       p2SubtotalPDF += final;
//       freeRowsPDF.push({ badge:`${disc}%`, sku:vd2.sku||'—', title:s.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:s.selectedQty, price:`$${(price*(1-disc/100)).toFixed(2)}`, color:[50,50,50], bg:[248,249,250]});
//       addPresPDF(vd2.pres, s.selectedQty, ex2.quantity);
//     });
//   }

//   const p3pdf = window.b2bPriority3Choice || {};
//   if (p3pdf.confirmed) {
//     (p3pdf.selections || []).forEach(sel => {
//       (sel.choices || []).forEach(choice => {
//         if (!choice.chosenQty || choice.chosenQty <= 0) return;
//         const vid2 = String(choice.chosenVariantId || '');
//         const vd2  = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2  = window.b2bVariantExtrasMap?.[vid2] || {};
//         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:ex2.quantity>0?ex2.quantity:'—', qty:choice.chosenQty, price:'$0.00', color:[22,101,52], bg:[220,252,231] });
//         addPresPDF(vd2.pres, choice.chosenQty, ex2.quantity);
//       });
//     });
//   }

//   if (freeRowsPDF.length) {
//     checkPage(20);
//     y += 4;
//     doc.setFillColor(39,110,49);
//     doc.rect(margin, y, colW, 8, 'F');
//     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     doc.text('INCENTIVES INCLUDED', margin + 3, y + 5.5);
//     doc.setTextColor(0,0,0); y += 10;

//     const colsF = [12,50,14,20,14,12,10,14];
//     const hdrsF = ['Type','Product','SKU','ML','Presentation','Pack','Qty','Price'];
//     doc.setFillColor(50,50,50); doc.rect(margin, y, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     let cxH = margin + 2;
//     hdrsF.forEach((h, i) => { doc.text(h, cxH, y + 4.5); cxH += colsF[i]; });
//     doc.setTextColor(0,0,0); y += 8;

//     freeRowsPDF.forEach(item => {
//       checkPage(8);
//       doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(7);
//       let cxF = margin + 2;
//       doc.setFont('helvetica','bold'); doc.setTextColor(...item.color);
//       doc.text(String(item.badge), cxF, y + 4); cxF += colsF[0];
//       doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
//       [item.title.substring(0,30), item.sku.substring(0,10), item.ml.substring(0,8), item.pres.substring(0,12), String(item.pack), String(item.qty), item.price].forEach((v, i) => {
//         doc.text(v, cxF, y + 4); cxF += colsF[i + 1];
//       });
//       y += 7;
//     });
//   }

//   // ── Order Summary ──
//   checkPage(60);
//   y += 8;
//   doc.setFillColor(50,50,50); doc.rect(margin, y, colW, 8, 'F');
//   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   doc.text('ORDER SUMMARY', margin + 3, y + 5.5);
//   doc.setTextColor(0,0,0); y += 10;

//   const sumCols = [120, 40, 30, 40];
//   const sumHdrs = ['Category','Units/Pack','Qty','Amount'];
//   doc.setFillColor(80,80,80); doc.rect(margin, y, colW, 7, 'F');
//   doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   let cxS = margin + 2;
//   sumHdrs.forEach((h, i) => { doc.text(h, cxS, y + 4.5); cxS += sumCols[i]; });
//   doc.setTextColor(0,0,0); y += 8;

//   let sumRow = 0;

//   const totalIncentiveQtyPDF = parseInt(getEl('dash-total-incentives')?.textContent || '0');
//   if (totalIncentiveQtyPDF > 0) {
//     Object.entries(incentiveByPresPDF).forEach(([pres, qty]) => {
//       checkPage(7);
//       doc.setFillColor(...(sumRow % 2 === 0 ? [240,252,244] : [220,252,231]));
//       doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(22,101,52);
//       let cx2 = margin + 2;
//       [`GWP ${pres}`, '—', String(qty), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//       doc.setTextColor(0,0,0); y += 7; sumRow++;
//     });
//     checkPage(7);
//     doc.setFillColor(200,240,210); doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(22,101,52);
//     let cx2 = margin + 2;
//     ['Total GWP', '—', String(totalIncentiveQtyPDF), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//     doc.setTextColor(0,0,0); y += 8; sumRow++;
//   }

//   groupSummaryPdf.forEach(g => {
//     checkPage(7);
//     doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [248,249,250]));
//     doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','normal');
//     let cx2 = margin + 2;
//     [g.key, '—', String(g.qty), '$' + fmt2(g.total)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//     y += 7; sumRow++;
//   });

//   if (p2SubtotalPDF > 0) {
//     checkPage(7);
//     doc.setFillColor(219,234,254); doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(29,78,216);
//     let cx2 = margin + 2;
//     [`Reward Credit (${p2pdf.discountPct}%)`, '—', '—', '$' + fmt2(p2SubtotalPDF)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//     doc.setTextColor(0,0,0); y += 7;
//   }

//   checkPage(9);
//   doc.setFillColor(50,50,50); doc.rect(margin, y - 1, colW, 9, 'F');
//   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   let cx2 = margin + 2;
//   ['Estimated Total', '—', String(totalItems), '$' + fmt2(grandTotal)].forEach((v, i) => { doc.text(v, cx2, y + 5.5); cx2 += sumCols[i]; });

//   return doc.output('datauristring').split(',')[1];
// }


async function generatePreOrderExcelBase64() {
  const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
 
  const wb = XLSX.utils.book_new();
 
  const groupedRows = {};
  const groupOrder  = [];
 
  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (!qty) return;
    const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
    const presLower = presDisp.toLowerCase();
    let groupKey = 'Others';
    if (presLower.includes('perfume'))                                              groupKey = 'Perfumes';
    else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
    else if (presLower.includes('retail'))                                          groupKey = 'Retail';
    else if (presLower.includes('travel'))                                          groupKey = 'Travel Set';
    else if (presDisp && presDisp !== 'N/A')                                        groupKey = presDisp;
 
    if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
    groupedRows[groupKey].push(row);
  });
 
  const mainData = [];
  mainData.push([`${vendor} — Pre Order`]);
  mainData.push([new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' })]);
  mainData.push([]);
 
  let grandTotal = 0, totalItems = 0;
  const groupSummary = [];
 
  const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
  const sortedGroups = [
    ...preferredOrder.filter(g => groupedRows[g]),
    ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
  ];
 
  sortedGroups.forEach(groupKey => {
    const rows = groupedRows[groupKey];
    if (!rows?.length) return;
 
    mainData.push([groupKey.toUpperCase()]);
    mainData.push(['Photo', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Coefficient', 'Qty', 'Unit Price', 'Total']);
 
    let groupTotal = 0, groupQty = 0;
 
    rows.forEach(row => {
      const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      const unitPrice = parseFloat(row.dataset.unitPrice || 0);
      const subtotal  = qty * unitPrice;
      groupTotal += subtotal;
      groupQty   += qty;
      grandTotal += subtotal;
      totalItems += qty;
 
      mainData.push([
        '',
        row.cells[5]?.textContent?.trim() || '',
        (row.dataset.sku || '-').toUpperCase(),
        row.cells[7]?.textContent?.trim() || '',
        row.cells[8]?.textContent?.trim() || '',
        row.cells[4]?.textContent?.trim() || '',
        row.cells[10]?.textContent?.trim() || '',
        qty,
        unitPrice,
        subtotal
      ]);
    });
 
    mainData.push(['', '', '', '', '', '', '', groupQty, '', groupTotal]);
    mainData.push([]);
    groupSummary.push({ key: groupKey, qty: groupQty, total: groupTotal });
  });
 
  const freeRowsExcel = [];
  const incentiveByPres = {};
 
  const addIncentivePres = (pres, qty, pack) => {
    const isVials = (pres || '').toLowerCase().includes('vial') ||
                    (pres || '').toLowerCase().includes('vail');
    const packVal = parseInt(pack) > 0 ? parseInt(pack) : 1;
    const total   = isVials ? qty * packVal : qty;
    incentiveByPres[pres || '—'] = (incentiveByPres[pres || '—'] || 0) + total;
  };
 
  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (!qty) return;
    const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
    if (!variantHasIncentive(extras)) return;
    const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
    if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
    const fps    = getVariantFreeProducts(extras);
    const fqs    = getVariantFreeQtys(extras);
    const mult   = calcVariantMultiplier(extras, qty, lineV);
    const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
 
    if (fps.length > 1) {
      if (!choice?.confirmed) return;
      const vid2   = String(choice.chosenVariantId || '');
      const vd2    = window.b2bAllVariantsMap?.[vid2] || {};
      const ex2    = window.b2bVariantExtrasMap?.[vid2] || {};
      const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
      freeRowsExcel.push(['FREE', choice.chosenTitle, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', choice.chosenQty, 0, 0]);
      addIncentivePres(vd2.pres, choice.chosenQty, packVal);
    } else {
      fps.forEach((fp, i) => {
        if (!fp?.title) return;
        const giftQty = (fqs[i] || 1) * mult;
        const vid2    = String(fp.variant_id || '');
        const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
        const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
        const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
        freeRowsExcel.push(['FREE', fp.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', giftQty, 0, 0]);
        addIncentivePres(vd2.pres, giftQty, packVal);
      });
    }
  });
 
  const p2 = window.b2bPriority2Choice || {};
  let p2Subtotal = 0;
  if (p2.confirmed) {
    (p2.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
      const vid2    = String(s.variant_id || '');
      const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
      const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
      const price   = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
      const disc    = parseFloat(p2.discountPct || 0);
      const final   = price * (1 - disc / 100) * s.selectedQty;
      const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
      p2Subtotal += final;
      freeRowsExcel.push([`${disc}% Credit`, `${s.title}`, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', s.selectedQty, price*(1-disc/100), final]);
      addIncentivePres(vd2.pres, s.selectedQty, packVal);
    });
  }
 
  const p3 = window.b2bPriority3Choice || {};
  if (p3.confirmed) {
    (p3.selections || []).forEach(sel => {
      (sel.choices || []).forEach(choice => {
        if (!choice.chosenQty || choice.chosenQty <= 0) return;
        const vid2    = String(choice.chosenVariantId || '');
        const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
        const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
        const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
        freeRowsExcel.push(['FREE', choice.title, vd2.sku||'—', vd2.ml||'—', vd2.pres||'—', '', packVal > 1 ? packVal : '—', choice.chosenQty, 0, 0]);
        addIncentivePres(vd2.pres, choice.chosenQty, packVal);
      });
    });
  }
 
  if (freeRowsExcel.length) {
    mainData.push(['INCENTIVES INCLUDED']);
    mainData.push(['Type', 'Product', 'SKU', 'ML', 'Presentation', 'Collection', 'Units/Pack', 'Qty', 'Unit Price', 'Total']);
    freeRowsExcel.forEach(r => mainData.push(r));
    mainData.push([]);
  }
 
  mainData.push(['ORDER SUMMARY']);
  mainData.push(['Category', 'Units/Pack', 'Qty', 'Amount']);
 
  const totalIncentiveQty = parseInt(getEl('dash-total-incentives')?.textContent || '0');
  if (totalIncentiveQty > 0) {
    Object.entries(incentiveByPres).forEach(([pres, qty]) => {
      mainData.push([`GWP ${pres}`, '—', qty, '$0.00']);
    });
    mainData.push(['Total GWP', '—', totalIncentiveQty, '$0.00']);
  }
 
  groupSummary.forEach(g => {
    mainData.push([g.key, '—', g.qty, g.total]);
  });
 
  if (p2Subtotal > 0) {
    mainData.push([`Reward Credit (${p2.discountPct}%)`, '—', '—', p2Subtotal]);
  }
 
  mainData.push(['Estimated Total', '—', totalItems, grandTotal]);
 
  const ws = XLSX.utils.aoa_to_sheet(mainData);
  ws['!cols'] = [{wch:12},{wch:32},{wch:20},{wch:10},{wch:14},{wch:20},{wch:12},{wch:8},{wch:14},{wch:14}];
  XLSX.utils.book_append_sheet(wb, ws, 'Pre-Order');
 
  return XLSX.write(wb, { bookType: 'xlsx', type: 'base64' });
}
 
 
// async function generatePreOrderPdfBase64() {
//   const { jsPDF } = window.jspdf;
//   if (!jsPDF) return null;
 
//   const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
//   const doc    = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
//   const pageW  = doc.internal.pageSize.getWidth();
//   const pageH  = doc.internal.pageSize.getHeight();
//   const margin = 10, colW = pageW - margin * 2;
//   let y = margin;
 
//   const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
//   const fmt2 = n => parseFloat(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
 
//   doc.setFontSize(16); doc.setFont('helvetica', 'bold');
//   doc.text(`${vendor} — Pre Order`, pageW / 2, y + 6, { align: 'center' }); y += 10;
//   doc.setFontSize(9); doc.setFont('helvetica', 'normal'); doc.setTextColor(120,120,120);
//   doc.text(new Date().toLocaleDateString('en-US', { year:'numeric', month:'long', day:'numeric' }), pageW / 2, y, { align: 'center' });
//   doc.setTextColor(0,0,0); y += 8;
 
//   const cols = [52, 20, 14, 22, 30, 14, 12, 22, 22];
//   const hdrs = ['Product','SKU','ML','Presentation','Collection','Coefficient','Qty','Unit Price','Total'];
 
//   function drawTableHeader() {
//     doc.setFillColor(50,50,50);
//     doc.rect(margin, y, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     let cx = margin + 2;
//     hdrs.forEach((h, i) => { doc.text(h, cx, y + 4.5); cx += cols[i]; });
//     doc.setTextColor(0,0,0); y += 8;
//   }
 
//   function drawGroupFooter(groupQty, groupTotal) {
//     checkPage(8);
//     doc.setFillColor(230,230,230);
//     doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold');
//     let cx2 = margin + 2;
//     cols.slice(0,6).forEach(w => cx2 += w);
//     doc.text(String(groupQty), cx2, y + 4);
//     cx2 += cols[6] + cols[7];
//     doc.text('$' + fmt2(groupTotal), cx2, y + 4);
//     doc.setFont('helvetica','normal');
//     y += 9;
//   }
 
//   const groupedRows = {};
//   const groupOrder  = [];
 
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
//     const presLower = presDisp.toLowerCase();
//     let groupKey = 'Others';
//     if (presLower.includes('perfume'))                                              groupKey = 'Perfumes';
//     else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
//     else if (presLower.includes('retail'))                                          groupKey = 'Retail';
//     else if (presLower.includes('travel'))                                          groupKey = 'Travel Set';
//     else if (presDisp && presDisp !== 'N/A')                                        groupKey = presDisp;
//     if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
//     groupedRows[groupKey].push(row);
//   });
 
//   const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
//   const sortedGroups   = [
//     ...preferredOrder.filter(g => groupedRows[g]),
//     ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
//   ];
 
//   let grandTotal = 0, totalItems = 0, rowCount = 0;
//   const groupSummaryPdf = [];
 
//   sortedGroups.forEach(groupKey => {
//     const rows = groupedRows[groupKey];
//     if (!rows?.length) return;
 
//     checkPage(20);
//     doc.setFillColor(184,167,125);
//     doc.rect(margin, y, colW, 8, 'F');
//     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     doc.text(`${groupKey}  (${rows.length} item${rows.length > 1 ? 's' : ''})`, margin + 3, y + 5.5);
//     doc.setTextColor(0,0,0); y += 10;
 
//     drawTableHeader();
 
//     let groupTotal = 0, groupQty = 0;
 
//     rows.forEach(row => {
//       const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//       const unitPrice = parseFloat(row.dataset.unitPrice || 0);
//       const subtotal  = qty * unitPrice;
//       checkPage(8);
//       doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [248,249,250]));
//       doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(7); doc.setFont('helvetica','normal');
//       let cx = margin + 2;
//       [
//         (row.cells[5]?.textContent?.trim() || '').substring(0,30),
//         (row.dataset.sku || '-').toUpperCase().substring(0,12),
//         (row.cells[7]?.textContent?.trim() || '').substring(0,8),
//         (row.cells[8]?.textContent?.trim() || '').substring(0,14),
//         (row.cells[4]?.textContent?.trim() || '').substring(0,18),
//         (row.cells[10]?.textContent?.trim() || '').substring(0,8),
//         String(qty),
//         '$' + unitPrice.toFixed(2),
//         '$' + subtotal.toFixed(2)
//       ].forEach((v, i) => { doc.text(v, cx, y + 4); cx += cols[i]; });
//       y += 7; rowCount++;
//       groupTotal += subtotal; groupQty += qty;
//       grandTotal += subtotal; totalItems += qty;
//     });
 
//     drawGroupFooter(groupQty, groupTotal);
//     groupSummaryPdf.push({ key: groupKey, qty: groupQty, total: groupTotal });
//   });
 
//   const freeRowsPDF = [];
//   const incentiveByPresPDF = {};
 
//   const addPresPDF = (pres, qty, pack) => {
//     const isVials = (pres || '').toLowerCase().includes('vial') ||
//                     (pres || '').toLowerCase().includes('vail');
//     const packVal = parseInt(pack) > 0 ? parseInt(pack) : 1;
//     const total   = isVials ? qty * packVal : qty;
//     incentiveByPresPDF[pres || '—'] = (incentiveByPresPDF[pres || '—'] || 0) + total;
//   };
 
//   variantRows().forEach(row => {
//     const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//     if (!qty) return;
//     const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
//     if (!variantHasIncentive(extras)) return;
//     const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
//     if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
//     const fps    = getVariantFreeProducts(extras);
//     const fqs    = getVariantFreeQtys(extras);
//     const mult   = calcVariantMultiplier(extras, qty, lineV);
//     const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];
 
//     if (fps.length > 1) {
//       if (!choice?.confirmed) return;
//       const vid2    = String(choice.chosenVariantId || '');
//       const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//       const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//       freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.chosenTitle, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', color:[50,50,50], bg:[248,249,250] });
//       addPresPDF(vd2.pres, choice.chosenQty, packVal);
//     } else {
//       fps.forEach((fp, i) => {
//         if (!fp?.title) return;
//         const giftQty = (fqs[i] || 1) * mult;
//         const vid2    = String(fp.variant_id || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:fp.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:giftQty, price:'$0.00', color:[50,50,50], bg:[248,249,250] });
//         addPresPDF(vd2.pres, giftQty, packVal);
//       });
//     }
//   });
 
//   const p2pdf = window.b2bPriority2Choice || {};
//   let p2SubtotalPDF = 0;
//   if (p2pdf.confirmed) {
//     (p2pdf.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
//       const vid2    = String(s.variant_id || '');
//       const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//       const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//       const price   = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
//       const disc    = parseFloat(p2pdf.discountPct || 0);
//       const final   = price * (1 - disc / 100) * s.selectedQty;
//       const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//       p2SubtotalPDF += final;
//       freeRowsPDF.push({ badge:`${disc}%`, sku:vd2.sku||'—', title:s.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:s.selectedQty, price:`$${(price*(1-disc/100)).toFixed(2)}`, color:[50,50,50], bg:[248,249,250] });
//       addPresPDF(vd2.pres, s.selectedQty, packVal);
//     });
//   }
 
//   const p3pdf = window.b2bPriority3Choice || {};
//   if (p3pdf.confirmed) {
//     (p3pdf.selections || []).forEach(sel => {
//       (sel.choices || []).forEach(choice => {
//         if (!choice.chosenQty || choice.chosenQty <= 0) return;
//         const vid2    = String(choice.chosenVariantId || '');
//         const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
//         const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
//         const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
//         freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', color:[50,50,50], bg:[248,249,250] });
//         addPresPDF(vd2.pres, choice.chosenQty, packVal);
//       });
//     });
//   }
 
//   if (freeRowsPDF.length) {
//     checkPage(20);
//     y += 4;
//     doc.setFillColor(50,50,50);
//     doc.rect(margin, y, colW, 8, 'F');
//     doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     doc.text('INCENTIVES INCLUDED', margin + 3, y + 5.5);
//     doc.setTextColor(0,0,0); y += 10;
 
//     const colsF = [12,50,14,20,14,12,10,14];
//     const hdrsF = ['Type','Product','SKU','ML','Presentation','Pack','Qty','Price'];
//     doc.setFillColor(80,80,80); doc.rect(margin, y, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//     let cxH = margin + 2;
//     hdrsF.forEach((h, i) => { doc.text(h, cxH, y + 4.5); cxH += colsF[i]; });
//     doc.setTextColor(0,0,0); y += 8;
 
//     freeRowsPDF.forEach(item => {
//       checkPage(8);
//       doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(7);
//       let cxF = margin + 2;
//       doc.setFont('helvetica','bold'); doc.setTextColor(...item.color);
//       doc.text(String(item.badge), cxF, y + 4); cxF += colsF[0];
//       doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
//       [item.title.substring(0,30), item.sku.substring(0,10), item.ml.substring(0,8), item.pres.substring(0,12), String(item.pack), String(item.qty), item.price].forEach((v, i) => {
//         doc.text(v, cxF, y + 4); cxF += colsF[i + 1];
//       });
//       y += 7;
//     });
//   }
 
//   checkPage(60);
//   y += 8;
//   doc.setFillColor(50,50,50); doc.rect(margin, y, colW, 8, 'F');
//   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   doc.text('ORDER SUMMARY', margin + 3, y + 5.5);
//   doc.setTextColor(0,0,0); y += 10;
 
//   const sumCols = [120, 40, 30, 40];
//   const sumHdrs = ['Category','Units/Pack','Qty','Amount'];
//   doc.setFillColor(80,80,80); doc.rect(margin, y, colW, 7, 'F');
//   doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   let cxS = margin + 2;
//   sumHdrs.forEach((h, i) => { doc.text(h, cxS, y + 4.5); cxS += sumCols[i]; });
//   doc.setTextColor(0,0,0); y += 8;
 
//   let sumRow = 0;
 
//   const totalIncentiveQtyPDF = parseInt(getEl('dash-total-incentives')?.textContent || '0');
//   if (totalIncentiveQtyPDF > 0) {
//     Object.entries(incentiveByPresPDF).forEach(([pres, qty]) => {
//       checkPage(7);
//       doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [248,249,250]));
//       doc.rect(margin, y - 1, colW, 7, 'F');
//       doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
//       let cx2 = margin + 2;
//       [`GWP ${pres}`, '—', String(qty), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//       doc.setTextColor(0,0,0); y += 7; sumRow++;
//     });
//     checkPage(7);
//     doc.setFillColor(230,230,230); doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(50,50,50);
//     let cx2 = margin + 2;
//     ['Total GWP', '—', String(totalIncentiveQtyPDF), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//     doc.setTextColor(0,0,0); y += 8; sumRow++;
//   }
 
//   groupSummaryPdf.forEach(g => {
//     checkPage(7);
//     doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [248,249,250]));
//     doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
//     let cx2 = margin + 2;
//     [g.key, '—', String(g.qty), '$' + fmt2(g.total)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//     y += 7; sumRow++;
//   });
 
//   if (p2SubtotalPDF > 0) {
//     checkPage(7);
//     doc.setFillColor(248,249,250); doc.rect(margin, y - 1, colW, 7, 'F');
//     doc.setFontSize(7); doc.setFont('helvetica','bold'); doc.setTextColor(50,50,50);
//     let cx2 = margin + 2;
//     [`Reward Credit (${p2pdf.discountPct}%)`, '—', '—', '$' + fmt2(p2SubtotalPDF)].forEach((v, i) => { doc.text(v, cx2, y + 4); cx2 += sumCols[i]; });
//     doc.setTextColor(0,0,0); y += 7;
//   }
 
//   checkPage(9);
//   doc.setFillColor(50,50,50); doc.rect(margin, y - 1, colW, 9, 'F');
//   doc.setFontSize(9); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
//   let cx2 = margin + 2;
//   ['Estimated Total', '—', String(totalItems), '$' + fmt2(grandTotal)].forEach((v, i) => { doc.text(v, cx2, y + 5.5); cx2 += sumCols[i]; });
 
//   return doc.output('datauristring').split(',')[1];
// }

// ══════════════════════════════════════════════════════════════
// ESTILO NICHE305 aplicado al PDF de Pre Order — v3
// Cambios sobre v2:
//   1) Las 3 stat-boxes ahora usan el mismo ancho que la tabla
//      (antes usaban una fórmula distinta y quedaban más angostas).
//   2) Letra más grande en toda la tabla (encabezados y filas).
//   3) Foto de producto más grande (16mm en vez de 11mm) y filas
//      más altas para que entre cómoda.
// ══════════════════════════════════════════════════════════════

// ── Helper: convierte una imagen a base64 para jsPDF ──
function loadImageAsBase64(url) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.crossOrigin = 'Anonymous';
    img.onload = function () {
      const canvas = document.createElement('canvas');
      canvas.width = img.width;
      canvas.height = img.height;
      const ctx = canvas.getContext('2d');
      ctx.drawImage(img, 0, 0);
      resolve(canvas.toDataURL('image/png'));
    };
    img.onerror = reject;
    img.src = url;
  });
}

// ── AJUSTAR AQUÍ si tu tabla de producto usa otro selector/atributo ──
function getRowImageUrl(row) {
  const img = row.querySelector('img');
  if (img) return img.currentSrc || img.src || null;
  if (row.dataset.image) return row.dataset.image;
  if (row.dataset.imageUrl) return row.dataset.imageUrl;
  return null;
}

// ── AJUSTAR AQUÍ si el mapa de variantes usa otro campo para la imagen ──
// FIX: los objetos de window.b2bAllVariantsMap normalmente no traen imagen,
// así que como respaldo buscamos la foto en el DOM (variantRows()) por
// variantId — el mismo método que ya funciona para la tabla principal.
function getFreeItemImageUrl(vd2, variantId) {
  const fromMap = vd2?.image || vd2?.img || vd2?.photo || vd2?.imageUrl || null;
  if (fromMap) return fromMap;
  if (variantId) return getVariantImageFromDom(variantId);
  return null;
}

let _variantImageDomCache = null;
function getVariantImageFromDom(variantId) {
  if (!_variantImageDomCache) {
    _variantImageDomCache = {};
    variantRows().forEach(r => {
      const vid = String(r.dataset.variantId || '');
      if (vid && !_variantImageDomCache[vid]) {
        const url = getRowImageUrl(r);
        if (url) _variantImageDomCache[vid] = url;
      }
    });
  }
  return _variantImageDomCache[String(variantId)] || null;
}

// ── Encabezado con logo (o fallback de texto) ──
async function drawPreOrderHeader(doc, pageW, margin, vendor) {
  doc.setFillColor(255, 255, 255);
  doc.rect(0, 0, pageW, 42, 'F');

  const logoUrl   = window.NICHE_LOGO_URL;
  const logoOrigW = window.NICHE_LOGO_WIDTH;
  const logoOrigH = window.NICHE_LOGO_HEIGHT;

  let logoDrawn = false;

  if (logoUrl) {
    try {
      const logoImg = await loadImageAsBase64(logoUrl);
      const maxH  = 18;
      const ratio = (logoOrigW && logoOrigH) ? logoOrigW / logoOrigH : 3;
      const logoH = maxH;
      const logoW = logoH * ratio;
      doc.addImage(logoImg, 'PNG', (pageW - logoW) / 2, 6, logoW, logoH);
      logoDrawn = true;
    } catch (e) {
      logoDrawn = false;
    }
  }

  if (!logoDrawn) {
    doc.setFont('helvetica', 'bold');
    doc.setFontSize(16);
    const nicheW     = doc.getTextWidth('NICHE');
    const totalLogoW = nicheW + doc.getTextWidth('305') + 2;
    const logoStartX = (pageW - totalLogoW) / 2;
    doc.setTextColor(60, 55, 45);
    doc.text('NICHE', logoStartX, 13);
    doc.setTextColor(183, 172, 126);
    doc.text('305', logoStartX + nicheW + 2, 13);
  }

  doc.setDrawColor(220, 215, 205);
  doc.setLineWidth(0.3);
  doc.line(margin, 27, pageW - margin, 27);

  doc.setFont('helvetica', 'bold');
  doc.setFontSize(13);
  doc.setTextColor(30, 30, 30);
  doc.text(`${vendor} — Pre Order`, pageW / 2, 33, { align: 'center' });

  doc.setFont('helvetica', 'normal');
  doc.setFontSize(8);
  doc.setTextColor(160, 160, 160);
  doc.text(
    new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' }),
    pageW / 2, 38, { align: 'center' }
  );

  doc.setDrawColor(220, 215, 205);
  doc.line(margin, 40, pageW - margin, 40);

  return 42;
}

// ── 3 stat-boxes: ahora usan EXACTAMENTE el mismo ancho que la tabla (colW) ──
function drawPreOrderStatBoxes(doc, stats, margin, colW, y) {
  const boxH = 22;
  const gap  = 4;
  const boxW = (colW - (stats.length - 1) * gap) / stats.length;

  stats.forEach((s, i) => {
    const bx = margin + i * (boxW + gap);
    doc.setFillColor(248, 247, 244);
    doc.setDrawColor(220, 215, 205);
    doc.setLineWidth(0.3);
    doc.roundedRect(bx, y, boxW, boxH, 1.5, 1.5, 'FD');

    doc.setFont('helvetica', 'normal');
    doc.setFontSize(8);
    doc.setTextColor(150, 140, 120);
    doc.text(s.label, bx + boxW / 2, y + 7, { align: 'center' });

    doc.setFont('helvetica', 'bold');
    doc.setFontSize(14);
    doc.setTextColor(30, 30, 30);
    doc.text(String(s.value), bx + boxW / 2, y + 16, { align: 'center' });
  });

  return y + boxH;
}

// ══════════════════════════════════════════════════════════════
// GENERADOR PRINCIPAL (misma lógica de datos que el original)
// ══════════════════════════════════════════════════════════════
async function generatePreOrderPdfBase64() {
  const { jsPDF } = window.jspdf;
  if (!jsPDF) return null;

  const vendor = new URLSearchParams(window.location.search).get('vendor') || 'Brand';
  const doc    = new jsPDF({ orientation: 'landscape', unit: 'mm', format: 'a4' });
  const pageW  = doc.internal.pageSize.getWidth();
  const pageH  = doc.internal.pageSize.getHeight();
  const margin = 14, colW = pageW - margin * 2;
  let y = 0;

  const checkPage = n => { if (y + n > pageH - margin) { doc.addPage(); y = margin; } };
  const fmt2 = n => parseFloat(n).toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // ── 1) Primera pasada: agrupar filas y calcular totales SIN dibujar ──
  const groupedRows = {};
  const groupOrder  = [];

  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (!qty) return;
    const presDisp  = row.cells[8]?.textContent?.trim() || 'N/A';
    const presLower = presDisp.toLowerCase();
    let groupKey = 'Others';
    if (presLower.includes('perfume'))                                              groupKey = 'Perfumes';
    else if (presLower.includes('vial') || presLower.includes('vail') || presLower.includes('tester')) groupKey = 'Vials & Testers';
    else if (presLower.includes('retail'))                                          groupKey = 'Retail';
    else if (presLower.includes('travel'))                                          groupKey = 'Travel Set';
    else if (presDisp && presDisp !== 'N/A')                                        groupKey = presDisp;
    if (!groupedRows[groupKey]) { groupedRows[groupKey] = []; groupOrder.push(groupKey); }
    groupedRows[groupKey].push(row);
  });

  const preferredOrder = ['Perfumes', 'Vials & Testers', 'Travel Set', 'Retail', 'Others'];
  const sortedGroups   = [
    ...preferredOrder.filter(g => groupedRows[g]),
    ...groupOrder.filter(g => !preferredOrder.includes(g) && groupedRows[g])
  ];

  let grandTotal = 0, totalItems = 0;
  sortedGroups.forEach(groupKey => {
    groupedRows[groupKey].forEach(row => {
      const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      const unitPrice = parseFloat(row.dataset.unitPrice || 0);
      grandTotal += qty * unitPrice;
      totalItems += qty;
    });
  });

  // ── 1b) Pre-cargar imágenes únicas ──
  const imageCache = {};
  async function cacheImage(url) {
    if (!url || imageCache[url] !== undefined) return;
    try { imageCache[url] = await loadImageAsBase64(url); }
    catch (e) { imageCache[url] = null; }
  }
  for (const key of sortedGroups) {
    for (const row of groupedRows[key]) {
      await cacheImage(getRowImageUrl(row));
    }
  }

  // ── 2) Header + stat boxes (mismo ancho que la tabla) ──
  y = await drawPreOrderHeader(doc, pageW, margin, vendor);
  y = drawPreOrderStatBoxes(doc, [
    { label: 'Total Items',     value: totalItems },
    { label: 'Categories',      value: sortedGroups.length },
    { label: 'Estimated Total', value: '$' + fmt2(grandTotal) },
  ], margin, colW, y + 6);
  y += 8;

  // ── 3) Tablas por grupo (letra e imagen más grandes) ──
  // Orden de columnas: Product, Photo, SKU, ML, Presentation, Collection, Coefficient, Qty, Unit Price, Total
  const cols = [46, 22, 24, 16, 26, 30, 16, 14, 24, 24];
  const hdrs = ['Product','Photo','SKU','ML','Presentation','Collection','Coefficient','Qty','Unit Price','Total'];
  const IMG_SIZE = 16;
  const ROW_H    = 22; // más alto para que quepa la foto más grande

  const colX = idx => margin + 2 + cols.slice(0, idx).reduce((a, b) => a + b, 0);

  function drawTableHeader() {
    checkPage(9);
    doc.setFillColor(40, 38, 35);
    doc.rect(margin, y, colW, 8, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    hdrs.forEach((h, i) => { doc.text(h, colX(i), y + 5.5); });
    doc.setTextColor(0,0,0); y += 9;
  }

  function drawGroupFooter(groupQty, groupTotal) {
    checkPage(9);
    doc.setFillColor(238, 233, 222);
    doc.rect(margin, y - 1, colW, 8, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(120,110,85);
    doc.text(String(groupQty), colX(7), y + 4.5);
    doc.text('$' + fmt2(groupTotal), colX(9), y + 4.5);
    doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
    y += 10;
  }

  let rowCount = 0;
  const groupSummaryPdf = [];

  sortedGroups.forEach(groupKey => {
    const rows = groupedRows[groupKey];
    if (!rows?.length) return;

    // Reserva espacio para: barra de título (9) + fila de encabezados (9) +
    // al menos la primera fila de datos (ROW_H). Así, si no entra completo,
    // salta de página ANTES de dibujar el título — nunca lo deja solo arriba.
    checkPage(9 + 9 + ROW_H + 4);
    doc.setFillColor(183, 172, 126);
    doc.rect(margin, y, colW, 9, 'F');
    doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    doc.text(`${groupKey}  (${rows.length} item${rows.length > 1 ? 's' : ''})`, margin + 3, y + 6.2);
    doc.setTextColor(0,0,0); y += 11;

    drawTableHeader();

    let groupTotal = 0, groupQty = 0;

    rows.forEach(row => {
      const qty       = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
      const unitPrice = parseFloat(row.dataset.unitPrice || 0);
      const subtotal  = qty * unitPrice;
      checkPage(ROW_H + 1);

      doc.setFillColor(...(rowCount % 2 === 0 ? [255,255,255] : [250,249,247]));
      doc.rect(margin, y - 1, colW, ROW_H, 'F');
      doc.setDrawColor(220,215,205); doc.setLineWidth(0.15);
      doc.line(margin, y - 1 + ROW_H, margin + colW, y - 1 + ROW_H);

      const textY = y - 1 + ROW_H / 2 + 1.8;

      const imgData = imageCache[getRowImageUrl(row)];
      const imgX = colX(1) - 1;
      const imgY = y - 1 + (ROW_H - IMG_SIZE) / 2;
      if (imgData) {
        doc.addImage(imgData, 'PNG', imgX, imgY, IMG_SIZE, IMG_SIZE);
      } else {
        doc.setFillColor(237, 233, 228);
        doc.rect(imgX, imgY, IMG_SIZE, IMG_SIZE, 'F');
      }

      doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
      doc.text((row.cells[5]?.textContent?.trim() || '').substring(0,26), colX(0), textY);
      doc.text((row.dataset.sku || '-').toUpperCase().substring(0,12), colX(2), textY);
      doc.text((row.cells[7]?.textContent?.trim() || '').substring(0,8), colX(3), textY);
      doc.text((row.cells[8]?.textContent?.trim() || '').substring(0,14), colX(4), textY);
      doc.text((row.cells[4]?.textContent?.trim() || '').substring(0,18), colX(5), textY);
      doc.text((row.cells[10]?.textContent?.trim() || '').substring(0,8), colX(6), textY);
      doc.text(String(qty), colX(7), textY);
      doc.text('$' + unitPrice.toFixed(2), colX(8), textY);
      doc.text('$' + subtotal.toFixed(2), colX(9), textY);
      doc.setTextColor(0,0,0);

      y += ROW_H; rowCount++;
      groupTotal += subtotal; groupQty += qty;
    });

    drawGroupFooter(groupQty, groupTotal);
    groupSummaryPdf.push({ key: groupKey, qty: groupQty, total: groupTotal });
  });

  // ── 4) Incentivos ──
  const freeRowsPDF = [];
  const incentiveByPresPDF = {};

  const addPresPDF = (pres, qty, pack) => {
    const isVials = (pres || '').toLowerCase().includes('vial') ||
                    (pres || '').toLowerCase().includes('vail');
    const packVal = parseInt(pack) > 0 ? parseInt(pack) : 1;
    const total   = isVials ? qty * packVal : qty;
    incentiveByPresPDF[pres || '—'] = (incentiveByPresPDF[pres || '—'] || 0) + total;
  };

  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (!qty) return;
    const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
    if (!variantHasIncentive(extras)) return;
    const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
    if (!checkVariantIncentiveMet(extras, qty, lineV)) return;
    const fps    = getVariantFreeProducts(extras);
    const fqs    = getVariantFreeQtys(extras);
    const mult   = calcVariantMultiplier(extras, qty, lineV);
    const choice = window.b2bVariantRewardChoices?.[row.dataset.variantId];

    if (fps.length > 1) {
      if (!choice?.confirmed) return;
      const vid2    = String(choice.chosenVariantId || '');
      const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
      const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
      const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
      freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.chosenTitle, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
      addPresPDF(vd2.pres, choice.chosenQty, packVal);
    } else {
      fps.forEach((fp, i) => {
        if (!fp?.title) return;
        const giftQty = (fqs[i] || 1) * mult;
        const vid2    = String(fp.variant_id || '');
        const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
        const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
        const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
        freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:fp.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:giftQty, price:'$0.00', image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
        addPresPDF(vd2.pres, giftQty, packVal);
      });
    }
  });

  const p2pdf = window.b2bPriority2Choice || {};
  let p2SubtotalPDF = 0;
  if (p2pdf.confirmed) {
    (p2pdf.selections || []).filter(s => (s.selectedQty||0) > 0).forEach(s => {
      const vid2    = String(s.variant_id || '');
      const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
      const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
      const price   = parseFloat(s.incentive_product_price || ex2.incentive_product_price || s.price || 0);
      const disc    = parseFloat(p2pdf.discountPct || 0);
      const final   = price * (1 - disc / 100) * s.selectedQty;
      const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
      p2SubtotalPDF += final;
      freeRowsPDF.push({ badge:`${disc}%`, sku:vd2.sku||'—', title:s.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:s.selectedQty, price:`$${(price*(1-disc/100)).toFixed(2)}`, image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
      addPresPDF(vd2.pres, s.selectedQty, packVal);
    });
  }

  const p3pdf = window.b2bPriority3Choice || {};
  if (p3pdf.confirmed) {
    (p3pdf.selections || []).forEach(sel => {
      (sel.choices || []).forEach(choice => {
        if (!choice.chosenQty || choice.chosenQty <= 0) return;
        const vid2    = String(choice.chosenVariantId || '');
        const vd2     = window.b2bAllVariantsMap?.[vid2] || {};
        const ex2     = window.b2bVariantExtrasMap?.[vid2] || {};
        const packVal = ex2.quantity > 0 ? ex2.quantity : 1;
        freeRowsPDF.push({ badge:'FREE', sku:vd2.sku||'—', title:choice.title, ml:vd2.ml||'—', pres:vd2.pres||'—', pack:packVal > 1 ? packVal : '—', qty:choice.chosenQty, price:'$0.00', image:getFreeItemImageUrl(vd2, vid2), bg:[250,249,247] });
        addPresPDF(vd2.pres, choice.chosenQty, packVal);
      });
    });
  }

  for (const item of freeRowsPDF) {
    await cacheImage(item.image);
  }

  if (freeRowsPDF.length) {
    // Igual que con los grupos: reserva espacio para el gap superior (4) +
    // barra de título (9) + fila de encabezados (9) + al menos la primera
    // fila (ROW_H), para que el título nunca quede solo al final de una página.
    checkPage(4 + 9 + 9 + ROW_H + 4);
    y += 4;
    doc.setFillColor(40, 38, 35);
    doc.rect(margin, y, colW, 9, 'F');
    doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    doc.text('INCENTIVES INCLUDED', margin + 3, y + 6.2);
    doc.setTextColor(0,0,0); y += 11;

    // Type, Product, Photo, SKU, ML, Presentation, Pack, Qty, Price
    const colsF = [14, 40, 22, 18, 16, 22, 12, 12, 16];
    const hdrsF = ['Type','Product','Photo','SKU','ML','Presentation','Pack','Qty','Price'];
    const colXF = idx => margin + 2 + colsF.slice(0, idx).reduce((a, b) => a + b, 0);

    doc.setFillColor(70, 66, 60); doc.rect(margin, y, colW, 8, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
    hdrsF.forEach((h, i) => { doc.text(h, colXF(i), y + 5.5); });
    doc.setTextColor(0,0,0); y += 9;

    freeRowsPDF.forEach(item => {
      checkPage(ROW_H + 1);
      doc.setFillColor(...item.bg); doc.rect(margin, y - 1, colW, ROW_H, 'F');
      doc.setDrawColor(220,215,205); doc.setLineWidth(0.15);
      doc.line(margin, y - 1 + ROW_H, margin + colW, y - 1 + ROW_H);

      const textY = y - 1 + ROW_H / 2 + 1.8;

      const imgData = imageCache[item.image];
      const imgX = colXF(2) - 1;
      const imgY = y - 1 + (ROW_H - IMG_SIZE) / 2;
      if (imgData) {
        doc.addImage(imgData, 'PNG', imgX, imgY, IMG_SIZE, IMG_SIZE);
      } else {
        doc.setFillColor(237, 233, 228);
        doc.rect(imgX, imgY, IMG_SIZE, IMG_SIZE, 'F');
      }

      doc.setFontSize(8);
      doc.setFont('helvetica','bold'); doc.setTextColor(183,172,126);
      doc.text(String(item.badge), colXF(0), textY);
      doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
      doc.text(item.title.substring(0,20), colXF(1), textY);
      doc.text(item.sku.substring(0,10), colXF(3), textY);
      doc.text(item.ml.substring(0,8), colXF(4), textY);
      doc.text(item.pres.substring(0,12), colXF(5), textY);
      doc.text(String(item.pack), colXF(6), textY);
      doc.text(String(item.qty), colXF(7), textY);
      doc.text(item.price, colXF(8), textY);
      doc.setTextColor(0,0,0);
      y += ROW_H;
    });
  }

  // ── 5) Order summary ──
  checkPage(60);
  y += 8;
  doc.setFillColor(40, 38, 35); doc.rect(margin, y, colW, 9, 'F');
  doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
  doc.text('ORDER SUMMARY', margin + 3, y + 6.2);
  doc.setTextColor(0,0,0); y += 11;

  const sumCols = [120, 40, 30, 40];
  const sumHdrs = ['Category','Units/Pack','Qty','Amount'];
  doc.setFillColor(70, 66, 60); doc.rect(margin, y, colW, 8, 'F');
  doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
  let cxS = margin + 2;
  sumHdrs.forEach((h, i) => { doc.text(h, cxS, y + 5.5); cxS += sumCols[i]; });
  doc.setTextColor(0,0,0); y += 9;

  let sumRow = 0;

  const totalIncentiveQtyPDF = parseInt(getEl('dash-total-incentives')?.textContent || '0');
  if (totalIncentiveQtyPDF > 0) {
    Object.entries(incentiveByPresPDF).forEach(([pres, qty]) => {
      checkPage(8);
      doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [250,249,247]));
      doc.rect(margin, y - 1, colW, 8, 'F');
      doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(50,50,50);
      let cx2 = margin + 2;
      [`GWP ${pres}`, '—', String(qty), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
      doc.setTextColor(0,0,0); y += 8; sumRow++;
    });
    checkPage(8);
    doc.setFillColor(238, 233, 222); doc.rect(margin, y - 1, colW, 8, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(120,110,85);
    let cx2 = margin + 2;
    ['Total GWP', '—', String(totalIncentiveQtyPDF), '$0.00'].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
    doc.setTextColor(0,0,0); y += 9; sumRow++;
  }

  groupSummaryPdf.forEach(g => {
    checkPage(8);
    doc.setFillColor(...(sumRow % 2 === 0 ? [255,255,255] : [250,249,247]));
    doc.rect(margin, y - 1, colW, 8, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','normal'); doc.setTextColor(0,0,0);
    let cx2 = margin + 2;
    [g.key, '—', String(g.qty), '$' + fmt2(g.total)].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
    y += 8; sumRow++;
  });

  if (p2SubtotalPDF > 0) {
    checkPage(8);
    doc.setFillColor(250,249,247); doc.rect(margin, y - 1, colW, 8, 'F');
    doc.setFontSize(8); doc.setFont('helvetica','bold'); doc.setTextColor(183,172,126);
    let cx2 = margin + 2;
    [`Reward Credit (${p2pdf.discountPct}%)`, '—', '—', '$' + fmt2(p2SubtotalPDF)].forEach((v, i) => { doc.text(v, cx2, y + 5); cx2 += sumCols[i]; });
    doc.setTextColor(0,0,0); y += 8;
  }

  checkPage(10);
  doc.setFillColor(40, 38, 35); doc.rect(margin, y - 1, colW, 10, 'F');
  doc.setFontSize(10); doc.setFont('helvetica','bold'); doc.setTextColor(255,255,255);
  let cxTot = margin + 2;
  ['Estimated Total', '—', String(totalItems), '$' + fmt2(grandTotal)].forEach((v, i) => { doc.text(v, cxTot, y + 6); cxTot += sumCols[i]; });

  // ── 6) Números de página ──
  const totalPages = doc.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFont('helvetica', 'normal');
    doc.setFontSize(7);
    doc.setTextColor(180, 180, 180);
    doc.text(`Page ${i} of ${totalPages}`, pageW / 2, pageH - 5, { align: 'center' });
  }

  return doc.output('datauristring').split(',')[1];
}


/* ============================================================
   PRESENTATION QUICK FILTER
   ============================================================ */

function initPresQuickFilter() {
  const btn      = getEl('pres-filter-btn');
  const dropdown = getEl('pres-filter-dropdown');
  const optsCont = getEl('pres-filter-options');
  const label    = getEl('pres-filter-label');
  if (!btn || !dropdown || !optsCont) return;

  let currentPres = 'all';

  // Filas visibles (sin los Tester ocultos de la Prioridad 4)
  const visibleRows = () => variantRows().filter(r => !r.classList.contains('b2b-row-hidden-tv'));
  // Si los Tester están ocultos, la opción se llama "Vials"; si no, "Vials & Tester"
  const vialLabel = () => variantRows().some(r => r.classList.contains('b2b-row-hidden-tv')) ? 'Vials' : 'Vials & Tester';

  // ── Build options with counts ──
  function buildOptions() {
    // Count per presentation value
    const counts = { all: 0 };
    visibleRows().forEach(row => {
      counts.all++;
      const pres = (row.dataset.presentation || '').toLowerCase().trim();
      if (!pres || pres === 'n/a') {
        counts['others'] = (counts['others'] || 0) + 1;
        return;
      }
      if (pres.includes('perfume')) {
          counts['perfume'] = (counts['perfume'] || 0) + 1;
        } else if (pres.includes('vial') || pres.includes('tester')) {
          counts['vial'] = (counts['vial'] || 0) + 1;
        } else {
          counts['others'] = (counts['others'] || 0) + 1;
        }
    });

    const options = [
      { key: 'all',     label: 'All Products',              count: counts.all     || 0 },
      { key: 'perfume', label: 'Perfume',           count: counts.perfume || 0 },
      { key: 'vial',   label: vialLabel(),        count: counts.vial   || 0 },
      { key: 'others',  label: 'Others',            count: counts.others  || 0 },
    ];

    optsCont.innerHTML = options.map(opt => `
      <div class="pres-filter-opt" data-key="${opt.key}"
        style="display:flex;align-items:center;justify-content:space-between;
               padding:10px 16px;cursor:pointer;font-family:'Crimson Pro',serif;
               font-size:15px;color:#374151;transition:background 0.1s;
               background:${currentPres === opt.key ? '#f9f5ef' : '#fff'};
               font-weight:${currentPres === opt.key ? '700' : '400'};">
        <span>${opt.label}</span>
        <span style="background:${currentPres === opt.key ? '#b8a77d' : '#f3f4f6'};
                     color:${currentPres === opt.key ? '#fff' : '#6b7280'};
                     font-size:13px;font-weight:700;padding:2px 9px;
                     border-radius:99px;min-width:28px;text-align:center;">
          ${opt.count}
        </span>
      </div>`).join('');

    // Hover effect
    optsCont.querySelectorAll('.pres-filter-opt').forEach(el => {
      el.addEventListener('mouseenter', () => {
        if (el.dataset.key !== currentPres) el.style.background = '#f9f5ef';
      });
      el.addEventListener('mouseleave', () => {
        if (el.dataset.key !== currentPres) el.style.background = '#fff';
      });
      el.addEventListener('click', () => {
        // currentPres = el.dataset.key;
        // applyPresFilter();
        // dropdown.style.display = 'none';
        // btn.style.background = currentPres === 'all' ? '#b8a77d' : '#b8a77d';
        // buildOptions(); // refresh badges
            currentPres = el.dataset.key;
            applyPresFilter();
            dropdown.style.display = 'none';
            btn.classList.remove('pres-filter-open');
            buildOptions(); // refresh badges
      });
    });
  }

  function applyPresFilter() {
    const labelMap = {
      all:     'All Product',
      perfume: 'Perfume',
      vial:    vialLabel(),
      others:  'Others',
    };
    label.textContent = labelMap[currentPres] || 'All Product';

    variantRows().forEach(row => {
      const pres = (row.dataset.presentation || '').toLowerCase().trim();
      let match = false;
      if (currentPres === 'all') {
        match = true;
      } else if (currentPres === 'perfume') {
        match = pres.includes('perfume');
      } else if (currentPres === 'vial') {
        match = pres.includes('vial') || pres.includes('tester');
      } else if (currentPres === 'others') {
          match = !pres.includes('perfume') &&
                  !pres.includes('vial') &&
                  !pres.includes('tester');
        }
      row.style.display = match ? '' : 'none';
    });

    updateTotals();
  }

  // ── Toggle dropdown ──
  // btn.addEventListener('click', () => {
  //   const open = dropdown.style.display !== 'none';
  //   if (!open) buildOptions();
  //   dropdown.style.display = open ? 'none' : 'block';
  // });

  // // ── Close on outside click ──
  // document.addEventListener('click', e => {
  //   if (!getEl('pres-filter-wrapper')?.contains(e.target)) {
  //     dropdown.style.display = 'none';
  //   }
  // });

    // ── Toggle dropdown ──
  btn.addEventListener('click', () => {
    const open = dropdown.style.display !== 'none';
    if (!open) buildOptions();
    dropdown.style.display = open ? 'none' : 'block';
    btn.classList.toggle('pres-filter-open', !open);
  });

  // ── Close on outside click ──
  document.addEventListener('click', e => {
    if (!getEl('pres-filter-wrapper')?.contains(e.target)) {
      dropdown.style.display = 'none';
      btn.classList.remove('pres-filter-open');
    }
  });
}

function showOverlayResult(success, message) {
  const overlay = getEl('b2b-processing-overlay');
  if (!overlay) return;
  
  const logoUrl = (window._b2bLogoUrl || '').replace(/^\/\//, 'https://');
  const color   = success ? '#b8a77d' : '#dc2626';
  const icon    = success ? '✓' : '✗';
  //  ${message}
  overlay.innerHTML = `
    <div style="background:white;border-radius:16px;padding:32px 48px;text-align:center;
                box-shadow:0 8px 40px rgba(0,0,0,0.2);font-family:'Crimson Pro',serif;max-width:400px;">
      <img src="${logoUrl}" alt="Logo"
        style="width:140px;object-fit:contain;margin-bottom:16px;display:block;margin-left:auto;margin-right:auto;"
        onerror="this.style.display='none'">
      <div style="width:64px;height:64px;border-radius:50%;background:${success ? '#fff' : '#fee2e2'};
                  display:flex;align-items:center;justify-content:center;
                  margin:0 auto 16px;font-size:32px;color:${color};">
        ${icon}
      </div>
      <div style="font-size:1.4rem;font-weight:700;color:${color};margin-bottom:8px;">
        ${success ? 'Email sent successfully!' : 'Error sending email'}
      </div>
      <div style="font-size:1rem;color:#6b7280;margin-bottom:24px;line-height:1.5;">
       
      </div>
      <button type="button" onclick="unlockUI()"
        style="padding:10px 32px;background:#b8a77d;color:#fff;border:none;
               border-radius:8px;font-size:16px;font-weight:700;cursor:pointer;
               font-family:'Crimson Pro',serif;">
        OK
      </button>
    </div>`;
}



/* ── Stock disponible real para poder regalar (descontando lo ya comprado de esa misma variante) ── */
// function getRemainingStockForGift(variantId, extraReserved = 0) {
//   const vid = String(variantId || '');
//   if (!vid) return Infinity; // sin variante trazable, no restringimos
//   const row = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
//   if (!row) return Infinity; // no se vende en este catálogo, no compite por stock
//   const totalStock   = parseInt(row.dataset.realStock || row.dataset.stock || 0);
//   const purchasedQty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
//   return totalStock - purchasedQty - extraReserved;
// }


/* ── Stock disponible real para poder regalar (descontando lo ya comprado de esa misma variante) ── */
function getRemainingStockForGift(variantId, extraReserved = 0) {
  const vid = String(variantId || '');
  if (!vid) return Infinity; 

  const row = document.querySelector(`.b2b-variant-row[data-variant-id="${vid}"]`);
  if (row) {
    const totalStock   = parseInt(row.dataset.realStock || row.dataset.stock || 0);
    const purchasedQty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    return totalStock - purchasedQty - extraReserved;
  }

  const rawStock = window.b2bStockMap ? window.b2bStockMap[vid] : undefined;
  if (rawStock == null) return Infinity;
  return rawStock - extraReserved;
}

function getProductPresentationPurchasedQty(handle, presKeyword) {
  let total = 0;
  variantRows().forEach(row => {
    if (row.dataset.handle !== handle) return;
    const pres = (row.dataset.presentation || '').toLowerCase();
    if (!pres.includes(presKeyword)) return;
    total += parseInt(row.querySelector('.hidden-qty')?.value) || 0;
  });
  return total;
}

function getUnlockCap(row) {
  const unlockPres = (row.dataset.unlockPres || '').trim();
  const unlockQty  = parseInt(row.dataset.unlockQty || 0);
  const unlockStep = parseInt(row.dataset.unlockStep || 1) || 1;
  if (!unlockPres || unlockQty <= 0) return Infinity; // sin configuración = sin restricción
  const basePurchased = getProductPresentationPurchasedQty(row.dataset.handle, unlockPres);
  return Math.floor(basePurchased / unlockQty) * unlockStep;
}

/* ── Máximo de FOC que realmente se puede asignar en un grupo, limitado por stock ── */
function computeMaxAchievableFoc(fps, totalFree) {
  let capSum = 0;
  let anyUnlimited = false;

  fps.forEach(fp => {
    const vid = String(fp.variant_id || '');
    const remaining = getRemainingStockForGift(vid);
    if (remaining === Infinity) {
      anyUnlimited = true;
    } else {
      capSum += Math.max(0, remaining);
    }
  });

  if (anyUnlimited) return totalFree; // al menos un producto no compite por stock, no hay límite real
  return Math.min(totalFree, capSum);
}


function hasAnyGiftStock(fps) {
  if (!fps || !fps.length) return false;
  return fps.some(fp => {
    const vid = String(fp.variant_id || '');
    if (!vid || vid === '0') return true; // no trazable en catálogo → no lo limitamos
    const remaining = getRemainingStockForGift(vid);
    return remaining > 0;
  });
}






/* ══════════════════════════════════════════════
   OFFLINE ORDER MODAL — lógica de apertura/cierre
   Pegar esto dentro de initGlobalListeners() en b2b-marca-tabla.js
   ══════════════════════════════════════════════ */

function openOfflineOrderModal() {
  const overlay = getEl('offline-order-modal-overlay');
  if (overlay) overlay.style.display = 'flex';
  document.body.style.overflow = 'hidden';
}

function closeOfflineOrderModal() {
  const overlay = getEl('offline-order-modal-overlay');
  if (overlay) overlay.style.display = 'none';
  document.body.style.overflow = '';
}

// Abrir modal al hacer click en el botón "Offline Order" del header
// (delegación de eventos: funciona aunque este script se cargue antes
// de que el botón exista en el DOM)
document.addEventListener('click', (e) => {
  if (e.target.closest('#offline-order-btn')) {
    openOfflineOrderModal();
  }
});

// Cerrar con la X
document.addEventListener('click', (e) => {
  if (e.target.closest('#offline-order-modal-close')) {
    closeOfflineOrderModal();
  }
});

// Cerrar con "Got it"
document.addEventListener('click', (e) => {
  if (e.target.closest('#offline-order-modal-gotit')) {
    closeOfflineOrderModal();
  }
});

// Cerrar haciendo click fuera del modal (en el overlay)
document.addEventListener('click', (e) => {
  if (e.target.id === 'offline-order-modal-overlay') closeOfflineOrderModal();
});

// Cerrar con la tecla Escape
document.addEventListener('keydown', (e) => {
  if (e.key === 'Escape') {
    const overlay = getEl('offline-order-modal-overlay');
    if (overlay && overlay.style.display !== 'none') closeOfflineOrderModal();
  }
});

// ── Botón "Download Offline Order Excel" (Paso 1) ──
document.addEventListener('click', async (e) => {
  const btn = e.target.closest('#offline-order-download-template');
  if (!btn) return;
  if (btn.classList.contains('is-loading')) return;

  const label   = btn.querySelector('.oo-download-btn-label');
  const spinner = btn.querySelector('.oo-download-btn-spinner');

  btn.classList.add('is-loading');
  label.style.display = 'none';
  spinner.style.display = 'inline-block';

  try {
    // TODO: reemplazar por la función real que genera la plantilla en blanco
    // (por ejemplo una versión de generateCatalogBase64 sin precios, solo
    // columnas para que el cliente complete cantidades).
    const base64 = await generateOfflineOrderTemplateBase64();
    if (base64) {
      const blob = base64toBlob(base64, 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet');
      const url  = URL.createObjectURL(blob);
      const a    = document.createElement('a');
      a.href = url;
      a.download = 'offline-order-template.xlsx';
      a.click();
      URL.revokeObjectURL(url);
    }
  } catch (err) {
    console.error('Error generating offline order template:', err);
  } finally {
    btn.classList.remove('is-loading');
    label.style.display = '';
    spinner.style.display = 'none';
  }
});

// ── Botón "Upload Excel File" (Paso 3 - Opción B) ──
document.addEventListener('click', (e) => {
  if (e.target.closest('#offline-order-upload-btn')) {
    getEl('offline-order-file-input')?.click();
  }
});

document.addEventListener('change', async (e) => {
  if (e.target.id !== 'offline-order-file-input') return;
  const file = e.target.files[0];
  if (!file) return;

  const filenameEl = getEl('offline-order-upload-filename');
  const uploadBtn   = getEl('offline-order-upload-btn');
  const label       = getEl('offline-order-upload-label');
  const spinner     = uploadBtn?.querySelector('.oo-upload-btn-spinner');

  uploadBtn?.classList.add('is-loading');
  if (label)   label.style.display = 'none';
  if (spinner) spinner.style.display = 'inline-block';

  try {
    // TODO: reemplazar por la lógica real de subida (ej: enviar a un endpoint
    // propio, a una Shopify App Proxy, o a un servicio externo).
    await uploadOfflineOrderFile(file);
    if (filenameEl) filenameEl.textContent = `Uploaded: ${file.name}`;
  } catch (err) {
    console.error('Error uploading offline order file:', err);
    if (filenameEl) filenameEl.textContent = 'Upload failed. Please try again.';
  } finally {
    uploadBtn?.classList.remove('is-loading');
    if (label)   label.style.display = '';
    if (spinner) spinner.style.display = 'none';
  }
});

/* ══════════════════════════════════════════════
   Funciones a implementar según tu backend real
   ══════════════════════════════════════════════ */


// Sube el archivo completado por el cliente. Ajustar a tu backend real.
async function uploadOfflineOrderFile(file) {
  // Ejemplo con Shopify App Proxy / endpoint propio:
  // const formData = new FormData();
  // formData.append('file', file);
  // const res = await fetch('/apps/offline-orders/upload', { method: 'POST', body: formData });
  // if (!res.ok) throw new Error('Upload failed');
  // return res.json();

  // Placeholder temporal: simula una subida.
  await new Promise(resolve => setTimeout(resolve, 800));
}











/* ============================================================
   SKU MODAL VIDEO CAROUSEL
   ============================================================ */
let skuVideoPlaylist = [];
let skuVideoCurrentIndex = 0;
let skuYtPlayer = null;
let skuYtApiReady = false;
let skuVideoCarouselIndex = 0;
const SKU_VIDEO_VISIBLE_COUNT = 4;

window.onYouTubeIframeAPIReady = window.onYouTubeIframeAPIReady || function() {
  skuYtApiReady = true;
};
if (window.YT && window.YT.Player) skuYtApiReady = true;

function ensureYoutubeApiLoaded() {
  if (document.getElementById('sku-youtube-api-script')) return;
  const s = document.createElement('script');
  s.id = 'sku-youtube-api-script';
  s.src = 'https://www.youtube.com/iframe_api';
  document.head.appendChild(s);
}

function getSkuVideoStep() {
  const track = getEl('skuVideoTrack');
  const firstItem = track?.querySelector('.sku-video-item');
  if (!firstItem) return 0;
  const gap = parseFloat(getComputedStyle(track).gap) || 0;
  return firstItem.getBoundingClientRect().width + gap;
}

function updateSkuVideoCarousel() {
  const track = getEl('skuVideoTrack');
  if (!track) return;
  const step = getSkuVideoStep();
  track.style.transform = 'translateX(' + (-skuVideoCarouselIndex * step) + 'px)';
  const prevBtn = getEl('skuVideoPrev');
  const nextBtn = getEl('skuVideoNext');
  if (prevBtn) prevBtn.disabled = skuVideoCarouselIndex <= 0;
  if (nextBtn) nextBtn.disabled = skuVideoCarouselIndex >= Math.max(skuVideoPlaylist.length - SKU_VIDEO_VISIBLE_COUNT, 0);
}

function renderSkuVideoCarousel(videos) {
  const section = getEl('sku-modal-videos');
  const track   = getEl('skuVideoTrack');
  if (!section || !track) return;
  
  skuVideoPlaylist = videos || [];
  skuVideoCarouselIndex = 0;
  
  if (!skuVideoPlaylist.length) {
    section.style.display = 'none';
    track.innerHTML = '';
    return;
  }
  
  section.style.display = 'block';
  
  track.innerHTML = skuVideoPlaylist.map((v, i) => {
    const thumb = v.thumb || `https://img.youtube.com/vi/${v.videoId}/hqdefault.jpg`;
    
    // ← AGREGA ESTO: Construir HTML de productDetails
    const productDetailsHtml = (v.prodcutDetails || []).map(pd => 
      `<span class="sku-video-product-detail">${pd.name || ''}</span>`
    ).join('');
    
    console.log("data =>", v);
    
    return `
    <div class="sku-video-item" data-index="${i}">
      <div class="sku-video-circle" style="position:relative;">
        <img src="${thumb}" alt="${v.label || ''}">
        <div style="position:absolute;inset:0;background:rgba(0,0,0,0.22);border-radius:50%;"></div>
        <div class="sku-video-play" style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%);width:34px;height:34px;background:#fff;border-radius:50%;display:flex;align-items:center;justify-content:center;pointer-events:none;box-shadow:0 2px 8px rgba(0,0,0,0.4);z-index:5;">
        </div>
      </div>
      ${productDetailsHtml ? `<div class="sku-video-products">${productDetailsHtml}</div><br/>` : ''}
    </div>`;
  }).join('');
  
  track.querySelectorAll('.sku-video-item').forEach(item => {
    item.addEventListener('click', () => {
      openSkuVideoModal(parseInt(item.dataset.index, 10));
    });
  });
  
  updateSkuVideoCarousel();
}


function skuVideoCarouselPrev() {
  skuVideoCarouselIndex = Math.max(skuVideoCarouselIndex - 1, 0);
  updateSkuVideoCarousel();
}
function skuVideoCarouselNext() {
  skuVideoCarouselIndex = Math.min(skuVideoCarouselIndex + 1, Math.max(skuVideoPlaylist.length - SKU_VIDEO_VISIBLE_COUNT, 0));
  updateSkuVideoCarousel();
}

function getSkuVideoPlayerSize() {
  const wrap = document.querySelector('.sku-video-modal-wrap');
  const rect = wrap.getBoundingClientRect();
  return { width: Math.round(rect.width), height: Math.round(rect.height) };
}

function playSkuVideoCurrent() {
  const videoId = skuVideoPlaylist[skuVideoCurrentIndex]?.videoId;
  if (!videoId) return;
  if (!skuYtApiReady || !window.YT || !window.YT.Player) {
    setTimeout(playSkuVideoCurrent, 200);
    return;
  }
  const size = getSkuVideoPlayerSize();

  if (skuYtPlayer) {
    skuYtPlayer.loadVideoById(videoId);
    skuYtPlayer.setSize(size.width, size.height);
  } else {
    skuYtPlayer = new YT.Player('skuYoutubePlayer', {
      videoId: videoId,
      width: size.width,
      height: size.height,
      playerVars: { autoplay: 1, rel: 0, modestbranding: 1, playsinline: 1, controls: 1, iv_load_policy: 3 },
      events: {
        onReady: e => e.target.setSize(size.width, size.height),
        onStateChange: e => { if (e.data === YT.PlayerState.ENDED) playSkuVideoNext(); }
      }
    });
  }
}

function playSkuVideoNext() {
  skuVideoCurrentIndex = (skuVideoCurrentIndex + 1) % skuVideoPlaylist.length;
  playSkuVideoCurrent();
}

function openSkuVideoModal(index) {
  skuVideoCurrentIndex = index;
  const modal = getEl('skuVideoModal');
  modal.classList.add('open');
  document.body.style.overflow = 'hidden';
  ensureYoutubeApiLoaded();
  playSkuVideoCurrent();
}

function closeSkuVideoModal() {
  const modal = getEl('skuVideoModal');
  modal.classList.remove('open');
  document.body.style.overflow = '';
  if (skuYtPlayer && skuYtPlayer.stopVideo) skuYtPlayer.stopVideo();
}

function initSkuVideoCarousel() {
  const prevBtn = getEl('skuVideoPrev');
  const nextBtn = getEl('skuVideoNext');
  const closeBtn = getEl('skuVideoModalClose');
  const modal = getEl('skuVideoModal');
  if (!prevBtn || prevBtn.dataset.listenerAttached) return;

  prevBtn.addEventListener('click', skuVideoCarouselPrev);
  nextBtn.addEventListener('click', skuVideoCarouselNext);
  closeBtn.addEventListener('click', closeSkuVideoModal);
  modal.addEventListener('click', e => { if (e.target.id === 'skuVideoModal') closeSkuVideoModal(); });
  window.addEventListener('resize', () => {
    if (skuYtPlayer && skuYtPlayer.setSize) {
      const size = getSkuVideoPlayerSize();
      skuYtPlayer.setSize(size.width, size.height);
    }
    updateSkuVideoCarousel();
  });

  prevBtn.dataset.listenerAttached = 'true';
}










/* ============================================================
   MASTER ORDER CONTEXT — Company → Customer en cascada
   ============================================================ */

window.b2bMasterOrderContext = {
  companyId: null,
  companyName: null,
   companyContactId: null,
  companyLocationId: null,
  customerId: null,
  customerName: null,
  customerEmail: null
};

const MASTER_API_BASE = 'https://shopifyadminapi.8motiv.com/api/Master';

async function loadMasterCompanies() {
  const companySel = getEl('master-company-select');
  if (!companySel) return;

  try {
    const res  = await fetch(`${MASTER_API_BASE}/Companies`);
    const data = await res.json();

    console.log({data:data});

    if (!data.success || !data.companies?.length) {
      companySel.innerHTML = '<option value="">No companies found</option>';
      return;
    }

    companySel.innerHTML =
      '<option value="">— Select company —</option>' +
      data.companies.map(c =>
        `<option value="${c.id}" data-location-id="${c.locations?.[0]?.id || ''}">${c.name}</option>`
      ).join('');

  } catch (err) {
    console.error('[Master] Error loading companies:', err);
    companySel.innerHTML = '<option value="">Error loading companies</option>';
  }
}

async function loadMasterCustomers(companyId) {
  const customerSel = getEl('master-customer-select');
  if (!customerSel) return;

  customerSel.disabled = true;
  customerSel.innerHTML = '<option value="">Loading customers...</option>';

  if (!companyId) {
    customerSel.innerHTML = '<option value="">Select a company first</option>';
    return;
  }

  try {
    const res  = await fetch(`${MASTER_API_BASE}/CompanyCustomers?companyId=${encodeURIComponent(companyId)}`);
    const data = await res.json();

    if (!data.success || !data.customers?.length) {
      customerSel.innerHTML = '<option value="">No customers found for this company</option>';
      customerSel.disabled = false;
      return;
    }

    customerSel.innerHTML =
      '<option value="">— Select customer —</option>' +
      data.customers.map(c => {
        const fullName = `${c.firstName || ''} ${c.lastName || ''}`.trim() || c.email || c.customerId;
        return `<option value="${c.customerId}"
          data-email="${c.email || ''}"
          data-name="${fullName}"
          data-contact-id="${c.contactId || ''}">${fullName}${c.isMainContact ? ' (Main Contact)' : ''}</option>`;
      }).join('');

    customerSel.disabled = false;

  } catch (err) {
    console.error('[Master] Error loading customers:', err);
    customerSel.innerHTML = '<option value="">Error loading customers</option>';
    customerSel.disabled = false;
  }
}

function updateMasterOrderBadge() {
  const badge     = getEl('master-order-badge');
  const badgeName = getEl('master-order-badge-name');
  const ctx       = window.b2bMasterOrderContext;

  if (!badge || !badgeName) return;

  if (ctx.customerId && ctx.customerName) {
    badgeName.textContent = `${ctx.customerName} — ${ctx.companyName}`;
    badge.style.display = 'inline-block';
  } else {
    badge.style.display = 'none';
  }
}


function updateMasterOrderLock() {
  if (!window.b2bIsMasterUser) return;

  const overlay = getEl('master-order-lock-overlay');
  const ctx     = window.b2bMasterOrderContext;
  const isReady = !!(ctx.companyId && ctx.customerId);

  window.b2bMasterOrderLocked = !isReady; // ← flag global que leen los handlers de clic

  if (overlay) overlay.style.display = isReady ? 'none' : 'flex';

  // ── Steppers: bloqueo VISUAL (no disabled nativo) para poder capturar el clic ──
  variantRows().forEach(row => {
    const plus  = row.querySelector('.step-plus');
    const minus = row.querySelector('.step-minus');
    const stock = parseInt(row.dataset.stock || 0);

    if (plus) {
      const shouldLook = !isReady || stock <= 0;
      plus.style.opacity    = shouldLook ? '0.4' : '';
      plus.style.cursor     = shouldLook ? 'not-allowed' : '';
      // Solo aplicamos disabled real cuando el bloqueo es por STOCK (no por master lock)
      plus.disabled = isReady && stock <= 0;
    }
    if (minus) {
      const curQty = parseInt(row.querySelector('.hidden-qty')?.value || 0);
      const shouldLook = !isReady || curQty <= 0;
      minus.style.opacity = shouldLook ? '0.4' : '';
      minus.style.cursor  = shouldLook ? 'not-allowed' : '';
      minus.disabled = isReady && curQty <= 0;
    }
  });

  // ── Search / FOC: bloqueo real está bien porque no necesitan mensaje de clic ──
  const searchInput = getEl('b2b-search-input');
  if (searchInput) {
    searchInput.disabled = !isReady;
    searchInput.style.opacity = isReady ? '' : '0.5';
  }

  // ── Add FOC: lo dejamos clickeable para mostrar el aviso (igual que los steppers) ──
  const focBtn = getEl('master-foc-btn');
  if (focBtn) {
    focBtn.style.opacity = isReady ? '' : '0.5';
    focBtn.style.cursor  = isReady ? '' : 'not-allowed';
  }

  // ── Buy buttons: mantenemos disabled real, ya que handleBuyNow() ya valida y alerta al hacer submit del form completo ──
  const buyBtn       = getEl('b2b-buy-btn');
  const buyBtnBottom = getEl('b2b-buy-now-bottom');
  if (!isReady) {
    if (buyBtn)       buyBtn.disabled = true;
    if (buyBtnBottom) buyBtnBottom.disabled = true;
  }
}

function initMasterOrderContext() {
  const companySel  = getEl('master-company-select');
  const customerSel = getEl('master-customer-select');
  if (!companySel || !customerSel || companySel.dataset.listenerAttached) return;

  loadMasterCompanies();
  updateMasterOrderLock(); // ← estado inicial: bloqueado

  companySel.addEventListener('change', () => {
    const opt = companySel.selectedOptions[0];
    const companyId = companySel.value;

    window.b2bMasterOrderContext.companyId          = companyId || null;
    window.b2bMasterOrderContext.companyName         = companyId ? opt.textContent : null;
    window.b2bMasterOrderContext.companyLocationId   = companyId ? (opt.dataset.locationId || null) : null;
    window.b2bMasterOrderContext.customerId          = null;
    window.b2bMasterOrderContext.customerName        = null;
    window.b2bMasterOrderContext.customerEmail       = null;
    window.b2bMasterOrderContext.companyContactId    = null;

    loadMasterCustomers(companyId);
    updateMasterOrderBadge();
    updateMasterOrderLock(); // ← se re-bloquea porque el customer se limpió
  });

  customerSel.addEventListener('change', () => {
    const opt = customerSel.selectedOptions[0];
    const customerId = customerSel.value;

    window.b2bMasterOrderContext.customerId       = customerId || null;
    window.b2bMasterOrderContext.customerName     = customerId ? opt.dataset.name : null;
    window.b2bMasterOrderContext.customerEmail    = customerId ? opt.dataset.email : null;
    window.b2bMasterOrderContext.companyContactId = customerId ? opt.dataset.contactId : null;

    updateMasterOrderBadge();
    updateMasterOrderLock(); // ← desbloquea si ya hay ambos
  });

  companySel.dataset.listenerAttached = 'true';
}






/* ============================================================
   MASTER FOC — asignación libre, único límite: stock real
   ============================================================ */

function initMasterFocModal() {
  if (!window.b2bIsMasterUser) return;
  const btn   = getEl('master-foc-btn');
  const modal = getEl('master-foc-modal');
  if (!btn || !modal || btn.dataset.listenerAttached) return;

 btn.addEventListener('click', () => {
  const ctx = window.b2bMasterOrderContext;
  if (!ctx.companyId || !ctx.customerId) {
    showMasterLockRequiredModal();
    return;
  }
  renderMasterFocTable('');
  modal.style.display = 'flex';
  document.body.style.overflow = 'hidden';
});

  getEl('master-foc-close')?.addEventListener('click', closeMasterFocModal);
  getEl('master-foc-overlay')?.addEventListener('click', closeMasterFocModal);

  getEl('master-foc-search')?.addEventListener('input', (e) => {
    renderMasterFocTable(e.target.value.trim().toLowerCase());
  });

  

getEl('master-foc-confirm')?.addEventListener('click', () => {
    document.querySelectorAll('#master-foc-tbody .master-foc-qty-input').forEach(input => {
      const vid = input.dataset.variantId;
      const max = parseInt(input.closest('.master-foc-stepper')?.dataset.max || 0); // ✅ FIX
      let qty   = parseInt(input.value) || 0;
      if (qty < 0)   qty = 0;
      if (qty > max) qty = max;
      if (qty > 0) window.b2bMasterFreeItems[vid] = qty;
      else         delete window.b2bMasterFreeItems[vid];
    });
    closeMasterFocModal();
    applyFreeProductStockDeductions();
    updateTotals();
    updateIncentiveBanners();
    renderPurchaseDetails(); // ← también sin el "if expanded", para que el dashboard FOC se actualice siempre
  });

  btn.dataset.listenerAttached = 'true';
}

function closeMasterFocModal() {
  const modal = getEl('master-foc-modal');
  if (modal) modal.style.display = 'none';
  document.body.style.overflow = '';
}

function renderMasterFocTable(filterText) {
  const tbody = getEl('master-foc-tbody');
  if (!tbody) return;

  const recommended = computeMasterRecommendedFoc();

  const rows = variantRows().filter(row => {
    const pres = (row.dataset.presentation || '').toLowerCase();
    const isVialOrTester = pres.includes('vial') || pres.includes('vail') || pres.includes('tester');
    if (!isVialOrTester) return false;

    if (!filterText) return true;
    const hay = [row.dataset.sku, row.dataset.perfume, row.dataset.collection, row.dataset.ml, row.dataset.presentation].join(' ').toLowerCase();
    return hay.includes(filterText);
  });

  tbody.innerHTML = rows.map(row => {
    const vid           = row.dataset.variantId;
    const realStock     = parseInt(row.dataset.realStock || 0);
    const purchasedQty  = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    const currentMaster = parseInt(window.b2bMasterFreeItems[vid] || 0);
    const available     = Math.max(0, realStock - purchasedQty);
    const maxForInput   = available + currentMaster;
    const rec           = recommended[vid] || 0;

    const imgUrl  = row.dataset.imgUrl || '';
    const product = row.cells[5]?.textContent?.trim() || '';
    const sku     = (row.dataset.sku || '').toUpperCase();
    const ml      = row.cells[7]?.textContent?.trim() || '';
    const pres    = row.cells[8]?.textContent?.trim() || '';

    return `
      <tr style="border-bottom:1px solid #e5e7eb;">
        <td style="padding:8px;text-align:center;">
          ${imgUrl ? `<img src="${imgUrl}" style="width:48px;height:48px;object-fit:cover;border-radius:6px;">` : ''}
        </td>
        <td style="padding:8px;">${product}</td>
        <td style="padding:8px;text-align:center;">${sku}</td>
        <td style="padding:8px;text-align:center;">${ml}</td>
        <td style="padding:8px;text-align:center;">${pres}</td>
        <td style="padding:8px;text-align:center;font-weight:700;">${available}</td>
        <td style="padding:8px;text-align:center;">
          ${rec > 0
            ? `<span style="background:#dcfce7;color:#166534;font-weight:700;padding:3px 12px;border-radius:12px;">${rec}</span>`
            : '<span style="color:#9ca3af;">—</span>'}
        </td>
        <td style="padding:8px;text-align:center;">
          <div class="master-foc-stepper" data-variant-id="${vid}" data-max="${maxForInput}"
            style="display:inline-flex;align-items:center;gap:8px;">
            <button type="button" class="master-foc-minus"
              style="width:28px;height:28px;border:1px solid #e5e7eb;border-radius:6px;background:#f9fafb;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;">−</button>
            <span class="master-foc-qty-val" style="min-width:22px;text-align:center;font-weight:700;font-size:15px;">${currentMaster}</span>
            <button type="button" class="master-foc-plus"
              style="width:28px;height:28px;border:1px solid #b8a77d;border-radius:6px;background:#b8a77d;color:#fff;font-size:16px;cursor:pointer;display:flex;align-items:center;justify-content:center;">+</button>
            <input type="hidden" class="master-foc-qty-input" data-variant-id="${vid}" value="${currentMaster}">
          </div>
        </td>
      </tr>`;
  }).join('');

  // ── Delegación de eventos para los steppers (una sola vez) ──
  if (!tbody.dataset.stepperListenerAttached) {
    tbody.addEventListener('click', e => {
      const minusBtn = e.target.closest('.master-foc-minus');
      const plusBtn  = e.target.closest('.master-foc-plus');
      if (!minusBtn && !plusBtn) return;

      const wrapper = e.target.closest('.master-foc-stepper');
      const max     = parseInt(wrapper.dataset.max || 0);
      const valEl   = wrapper.querySelector('.master-foc-qty-val');
      const hidden  = wrapper.querySelector('.master-foc-qty-input');
      let qty       = parseInt(hidden.value) || 0;

      if (minusBtn) qty = Math.max(0, qty - 1);
      if (plusBtn)  qty = Math.min(max, qty + 1);

      valEl.textContent = qty;
      hidden.value = qty;
    });
    tbody.dataset.stepperListenerAttached = 'true';
  }
}


/* Calcula el FOC recomendado por variante regalo, según lo que hay en el pedido */
function computeMasterRecommendedFoc() {
  const rec = {};
  variantRows().forEach(row => {
    const qty = parseInt(row.querySelector('.hidden-qty')?.value) || 0;
    if (qty <= 0) return;

    const extras = window.b2bVariantExtrasMap?.[row.dataset.variantId];
    if (!extras) return;

    const lineV = qty * parseFloat(row.dataset.unitPrice || 0);
    if (!checkVariantIncentiveMet(extras, qty, lineV)) return;

    const fps  = getVariantFreeProducts(extras);
    const fqs  = getVariantFreeQtys(extras);
    const mult = calcVariantMultiplier(extras, qty, lineV);

    fps.forEach((fp, i) => {
      const gvid = String(fp?.variant_id || '');
      if (!gvid || gvid === '0') return;
      rec[gvid] = (rec[gvid] || 0) + (fqs[i] || 1) * mult;
    });
  });
  return rec;
}

/* ============================================================
   INIT GLOBAL
   ============================================================ */

window.b2bInitAll = function() {
  initSteppers();
  initCopySku();
  initSkuHover();
  initSkuVideoCarousel();
  initSkuModal();
  initSkuAudioPlayer();
  initSearch();
  initSort();
  initPresentationFilter();
  b2bBuildFilterOptions();
  b2bInitCombos();
  b2bApplyFilters();
  initGuidelinesModal();
  initExcelExport();
  initCatalogExport();
  initPdfExport();
  initGlobalListeners();
  initViewToggle();
  updateTotals();
  initFooterPadding();
   initSendModal();
   initPresQuickFilter();
   if (window.b2bIsMasterUser) initMasterOrderContext();
    if (window.b2bIsMasterUser) initMasterFocModal();
};

window.openAllVariantRewardsModal = openAllVariantRewardsModal;
window.openRewardChoiceModal      = openRewardChoiceModal;
window.b2bApplyFilters            = b2bApplyFilters;